import { A as SO, g as _O, s as yo } from "./auth.service-D6yh8BVE.js";
import * as x from "react";
import Ae, { createContext as dt, useState as Ie, useCallback as rr, useEffect as rt, useMemo as ar, forwardRef as X, createElement as _e, useContext as Ar, useRef as Nt, useImperativeHandle as EO, useLayoutEffect as V7, Children as bo, cloneElement as C1, isValidElement as Nd, Fragment as MO, useId as CO } from "react";
import { jsx as A, jsxs as ie, Fragment as Ge } from "react/jsx-runtime";
import { useNavigate as Aa, useSearchParams as Co, useParams as H7 } from "react-router-dom";
import { ApiError as Soe, createAxiosInstance as _oe, transformApiValidationErrors as Eoe } from "./axios.js";
import * as Oo from "react-dom";
import OO from "react-dom";
const NO = { isAuthenticated: !1, isImpersonated: !1 }, IO = {
  authPagePath: "/auth",
  signUpPagePath: "/sign-up",
  forgotPasswordPagePath: "/forgot-password",
  authHostUrl: "",
  authorizeUrl: void 0,
  signOutUrl: void 0,
  service: new SO("")
}, K7 = dt(NO), W7 = dt(IO);
function Bne({
  children: e,
  authPagePath: t = "/auth",
  signUpPagePath: r = "/sign-up",
  forgotPasswordPagePath: n = "/forgot-password",
  authHostUrl: o,
  authorizeUrl: a,
  signOutUrl: d,
  service: i,
  ...s
}) {
  const [u, c] = Ie(i.session.tokens.access), [l, p] = Ie(i.session.tokens.refresh), [h, m] = Ie(i.session.userInfo), f = rr(() => {
    c(i.session.tokens.access), p(i.session.tokens.refresh), m(i.session.userInfo);
  }, [i.session.tokens.access, i.session.tokens.refresh, i.session.userInfo]);
  rt(() => {
    i.setAuthState = f;
  }, [i, f]);
  const $ = ar(
    () => ({
      accessToken: u,
      refreshToken: l,
      userInfo: h,
      isAuthenticated: !!h,
      isImpersonated: !!(h != null && h.impersonator)
    }),
    [u, l, h]
  ), v = ar(
    () => ({
      authPagePath: t,
      signUpPagePath: r,
      forgotPasswordPagePath: n,
      authorizeUrl: a,
      signOutUrl: d,
      authHostUrl: o,
      service: i
    }),
    [o, t, a, n, i, d, r]
  );
  return /* @__PURE__ */ A(W7.Provider, { ...s, value: v, children: /* @__PURE__ */ A(K7.Provider, { ...s, value: $, children: e }) });
}
function Jd(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), o, a;
  for (a = 0; a < n.length; a++)
    o = n[a], !(t.indexOf(o) >= 0) && (r[o] = e[o]);
  return r;
}
var PO = ["color"], RO = /* @__PURE__ */ X(function(e, t) {
  var r = e.color, n = r === void 0 ? "currentColor" : r, o = Jd(e, PO);
  return _e("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, o, {
    ref: t
  }), _e("path", {
    d: "M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704ZM9.85358 5.14644C10.0488 5.3417 10.0488 5.65829 9.85358 5.85355L8.20713 7.49999L9.85358 9.14644C10.0488 9.3417 10.0488 9.65829 9.85358 9.85355C9.65832 10.0488 9.34173 10.0488 9.14647 9.85355L7.50002 8.2071L5.85358 9.85355C5.65832 10.0488 5.34173 10.0488 5.14647 9.85355C4.95121 9.65829 4.95121 9.3417 5.14647 9.14644L6.79292 7.49999L5.14647 5.85355C4.95121 5.65829 4.95121 5.3417 5.14647 5.14644C5.34173 4.95118 5.65832 4.95118 5.85358 5.14644L7.50002 6.79289L9.14647 5.14644C9.34173 4.95118 9.65832 4.95118 9.85358 5.14644Z",
    fill: n,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), TO = ["color"], z7 = /* @__PURE__ */ X(function(e, t) {
  var r = e.color, n = r === void 0 ? "currentColor" : r, o = Jd(e, TO);
  return _e("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, o, {
    ref: t
  }), _e("path", {
    d: "M1 2C0.447715 2 0 2.44772 0 3V12C0 12.5523 0.447715 13 1 13H14C14.5523 13 15 12.5523 15 12V3C15 2.44772 14.5523 2 14 2H1ZM1 3L14 3V3.92494C13.9174 3.92486 13.8338 3.94751 13.7589 3.99505L7.5 7.96703L1.24112 3.99505C1.16621 3.94751 1.0826 3.92486 1 3.92494V3ZM1 4.90797V12H14V4.90797L7.74112 8.87995C7.59394 8.97335 7.40606 8.97335 7.25888 8.87995L1 4.90797Z",
    fill: n,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), DO = ["color"], Qd = /* @__PURE__ */ X(function(e, t) {
  var r = e.color, n = r === void 0 ? "currentColor" : r, o = Jd(e, DO);
  return _e("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, o, {
    ref: t
  }), _e("path", {
    d: "M1.90321 7.29677C1.90321 10.341 4.11041 12.4147 6.58893 12.8439C6.87255 12.893 7.06266 13.1627 7.01355 13.4464C6.96444 13.73 6.69471 13.9201 6.41109 13.871C3.49942 13.3668 0.86084 10.9127 0.86084 7.29677C0.860839 5.76009 1.55996 4.55245 2.37639 3.63377C2.96124 2.97568 3.63034 2.44135 4.16846 2.03202L2.53205 2.03202C2.25591 2.03202 2.03205 1.80816 2.03205 1.53202C2.03205 1.25588 2.25591 1.03202 2.53205 1.03202L5.53205 1.03202C5.80819 1.03202 6.03205 1.25588 6.03205 1.53202L6.03205 4.53202C6.03205 4.80816 5.80819 5.03202 5.53205 5.03202C5.25591 5.03202 5.03205 4.80816 5.03205 4.53202L5.03205 2.68645L5.03054 2.68759L5.03045 2.68766L5.03044 2.68767L5.03043 2.68767C4.45896 3.11868 3.76059 3.64538 3.15554 4.3262C2.44102 5.13021 1.90321 6.10154 1.90321 7.29677ZM13.0109 7.70321C13.0109 4.69115 10.8505 2.6296 8.40384 2.17029C8.12093 2.11718 7.93465 1.84479 7.98776 1.56188C8.04087 1.27898 8.31326 1.0927 8.59616 1.14581C11.4704 1.68541 14.0532 4.12605 14.0532 7.70321C14.0532 9.23988 13.3541 10.4475 12.5377 11.3662C11.9528 12.0243 11.2837 12.5586 10.7456 12.968L12.3821 12.968C12.6582 12.968 12.8821 13.1918 12.8821 13.468C12.8821 13.7441 12.6582 13.968 12.3821 13.968L9.38205 13.968C9.10591 13.968 8.88205 13.7441 8.88205 13.468L8.88205 10.468C8.88205 10.1918 9.10591 9.96796 9.38205 9.96796C9.65819 9.96796 9.88205 10.1918 9.88205 10.468L9.88205 12.3135L9.88362 12.3123C10.4551 11.8813 11.1535 11.3546 11.7585 10.6738C12.4731 9.86976 13.0109 8.89844 13.0109 7.70321Z",
    fill: n,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), LO = ["color"], FO = /* @__PURE__ */ X(function(e, t) {
  var r = e.color, n = r === void 0 ? "currentColor" : r, o = Jd(e, LO);
  return _e("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, o, {
    ref: t
  }), _e("path", {
    d: "M7.49998 0.849976C7.22383 0.849976 6.99998 1.07383 6.99998 1.34998V3.52234C6.99998 3.79848 7.22383 4.02234 7.49998 4.02234C7.77612 4.02234 7.99998 3.79848 7.99998 3.52234V1.8718C10.8862 2.12488 13.15 4.54806 13.15 7.49998C13.15 10.6204 10.6204 13.15 7.49998 13.15C4.37957 13.15 1.84998 10.6204 1.84998 7.49998C1.84998 6.10612 2.35407 4.83128 3.19049 3.8459C3.36919 3.63538 3.34339 3.31985 3.13286 3.14115C2.92234 2.96245 2.60681 2.98825 2.42811 3.19877C1.44405 4.35808 0.849976 5.86029 0.849976 7.49998C0.849976 11.1727 3.82728 14.15 7.49998 14.15C11.1727 14.15 14.15 11.1727 14.15 7.49998C14.15 3.82728 11.1727 0.849976 7.49998 0.849976ZM6.74049 8.08072L4.22363 4.57237C4.15231 4.47295 4.16346 4.33652 4.24998 4.25C4.33649 4.16348 4.47293 4.15233 4.57234 4.22365L8.08069 6.74051C8.56227 7.08599 8.61906 7.78091 8.19998 8.2C7.78089 8.61909 7.08597 8.56229 6.74049 8.08072Z",
    fill: n,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
function Y7(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (r = Y7(e[t])) && (n && (n += " "), n += r);
  } else for (r in e) e[r] && (n && (n += " "), n += r);
  return n;
}
function kO() {
  for (var e, t, r = 0, n = "", o = arguments.length; r < o; r++) (e = arguments[r]) && (t = Y7(e)) && (n && (n += " "), n += t);
  return n;
}
const O1 = "-";
function jO(e) {
  const t = ZO(e), {
    conflictingClassGroups: r,
    conflictingClassGroupModifiers: n
  } = e;
  function o(d) {
    const i = d.split(O1);
    return i[0] === "" && i.length !== 1 && i.shift(), X7(i, t) || BO(d);
  }
  function a(d, i) {
    const s = r[d] || [];
    return i && n[d] ? [...s, ...n[d]] : s;
  }
  return {
    getClassGroupId: o,
    getConflictingClassGroupIds: a
  };
}
function X7(e, t) {
  var r;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], o = t.nextPart.get(n), a = o ? X7(e.slice(1), o) : void 0;
  if (a)
    return a;
  if (t.validators.length === 0)
    return;
  const d = e.join(O1);
  return (r = t.validators.find(({
    validator: i
  }) => i(d))) == null ? void 0 : r.classGroupId;
}
const ff = /^\[(.+)\]$/;
function BO(e) {
  if (ff.test(e)) {
    const t = ff.exec(e)[1], r = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (r)
      return "arbitrary.." + r;
  }
}
function ZO(e) {
  const {
    theme: t,
    prefix: r
  } = e, n = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return GO(Object.entries(e.classGroups), r).forEach(([o, a]) => {
    Ic(a, n, o, t);
  }), n;
}
function Ic(e, t, r, n) {
  e.forEach((o) => {
    if (typeof o == "string") {
      const a = o === "" ? t : pf(t, o);
      a.classGroupId = r;
      return;
    }
    if (typeof o == "function") {
      if (UO(o)) {
        Ic(o(n), t, r, n);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: r
      });
      return;
    }
    Object.entries(o).forEach(([a, d]) => {
      Ic(d, pf(t, a), r, n);
    });
  });
}
function pf(e, t) {
  let r = e;
  return t.split(O1).forEach((n) => {
    r.nextPart.has(n) || r.nextPart.set(n, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), r = r.nextPart.get(n);
  }), r;
}
function UO(e) {
  return e.isThemeGetter;
}
function GO(e, t) {
  return t ? e.map(([r, n]) => {
    const o = n.map((a) => typeof a == "string" ? t + a : typeof a == "object" ? Object.fromEntries(Object.entries(a).map(([d, i]) => [t + d, i])) : a);
    return [r, o];
  }) : e;
}
function VO(e) {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  function o(a, d) {
    r.set(a, d), t++, t > e && (t = 0, n = r, r = /* @__PURE__ */ new Map());
  }
  return {
    get(a) {
      let d = r.get(a);
      if (d !== void 0)
        return d;
      if ((d = n.get(a)) !== void 0)
        return o(a, d), d;
    },
    set(a, d) {
      r.has(a) ? r.set(a, d) : o(a, d);
    }
  };
}
const q7 = "!";
function HO(e) {
  const {
    separator: t,
    experimentalParseClassName: r
  } = e, n = t.length === 1, o = t[0], a = t.length;
  function d(i) {
    const s = [];
    let u = 0, c = 0, l;
    for (let $ = 0; $ < i.length; $++) {
      let v = i[$];
      if (u === 0) {
        if (v === o && (n || i.slice($, $ + a) === t)) {
          s.push(i.slice(c, $)), c = $ + a;
          continue;
        }
        if (v === "/") {
          l = $;
          continue;
        }
      }
      v === "[" ? u++ : v === "]" && u--;
    }
    const p = s.length === 0 ? i : i.substring(c), h = p.startsWith(q7), m = h ? p.substring(1) : p, f = l && l > c ? l - c : void 0;
    return {
      modifiers: s,
      hasImportantModifier: h,
      baseClassName: m,
      maybePostfixModifierPosition: f
    };
  }
  return r ? function(i) {
    return r({
      className: i,
      parseClassName: d
    });
  } : d;
}
function KO(e) {
  if (e.length <= 1)
    return e;
  const t = [];
  let r = [];
  return e.forEach((n) => {
    n[0] === "[" ? (t.push(...r.sort(), n), r = []) : r.push(n);
  }), t.push(...r.sort()), t;
}
function WO(e) {
  return {
    cache: VO(e.cacheSize),
    parseClassName: HO(e),
    ...jO(e)
  };
}
const zO = /\s+/;
function YO(e, t) {
  const {
    parseClassName: r,
    getClassGroupId: n,
    getConflictingClassGroupIds: o
  } = t, a = /* @__PURE__ */ new Set();
  return e.trim().split(zO).map((d) => {
    const {
      modifiers: i,
      hasImportantModifier: s,
      baseClassName: u,
      maybePostfixModifierPosition: c
    } = r(d);
    let l = !!c, p = n(l ? u.substring(0, c) : u);
    if (!p) {
      if (!l)
        return {
          isTailwindClass: !1,
          originalClassName: d
        };
      if (p = n(u), !p)
        return {
          isTailwindClass: !1,
          originalClassName: d
        };
      l = !1;
    }
    const h = KO(i).join(":");
    return {
      isTailwindClass: !0,
      modifierId: s ? h + q7 : h,
      classGroupId: p,
      originalClassName: d,
      hasPostfixModifier: l
    };
  }).reverse().filter((d) => {
    if (!d.isTailwindClass)
      return !0;
    const {
      modifierId: i,
      classGroupId: s,
      hasPostfixModifier: u
    } = d, c = i + s;
    return a.has(c) ? !1 : (a.add(c), o(s, u).forEach((l) => a.add(i + l)), !0);
  }).reverse().map((d) => d.originalClassName).join(" ");
}
function XO() {
  let e = 0, t, r, n = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (r = J7(t)) && (n && (n += " "), n += r);
  return n;
}
function J7(e) {
  if (typeof e == "string")
    return e;
  let t, r = "";
  for (let n = 0; n < e.length; n++)
    e[n] && (t = J7(e[n])) && (r && (r += " "), r += t);
  return r;
}
function qO(e, ...t) {
  let r, n, o, a = d;
  function d(s) {
    const u = t.reduce((c, l) => l(c), e());
    return r = WO(u), n = r.cache.get, o = r.cache.set, a = i, i(s);
  }
  function i(s) {
    const u = n(s);
    if (u)
      return u;
    const c = YO(s, r);
    return o(s, c), c;
  }
  return function() {
    return a(XO.apply(null, arguments));
  };
}
function Fe(e) {
  const t = (r) => r[e] || [];
  return t.isThemeGetter = !0, t;
}
const Q7 = /^\[(?:([a-z-]+):)?(.+)\]$/i, JO = /^\d+\/\d+$/, QO = /* @__PURE__ */ new Set(["px", "full", "screen"]), eN = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, tN = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, rN = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, nN = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, oN = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
function cr(e) {
  return dn(e) || QO.has(e) || JO.test(e);
}
function Nr(e) {
  return No(e, "length", fN);
}
function dn(e) {
  return !!e && !Number.isNaN(Number(e));
}
function za(e) {
  return No(e, "number", dn);
}
function Ho(e) {
  return !!e && Number.isInteger(Number(e));
}
function aN(e) {
  return e.endsWith("%") && dn(e.slice(0, -1));
}
function Me(e) {
  return Q7.test(e);
}
function Ir(e) {
  return eN.test(e);
}
const dN = /* @__PURE__ */ new Set(["length", "size", "percentage"]);
function iN(e) {
  return No(e, dN, ep);
}
function sN(e) {
  return No(e, "position", ep);
}
const uN = /* @__PURE__ */ new Set(["image", "url"]);
function lN(e) {
  return No(e, uN, $N);
}
function cN(e) {
  return No(e, "", pN);
}
function Ko() {
  return !0;
}
function No(e, t, r) {
  const n = Q7.exec(e);
  return n ? n[1] ? typeof t == "string" ? n[1] === t : t.has(n[1]) : r(n[2]) : !1;
}
function fN(e) {
  return tN.test(e) && !rN.test(e);
}
function ep() {
  return !1;
}
function pN(e) {
  return nN.test(e);
}
function $N(e) {
  return oN.test(e);
}
function vN() {
  const e = Fe("colors"), t = Fe("spacing"), r = Fe("blur"), n = Fe("brightness"), o = Fe("borderColor"), a = Fe("borderRadius"), d = Fe("borderSpacing"), i = Fe("borderWidth"), s = Fe("contrast"), u = Fe("grayscale"), c = Fe("hueRotate"), l = Fe("invert"), p = Fe("gap"), h = Fe("gradientColorStops"), m = Fe("gradientColorStopPositions"), f = Fe("inset"), $ = Fe("margin"), v = Fe("opacity"), y = Fe("padding"), S = Fe("saturate"), w = Fe("scale"), _ = Fe("sepia"), I = Fe("skew"), N = Fe("space"), O = Fe("translate"), E = () => ["auto", "contain", "none"], C = () => ["auto", "hidden", "clip", "visible", "scroll"], P = () => ["auto", Me, t], T = () => [Me, t], j = () => ["", cr, Nr], F = () => ["auto", dn, Me], Z = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], te = () => ["solid", "dashed", "dotted", "double", "none"], H = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], de = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], G = () => ["", "0", Me], le = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], fe = () => [dn, za], U = () => [dn, Me];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Ko],
      spacing: [cr, Nr],
      blur: ["none", "", Ir, Me],
      brightness: fe(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Ir, Me],
      borderSpacing: T(),
      borderWidth: j(),
      contrast: fe(),
      grayscale: G(),
      hueRotate: U(),
      invert: G(),
      gap: T(),
      gradientColorStops: [e],
      gradientColorStopPositions: [aN, Nr],
      inset: P(),
      margin: P(),
      opacity: fe(),
      padding: T(),
      saturate: fe(),
      scale: fe(),
      sepia: G(),
      skew: U(),
      space: T(),
      translate: T()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", Me]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Ir]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": le()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": le()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...Z(), Me]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: C()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": C()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": C()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: E()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": E()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": E()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [f]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [f]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [f]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [f]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [f]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [f]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [f]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [f]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [f]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Ho, Me]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: P()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", Me]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: G()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: G()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Ho, Me]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Ko]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Ho, Me]
        }, Me]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": F()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": F()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Ko]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Ho, Me]
        }, Me]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": F()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": F()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", Me]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", Me]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [p]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [p]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [p]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...de()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...de(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...de(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [y]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [y]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [y]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [y]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [y]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [y]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [y]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [y]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [y]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [$]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [$]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [$]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [$]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [$]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [$]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [$]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [$]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [$]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [N]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [N]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", Me, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [Me, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [Me, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [Ir]
        }, Ir]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [Me, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [Me, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [Me, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [Me, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Ir, Nr]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", za]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Ko]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", Me]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", dn, za]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", cr, Me]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", Me]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", Me]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [v]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [v]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...te(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", cr, Nr]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", cr, Me]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: T()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", Me]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", Me]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [v]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...Z(), sN]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", iN]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, lN]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [m]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [h]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [a]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [a]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [a]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [a]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [a]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [a]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [a]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [a]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [a]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [a]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [a]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [a]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [a]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [a]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [a]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [i]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [i]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [i]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [i]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [i]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [i]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [i]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [i]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [i]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [v]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...te(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [i]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [i]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [v]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: te()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...te()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [cr, Me]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [cr, Nr]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: j()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [v]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [cr, Nr]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Ir, cN]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Ko]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [v]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...H(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": H()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [r]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [n]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [s]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Ir, Me]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [c]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [l]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [S]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [_]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [r]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [n]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [s]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [c]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [l]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [v]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [S]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [_]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [d]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [d]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [d]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", Me]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: U()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", Me]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: U()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", Me]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [w]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [w]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [w]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Ho, Me]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [O]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [O]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [I]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [I]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", Me]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", Me]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": T()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": T()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": T()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": T()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": T()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": T()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": T()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": T()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": T()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": T()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": T()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": T()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": T()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": T()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": T()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": T()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": T()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": T()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", Me]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [cr, Nr, za]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
const mN = /* @__PURE__ */ qO(vN);
function Ur(...e) {
  return mN(kO(e));
}
function tp(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (r = tp(e[t])) && (n && (n += " "), n += r);
  } else for (r in e) e[r] && (n && (n += " "), n += r);
  return n;
}
function hN() {
  for (var e, t, r = 0, n = "", o = arguments.length; r < o; r++) (e = arguments[r]) && (t = tp(e)) && (n && (n += " "), n += t);
  return n;
}
const $f = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, vf = hN, jt = (e, t) => (r) => {
  var n;
  if ((t == null ? void 0 : t.variants) == null) return vf(e, r == null ? void 0 : r.class, r == null ? void 0 : r.className);
  const { variants: o, defaultVariants: a } = t, d = Object.keys(o).map((u) => {
    const c = r == null ? void 0 : r[u], l = a == null ? void 0 : a[u];
    if (c === null) return null;
    const p = $f(c) || $f(l);
    return o[u][p];
  }), i = r && Object.entries(r).reduce((u, c) => {
    let [l, p] = c;
    return p === void 0 || (u[l] = p), u;
  }, {}), s = t == null || (n = t.compoundVariants) === null || n === void 0 ? void 0 : n.reduce((u, c) => {
    let { class: l, className: p, ...h } = c;
    return Object.entries(h).every((m) => {
      let [f, $] = m;
      return Array.isArray($) ? $.includes({
        ...a,
        ...i
      }[f]) : {
        ...a,
        ...i
      }[f] === $;
    }) ? [
      ...u,
      l,
      p
    ] : u;
  }, []);
  return vf(e, d, s, r == null ? void 0 : r.class, r == null ? void 0 : r.className);
};
function rp(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (r = rp(e[t])) && (n && (n += " "), n += r);
  } else for (r in e) e[r] && (n && (n += " "), n += r);
  return n;
}
function gN() {
  for (var e, t, r = 0, n = "", o = arguments.length; r < o; r++) (e = arguments[r]) && (t = rp(e)) && (n && (n += " "), n += t);
  return n;
}
const N1 = "-";
function yN(e) {
  const t = xN(e), {
    conflictingClassGroups: r,
    conflictingClassGroupModifiers: n
  } = e;
  function o(d) {
    const i = d.split(N1);
    return i[0] === "" && i.length !== 1 && i.shift(), np(i, t) || bN(d);
  }
  function a(d, i) {
    const s = r[d] || [];
    return i && n[d] ? [...s, ...n[d]] : s;
  }
  return {
    getClassGroupId: o,
    getConflictingClassGroupIds: a
  };
}
function np(e, t) {
  var r;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], o = t.nextPart.get(n), a = o ? np(e.slice(1), o) : void 0;
  if (a)
    return a;
  if (t.validators.length === 0)
    return;
  const d = e.join(N1);
  return (r = t.validators.find(({
    validator: i
  }) => i(d))) == null ? void 0 : r.classGroupId;
}
const mf = /^\[(.+)\]$/;
function bN(e) {
  if (mf.test(e)) {
    const t = mf.exec(e)[1], r = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (r)
      return "arbitrary.." + r;
  }
}
function xN(e) {
  const {
    theme: t,
    prefix: r
  } = e, n = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return AN(Object.entries(e.classGroups), r).forEach(([o, a]) => {
    Pc(a, n, o, t);
  }), n;
}
function Pc(e, t, r, n) {
  e.forEach((o) => {
    if (typeof o == "string") {
      const a = o === "" ? t : hf(t, o);
      a.classGroupId = r;
      return;
    }
    if (typeof o == "function") {
      if (wN(o)) {
        Pc(o(n), t, r, n);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: r
      });
      return;
    }
    Object.entries(o).forEach(([a, d]) => {
      Pc(d, hf(t, a), r, n);
    });
  });
}
function hf(e, t) {
  let r = e;
  return t.split(N1).forEach((n) => {
    r.nextPart.has(n) || r.nextPart.set(n, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), r = r.nextPart.get(n);
  }), r;
}
function wN(e) {
  return e.isThemeGetter;
}
function AN(e, t) {
  return t ? e.map(([r, n]) => {
    const o = n.map((a) => typeof a == "string" ? t + a : typeof a == "object" ? Object.fromEntries(Object.entries(a).map(([d, i]) => [t + d, i])) : a);
    return [r, o];
  }) : e;
}
function SN(e) {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  function o(a, d) {
    r.set(a, d), t++, t > e && (t = 0, n = r, r = /* @__PURE__ */ new Map());
  }
  return {
    get(a) {
      let d = r.get(a);
      if (d !== void 0)
        return d;
      if ((d = n.get(a)) !== void 0)
        return o(a, d), d;
    },
    set(a, d) {
      r.has(a) ? r.set(a, d) : o(a, d);
    }
  };
}
const op = "!";
function _N(e) {
  const {
    separator: t,
    experimentalParseClassName: r
  } = e, n = t.length === 1, o = t[0], a = t.length;
  function d(i) {
    const s = [];
    let u = 0, c = 0, l;
    for (let $ = 0; $ < i.length; $++) {
      let v = i[$];
      if (u === 0) {
        if (v === o && (n || i.slice($, $ + a) === t)) {
          s.push(i.slice(c, $)), c = $ + a;
          continue;
        }
        if (v === "/") {
          l = $;
          continue;
        }
      }
      v === "[" ? u++ : v === "]" && u--;
    }
    const p = s.length === 0 ? i : i.substring(c), h = p.startsWith(op), m = h ? p.substring(1) : p, f = l && l > c ? l - c : void 0;
    return {
      modifiers: s,
      hasImportantModifier: h,
      baseClassName: m,
      maybePostfixModifierPosition: f
    };
  }
  return r ? function(i) {
    return r({
      className: i,
      parseClassName: d
    });
  } : d;
}
function EN(e) {
  if (e.length <= 1)
    return e;
  const t = [];
  let r = [];
  return e.forEach((n) => {
    n[0] === "[" ? (t.push(...r.sort(), n), r = []) : r.push(n);
  }), t.push(...r.sort()), t;
}
function MN(e) {
  return {
    cache: SN(e.cacheSize),
    parseClassName: _N(e),
    ...yN(e)
  };
}
const CN = /\s+/;
function ON(e, t) {
  const {
    parseClassName: r,
    getClassGroupId: n,
    getConflictingClassGroupIds: o
  } = t, a = /* @__PURE__ */ new Set();
  return e.trim().split(CN).map((d) => {
    const {
      modifiers: i,
      hasImportantModifier: s,
      baseClassName: u,
      maybePostfixModifierPosition: c
    } = r(d);
    let l = !!c, p = n(l ? u.substring(0, c) : u);
    if (!p) {
      if (!l)
        return {
          isTailwindClass: !1,
          originalClassName: d
        };
      if (p = n(u), !p)
        return {
          isTailwindClass: !1,
          originalClassName: d
        };
      l = !1;
    }
    const h = EN(i).join(":");
    return {
      isTailwindClass: !0,
      modifierId: s ? h + op : h,
      classGroupId: p,
      originalClassName: d,
      hasPostfixModifier: l
    };
  }).reverse().filter((d) => {
    if (!d.isTailwindClass)
      return !0;
    const {
      modifierId: i,
      classGroupId: s,
      hasPostfixModifier: u
    } = d, c = i + s;
    return a.has(c) ? !1 : (a.add(c), o(s, u).forEach((l) => a.add(i + l)), !0);
  }).reverse().map((d) => d.originalClassName).join(" ");
}
function NN() {
  let e = 0, t, r, n = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (r = ap(t)) && (n && (n += " "), n += r);
  return n;
}
function ap(e) {
  if (typeof e == "string")
    return e;
  let t, r = "";
  for (let n = 0; n < e.length; n++)
    e[n] && (t = ap(e[n])) && (r && (r += " "), r += t);
  return r;
}
function IN(e, ...t) {
  let r, n, o, a = d;
  function d(s) {
    const u = t.reduce((c, l) => l(c), e());
    return r = MN(u), n = r.cache.get, o = r.cache.set, a = i, i(s);
  }
  function i(s) {
    const u = n(s);
    if (u)
      return u;
    const c = ON(s, r);
    return o(s, c), c;
  }
  return function() {
    return a(NN.apply(null, arguments));
  };
}
function ke(e) {
  const t = (r) => r[e] || [];
  return t.isThemeGetter = !0, t;
}
const dp = /^\[(?:([a-z-]+):)?(.+)\]$/i, PN = /^\d+\/\d+$/, RN = /* @__PURE__ */ new Set(["px", "full", "screen"]), TN = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, DN = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, LN = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, FN = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, kN = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
function fr(e) {
  return sn(e) || RN.has(e) || PN.test(e);
}
function Pr(e) {
  return Io(e, "length", KN);
}
function sn(e) {
  return !!e && !Number.isNaN(Number(e));
}
function Ya(e) {
  return Io(e, "number", sn);
}
function Wo(e) {
  return !!e && Number.isInteger(Number(e));
}
function jN(e) {
  return e.endsWith("%") && sn(e.slice(0, -1));
}
function Ce(e) {
  return dp.test(e);
}
function Rr(e) {
  return TN.test(e);
}
const BN = /* @__PURE__ */ new Set(["length", "size", "percentage"]);
function ZN(e) {
  return Io(e, BN, ip);
}
function UN(e) {
  return Io(e, "position", ip);
}
const GN = /* @__PURE__ */ new Set(["image", "url"]);
function VN(e) {
  return Io(e, GN, zN);
}
function HN(e) {
  return Io(e, "", WN);
}
function zo() {
  return !0;
}
function Io(e, t, r) {
  const n = dp.exec(e);
  return n ? n[1] ? typeof t == "string" ? n[1] === t : t.has(n[1]) : r(n[2]) : !1;
}
function KN(e) {
  return DN.test(e) && !LN.test(e);
}
function ip() {
  return !1;
}
function WN(e) {
  return FN.test(e);
}
function zN(e) {
  return kN.test(e);
}
function YN() {
  const e = ke("colors"), t = ke("spacing"), r = ke("blur"), n = ke("brightness"), o = ke("borderColor"), a = ke("borderRadius"), d = ke("borderSpacing"), i = ke("borderWidth"), s = ke("contrast"), u = ke("grayscale"), c = ke("hueRotate"), l = ke("invert"), p = ke("gap"), h = ke("gradientColorStops"), m = ke("gradientColorStopPositions"), f = ke("inset"), $ = ke("margin"), v = ke("opacity"), y = ke("padding"), S = ke("saturate"), w = ke("scale"), _ = ke("sepia"), I = ke("skew"), N = ke("space"), O = ke("translate"), E = () => ["auto", "contain", "none"], C = () => ["auto", "hidden", "clip", "visible", "scroll"], P = () => ["auto", Ce, t], T = () => [Ce, t], j = () => ["", fr, Pr], F = () => ["auto", sn, Ce], Z = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], te = () => ["solid", "dashed", "dotted", "double", "none"], H = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], de = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], G = () => ["", "0", Ce], le = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], fe = () => [sn, Ya], U = () => [sn, Ce];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [zo],
      spacing: [fr, Pr],
      blur: ["none", "", Rr, Ce],
      brightness: fe(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Rr, Ce],
      borderSpacing: T(),
      borderWidth: j(),
      contrast: fe(),
      grayscale: G(),
      hueRotate: U(),
      invert: G(),
      gap: T(),
      gradientColorStops: [e],
      gradientColorStopPositions: [jN, Pr],
      inset: P(),
      margin: P(),
      opacity: fe(),
      padding: T(),
      saturate: fe(),
      scale: fe(),
      sepia: G(),
      skew: U(),
      space: T(),
      translate: T()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", Ce]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Rr]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": le()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": le()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...Z(), Ce]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: C()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": C()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": C()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: E()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": E()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": E()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [f]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [f]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [f]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [f]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [f]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [f]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [f]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [f]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [f]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Wo, Ce]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: P()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", Ce]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: G()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: G()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Wo, Ce]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [zo]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Wo, Ce]
        }, Ce]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": F()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": F()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [zo]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Wo, Ce]
        }, Ce]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": F()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": F()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", Ce]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", Ce]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [p]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [p]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [p]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...de()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...de(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...de(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [y]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [y]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [y]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [y]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [y]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [y]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [y]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [y]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [y]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [$]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [$]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [$]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [$]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [$]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [$]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [$]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [$]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [$]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [N]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [N]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", Ce, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [Ce, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [Ce, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [Rr]
        }, Rr]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [Ce, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [Ce, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [Ce, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [Ce, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Rr, Pr]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Ya]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [zo]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", Ce]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", sn, Ya]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", fr, Ce]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", Ce]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", Ce]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [v]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [v]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...te(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", fr, Pr]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", fr, Ce]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: T()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", Ce]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", Ce]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [v]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...Z(), UN]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", ZN]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, VN]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [m]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [h]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [a]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [a]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [a]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [a]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [a]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [a]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [a]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [a]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [a]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [a]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [a]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [a]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [a]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [a]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [a]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [i]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [i]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [i]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [i]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [i]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [i]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [i]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [i]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [i]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [v]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...te(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [i]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [i]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [v]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: te()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...te()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [fr, Ce]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [fr, Pr]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: j()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [v]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [fr, Pr]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Rr, HN]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [zo]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [v]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...H(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": H()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [r]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [n]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [s]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Rr, Ce]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [c]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [l]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [S]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [_]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [r]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [n]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [s]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [c]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [l]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [v]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [S]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [_]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [d]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [d]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [d]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", Ce]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: U()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", Ce]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: U()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", Ce]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [w]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [w]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [w]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Wo, Ce]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [O]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [O]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [I]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [I]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", Ce]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", Ce]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": T()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": T()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": T()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": T()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": T()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": T()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": T()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": T()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": T()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": T()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": T()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": T()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": T()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": T()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": T()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": T()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": T()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": T()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", Ce]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [fr, Pr, Ya]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
const XN = /* @__PURE__ */ IN(YN);
function q(...e) {
  return XN(gN(e));
}
const gf = Symbol("none");
function qN(e, t, r, n) {
  var o, a, d, i;
  if (!r) return;
  t = t ?? gf, n = n ?? gf;
  const s = ((a = (o = e[t]) == null ? void 0 : o[n]) == null ? void 0 : a[r]) ?? ((d = e[t]) == null ? void 0 : d[r]), u = (i = e[n]) == null ? void 0 : i[r], c = e[r];
  return typeof s == "string" ? s : typeof u == "string" ? u : typeof c == "string" ? c : `Unknown error: ${r.toString()}`;
}
const JN = jt(
  "relative w-full rounded-lg border px-4 py-3 text-sm [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground [&>svg~*]:pl-7",
  {
    variants: {
      variant: {
        default: "bg-background text-foreground",
        destructive: "border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), Sa = X(
  ({ className: e, variant: t, ...r }, n) => /* @__PURE__ */ A("div", { ref: n, role: "alert", className: q(JN({ variant: t }), e), ...r })
);
Sa.displayName = "Alert";
const _a = X(
  ({ className: e, ...t }, r) => /* @__PURE__ */ A("h5", { ref: r, className: q("mb-1 font-medium leading-none tracking-tight", e), ...t })
);
_a.displayName = "AlertTitle";
const Ea = X(
  ({ className: e, ...t }, r) => /* @__PURE__ */ A("div", { ref: r, className: q("text-sm [&_p]:leading-relaxed", e), ...t })
);
Ea.displayName = "AlertDescription";
/**
 * @license lucide-react v0.508.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QN = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), eI = (e) => e.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (t, r, n) => n ? n.toUpperCase() : r.toLowerCase()
), yf = (e) => {
  const t = eI(e);
  return t.charAt(0).toUpperCase() + t.slice(1);
}, sp = (...e) => e.filter((t, r, n) => !!t && t.trim() !== "" && n.indexOf(t) === r).join(" ").trim(), tI = (e) => {
  for (const t in e)
    if (t.startsWith("aria-") || t === "role" || t === "title")
      return !0;
};
/**
 * @license lucide-react v0.508.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var rI = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.508.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nI = X(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: r = 2,
    absoluteStrokeWidth: n,
    className: o = "",
    children: a,
    iconNode: d,
    ...i
  }, s) => _e(
    "svg",
    {
      ref: s,
      ...rI,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: n ? Number(r) * 24 / Number(t) : r,
      className: sp("lucide", o),
      ...!a && !tI(i) && { "aria-hidden": "true" },
      ...i
    },
    [
      ...d.map(([u, c]) => _e(u, c)),
      ...Array.isArray(a) ? a : [a]
    ]
  )
);
/**
 * @license lucide-react v0.508.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wr = (e, t) => {
  const r = X(
    ({ className: n, ...o }, a) => _e(nI, {
      ref: a,
      iconNode: t,
      className: sp(
        `lucide-${QN(yf(e))}`,
        `lucide-${e}`,
        n
      ),
      ...o
    })
  );
  return r.displayName = yf(e), r;
};
/**
 * @license lucide-react v0.508.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oI = [["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]], Rc = Wr("loader-circle", oI), aI = jt("flex-col items-center justify-center", {
  variants: {
    show: {
      true: "flex",
      false: "hidden"
    }
  },
  defaultVariants: {
    show: !0
  }
}), dI = jt("animate-spin text-primary", {
  variants: {
    size: {
      small: "size-6",
      medium: "size-8",
      large: "size-12"
    }
  },
  defaultVariants: {
    size: "medium"
  }
});
function iI({ size: e, show: t, children: r, className: n }) {
  return /* @__PURE__ */ ie("span", { className: aI({ show: t }), children: [
    /* @__PURE__ */ A(Rc, { className: q(dI({ size: e }), n) }),
    r
  ] });
}
const I1 = () => {
  const e = Ar(K7);
  if (e === void 0) throw new Error("useAuthInfo can be used only within an <Auth />");
  return e;
}, Po = () => {
  const e = Ar(W7);
  if (e === void 0) throw new Error("useAuthApi can be used only within an <Auth />");
  return e;
};
function Zne() {
  const e = Aa(), [t, r] = Ie(!1), [n] = Co(), o = n == null ? void 0 : n.get("code"), { service: a, authPagePath: d } = Po();
  return rt(() => {
    if (!o) {
      r(!0);
      return;
    }
    a.refreshTokens(o).then(() => e("/")).catch((i) => {
      console.error(i), e(d);
    });
  }, [o, a, e, d]), /* @__PURE__ */ ie(Ge, { children: [
    !t && /* @__PURE__ */ A("div", { className: "my-auto flex h-screen flex-col items-center justify-center", children: /* @__PURE__ */ A(iI, {}) }),
    t && /* @__PURE__ */ A("div", { className: "flex h-screen w-screen items-center justify-center", children: /* @__PURE__ */ ie(Sa, { className: Ur("w-fit", { invisible: !1 }), children: [
      /* @__PURE__ */ A(RO, { className: "size-4" }),
      /* @__PURE__ */ A(_a, { children: "Authentication failed!" }),
      /* @__PURE__ */ A(Ea, { children: "This is not expected. Please contact support for further help." })
    ] }) })
  ] });
}
var Ma = (e) => e.type === "checkbox", mo = (e) => e instanceof Date, pt = (e) => e == null;
const up = (e) => typeof e == "object";
var nt = (e) => !pt(e) && !Array.isArray(e) && up(e) && !mo(e), sI = (e) => nt(e) && e.target ? Ma(e.target) ? e.target.checked : e.target.value : e, uI = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, lI = (e, t) => e.has(uI(t)), cI = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return nt(t) && t.hasOwnProperty("isPrototypeOf");
}, P1 = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Dt(e) {
  let t;
  const r = Array.isArray(e);
  if (e instanceof Date)
    t = new Date(e);
  else if (e instanceof Set)
    t = new Set(e);
  else if (!(P1 && (e instanceof Blob || e instanceof FileList)) && (r || nt(e)))
    if (t = r ? [] : {}, !r && !cI(e))
      t = e;
    else
      for (const n in e)
        e.hasOwnProperty(n) && (t[n] = Dt(e[n]));
  else
    return e;
  return t;
}
var ei = (e) => Array.isArray(e) ? e.filter(Boolean) : [], Je = (e) => e === void 0, pe = (e, t, r) => {
  if (!t || !nt(e))
    return r;
  const n = ei(t.split(/[,[\].]+?/)).reduce((o, a) => pt(o) ? o : o[a], e);
  return Je(n) || n === e ? Je(e[t]) ? r : e[t] : n;
}, Fr = (e) => typeof e == "boolean", R1 = (e) => /^\w*$/.test(e), lp = (e) => ei(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Ne = (e, t, r) => {
  let n = -1;
  const o = R1(t) ? [t] : lp(t), a = o.length, d = a - 1;
  for (; ++n < a; ) {
    const i = o[n];
    let s = r;
    if (n !== d) {
      const u = e[i];
      s = nt(u) || Array.isArray(u) ? u : isNaN(+o[n + 1]) ? {} : [];
    }
    if (i === "__proto__")
      return;
    e[i] = s, e = e[i];
  }
  return e;
};
const bf = {
  BLUR: "blur",
  FOCUS_OUT: "focusout"
}, Kt = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, pr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
};
Ae.createContext(null);
var fI = (e, t, r, n = !0) => {
  const o = {
    defaultValues: t._defaultValues
  };
  for (const a in e)
    Object.defineProperty(o, a, {
      get: () => {
        const d = a;
        return t._proxyFormState[d] !== Kt.all && (t._proxyFormState[d] = !n || Kt.all), e[d];
      }
    });
  return o;
}, bt = (e) => nt(e) && !Object.keys(e).length, pI = (e, t, r, n) => {
  r(e);
  const { name: o, ...a } = e;
  return bt(a) || Object.keys(a).length >= Object.keys(t).length || Object.keys(a).find((d) => t[d] === Kt.all);
}, bd = (e) => Array.isArray(e) ? e : [e];
function $I(e) {
  const t = Ae.useRef(e);
  t.current = e, Ae.useEffect(() => {
    const r = !e.disabled && t.current.subject && t.current.subject.subscribe({
      next: t.current.next
    });
    return () => {
      r && r.unsubscribe();
    };
  }, [e.disabled]);
}
var nr = (e) => typeof e == "string", vI = (e, t, r, n, o) => nr(e) ? (n && t.watch.add(e), pe(r, e, o)) : Array.isArray(e) ? e.map((a) => (n && t.watch.add(a), pe(r, a))) : (n && (t.watchAll = !0), r), cp = (e, t, r, n, o) => t ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [n]: o || !0
  }
} : {}, xf = (e) => ({
  isOnSubmit: !e || e === Kt.onSubmit,
  isOnBlur: e === Kt.onBlur,
  isOnChange: e === Kt.onChange,
  isOnAll: e === Kt.all,
  isOnTouch: e === Kt.onTouched
}), wf = (e, t, r) => !r && (t.watchAll || t.watch.has(e) || [...t.watch].some((n) => e.startsWith(n) && /^\.\w+/.test(e.slice(n.length))));
const la = (e, t, r, n) => {
  for (const o of r || Object.keys(e)) {
    const a = pe(e, o);
    if (a) {
      const { _f: d, ...i } = a;
      if (d) {
        if (d.refs && d.refs[0] && t(d.refs[0], o) && !n)
          break;
        if (d.ref && t(d.ref, d.name) && !n)
          break;
        la(i, t);
      } else nt(i) && la(i, t);
    }
  }
};
var mI = (e, t, r) => {
  const n = bd(pe(e, r));
  return Ne(n, "root", t[r]), Ne(e, r, n), e;
}, T1 = (e) => e.type === "file", kr = (e) => typeof e == "function", Id = (e) => {
  if (!P1)
    return !1;
  const t = e ? e.ownerDocument : 0;
  return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
}, xd = (e) => nr(e), D1 = (e) => e.type === "radio", Pd = (e) => e instanceof RegExp;
const Af = {
  value: !1,
  isValid: !1
}, Sf = { value: !0, isValid: !0 };
var fp = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const t = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: t, isValid: !!t.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !Je(e[0].attributes.value) ? Je(e[0].value) || e[0].value === "" ? Sf : { value: e[0].value, isValid: !0 } : Sf
    ) : Af;
  }
  return Af;
};
const _f = {
  isValid: !1,
  value: null
};
var pp = (e) => Array.isArray(e) ? e.reduce((t, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : t, _f) : _f;
function Ef(e, t, r = "validate") {
  if (xd(e) || Array.isArray(e) && e.every(xd) || Fr(e) && !e)
    return {
      type: r,
      message: xd(e) ? e : "",
      ref: t
    };
}
var _n = (e) => nt(e) && !Pd(e) ? e : {
  value: e,
  message: ""
}, Mf = async (e, t, r, n, o) => {
  const { ref: a, refs: d, required: i, maxLength: s, minLength: u, min: c, max: l, pattern: p, validate: h, name: m, valueAsNumber: f, mount: $, disabled: v } = e._f, y = pe(t, m);
  if (!$ || v)
    return {};
  const S = d ? d[0] : a, w = (T) => {
    n && S.reportValidity && (S.setCustomValidity(Fr(T) ? "" : T || ""), S.reportValidity());
  }, _ = {}, I = D1(a), N = Ma(a), O = I || N, E = (f || T1(a)) && Je(a.value) && Je(y) || Id(a) && a.value === "" || y === "" || Array.isArray(y) && !y.length, C = cp.bind(null, m, r, _), P = (T, j, F, Z = pr.maxLength, te = pr.minLength) => {
    const H = T ? j : F;
    _[m] = {
      type: T ? Z : te,
      message: H,
      ref: a,
      ...C(T ? Z : te, H)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : i && (!O && (E || pt(y)) || Fr(y) && !y || N && !fp(d).isValid || I && !pp(d).isValid)) {
    const { value: T, message: j } = xd(i) ? { value: !!i, message: i } : _n(i);
    if (T && (_[m] = {
      type: pr.required,
      message: j,
      ref: S,
      ...C(pr.required, j)
    }, !r))
      return w(j), _;
  }
  if (!E && (!pt(c) || !pt(l))) {
    let T, j;
    const F = _n(l), Z = _n(c);
    if (!pt(y) && !isNaN(y)) {
      const te = a.valueAsNumber || y && +y;
      pt(F.value) || (T = te > F.value), pt(Z.value) || (j = te < Z.value);
    } else {
      const te = a.valueAsDate || new Date(y), H = (le) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + le), de = a.type == "time", G = a.type == "week";
      nr(F.value) && y && (T = de ? H(y) > H(F.value) : G ? y > F.value : te > new Date(F.value)), nr(Z.value) && y && (j = de ? H(y) < H(Z.value) : G ? y < Z.value : te < new Date(Z.value));
    }
    if ((T || j) && (P(!!T, F.message, Z.message, pr.max, pr.min), !r))
      return w(_[m].message), _;
  }
  if ((s || u) && !E && (nr(y) || o && Array.isArray(y))) {
    const T = _n(s), j = _n(u), F = !pt(T.value) && y.length > +T.value, Z = !pt(j.value) && y.length < +j.value;
    if ((F || Z) && (P(F, T.message, j.message), !r))
      return w(_[m].message), _;
  }
  if (p && !E && nr(y)) {
    const { value: T, message: j } = _n(p);
    if (Pd(T) && !y.match(T) && (_[m] = {
      type: pr.pattern,
      message: j,
      ref: a,
      ...C(pr.pattern, j)
    }, !r))
      return w(j), _;
  }
  if (h) {
    if (kr(h)) {
      const T = await h(y, t), j = Ef(T, S);
      if (j && (_[m] = {
        ...j,
        ...C(pr.validate, j.message)
      }, !r))
        return w(j.message), _;
    } else if (nt(h)) {
      let T = {};
      for (const j in h) {
        if (!bt(T) && !r)
          break;
        const F = Ef(await h[j](y, t), S, j);
        F && (T = {
          ...F,
          ...C(j, F.message)
        }, w(F.message), r && (_[m] = T));
      }
      if (!bt(T) && (_[m] = {
        ref: S,
        ...T
      }, !r))
        return _;
    }
  }
  return w(!0), _;
};
function hI(e, t) {
  const r = t.slice(0, -1).length;
  let n = 0;
  for (; n < r; )
    e = Je(e) ? n++ : e[t[n++]];
  return e;
}
function gI(e) {
  for (const t in e)
    if (e.hasOwnProperty(t) && !Je(e[t]))
      return !1;
  return !0;
}
function tt(e, t) {
  const r = Array.isArray(t) ? t : R1(t) ? [t] : lp(t), n = r.length === 1 ? e : hI(e, r), o = r.length - 1, a = r[o];
  return n && delete n[a], o !== 0 && (nt(n) && bt(n) || Array.isArray(n) && gI(n)) && tt(e, r.slice(0, -1)), e;
}
var Ss = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (o) => {
      for (const a of e)
        a.next && a.next(o);
    },
    subscribe: (o) => (e.push(o), {
      unsubscribe: () => {
        e = e.filter((a) => a !== o);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Rd = (e) => pt(e) || !up(e);
function un(e, t) {
  if (Rd(e) || Rd(t))
    return e === t;
  if (mo(e) && mo(t))
    return e.getTime() === t.getTime();
  const r = Object.keys(e), n = Object.keys(t);
  if (r.length !== n.length)
    return !1;
  for (const o of r) {
    const a = e[o];
    if (!n.includes(o))
      return !1;
    if (o !== "ref") {
      const d = t[o];
      if (mo(a) && mo(d) || nt(a) && nt(d) || Array.isArray(a) && Array.isArray(d) ? !un(a, d) : a !== d)
        return !1;
    }
  }
  return !0;
}
var $p = (e) => e.type === "select-multiple", yI = (e) => D1(e) || Ma(e), _s = (e) => Id(e) && e.isConnected, vp = (e) => {
  for (const t in e)
    if (kr(e[t]))
      return !0;
  return !1;
};
function Td(e, t = {}) {
  const r = Array.isArray(e);
  if (nt(e) || r)
    for (const n in e)
      Array.isArray(e[n]) || nt(e[n]) && !vp(e[n]) ? (t[n] = Array.isArray(e[n]) ? [] : {}, Td(e[n], t[n])) : pt(e[n]) || (t[n] = !0);
  return t;
}
function mp(e, t, r) {
  const n = Array.isArray(e);
  if (nt(e) || n)
    for (const o in e)
      Array.isArray(e[o]) || nt(e[o]) && !vp(e[o]) ? Je(t) || Rd(r[o]) ? r[o] = Array.isArray(e[o]) ? Td(e[o], []) : { ...Td(e[o]) } : mp(e[o], pt(t) ? {} : t[o], r[o]) : r[o] = !un(e[o], t[o]);
  return r;
}
var Xa = (e, t) => mp(e, t, Td(t)), hp = (e, { valueAsNumber: t, valueAsDate: r, setValueAs: n }) => Je(e) ? e : t ? e === "" ? NaN : e && +e : r && nr(e) ? new Date(e) : n ? n(e) : e;
function Es(e) {
  const t = e.ref;
  if (!(e.refs ? e.refs.every((r) => r.disabled) : t.disabled))
    return T1(t) ? t.files : D1(t) ? pp(e.refs).value : $p(t) ? [...t.selectedOptions].map(({ value: r }) => r) : Ma(t) ? fp(e.refs).value : hp(Je(t.value) ? e.ref.value : t.value, e);
}
var bI = (e, t, r, n) => {
  const o = {};
  for (const a of e) {
    const d = pe(t, a);
    d && Ne(o, a, d._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: o,
    shouldUseNativeValidation: n
  };
}, Yo = (e) => Je(e) ? e : Pd(e) ? e.source : nt(e) ? Pd(e.value) ? e.value.source : e.value : e, xI = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate);
function Cf(e, t, r) {
  const n = pe(e, r);
  if (n || R1(r))
    return {
      error: n,
      name: r
    };
  const o = r.split(".");
  for (; o.length; ) {
    const a = o.join("."), d = pe(t, a), i = pe(e, a);
    if (d && !Array.isArray(d) && r !== a)
      return { name: r };
    if (i && i.type)
      return {
        name: a,
        error: i
      };
    o.pop();
  }
  return {
    name: r
  };
}
var wI = (e, t, r, n, o) => o.isOnAll ? !1 : !r && o.isOnTouch ? !(t || e) : (r ? n.isOnBlur : o.isOnBlur) ? !e : (r ? n.isOnChange : o.isOnChange) ? e : !0, AI = (e, t) => !ei(pe(e, t)).length && tt(e, t);
const SI = {
  mode: Kt.onSubmit,
  reValidateMode: Kt.onChange,
  shouldFocusError: !0
};
function _I(e = {}) {
  let t = {
    ...SI,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: kr(t.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: t.errors || {},
    disabled: t.disabled || !1
  }, n = {}, o = nt(t.defaultValues) || nt(t.values) ? Dt(t.defaultValues || t.values) || {} : {}, a = t.shouldUnregister ? {} : Dt(o), d = {
    action: !1,
    mount: !1,
    watch: !1
  }, i = {
    mount: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, s, u = 0;
  const c = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, l = {
    values: Ss(),
    array: Ss(),
    state: Ss()
  }, p = xf(t.mode), h = xf(t.reValidateMode), m = t.criteriaMode === Kt.all, f = (g) => (b) => {
    clearTimeout(u), u = setTimeout(g, b);
  }, $ = async (g) => {
    if (c.isValid || g) {
      const b = t.resolver ? bt((await O()).errors) : await C(n, !0);
      b !== r.isValid && l.state.next({
        isValid: b
      });
    }
  }, v = (g, b) => {
    (c.isValidating || c.validatingFields) && ((g || Array.from(i.mount)).forEach((M) => {
      M && (b ? Ne(r.validatingFields, M, b) : tt(r.validatingFields, M));
    }), l.state.next({
      validatingFields: r.validatingFields,
      isValidating: !bt(r.validatingFields)
    }));
  }, y = (g, b = [], M, D, R = !0, L = !0) => {
    if (D && M) {
      if (d.action = !0, L && Array.isArray(pe(n, g))) {
        const B = M(pe(n, g), D.argA, D.argB);
        R && Ne(n, g, B);
      }
      if (L && Array.isArray(pe(r.errors, g))) {
        const B = M(pe(r.errors, g), D.argA, D.argB);
        R && Ne(r.errors, g, B), AI(r.errors, g);
      }
      if (c.touchedFields && L && Array.isArray(pe(r.touchedFields, g))) {
        const B = M(pe(r.touchedFields, g), D.argA, D.argB);
        R && Ne(r.touchedFields, g, B);
      }
      c.dirtyFields && (r.dirtyFields = Xa(o, a)), l.state.next({
        name: g,
        isDirty: T(g, b),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Ne(a, g, b);
  }, S = (g, b) => {
    Ne(r.errors, g, b), l.state.next({
      errors: r.errors
    });
  }, w = (g) => {
    r.errors = g, l.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, _ = (g, b, M, D) => {
    const R = pe(n, g);
    if (R) {
      const L = pe(a, g, Je(M) ? pe(o, g) : M);
      Je(L) || D && D.defaultChecked || b ? Ne(a, g, b ? L : Es(R._f)) : Z(g, L), d.mount && $();
    }
  }, I = (g, b, M, D, R) => {
    let L = !1, B = !1;
    const V = {
      name: g
    }, oe = !!(pe(n, g) && pe(n, g)._f && pe(n, g)._f.disabled);
    if (!M || D) {
      c.isDirty && (B = r.isDirty, r.isDirty = V.isDirty = T(), L = B !== V.isDirty);
      const me = oe || un(pe(o, g), b);
      B = !!(!oe && pe(r.dirtyFields, g)), me || oe ? tt(r.dirtyFields, g) : Ne(r.dirtyFields, g, !0), V.dirtyFields = r.dirtyFields, L = L || c.dirtyFields && B !== !me;
    }
    if (M) {
      const me = pe(r.touchedFields, g);
      me || (Ne(r.touchedFields, g, M), V.touchedFields = r.touchedFields, L = L || c.touchedFields && me !== M);
    }
    return L && R && l.state.next(V), L ? V : {};
  }, N = (g, b, M, D) => {
    const R = pe(r.errors, g), L = c.isValid && Fr(b) && r.isValid !== b;
    if (e.delayError && M ? (s = f(() => S(g, M)), s(e.delayError)) : (clearTimeout(u), s = null, M ? Ne(r.errors, g, M) : tt(r.errors, g)), (M ? !un(R, M) : R) || !bt(D) || L) {
      const B = {
        ...D,
        ...L && Fr(b) ? { isValid: b } : {},
        errors: r.errors,
        name: g
      };
      r = {
        ...r,
        ...B
      }, l.state.next(B);
    }
  }, O = async (g) => {
    v(g, !0);
    const b = await t.resolver(a, t.context, bI(g || i.mount, n, t.criteriaMode, t.shouldUseNativeValidation));
    return v(g), b;
  }, E = async (g) => {
    const { errors: b } = await O(g);
    if (g)
      for (const M of g) {
        const D = pe(b, M);
        D ? Ne(r.errors, M, D) : tt(r.errors, M);
      }
    else
      r.errors = b;
    return b;
  }, C = async (g, b, M = {
    valid: !0
  }) => {
    for (const D in g) {
      const R = g[D];
      if (R) {
        const { _f: L, ...B } = R;
        if (L) {
          const V = i.array.has(L.name);
          v([D], !0);
          const oe = await Mf(R, a, m, t.shouldUseNativeValidation && !b, V);
          if (v([D]), oe[L.name] && (M.valid = !1, b))
            break;
          !b && (pe(oe, L.name) ? V ? mI(r.errors, oe, L.name) : Ne(r.errors, L.name, oe[L.name]) : tt(r.errors, L.name));
        }
        !bt(B) && await C(B, b, M);
      }
    }
    return M.valid;
  }, P = () => {
    for (const g of i.unMount) {
      const b = pe(n, g);
      b && (b._f.refs ? b._f.refs.every((M) => !_s(M)) : !_s(b._f.ref)) && we(g);
    }
    i.unMount = /* @__PURE__ */ new Set();
  }, T = (g, b) => (g && b && Ne(a, g, b), !un(fe(), o)), j = (g, b, M) => vI(g, i, {
    ...d.mount ? a : Je(b) ? o : nr(g) ? { [g]: b } : b
  }, M, b), F = (g) => ei(pe(d.mount ? a : o, g, e.shouldUnregister ? pe(o, g, []) : [])), Z = (g, b, M = {}) => {
    const D = pe(n, g);
    let R = b;
    if (D) {
      const L = D._f;
      L && (!L.disabled && Ne(a, g, hp(b, L)), R = Id(L.ref) && pt(b) ? "" : b, $p(L.ref) ? [...L.ref.options].forEach((B) => B.selected = R.includes(B.value)) : L.refs ? Ma(L.ref) ? L.refs.length > 1 ? L.refs.forEach((B) => (!B.defaultChecked || !B.disabled) && (B.checked = Array.isArray(R) ? !!R.find((V) => V === B.value) : R === B.value)) : L.refs[0] && (L.refs[0].checked = !!R) : L.refs.forEach((B) => B.checked = B.value === R) : T1(L.ref) ? L.ref.value = "" : (L.ref.value = R, L.ref.type || l.values.next({
        name: g,
        values: { ...a }
      })));
    }
    (M.shouldDirty || M.shouldTouch) && I(g, R, M.shouldTouch, M.shouldDirty, !0), M.shouldValidate && le(g);
  }, te = (g, b, M) => {
    for (const D in b) {
      const R = b[D], L = `${g}.${D}`, B = pe(n, L);
      (i.array.has(g) || !Rd(R) || B && !B._f) && !mo(R) ? te(L, R, M) : Z(L, R, M);
    }
  }, H = (g, b, M = {}) => {
    const D = pe(n, g), R = i.array.has(g), L = Dt(b);
    Ne(a, g, L), R ? (l.array.next({
      name: g,
      values: { ...a }
    }), (c.isDirty || c.dirtyFields) && M.shouldDirty && l.state.next({
      name: g,
      dirtyFields: Xa(o, a),
      isDirty: T(g, L)
    })) : D && !D._f && !pt(L) ? te(g, L, M) : Z(g, L, M), wf(g, i) && l.state.next({ ...r }), l.values.next({
      name: d.mount ? g : void 0,
      values: { ...a }
    });
  }, de = async (g) => {
    d.mount = !0;
    const b = g.target;
    let M = b.name, D = !0;
    const R = pe(n, M), L = () => b.type ? Es(R._f) : sI(g), B = (V) => {
      D = Number.isNaN(V) || V === pe(a, M, V);
    };
    if (R) {
      let V, oe;
      const me = L(), He = g.type === bf.BLUR || g.type === bf.FOCUS_OUT, Ke = !xI(R._f) && !t.resolver && !pe(r.errors, M) && !R._f.deps || wI(He, pe(r.touchedFields, M), r.isSubmitted, h, p), Le = wf(M, i, He);
      Ne(a, M, me), He ? (R._f.onBlur && R._f.onBlur(g), s && s(0)) : R._f.onChange && R._f.onChange(g);
      const st = I(M, me, He, !1), Bt = !bt(st) || Le;
      if (!He && l.values.next({
        name: M,
        type: g.type,
        values: { ...a }
      }), Ke)
        return c.isValid && $(), Bt && l.state.next({ name: M, ...Le ? {} : st });
      if (!He && Le && l.state.next({ ...r }), t.resolver) {
        const { errors: Qe } = await O([M]);
        if (B(me), D) {
          const ut = Cf(r.errors, n, M), Tt = Cf(Qe, n, ut.name || M);
          V = Tt.error, M = Tt.name, oe = bt(Qe);
        }
      } else
        v([M], !0), V = (await Mf(R, a, m, t.shouldUseNativeValidation))[M], v([M]), B(me), D && (V ? oe = !1 : c.isValid && (oe = await C(n, !0)));
      D && (R._f.deps && le(R._f.deps), N(M, oe, V, st));
    }
  }, G = (g, b) => {
    if (pe(r.errors, b) && g.focus)
      return g.focus(), 1;
  }, le = async (g, b = {}) => {
    let M, D;
    const R = bd(g);
    if (t.resolver) {
      const L = await E(Je(g) ? g : R);
      M = bt(L), D = g ? !R.some((B) => pe(L, B)) : M;
    } else g ? (D = (await Promise.all(R.map(async (L) => {
      const B = pe(n, L);
      return await C(B && B._f ? { [L]: B } : B);
    }))).every(Boolean), !(!D && !r.isValid) && $()) : D = M = await C(n);
    return l.state.next({
      ...!nr(g) || c.isValid && M !== r.isValid ? {} : { name: g },
      ...t.resolver || !g ? { isValid: M } : {},
      errors: r.errors
    }), b.shouldFocus && !D && la(n, G, g ? R : i.mount), D;
  }, fe = (g) => {
    const b = {
      ...d.mount ? a : o
    };
    return Je(g) ? b : nr(g) ? pe(b, g) : g.map((M) => pe(b, M));
  }, U = (g, b) => ({
    invalid: !!pe((b || r).errors, g),
    isDirty: !!pe((b || r).dirtyFields, g),
    error: pe((b || r).errors, g),
    isValidating: !!pe(r.validatingFields, g),
    isTouched: !!pe((b || r).touchedFields, g)
  }), ae = (g) => {
    g && bd(g).forEach((b) => tt(r.errors, b)), l.state.next({
      errors: g ? r.errors : {}
    });
  }, ue = (g, b, M) => {
    const D = (pe(n, g, { _f: {} })._f || {}).ref, R = pe(r.errors, g) || {}, { ref: L, message: B, type: V, ...oe } = R;
    Ne(r.errors, g, {
      ...oe,
      ...b,
      ref: D
    }), l.state.next({
      name: g,
      errors: r.errors,
      isValid: !1
    }), M && M.shouldFocus && D && D.focus && D.focus();
  }, se = (g, b) => kr(g) ? l.values.subscribe({
    next: (M) => g(j(void 0, b), M)
  }) : j(g, b, !0), we = (g, b = {}) => {
    for (const M of g ? bd(g) : i.mount)
      i.mount.delete(M), i.array.delete(M), b.keepValue || (tt(n, M), tt(a, M)), !b.keepError && tt(r.errors, M), !b.keepDirty && tt(r.dirtyFields, M), !b.keepTouched && tt(r.touchedFields, M), !b.keepIsValidating && tt(r.validatingFields, M), !t.shouldUnregister && !b.keepDefaultValue && tt(o, M);
    l.values.next({
      values: { ...a }
    }), l.state.next({
      ...r,
      ...b.keepDirty ? { isDirty: T() } : {}
    }), !b.keepIsValid && $();
  }, re = ({ disabled: g, name: b, field: M, fields: D, value: R }) => {
    if (Fr(g) && d.mount || g) {
      const L = g ? void 0 : Je(R) ? Es(M ? M._f : pe(D, b)._f) : R;
      Ne(a, b, L), I(b, L, !1, !1, !0);
    }
  }, ye = (g, b = {}) => {
    let M = pe(n, g);
    const D = Fr(b.disabled);
    return Ne(n, g, {
      ...M || {},
      _f: {
        ...M && M._f ? M._f : { ref: { name: g } },
        name: g,
        mount: !0,
        ...b
      }
    }), i.mount.add(g), M ? re({
      field: M,
      disabled: b.disabled,
      name: g,
      value: b.value
    }) : _(g, !0, b.value), {
      ...D ? { disabled: b.disabled } : {},
      ...t.progressive ? {
        required: !!b.required,
        min: Yo(b.min),
        max: Yo(b.max),
        minLength: Yo(b.minLength),
        maxLength: Yo(b.maxLength),
        pattern: Yo(b.pattern)
      } : {},
      name: g,
      onChange: de,
      onBlur: de,
      ref: (R) => {
        if (R) {
          ye(g, b), M = pe(n, g);
          const L = Je(R.value) && R.querySelectorAll && R.querySelectorAll("input,select,textarea")[0] || R, B = yI(L), V = M._f.refs || [];
          if (B ? V.find((oe) => oe === L) : L === M._f.ref)
            return;
          Ne(n, g, {
            _f: {
              ...M._f,
              ...B ? {
                refs: [
                  ...V.filter(_s),
                  L,
                  ...Array.isArray(pe(o, g)) ? [{}] : []
                ],
                ref: { type: L.type, name: g }
              } : { ref: L }
            }
          }), _(g, !1, void 0, L);
        } else
          M = pe(n, g, {}), M._f && (M._f.mount = !1), (t.shouldUnregister || b.shouldUnregister) && !(lI(i.array, g) && d.action) && i.unMount.add(g);
      }
    };
  }, xe = () => t.shouldFocusError && la(n, G, i.mount), be = (g) => {
    Fr(g) && (l.state.next({ disabled: g }), la(n, (b, M) => {
      const D = pe(n, M);
      D && (b.disabled = D._f.disabled || g, Array.isArray(D._f.refs) && D._f.refs.forEach((R) => {
        R.disabled = D._f.disabled || g;
      }));
    }, 0, !1));
  }, ee = (g, b) => async (M) => {
    let D;
    M && (M.preventDefault && M.preventDefault(), M.persist && M.persist());
    let R = Dt(a);
    if (l.state.next({
      isSubmitting: !0
    }), t.resolver) {
      const { errors: L, values: B } = await O();
      r.errors = L, R = B;
    } else
      await C(n);
    if (tt(r.errors, "root"), bt(r.errors)) {
      l.state.next({
        errors: {}
      });
      try {
        await g(R, M);
      } catch (L) {
        D = L;
      }
    } else
      b && await b({ ...r.errors }, M), xe(), setTimeout(xe);
    if (l.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: bt(r.errors) && !D,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), D)
      throw D;
  }, ce = (g, b = {}) => {
    pe(n, g) && (Je(b.defaultValue) ? H(g, Dt(pe(o, g))) : (H(g, b.defaultValue), Ne(o, g, Dt(b.defaultValue))), b.keepTouched || tt(r.touchedFields, g), b.keepDirty || (tt(r.dirtyFields, g), r.isDirty = b.defaultValue ? T(g, Dt(pe(o, g))) : T()), b.keepError || (tt(r.errors, g), c.isValid && $()), l.state.next({ ...r }));
  }, he = (g, b = {}) => {
    const M = g ? Dt(g) : o, D = Dt(M), R = bt(g), L = R ? o : D;
    if (b.keepDefaultValues || (o = M), !b.keepValues) {
      if (b.keepDirtyValues)
        for (const B of i.mount)
          pe(r.dirtyFields, B) ? Ne(L, B, pe(a, B)) : H(B, pe(L, B));
      else {
        if (P1 && Je(g))
          for (const B of i.mount) {
            const V = pe(n, B);
            if (V && V._f) {
              const oe = Array.isArray(V._f.refs) ? V._f.refs[0] : V._f.ref;
              if (Id(oe)) {
                const me = oe.closest("form");
                if (me) {
                  me.reset();
                  break;
                }
              }
            }
          }
        n = {};
      }
      a = e.shouldUnregister ? b.keepDefaultValues ? Dt(o) : {} : Dt(L), l.array.next({
        values: { ...L }
      }), l.values.next({
        values: { ...L }
      });
    }
    i = {
      mount: b.keepDirtyValues ? i.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, d.mount = !c.isValid || !!b.keepIsValid || !!b.keepDirtyValues, d.watch = !!e.shouldUnregister, l.state.next({
      submitCount: b.keepSubmitCount ? r.submitCount : 0,
      isDirty: R ? !1 : b.keepDirty ? r.isDirty : !!(b.keepDefaultValues && !un(g, o)),
      isSubmitted: b.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: R ? {} : b.keepDirtyValues ? b.keepDefaultValues && a ? Xa(o, a) : r.dirtyFields : b.keepDefaultValues && g ? Xa(o, g) : b.keepDirty ? r.dirtyFields : {},
      touchedFields: b.keepTouched ? r.touchedFields : {},
      errors: b.keepErrors ? r.errors : {},
      isSubmitSuccessful: b.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Ee = (g, b) => he(kr(g) ? g(a) : g, b);
  return {
    control: {
      register: ye,
      unregister: we,
      getFieldState: U,
      handleSubmit: ee,
      setError: ue,
      _executeSchema: O,
      _getWatch: j,
      _getDirty: T,
      _updateValid: $,
      _removeUnmounted: P,
      _updateFieldArray: y,
      _updateDisabledField: re,
      _getFieldArray: F,
      _reset: he,
      _resetDefaultValues: () => kr(t.defaultValues) && t.defaultValues().then((g) => {
        Ee(g, t.resetOptions), l.state.next({
          isLoading: !1
        });
      }),
      _updateFormState: (g) => {
        r = {
          ...r,
          ...g
        };
      },
      _disableForm: be,
      _subjects: l,
      _proxyFormState: c,
      _setErrors: w,
      get _fields() {
        return n;
      },
      get _formValues() {
        return a;
      },
      get _state() {
        return d;
      },
      set _state(g) {
        d = g;
      },
      get _defaultValues() {
        return o;
      },
      get _names() {
        return i;
      },
      set _names(g) {
        i = g;
      },
      get _formState() {
        return r;
      },
      set _formState(g) {
        r = g;
      },
      get _options() {
        return t;
      },
      set _options(g) {
        t = {
          ...t,
          ...g
        };
      }
    },
    trigger: le,
    register: ye,
    handleSubmit: ee,
    watch: se,
    setValue: H,
    getValues: fe,
    reset: Ee,
    resetField: ce,
    clearErrors: ae,
    unregister: we,
    setError: ue,
    setFocus: (g, b = {}) => {
      const M = pe(n, g), D = M && M._f;
      if (D) {
        const R = D.refs ? D.refs[0] : D.ref;
        R.focus && (R.focus(), b.shouldSelect && R.select());
      }
    },
    getFieldState: U
  };
}
function ti(e = {}) {
  const t = Ae.useRef(), r = Ae.useRef(), [n, o] = Ae.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: kr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: kr(e.defaultValues) ? void 0 : e.defaultValues
  });
  t.current || (t.current = {
    ..._I(e),
    formState: n
  });
  const a = t.current.control;
  return a._options = e, $I({
    subject: a._subjects.state,
    next: (d) => {
      pI(d, a._proxyFormState, a._updateFormState) && o({ ...a._formState });
    }
  }), Ae.useEffect(() => a._disableForm(e.disabled), [a, e.disabled]), Ae.useEffect(() => {
    if (a._proxyFormState.isDirty) {
      const d = a._getDirty();
      d !== n.isDirty && a._subjects.state.next({
        isDirty: d
      });
    }
  }, [a, n.isDirty]), Ae.useEffect(() => {
    e.values && !un(e.values, r.current) ? (a._reset(e.values, a._options.resetOptions), r.current = e.values, o((d) => ({ ...d }))) : a._resetDefaultValues();
  }, [e.values, a]), Ae.useEffect(() => {
    e.errors && a._setErrors(e.errors);
  }, [e.errors, a]), Ae.useEffect(() => {
    a._state.mount || (a._updateValid(), a._state.mount = !0), a._state.watch && (a._state.watch = !1, a._subjects.state.next({ ...a._formState })), a._removeUnmounted();
  }), Ae.useEffect(() => {
    e.shouldUnregister && a._subjects.values.next({
      values: a._getWatch()
    });
  }, [e.shouldUnregister, a]), t.current.formState = fI(n, a), t.current;
}
const Of = (e, t, r) => {
  if (e && "reportValidity" in e) {
    const n = pe(r, t);
    e.setCustomValidity(n && n.message || ""), e.reportValidity();
  }
}, gp = (e, t) => {
  for (const r in t.fields) {
    const n = t.fields[r];
    n && n.ref && "reportValidity" in n.ref ? Of(n.ref, r, e) : n.refs && n.refs.forEach((o) => Of(o, r, e));
  }
}, EI = (e, t) => {
  t.shouldUseNativeValidation && gp(e, t);
  const r = {};
  for (const n in e) {
    const o = pe(t.fields, n), a = Object.assign(e[n] || {}, { ref: o && o.ref });
    if (MI(t.names || Object.keys(e), n)) {
      const d = Object.assign({}, pe(r, n));
      Ne(d, "root", a), Ne(r, n, d);
    } else Ne(r, n, a);
  }
  return r;
}, MI = (e, t) => e.some((r) => r.startsWith(t + "."));
function ri(e, t, r) {
  return t === void 0 && (t = {}), r === void 0 && (r = {}), function(n, o, a) {
    try {
      return Promise.resolve(function(d, i) {
        try {
          var s = (t.context && process.env.NODE_ENV === "development" && console.warn("You should not used the yup options context. Please, use the 'useForm' context object instead"), Promise.resolve(e[r.mode === "sync" ? "validateSync" : "validate"](n, Object.assign({ abortEarly: !1 }, t, { context: o }))).then(function(u) {
            return a.shouldUseNativeValidation && gp({}, a), { values: r.raw ? n : u, errors: {} };
          }));
        } catch (u) {
          return i(u);
        }
        return s && s.then ? s.then(void 0, i) : s;
      }(0, function(d) {
        if (!d.inner) throw d;
        return { values: {}, errors: EI((i = d, s = !a.shouldUseNativeValidation && a.criteriaMode === "all", (i.inner || []).reduce(function(u, c) {
          if (u[c.path] || (u[c.path] = { message: c.message, type: c.type }), s) {
            var l = u[c.path].types, p = l && l[c.type];
            u[c.path] = cp(c.path, s, u, c.type, p ? [].concat(p, c.message) : c.message);
          }
          return u;
        }, {})), a) };
        var i, s;
      }));
    } catch (d) {
      return Promise.reject(d);
    }
  };
}
var Ms, Nf;
function CI() {
  if (Nf) return Ms;
  Nf = 1;
  function e(v) {
    this._maxSize = v, this.clear();
  }
  e.prototype.clear = function() {
    this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
  }, e.prototype.get = function(v) {
    return this._values[v];
  }, e.prototype.set = function(v, y) {
    return this._size >= this._maxSize && this.clear(), v in this._values || this._size++, this._values[v] = y;
  };
  var t = /[^.^\]^[]+|(?=\[\]|\.\.)/g, r = /^\d+$/, n = /^\d/, o = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, a = /^\s*(['"]?)(.*?)(\1)\s*$/, d = 512, i = new e(d), s = new e(d), u = new e(d);
  Ms = {
    Cache: e,
    split: l,
    normalizePath: c,
    setter: function(v) {
      var y = c(v);
      return s.get(v) || s.set(v, function(w, _) {
        for (var I = 0, N = y.length, O = w; I < N - 1; ) {
          var E = y[I];
          if (E === "__proto__" || E === "constructor" || E === "prototype")
            return w;
          O = O[y[I++]];
        }
        O[y[I]] = _;
      });
    },
    getter: function(v, y) {
      var S = c(v);
      return u.get(v) || u.set(v, function(_) {
        for (var I = 0, N = S.length; I < N; )
          if (_ != null || !y) _ = _[S[I++]];
          else return;
        return _;
      });
    },
    join: function(v) {
      return v.reduce(function(y, S) {
        return y + (h(S) || r.test(S) ? "[" + S + "]" : (y ? "." : "") + S);
      }, "");
    },
    forEach: function(v, y, S) {
      p(Array.isArray(v) ? v : l(v), y, S);
    }
  };
  function c(v) {
    return i.get(v) || i.set(
      v,
      l(v).map(function(y) {
        return y.replace(a, "$2");
      })
    );
  }
  function l(v) {
    return v.match(t) || [""];
  }
  function p(v, y, S) {
    var w = v.length, _, I, N, O;
    for (I = 0; I < w; I++)
      _ = v[I], _ && ($(_) && (_ = '"' + _ + '"'), O = h(_), N = !O && /^\d+$/.test(_), y.call(S, _, O, N, I, v));
  }
  function h(v) {
    return typeof v == "string" && v && ["'", '"'].indexOf(v.charAt(0)) !== -1;
  }
  function m(v) {
    return v.match(n) && !v.match(r);
  }
  function f(v) {
    return o.test(v);
  }
  function $(v) {
    return !h(v) && (m(v) || f(v));
  }
  return Ms;
}
var cn = CI(), Cs, If;
function OI() {
  if (If) return Cs;
  If = 1;
  const e = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g, t = (c) => c.match(e) || [], r = (c) => c[0].toUpperCase() + c.slice(1), n = (c, l) => t(c).join(l).toLowerCase(), o = (c) => t(c).reduce(
    (l, p) => `${l}${l ? p[0].toUpperCase() + p.slice(1).toLowerCase() : p.toLowerCase()}`,
    ""
  );
  return Cs = {
    words: t,
    upperFirst: r,
    camelCase: o,
    pascalCase: (c) => r(o(c)),
    snakeCase: (c) => n(c, "_"),
    kebabCase: (c) => n(c, "-"),
    sentenceCase: (c) => r(n(c, " ")),
    titleCase: (c) => t(c).map(r).join(" ")
  }, Cs;
}
var Os = OI(), qa = { exports: {} }, Pf;
function NI() {
  if (Pf) return qa.exports;
  Pf = 1, qa.exports = function(o) {
    return e(t(o), o);
  }, qa.exports.array = e;
  function e(o, a) {
    var d = o.length, i = new Array(d), s = {}, u = d, c = r(a), l = n(o);
    for (a.forEach(function(h) {
      if (!l.has(h[0]) || !l.has(h[1]))
        throw new Error("Unknown node. There is an unknown node in the supplied edges.");
    }); u--; )
      s[u] || p(o[u], u, /* @__PURE__ */ new Set());
    return i;
    function p(h, m, f) {
      if (f.has(h)) {
        var $;
        try {
          $ = ", node was:" + JSON.stringify(h);
        } catch {
          $ = "";
        }
        throw new Error("Cyclic dependency" + $);
      }
      if (!l.has(h))
        throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(h));
      if (!s[m]) {
        s[m] = !0;
        var v = c.get(h) || /* @__PURE__ */ new Set();
        if (v = Array.from(v), m = v.length) {
          f.add(h);
          do {
            var y = v[--m];
            p(y, l.get(y), f);
          } while (m);
          f.delete(h);
        }
        i[--d] = h;
      }
    }
  }
  function t(o) {
    for (var a = /* @__PURE__ */ new Set(), d = 0, i = o.length; d < i; d++) {
      var s = o[d];
      a.add(s[0]), a.add(s[1]);
    }
    return Array.from(a);
  }
  function r(o) {
    for (var a = /* @__PURE__ */ new Map(), d = 0, i = o.length; d < i; d++) {
      var s = o[d];
      a.has(s[0]) || a.set(s[0], /* @__PURE__ */ new Set()), a.has(s[1]) || a.set(s[1], /* @__PURE__ */ new Set()), a.get(s[0]).add(s[1]);
    }
    return a;
  }
  function n(o) {
    for (var a = /* @__PURE__ */ new Map(), d = 0, i = o.length; d < i; d++)
      a.set(o[d], d);
    return a;
  }
  return qa.exports;
}
var II = NI();
const PI = /* @__PURE__ */ _O(II), RI = Object.prototype.toString, TI = Error.prototype.toString, DI = RegExp.prototype.toString, LI = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", FI = /^Symbol\((.*)\)(.*)$/;
function kI(e) {
  return e != +e ? "NaN" : e === 0 && 1 / e < 0 ? "-0" : "" + e;
}
function Rf(e, t = !1) {
  if (e == null || e === !0 || e === !1) return "" + e;
  const r = typeof e;
  if (r === "number") return kI(e);
  if (r === "string") return t ? `"${e}"` : e;
  if (r === "function") return "[Function " + (e.name || "anonymous") + "]";
  if (r === "symbol") return LI.call(e).replace(FI, "Symbol($1)");
  const n = RI.call(e).slice(8, -1);
  return n === "Date" ? isNaN(e.getTime()) ? "" + e : e.toISOString(e) : n === "Error" || e instanceof Error ? "[" + TI.call(e) + "]" : n === "RegExp" ? DI.call(e) : null;
}
function jr(e, t) {
  let r = Rf(e, t);
  return r !== null ? r : JSON.stringify(e, function(n, o) {
    let a = Rf(this[n], t);
    return a !== null ? a : o;
  }, 2);
}
function yp(e) {
  return e == null ? [] : [].concat(e);
}
let bp, xp, wp, jI = /\$\{\s*(\w+)\s*\}/g;
bp = Symbol.toStringTag;
class Tf {
  constructor(t, r, n, o) {
    this.name = void 0, this.message = void 0, this.value = void 0, this.path = void 0, this.type = void 0, this.params = void 0, this.errors = void 0, this.inner = void 0, this[bp] = "Error", this.name = "ValidationError", this.value = r, this.path = n, this.type = o, this.errors = [], this.inner = [], yp(t).forEach((a) => {
      if (xt.isError(a)) {
        this.errors.push(...a.errors);
        const d = a.inner.length ? a.inner : [a];
        this.inner.push(...d);
      } else
        this.errors.push(a);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
  }
}
xp = Symbol.hasInstance;
wp = Symbol.toStringTag;
class xt extends Error {
  static formatError(t, r) {
    const n = r.label || r.path || "this";
    return n !== r.path && (r = Object.assign({}, r, {
      path: n
    })), typeof t == "string" ? t.replace(jI, (o, a) => jr(r[a])) : typeof t == "function" ? t(r) : t;
  }
  static isError(t) {
    return t && t.name === "ValidationError";
  }
  constructor(t, r, n, o, a) {
    const d = new Tf(t, r, n, o);
    if (a)
      return d;
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.params = void 0, this.errors = [], this.inner = [], this[wp] = "Error", this.name = d.name, this.message = d.message, this.type = d.type, this.value = d.value, this.path = d.path, this.errors = d.errors, this.inner = d.inner, Error.captureStackTrace && Error.captureStackTrace(this, xt);
  }
  static [xp](t) {
    return Tf[Symbol.hasInstance](t) || super[Symbol.hasInstance](t);
  }
}
let er = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  defined: "${path} must be defined",
  notNull: "${path} cannot be null",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: e,
    type: t,
    value: r,
    originalValue: n
  }) => {
    const o = n != null && n !== r ? ` (cast from the value \`${jr(n, !0)}\`).` : ".";
    return t !== "mixed" ? `${e} must be a \`${t}\` type, but the final value was: \`${jr(r, !0)}\`` + o : `${e} must match the configured type. The validated value was: \`${jr(r, !0)}\`` + o;
  }
}, yt = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  datetime: "${path} must be a valid ISO date-time",
  datetime_precision: "${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits",
  datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, BI = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, Tc = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, ZI = {
  isValue: "${path} field must be ${value}"
}, Dc = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
}, UI = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
}, GI = {
  notType: (e) => {
    const {
      path: t,
      value: r,
      spec: n
    } = e, o = n.types.length;
    if (Array.isArray(r)) {
      if (r.length < o) return `${t} tuple value has too few items, expected a length of ${o} but got ${r.length} for value: \`${jr(r, !0)}\``;
      if (r.length > o) return `${t} tuple value has too many items, expected a length of ${o} but got ${r.length} for value: \`${jr(r, !0)}\``;
    }
    return xt.formatError(er.notType, e);
  }
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed: er,
  string: yt,
  number: BI,
  date: Tc,
  object: Dc,
  array: UI,
  boolean: ZI,
  tuple: GI
});
const L1 = (e) => e && e.__isYupSchema__;
class Dd {
  static fromOptions(t, r) {
    if (!r.then && !r.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: n,
      then: o,
      otherwise: a
    } = r, d = typeof n == "function" ? n : (...i) => i.every((s) => s === n);
    return new Dd(t, (i, s) => {
      var u;
      let c = d(...i) ? o : a;
      return (u = c == null ? void 0 : c(s)) != null ? u : s;
    });
  }
  constructor(t, r) {
    this.fn = void 0, this.refs = t, this.refs = t, this.fn = r;
  }
  resolve(t, r) {
    let n = this.refs.map((a) => (
      // TODO: ? operator here?
      a.getValue(r == null ? void 0 : r.value, r == null ? void 0 : r.parent, r == null ? void 0 : r.context)
    )), o = this.fn(n, t, r);
    if (o === void 0 || // @ts-ignore this can be base
    o === t)
      return t;
    if (!L1(o)) throw new TypeError("conditions must return a schema object");
    return o.resolve(r);
  }
}
const Ja = {
  context: "$",
  value: "."
};
function VI(e, t) {
  return new zr(e, t);
}
class zr {
  constructor(t, r = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof t != "string") throw new TypeError("ref must be a string, got: " + t);
    if (this.key = t.trim(), t === "") throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === Ja.context, this.isValue = this.key[0] === Ja.value, this.isSibling = !this.isContext && !this.isValue;
    let n = this.isContext ? Ja.context : this.isValue ? Ja.value : "";
    this.path = this.key.slice(n.length), this.getter = this.path && cn.getter(this.path, !0), this.map = r.map;
  }
  getValue(t, r, n) {
    let o = this.isContext ? n : this.isValue ? t : r;
    return this.getter && (o = this.getter(o || {})), this.map && (o = this.map(o)), o;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(t, r) {
    return this.getValue(t, r == null ? void 0 : r.parent, r == null ? void 0 : r.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(t) {
    return t && t.__isYupRef;
  }
}
zr.prototype.__isYupRef = !0;
const ln = (e) => e == null;
function En(e) {
  function t({
    value: r,
    path: n = "",
    options: o,
    originalValue: a,
    schema: d
  }, i, s) {
    const {
      name: u,
      test: c,
      params: l,
      message: p,
      skipAbsent: h
    } = e;
    let {
      parent: m,
      context: f,
      abortEarly: $ = d.spec.abortEarly,
      disableStackTrace: v = d.spec.disableStackTrace
    } = o;
    function y(P) {
      return zr.isRef(P) ? P.getValue(r, m, f) : P;
    }
    function S(P = {}) {
      const T = Object.assign({
        value: r,
        originalValue: a,
        label: d.spec.label,
        path: P.path || n,
        spec: d.spec,
        disableStackTrace: P.disableStackTrace || v
      }, l, P.params);
      for (const F of Object.keys(T)) T[F] = y(T[F]);
      const j = new xt(xt.formatError(P.message || p, T), r, T.path, P.type || u, T.disableStackTrace);
      return j.params = T, j;
    }
    const w = $ ? i : s;
    let _ = {
      path: n,
      parent: m,
      type: u,
      from: o.from,
      createError: S,
      resolve: y,
      options: o,
      originalValue: a,
      schema: d
    };
    const I = (P) => {
      xt.isError(P) ? w(P) : P ? s(null) : w(S());
    }, N = (P) => {
      xt.isError(P) ? w(P) : i(P);
    };
    if (h && ln(r))
      return I(!0);
    let E;
    try {
      var C;
      if (E = c.call(_, r, _), typeof ((C = E) == null ? void 0 : C.then) == "function") {
        if (o.sync)
          throw new Error(`Validation test of type: "${_.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
        return Promise.resolve(E).then(I, N);
      }
    } catch (P) {
      N(P);
      return;
    }
    I(E);
  }
  return t.OPTIONS = e, t;
}
function HI(e, t, r, n = r) {
  let o, a, d;
  return t ? (cn.forEach(t, (i, s, u) => {
    let c = s ? i.slice(1, i.length - 1) : i;
    e = e.resolve({
      context: n,
      parent: o,
      value: r
    });
    let l = e.type === "tuple", p = u ? parseInt(c, 10) : 0;
    if (e.innerType || l) {
      if (l && !u) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${d}" must contain an index to the tuple element, e.g. "${d}[0]"`);
      if (r && p >= r.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${i}, in the path: ${t}. because there is no value at that index. `);
      o = r, r = r && r[p], e = l ? e.spec.types[p] : e.innerType;
    }
    if (!u) {
      if (!e.fields || !e.fields[c]) throw new Error(`The schema does not contain the path: ${t}. (failed at: ${d} which is a type: "${e.type}")`);
      o = r, r = r && r[c], e = e.fields[c];
    }
    a = c, d = s ? "[" + i + "]" : "." + i;
  }), {
    schema: e,
    parent: o,
    parentPath: a
  }) : {
    parent: o,
    parentPath: t,
    schema: e
  };
}
class Ld extends Set {
  describe() {
    const t = [];
    for (const r of this.values())
      t.push(zr.isRef(r) ? r.describe() : r);
    return t;
  }
  resolveAll(t) {
    let r = [];
    for (const n of this.values())
      r.push(t(n));
    return r;
  }
  clone() {
    return new Ld(this.values());
  }
  merge(t, r) {
    const n = this.clone();
    return t.forEach((o) => n.add(o)), r.forEach((o) => n.delete(o)), n;
  }
}
function ho(e, t = /* @__PURE__ */ new Map()) {
  if (L1(e) || !e || typeof e != "object") return e;
  if (t.has(e)) return t.get(e);
  let r;
  if (e instanceof Date)
    r = new Date(e.getTime()), t.set(e, r);
  else if (e instanceof RegExp)
    r = new RegExp(e), t.set(e, r);
  else if (Array.isArray(e)) {
    r = new Array(e.length), t.set(e, r);
    for (let n = 0; n < e.length; n++) r[n] = ho(e[n], t);
  } else if (e instanceof Map) {
    r = /* @__PURE__ */ new Map(), t.set(e, r);
    for (const [n, o] of e.entries()) r.set(n, ho(o, t));
  } else if (e instanceof Set) {
    r = /* @__PURE__ */ new Set(), t.set(e, r);
    for (const n of e) r.add(ho(n, t));
  } else if (e instanceof Object) {
    r = {}, t.set(e, r);
    for (const [n, o] of Object.entries(e)) r[n] = ho(o, t);
  } else
    throw Error(`Unable to clone ${e}`);
  return r;
}
class dr {
  constructor(t) {
    this.type = void 0, this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this.internalTests = {}, this._whitelist = new Ld(), this._blacklist = new Ld(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this._typeCheck = void 0, this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(er.notType);
    }), this.type = t.type, this._typeCheck = t.check, this.spec = Object.assign({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      disableStackTrace: !1,
      nullable: !1,
      optional: !0,
      coerce: !0
    }, t == null ? void 0 : t.spec), this.withMutation((r) => {
      r.nonNullable();
    });
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  clone(t) {
    if (this._mutate)
      return t && Object.assign(this.spec, t), this;
    const r = Object.create(Object.getPrototypeOf(this));
    return r.type = this.type, r._typeCheck = this._typeCheck, r._whitelist = this._whitelist.clone(), r._blacklist = this._blacklist.clone(), r.internalTests = Object.assign({}, this.internalTests), r.exclusiveTests = Object.assign({}, this.exclusiveTests), r.deps = [...this.deps], r.conditions = [...this.conditions], r.tests = [...this.tests], r.transforms = [...this.transforms], r.spec = ho(Object.assign({}, this.spec, t)), r;
  }
  label(t) {
    let r = this.clone();
    return r.spec.label = t, r;
  }
  meta(...t) {
    if (t.length === 0) return this.spec.meta;
    let r = this.clone();
    return r.spec.meta = Object.assign(r.spec.meta || {}, t[0]), r;
  }
  withMutation(t) {
    let r = this._mutate;
    this._mutate = !0;
    let n = t(this);
    return this._mutate = r, n;
  }
  concat(t) {
    if (!t || t === this) return this;
    if (t.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${t.type}`);
    let r = this, n = t.clone();
    const o = Object.assign({}, r.spec, n.spec);
    return n.spec = o, n.internalTests = Object.assign({}, r.internalTests, n.internalTests), n._whitelist = r._whitelist.merge(t._whitelist, t._blacklist), n._blacklist = r._blacklist.merge(t._blacklist, t._whitelist), n.tests = r.tests, n.exclusiveTests = r.exclusiveTests, n.withMutation((a) => {
      t.tests.forEach((d) => {
        a.test(d.OPTIONS);
      });
    }), n.transforms = [...r.transforms, ...n.transforms], n;
  }
  isType(t) {
    return t == null ? !!(this.spec.nullable && t === null || this.spec.optional && t === void 0) : this._typeCheck(t);
  }
  resolve(t) {
    let r = this;
    if (r.conditions.length) {
      let n = r.conditions;
      r = r.clone(), r.conditions = [], r = n.reduce((o, a) => a.resolve(o, t), r), r = r.resolve(t);
    }
    return r;
  }
  resolveOptions(t) {
    var r, n, o, a;
    return Object.assign({}, t, {
      from: t.from || [],
      strict: (r = t.strict) != null ? r : this.spec.strict,
      abortEarly: (n = t.abortEarly) != null ? n : this.spec.abortEarly,
      recursive: (o = t.recursive) != null ? o : this.spec.recursive,
      disableStackTrace: (a = t.disableStackTrace) != null ? a : this.spec.disableStackTrace
    });
  }
  /**
   * Run the configured transform pipeline over an input value.
   */
  cast(t, r = {}) {
    let n = this.resolve(Object.assign({
      value: t
    }, r)), o = r.assert === "ignore-optionality", a = n._cast(t, r);
    if (r.assert !== !1 && !n.isType(a)) {
      if (o && ln(a))
        return a;
      let d = jr(t), i = jr(a);
      throw new TypeError(`The value of ${r.path || "field"} could not be cast to a value that satisfies the schema type: "${n.type}". 

attempted value: ${d} 
` + (i !== d ? `result of cast: ${i}` : ""));
    }
    return a;
  }
  _cast(t, r) {
    let n = t === void 0 ? t : this.transforms.reduce((o, a) => a.call(this, o, t, this), t);
    return n === void 0 && (n = this.getDefault(r)), n;
  }
  _validate(t, r = {}, n, o) {
    let {
      path: a,
      originalValue: d = t,
      strict: i = this.spec.strict
    } = r, s = t;
    i || (s = this._cast(s, Object.assign({
      assert: !1
    }, r)));
    let u = [];
    for (let c of Object.values(this.internalTests))
      c && u.push(c);
    this.runTests({
      path: a,
      value: s,
      originalValue: d,
      options: r,
      tests: u
    }, n, (c) => {
      if (c.length)
        return o(c, s);
      this.runTests({
        path: a,
        value: s,
        originalValue: d,
        options: r,
        tests: this.tests
      }, n, o);
    });
  }
  /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */
  runTests(t, r, n) {
    let o = !1, {
      tests: a,
      value: d,
      originalValue: i,
      path: s,
      options: u
    } = t, c = (f) => {
      o || (o = !0, r(f, d));
    }, l = (f) => {
      o || (o = !0, n(f, d));
    }, p = a.length, h = [];
    if (!p) return l([]);
    let m = {
      value: d,
      originalValue: i,
      path: s,
      options: u,
      schema: this
    };
    for (let f = 0; f < a.length; f++) {
      const $ = a[f];
      $(m, c, function(y) {
        y && (Array.isArray(y) ? h.push(...y) : h.push(y)), --p <= 0 && l(h);
      });
    }
  }
  asNestedTest({
    key: t,
    index: r,
    parent: n,
    parentPath: o,
    originalParent: a,
    options: d
  }) {
    const i = t ?? r;
    if (i == null)
      throw TypeError("Must include `key` or `index` for nested validations");
    const s = typeof i == "number";
    let u = n[i];
    const c = Object.assign({}, d, {
      // Nested validations fields are always strict:
      //    1. parent isn't strict so the casting will also have cast inner values
      //    2. parent is strict in which case the nested values weren't cast either
      strict: !0,
      parent: n,
      value: u,
      originalValue: a[i],
      // FIXME: tests depend on `index` being passed around deeply,
      //   we should not let the options.key/index bleed through
      key: void 0,
      // index: undefined,
      [s ? "index" : "key"]: i,
      path: s || i.includes(".") ? `${o || ""}[${s ? i : `"${i}"`}]` : (o ? `${o}.` : "") + t
    });
    return (l, p, h) => this.resolve(c)._validate(u, c, p, h);
  }
  validate(t, r) {
    var n;
    let o = this.resolve(Object.assign({}, r, {
      value: t
    })), a = (n = r == null ? void 0 : r.disableStackTrace) != null ? n : o.spec.disableStackTrace;
    return new Promise((d, i) => o._validate(t, r, (s, u) => {
      xt.isError(s) && (s.value = u), i(s);
    }, (s, u) => {
      s.length ? i(new xt(s, u, void 0, void 0, a)) : d(u);
    }));
  }
  validateSync(t, r) {
    var n;
    let o = this.resolve(Object.assign({}, r, {
      value: t
    })), a, d = (n = r == null ? void 0 : r.disableStackTrace) != null ? n : o.spec.disableStackTrace;
    return o._validate(t, Object.assign({}, r, {
      sync: !0
    }), (i, s) => {
      throw xt.isError(i) && (i.value = s), i;
    }, (i, s) => {
      if (i.length) throw new xt(i, t, void 0, void 0, d);
      a = s;
    }), a;
  }
  isValid(t, r) {
    return this.validate(t, r).then(() => !0, (n) => {
      if (xt.isError(n)) return !1;
      throw n;
    });
  }
  isValidSync(t, r) {
    try {
      return this.validateSync(t, r), !0;
    } catch (n) {
      if (xt.isError(n)) return !1;
      throw n;
    }
  }
  _getDefault(t) {
    let r = this.spec.default;
    return r == null ? r : typeof r == "function" ? r.call(this, t) : ho(r);
  }
  getDefault(t) {
    return this.resolve(t || {})._getDefault(t);
  }
  default(t) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: t
    });
  }
  strict(t = !0) {
    return this.clone({
      strict: t
    });
  }
  nullability(t, r) {
    const n = this.clone({
      nullable: t
    });
    return n.internalTests.nullable = En({
      message: r,
      name: "nullable",
      test(o) {
        return o === null ? this.schema.spec.nullable : !0;
      }
    }), n;
  }
  optionality(t, r) {
    const n = this.clone({
      optional: t
    });
    return n.internalTests.optionality = En({
      message: r,
      name: "optionality",
      test(o) {
        return o === void 0 ? this.schema.spec.optional : !0;
      }
    }), n;
  }
  optional() {
    return this.optionality(!0);
  }
  defined(t = er.defined) {
    return this.optionality(!1, t);
  }
  nullable() {
    return this.nullability(!0);
  }
  nonNullable(t = er.notNull) {
    return this.nullability(!1, t);
  }
  required(t = er.required) {
    return this.clone().withMutation((r) => r.nonNullable(t).defined(t));
  }
  notRequired() {
    return this.clone().withMutation((t) => t.nullable().optional());
  }
  transform(t) {
    let r = this.clone();
    return r.transforms.push(t), r;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...t) {
    let r;
    if (t.length === 1 ? typeof t[0] == "function" ? r = {
      test: t[0]
    } : r = t[0] : t.length === 2 ? r = {
      name: t[0],
      test: t[1]
    } : r = {
      name: t[0],
      message: t[1],
      test: t[2]
    }, r.message === void 0 && (r.message = er.default), typeof r.test != "function") throw new TypeError("`test` is a required parameters");
    let n = this.clone(), o = En(r), a = r.exclusive || r.name && n.exclusiveTests[r.name] === !0;
    if (r.exclusive && !r.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return r.name && (n.exclusiveTests[r.name] = !!r.exclusive), n.tests = n.tests.filter((d) => !(d.OPTIONS.name === r.name && (a || d.OPTIONS.test === o.OPTIONS.test))), n.tests.push(o), n;
  }
  when(t, r) {
    !Array.isArray(t) && typeof t != "string" && (r = t, t = ".");
    let n = this.clone(), o = yp(t).map((a) => new zr(a));
    return o.forEach((a) => {
      a.isSibling && n.deps.push(a.key);
    }), n.conditions.push(typeof r == "function" ? new Dd(o, r) : Dd.fromOptions(o, r)), n;
  }
  typeError(t) {
    let r = this.clone();
    return r.internalTests.typeError = En({
      message: t,
      name: "typeError",
      skipAbsent: !0,
      test(n) {
        return this.schema._typeCheck(n) ? !0 : this.createError({
          params: {
            type: this.schema.type
          }
        });
      }
    }), r;
  }
  oneOf(t, r = er.oneOf) {
    let n = this.clone();
    return t.forEach((o) => {
      n._whitelist.add(o), n._blacklist.delete(o);
    }), n.internalTests.whiteList = En({
      message: r,
      name: "oneOf",
      skipAbsent: !0,
      test(o) {
        let a = this.schema._whitelist, d = a.resolveAll(this.resolve);
        return d.includes(o) ? !0 : this.createError({
          params: {
            values: Array.from(a).join(", "),
            resolved: d
          }
        });
      }
    }), n;
  }
  notOneOf(t, r = er.notOneOf) {
    let n = this.clone();
    return t.forEach((o) => {
      n._blacklist.add(o), n._whitelist.delete(o);
    }), n.internalTests.blacklist = En({
      message: r,
      name: "notOneOf",
      test(o) {
        let a = this.schema._blacklist, d = a.resolveAll(this.resolve);
        return d.includes(o) ? this.createError({
          params: {
            values: Array.from(a).join(", "),
            resolved: d
          }
        }) : !0;
      }
    }), n;
  }
  strip(t = !0) {
    let r = this.clone();
    return r.spec.strip = t, r;
  }
  /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */
  describe(t) {
    const r = (t ? this.resolve(t) : this).clone(), {
      label: n,
      meta: o,
      optional: a,
      nullable: d
    } = r.spec;
    return {
      meta: o,
      label: n,
      optional: a,
      nullable: d,
      default: r.getDefault(t),
      type: r.type,
      oneOf: r._whitelist.describe(),
      notOneOf: r._blacklist.describe(),
      tests: r.tests.map((s) => ({
        name: s.OPTIONS.name,
        params: s.OPTIONS.params
      })).filter((s, u, c) => c.findIndex((l) => l.name === s.name) === u)
    };
  }
}
dr.prototype.__isYupSchema__ = !0;
for (const e of ["validate", "validateSync"]) dr.prototype[`${e}At`] = function(t, r, n = {}) {
  const {
    parent: o,
    parentPath: a,
    schema: d
  } = HI(this, t, r, n.context);
  return d[e](o && o[a], Object.assign({}, n, {
    parent: o,
    path: t
  }));
};
for (const e of ["equals", "is"]) dr.prototype[e] = dr.prototype.oneOf;
for (const e of ["not", "nope"]) dr.prototype[e] = dr.prototype.notOneOf;
const KI = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function WI(e) {
  const t = Lc(e);
  if (!t) return Date.parse ? Date.parse(e) : Number.NaN;
  if (t.z === void 0 && t.plusMinus === void 0)
    return new Date(t.year, t.month, t.day, t.hour, t.minute, t.second, t.millisecond).valueOf();
  let r = 0;
  return t.z !== "Z" && t.plusMinus !== void 0 && (r = t.hourOffset * 60 + t.minuteOffset, t.plusMinus === "+" && (r = 0 - r)), Date.UTC(t.year, t.month, t.day, t.hour, t.minute + r, t.second, t.millisecond);
}
function Lc(e) {
  var t, r;
  const n = KI.exec(e);
  return n ? {
    year: $r(n[1]),
    month: $r(n[2], 1) - 1,
    day: $r(n[3], 1),
    hour: $r(n[4]),
    minute: $r(n[5]),
    second: $r(n[6]),
    millisecond: n[7] ? (
      // allow arbitrary sub-second precision beyond milliseconds
      $r(n[7].substring(0, 3))
    ) : 0,
    precision: (t = (r = n[7]) == null ? void 0 : r.length) != null ? t : void 0,
    z: n[8] || void 0,
    plusMinus: n[9] || void 0,
    hourOffset: $r(n[10]),
    minuteOffset: $r(n[11])
  } : null;
}
function $r(e, t = 0) {
  return Number(e) || t;
}
let zI = (
  // eslint-disable-next-line
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
), YI = (
  // eslint-disable-next-line
  /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i
), XI = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, qI = "^\\d{4}-\\d{2}-\\d{2}", JI = "\\d{2}:\\d{2}:\\d{2}", QI = "(([+-]\\d{2}(:?\\d{2})?)|Z)", eP = new RegExp(`${qI}T${JI}(\\.\\d+)?${QI}$`), tP = (e) => ln(e) || e === e.trim(), rP = {}.toString();
function mr() {
  return new Ap();
}
class Ap extends dr {
  constructor() {
    super({
      type: "string",
      check(t) {
        return t instanceof String && (t = t.valueOf()), typeof t == "string";
      }
    }), this.withMutation(() => {
      this.transform((t, r, n) => {
        if (!n.spec.coerce || n.isType(t) || Array.isArray(t)) return t;
        const o = t != null && t.toString ? t.toString() : t;
        return o === rP ? t : o;
      });
    });
  }
  required(t) {
    return super.required(t).withMutation((r) => r.test({
      message: t || er.required,
      name: "required",
      skipAbsent: !0,
      test: (n) => !!n.length
    }));
  }
  notRequired() {
    return super.notRequired().withMutation((t) => (t.tests = t.tests.filter((r) => r.OPTIONS.name !== "required"), t));
  }
  length(t, r = yt.length) {
    return this.test({
      message: r,
      name: "length",
      exclusive: !0,
      params: {
        length: t
      },
      skipAbsent: !0,
      test(n) {
        return n.length === this.resolve(t);
      }
    });
  }
  min(t, r = yt.min) {
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      skipAbsent: !0,
      test(n) {
        return n.length >= this.resolve(t);
      }
    });
  }
  max(t, r = yt.max) {
    return this.test({
      name: "max",
      exclusive: !0,
      message: r,
      params: {
        max: t
      },
      skipAbsent: !0,
      test(n) {
        return n.length <= this.resolve(t);
      }
    });
  }
  matches(t, r) {
    let n = !1, o, a;
    return r && (typeof r == "object" ? {
      excludeEmptyString: n = !1,
      message: o,
      name: a
    } = r : o = r), this.test({
      name: a || "matches",
      message: o || yt.matches,
      params: {
        regex: t
      },
      skipAbsent: !0,
      test: (d) => d === "" && n || d.search(t) !== -1
    });
  }
  email(t = yt.email) {
    return this.matches(zI, {
      name: "email",
      message: t,
      excludeEmptyString: !0
    });
  }
  url(t = yt.url) {
    return this.matches(YI, {
      name: "url",
      message: t,
      excludeEmptyString: !0
    });
  }
  uuid(t = yt.uuid) {
    return this.matches(XI, {
      name: "uuid",
      message: t,
      excludeEmptyString: !1
    });
  }
  datetime(t) {
    let r = "", n, o;
    return t && (typeof t == "object" ? {
      message: r = "",
      allowOffset: n = !1,
      precision: o = void 0
    } = t : r = t), this.matches(eP, {
      name: "datetime",
      message: r || yt.datetime,
      excludeEmptyString: !0
    }).test({
      name: "datetime_offset",
      message: r || yt.datetime_offset,
      params: {
        allowOffset: n
      },
      skipAbsent: !0,
      test: (a) => {
        if (!a || n) return !0;
        const d = Lc(a);
        return d ? !!d.z : !1;
      }
    }).test({
      name: "datetime_precision",
      message: r || yt.datetime_precision,
      params: {
        precision: o
      },
      skipAbsent: !0,
      test: (a) => {
        if (!a || o == null) return !0;
        const d = Lc(a);
        return d ? d.precision === o : !1;
      }
    });
  }
  //-- transforms --
  ensure() {
    return this.default("").transform((t) => t === null ? "" : t);
  }
  trim(t = yt.trim) {
    return this.transform((r) => r != null ? r.trim() : r).test({
      message: t,
      name: "trim",
      test: tP
    });
  }
  lowercase(t = yt.lowercase) {
    return this.transform((r) => ln(r) ? r : r.toLowerCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      skipAbsent: !0,
      test: (r) => ln(r) || r === r.toLowerCase()
    });
  }
  uppercase(t = yt.uppercase) {
    return this.transform((r) => ln(r) ? r : r.toUpperCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      skipAbsent: !0,
      test: (r) => ln(r) || r === r.toUpperCase()
    });
  }
}
mr.prototype = Ap.prototype;
let nP = /* @__PURE__ */ new Date(""), oP = (e) => Object.prototype.toString.call(e) === "[object Date]";
class F1 extends dr {
  constructor() {
    super({
      type: "date",
      check(t) {
        return oP(t) && !isNaN(t.getTime());
      }
    }), this.withMutation(() => {
      this.transform((t, r, n) => !n.spec.coerce || n.isType(t) || t === null ? t : (t = WI(t), isNaN(t) ? F1.INVALID_DATE : new Date(t)));
    });
  }
  prepareParam(t, r) {
    let n;
    if (zr.isRef(t))
      n = t;
    else {
      let o = this.cast(t);
      if (!this._typeCheck(o)) throw new TypeError(`\`${r}\` must be a Date or a value that can be \`cast()\` to a Date`);
      n = o;
    }
    return n;
  }
  min(t, r = Tc.min) {
    let n = this.prepareParam(t, "min");
    return this.test({
      message: r,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      skipAbsent: !0,
      test(o) {
        return o >= this.resolve(n);
      }
    });
  }
  max(t, r = Tc.max) {
    let n = this.prepareParam(t, "max");
    return this.test({
      message: r,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      skipAbsent: !0,
      test(o) {
        return o <= this.resolve(n);
      }
    });
  }
}
F1.INVALID_DATE = nP;
function aP(e, t = []) {
  let r = [], n = /* @__PURE__ */ new Set(), o = new Set(t.map(([d, i]) => `${d}-${i}`));
  function a(d, i) {
    let s = cn.split(d)[0];
    n.add(s), o.has(`${i}-${s}`) || r.push([i, s]);
  }
  for (const d of Object.keys(e)) {
    let i = e[d];
    n.add(d), zr.isRef(i) && i.isSibling ? a(i.path, d) : L1(i) && "deps" in i && i.deps.forEach((s) => a(s, d));
  }
  return PI.array(Array.from(n), r).reverse();
}
function Df(e, t) {
  let r = 1 / 0;
  return e.some((n, o) => {
    var a;
    if ((a = t.path) != null && a.includes(n))
      return r = o, !0;
  }), r;
}
function Sp(e) {
  return (t, r) => Df(e, t) - Df(e, r);
}
const dP = (e, t, r) => {
  if (typeof e != "string")
    return e;
  let n = e;
  try {
    n = JSON.parse(e);
  } catch {
  }
  return r.isType(n) ? n : e;
};
function wd(e) {
  if ("fields" in e) {
    const t = {};
    for (const [r, n] of Object.entries(e.fields))
      t[r] = wd(n);
    return e.setFields(t);
  }
  if (e.type === "array") {
    const t = e.optional();
    return t.innerType && (t.innerType = wd(t.innerType)), t;
  }
  return e.type === "tuple" ? e.optional().clone({
    types: e.spec.types.map(wd)
  }) : "optional" in e ? e.optional() : e;
}
const iP = (e, t) => {
  const r = [...cn.normalizePath(t)];
  if (r.length === 1) return r[0] in e;
  let n = r.pop(), o = cn.getter(cn.join(r), !0)(e);
  return !!(o && n in o);
};
let Lf = (e) => Object.prototype.toString.call(e) === "[object Object]";
function sP(e, t) {
  let r = Object.keys(e.fields);
  return Object.keys(t).filter((n) => r.indexOf(n) === -1);
}
const uP = Sp([]);
function Ca(e) {
  return new _p(e);
}
class _p extends dr {
  constructor(t) {
    super({
      type: "object",
      check(r) {
        return Lf(r) || typeof r == "function";
      }
    }), this.fields = /* @__PURE__ */ Object.create(null), this._sortErrors = uP, this._nodes = [], this._excludedEdges = [], this.withMutation(() => {
      t && this.shape(t);
    });
  }
  _cast(t, r = {}) {
    var n;
    let o = super._cast(t, r);
    if (o === void 0) return this.getDefault(r);
    if (!this._typeCheck(o)) return o;
    let a = this.fields, d = (n = r.stripUnknown) != null ? n : this.spec.noUnknown, i = [].concat(this._nodes, Object.keys(o).filter((l) => !this._nodes.includes(l))), s = {}, u = Object.assign({}, r, {
      parent: s,
      __validating: r.__validating || !1
    }), c = !1;
    for (const l of i) {
      let p = a[l], h = l in o;
      if (p) {
        let m, f = o[l];
        u.path = (r.path ? `${r.path}.` : "") + l, p = p.resolve({
          value: f,
          context: r.context,
          parent: s
        });
        let $ = p instanceof dr ? p.spec : void 0, v = $ == null ? void 0 : $.strict;
        if ($ != null && $.strip) {
          c = c || l in o;
          continue;
        }
        m = !r.__validating || !v ? (
          // TODO: use _cast, this is double resolving
          p.cast(o[l], u)
        ) : o[l], m !== void 0 && (s[l] = m);
      } else h && !d && (s[l] = o[l]);
      (h !== l in s || s[l] !== o[l]) && (c = !0);
    }
    return c ? s : o;
  }
  _validate(t, r = {}, n, o) {
    let {
      from: a = [],
      originalValue: d = t,
      recursive: i = this.spec.recursive
    } = r;
    r.from = [{
      schema: this,
      value: d
    }, ...a], r.__validating = !0, r.originalValue = d, super._validate(t, r, n, (s, u) => {
      if (!i || !Lf(u)) {
        o(s, u);
        return;
      }
      d = d || u;
      let c = [];
      for (let l of this._nodes) {
        let p = this.fields[l];
        !p || zr.isRef(p) || c.push(p.asNestedTest({
          options: r,
          key: l,
          parent: u,
          parentPath: r.path,
          originalParent: d
        }));
      }
      this.runTests({
        tests: c,
        value: u,
        originalValue: d,
        options: r
      }, n, (l) => {
        o(l.sort(this._sortErrors).concat(s), u);
      });
    });
  }
  clone(t) {
    const r = super.clone(t);
    return r.fields = Object.assign({}, this.fields), r._nodes = this._nodes, r._excludedEdges = this._excludedEdges, r._sortErrors = this._sortErrors, r;
  }
  concat(t) {
    let r = super.concat(t), n = r.fields;
    for (let [o, a] of Object.entries(this.fields)) {
      const d = n[o];
      n[o] = d === void 0 ? a : d;
    }
    return r.withMutation((o) => (
      // XXX: excludes here is wrong
      o.setFields(n, [...this._excludedEdges, ...t._excludedEdges])
    ));
  }
  _getDefault(t) {
    if ("default" in this.spec)
      return super._getDefault(t);
    if (!this._nodes.length)
      return;
    let r = {};
    return this._nodes.forEach((n) => {
      var o;
      const a = this.fields[n];
      let d = t;
      (o = d) != null && o.value && (d = Object.assign({}, d, {
        parent: d.value,
        value: d.value[n]
      })), r[n] = a && "getDefault" in a ? a.getDefault(d) : void 0;
    }), r;
  }
  setFields(t, r) {
    let n = this.clone();
    return n.fields = t, n._nodes = aP(t, r), n._sortErrors = Sp(Object.keys(t)), r && (n._excludedEdges = r), n;
  }
  shape(t, r = []) {
    return this.clone().withMutation((n) => {
      let o = n._excludedEdges;
      return r.length && (Array.isArray(r[0]) || (r = [r]), o = [...n._excludedEdges, ...r]), n.setFields(Object.assign(n.fields, t), o);
    });
  }
  partial() {
    const t = {};
    for (const [r, n] of Object.entries(this.fields))
      t[r] = "optional" in n && n.optional instanceof Function ? n.optional() : n;
    return this.setFields(t);
  }
  deepPartial() {
    return wd(this);
  }
  pick(t) {
    const r = {};
    for (const n of t)
      this.fields[n] && (r[n] = this.fields[n]);
    return this.setFields(r, this._excludedEdges.filter(([n, o]) => t.includes(n) && t.includes(o)));
  }
  omit(t) {
    const r = [];
    for (const n of Object.keys(this.fields))
      t.includes(n) || r.push(n);
    return this.pick(r);
  }
  from(t, r, n) {
    let o = cn.getter(t, !0);
    return this.transform((a) => {
      if (!a) return a;
      let d = a;
      return iP(a, t) && (d = Object.assign({}, a), n || delete d[t], d[r] = o(a)), d;
    });
  }
  /** Parse an input JSON string to an object */
  json() {
    return this.transform(dP);
  }
  noUnknown(t = !0, r = Dc.noUnknown) {
    typeof t != "boolean" && (r = t, t = !0);
    let n = this.test({
      name: "noUnknown",
      exclusive: !0,
      message: r,
      test(o) {
        if (o == null) return !0;
        const a = sP(this.schema, o);
        return !t || a.length === 0 || this.createError({
          params: {
            unknown: a.join(", ")
          }
        });
      }
    });
    return n.spec.noUnknown = t, n;
  }
  unknown(t = !0, r = Dc.noUnknown) {
    return this.noUnknown(!t, r);
  }
  transformKeys(t) {
    return this.transform((r) => {
      if (!r) return r;
      const n = {};
      for (const o of Object.keys(r)) n[t(o)] = r[o];
      return n;
    });
  }
  camelCase() {
    return this.transformKeys(Os.camelCase);
  }
  snakeCase() {
    return this.transformKeys(Os.snakeCase);
  }
  constantCase() {
    return this.transformKeys((t) => Os.snakeCase(t).toUpperCase());
  }
  describe(t) {
    const r = (t ? this.resolve(t) : this).clone(), n = super.describe(t);
    n.fields = {};
    for (const [a, d] of Object.entries(r.fields)) {
      var o;
      let i = t;
      (o = i) != null && o.value && (i = Object.assign({}, i, {
        parent: i.value,
        value: i.value[a]
      })), n.fields[a] = d.describe(i);
    }
    return n;
  }
}
Ca.prototype = _p.prototype;
function ni(e) {
  const { apiCall: t, onResponse: r, onError: n } = typeof e == "function" ? { apiCall: e } : e, [o, a] = Ie(), [d, i] = Ie(), [s, u] = Ie(!1), [c, l] = Ie(!1), [p, h] = Ie(!1), [m, f] = Ie(!1);
  return { submit: async ($) => {
    try {
      u(!0), f(!1), a(void 0), l(!1), h(!1);
      const v = await t($);
      i(v), l(!0), r == null || r(v);
    } catch (v) {
      const y = { status: v.status, code: v.code, data: v.data };
      a(y), h(!0), n == null || n(y);
    } finally {
      u(!1), f(!0);
    }
  }, isApiLoading: s, apiResponse: d, apiError: o, isApiLoaded: m, isApiOk: c, isApiError: p };
}
function $e(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function lP(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var o = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var Mn = {}, Cn = {}, je = {}, Pe = {}, Ff;
function oi() {
  if (Ff) return Pe;
  Ff = 1, Object.defineProperty(Pe, "__esModule", { value: !0 }), Pe.PropValueProvider = Pe.IdentityProvider = Pe.ValueProvider = void 0, Pe.nullIfEmpty = e, Pe.trimBlank = t, Pe.trimStrings = r, Pe.nvl = n, Pe.isBlank = o, Pe.isBlankObject = a, Pe.isEmpty = d, Pe.omit = i, Pe.omitUntyped = s, Pe.pick = u, Pe.pickAndSkipUndefined = c, Pe.pickUntyped = l, Pe.isPrimitiveValue = p, Pe.mapObject = h, Pe.assignOwnProps = m, Pe.prop = f, Pe.deepSortObject = S;
  function e(w) {
    return w && Object.entries(w).find(([_, I]) => !o(I)) ? w : null;
  }
  function t(w) {
    if (o(w))
      return;
    if (typeof w != "object" || w instanceof Date)
      return w;
    if (Array.isArray(w))
      return w.map((O) => t(O)).filter((O) => !o(O));
    let _ = !1, I = !1;
    const N = Object.entries(w).reduce((O, [E, C]) => {
      const P = t(C);
      return Array.isArray(P) ? (O[E] = P, P.length && (I = !0)) : o(P) || (O[E] = P, _ = !0), O;
    }, {});
    return _ || I ? N : void 0;
  }
  function r(w) {
    return typeof w == "string" ? w.trim() : typeof w == "object" ? Object.entries(w).reduce((_, [I, N]) => (_[I] = r(N), _), {}) : Array.isArray(w) ? w.map((_) => r(_)) : w;
  }
  function n(w, _) {
    return o(w) ? _ : w;
  }
  function o(w) {
    return w == null;
  }
  function a(w) {
    return w == null ? !0 : !Object.entries(w).find(([_, I]) => !o(I));
  }
  function d(w) {
    return w == null || w === "";
  }
  function i(w, ..._) {
    const I = Object.assign({}, w);
    return _.forEach((N) => delete I[N]), I;
  }
  function s(w, ..._) {
    const I = Object.assign({}, w);
    return _.forEach((N) => delete I[N]), I;
  }
  function u(w, ..._) {
    return _.reduce((I, N) => (I[N] = w[N], I), {});
  }
  function c(w, ..._) {
    return _.reduce((I, N) => (w[N] !== void 0 && (I[N] = w[N]), I), {});
  }
  function l(w, ..._) {
    return _.reduce((I, N) => (I[N] = w[N], I), {});
  }
  function p(w) {
    const _ = typeof w;
    return w == null || _ === "string" || _ === "number" || _ === "boolean" || _ === "undefined" || _ === "bigint" || _ === "symbol" || w instanceof Date;
  }
  function h(w, _) {
    return w && Object.fromEntries(Object.entries(w).map(_));
  }
  function m(w, _) {
    Object.getOwnPropertyNames(w).forEach((I) => {
      w[I] = _[I];
    });
  }
  function f(w, _) {
    if (o(w) || d(_))
      return w;
    let I = w;
    const N = _.split(".");
    for (const O of N)
      if (I = I[O.trim()], o(I))
        return I;
    return I;
  }
  class $ {
    // noinspection TypeScriptAbstractClassConstructorCanBeMadeProtected
    constructor(_) {
      this.obj = _;
    }
  }
  Pe.ValueProvider = $;
  class v extends $ {
    get value() {
      return "getId" in this.obj ? { id: this.obj.getId() } : { id: this.obj.id };
    }
  }
  Pe.IdentityProvider = v;
  class y extends $ {
    constructor(_, I) {
      super(_), this.prop = I;
    }
    get value() {
      return f(this.obj, this.prop);
    }
  }
  Pe.PropValueProvider = y;
  function S(w) {
    const _ = w;
    if (typeof _ != "object" || _ === null)
      return _;
    if (Array.isArray(_))
      return _.map(S);
    const I = Object.keys(_).sort(), N = {};
    return I.forEach((O) => {
      const E = _[O];
      N[O] = typeof E == "object" && E !== null && !(E instanceof Date) ? S(E) : E;
    }), N;
  }
  return Pe;
}
var Be = {}, kf;
function Ro() {
  if (kf) return Be;
  kf = 1, Object.defineProperty(Be, "__esModule", { value: !0 }), Be.split = t, Be.camel2snake = r, Be.camel2spine = n, Be.pascal2camel = o, Be.pascal2snake = a, Be.pascal2spine = d, Be.toPascal = i, Be.toSpine = s, Be.toSnake = u, Be.toCamel = c, Be.circularDepsReplacer = l, Be.json = p, Be.jsonStable = h, Be.stringifySafe = m, Be.lpad = v, Be.rpad = y, Be.replaceAll = S, Be.randomString = w, Be.randomCode = _, Be.randomDigits = I, Be.reverse = N, Be.hashCode = O;
  const e = oi();
  function t(E, C) {
    return [E.slice(0, C), E.slice(C)];
  }
  function r(E) {
    return E.replace(/[A-Z]/g, (C) => "_" + C.toLowerCase());
  }
  function n(E) {
    return E.replace(/[A-Z]/g, (C) => "-" + C.toLowerCase());
  }
  function o(E) {
    return E.charAt(0).toLowerCase() + E.slice(1);
  }
  function a(E) {
    return E.charAt(0).toLowerCase() + r(E.slice(1));
  }
  function d(E) {
    return E.charAt(0).toLowerCase() + n(E.slice(1));
  }
  function i(E, C = !1) {
    let P = E.split(/([_-]\w)/g).map((T) => T.startsWith("_") || T.startsWith("-") ? T.slice(1).toUpperCase() : T).join("");
    return C && (P = P.split(/([A-Z]+)/g).map((T) => T.length > 1 && T.match(/[A-Z]+/) ? T.charAt(0) + T.slice(1).toLowerCase() : T).join("")), P.charAt(0).toUpperCase() + P.slice(1);
  }
  function s(E) {
    return d(i(E, !0).replace(/ +/, "-"));
  }
  function u(E) {
    return a(i(E, !0).replace(/ +/, "_"));
  }
  function c(E) {
    return o(i(E, !0).replace(/ +/, ""));
  }
  function l() {
    const E = [];
    return function(C, P) {
      if (typeof P == "object" && P !== null) {
        if (E.indexOf(P) !== -1)
          return;
        E.push(P);
      }
      return typeof P == "bigint" ? "big:" + P.toString() : P;
    };
  }
  function p(E, C = " ", P) {
    return JSON.stringify(E, P ?? l(), C === !1 ? "" : C);
  }
  function h(E, C = !1, P) {
    return p((0, e.deepSortObject)(E), C, P);
  }
  function m(E, C, P = "*****") {
    return p(f(E, C ?? [/password/gi, /secret/gi, /key/gi, /token/gi], P));
  }
  function f(E, C, P) {
    return (0, e.isPrimitiveValue)(E) ? E : Object.entries(E).reduce((T, [j, F]) => (C.some((Z) => Z.test(j)) && (0, e.isPrimitiveValue)(F) ? T[j] = P : (0, e.isPrimitiveValue)(F) ? T[j] = F : Array.isArray(F) ? T[j] = F.map((Z) => f(Z, C, P)) : T[j] = f(F, C, P), T), {});
  }
  function $(E, C) {
    return E > 0 ? C.repeat(E / C.length + 1).slice(0, E) : "";
  }
  function v(E, C, P = " ") {
    return $(C - `${E}`.length, P) + E;
  }
  function y(E, C, P = " ") {
    return E + $(C - `${E}`.length, P);
  }
  function S(E, C, P) {
    return E.replace(
      // eslint-disable-next-line security/detect-non-literal-regexp
      typeof C == "string" ? new RegExp(C, "g") : C,
      P
    );
  }
  function w(E, C = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789") {
    return new Array(E).fill(null).map(() => C.charAt(Math.floor(Math.random() * C.length))).join("");
  }
  function _(E, C = "ABCDEFGHIJKLMNPQRSTUVWXYZ123456789") {
    return w(E, C);
  }
  function I(E) {
    return w(E, "0123456789");
  }
  function N(E) {
    return E.split("").reverse().join("");
  }
  function O(E, C = Number.MAX_SAFE_INTEGER, P = !0) {
    E = P ? N(E) : E;
    const T = 37;
    let j = 17;
    if (E.length === 0)
      return j;
    for (let F = 0; F < E.length; F++) {
      const Z = E.charCodeAt(F) + (7 ^ F);
      j = T * j + Z;
    }
    return Math.abs(j) % C;
  }
  return Be;
}
var jf;
function cP() {
  if (jf) return je;
  jf = 1, Object.defineProperty(je, "__esModule", { value: !0 }), je.ConcurrentUpdateError = je.DataValidationError = je.ValidationError = je.NotFoundError = je.UnauthorizedImpersonationError = je.AuthorizationError = je.AuthenticationError = je.AppError = je.HttpError = je.TimeoutError = je.Exception = void 0;
  const e = oi(), t = Ro();
  class r extends Error {
    constructor(m, f) {
      var $, v, y, S;
      super(typeof m == "string" ? m : ($ = m == null ? void 0 : m.message) !== null && $ !== void 0 ? $ : (0, t.json)(m, !1)), this.body = m, this.root = f, this.stack = ((v = this.stack) !== null && v !== void 0 ? v : "") + (f ? `
Root: ` + ((S = (y = f.stack) !== null && y !== void 0 ? y : f.message) !== null && S !== void 0 ? S : f) : ""), Object.setPrototypeOf(this, r.prototype);
    }
  }
  je.Exception = r;
  class n extends r {
    constructor(m, f) {
      super(m ?? "Timeout happened", f), Object.setPrototypeOf(this, n.prototype);
    }
  }
  je.TimeoutError = n;
  class o extends r {
    constructor(m, f, $ = 400) {
      super(m, f), this.status = $, Object.setPrototypeOf(this, o.prototype);
    }
  }
  je.HttpError = o;
  class a extends o {
    constructor(m, f, $, v, y = 409) {
      super({ message: m, code: f, args: v }, $, y), this.message = m, this.code = f, this.args = v, Object.setPrototypeOf(this, a.prototype);
    }
  }
  je.AppError = a;
  class d extends a {
    constructor(m, f, $) {
      super(m ?? "Authentication failed.", f ?? "authentication-failed", $, void 0, 401), Object.setPrototypeOf(this, d.prototype);
    }
  }
  je.AuthenticationError = d;
  class i extends a {
    constructor(m, f, $) {
      super(m ?? "Authorization failed.", f ?? "unauthorized", $, void 0, 403), Object.setPrototypeOf(this, i.prototype);
    }
  }
  je.AuthorizationError = i;
  class s extends i {
    constructor(m, f, $) {
      super(m ?? "Unauthorized impersonation.", f ?? "unauthorized-impersonation", $), Object.setPrototypeOf(this, s.prototype);
    }
  }
  je.UnauthorizedImpersonationError = s;
  class u extends o {
    constructor(m, f) {
      super((0, e.nullIfEmpty)({ message: m }), f, 404), Object.setPrototypeOf(this, u.prototype);
    }
  }
  je.NotFoundError = u;
  class c extends o {
    constructor(m, f) {
      super((0, e.nullIfEmpty)({ message: m }), f, 400), Object.setPrototypeOf(this, c.prototype);
    }
  }
  je.ValidationError = c;
  class l extends o {
    constructor(m) {
      super({ errors: m }, 400), Object.setPrototypeOf(this, l.prototype), this.errors = m;
    }
  }
  je.DataValidationError = l;
  class p extends r {
    constructor(m, f) {
      super(m ?? "Concurrent update happened", f), Object.setPrototypeOf(this, p.prototype);
    }
  }
  return je.ConcurrentUpdateError = p, je;
}
var Bf = {}, Zf;
function fP() {
  return Zf || (Zf = 1, Object.defineProperty(Bf, "__esModule", { value: !0 })), Bf;
}
var Uf;
function pP() {
  return Uf || (Uf = 1, function(e) {
    var t = Cn && Cn.__createBinding || (Object.create ? function(n, o, a, d) {
      d === void 0 && (d = a);
      var i = Object.getOwnPropertyDescriptor(o, a);
      (!i || ("get" in i ? !o.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
        return o[a];
      } }), Object.defineProperty(n, d, i);
    } : function(n, o, a, d) {
      d === void 0 && (d = a), n[d] = o[a];
    }), r = Cn && Cn.__exportStar || function(n, o) {
      for (var a in n) a !== "default" && !Object.prototype.hasOwnProperty.call(o, a) && t(o, n, a);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), r(cP(), e), r(fP(), e);
  }(Cn)), Cn;
}
var Xo = {}, Gf;
function Ep() {
  if (Gf) return Xo;
  Gf = 1, Object.defineProperty(Xo, "__esModule", { value: !0 }), Xo.grow = e, Xo.flatten = t;
  function e(d, i = "", s = "_") {
    return Array.isArray(d) ? d.map((u) => n(u, i, s)) : n(d, i, s);
  }
  function t(d, i = "", s = "_") {
    return Array.isArray(d) ? d.map((u) => a(u, s)).map((u) => r(u, i)) : r(a(d, s), i);
  }
  function r(d, i) {
    const s = {};
    return Object.entries(d).forEach(([u, c]) => {
      s[i + u] = c;
    }), s;
  }
  function n(d, i, s) {
    if (d == null)
      return d;
    const u = {};
    return Object.entries(d).filter(([c]) => c.startsWith(i)).map(([c, l]) => [c.replace(i, ""), l]).forEach(([c, l]) => {
      const p = c.split(s), h = p.splice(-1, 1);
      let m = u;
      p.forEach((f) => {
        m = o(m, f);
      }), m[h] = l;
    }), u;
  }
  function o(d, i, s) {
    return d[i] === void 0 && (s === void 0 && (s = {}), d[i] = s), d[i];
  }
  function a(d, i, s = [], u = {}) {
    let c = Object.assign({}, u);
    for (const l in d) {
      const p = [...s, l];
      if (Array.isArray(d[l]))
        c[p.join(i)] = d[l];
      else if (typeof d[l] == "object") {
        const h = a(d[l], i, p, {});
        c = Object.assign(Object.assign({}, c), h);
      } else
        c[p.join(i)] = d[l];
    }
    return c;
  }
  return Xo;
}
var Vf = {}, qo = {}, Hf;
function Mp() {
  if (Hf) return qo;
  Hf = 1, Object.defineProperty(qo, "__esModule", { value: !0 }), qo.inTimezone = t, qo.msToDuration = o;
  const e = Ro();
  function t(a, d, i) {
    return new Date(a.toLocaleString(i, {
      timeZone: d
    }));
  }
  const r = {
    ms: 0,
    s: 1,
    m: 2,
    h: 3,
    d: 4
  };
  function n(a, d) {
    return r[a] > r[d];
  }
  function o(a, d = "d") {
    const i = Math.floor(a % (n(d, "ms") ? 1e3 : Number.MAX_SAFE_INTEGER)), s = Math.floor(a / 1e3 % (n(d, "s") ? 60 : d === "s" ? Number.MAX_SAFE_INTEGER : 1)), u = Math.floor(a / 1e3 / 60 % (n(d, "m") ? 60 : d === "m" ? Number.MAX_SAFE_INTEGER : 1)), c = Math.floor(a / 1e3 / 60 / 60 % (n(d, "h") ? 24 : d === "h" ? Number.MAX_SAFE_INTEGER : 1)), l = d === "d" ? Math.floor(a / 1e3 / 60 / 60 / 24 % 24) : 0;
    let p = "";
    if (l || p.length) {
      const h = `${l}`;
      p += `${h}d `;
    }
    if (c || p.length) {
      const h = n(d, "h") && p.length ? (0, e.lpad)(c, 2, "0") : `${c}`;
      p += `${h}h `;
    }
    if (u || p.length) {
      const h = n(d, "m") && p.length ? (0, e.lpad)(u, 2, "0") : `${u}`;
      p += `${h}m `;
    }
    if (s || p.length) {
      const h = n(d, "s") && p.length ? (0, e.lpad)(s, 2, "0") : `${s}`;
      p += `${h}s `;
    }
    if (i || p.length) {
      const h = n(d, "ms") && p.length ? (0, e.lpad)(i, 3, "0") : `${i}`;
      p += `${h}ms`;
    }
    return p;
  }
  return qo;
}
var Kf;
function $P() {
  return Kf || (Kf = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.noopLogger = e.NoopLogger = e.SimpleConsoleLogger = e.BareConsoleLogger = e.BaseLogger = e.ContextHolder = e.logLevelWeights = e.LogLevel = void 0, e.utcTimeString = c, e.localTimeString = l, e.getMessageText = h;
    const t = Mp(), r = oi(), n = Ro();
    var o;
    (function(m) {
      m.off = "off", m.fatal = "fatal", m.error = "error", m.warn = "warn", m.info = "info", m.trace = "trace", m.debug = "debug";
    })(o || (e.LogLevel = o = {})), e.logLevelWeights = {
      [o.off]: 0,
      [o.fatal]: 1,
      [o.error]: 2,
      [o.warn]: 3,
      [o.info]: 4,
      [o.trace]: 5,
      [o.debug]: 6
    };
    class a {
      constructor(f) {
        this.name = f;
      }
    }
    e.ContextHolder = a;
    class d {
      constructor(f, $) {
        var v, y;
        this.config = f, this.ctx = $, this._context = (y = (v = this.config) === null || v === void 0 ? void 0 : v.format) === null || y === void 0 ? void 0 : y.context;
      }
      log(f, ...$) {
        var v, y, S, w, _, I;
        if (!this.isEnabled(f))
          return;
        const N = /* @__PURE__ */ new Date(), O = !((y = (v = this.config) === null || v === void 0 ? void 0 : v.format) === null || y === void 0) && y.timezone ? `${l(N, this.config.format.timezone)} in ${this.config.format.timezone}` : "", E = c(N) + (O ? ` (${O})` : "");
        let C = (I = (S = this.getContext()) !== null && S !== void 0 ? S : (_ = (w = this.config) === null || w === void 0 ? void 0 : w.format) === null || _ === void 0 ? void 0 : _.context) !== null && I !== void 0 ? I : "MAIN";
        const P = $[$.length - 1];
        P instanceof a && (C = P.name, $ = $.slice(0, -1));
        const T = {
          timestamp: E,
          context: C
        }, j = $.map((F) => (typeof F == "function" && (F = F()), F)).map((F) => {
          var Z, te;
          return h(F, !1, (te = (Z = this.config) === null || Z === void 0 ? void 0 : Z.format) === null || te === void 0 ? void 0 : te.objectFormat);
        });
        this.logMessages(f, T, ...j);
      }
      debug(...f) {
        this.log(o.debug, ...f);
      }
      info(...f) {
        this.log(o.info, ...f);
      }
      trace(...f) {
        this.log(o.trace, ...f);
      }
      warn(...f) {
        this.log(o.warn, ...f);
      }
      error(...f) {
        this.log(o.error, ...f);
      }
      fatal(...f) {
        this.log(o.fatal, ...f);
      }
      isEnabled(f) {
        var $, v;
        return e.logLevelWeights[(v = ($ = this.config) === null || $ === void 0 ? void 0 : $.level) !== null && v !== void 0 ? v : o.debug] >= e.logLevelWeights[f];
      }
      setContext(f) {
        this._context = f;
      }
      getContext() {
        return this._context;
      }
    }
    e.BaseLogger = d;
    class i extends d {
      constructor(f = o.debug) {
        super({
          level: f
        }), this.level = f;
      }
      clone() {
        return new i(this.level);
      }
      logMessages(f, $, ...v) {
        const y = `${v.join(`
`)}`;
        switch (f) {
          case o.fatal:
          case o.error:
            console.error(y);
            break;
          case o.warn:
            console.warn(y);
            break;
          case o.info:
          case o.trace:
            console.info(y);
            break;
          case o.debug:
            console.debug(y);
            break;
          default:
            console.log(y);
        }
      }
    }
    e.BareConsoleLogger = i;
    class s extends d {
      constructor(f, $) {
        super(typeof f == "string" ? void 0 : f), typeof f == "string" ? this.setContext(f) : (this.config = f, this.ctx = $);
      }
      clone() {
        return new s(this.config, this.ctx);
      }
      logMessages(f, $, ...v) {
        var y, S, w, _;
        const I = !((y = this.ctx) === null || y === void 0) && y.getId() ? ` <${this.ctx.getId()}>` : "", N = `${$.timestamp} ${(0, n.lpad)(f.toUpperCase(), 5)}: [${(0, n.rpad)($.context, (_ = (w = (S = this.config) === null || S === void 0 ? void 0 : S.format) === null || w === void 0 ? void 0 : w.contextPadding) !== null && _ !== void 0 ? _ : 0)}]${I} ${v.join(`
`)}`;
        switch (f) {
          case o.fatal:
          case o.error:
            console.error(N);
            break;
          case o.warn:
            console.warn(N);
            break;
          case o.info:
          case o.trace:
            console.info(N);
            break;
          case o.debug:
            console.debug(N);
            break;
          default:
            console.log(N);
        }
      }
    }
    e.SimpleConsoleLogger = s;
    class u extends s {
      clone() {
        return new u(this.config, this.ctx);
      }
      isEnabled(f) {
        return !1;
      }
    }
    e.NoopLogger = u, e.noopLogger = new u();
    function c(m) {
      return `${m.getUTCFullYear()}-${(0, n.lpad)(m.getUTCMonth() + 1, 2, "0")}-${(0, n.lpad)(m.getUTCDate(), 2, "0")} ${(0, n.lpad)(m.getUTCHours(), 2, "0")}:${(0, n.lpad)(m.getUTCMinutes(), 2, "0")}:${(0, n.lpad)(m.getUTCSeconds(), 2, "0")}.${(0, n.lpad)(m.getUTCMilliseconds(), 3, "0")}`;
    }
    function l(m, f) {
      return m = (0, t.inTimezone)(m, f), `${m.getFullYear()}-${(0, n.lpad)(m.getMonth() + 1, 2, "0")}-${(0, n.lpad)(m.getDate(), 2, "0")} ${(0, n.lpad)(m.getHours(), 2, "0")}:${(0, n.lpad)(m.getMinutes(), 2, "0")}:${(0, n.lpad)(m.getSeconds(), 2, "0")}.${(0, n.lpad)(m.getMilliseconds(), 3, "0")}`;
    }
    function p(m, f) {
      var $;
      return m instanceof Error ? ($ = m.stack) !== null && $ !== void 0 ? $ : m.message : m === null ? "NULL" : m === void 0 ? "UNDEFINED" : (0, r.isPrimitiveValue)(m) ? m : f === "text" ? m.toString() : f === "compact-json" ? (0, n.json)(m, !1) : (0, n.json)(m);
    }
    function h(m, f, $) {
      if (Array.isArray(m)) {
        const v = m.map((y) => p(y, "compact-json"));
        return f ? v.join(`
`) : (0, n.json)(v);
      }
      return m instanceof Map ? (0, n.json)(Object.fromEntries([...m])) : m instanceof Set ? (0, n.json)([...m]) : p(m, $);
    }
  }(Vf)), Vf;
}
var Re = {}, Wf;
function vP() {
  if (Wf) return Re;
  Wf = 1, Object.defineProperty(Re, "__esModule", { value: !0 }), Re.or = t, Re.and = r, Re.sum = n, Re.count = o, Re.avg = a, Re.unique = d, Re.array2Map = i, Re.array2ArrayMap = s, Re.zip = u, Re.last = c, Re.first = l, Re.range = p, Re.charRange = h, Re.splitArray = m, Re.chunkArray = f, Re.rotateLeft = $, Re.rotateRight = v, Re.diff = y, Re.intersect = S, Re.union = w, Re.hasAny = _, Re.hasAll = I, Re.hasNone = N;
  const e = Ro();
  function t(O, E = (C) => !!C) {
    return O.reduce((C, P) => C || E(P), !1);
  }
  function r(O, E = (C) => !!C) {
    return O.reduce((C, P) => C && E(P), !0);
  }
  function n(O, E = (C) => C) {
    return O.reduce((C, P) => C + E(P), 0);
  }
  function o(O, E = (C) => C ? 1 : 0) {
    return O.reduce((C, P) => C + E(P), 0);
  }
  function a(O, E = (C) => C) {
    return O.length ? n(O, E) / O.length : 0;
  }
  function d(O, E, C) {
    if (!(O != null && O.length))
      return [];
    E || (E = (j) => (0, e.json)(j, !1));
    const P = {}, T = [];
    for (const j of O) {
      const F = E(j), Z = P[F];
      Z === void 0 ? (P[F] = T.length, T.push(j)) : C && (T[Z] = j);
    }
    return T;
  }
  function i(O, E = (C) => (0, e.json)(C, !1)) {
    if (!(O != null && O.length))
      return {};
    const C = {};
    for (const P of O) {
      const T = E(P);
      C[T] = P;
    }
    return C;
  }
  function s(O, E = (C) => (0, e.json)(C, !1)) {
    var C;
    if (!(O != null && O.length))
      return {};
    const P = {};
    for (const T of O) {
      const j = E(T);
      ((C = P[j]) !== null && C !== void 0 ? C : P[j] = []).push(T);
    }
    return P;
  }
  function u(...O) {
    return Array(Math.max(...O.map((E) => E.length))).fill(0).map((E, C) => O.map((P) => P[C]));
  }
  function c(O) {
    return O[O.length - 1];
  }
  function l(O) {
    return O[0];
  }
  function p(O, E = 0) {
    return [...Array(O).keys()].map((C) => C + E);
  }
  function h(O, E) {
    return p(E.charCodeAt(0) - O.charCodeAt(0) + 1, O.charCodeAt(0)).map((C) => String.fromCharCode(C));
  }
  function m(O, E) {
    const C = E >= 0 ? E : O.length + E;
    return [O.slice(0, C), O.slice(C)];
  }
  function f(O, E) {
    if (E <= 0)
      throw new Error("Chunk size must be greater than 0");
    const C = [];
    for (let P = 0; P < O.length; P += E)
      C.push(O.slice(P, P + E));
    return C;
  }
  function $(O) {
    const [E, C] = m(O, 1);
    return [...C, ...E];
  }
  function v(O) {
    const [E, C] = m(O, -1);
    return [...C, ...E];
  }
  function y(O, E, C = (P, T) => P === T) {
    const P = [];
    for (const T of O)
      E.some((j) => C(T, j)) || P.push(T);
    return P;
  }
  function S(O, E, C = (P, T) => P === T) {
    const P = [];
    for (const T of O)
      E.some((j) => C(T, j)) && P.push(T);
    return P;
  }
  function w(O, E, C = (P, T) => P === T) {
    const P = [...O];
    for (const T of E)
      P.some((j) => C(T, j)) || P.push(T);
    return P;
  }
  function _(O, E) {
    return O.some((C) => E.includes(C));
  }
  function I(O, E) {
    return O.every((C) => E.includes(C));
  }
  function N(O, E) {
    return !_(O, E);
  }
  return Re;
}
var Mt = {}, zf;
function mP() {
  if (zf) return Mt;
  zf = 1, Object.defineProperty(Mt, "__esModule", { value: !0 }), Mt.FixedBackoff = Mt.ExponentialBackoff = Mt.FibonacciBackoff = Mt.LinearBackoff = Mt.Backoff = void 0;
  class e {
    constructor(d) {
      var i, s;
      this.min = 10, this.max = 1e4, this.jitter = 0, this.cur = 0, this.min = (i = d == null ? void 0 : d.min) !== null && i !== void 0 ? i : 100, this.max = (s = d == null ? void 0 : d.max) !== null && s !== void 0 ? s : 1e4, this.jitter = (d == null ? void 0 : d.jitter) !== void 0 && d.jitter >= 0 && d.jitter <= 1 ? d.jitter : 0, this.reset();
    }
    next() {
      if (this.jitter) {
        const i = this.spread() * this.jitter;
        this.cur += Math.random() * i - i / 2;
      }
      this.cur = Math.max(0, Math.min(this.max, Math.floor(this.cur)));
      const d = this.cur;
      return this.step(), d;
    }
  }
  Mt.Backoff = e;
  class t extends e {
    constructor(d) {
      var i;
      super(d), this._step = 50, this._step = (i = d == null ? void 0 : d.step) !== null && i !== void 0 ? i : 50;
    }
    reset() {
      this.cur = this.min;
    }
    spread() {
      return this._step;
    }
    step() {
      this.cur = this.cur + this._step;
    }
  }
  Mt.LinearBackoff = t;
  class r extends e {
    constructor() {
      super(...arguments), this.last = 0;
    }
    reset() {
      this.cur = this.min, this.last = 0;
    }
    spread() {
      return this.cur === this.last ? this.cur : this.cur - this.last;
    }
    step() {
      let d = this.last + this.cur;
      d === 0 && (d = 1), this.last = this.cur, this.cur = d;
    }
  }
  Mt.FibonacciBackoff = r;
  class n extends e {
    constructor(d) {
      var i;
      super(d), this.factor = 2, this.factor = (i = d == null ? void 0 : d.factor) !== null && i !== void 0 ? i : 2;
    }
    reset() {
      this.cur = this.min;
    }
    spread() {
      return this.cur - this.cur / this.factor;
    }
    step() {
      this.cur === 0 ? this.cur = 1 : this.cur *= this.factor;
    }
  }
  Mt.ExponentialBackoff = n;
  class o extends e {
    constructor(d) {
      super(), this.sequence = d.sequence, this.idx = 0, this.lastIdx = this.sequence.length - 1, this.reset();
    }
    reset() {
      var d;
      this.idx = 0, this.cur = (d = this.sequence) === null || d === void 0 ? void 0 : d[this.idx];
    }
    spread() {
      return this.idx === 0 ? this.sequence[this.idx] : Math.abs(this.sequence[this.idx] - this.sequence[this.idx - 1]);
    }
    step() {
      this.idx = Math.min(this.idx + 1, this.lastIdx), this.cur = this.sequence[this.idx];
    }
  }
  return Mt.FixedBackoff = o, Mt;
}
var Qa = {}, Yf;
function hP() {
  if (Yf) return Qa;
  Yf = 1, Object.defineProperty(Qa, "__esModule", { value: !0 }), Qa.cached = e;
  async function e(t, r, n) {
    let o = t.get(r);
    return o === void 0 && (o = await n(), t.set(r, o)), o;
  }
  return Qa;
}
var Jt = {}, Yr = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      this.groups = [], this.each = !1, this.context = void 0, this.type = t.type, this.name = t.name, this.target = t.target, this.propertyName = t.propertyName, this.constraints = t == null ? void 0 : t.constraints, this.constraintCls = t.constraintCls, this.validationTypeOptions = t.validationTypeOptions, t.validationOptions && (this.message = t.validationOptions.message, this.groups = t.validationOptions.groups, this.always = t.validationOptions.always, this.each = t.validationOptions.each, this.context = t.validationOptions.context);
    }
    return e;
  }()
), gP = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.transform = function(t) {
      var r = [];
      return Object.keys(t.properties).forEach(function(n) {
        t.properties[n].forEach(function(o) {
          var a = {
            message: o.message,
            groups: o.groups,
            always: o.always,
            each: o.each
          }, d = {
            type: o.type,
            name: o.name,
            target: t.name,
            propertyName: n,
            constraints: o.constraints,
            validationTypeOptions: o.options,
            validationOptions: a
          };
          r.push(new Yr(d));
        });
      }), r;
    }, e;
  }()
);
function yP(e) {
  return e instanceof Map ? Array.from(e.values()) : Array.isArray(e) ? e : Array.from(e);
}
function bP() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof global < "u")
    return global;
  if (typeof window < "u")
    return window;
  if (typeof self < "u")
    return self;
}
function Ns(e) {
  return e !== null && typeof e == "object" && typeof e.then == "function";
}
var xP = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Xf = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), o, a = [], d;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = n.next()).done; ) a.push(o.value);
  } catch (i) {
    d = { error: i };
  } finally {
    try {
      o && !o.done && (r = n.return) && r.call(n);
    } finally {
      if (d) throw d.error;
    }
  }
  return a;
}, wP = function(e, t, r) {
  if (arguments.length === 2) for (var n = 0, o = t.length, a; n < o; n++)
    (a || !(n in t)) && (a || (a = Array.prototype.slice.call(t, 0, n)), a[n] = t[n]);
  return e.concat(a || Array.prototype.slice.call(t));
}, k1 = (
  /** @class */
  function() {
    function e() {
      this.validationMetadatas = /* @__PURE__ */ new Map(), this.constraintMetadatas = /* @__PURE__ */ new Map();
    }
    return Object.defineProperty(e.prototype, "hasValidationMetaData", {
      get: function() {
        return !!this.validationMetadatas.size;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.addValidationSchema = function(t) {
      var r = this, n = new gP().transform(t);
      n.forEach(function(o) {
        return r.addValidationMetadata(o);
      });
    }, e.prototype.addValidationMetadata = function(t) {
      var r = this.validationMetadatas.get(t.target);
      r ? r.push(t) : this.validationMetadatas.set(t.target, [t]);
    }, e.prototype.addConstraintMetadata = function(t) {
      var r = this.constraintMetadatas.get(t.target);
      r ? r.push(t) : this.constraintMetadatas.set(t.target, [t]);
    }, e.prototype.groupByPropertyName = function(t) {
      var r = {};
      return t.forEach(function(n) {
        r[n.propertyName] || (r[n.propertyName] = []), r[n.propertyName].push(n);
      }), r;
    }, e.prototype.getTargetValidationMetadatas = function(t, r, n, o, a) {
      var d, i, s = function(w) {
        return typeof w.always < "u" ? w.always : w.groups && w.groups.length ? !1 : n;
      }, u = function(w) {
        return !!(o && (!a || !a.length) && w.groups && w.groups.length);
      }, c = this.validationMetadatas.get(t) || [], l = c.filter(function(w) {
        return w.target !== t && w.target !== r ? !1 : s(w) ? !0 : u(w) ? !1 : a && a.length > 0 ? w.groups && !!w.groups.find(function(_) {
          return a.indexOf(_) !== -1;
        }) : !0;
      }), p = [];
      try {
        for (var h = xP(this.validationMetadatas.entries()), m = h.next(); !m.done; m = h.next()) {
          var f = Xf(m.value, 2), $ = f[0], v = f[1];
          t.prototype instanceof $ && p.push.apply(p, wP([], Xf(v), !1));
        }
      } catch (w) {
        d = { error: w };
      } finally {
        try {
          m && !m.done && (i = h.return) && i.call(h);
        } finally {
          if (d) throw d.error;
        }
      }
      var y = p.filter(function(w) {
        return typeof w.target == "string" || w.target === t || w.target instanceof Function && !(t.prototype instanceof w.target) ? !1 : s(w) ? !0 : u(w) ? !1 : a && a.length > 0 ? w.groups && !!w.groups.find(function(_) {
          return a.indexOf(_) !== -1;
        }) : !0;
      }), S = y.filter(function(w) {
        return !l.find(function(_) {
          return _.propertyName === w.propertyName && _.type === w.type;
        });
      });
      return l.concat(S);
    }, e.prototype.getTargetValidatorConstraints = function(t) {
      return this.constraintMetadatas.get(t) || [];
    }, e;
  }()
);
function Ft() {
  var e = bP();
  return e.classValidatorMetadataStorage || (e.classValidatorMetadataStorage = new k1()), e.classValidatorMetadataStorage;
}
var Fc = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.toString = function(t, r, n, o) {
      var a = this;
      t === void 0 && (t = !1), r === void 0 && (r = !1), n === void 0 && (n = ""), o === void 0 && (o = !1);
      var d = t ? "\x1B[1m" : "", i = t ? "\x1B[22m" : "", s = function() {
        var l;
        return (o ? Object.values : Object.keys)((l = a.constraints) !== null && l !== void 0 ? l : {}).join(", ");
      }, u = function(l) {
        return " - property ".concat(d).concat(n).concat(l).concat(i, " has failed the following constraints: ").concat(d).concat(s()).concat(i, ` 
`);
      };
      if (r) {
        var c = Number.isInteger(+this.property) ? "[".concat(this.property, "]") : "".concat(n ? "." : "").concat(this.property);
        return this.constraints ? u(c) : this.children ? this.children.map(function(l) {
          return l.toString(t, !0, "".concat(n).concat(c), o);
        }).join("") : "";
      } else
        return "An instance of ".concat(d).concat(this.target ? this.target.constructor.name : "an object").concat(i, ` has failed the validation:
`) + (this.constraints ? u(this.property) : "") + (this.children ? this.children.map(function(l) {
          return l.toString(t, !0, a.property, o);
        }).join("") : "");
    }, e;
  }()
), Xe = (
  /** @class */
  function() {
    function e() {
    }
    return e.isValid = function(t) {
      var r = this;
      return t !== "isValid" && t !== "getMessage" && Object.keys(this).map(function(n) {
        return r[n];
      }).indexOf(t) !== -1;
    }, e.CUSTOM_VALIDATION = "customValidation", e.NESTED_VALIDATION = "nestedValidation", e.PROMISE_VALIDATION = "promiseValidation", e.CONDITIONAL_VALIDATION = "conditionalValidation", e.WHITELIST = "whitelistValidation", e.IS_DEFINED = "isDefined", e;
  }()
);
function AP(e) {
  return Array.isArray(e) ? e.join(", ") : (typeof e == "symbol" && (e = e.description), "".concat(e));
}
var SP = (
  /** @class */
  function() {
    function e() {
    }
    return e.replaceMessageSpecialTokens = function(t, r) {
      var n;
      return t instanceof Function ? n = t(r) : typeof t == "string" && (n = t), n && Array.isArray(r.constraints) && r.constraints.forEach(function(o, a) {
        n = n.replace(new RegExp("\\$constraint".concat(a + 1), "g"), AP(o));
      }), n && r.value !== void 0 && r.value !== null && ["string", "boolean", "number"].includes(typeof r.value) && (n = n.replace(/\$value/g, r.value)), n && (n = n.replace(/\$property/g, r.property)), n && (n = n.replace(/\$target/g, r.targetName)), n;
    }, e;
  }()
), Jo = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), o, a = [], d;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = n.next()).done; ) a.push(o.value);
  } catch (i) {
    d = { error: i };
  } finally {
    try {
      o && !o.done && (r = n.return) && r.call(n);
    } finally {
      if (d) throw d.error;
    }
  }
  return a;
}, qf = (
  /** @class */
  function() {
    function e(t, r) {
      this.validator = t, this.validatorOptions = r, this.awaitingPromises = [], this.ignoreAsyncValidations = !1, this.metadataStorage = Ft();
    }
    return e.prototype.execute = function(t, r, n) {
      var o = this, a, d;
      !this.metadataStorage.hasValidationMetaData && ((a = this.validatorOptions) === null || a === void 0 ? void 0 : a.enableDebugMessages) === !0 && console.warn(`No validation metadata found. No validation will be  performed. There are multiple possible reasons:
  - There may be multiple class-validator versions installed. You will need to flatten your dependencies to fix the issue.
  - This validation runs before any file with validation decorator was parsed by NodeJS.`);
      var i = this.validatorOptions ? this.validatorOptions.groups : void 0, s = this.validatorOptions && this.validatorOptions.strictGroups || !1, u = this.validatorOptions && this.validatorOptions.always || !1, c = ((d = this.validatorOptions) === null || d === void 0 ? void 0 : d.forbidUnknownValues) === void 0 || this.validatorOptions.forbidUnknownValues !== !1, l = this.metadataStorage.getTargetValidationMetadatas(t.constructor, r, u, s, i), p = this.metadataStorage.groupByPropertyName(l);
      if (c && !l.length) {
        var h = new Fc();
        (!this.validatorOptions || !this.validatorOptions.validationError || this.validatorOptions.validationError.target === void 0 || this.validatorOptions.validationError.target === !0) && (h.target = t), h.value = void 0, h.property = void 0, h.children = [], h.constraints = { unknownValue: "an unknown value was passed to the validate function" }, n.push(h);
        return;
      }
      this.validatorOptions && this.validatorOptions.whitelist && this.whitelist(t, p, n), Object.keys(p).forEach(function(m) {
        var f = t[m], $ = p[m].filter(function(y) {
          return y.type === Xe.IS_DEFINED;
        }), v = p[m].filter(function(y) {
          return y.type !== Xe.IS_DEFINED && y.type !== Xe.WHITELIST;
        });
        f instanceof Promise && v.find(function(y) {
          return y.type === Xe.PROMISE_VALIDATION;
        }) ? o.awaitingPromises.push(f.then(function(y) {
          o.performValidations(t, y, m, $, v, n);
        })) : o.performValidations(t, f, m, $, v, n);
      });
    }, e.prototype.whitelist = function(t, r, n) {
      var o = this, a = [];
      Object.keys(t).forEach(function(d) {
        (!r[d] || r[d].length === 0) && a.push(d);
      }), a.length > 0 && (this.validatorOptions && this.validatorOptions.forbidNonWhitelisted ? a.forEach(function(d) {
        var i, s = o.generateValidationError(t, t[d], d);
        s.constraints = (i = {}, i[Xe.WHITELIST] = "property ".concat(d, " should not exist"), i), s.children = void 0, n.push(s);
      }) : a.forEach(function(d) {
        return delete t[d];
      }));
    }, e.prototype.stripEmptyErrors = function(t) {
      var r = this;
      return t.filter(function(n) {
        if (n.children && (n.children = r.stripEmptyErrors(n.children)), Object.keys(n.constraints).length === 0) {
          if (n.children.length === 0)
            return !1;
          delete n.constraints;
        }
        return !0;
      });
    }, e.prototype.performValidations = function(t, r, n, o, a, d) {
      var i = a.filter(function(p) {
        return p.type === Xe.CUSTOM_VALIDATION;
      }), s = a.filter(function(p) {
        return p.type === Xe.NESTED_VALIDATION;
      }), u = a.filter(function(p) {
        return p.type === Xe.CONDITIONAL_VALIDATION;
      }), c = this.generateValidationError(t, r, n);
      d.push(c);
      var l = this.conditionalValidations(t, r, u);
      l && (this.customValidations(t, r, o, c), this.mapContexts(t, r, o, c), !(r === void 0 && this.validatorOptions && this.validatorOptions.skipUndefinedProperties === !0) && (r === null && this.validatorOptions && this.validatorOptions.skipNullProperties === !0 || r == null && this.validatorOptions && this.validatorOptions.skipMissingProperties === !0 || (this.customValidations(t, r, i, c), this.nestedValidations(r, s, c), this.mapContexts(t, r, a, c), this.mapContexts(t, r, i, c))));
    }, e.prototype.generateValidationError = function(t, r, n) {
      var o = new Fc();
      return (!this.validatorOptions || !this.validatorOptions.validationError || this.validatorOptions.validationError.target === void 0 || this.validatorOptions.validationError.target === !0) && (o.target = t), (!this.validatorOptions || !this.validatorOptions.validationError || this.validatorOptions.validationError.value === void 0 || this.validatorOptions.validationError.value === !0) && (o.value = r), o.property = n, o.children = [], o.constraints = {}, o;
    }, e.prototype.conditionalValidations = function(t, r, n) {
      return n.map(function(o) {
        return o.constraints[0](t, r);
      }).reduce(function(o, a) {
        return o && a;
      }, !0);
    }, e.prototype.customValidations = function(t, r, n, o) {
      var a = this;
      n.forEach(function(d) {
        a.metadataStorage.getTargetValidatorConstraints(d.constraintCls).forEach(function(i) {
          if (!(i.async && a.ignoreAsyncValidations) && !(a.validatorOptions && a.validatorOptions.stopAtFirstError && Object.keys(o.constraints || {}).length > 0)) {
            var s = {
              targetName: t.constructor ? t.constructor.name : void 0,
              property: d.propertyName,
              object: t,
              value: r,
              constraints: d.constraints
            };
            if (!d.each || !(Array.isArray(r) || r instanceof Set || r instanceof Map)) {
              var u = i.instance.validate(r, s);
              if (Ns(u)) {
                var c = u.then(function(_) {
                  if (!_) {
                    var I = Jo(a.createValidationError(t, r, d, i), 2), N = I[0], O = I[1];
                    o.constraints[N] = O, d.context && (o.contexts || (o.contexts = {}), o.contexts[N] = Object.assign(o.contexts[N] || {}, d.context));
                  }
                });
                a.awaitingPromises.push(c);
              } else if (!u) {
                var l = Jo(a.createValidationError(t, r, d, i), 2), p = l[0], h = l[1];
                o.constraints[p] = h;
              }
              return;
            }
            var m = yP(r), f = m.map(function(_) {
              return i.instance.validate(_, s);
            }), $ = f.some(function(_) {
              return Ns(_);
            });
            if ($) {
              var v = f.map(function(_) {
                return Ns(_) ? _ : Promise.resolve(_);
              }), y = Promise.all(v).then(function(_) {
                var I = _.every(function(C) {
                  return C;
                });
                if (!I) {
                  var N = Jo(a.createValidationError(t, r, d, i), 2), O = N[0], E = N[1];
                  o.constraints[O] = E, d.context && (o.contexts || (o.contexts = {}), o.contexts[O] = Object.assign(o.contexts[O] || {}, d.context));
                }
              });
              a.awaitingPromises.push(y);
              return;
            }
            var S = f.every(function(_) {
              return _;
            });
            if (!S) {
              var w = Jo(a.createValidationError(t, r, d, i), 2), p = w[0], h = w[1];
              o.constraints[p] = h;
            }
          }
        });
      });
    }, e.prototype.nestedValidations = function(t, r, n) {
      var o = this;
      t !== void 0 && r.forEach(function(a) {
        if (!(a.type !== Xe.NESTED_VALIDATION && a.type !== Xe.PROMISE_VALIDATION) && !(o.validatorOptions && o.validatorOptions.stopAtFirstError && Object.keys(n.constraints || {}).length > 0))
          if (Array.isArray(t) || t instanceof Set || t instanceof Map) {
            var d = t instanceof Set ? Array.from(t) : t;
            d.forEach(function(l, p) {
              o.performValidations(t, l, p.toString(), [], r, n.children);
            });
          } else if (t instanceof Object) {
            var i = typeof a.target == "string" ? a.target : a.target.name;
            o.execute(t, i, n.children);
          } else {
            var s = Jo(o.createValidationError(a.target, t, a), 2), u = s[0], c = s[1];
            n.constraints[u] = c;
          }
      });
    }, e.prototype.mapContexts = function(t, r, n, o) {
      var a = this;
      return n.forEach(function(d) {
        if (d.context) {
          var i = void 0;
          if (d.type === Xe.CUSTOM_VALIDATION) {
            var s = a.metadataStorage.getTargetValidatorConstraints(d.constraintCls);
            i = s[0];
          }
          var u = a.getConstraintType(d, i);
          o.constraints[u] && (o.contexts || (o.contexts = {}), o.contexts[u] = Object.assign(o.contexts[u] || {}, d.context));
        }
      });
    }, e.prototype.createValidationError = function(t, r, n, o) {
      var a = t.constructor ? t.constructor.name : void 0, d = this.getConstraintType(n, o), i = {
        targetName: a,
        property: n.propertyName,
        object: t,
        value: r,
        constraints: n.constraints
      }, s = n.message || "";
      !n.message && (!this.validatorOptions || this.validatorOptions && !this.validatorOptions.dismissDefaultMessages) && o && o.instance.defaultMessage instanceof Function && (s = o.instance.defaultMessage(i));
      var u = SP.replaceMessageSpecialTokens(s, i);
      return [d, u];
    }, e.prototype.getConstraintType = function(t, r) {
      var n = r && r.name ? r.name : t.type;
      return n;
    }, e;
  }()
), _P = function(e, t, r, n) {
  function o(a) {
    return a instanceof r ? a : new r(function(d) {
      d(a);
    });
  }
  return new (r || (r = Promise))(function(a, d) {
    function i(c) {
      try {
        u(n.next(c));
      } catch (l) {
        d(l);
      }
    }
    function s(c) {
      try {
        u(n.throw(c));
      } catch (l) {
        d(l);
      }
    }
    function u(c) {
      c.done ? a(c.value) : o(c.value).then(i, s);
    }
    u((n = n.apply(e, [])).next());
  });
}, EP = function(e, t) {
  var r = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, n, o, a, d;
  return d = { next: i(0), throw: i(1), return: i(2) }, typeof Symbol == "function" && (d[Symbol.iterator] = function() {
    return this;
  }), d;
  function i(u) {
    return function(c) {
      return s([u, c]);
    };
  }
  function s(u) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; d && (d = 0, u[0] && (r = 0)), r; ) try {
      if (n = 1, o && (a = u[0] & 2 ? o.return : u[0] ? o.throw || ((a = o.return) && a.call(o), 0) : o.next) && !(a = a.call(o, u[1])).done) return a;
      switch (o = 0, a && (u = [u[0] & 2, a.value]), u[0]) {
        case 0:
        case 1:
          a = u;
          break;
        case 4:
          return r.label++, { value: u[1], done: !1 };
        case 5:
          r.label++, o = u[1], u = [0];
          continue;
        case 7:
          u = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (a = r.trys, !(a = a.length > 0 && a[a.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            r = 0;
            continue;
          }
          if (u[0] === 3 && (!a || u[1] > a[0] && u[1] < a[3])) {
            r.label = u[1];
            break;
          }
          if (u[0] === 6 && r.label < a[1]) {
            r.label = a[1], a = u;
            break;
          }
          if (a && r.label < a[2]) {
            r.label = a[2], r.ops.push(u);
            break;
          }
          a[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      u = t.call(e, r);
    } catch (c) {
      u = [6, c], o = 0;
    } finally {
      n = a = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, fn = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.validate = function(t, r, n) {
      return this.coreValidate(t, r, n);
    }, e.prototype.validateOrReject = function(t, r, n) {
      return _P(this, void 0, void 0, function() {
        var o;
        return EP(this, function(a) {
          switch (a.label) {
            case 0:
              return [4, this.coreValidate(t, r, n)];
            case 1:
              return o = a.sent(), o.length ? [2, Promise.reject(o)] : [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.validateSync = function(t, r, n) {
      var o = typeof t == "string" ? r : t, a = typeof t == "string" ? n : r, d = typeof t == "string" ? t : void 0, i = new qf(this, a);
      i.ignoreAsyncValidations = !0;
      var s = [];
      return i.execute(o, d, s), i.stripEmptyErrors(s);
    }, e.prototype.coreValidate = function(t, r, n) {
      var o = typeof t == "string" ? r : t, a = typeof t == "string" ? n : r, d = typeof t == "string" ? t : void 0, i = new qf(this, a), s = [];
      return i.execute(o, d, s), Promise.all(i.awaitingPromises).then(function() {
        return i.stripEmptyErrors(s);
      });
    }, e;
  }()
), MP = new /** @class */
(function() {
  function e() {
    this.instances = [];
  }
  return e.prototype.get = function(t) {
    var r = this.instances.find(function(n) {
      return n.type === t;
    });
    return r || (r = { type: t, object: new t() }, this.instances.push(r)), r.object;
  }, e;
}())(), kc, aa;
function CP(e, t) {
  kc = e, aa = t;
}
function Sr(e) {
  if (kc)
    try {
      var t = kc.get(e);
      if (t || !aa || !aa.fallback)
        return t;
    } catch (r) {
      if (!aa || !aa.fallbackOnErrors)
        throw r;
    }
  return MP.get(e);
}
function OP(e) {
  return function(t, r) {
    var n = {
      type: Xe.WHITELIST,
      target: t.constructor,
      propertyName: r,
      validationOptions: e
    };
    Ft().addValidationMetadata(new Yr(n));
  };
}
var Cp = (
  /** @class */
  function() {
    function e(t, r, n) {
      n === void 0 && (n = !1), this.target = t, this.name = r, this.async = n;
    }
    return Object.defineProperty(e.prototype, "instance", {
      // -------------------------------------------------------------------------
      // Accessors
      // -------------------------------------------------------------------------
      /**
       * Instance of the target custom validation class which performs validation.
       */
      get: function() {
        return Sr(this.target);
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }()
);
function Op(e) {
  var t;
  if (e.validator instanceof Function) {
    t = e.validator;
    var r = Sr(k1).getTargetValidatorConstraints(e.validator);
    if (r.length > 1)
      throw "More than one implementation of ValidatorConstraintInterface found for validator on: ".concat(e.target.name, ":").concat(e.propertyName);
  } else {
    var n = e.validator;
    t = /** @class */
    function() {
      function a() {
      }
      return a.prototype.validate = function(d, i) {
        return n.validate(d, i);
      }, a.prototype.defaultMessage = function(d) {
        return n.defaultMessage ? n.defaultMessage(d) : "";
      }, a;
    }(), Ft().addConstraintMetadata(new Cp(t, e.name, e.async));
  }
  var o = {
    type: e.name && Xe.isValid(e.name) ? e.name : Xe.CUSTOM_VALIDATION,
    name: e.name,
    target: e.target,
    propertyName: e.propertyName,
    validationOptions: e.options,
    constraintCls: t,
    constraints: e.constraints
  };
  Ft().addValidationMetadata(new Yr(o));
}
function K(e, t) {
  return function(r) {
    var n = t && t.each ? "each value in " : "";
    return e(n, r);
  };
}
function W(e, t) {
  return function(r, n) {
    Op({
      name: e.name,
      target: r.constructor,
      propertyName: n,
      options: t,
      constraints: e.constraints,
      validator: e.validator
    });
  };
}
var Np = Xe.IS_DEFINED;
function Ip(e) {
  return e != null;
}
function NP(e) {
  return W({
    name: Np,
    validator: {
      validate: function(t) {
        return Ip(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property should not be null or undefined";
      }, e)
    }
  }, e);
}
var Pp = "isOptional";
function IP(e) {
  return function(t, r) {
    var n = {
      type: Xe.CONDITIONAL_VALIDATION,
      name: Pp,
      target: t.constructor,
      propertyName: r,
      constraints: [
        function(o, a) {
          return o[r] !== null && o[r] !== void 0;
        }
      ],
      validationOptions: e
    };
    Ft().addValidationMetadata(new Yr(n));
  };
}
function PP(e) {
  return function(t) {
    var r = e && e.async, n = e && e.name ? e.name : "";
    n || (n = t.name, n || (n = n.replace(/\.?([A-Z]+)/g, function(a, d) {
      return "_" + d.toLowerCase();
    }).replace(/^_/, "")));
    var o = new Cp(t, n, r);
    Ft().addConstraintMetadata(o);
  };
}
function RP(e, t, r) {
  return function(n, o) {
    var a = {
      type: Xe.CUSTOM_VALIDATION,
      target: n.constructor,
      propertyName: o,
      constraintCls: e,
      constraints: Array.isArray(t) ? t : void 0,
      validationOptions: Array.isArray(t) ? r : t
    };
    Ft().addValidationMetadata(new Yr(a));
  };
}
function TP(e, t) {
  return function(r, n) {
    var o = {
      type: Xe.CONDITIONAL_VALIDATION,
      target: r.constructor,
      propertyName: n,
      constraints: [e],
      validationOptions: t
    };
    Ft().addValidationMetadata(new Yr(o));
  };
}
var jc = function() {
  return jc = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, jc.apply(this, arguments);
};
function DP(e) {
  var t = jc({}, e), r = t.each ? "each value in " : "";
  return t.message = t.message || r + "nested property $property must be either object or array", function(n, o) {
    var a = {
      type: Xe.NESTED_VALIDATION,
      target: n.constructor,
      propertyName: o,
      validationOptions: t
    };
    Ft().addValidationMetadata(new Yr(a));
  };
}
function LP(e) {
  return function(t, r) {
    var n = {
      type: Xe.PROMISE_VALIDATION,
      target: t.constructor,
      propertyName: r,
      validationOptions: e
    };
    Ft().addValidationMetadata(new Yr(n));
  };
}
var Is = { exports: {} }, Ps = { exports: {} }, Jf;
function J() {
  return Jf || (Jf = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = n;
    function r(o) {
      "@babel/helpers - typeof";
      return r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(a) {
        return typeof a;
      } : function(a) {
        return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
      }, r(o);
    }
    function n(o) {
      var a = typeof o == "string" || o instanceof String;
      if (!a) {
        var d = r(o);
        throw o === null ? d = "null" : d === "object" && (d = o.constructor.name), new TypeError("Expected a string but received a ".concat(d));
      }
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Ps, Ps.exports)), Ps.exports;
}
var Rs = { exports: {} }, Qf;
function $t() {
  return Qf || (Qf = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = r;
    function r() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = arguments.length > 1 ? arguments[1] : void 0;
      for (var a in o)
        typeof n[a] > "u" && (n[a] = o[a]);
      return n;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Rs, Rs.exports)), Rs.exports;
}
var e9;
function Rp() {
  return e9 || (e9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = c;
    var r = o(/* @__PURE__ */ J()), n = o(/* @__PURE__ */ $t());
    function o(l) {
      return l && l.__esModule ? l : { default: l };
    }
    var a = /^\(?[+-]?(90(\.0+)?|[1-8]?\d(\.\d+)?)$/, d = /^\s?[+-]?(180(\.0+)?|1[0-7]\d(\.\d+)?|\d{1,2}(\.\d+)?)\)?$/, i = /^(([1-8]?\d)\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|90\D+0\D+0)\D+[NSns]?$/i, s = /^\s*([1-7]?\d{1,2}\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|180\D+0\D+0)\D+[EWew]?$/i, u = {
      checkDMS: !1
    };
    function c(l, p) {
      if ((0, r.default)(l), p = (0, n.default)(p, u), !l.includes(",")) return !1;
      var h = l.split(",");
      return h[0].startsWith("(") && !h[1].endsWith(")") || h[1].endsWith(")") && !h[0].startsWith("(") ? !1 : p.checkDMS ? i.test(h[0]) && s.test(h[1]) : a.test(h[0]) && d.test(h[1]);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Is, Is.exports)), Is.exports;
}
var FP = /* @__PURE__ */ Rp();
const kP = /* @__PURE__ */ $e(FP);
var Tp = "isLatLong";
function ai(e) {
  return typeof e == "string" && kP(e);
}
function jP(e) {
  return W({
    name: Tp,
    validator: {
      validate: function(t, r) {
        return ai(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be a latitude,longitude string";
      }, e)
    }
  }, e);
}
var Dp = "isLatitude";
function Lp(e) {
  return (typeof e == "number" || typeof e == "string") && ai("".concat(e, ",0"));
}
function BP(e) {
  return W({
    name: Dp,
    validator: {
      validate: function(t, r) {
        return Lp(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be a latitude string or number";
      }, e)
    }
  }, e);
}
var Fp = "isLongitude";
function kp(e) {
  return (typeof e == "number" || typeof e == "string") && ai("0,".concat(e));
}
function ZP(e) {
  return W({
    name: Fp,
    validator: {
      validate: function(t, r) {
        return kp(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be a longitude string or number";
      }, e)
    }
  }, e);
}
var jp = "equals";
function Bp(e, t) {
  return e === t;
}
function UP(e, t) {
  return W({
    name: jp,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Bp(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must be equal to $constraint1";
      }, t)
    }
  }, t);
}
var Zp = "notEquals";
function Up(e, t) {
  return e !== t;
}
function GP(e, t) {
  return W({
    name: Zp,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Up(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property should not be equal to $constraint1";
      }, t)
    }
  }, t);
}
var Gp = "isEmpty";
function Vp(e) {
  return e === "" || e === null || e === void 0;
}
function VP(e) {
  return W({
    name: Gp,
    validator: {
      validate: function(t, r) {
        return Vp(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be empty";
      }, e)
    }
  }, e);
}
var Hp = "isNotEmpty";
function Kp(e) {
  return e !== "" && e !== null && e !== void 0;
}
function HP(e) {
  return W({
    name: Hp,
    validator: {
      validate: function(t, r) {
        return Kp(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property should not be empty";
      }, e)
    }
  }, e);
}
var Wp = "isIn";
function zp(e, t) {
  return Array.isArray(t) && t.some(function(r) {
    return r === e;
  });
}
function KP(e, t) {
  return W({
    name: Wp,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return zp(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must be one of the following values: $constraint1";
      }, t)
    }
  }, t);
}
var Yp = "isNotIn";
function Xp(e, t) {
  return !Array.isArray(t) || !t.some(function(r) {
    return r === e;
  });
}
function WP(e, t) {
  return W({
    name: Yp,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Xp(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property should not be one of the following values: $constraint1";
      }, t)
    }
  }, t);
}
var Ts = { exports: {} }, Ds = { exports: {} }, On = {}, Ls = { exports: {} }, t9;
function qp() {
  return t9 || (t9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = r;
    function r(n) {
      return n == null;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Ls, Ls.exports)), Ls.exports;
}
var ze = {}, r9;
function Oa() {
  if (r9) return ze;
  r9 = 1, Object.defineProperty(ze, "__esModule", {
    value: !0
  }), ze.farsiLocales = ze.englishLocales = ze.dotDecimal = ze.decimal = ze.commaDecimal = ze.bengaliLocales = ze.arabicLocales = ze.alphanumeric = ze.alpha = void 0;
  for (var e = ze.alpha = {
    "en-US": /^[A-Z]+$/i,
    "az-AZ": /^[A-VXYZÇƏĞİıÖŞÜ]+$/i,
    "bg-BG": /^[А-Я]+$/i,
    "cs-CZ": /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
    "da-DK": /^[A-ZÆØÅ]+$/i,
    "de-DE": /^[A-ZÄÖÜß]+$/i,
    "el-GR": /^[Α-ώ]+$/i,
    "es-ES": /^[A-ZÁÉÍÑÓÚÜ]+$/i,
    "fa-IR": /^[ابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی]+$/i,
    "fi-FI": /^[A-ZÅÄÖ]+$/i,
    "fr-FR": /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
    "it-IT": /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
    "ja-JP": /^[ぁ-んァ-ヶｦ-ﾟ一-龠ー・。、]+$/i,
    "nb-NO": /^[A-ZÆØÅ]+$/i,
    "nl-NL": /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
    "nn-NO": /^[A-ZÆØÅ]+$/i,
    "hu-HU": /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
    "pl-PL": /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
    "pt-PT": /^[A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
    "ru-RU": /^[А-ЯЁ]+$/i,
    "kk-KZ": /^[А-ЯЁ\u04D8\u04B0\u0406\u04A2\u0492\u04AE\u049A\u04E8\u04BA]+$/i,
    "sl-SI": /^[A-ZČĆĐŠŽ]+$/i,
    "sk-SK": /^[A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
    "sr-RS@latin": /^[A-ZČĆŽŠĐ]+$/i,
    "sr-RS": /^[А-ЯЂЈЉЊЋЏ]+$/i,
    "sv-SE": /^[A-ZÅÄÖ]+$/i,
    "th-TH": /^[ก-๐\s]+$/i,
    "tr-TR": /^[A-ZÇĞİıÖŞÜ]+$/i,
    "uk-UA": /^[А-ЩЬЮЯЄIЇҐі]+$/i,
    "vi-VN": /^[A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
    "ko-KR": /^[ㄱ-ㅎㅏ-ㅣ가-힣]*$/,
    "ku-IQ": /^[ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
    ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
    he: /^[א-ת]+$/,
    fa: /^['آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی']+$/i,
    bn: /^['ঀঁংঃঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহ়ঽািীুূৃৄেৈোৌ্ৎৗড়ঢ়য়ৠৡৢৣৰৱ৲৳৴৵৶৷৸৹৺৻']+$/,
    eo: /^[ABCĈD-GĜHĤIJĴK-PRSŜTUŬVZ]+$/i,
    "hi-IN": /^[\u0900-\u0961]+[\u0972-\u097F]*$/i,
    "si-LK": /^[\u0D80-\u0DFF]+$/
  }, t = ze.alphanumeric = {
    "en-US": /^[0-9A-Z]+$/i,
    "az-AZ": /^[0-9A-VXYZÇƏĞİıÖŞÜ]+$/i,
    "bg-BG": /^[0-9А-Я]+$/i,
    "cs-CZ": /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
    "da-DK": /^[0-9A-ZÆØÅ]+$/i,
    "de-DE": /^[0-9A-ZÄÖÜß]+$/i,
    "el-GR": /^[0-9Α-ω]+$/i,
    "es-ES": /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
    "fi-FI": /^[0-9A-ZÅÄÖ]+$/i,
    "fr-FR": /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
    "it-IT": /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
    "ja-JP": /^[0-9０-９ぁ-んァ-ヶｦ-ﾟ一-龠ー・。、]+$/i,
    "hu-HU": /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
    "nb-NO": /^[0-9A-ZÆØÅ]+$/i,
    "nl-NL": /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
    "nn-NO": /^[0-9A-ZÆØÅ]+$/i,
    "pl-PL": /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
    "pt-PT": /^[0-9A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
    "ru-RU": /^[0-9А-ЯЁ]+$/i,
    "kk-KZ": /^[0-9А-ЯЁ\u04D8\u04B0\u0406\u04A2\u0492\u04AE\u049A\u04E8\u04BA]+$/i,
    "sl-SI": /^[0-9A-ZČĆĐŠŽ]+$/i,
    "sk-SK": /^[0-9A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
    "sr-RS@latin": /^[0-9A-ZČĆŽŠĐ]+$/i,
    "sr-RS": /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
    "sv-SE": /^[0-9A-ZÅÄÖ]+$/i,
    "th-TH": /^[ก-๙\s]+$/i,
    "tr-TR": /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
    "uk-UA": /^[0-9А-ЩЬЮЯЄIЇҐі]+$/i,
    "ko-KR": /^[0-9ㄱ-ㅎㅏ-ㅣ가-힣]*$/,
    "ku-IQ": /^[٠١٢٣٤٥٦٧٨٩0-9ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
    "vi-VN": /^[0-9A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
    ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
    he: /^[0-9א-ת]+$/,
    fa: /^['0-9آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی۱۲۳۴۵۶۷۸۹۰']+$/i,
    bn: /^['ঀঁংঃঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহ়ঽািীুূৃৄেৈোৌ্ৎৗড়ঢ়য়ৠৡৢৣ০১২৩৪৫৬৭৮৯ৰৱ৲৳৴৵৶৷৸৹৺৻']+$/,
    eo: /^[0-9ABCĈD-GĜHĤIJĴK-PRSŜTUŬVZ]+$/i,
    "hi-IN": /^[\u0900-\u0963]+[\u0966-\u097F]*$/i,
    "si-LK": /^[0-9\u0D80-\u0DFF]+$/
  }, r = ze.decimal = {
    "en-US": ".",
    ar: "٫"
  }, n = ze.englishLocales = ["AU", "GB", "HK", "IN", "NZ", "ZA", "ZM"], o, a = 0; a < n.length; a++)
    o = "en-".concat(n[a]), e[o] = e["en-US"], t[o] = t["en-US"], r[o] = r["en-US"];
  for (var d = ze.arabicLocales = ["AE", "BH", "DZ", "EG", "IQ", "JO", "KW", "LB", "LY", "MA", "QM", "QA", "SA", "SD", "SY", "TN", "YE"], i, s = 0; s < d.length; s++)
    i = "ar-".concat(d[s]), e[i] = e.ar, t[i] = t.ar, r[i] = r.ar;
  for (var u = ze.farsiLocales = ["IR", "AF"], c, l = 0; l < u.length; l++)
    c = "fa-".concat(u[l]), t[c] = t.fa, r[c] = r.ar;
  for (var p = ze.bengaliLocales = ["BD", "IN"], h, m = 0; m < p.length; m++)
    h = "bn-".concat(p[m]), e[h] = e.bn, t[h] = t.bn, r[h] = r["en-US"];
  for (var f = ze.dotDecimal = ["ar-EG", "ar-LB", "ar-LY"], $ = ze.commaDecimal = ["bg-BG", "cs-CZ", "da-DK", "de-DE", "el-GR", "en-ZM", "eo", "es-ES", "fr-CA", "fr-FR", "id-ID", "it-IT", "ku-IQ", "hi-IN", "hu-HU", "nb-NO", "nn-NO", "nl-NL", "pl-PL", "pt-PT", "ru-RU", "kk-KZ", "si-LK", "sl-SI", "sr-RS@latin", "sr-RS", "sv-SE", "tr-TR", "uk-UA", "vi-VN"], v = 0; v < f.length; v++)
    r[f[v]] = r["en-US"];
  for (var y = 0; y < $.length; y++)
    r[$[y]] = ",";
  return e["fr-CA"] = e["fr-FR"], t["fr-CA"] = t["fr-FR"], e["pt-BR"] = e["pt-PT"], t["pt-BR"] = t["pt-PT"], r["pt-BR"] = r["pt-PT"], e["pl-Pl"] = e["pl-PL"], t["pl-Pl"] = t["pl-PL"], r["pl-Pl"] = r["pl-PL"], e["fa-AF"] = e.fa, ze;
}
var n9;
function Jp() {
  if (n9) return On;
  n9 = 1, Object.defineProperty(On, "__esModule", {
    value: !0
  }), On.default = o, On.locales = void 0;
  var e = n(/* @__PURE__ */ J()), t = n(/* @__PURE__ */ qp()), r = /* @__PURE__ */ Oa();
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function o(a, d) {
    (0, e.default)(a), d = d || {};
    var i = new RegExp("^(?:[-+])?(?:[0-9]+)?(?:\\".concat(d.locale ? r.decimal[d.locale] : ".", "[0-9]*)?(?:[eE][\\+\\-]?(?:[0-9]+))?$"));
    if (a === "" || a === "." || a === "," || a === "-" || a === "+")
      return !1;
    var s = parseFloat(a.replace(",", "."));
    return i.test(a) && (!d.hasOwnProperty("min") || (0, t.default)(d.min) || s >= d.min) && (!d.hasOwnProperty("max") || (0, t.default)(d.max) || s <= d.max) && (!d.hasOwnProperty("lt") || (0, t.default)(d.lt) || s < d.lt) && (!d.hasOwnProperty("gt") || (0, t.default)(d.gt) || s > d.gt);
  }
  return On.locales = Object.keys(r.decimal), On;
}
var o9;
function Qp() {
  return o9 || (o9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ Jp());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a) {
      return (0, r.default)(a) ? parseFloat(a) : NaN;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Ds, Ds.exports)), Ds.exports;
}
var a9;
function e$() {
  return a9 || (a9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = o(/* @__PURE__ */ J()), n = o(/* @__PURE__ */ Qp());
    function o(d) {
      return d && d.__esModule ? d : { default: d };
    }
    function a(d, i) {
      return (0, r.default)(d), (0, n.default)(d) % parseInt(i, 10) === 0;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Ts, Ts.exports)), Ts.exports;
}
var zP = /* @__PURE__ */ e$();
const YP = /* @__PURE__ */ $e(zP);
var t$ = "isDivisibleBy";
function r$(e, t) {
  return typeof e == "number" && typeof t == "number" && YP(String(e), t);
}
function XP(e, t) {
  return W({
    name: t$,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return r$(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must be divisible by $constraint1";
      }, t)
    }
  }, t);
}
var n$ = "isPositive";
function o$(e) {
  return typeof e == "number" && e > 0;
}
function qP(e) {
  return W({
    name: n$,
    validator: {
      validate: function(t, r) {
        return o$(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be a positive number";
      }, e)
    }
  }, e);
}
var a$ = "isNegative";
function d$(e) {
  return typeof e == "number" && e < 0;
}
function JP(e) {
  return W({
    name: a$,
    validator: {
      validate: function(t, r) {
        return d$(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be a negative number";
      }, e)
    }
  }, e);
}
var i$ = "max";
function s$(e, t) {
  return typeof e == "number" && typeof t == "number" && e <= t;
}
function QP(e, t) {
  return W({
    name: i$,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return s$(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must not be greater than $constraint1";
      }, t)
    }
  }, t);
}
var u$ = "min";
function l$(e, t) {
  return typeof e == "number" && typeof t == "number" && e >= t;
}
function eR(e, t) {
  return W({
    name: u$,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return l$(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must not be less than $constraint1";
      }, t)
    }
  }, t);
}
var c$ = "minDate";
function f$(e, t) {
  return e instanceof Date && e.getTime() >= (t instanceof Date ? t : t()).getTime();
}
function tR(e, t) {
  return W({
    name: c$,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return f$(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return "minimal allowed date for " + r + "$property is $constraint1";
      }, t)
    }
  }, t);
}
var p$ = "maxDate";
function $$(e, t) {
  return e instanceof Date && e.getTime() <= (t instanceof Date ? t : t()).getTime();
}
function rR(e, t) {
  return W({
    name: p$,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return $$(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return "maximal allowed date for " + r + "$property is $constraint1";
      }, t)
    }
  }, t);
}
var Fs = { exports: {} }, ks = { exports: {} }, d9;
function v$() {
  return d9 || (d9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = n;
    function r(o) {
      "@babel/helpers - typeof";
      return r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(a) {
        return typeof a;
      } : function(a) {
        return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
      }, r(o);
    }
    function n(o) {
      return r(o) === "object" && o !== null ? typeof o.toString == "function" ? o = o.toString() : o = "[object Object]" : (o === null || typeof o > "u" || isNaN(o) && !o.length) && (o = ""), String(o);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(ks, ks.exports)), ks.exports;
}
var i9;
function m$() {
  return i9 || (i9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var r = a(/* @__PURE__ */ J()), n = a(/* @__PURE__ */ v$()), o = a(/* @__PURE__ */ $t());
    function a(s) {
      return s && s.__esModule ? s : { default: s };
    }
    var d = {
      ignoreCase: !1,
      minOccurrences: 1
    };
    function i(s, u, c) {
      return (0, r.default)(s), c = (0, o.default)(c, d), c.ignoreCase ? s.toLowerCase().split((0, n.default)(u).toLowerCase()).length > c.minOccurrences : s.split((0, n.default)(u)).length > c.minOccurrences;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Fs, Fs.exports)), Fs.exports;
}
var nR = /* @__PURE__ */ m$();
const h$ = /* @__PURE__ */ $e(nR);
var g$ = "contains";
function y$(e, t) {
  return typeof e == "string" && h$(e, t);
}
function oR(e, t) {
  return W({
    name: g$,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return y$(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must contain a $constraint1 string";
      }, t)
    }
  }, t);
}
var b$ = "notContains";
function x$(e, t) {
  return typeof e == "string" && !h$(e, t);
}
function aR(e, t) {
  return W({
    name: b$,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return x$(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property should not contain a $constraint1 string";
      }, t)
    }
  }, t);
}
var Nn = {}, s9;
function w$() {
  if (s9) return Nn;
  s9 = 1, Object.defineProperty(Nn, "__esModule", {
    value: !0
  }), Nn.default = n, Nn.locales = void 0;
  var e = r(/* @__PURE__ */ J()), t = /* @__PURE__ */ Oa();
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function n(o) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US", d = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    (0, e.default)(o);
    var i = o, s = d.ignore;
    if (s)
      if (s instanceof RegExp)
        i = i.replace(s, "");
      else if (typeof s == "string")
        i = i.replace(new RegExp("[".concat(s.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, "\\$&"), "]"), "g"), "");
      else
        throw new Error("ignore should be instance of a String or RegExp");
    if (a in t.alpha)
      return t.alpha[a].test(i);
    throw new Error("Invalid locale '".concat(a, "'"));
  }
  return Nn.locales = Object.keys(t.alpha), Nn;
}
var dR = /* @__PURE__ */ w$();
const iR = /* @__PURE__ */ $e(dR);
var A$ = "isAlpha";
function S$(e, t) {
  return typeof e == "string" && iR(e, t);
}
function sR(e, t) {
  return W({
    name: A$,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return S$(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must contain only letters (a-zA-Z)";
      }, t)
    }
  }, t);
}
var In = {}, u9;
function _$() {
  if (u9) return In;
  u9 = 1, Object.defineProperty(In, "__esModule", {
    value: !0
  }), In.default = n, In.locales = void 0;
  var e = r(/* @__PURE__ */ J()), t = /* @__PURE__ */ Oa();
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function n(o) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US", d = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    (0, e.default)(o);
    var i = o, s = d.ignore;
    if (s)
      if (s instanceof RegExp)
        i = i.replace(s, "");
      else if (typeof s == "string")
        i = i.replace(new RegExp("[".concat(s.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, "\\$&"), "]"), "g"), "");
      else
        throw new Error("ignore should be instance of a String or RegExp");
    if (a in t.alphanumeric)
      return t.alphanumeric[a].test(i);
    throw new Error("Invalid locale '".concat(a, "'"));
  }
  return In.locales = Object.keys(t.alphanumeric), In;
}
var uR = /* @__PURE__ */ _$();
const lR = /* @__PURE__ */ $e(uR);
var E$ = "isAlphanumeric";
function M$(e, t) {
  return typeof e == "string" && lR(e, t);
}
function cR(e, t) {
  return W({
    name: E$,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return M$(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must contain only letters and numbers";
      }, t)
    }
  }, t);
}
var js = { exports: {} }, Bs = { exports: {} }, l9;
function fR() {
  return l9 || (l9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = function(n, o) {
      return n.some(function(a) {
        return o === a;
      });
    };
    t.default = r, e.exports = t.default, e.exports.default = t.default;
  }(Bs, Bs.exports)), Bs.exports;
}
var c9;
function C$() {
  return c9 || (c9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = c;
    var r = d(/* @__PURE__ */ $t()), n = d(/* @__PURE__ */ J()), o = d(/* @__PURE__ */ fR()), a = /* @__PURE__ */ Oa();
    function d(l) {
      return l && l.__esModule ? l : { default: l };
    }
    function i(l) {
      var p = new RegExp("^[-+]?([0-9]+)?(\\".concat(a.decimal[l.locale], "[0-9]{").concat(l.decimal_digits, "})").concat(l.force_decimal ? "" : "?", "$"));
      return p;
    }
    var s = {
      force_decimal: !1,
      decimal_digits: "1,",
      locale: "en-US"
    }, u = ["", "-", "+"];
    function c(l, p) {
      if ((0, n.default)(l), p = (0, r.default)(p, s), p.locale in a.decimal)
        return !(0, o.default)(u, l.replace(/ /g, "")) && i(p).test(l);
      throw new Error("Invalid locale '".concat(p.locale, "'"));
    }
    e.exports = t.default, e.exports.default = t.default;
  }(js, js.exports)), js.exports;
}
var pR = /* @__PURE__ */ C$();
const $R = /* @__PURE__ */ $e(pR);
var O$ = "isDecimal";
function N$(e, t) {
  return typeof e == "string" && $R(e, t);
}
function vR(e, t) {
  return W({
    name: O$,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return N$(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property is not a valid decimal number.";
      }, t)
    }
  }, t);
}
var Zs = { exports: {} }, f9;
function I$() {
  return f9 || (f9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ J());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /^[\x00-\x7F]+$/;
    function a(d) {
      return (0, r.default)(d), o.test(d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Zs, Zs.exports)), Zs.exports;
}
var mR = /* @__PURE__ */ I$();
const hR = /* @__PURE__ */ $e(mR);
var P$ = "isAscii";
function R$(e) {
  return typeof e == "string" && hR(e);
}
function gR(e) {
  return W({
    name: P$,
    validator: {
      validate: function(t, r) {
        return R$(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must contain only ASCII characters";
      }, e)
    }
  }, e);
}
var Us = { exports: {} }, p9;
function j1() {
  return p9 || (p9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = s;
    var r = o(/* @__PURE__ */ J()), n = o(/* @__PURE__ */ $t());
    function o(u) {
      return u && u.__esModule ? u : { default: u };
    }
    var a = /[^A-Z0-9+\/=]/i, d = /^[A-Z0-9_\-]*$/i, i = {
      urlSafe: !1
    };
    function s(u, c) {
      (0, r.default)(u), c = (0, n.default)(c, i);
      var l = u.length;
      if (c.urlSafe)
        return d.test(u);
      if (l % 4 !== 0 || a.test(u))
        return !1;
      var p = u.indexOf("=");
      return p === -1 || p === l - 1 || p === l - 2 && u[l - 1] === "=";
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Us, Us.exports)), Us.exports;
}
var yR = /* @__PURE__ */ j1();
const bR = /* @__PURE__ */ $e(yR);
var T$ = "isBase64";
function D$(e, t) {
  return typeof e == "string" && bR(e, t);
}
function xR(e, t) {
  return W({
    name: T$,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return D$(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must be base64 encoded";
      }, t)
    }
  }, t);
}
var Gs = { exports: {} }, $9;
function B1() {
  return $9 || ($9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ J());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    function o(d) {
      "@babel/helpers - typeof";
      return o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
        return typeof i;
      } : function(i) {
        return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
      }, o(d);
    }
    function a(d, i) {
      (0, r.default)(d);
      var s, u;
      o(i) === "object" ? (s = i.min || 0, u = i.max) : (s = arguments[1], u = arguments[2]);
      var c = encodeURI(d).split(/%..|./).length - 1;
      return c >= s && (typeof u > "u" || c <= u);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Gs, Gs.exports)), Gs.exports;
}
var wR = /* @__PURE__ */ B1();
const AR = /* @__PURE__ */ $e(wR);
var L$ = "isByteLength";
function F$(e, t, r) {
  return typeof e == "string" && AR(e, { min: t, max: r });
}
function SR(e, t, r) {
  return W({
    name: L$,
    constraints: [e, t],
    validator: {
      validate: function(n, o) {
        return F$(n, o == null ? void 0 : o.constraints[0], o == null ? void 0 : o.constraints[1]);
      },
      defaultMessage: K(function(n) {
        return n + "$property's byte length must fall into ($constraint1, $constraint2) range";
      }, r)
    }
  }, r);
}
var Vs = { exports: {} }, Hs = { exports: {} }, v9;
function k$() {
  return v9 || (v9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ J());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a) {
      (0, r.default)(a);
      for (var d = a.replace(/[- ]+/g, ""), i = 0, s, u, c, l = d.length - 1; l >= 0; l--)
        s = d.substring(l, l + 1), u = parseInt(s, 10), c ? (u *= 2, u >= 10 ? i += u % 10 + 1 : i += u) : i += u, c = !c;
      return !!(i % 10 === 0 && d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Hs, Hs.exports)), Hs.exports;
}
var m9;
function j$() {
  return m9 || (m9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var r = o(/* @__PURE__ */ J()), n = o(/* @__PURE__ */ k$());
    function o(s) {
      return s && s.__esModule ? s : { default: s };
    }
    var a = {
      amex: /^3[47][0-9]{13}$/,
      dinersclub: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
      discover: /^6(?:011|5[0-9][0-9])[0-9]{12,15}$/,
      jcb: /^(?:2131|1800|35\d{3})\d{11}$/,
      mastercard: /^5[1-5][0-9]{2}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/,
      // /^[25][1-7][0-9]{14}$/;
      unionpay: /^(6[27][0-9]{14}|^(81[0-9]{14,17}))$/,
      visa: /^(?:4[0-9]{12})(?:[0-9]{3,6})?$/
    }, d = function() {
      var s = [];
      for (var u in a)
        a.hasOwnProperty(u) && s.push(a[u]);
      return s;
    }();
    function i(s) {
      var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      (0, r.default)(s);
      var c = u.provider, l = s.replace(/[- ]+/g, "");
      if (c && c.toLowerCase() in a) {
        if (!a[c.toLowerCase()].test(l))
          return !1;
      } else {
        if (c && !(c.toLowerCase() in a))
          throw new Error("".concat(c, " is not a valid credit card provider."));
        if (!d.some(function(p) {
          return p.test(l);
        }))
          return !1;
      }
      return (0, n.default)(s);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Vs, Vs.exports)), Vs.exports;
}
var _R = /* @__PURE__ */ j$();
const ER = /* @__PURE__ */ $e(_R);
var B$ = "isCreditCard";
function Z$(e) {
  return typeof e == "string" && ER(e);
}
function MR(e) {
  return W({
    name: B$,
    validator: {
      validate: function(t, r) {
        return Z$(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be a credit card";
      }, e)
    }
  }, e);
}
var Ks = { exports: {} }, h9;
function U$() {
  return h9 || (h9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var r = o(/* @__PURE__ */ $t()), n = o(/* @__PURE__ */ J());
    function o(s) {
      return s && s.__esModule ? s : { default: s };
    }
    function a(s) {
      var u = "\\d{".concat(s.digits_after_decimal[0], "}");
      s.digits_after_decimal.forEach(function(y, S) {
        S !== 0 && (u = "".concat(u, "|\\d{").concat(y, "}"));
      });
      var c = "(".concat(s.symbol.replace(/\W/, function(y) {
        return "\\".concat(y);
      }), ")").concat(s.require_symbol ? "" : "?"), l = "-?", p = "[1-9]\\d*", h = "[1-9]\\d{0,2}(\\".concat(s.thousands_separator, "\\d{3})*"), m = ["0", p, h], f = "(".concat(m.join("|"), ")?"), $ = "(\\".concat(s.decimal_separator, "(").concat(u, "))").concat(s.require_decimal ? "" : "?"), v = f + (s.allow_decimal || s.require_decimal ? $ : "");
      return s.allow_negatives && !s.parens_for_negatives && (s.negative_sign_after_digits ? v += l : s.negative_sign_before_digits && (v = l + v)), s.allow_negative_sign_placeholder ? v = "( (?!\\-))?".concat(v) : s.allow_space_after_symbol ? v = " ?".concat(v) : s.allow_space_after_digits && (v += "( (?!$))?"), s.symbol_after_digits ? v += c : v = c + v, s.allow_negatives && (s.parens_for_negatives ? v = "(\\(".concat(v, "\\)|").concat(v, ")") : s.negative_sign_before_digits || s.negative_sign_after_digits || (v = l + v)), new RegExp("^(?!-? )(?=.*\\d)".concat(v, "$"));
    }
    var d = {
      symbol: "$",
      require_symbol: !1,
      allow_space_after_symbol: !1,
      symbol_after_digits: !1,
      allow_negatives: !0,
      parens_for_negatives: !1,
      negative_sign_before_digits: !1,
      negative_sign_after_digits: !1,
      allow_negative_sign_placeholder: !1,
      thousands_separator: ",",
      decimal_separator: ".",
      allow_decimal: !0,
      require_decimal: !1,
      digits_after_decimal: [2],
      allow_space_after_digits: !1
    };
    function i(s, u) {
      return (0, n.default)(s), u = (0, r.default)(u, d), a(u).test(s);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Ks, Ks.exports)), Ks.exports;
}
var CR = /* @__PURE__ */ U$();
const OR = /* @__PURE__ */ $e(CR);
var G$ = "isCurrency";
function V$(e, t) {
  return typeof e == "string" && OR(e, t);
}
function NR(e, t) {
  return W({
    name: G$,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return V$(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must be a currency";
      }, t)
    }
  }, t);
}
var Ws = { exports: {} }, zs = { exports: {} }, g9;
function H$() {
  return g9 || (g9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = n;
    function r(o) {
      return Object.prototype.toString.call(o) === "[object RegExp]";
    }
    function n(o, a) {
      for (var d = 0; d < a.length; d++) {
        var i = a[d];
        if (o === i || r(i) && i.test(o))
          return !0;
      }
      return !1;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(zs, zs.exports)), zs.exports;
}
var Ys = { exports: {} }, y9;
function di() {
  return y9 || (y9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = o(/* @__PURE__ */ J()), n = o(/* @__PURE__ */ $t());
    function o(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var a = {
      require_tld: !0,
      allow_underscores: !1,
      allow_trailing_dot: !1,
      allow_numeric_tld: !1,
      allow_wildcard: !1,
      ignore_max_length: !1
    };
    function d(i, s) {
      (0, r.default)(i), s = (0, n.default)(s, a), s.allow_trailing_dot && i[i.length - 1] === "." && (i = i.substring(0, i.length - 1)), s.allow_wildcard === !0 && i.indexOf("*.") === 0 && (i = i.substring(2));
      var u = i.split("."), c = u[u.length - 1];
      return s.require_tld && (u.length < 2 || !s.allow_numeric_tld && !/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(c) || /\s/.test(c)) || !s.allow_numeric_tld && /^\d+$/.test(c) ? !1 : u.every(function(l) {
        return !(l.length > 63 && !s.ignore_max_length || !/^[a-z_\u00a1-\uffff0-9-]+$/i.test(l) || /[\uff01-\uff5e]/.test(l) || /^-|-$/.test(l) || !s.allow_underscores && /_/.test(l));
      });
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Ys, Ys.exports)), Ys.exports;
}
var Xs = { exports: {} }, b9;
function Na() {
  return b9 || (b9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = u;
    var r = n(/* @__PURE__ */ J());
    function n(c) {
      return c && c.__esModule ? c : { default: c };
    }
    var o = "(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])", a = "(".concat(o, "[.]){3}").concat(o), d = new RegExp("^".concat(a, "$")), i = "(?:[0-9a-fA-F]{1,4})", s = new RegExp("^(" + "(?:".concat(i, ":){7}(?:").concat(i, "|:)|") + "(?:".concat(i, ":){6}(?:").concat(a, "|:").concat(i, "|:)|") + "(?:".concat(i, ":){5}(?::").concat(a, "|(:").concat(i, "){1,2}|:)|") + "(?:".concat(i, ":){4}(?:(:").concat(i, "){0,1}:").concat(a, "|(:").concat(i, "){1,3}|:)|") + "(?:".concat(i, ":){3}(?:(:").concat(i, "){0,2}:").concat(a, "|(:").concat(i, "){1,4}|:)|") + "(?:".concat(i, ":){2}(?:(:").concat(i, "){0,3}:").concat(a, "|(:").concat(i, "){1,5}|:)|") + "(?:".concat(i, ":){1}(?:(:").concat(i, "){0,4}:").concat(a, "|(:").concat(i, "){1,6}|:)|") + "(?::((?::".concat(i, "){0,5}:").concat(a, "|(?::").concat(i, "){1,7}|:))") + ")(%[0-9a-zA-Z-.:]{1,})?$");
    function u(c) {
      var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
      return (0, r.default)(c), l = String(l), l ? l === "4" ? d.test(c) : l === "6" ? s.test(c) : !1 : u(c, 4) || u(c, 6);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Xs, Xs.exports)), Xs.exports;
}
var x9;
function Z1() {
  return x9 || (x9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = y;
    var r = s(/* @__PURE__ */ J()), n = s(/* @__PURE__ */ H$()), o = s(/* @__PURE__ */ B1()), a = s(/* @__PURE__ */ di()), d = s(/* @__PURE__ */ Na()), i = s(/* @__PURE__ */ $t());
    function s(S) {
      return S && S.__esModule ? S : { default: S };
    }
    var u = {
      allow_display_name: !1,
      allow_underscores: !1,
      require_display_name: !1,
      allow_utf8_local_part: !0,
      require_tld: !0,
      blacklisted_chars: "",
      ignore_max_length: !1,
      host_blacklist: [],
      host_whitelist: []
    }, c = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i, l = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i, p = /^[a-z\d]+$/, h = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i, m = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A1-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i, f = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i, $ = 254;
    function v(S) {
      var w = S.replace(/^"(.+)"$/, "$1");
      if (!w.trim())
        return !1;
      var _ = /[\.";<>]/.test(w);
      if (_) {
        if (w === S)
          return !1;
        var I = w.split('"').length === w.split('\\"').length;
        if (!I)
          return !1;
      }
      return !0;
    }
    function y(S, w) {
      if ((0, r.default)(S), w = (0, i.default)(w, u), w.require_display_name || w.allow_display_name) {
        var _ = S.match(c);
        if (_) {
          var I = _[1];
          if (S = S.replace(I, "").replace(/(^<|>$)/g, ""), I.endsWith(" ") && (I = I.slice(0, -1)), !v(I))
            return !1;
        } else if (w.require_display_name)
          return !1;
      }
      if (!w.ignore_max_length && S.length > $)
        return !1;
      var N = S.split("@"), O = N.pop(), E = O.toLowerCase();
      if (w.host_blacklist.length > 0 && (0, n.default)(E, w.host_blacklist) || w.host_whitelist.length > 0 && !(0, n.default)(E, w.host_whitelist))
        return !1;
      var C = N.join("@");
      if (w.domain_specific_validation && (E === "gmail.com" || E === "googlemail.com")) {
        C = C.toLowerCase();
        var P = C.split("+")[0];
        if (!(0, o.default)(P.replace(/\./g, ""), {
          min: 6,
          max: 30
        }))
          return !1;
        for (var T = P.split("."), j = 0; j < T.length; j++)
          if (!p.test(T[j]))
            return !1;
      }
      if (w.ignore_max_length === !1 && (!(0, o.default)(C, {
        max: 64
      }) || !(0, o.default)(O, {
        max: 254
      })))
        return !1;
      if (!(0, a.default)(O, {
        require_tld: w.require_tld,
        ignore_max_length: w.ignore_max_length,
        allow_underscores: w.allow_underscores
      })) {
        if (!w.allow_ip_domain)
          return !1;
        if (!(0, d.default)(O)) {
          if (!O.startsWith("[") || !O.endsWith("]"))
            return !1;
          var F = O.slice(1, -1);
          if (F.length === 0 || !(0, d.default)(F))
            return !1;
        }
      }
      if (w.blacklisted_chars && C.search(new RegExp("[".concat(w.blacklisted_chars, "]+"), "g")) !== -1)
        return !1;
      if (C[0] === '"' && C[C.length - 1] === '"')
        return C = C.slice(1, C.length - 1), w.allow_utf8_local_part ? f.test(C) : h.test(C);
      for (var Z = w.allow_utf8_local_part ? m : l, te = C.split("."), H = 0; H < te.length; H++)
        if (!Z.test(te[H]))
          return !1;
      return !0;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Ws, Ws.exports)), Ws.exports;
}
var IR = /* @__PURE__ */ Z1();
const PR = /* @__PURE__ */ $e(IR);
var K$ = "isEmail";
function W$(e, t) {
  return typeof e == "string" && PR(e, t);
}
function RR(e, t) {
  return W({
    name: K$,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return W$(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must be an email";
      }, t)
    }
  }, t);
}
var TR = /* @__PURE__ */ di();
const DR = /* @__PURE__ */ $e(TR);
var z$ = "isFqdn";
function Y$(e, t) {
  return typeof e == "string" && DR(e, t);
}
function LR(e, t) {
  return W({
    name: z$,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Y$(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must be a valid domain name";
      }, t)
    }
  }, t);
}
var Pn = {}, w9;
function U1() {
  if (w9) return Pn;
  w9 = 1, Object.defineProperty(Pn, "__esModule", {
    value: !0
  }), Pn.default = n, Pn.fullWidth = void 0;
  var e = t(/* @__PURE__ */ J());
  function t(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var r = Pn.fullWidth = /[^\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
  function n(o) {
    return (0, e.default)(o), r.test(o);
  }
  return Pn;
}
var FR = /* @__PURE__ */ U1();
const kR = /* @__PURE__ */ $e(FR);
var X$ = "isFullWidth";
function q$(e) {
  return typeof e == "string" && kR(e);
}
function jR(e) {
  return W({
    name: X$,
    validator: {
      validate: function(t, r) {
        return q$(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must contain a full-width characters";
      }, e)
    }
  }, e);
}
var Rn = {}, A9;
function G1() {
  if (A9) return Rn;
  A9 = 1, Object.defineProperty(Rn, "__esModule", {
    value: !0
  }), Rn.default = n, Rn.halfWidth = void 0;
  var e = t(/* @__PURE__ */ J());
  function t(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var r = Rn.halfWidth = /[\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
  function n(o) {
    return (0, e.default)(o), r.test(o);
  }
  return Rn;
}
var BR = /* @__PURE__ */ G1();
const ZR = /* @__PURE__ */ $e(BR);
var J$ = "isHalfWidth";
function Q$(e) {
  return typeof e == "string" && ZR(e);
}
function UR(e) {
  return W({
    name: J$,
    validator: {
      validate: function(t, r) {
        return Q$(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must contain a half-width characters";
      }, e)
    }
  }, e);
}
var qs = { exports: {} }, S9;
function ev() {
  return S9 || (S9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = a(/* @__PURE__ */ J()), n = /* @__PURE__ */ U1(), o = /* @__PURE__ */ G1();
    function a(i) {
      return i && i.__esModule ? i : { default: i };
    }
    function d(i) {
      return (0, r.default)(i), n.fullWidth.test(i) && o.halfWidth.test(i);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(qs, qs.exports)), qs.exports;
}
var GR = /* @__PURE__ */ ev();
const VR = /* @__PURE__ */ $e(GR);
var tv = "isVariableWidth";
function rv(e) {
  return typeof e == "string" && VR(e);
}
function HR(e) {
  return W({
    name: tv,
    validator: {
      validate: function(t, r) {
        return rv(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must contain a full-width and half-width characters";
      }, e)
    }
  }, e);
}
var Js = { exports: {} }, _9;
function nv() {
  return _9 || (_9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ J());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /^#?([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$/i;
    function a(d) {
      return (0, r.default)(d), o.test(d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Js, Js.exports)), Js.exports;
}
var KR = /* @__PURE__ */ nv();
const WR = /* @__PURE__ */ $e(KR);
var ov = "isHexColor";
function av(e) {
  return typeof e == "string" && WR(e);
}
function zR(e) {
  return W({
    name: ov,
    validator: {
      validate: function(t, r) {
        return av(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be a hexadecimal color";
      }, e)
    }
  }, e);
}
var Qs = { exports: {} }, E9;
function V1() {
  return E9 || (E9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ J());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /^(0x|0h)?[0-9A-F]+$/i;
    function a(d) {
      return (0, r.default)(d), o.test(d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Qs, Qs.exports)), Qs.exports;
}
var YR = /* @__PURE__ */ V1();
const XR = /* @__PURE__ */ $e(YR);
var dv = "isHexadecimal";
function iv(e) {
  return typeof e == "string" && XR(e);
}
function qR(e) {
  return W({
    name: dv,
    validator: {
      validate: function(t, r) {
        return iv(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be a hexadecimal number";
      }, e)
    }
  }, e);
}
function Bc(e) {
  return e ? "each" in e || "message" in e || "groups" in e || "always" in e || "context" in e : !1;
}
var e0 = { exports: {} }, M9;
function sv() {
  return M9 || (M9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = c;
    var r = n(/* @__PURE__ */ J());
    function n(l) {
      return l && l.__esModule ? l : { default: l };
    }
    var o = /^(?:[0-9a-fA-F]{2}([-:\s]))([0-9a-fA-F]{2}\1){4}([0-9a-fA-F]{2})$/, a = /^([0-9a-fA-F]){12}$/, d = /^([0-9a-fA-F]{4}\.){2}([0-9a-fA-F]{4})$/, i = /^(?:[0-9a-fA-F]{2}([-:\s]))([0-9a-fA-F]{2}\1){6}([0-9a-fA-F]{2})$/, s = /^([0-9a-fA-F]){16}$/, u = /^([0-9a-fA-F]{4}\.){3}([0-9a-fA-F]{4})$/;
    function c(l, p) {
      return (0, r.default)(l), p != null && p.eui && (p.eui = String(p.eui)), p != null && p.no_colons || p != null && p.no_separators ? p.eui === "48" ? a.test(l) : p.eui === "64" ? s.test(l) : a.test(l) || s.test(l) : (p == null ? void 0 : p.eui) === "48" ? o.test(l) || d.test(l) : (p == null ? void 0 : p.eui) === "64" ? i.test(l) || u.test(l) : c(l, {
        eui: "48"
      }) || c(l, {
        eui: "64"
      });
    }
    e.exports = t.default, e.exports.default = t.default;
  }(e0, e0.exports)), e0.exports;
}
var JR = /* @__PURE__ */ sv();
const QR = /* @__PURE__ */ $e(JR);
var uv = "isMacAddress";
function lv(e, t) {
  return typeof e == "string" && QR(e, t);
}
function eT(e, t) {
  var r = Bc(e) ? void 0 : e, n = Bc(e) ? e : t;
  return W({
    name: uv,
    constraints: [r],
    validator: {
      validate: function(o, a) {
        return lv(o, r);
      },
      defaultMessage: K(function(o) {
        return o + "$property must be a MAC Address";
      }, n)
    }
  }, n);
}
var tT = /* @__PURE__ */ Na();
const rT = /* @__PURE__ */ $e(tT);
var cv = "isIp";
function fv(e, t) {
  var r = t ? "".concat(t) : void 0;
  return typeof e == "string" && rT(e, r);
}
function nT(e, t) {
  return W({
    name: cv,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return fv(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must be an ip address";
      }, t)
    }
  }, t);
}
var t0 = { exports: {} }, r0 = { exports: {} }, C9;
function H1() {
  return C9 || (C9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var r = o(/* @__PURE__ */ J()), n = o(/* @__PURE__ */ qp());
    function o(s) {
      return s && s.__esModule ? s : { default: s };
    }
    var a = /^(?:[-+]?(?:0|[1-9][0-9]*))$/, d = /^[-+]?[0-9]+$/;
    function i(s, u) {
      (0, r.default)(s), u = u || {};
      var c = u.allow_leading_zeroes === !1 ? a : d, l = !u.hasOwnProperty("min") || (0, n.default)(u.min) || s >= u.min, p = !u.hasOwnProperty("max") || (0, n.default)(u.max) || s <= u.max, h = !u.hasOwnProperty("lt") || (0, n.default)(u.lt) || s < u.lt, m = !u.hasOwnProperty("gt") || (0, n.default)(u.gt) || s > u.gt;
      return c.test(s) && l && p && h && m;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(r0, r0.exports)), r0.exports;
}
var O9;
function pv() {
  return O9 || (O9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ H1());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a) {
      return (0, r.default)(a, {
        allow_leading_zeroes: !1,
        min: 0,
        max: 65535
      });
    }
    e.exports = t.default, e.exports.default = t.default;
  }(t0, t0.exports)), t0.exports;
}
var oT = /* @__PURE__ */ pv();
const aT = /* @__PURE__ */ $e(oT);
var $v = "isPort";
function vv(e) {
  return typeof e == "string" && aT(e);
}
function dT(e) {
  return W({
    name: $v,
    validator: {
      validate: function(t, r) {
        return vv(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be a port";
      }, e)
    }
  }, e);
}
var n0 = { exports: {} }, N9;
function mv() {
  return N9 || (N9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var r = n(/* @__PURE__ */ J());
    function n(s) {
      return s && s.__esModule ? s : { default: s };
    }
    var o = /^(?:[0-9]{9}X|[0-9]{10})$/, a = /^(?:[0-9]{13})$/, d = [1, 3];
    function i(s, u) {
      (0, r.default)(s);
      var c = String((u == null ? void 0 : u.version) || u);
      if (!(u != null && u.version || u))
        return i(s, {
          version: 10
        }) || i(s, {
          version: 13
        });
      var l = s.replace(/[\s-]+/g, ""), p = 0;
      if (c === "10") {
        if (!o.test(l))
          return !1;
        for (var h = 0; h < c - 1; h++)
          p += (h + 1) * l.charAt(h);
        if (l.charAt(9) === "X" ? p += 10 * 10 : p += 10 * l.charAt(9), p % 11 === 0)
          return !0;
      } else if (c === "13") {
        if (!a.test(l))
          return !1;
        for (var m = 0; m < 12; m++)
          p += d[m % 2] * l.charAt(m);
        if (l.charAt(12) - (10 - p % 10) % 10 === 0)
          return !0;
      }
      return !1;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(n0, n0.exports)), n0.exports;
}
var iT = /* @__PURE__ */ mv();
const sT = /* @__PURE__ */ $e(iT);
var hv = "isIsbn";
function gv(e, t) {
  var r = t ? "".concat(t) : void 0;
  return typeof e == "string" && sT(e, r);
}
function uT(e, t) {
  return W({
    name: hv,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return gv(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must be an ISBN";
      }, t)
    }
  }, t);
}
var o0 = { exports: {} }, I9;
function yv() {
  return I9 || (I9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ J());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /^[A-Z]{2}[0-9A-Z]{9}[0-9]$/;
    function a(d) {
      if ((0, r.default)(d), !o.test(d))
        return !1;
      for (var i = !0, s = 0, u = d.length - 2; u >= 0; u--)
        if (d[u] >= "A" && d[u] <= "Z")
          for (var c = d[u].charCodeAt(0) - 55, l = c % 10, p = Math.trunc(c / 10), h = 0, m = [l, p]; h < m.length; h++) {
            var f = m[h];
            i ? f >= 5 ? s += 1 + (f - 5) * 2 : s += f * 2 : s += f, i = !i;
          }
        else {
          var $ = d[u].charCodeAt(0) - 48;
          i ? $ >= 5 ? s += 1 + ($ - 5) * 2 : s += $ * 2 : s += $, i = !i;
        }
      var v = Math.trunc((s + 9) / 10) * 10 - s;
      return +d[d.length - 1] === v;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(o0, o0.exports)), o0.exports;
}
var lT = /* @__PURE__ */ yv();
const cT = /* @__PURE__ */ $e(lT);
var bv = "isIsin";
function xv(e) {
  return typeof e == "string" && cT(e);
}
function fT(e) {
  return W({
    name: bv,
    validator: {
      validate: function(t, r) {
        return xv(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be an ISIN (stock/security identifier)";
      }, e)
    }
  }, e);
}
var a0 = { exports: {} }, P9;
function wv() {
  return P9 || (P9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var r = n(/* @__PURE__ */ J());
    function n(s) {
      return s && s.__esModule ? s : { default: s };
    }
    var o = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/, a = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/, d = function(s) {
      var u = s.match(/^(\d{4})-?(\d{3})([ T]{1}\.*|$)/);
      if (u) {
        var c = Number(u[1]), l = Number(u[2]);
        return c % 4 === 0 && c % 100 !== 0 || c % 400 === 0 ? l <= 366 : l <= 365;
      }
      var p = s.match(/(\d{4})-?(\d{0,2})-?(\d*)/).map(Number), h = p[1], m = p[2], f = p[3], $ = m && "0".concat(m).slice(-2), v = f && "0".concat(f).slice(-2), y = new Date("".concat(h, "-").concat($ || "01", "-").concat(v || "01"));
      return m && f ? y.getUTCFullYear() === h && y.getUTCMonth() + 1 === m && y.getUTCDate() === f : !0;
    };
    function i(s) {
      var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      (0, r.default)(s);
      var c = u.strictSeparator ? a.test(s) : o.test(s);
      return c && u.strict ? d(s) : c;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(a0, a0.exports)), a0.exports;
}
var pT = /* @__PURE__ */ wv();
const $T = /* @__PURE__ */ $e(pT);
var Av = "isIso8601";
function K1(e, t) {
  return typeof e == "string" && $T(e, t);
}
function vT(e, t) {
  return W({
    name: Av,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return K1(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must be a valid ISO 8601 date string";
      }, t)
    }
  }, t);
}
var d0 = { exports: {} }, R9;
function Sv() {
  return R9 || (R9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var r = o(/* @__PURE__ */ J()), n = o(/* @__PURE__ */ $t());
    function o(s) {
      return s && s.__esModule ? s : { default: s };
    }
    function a(s) {
      "@babel/helpers - typeof";
      return a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(u) {
        return typeof u;
      } : function(u) {
        return u && typeof Symbol == "function" && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
      }, a(s);
    }
    var d = {
      allow_primitives: !1
    };
    function i(s, u) {
      (0, r.default)(s);
      try {
        u = (0, n.default)(u, d);
        var c = [];
        u.allow_primitives && (c = [null, !1, !0]);
        var l = JSON.parse(s);
        return c.includes(l) || !!l && a(l) === "object";
      } catch {
      }
      return !1;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(d0, d0.exports)), d0.exports;
}
var mT = /* @__PURE__ */ Sv();
const hT = /* @__PURE__ */ $e(mT);
var _v = "isJson";
function Ev(e) {
  return typeof e == "string" && hT(e);
}
function gT(e) {
  return W({
    name: _v,
    validator: {
      validate: function(t, r) {
        return Ev(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be a json string";
      }, e)
    }
  }, e);
}
var i0 = { exports: {} }, T9;
function Mv() {
  return T9 || (T9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = o(/* @__PURE__ */ J()), n = o(/* @__PURE__ */ j1());
    function o(d) {
      return d && d.__esModule ? d : { default: d };
    }
    function a(d) {
      (0, r.default)(d);
      var i = d.split("."), s = i.length;
      return s !== 3 ? !1 : i.reduce(function(u, c) {
        return u && (0, n.default)(c, {
          urlSafe: !0
        });
      }, !0);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(i0, i0.exports)), i0.exports;
}
var yT = /* @__PURE__ */ Mv();
const bT = /* @__PURE__ */ $e(yT);
var Cv = "isJwt";
function Ov(e) {
  return typeof e == "string" && bT(e);
}
function xT(e) {
  return W({
    name: Cv,
    validator: {
      validate: function(t, r) {
        return Ov(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be a jwt string";
      }, e)
    }
  }, e);
}
var s0 = { exports: {} }, D9;
function Nv() {
  return D9 || (D9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ J());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a) {
      return (0, r.default)(a), a === a.toLowerCase();
    }
    e.exports = t.default, e.exports.default = t.default;
  }(s0, s0.exports)), s0.exports;
}
var wT = /* @__PURE__ */ Nv();
const AT = /* @__PURE__ */ $e(wT);
var Iv = "isLowercase";
function Pv(e) {
  return typeof e == "string" && AT(e);
}
function ST(e) {
  return W({
    name: Iv,
    validator: {
      validate: function(t, r) {
        return Pv(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be a lowercase string";
      }, e)
    }
  }, e);
}
var Tn = {}, L9;
function Rv() {
  if (L9) return Tn;
  L9 = 1, Object.defineProperty(Tn, "__esModule", {
    value: !0
  }), Tn.default = n, Tn.locales = void 0;
  var e = t(/* @__PURE__ */ J());
  function t(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var r = {
    "am-AM": /^(\+?374|0)(33|4[134]|55|77|88|9[13-689])\d{6}$/,
    "ar-AE": /^((\+?971)|0)?5[024568]\d{7}$/,
    "ar-BH": /^(\+?973)?(3|6)\d{7}$/,
    "ar-DZ": /^(\+?213|0)(5|6|7)\d{8}$/,
    "ar-LB": /^(\+?961)?((3|81)\d{6}|7\d{7})$/,
    "ar-EG": /^((\+?20)|0)?1[0125]\d{8}$/,
    "ar-IQ": /^(\+?964|0)?7[0-9]\d{8}$/,
    "ar-JO": /^(\+?962|0)?7[789]\d{7}$/,
    "ar-KW": /^(\+?965)([569]\d{7}|41\d{6})$/,
    "ar-LY": /^((\+?218)|0)?(9[1-6]\d{7}|[1-8]\d{7,9})$/,
    "ar-MA": /^(?:(?:\+|00)212|0)[5-7]\d{8}$/,
    "ar-OM": /^((\+|00)968)?(9[1-9])\d{6}$/,
    "ar-PS": /^(\+?970|0)5[6|9](\d{7})$/,
    "ar-SA": /^(!?(\+?966)|0)?5\d{8}$/,
    "ar-SD": /^((\+?249)|0)?(9[012369]|1[012])\d{7}$/,
    "ar-SY": /^(!?(\+?963)|0)?9\d{8}$/,
    "ar-TN": /^(\+?216)?[2459]\d{7}$/,
    "az-AZ": /^(\+994|0)(10|5[015]|7[07]|99)\d{7}$/,
    "bs-BA": /^((((\+|00)3876)|06))((([0-3]|[5-6])\d{6})|(4\d{7}))$/,
    "be-BY": /^(\+?375)?(24|25|29|33|44)\d{7}$/,
    "bg-BG": /^(\+?359|0)?8[789]\d{7}$/,
    "bn-BD": /^(\+?880|0)1[13456789][0-9]{8}$/,
    "ca-AD": /^(\+376)?[346]\d{5}$/,
    "cs-CZ": /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
    "da-DK": /^(\+?45)?\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
    "de-DE": /^((\+49|0)1)(5[0-25-9]\d|6([23]|0\d?)|7([0-57-9]|6\d))\d{7,9}$/,
    "de-AT": /^(\+43|0)\d{1,4}\d{3,12}$/,
    "de-CH": /^(\+41|0)([1-9])\d{1,9}$/,
    "de-LU": /^(\+352)?((6\d1)\d{6})$/,
    "dv-MV": /^(\+?960)?(7[2-9]|9[1-9])\d{5}$/,
    "el-GR": /^(\+?30|0)?6(8[5-9]|9(?![26])[0-9])\d{7}$/,
    "el-CY": /^(\+?357?)?(9(9|6)\d{6})$/,
    "en-AI": /^(\+?1|0)264(?:2(35|92)|4(?:6[1-2]|76|97)|5(?:3[6-9]|8[1-4])|7(?:2(4|9)|72))\d{4}$/,
    "en-AU": /^(\+?61|0)4\d{8}$/,
    "en-AG": /^(?:\+1|1)268(?:464|7(?:1[3-9]|[28]\d|3[0246]|64|7[0-689]))\d{4}$/,
    "en-BM": /^(\+?1)?441(((3|7)\d{6}$)|(5[0-3][0-9]\d{4}$)|(59\d{5}$))/,
    "en-BS": /^(\+?1[-\s]?|0)?\(?242\)?[-\s]?\d{3}[-\s]?\d{4}$/,
    "en-GB": /^(\+?44|0)7[1-9]\d{8}$/,
    "en-GG": /^(\+?44|0)1481\d{6}$/,
    "en-GH": /^(\+233|0)(20|50|24|54|27|57|26|56|23|53|28|55|59)\d{7}$/,
    "en-GY": /^(\+592|0)6\d{6}$/,
    "en-HK": /^(\+?852[-\s]?)?[456789]\d{3}[-\s]?\d{4}$/,
    "en-MO": /^(\+?853[-\s]?)?[6]\d{3}[-\s]?\d{4}$/,
    "en-IE": /^(\+?353|0)8[356789]\d{7}$/,
    "en-IN": /^(\+?91|0)?[6789]\d{9}$/,
    "en-JM": /^(\+?876)?\d{7}$/,
    "en-KE": /^(\+?254|0)(7|1)\d{8}$/,
    "fr-CF": /^(\+?236| ?)(70|75|77|72|21|22)\d{6}$/,
    "en-SS": /^(\+?211|0)(9[1257])\d{7}$/,
    "en-KI": /^((\+686|686)?)?( )?((6|7)(2|3|8)[0-9]{6})$/,
    "en-KN": /^(?:\+1|1)869(?:46\d|48[89]|55[6-8]|66\d|76[02-7])\d{4}$/,
    "en-LS": /^(\+?266)(22|28|57|58|59|27|52)\d{6}$/,
    "en-MT": /^(\+?356|0)?(99|79|77|21|27|22|25)[0-9]{6}$/,
    "en-MU": /^(\+?230|0)?\d{8}$/,
    "en-MW": /^(\+?265|0)(((77|88|31|99|98|21)\d{7})|(((111)|1)\d{6})|(32000\d{4}))$/,
    "en-NA": /^(\+?264|0)(6|8)\d{7}$/,
    "en-NG": /^(\+?234|0)?[789]\d{9}$/,
    "en-NZ": /^(\+?64|0)[28]\d{7,9}$/,
    "en-PG": /^(\+?675|0)?(7\d|8[18])\d{6}$/,
    "en-PK": /^((00|\+)?92|0)3[0-6]\d{8}$/,
    "en-PH": /^(09|\+639)\d{9}$/,
    "en-RW": /^(\+?250|0)?[7]\d{8}$/,
    "en-SG": /^(\+65)?[3689]\d{7}$/,
    "en-SL": /^(\+?232|0)\d{8}$/,
    "en-TZ": /^(\+?255|0)?[67]\d{8}$/,
    "en-UG": /^(\+?256|0)?[7]\d{8}$/,
    "en-US": /^((\+1|1)?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/,
    "en-ZA": /^(\+?27|0)\d{9}$/,
    "en-ZM": /^(\+?26)?0[79][567]\d{7}$/,
    "en-ZW": /^(\+263)[0-9]{9}$/,
    "en-BW": /^(\+?267)?(7[1-8]{1})\d{6}$/,
    "es-AR": /^\+?549(11|[2368]\d)\d{8}$/,
    "es-BO": /^(\+?591)?(6|7)\d{7}$/,
    "es-CO": /^(\+?57)?3(0(0|1|2|4|5)|1\d|2[0-4]|5(0|1))\d{7}$/,
    "es-CL": /^(\+?56|0)[2-9]\d{1}\d{7}$/,
    "es-CR": /^(\+506)?[2-8]\d{7}$/,
    "es-CU": /^(\+53|0053)?5\d{7}$/,
    "es-DO": /^(\+?1)?8[024]9\d{7}$/,
    "es-HN": /^(\+?504)?[9|8|3|2]\d{7}$/,
    "es-EC": /^(\+?593|0)([2-7]|9[2-9])\d{7}$/,
    "es-ES": /^(\+?34)?[6|7]\d{8}$/,
    "es-GT": /^(\+?502)?[2|6|7]\d{7}$/,
    "es-PE": /^(\+?51)?9\d{8}$/,
    "es-MX": /^(\+?52)?(1|01)?\d{10,11}$/,
    "es-NI": /^(\+?505)\d{7,8}$/,
    "es-PA": /^(\+?507)\d{7,8}$/,
    "es-PY": /^(\+?595|0)9[9876]\d{7}$/,
    "es-SV": /^(\+?503)?[67]\d{7}$/,
    "es-UY": /^(\+598|0)9[1-9][\d]{6}$/,
    "es-VE": /^(\+?58)?(2|4)\d{9}$/,
    "et-EE": /^(\+?372)?\s?(5|8[1-4])\s?([0-9]\s?){6,7}$/,
    "fa-IR": /^(\+?98[\-\s]?|0)9[0-39]\d[\-\s]?\d{3}[\-\s]?\d{4}$/,
    "fi-FI": /^(\+?358|0)\s?(4[0-6]|50)\s?(\d\s?){4,8}$/,
    "fj-FJ": /^(\+?679)?\s?\d{3}\s?\d{4}$/,
    "fo-FO": /^(\+?298)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
    "fr-BF": /^(\+226|0)[67]\d{7}$/,
    "fr-BJ": /^(\+229)\d{8}$/,
    "fr-CD": /^(\+?243|0)?(8|9)\d{8}$/,
    "fr-CM": /^(\+?237)6[0-9]{8}$/,
    "fr-FR": /^(\+?33|0)[67]\d{8}$/,
    "fr-GF": /^(\+?594|0|00594)[67]\d{8}$/,
    "fr-GP": /^(\+?590|0|00590)[67]\d{8}$/,
    "fr-MQ": /^(\+?596|0|00596)[67]\d{8}$/,
    "fr-PF": /^(\+?689)?8[789]\d{6}$/,
    "fr-RE": /^(\+?262|0|00262)[67]\d{8}$/,
    "fr-WF": /^(\+681)?\d{6}$/,
    "he-IL": /^(\+972|0)([23489]|5[012345689]|77)[1-9]\d{6}$/,
    "hu-HU": /^(\+?36|06)(20|30|31|50|70)\d{7}$/,
    "id-ID": /^(\+?62|0)8(1[123456789]|2[1238]|3[1238]|5[12356789]|7[78]|9[56789]|8[123456789])([\s?|\d]{5,11})$/,
    "ir-IR": /^(\+98|0)?9\d{9}$/,
    "it-IT": /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
    "it-SM": /^((\+378)|(0549)|(\+390549)|(\+3780549))?6\d{5,9}$/,
    "ja-JP": /^(\+81[ \-]?(\(0\))?|0)[6789]0[ \-]?\d{4}[ \-]?\d{4}$/,
    "ka-GE": /^(\+?995)?(79\d{7}|5\d{8})$/,
    "kk-KZ": /^(\+?7|8)?7\d{9}$/,
    "kl-GL": /^(\+?299)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
    "ko-KR": /^((\+?82)[ \-]?)?0?1([0|1|6|7|8|9]{1})[ \-]?\d{3,4}[ \-]?\d{4}$/,
    "ky-KG": /^(\+996\s?)?(22[0-9]|50[0-9]|55[0-9]|70[0-9]|75[0-9]|77[0-9]|880|990|995|996|997|998)\s?\d{3}\s?\d{3}$/,
    "lt-LT": /^(\+370|8)\d{8}$/,
    "lv-LV": /^(\+?371)2\d{7}$/,
    "mg-MG": /^((\+?261|0)(2|3)\d)?\d{7}$/,
    "mn-MN": /^(\+|00|011)?976(77|81|88|91|94|95|96|99)\d{6}$/,
    "my-MM": /^(\+?959|09|9)(2[5-7]|3[1-2]|4[0-5]|6[6-9]|7[5-9]|9[6-9])[0-9]{7}$/,
    "ms-MY": /^(\+?60|0)1(([0145](-|\s)?\d{7,8})|([236-9](-|\s)?\d{7}))$/,
    "mz-MZ": /^(\+?258)?8[234567]\d{7}$/,
    "nb-NO": /^(\+?47)?[49]\d{7}$/,
    "ne-NP": /^(\+?977)?9[78]\d{8}$/,
    "nl-BE": /^(\+?32|0)4\d{8}$/,
    "nl-NL": /^(((\+|00)?31\(0\))|((\+|00)?31)|0)6{1}\d{8}$/,
    "nl-AW": /^(\+)?297(56|59|64|73|74|99)\d{5}$/,
    "nn-NO": /^(\+?47)?[49]\d{7}$/,
    "pl-PL": /^(\+?48)? ?([5-8]\d|45) ?\d{3} ?\d{2} ?\d{2}$/,
    "pt-BR": /^((\+?55\ ?[1-9]{2}\ ?)|(\+?55\ ?\([1-9]{2}\)\ ?)|(0[1-9]{2}\ ?)|(\([1-9]{2}\)\ ?)|([1-9]{2}\ ?))((\d{4}\-?\d{4})|(9[1-9]{1}\d{3}\-?\d{4}))$/,
    "pt-PT": /^(\+?351)?9[1236]\d{7}$/,
    "pt-AO": /^(\+244)\d{9}$/,
    "ro-MD": /^(\+?373|0)((6(0|1|2|6|7|8|9))|(7(6|7|8|9)))\d{6}$/,
    "ro-RO": /^(\+?40|0)\s?7\d{2}(\/|\s|\.|-)?\d{3}(\s|\.|-)?\d{3}$/,
    "ru-RU": /^(\+?7|8)?9\d{9}$/,
    "si-LK": /^(?:0|94|\+94)?(7(0|1|2|4|5|6|7|8)( |-)?)\d{7}$/,
    "sl-SI": /^(\+386\s?|0)(\d{1}\s?\d{3}\s?\d{2}\s?\d{2}|\d{2}\s?\d{3}\s?\d{3})$/,
    "sk-SK": /^(\+?421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
    "so-SO": /^(\+?252|0)((6[0-9])\d{7}|(7[1-9])\d{7})$/,
    "sq-AL": /^(\+355|0)6[2-9]\d{7}$/,
    "sr-RS": /^(\+3816|06)[- \d]{5,9}$/,
    "sv-SE": /^(\+?46|0)[\s\-]?7[\s\-]?[02369]([\s\-]?\d){7}$/,
    "tg-TJ": /^(\+?992)?[5][5]\d{7}$/,
    "th-TH": /^(\+66|66|0)\d{9}$/,
    "tr-TR": /^(\+?90|0)?5\d{9}$/,
    "tk-TM": /^(\+993|993|8)\d{8}$/,
    "uk-UA": /^(\+?38)?0(50|6[36-8]|7[357]|9[1-9])\d{7}$/,
    "uz-UZ": /^(\+?998)?(6[125-79]|7[1-69]|88|9\d)\d{7}$/,
    "vi-VN": /^((\+?84)|0)((3([2-9]))|(5([25689]))|(7([0|6-9]))|(8([1-9]))|(9([0-9])))([0-9]{7})$/,
    "zh-CN": /^((\+|00)86)?(1[3-9]|9[28])\d{9}$/,
    "zh-TW": /^(\+?886\-?|0)?9\d{8}$/,
    "dz-BT": /^(\+?975|0)?(17|16|77|02)\d{6}$/,
    "ar-YE": /^(((\+|00)9677|0?7)[0137]\d{7}|((\+|00)967|0)[1-7]\d{6})$/,
    "ar-EH": /^(\+?212|0)[\s\-]?(5288|5289)[\s\-]?\d{5}$/,
    "fa-AF": /^(\+93|0)?(2{1}[0-8]{1}|[3-5]{1}[0-4]{1})(\d{7})$/,
    "mk-MK": /^(\+?389|0)?((?:2[2-9]\d{6}|(?:3[1-4]|4[2-8])\d{6}|500\d{5}|5[2-9]\d{6}|7[0-9][2-9]\d{5}|8[1-9]\d{6}|800\d{5}|8009\d{4}))$/
  };
  r["en-CA"] = r["en-US"], r["fr-CA"] = r["en-CA"], r["fr-BE"] = r["nl-BE"], r["zh-HK"] = r["en-HK"], r["zh-MO"] = r["en-MO"], r["ga-IE"] = r["en-IE"], r["fr-CH"] = r["de-CH"], r["it-CH"] = r["fr-CH"];
  function n(o, a, d) {
    if ((0, e.default)(o), d && d.strictMode && !o.startsWith("+"))
      return !1;
    if (Array.isArray(a))
      return a.some(function(u) {
        if (r.hasOwnProperty(u)) {
          var c = r[u];
          if (c.test(o))
            return !0;
        }
        return !1;
      });
    if (a in r)
      return r[a].test(o);
    if (!a || a === "any") {
      for (var i in r)
        if (r.hasOwnProperty(i)) {
          var s = r[i];
          if (s.test(o))
            return !0;
        }
      return !1;
    }
    throw new Error("Invalid locale '".concat(a, "'"));
  }
  return Tn.locales = Object.keys(r), Tn;
}
var _T = /* @__PURE__ */ Rv();
const ET = /* @__PURE__ */ $e(_T);
var Tv = "isMobilePhone";
function Dv(e, t, r) {
  return typeof e == "string" && ET(e, t, r);
}
function MT(e, t, r) {
  return W({
    name: Tv,
    constraints: [e, t],
    validator: {
      validate: function(n, o) {
        return Dv(n, o == null ? void 0 : o.constraints[0], o == null ? void 0 : o.constraints[1]);
      },
      defaultMessage: K(function(n) {
        return n + "$property must be a phone number";
      }, r)
    }
  }, r);
}
var Dn = {}, F9;
function W1() {
  if (F9) return Dn;
  F9 = 1, Object.defineProperty(Dn, "__esModule", {
    value: !0
  }), Dn.CountryCodes = void 0, Dn.default = n;
  var e = t(/* @__PURE__ */ J());
  function t(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var r = /* @__PURE__ */ new Set(["AD", "AE", "AF", "AG", "AI", "AL", "AM", "AO", "AQ", "AR", "AS", "AT", "AU", "AW", "AX", "AZ", "BA", "BB", "BD", "BE", "BF", "BG", "BH", "BI", "BJ", "BL", "BM", "BN", "BO", "BQ", "BR", "BS", "BT", "BV", "BW", "BY", "BZ", "CA", "CC", "CD", "CF", "CG", "CH", "CI", "CK", "CL", "CM", "CN", "CO", "CR", "CU", "CV", "CW", "CX", "CY", "CZ", "DE", "DJ", "DK", "DM", "DO", "DZ", "EC", "EE", "EG", "EH", "ER", "ES", "ET", "FI", "FJ", "FK", "FM", "FO", "FR", "GA", "GB", "GD", "GE", "GF", "GG", "GH", "GI", "GL", "GM", "GN", "GP", "GQ", "GR", "GS", "GT", "GU", "GW", "GY", "HK", "HM", "HN", "HR", "HT", "HU", "ID", "IE", "IL", "IM", "IN", "IO", "IQ", "IR", "IS", "IT", "JE", "JM", "JO", "JP", "KE", "KG", "KH", "KI", "KM", "KN", "KP", "KR", "KW", "KY", "KZ", "LA", "LB", "LC", "LI", "LK", "LR", "LS", "LT", "LU", "LV", "LY", "MA", "MC", "MD", "ME", "MF", "MG", "MH", "MK", "ML", "MM", "MN", "MO", "MP", "MQ", "MR", "MS", "MT", "MU", "MV", "MW", "MX", "MY", "MZ", "NA", "NC", "NE", "NF", "NG", "NI", "NL", "NO", "NP", "NR", "NU", "NZ", "OM", "PA", "PE", "PF", "PG", "PH", "PK", "PL", "PM", "PN", "PR", "PS", "PT", "PW", "PY", "QA", "RE", "RO", "RS", "RU", "RW", "SA", "SB", "SC", "SD", "SE", "SG", "SH", "SI", "SJ", "SK", "SL", "SM", "SN", "SO", "SR", "SS", "ST", "SV", "SX", "SY", "SZ", "TC", "TD", "TF", "TG", "TH", "TJ", "TK", "TL", "TM", "TN", "TO", "TR", "TT", "TV", "TW", "TZ", "UA", "UG", "UM", "US", "UY", "UZ", "VA", "VC", "VE", "VG", "VI", "VN", "VU", "WF", "WS", "YE", "YT", "ZA", "ZM", "ZW"]);
  function n(o) {
    return (0, e.default)(o), r.has(o.toUpperCase());
  }
  return Dn.CountryCodes = r, Dn;
}
var CT = /* @__PURE__ */ W1();
const OT = /* @__PURE__ */ $e(CT);
var Lv = "isISO31661Alpha2";
function Fv(e) {
  return typeof e == "string" && OT(e);
}
function NT(e) {
  return W({
    name: Lv,
    validator: {
      validate: function(t, r) {
        return Fv(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be a valid ISO31661 Alpha2 code";
      }, e)
    }
  }, e);
}
var u0 = { exports: {} }, k9;
function kv() {
  return k9 || (k9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ J());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /* @__PURE__ */ new Set(["AFG", "ALA", "ALB", "DZA", "ASM", "AND", "AGO", "AIA", "ATA", "ATG", "ARG", "ARM", "ABW", "AUS", "AUT", "AZE", "BHS", "BHR", "BGD", "BRB", "BLR", "BEL", "BLZ", "BEN", "BMU", "BTN", "BOL", "BES", "BIH", "BWA", "BVT", "BRA", "IOT", "BRN", "BGR", "BFA", "BDI", "KHM", "CMR", "CAN", "CPV", "CYM", "CAF", "TCD", "CHL", "CHN", "CXR", "CCK", "COL", "COM", "COG", "COD", "COK", "CRI", "CIV", "HRV", "CUB", "CUW", "CYP", "CZE", "DNK", "DJI", "DMA", "DOM", "ECU", "EGY", "SLV", "GNQ", "ERI", "EST", "ETH", "FLK", "FRO", "FJI", "FIN", "FRA", "GUF", "PYF", "ATF", "GAB", "GMB", "GEO", "DEU", "GHA", "GIB", "GRC", "GRL", "GRD", "GLP", "GUM", "GTM", "GGY", "GIN", "GNB", "GUY", "HTI", "HMD", "VAT", "HND", "HKG", "HUN", "ISL", "IND", "IDN", "IRN", "IRQ", "IRL", "IMN", "ISR", "ITA", "JAM", "JPN", "JEY", "JOR", "KAZ", "KEN", "KIR", "PRK", "KOR", "KWT", "KGZ", "LAO", "LVA", "LBN", "LSO", "LBR", "LBY", "LIE", "LTU", "LUX", "MAC", "MKD", "MDG", "MWI", "MYS", "MDV", "MLI", "MLT", "MHL", "MTQ", "MRT", "MUS", "MYT", "MEX", "FSM", "MDA", "MCO", "MNG", "MNE", "MSR", "MAR", "MOZ", "MMR", "NAM", "NRU", "NPL", "NLD", "NCL", "NZL", "NIC", "NER", "NGA", "NIU", "NFK", "MNP", "NOR", "OMN", "PAK", "PLW", "PSE", "PAN", "PNG", "PRY", "PER", "PHL", "PCN", "POL", "PRT", "PRI", "QAT", "REU", "ROU", "RUS", "RWA", "BLM", "SHN", "KNA", "LCA", "MAF", "SPM", "VCT", "WSM", "SMR", "STP", "SAU", "SEN", "SRB", "SYC", "SLE", "SGP", "SXM", "SVK", "SVN", "SLB", "SOM", "ZAF", "SGS", "SSD", "ESP", "LKA", "SDN", "SUR", "SJM", "SWZ", "SWE", "CHE", "SYR", "TWN", "TJK", "TZA", "THA", "TLS", "TGO", "TKL", "TON", "TTO", "TUN", "TUR", "TKM", "TCA", "TUV", "UGA", "UKR", "ARE", "GBR", "USA", "UMI", "URY", "UZB", "VUT", "VEN", "VNM", "VGB", "VIR", "WLF", "ESH", "YEM", "ZMB", "ZWE"]);
    function a(d) {
      return (0, r.default)(d), o.has(d.toUpperCase());
    }
    e.exports = t.default, e.exports.default = t.default;
  }(u0, u0.exports)), u0.exports;
}
var IT = /* @__PURE__ */ kv();
const PT = /* @__PURE__ */ $e(IT);
var jv = "isISO31661Alpha3";
function Bv(e) {
  return typeof e == "string" && PT(e);
}
function RT(e) {
  return W({
    name: jv,
    validator: {
      validate: function(t, r) {
        return Bv(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be a valid ISO31661 Alpha3 code";
      }, e)
    }
  }, e);
}
var l0 = { exports: {} }, j9;
function Zv() {
  return j9 || (j9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = o(/* @__PURE__ */ J()), n = o(/* @__PURE__ */ V1());
    function o(d) {
      return d && d.__esModule ? d : { default: d };
    }
    function a(d) {
      return (0, r.default)(d), (0, n.default)(d) && d.length === 24;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(l0, l0.exports)), l0.exports;
}
var TT = /* @__PURE__ */ Zv();
const DT = /* @__PURE__ */ $e(TT);
var Uv = "isMongoId";
function Gv(e) {
  return typeof e == "string" && DT(e);
}
function LT(e) {
  return W({
    name: Uv,
    validator: {
      validate: function(t, r) {
        return Gv(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be a mongodb id";
      }, e)
    }
  }, e);
}
var c0 = { exports: {} }, B9;
function Vv() {
  return B9 || (B9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ J());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /[^\x00-\x7F]/;
    function a(d) {
      return (0, r.default)(d), o.test(d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(c0, c0.exports)), c0.exports;
}
var FT = /* @__PURE__ */ Vv();
const kT = /* @__PURE__ */ $e(FT);
var Hv = "isMultibyte";
function Kv(e) {
  return typeof e == "string" && kT(e);
}
function jT(e) {
  return W({
    name: Hv,
    validator: {
      validate: function(t, r) {
        return Kv(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must contain one or more multibyte chars";
      }, e)
    }
  }, e);
}
var f0 = { exports: {} }, Z9;
function Wv() {
  return Z9 || (Z9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ J());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;
    function a(d) {
      return (0, r.default)(d), o.test(d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(f0, f0.exports)), f0.exports;
}
var BT = /* @__PURE__ */ Wv();
const ZT = /* @__PURE__ */ $e(BT);
var zv = "isSurrogatePair";
function Yv(e) {
  return typeof e == "string" && ZT(e);
}
function UT(e) {
  return W({
    name: zv,
    validator: {
      validate: function(t, r) {
        return Yv(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must contain any surrogate pairs chars";
      }, e)
    }
  }, e);
}
var p0 = { exports: {} }, U9;
function Xv() {
  return U9 || (U9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = $;
    var r = i(/* @__PURE__ */ J()), n = i(/* @__PURE__ */ H$()), o = i(/* @__PURE__ */ di()), a = i(/* @__PURE__ */ Na()), d = i(/* @__PURE__ */ $t());
    function i(v) {
      return v && v.__esModule ? v : { default: v };
    }
    function s(v, y) {
      return h(v) || p(v, y) || c(v, y) || u();
    }
    function u() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function c(v, y) {
      if (v) {
        if (typeof v == "string") return l(v, y);
        var S = {}.toString.call(v).slice(8, -1);
        return S === "Object" && v.constructor && (S = v.constructor.name), S === "Map" || S === "Set" ? Array.from(v) : S === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(S) ? l(v, y) : void 0;
      }
    }
    function l(v, y) {
      (y == null || y > v.length) && (y = v.length);
      for (var S = 0, w = Array(y); S < y; S++) w[S] = v[S];
      return w;
    }
    function p(v, y) {
      var S = v == null ? null : typeof Symbol < "u" && v[Symbol.iterator] || v["@@iterator"];
      if (S != null) {
        var w, _, I, N, O = [], E = !0, C = !1;
        try {
          if (I = (S = S.call(v)).next, y !== 0) for (; !(E = (w = I.call(S)).done) && (O.push(w.value), O.length !== y); E = !0) ;
        } catch (P) {
          C = !0, _ = P;
        } finally {
          try {
            if (!E && S.return != null && (N = S.return(), Object(N) !== N)) return;
          } finally {
            if (C) throw _;
          }
        }
        return O;
      }
    }
    function h(v) {
      if (Array.isArray(v)) return v;
    }
    var m = {
      protocols: ["http", "https", "ftp"],
      require_tld: !0,
      require_protocol: !1,
      require_host: !0,
      require_port: !1,
      require_valid_protocol: !0,
      allow_underscores: !1,
      allow_trailing_dot: !1,
      allow_protocol_relative_urls: !1,
      allow_fragments: !0,
      allow_query_components: !0,
      validate_length: !0,
      max_allowed_length: 2084
    }, f = /^\[([^\]]+)\](?::([0-9]+))?$/;
    function $(v, y) {
      if ((0, r.default)(v), !v || /[\s<>]/.test(v) || v.indexOf("mailto:") === 0 || (y = (0, d.default)(y, m), y.validate_length && v.length > y.max_allowed_length) || !y.allow_fragments && v.includes("#") || !y.allow_query_components && (v.includes("?") || v.includes("&")))
        return !1;
      var S, w, _, I, N, O, E, C;
      if (E = v.split("#"), v = E.shift(), E = v.split("?"), v = E.shift(), E = v.split("://"), E.length > 1) {
        if (S = E.shift().toLowerCase(), y.require_valid_protocol && y.protocols.indexOf(S) === -1)
          return !1;
      } else {
        if (y.require_protocol)
          return !1;
        if (v.slice(0, 2) === "//") {
          if (!y.allow_protocol_relative_urls)
            return !1;
          E[0] = v.slice(2);
        }
      }
      if (v = E.join("://"), v === "")
        return !1;
      if (E = v.split("/"), v = E.shift(), v === "" && !y.require_host)
        return !0;
      if (E = v.split("@"), E.length > 1) {
        if (y.disallow_auth || E[0] === "" || (w = E.shift(), w.indexOf(":") >= 0 && w.split(":").length > 2))
          return !1;
        var P = w.split(":"), T = s(P, 2), j = T[0], F = T[1];
        if (j === "" && F === "")
          return !1;
      }
      I = E.join("@"), O = null, C = null;
      var Z = I.match(f);
      if (Z ? (_ = "", C = Z[1], O = Z[2] || null) : (E = I.split(":"), _ = E.shift(), E.length && (O = E.join(":"))), O !== null && O.length > 0) {
        if (N = parseInt(O, 10), !/^[0-9]+$/.test(O) || N <= 0 || N > 65535)
          return !1;
      } else if (y.require_port)
        return !1;
      return y.host_whitelist ? (0, n.default)(_, y.host_whitelist) : _ === "" && !y.require_host ? !0 : !(!(0, a.default)(_) && !(0, o.default)(_, y) && (!C || !(0, a.default)(C, 6)) || (_ = _ || C, y.host_blacklist && (0, n.default)(_, y.host_blacklist)));
    }
    e.exports = t.default, e.exports.default = t.default;
  }(p0, p0.exports)), p0.exports;
}
var GT = /* @__PURE__ */ Xv();
const VT = /* @__PURE__ */ $e(GT);
var qv = "isUrl";
function Jv(e, t) {
  return typeof e == "string" && VT(e, t);
}
function HT(e, t) {
  return W({
    name: qv,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Jv(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must be a URL address";
      }, t)
    }
  }, t);
}
var $0 = { exports: {} }, G9;
function Qv() {
  return G9 || (G9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ J());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = {
      1: /^[0-9A-F]{8}-[0-9A-F]{4}-1[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      2: /^[0-9A-F]{8}-[0-9A-F]{4}-2[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      6: /^[0-9A-F]{8}-[0-9A-F]{4}-6[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      7: /^[0-9A-F]{8}-[0-9A-F]{4}-7[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      8: /^[0-9A-F]{8}-[0-9A-F]{4}-8[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      nil: /^00000000-0000-0000-0000-000000000000$/i,
      max: /^ffffffff-ffff-ffff-ffff-ffffffffffff$/i,
      // From https://github.com/uuidjs/uuid/blob/main/src/regex.js
      all: /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i
    };
    function a(d, i) {
      return (0, r.default)(d), i == null && (i = "all"), i in o ? o[i].test(d) : !1;
    }
    e.exports = t.default, e.exports.default = t.default;
  }($0, $0.exports)), $0.exports;
}
var KT = /* @__PURE__ */ Qv();
const WT = /* @__PURE__ */ $e(KT);
var em = "isUuid";
function tm(e, t) {
  return typeof e == "string" && WT(e, t);
}
function zT(e, t) {
  return W({
    name: em,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return tm(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must be a UUID";
      }, t)
    }
  }, t);
}
var rm = "IsFirebasePushId";
function nm(e) {
  var t = /^[a-zA-Z0-9_-]*$/;
  return typeof e == "string" && e.length === 20 && t.test(e);
}
function YT(e) {
  return W({
    name: rm,
    validator: {
      validate: function(t, r) {
        return nm(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be a Firebase Push Id";
      }, e)
    }
  }, e);
}
var v0 = { exports: {} }, V9;
function om() {
  return V9 || (V9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ J());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a) {
      return (0, r.default)(a), a === a.toUpperCase();
    }
    e.exports = t.default, e.exports.default = t.default;
  }(v0, v0.exports)), v0.exports;
}
var XT = /* @__PURE__ */ om();
const qT = /* @__PURE__ */ $e(XT);
var am = "isUppercase";
function dm(e) {
  return typeof e == "string" && qT(e);
}
function JT(e) {
  return W({
    name: am,
    validator: {
      validate: function(t, r) {
        return dm(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be uppercase";
      }, e)
    }
  }, e);
}
var m0 = { exports: {} }, H9;
function im() {
  return H9 || (H9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ J());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    function o(d) {
      "@babel/helpers - typeof";
      return o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
        return typeof i;
      } : function(i) {
        return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
      }, o(d);
    }
    function a(d, i) {
      (0, r.default)(d);
      var s, u;
      o(i) === "object" ? (s = i.min || 0, u = i.max) : (s = arguments[1] || 0, u = arguments[2]);
      var c = d.match(/(\uFE0F|\uFE0E)/g) || [], l = d.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [], p = d.length - c.length - l.length, h = p >= s && (typeof u > "u" || p <= u);
      return h && Array.isArray(i == null ? void 0 : i.discreteLengths) ? i.discreteLengths.some(function(m) {
        return m === p;
      }) : h;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(m0, m0.exports)), m0.exports;
}
var QT = /* @__PURE__ */ im();
const z1 = /* @__PURE__ */ $e(QT);
var sm = "isLength";
function um(e, t, r) {
  return typeof e == "string" && z1(e, { min: t, max: r });
}
function eD(e, t, r) {
  return W({
    name: sm,
    constraints: [e, t],
    validator: {
      validate: function(n, o) {
        return um(n, o == null ? void 0 : o.constraints[0], o == null ? void 0 : o.constraints[1]);
      },
      defaultMessage: K(function(n, o) {
        var a = (o == null ? void 0 : o.constraints[0]) !== null && (o == null ? void 0 : o.constraints[0]) !== void 0, d = (o == null ? void 0 : o.constraints[1]) !== null && (o == null ? void 0 : o.constraints[1]) !== void 0;
        return a && (!o.value || o.value.length < (o == null ? void 0 : o.constraints[0])) ? n + "$property must be longer than or equal to $constraint1 characters" : d && o.value.length > (o == null ? void 0 : o.constraints[1]) ? n + "$property must be shorter than or equal to $constraint2 characters" : n + "$property must be longer than or equal to $constraint1 and shorter than or equal to $constraint2 characters";
      }, r)
    }
  }, r);
}
var lm = "maxLength";
function cm(e, t) {
  return typeof e == "string" && z1(e, { min: 0, max: t });
}
function tD(e, t) {
  return W({
    name: lm,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return cm(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must be shorter than or equal to $constraint1 characters";
      }, t)
    }
  }, t);
}
var fm = "minLength";
function pm(e, t) {
  return typeof e == "string" && z1(e, { min: t });
}
function rD(e, t) {
  return W({
    name: fm,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return pm(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must be longer than or equal to $constraint1 characters";
      }, t)
    }
  }, t);
}
var h0 = { exports: {} }, K9;
function $m() {
  return K9 || (K9 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ J());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a, d, i) {
      return (0, r.default)(a), Object.prototype.toString.call(d) !== "[object RegExp]" && (d = new RegExp(d, i)), !!a.match(d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(h0, h0.exports)), h0.exports;
}
var nD = /* @__PURE__ */ $m();
const vm = /* @__PURE__ */ $e(nD);
var mm = "matches";
function hm(e, t, r) {
  return typeof e == "string" && vm(e, t, r);
}
function oD(e, t, r) {
  var n;
  return t && t instanceof Object && !r ? r = t : n = t, W({
    name: mm,
    constraints: [e, n],
    validator: {
      validate: function(o, a) {
        return hm(o, a == null ? void 0 : a.constraints[0], a == null ? void 0 : a.constraints[1]);
      },
      defaultMessage: K(function(o, a) {
        return o + "$property must match $constraint1 regular expression";
      }, r)
    }
  }, r);
}
const aD = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6], 0, 0, 0, 0, 0, 0, 0, [["6[2-467]\\d{3}", [5]], ["4\\d{4}", [5]], 0, 0, 0, 0, ["(?:0[1-9]|[1589]\\d)\\d{4}", [6]]]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [["[78]\\d{5}", [6]], ["690\\d{6}|[356]\\d{5}", [6, 9]], ["180[02]\\d{4}", [8]], ["[19]\\d{5}", [6]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[2-4679][2-8]\\d{6}", [8]], ["5[024-68]\\d{7}", [9]], ["400\\d{6}|800\\d{2,9}"], ["900[02]\\d{5}", [9]], 0, 0, ["600[25]\\d{5}", [9]], 0, 0, ["700[05]\\d{5}", [9]]]], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}"], ["7\\d{8}"]]], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268", [["268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}"], ["268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, ["26840[69]\\d{4}"], ["26848[01]\\d{4}"]]], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264", [["264(?:292|4(?:6[12]|9[78]))\\d{4}"], ["264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, ["264724\\d{4}"]]], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}", [8]], ["6(?:[78][2-9]|9\\d)\\d{6}", [9]], ["800\\d{4}", [7]], ["900[1-9]\\d\\d", [6]], ["700[2-9]\\d{4}", [8]], 0, 0, 0, 0, ["808[1-9]\\d\\d", [6]]]], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}"], ["(?:33|4[1349]|55|77|88|9[13-9])\\d{6}"], ["800\\d{5}"], ["90[016]\\d{5}"], 0, 0, 0, 0, ["60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[0-2])\\d{4}"], ["80[1-4]\\d{5}"]]], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]], 0, 0, 0, 0, 0, 0, [["2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}"], ["9[1-79]\\d{7}"]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1", 0, 0, [["3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:657|9(?:54|66))|3(?:48[27]|7(?:55|77)|8(?:65|78)))[2-8]\\d{5}|(?:2(?:284|3(?:02|23)|477|622|920)|3(?:4(?:46|89|92)|541))[2-7]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[25][4-6]|3[3-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|1[2-7]|3[4-6]|5[3-6]|7[2-6]|8[3-68])))\\d{6}|(?:2(?:2(?:62|81)|320|9(?:42|83))|3(?:329|4(?:62|7[16])|5(?:43|64)|7(?:18|5[17])))[2-6]\\d{5}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|64)|5(?:25|37|4[47]|71)|7(?:35|72)|825))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[035-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[3-5]|8[26])|8(?:2[67]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}", [10]], ["93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:657|9(?:54|66))|3(?:48[27]|7(?:55|77)|8(?:65|78)))[2-8]\\d{5}|9(?:2(?:284|3(?:02|23)|477|622|920)|3(?:4(?:46|89|92)|541))[2-7]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[25][4-6]|3[3-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|1[2-7]|3[4-6]|5[3-6]|7[2-6]|8[3-68]))))\\d{6}|9(?:2(?:2(?:62|81)|320|9(?:42|83))|3(?:329|4(?:62|7[16])|5(?:43|64)|7(?:18|5[17])))[2-6]\\d{5}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|64)|5(?:25|37|4[47]|71)|7(?:35|72)|825))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[035-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[3-5]|8[26])|8(?:2[67]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}"], ["800\\d{7,8}"], ["60[04579]\\d{7}", [10]], 0, 0, ["810\\d{7}", [10]]]], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684", [["6846(?:22|33|44|55|77|88|9[19])\\d{4}"], ["684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]", "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1(?:11\\d|[2-9]\\d{3,11})|(?:316|463)\\d{3,10}|648[34]\\d{3,9}|(?:51|66|73)2\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-7]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}"], ["6(?:485|(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d)\\d{3,9}", [7, 8, 9, 10, 11, 12, 13]], ["800\\d{6,10}", [9, 10, 11, 12, 13]], ["(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}", [9, 10, 11, 12, 13]], 0, 0, 0, 0, ["5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}", [5, 6, 7, 8, 9, 10, 11, 12, 13]], ["8(?:10|2[018])\\d{6,10}|828\\d{5}", [8, 9, 10, 11, 12, 13]]]], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]], 0, 0, 0, 0, 0, 0, [["5(?:2\\d|8[1-9])\\d{4}"], ["(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}"], ["800\\d{4}"], ["900\\d{4}"], 0, 0, 0, 0, ["(?:28\\d|501)\\d{4}"]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", [["18[1-8]\\d{3,6}", [6, 7, 8, 9]], ["4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", [6, 7, 8, 9, 10]], ["800\\d{4,6}", [7, 8, 9]], ["[67]00\\d{5,6}", [8, 9]], 0, 0, ["20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}"]], "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}"], ["36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}"], ["88\\d{7}"], ["900200\\d{3}"]]], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}", [8]], ["6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}"], ["8[08]\\d{6}", [8]], ["9[0246]\\d{6}", [8]], 0, 0, ["703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}", [8]], 0, 0, ["8[12]\\d{6}", [8]]]], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246", [["246521[0369]\\d{3}|246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}"], ["246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["(?:246976|900[2-9]\\d\\d)\\d{4}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, ["246(?:292|367|4(?:1[7-9]|3[01]|4[47-9]|67)|7(?:1[2-9]|2\\d|3[016]|53))\\d{4}"], 0, ["24631\\d{5}"]]], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:[23]\\d|[45])\\d\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}"], ["(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}", [10]], ["80[03]\\d{7}", [10]], 0, 0, 0, 0, 0, ["96(?:0[469]|1[0-47]|3[389]|43|6[69]|7[78])\\d{6}", [10]]]], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0", 0, 0, 0, 0, 0, [["80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}", [8]], ["4[5-9]\\d{7}", [9]], ["800[1-9]\\d{4}", [8]], ["(?:70(?:2[0-57]|3[04-7]|44|6[04-69]|7[0579])|90\\d\\d)\\d{4}", [8]], 0, 0, ["78(?:0[578]|1[014-8]|2[25]|3[15-8]|48|5[05]|60|7[06-8]|9\\d)\\d{4}", [8]], 0, 0, ["7879\\d{4}", [8]]]], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]], 0, 0, 0, 0, 0, 0, [["2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}"], ["(?:0[1-7]|5[0-8]|[67]\\d)\\d{6}"]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}", [6, 7, 8]], ["(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}", [8, 9]], ["(?:00800\\d\\d|800)\\d{5}", [8, 12]], ["90\\d{6}", [8]], 0, 0, 0, 0, 0, ["700\\d{5}", [8]]]], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]], 0, 0, 0, 0, 0, 0, [["(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|55|7[7-9]|88)|9[69][69])|7(?:[07]\\d\\d|1(?:11|78)))\\d{4}"], ["(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-689])))\\d{4}"], ["8[02369]\\d{6}"], ["(?:87|9[0-8])\\d{6}"], 0, 0, 0, 0, 0, ["84\\d{6}"]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]], 0, 0, 0, 0, 0, 0, [["(?:22|31)\\d{6}"], ["(?:29|[67][125-9])\\d{6}"]]], BJ: ["229", "00", "(?:01\\d|[24-689])\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]], 0, 0, 0, 0, 0, 0, [["2090\\d{4}|(?:012\\d\\d|2(?:02|1[037]|2[45]|3[68]|4\\d))\\d{5}"], ["(?:01(?:2[5-9]|[4-69]\\d)|4[0-8]|[56]\\d|9[013-9])\\d{6}"], 0, 0, 0, 0, ["81\\d{6}", [8]], 0, ["857[58]\\d{4}", [8]]]], BL: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441", [["441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}"], ["441(?:[2378]\\d|5[0-39]|9[02])\\d{5}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]], 0, 0, 0, 0, 0, 0, [["22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}"], ["(?:22[89]|[78]\\d\\d)\\d{4}"], 0, 0, 0, 0, 0, 0, ["5[34]\\d{5}"]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?", 0, 0, 0, [["(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}", [8]], ["[67]\\d{7}", [8]], ["8001[07]\\d{4}", [9]], 0, 0, 0, 0, 0, ["50\\d{6}", [8]]]], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]", [["(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}"], ["(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}"]]], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2", 0, 0, [["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}", [10]], ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}", [10, 11]], ["800\\d{6,7}", [9, 10]], ["300\\d{6}|[59]00\\d{6,7}", [9, 10]], 0, 0, 0, 0, 0, ["(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370))\\d{4}|300\\d{5}", [8, 10]]]], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242", [["242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-5]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}"], ["242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|3[0-4]|[89]9))\\d{4}"], ["242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, ["242225\\d{4}"]]], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], 0, 0, 0, 0, 0, 0, [["(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}", [7]], ["(?:1[67]|77)\\d{6}", [8]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013]|81)|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[013467]))\\d{4}", [7]], ["(?:321|7[1-8]\\d)\\d{5}", [8]], ["(?:0800|800\\d)\\d{6}", [10]], ["90\\d{5}", [7]], 0, 0, 0, 0, ["79(?:1(?:[0-2]\\d|3[0-3])|2[0-7]\\d)\\d{3}", [8]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, [["(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}", [9]], ["(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}", [9]], ["800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}"], ["(?:810|902)\\d{7}", [10]], 0, 0, 0, 0, ["249\\d{6}", [9]]], "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}", [7]], ["6[0-35-7]\\d{5}", [7]], ["0800\\d{7}", [11]]]], CA: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:12|573)\\d\\d|276)\\d{5}|[1-6]\\d{6}"], ["88\\d{5}|(?:8[0-69]|9[017-9])\\d{7}", [7, 9]]]], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]], 0, 0, 0, 0, 0, 0, [["2[12]\\d{6}"], ["7[024-7]\\d{6}"], 0, ["8776\\d{4}"]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]], 0, 0, 0, 0, 0, 0, [["222[1-589]\\d{5}"], ["026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}"], 0, ["80[0-2]\\d{6}"]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}", [9]], ["(?:6[89]|7[235-9])\\d{7}", [9]], ["800\\d{6}", [9]], ["90[016]\\d{6}", [9]], ["878\\d{6}", [9]], ["860\\d{9}", [12]], ["5[18]\\d{7}", [9]], ["74[0248]\\d{6}", [9]], 0, ["84[0248]\\d{6}", [9]]]], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]], 0, 0, 0, 0, 0, 0, [["2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|2[245]|3[45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}"], ["0[157]\\d{8}"]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[13-7]|4[1-5])\\d{3}"], ["[578]\\d{4}"]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], 0, 0, 0, 0, 0, 0, [["2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}", [9]], ["", [9]], ["(?:123|8)00\\d{6}", [9, 11]], 0, 0, 0, 0, 0, ["44\\d{7}", [9]], ["600\\d{7,8}", [10, 11]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]], 0, 0, 0, 0, 0, 0, [["2(?:22|33)\\d{6}", [9]], ["(?:24[23]|6(?:[25-9]\\d|40))\\d{6}", [9]], ["88\\d{6,7}"]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, [["(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|2(?:[02-57-9]\\d{3}|1(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))|(?:41[03]|8078|9(?:78|94))\\d\\d)\\d{5}|(?:10|2[0-57-9])(?:1(?:00|23)\\d\\d|95\\d{3,4})|(?:41[03]|9(?:78|94))(?:100\\d\\d|95\\d{3,4})|8078123|(?:43[35]|754|851)\\d{7,8}|(?:43[35]|754|851)(?:1(?:00\\d|23)\\d|95\\d{3,4})|(?:3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[13-9]\\d{6}|2(?:[0-24-9]\\d{5}|3\\d(?:\\d{4})?))|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[24-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[13-9]\\d{5}|2(?:[0-24-9]\\d{4}|3\\d(?:\\d{3})?))|9(?:[0-46-9]\\d{5}|5\\d{3,5}))", [7, 8, 9, 10, 11]], ["1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}", [11]], ["(?:(?:10|21)8|8)00\\d{7}", [10, 12]], ["16[08]\\d{5}", [8]], 0, 0, 0, 0, 0, ["10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}", [7, 8, 9, 10, 11]]], "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?", 0, 0, 0, [["601055(?:[0-4]\\d|50)\\d\\d|6010(?:[0-4]\\d|5[0-4])\\d{4}|(?:46|60(?:[124-7][2-9]|8[1-9]))\\d{6}", [8, 10]], ["333301[0-5]\\d{3}|3333(?:00|2[5-9]|[3-9]\\d)\\d{4}|(?:3(?:24[1-9]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}", [10]], ["1800\\d{7}", [11]], ["(?:19(?:0[01]|4[78])|901)\\d{7}", [10, 11]]]], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))", 0, 0, 0, [["210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}", [8]], ["(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}", [8]], ["800\\d{7}", [10]], ["90[059]\\d{7}", [10]], 0, 0, 0, 0, ["(?:210[0-6]|4\\d{3}|5100)\\d{4}", [8]]]], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3[23]|4[89])\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}"], ["(?:5\\d|6[2-4])\\d{6}", [8]], ["800\\d{7}", [10]], 0, 0, 0, 0, 0, 0, ["807\\d{7}", [10]]]], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}"], ["(?:36|5[1-389]|9\\d)\\d{5}"], ["800\\d{4}"], 0, 0, 0, 0, 0, ["(?:3[3-5]|4[356])\\d{5}"]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]", [["9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}"], ["953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}"], 0, 0, 0, 0, 0, ["955\\d{5}", [8]], 0, ["60[0-2]\\d{4}", [7]]]], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]], 0, 0, 0, 0, 0, 0, [["2[2-6]\\d{6}"], ["9(?:10|[4-79]\\d)\\d{5}"], ["800\\d{5}"], ["90[09]\\d{5}"], ["700\\d{5}"], 0, ["(?:50|77)\\d{6}"], 0, 0, ["80[1-9]\\d{5}"]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}", [9]], ["(?:60[1-8]\\d|7(?:0(?:[2-5]\\d|60)|19[0-2]|[2379]\\d\\d))\\d{5}", [9]], ["800\\d{6}", [9]], ["9(?:0[05689]|76)\\d{6}", [9]], ["70[01]\\d{6}", [9]], ["9(?:3\\d{9}|6\\d{7,10})"], ["9(?:5\\d|7[2-4])\\d{6}", [9]], 0, ["9[17]0\\d{6}", [9]], ["8[134]\\d{7}", [9]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0", 0, 0, 0, 0, 0, [["32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}", [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]], ["1(?:(?:5(?:[0-25-9]\\d\\d|310)|76\\d\\d)\\d{6}|6[023]\\d{7,8})|17\\d{8}", [10, 11]], ["800\\d{7,12}", [10, 11, 12, 13, 14, 15]], ["(?:137[7-9]|900(?:[135]|9\\d))\\d{6}", [10, 11]], ["700\\d{8}", [11]], ["1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}", [12, 13]], ["18(?:1\\d{5,11}|[2-9]\\d{8})", [8, 9, 10, 11, 12, 13, 14]], ["16(?:4\\d{1,10}|[89]\\d{1,11})", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]], 0, ["180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}", [7, 8, 9, 10, 11, 12, 13, 14]]]], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]], 0, 0, 0, 0, 0, 0, [["2(?:1[2-5]|7[45])\\d{5}"], ["77\\d{6}"]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[0-59][1-9]|[6-8]\\d)|3(?:[0-3][1-9]|4[13]|5[1-58]|6[1347-9]|7\\d|8[1-8]|9[1-79])|4(?:[0-25][1-9]|[34][2-9]|6[13-579]|7[13579]|8[1-47]|9[127])|5(?:[0-36][1-9]|4[146-9]|5[3-57-9]|7[568]|8[1-358]|9[1-69])|6(?:[0135][1-9]|2[1-68]|4[2-8]|6[1689]|[78]\\d|9[15689])|7(?:[0-69][1-9]|7[3-9]|8[147])|8(?:[16-9][1-9]|2[1-58])|9(?:[1-47-9][1-9]|6\\d))\\d{5}"], ["(?:2[6-8]|37|6[78]|96)\\d{6}|(?:2[0-59]|3[0-689]|[457]\\d|6[0-69]|8[126-9]|9[1-47-9])[1-9]\\d{5}"], ["80\\d{6}"], ["90\\d{6}"]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767", [["767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}"], ["767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9", [["8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}"], ["8[024]9[2-9]\\d{6}"], ["8(?:00(?:14|[2-9]\\d)|(?:33|44|55|66|77|88)[2-9]\\d)\\d{5}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[013-689])\\d{6}"], ["(?:5(?:4[0-29]|5\\d|6[0-3])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}", [9]], ["800\\d{6}", [9]], ["80[3-689]1\\d{5}", [9]], 0, 0, 0, 0, ["98[23]\\d{6}", [9]], ["80[12]1\\d{5}", [9]]]], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["[2-7][2-7]\\d{6}", [8]], ["964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}", [9]], ["1800\\d{7}|1[78]00\\d{6}", [10, 11]], 0, 0, 0, 0, 0, ["[2-7]890\\d{4}", [8]]]], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}", [7]], ["(?:5\\d{5}|8(?:1(?:0(?:0(?:00|[178]\\d)|[3-9]\\d\\d)|(?:1(?:0[2-6]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:0(?:00|4\\d)|(?:19|[2-7]\\d)\\d)|(?:(?:[124-69]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}", [7, 8]], ["800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}"], ["(?:40\\d\\d|900)\\d{4}", [7, 8]], ["70[0-2]\\d{5}", [8]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2\\d|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}", [8, 9]], ["1[0-25]\\d{8}", [10]], ["800\\d{7}", [10]], ["900\\d{7}", [10]]]], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]", [["528[89]\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-5]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}"], ["(?:17[1-3]|7\\d\\d)\\d{4}"]]], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]], 0, 0, 0, 0, 0, 0, [["96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}"], ["(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}"], ["[89]00\\d{6}"], ["80[367]\\d{6}"], ["70\\d{7}"], 0, ["51\\d{7}"], 0, 0, ["90[12]\\d{6}"]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8]|7\\d)|5(?:1[578]|44|5[0-4])|6(?:1[578]|2[69]|39|4[5-7]|5[0-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}"], ["700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|22|77|86|99)|9\\d\\d)\\d{6}"]]], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", [["1[3-7][1-8]\\d{3,6}|(?:19[1-8]|[23568][1-8]\\d|9(?:00|[1-8]\\d))\\d{2,6}", [5, 6, 7, 8, 9]], ["4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", [6, 7, 8, 9, 10]], ["800\\d{4,6}", [7, 8, 9]], ["[67]00\\d{5,6}", [8, 9]], 0, 0, ["20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}"]], "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, [["603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}", [7]], ["(?:[279]\\d|45|5[01568]|8[034679])\\d{5}", [7]], ["0800\\d{7}", [11]]], "00"], FK: ["500", "00", "[2-7]\\d{4}", [5], 0, 0, 0, 0, 0, 0, 0, [["[2-47]\\d{4}"], ["[56]\\d{4}"]]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]], 0, 0, 0, 0, 0, 0, [["31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}"], ["31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}"]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))", 0, 0, 0, [["(?:20|[34]\\d|8[19])\\d{4}"], ["(?:[27][1-9]|5\\d|9[16])\\d{4}"], ["80[257-9]\\d{3}"], ["90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d"], 0, 0, 0, 0, ["(?:6[0-36]|88)\\d{4}"]]], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:26[013-9]|59[1-35-9])\\d{6}|(?:[13]\\d|2[0-57-9]|4[1-9]|5[0-8])\\d{7}"], ["(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}"], ["80[0-5]\\d{6}"], ["836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}"], 0, 0, ["80[6-9]\\d{6}"], 0, ["9\\d{8}"], ["8(?:1[01]|2[0156]|4[024]|84)\\d{6}"]]], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1", 0, 0, [["[01]1\\d{6}", [8]], ["(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}"]]], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473", [["473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-4]|5[59]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}"], ["473(?:4(?:0[2-79]|1[04-9]|2[0-5]|49|5[6-8])|5(?:2[01]|3[3-8])|901)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}"], ["5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|5(?:0(?:0[17]0|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}|(?:5(?:0(?:0(?:0\\d|11|22|3[0-6]|44|5[05]|77|88|9[09])|(?:[14]\\d|77)\\d|22[02])|1(?:1(?:[03][01]|[124]\\d|5[2-6]|7[0-4])|4\\d\\d)|[23]555|4(?:4\\d\\d|555)|5(?:[0157-9]\\d\\d|200|333|444)|6[89]\\d\\d|7(?:[0147-9]\\d\\d|5(?:00|[57]5))|8(?:0(?:[018]\\d|2[0-4])|5(?:55|8[89])|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}"], ["800\\d{6}"], 0, 0, 0, 0, 0, ["70[67]\\d{6}"]]], GF: ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["594(?:[02-49]\\d|1[0-5]|5[6-9]|6[0-3]|80)\\d{4}"], ["(?:694(?:[0-249]\\d|3[0-8])|7093[0-3])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:396|76\\d)\\d|476[0-6])\\d{4}"]]], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}", [9]], ["(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}", [9]], ["800\\d{5}", [8]]]], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]], 0, 0, 0, 0, 0, 0, [["2190[0-2]\\d{3}|2(?:0(?:[02]\\d|3[01])|16[24-9]|2[2-5]\\d)\\d{4}"], ["5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}"]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:19|3[1-7]|[68][1-9]|70|9\\d)\\d{4}"], ["[245]\\d{5}"], ["80\\d{4}"], 0, 0, 0, 0, 0, ["3[89]\\d{4}"]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}"], ["(?:[23679]\\d|4[015]|5[0-489])\\d{5}"]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]], 0, 0, 0, 0, 0, 0, [["3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}", [8]], ["6[0-356]\\d{7}", [9]], 0, 0, 0, 0, 0, 0, ["722\\d{6}", [9]]]], GP: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}"], ["(?:222|55\\d)\\d{6}"], ["80\\d[1-9]\\d{5}"], ["90\\d[1-9]\\d{5}"]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}", [10]], ["68[57-9]\\d{7}|(?:69|94)\\d{8}", [10]], ["800\\d{7,9}"], ["90[19]\\d{7}", [10]], ["70\\d{8}", [10]], 0, ["5005000\\d{3}", [10]], 0, 0, ["8(?:0[16]|12|[27]5|50)\\d{7}", [10]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [["[267][2-9]\\d{6}", [8]], ["(?:[3-5]\\d\\d|80[0-4])\\d{5}", [8]], ["18[01]\\d{8}", [11]], ["19\\d{9}", [11]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671", [["671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[478])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]], 0, 0, 0, 0, 0, 0, [["443\\d{6}", [9]], ["9(?:5\\d|6[569]|77)\\d{6}", [9]], 0, 0, 0, 0, 0, 0, ["40\\d{5}", [7]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|50[0-6]|77[1-57])\\d{4}"], ["(?:510|6\\d\\d|7(?:[0-5]\\d|6[01]))\\d{4}"], ["(?:289|8(?:00|6[28]|88|99))\\d{4}"], ["9008\\d{3}"], 0, 0, 0, 0, ["515\\d{4}"]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:4[0-8]|[579]\\d|6[0-2]))|58(?:0[1-9]|1[2-9]))\\d{4}", [8]], ["(?:4(?:44[0-35-9]|6(?:1[0-79]|4[0-57-9]|6[0-4])|7(?:[26][0-5]|4[0-28]))|5(?:73[0-6]|95[0-8])|6(?:26[013-8]|66[0-3]|78[0-5])|70(?:7[1-8]|8[0-4])|84(?:4[0-2]|8[0-35-9])|9(?:29[013-9]|39[014-9]|59[0-4]|899))\\d{4}|(?:4(?:4[0-35-9]|6[02357-9]|7[015])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|70[1-59]|84[0-39]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}", [8]], ["800\\d{6}", [9]], ["900(?:[0-24-9]\\d{7}|3\\d{1,4})", [5, 6, 7, 8, 11]], ["8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}", [8]], 0, ["30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}", [8]], ["7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}", [8]]], "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2(?:0[0-59]|1[1-9]|[23]\\d|4[02-7]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[578]|2[3-59]|3[13-9]|4[0-68]|5[1-3589])|5(?:0[2357-9]|1[1-356]|4[03-5]|5\\d|6[014-69]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[047]|4[0-378]|[78][0-8]|9[01])|7(?:0[5-79]|6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}", [8]], ["[37-9]\\d{7}", [8]], ["8002\\d{7}", [11]]]], HR: ["385", "00", "[2-69]\\d{8}|80\\d{5,7}|[1-79]\\d{7}|6\\d{6}", [7, 8, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}", [8, 9]], ["9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|55|77|9[5-79])))\\d{4}|98\\d{6}", [8, 9]], ["80\\d{5,7}"], ["6[01459]\\d{6}|6[01]\\d{5}", [7, 8]], ["7[45]\\d{6}", [8]], 0, ["62\\d{6,7}|72\\d{6}", [8, 9]]]], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2\\d|5[1-5]|81|9[149])\\d{5}"], ["(?:[34]\\d|55)\\d{6}"], ["8\\d{7}"], 0, 0, 0, 0, 0, ["9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}"]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06", 0, 0, 0, 0, 0, [["(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}", [8]], ["(?:[257]0|3[01])\\d{7}", [9]], ["(?:[48]0\\d|680[29])\\d{5}"], ["9[01]\\d{6}", [8]], 0, 0, ["38\\d{7}", [9]], 0, ["21\\d{7}", [9]]]], ID: ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}", [7, 8, 9, 10, 11]], ["8[1-35-9]\\d{7,10}", [9, 10, 11, 12]], ["00(?:1803\\d{5,11}|7803\\d{7})|(?:177\\d|800)\\d{5,7}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17]], ["809\\d{7}", [10]], 0, 0, ["(?:1500|8071\\d{3})\\d{3}", [7, 10]], 0, 0, ["804\\d{7}", [10]]]], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}"], ["8(?:22|[35-9]\\d)\\d{6}", [9]], ["1800\\d{6}", [10]], ["15(?:1[2-8]|[2-8]0|9[089])\\d{6}", [10]], ["700\\d{6}", [9]], ["88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}", [10]], ["818\\d{6}", [9]], 0, ["76\\d{7}", [9]], ["18[59]0\\d{6}", [10]]]], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0", 0, 0, 0, 0, 0, [["153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}", [8, 11, 12]], ["55(?:4(?:[01]0|5[0-2])|57[0-289])\\d{4}|5(?:(?:[0-2][02-9]|[36]\\d|[49][2-9]|8[3-7])\\d|5(?:01|2\\d|3[0-3]|4[34]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}", [9]], ["1(?:255|80[019]\\d{3})\\d{3}", [7, 10]], ["1212\\d{4}|1(?:200|9(?:0[0-2]|19))\\d{6}", [8, 10]], 0, ["151\\d{8,9}", [11, 12]], ["1599\\d{6}", [10]], 0, ["7(?:38(?:0\\d|5[0-3569]|88)|8(?:33|55|77|81)\\d)\\d{4}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}", [9]], ["1700\\d{6}", [10]]]], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24", [["1624(?:230|[5-8]\\d\\d)\\d{3}"], ["76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}"], ["808162\\d{4}"], ["8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}"], ["70\\d{8}"], 0, ["3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}"], 0, ["56\\d{8}"]]], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0", 0, 0, 0, 0, 0, [["2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}", [10]], ["(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}", [10]], ["000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))"], ["186[12]\\d{9}", [13]], 0, 0, ["140\\d{7}", [10]], 0, 0, ["1860\\d{7}", [11]]]], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]], 0, 0, 0, 0, 0, 0, [["37\\d{5}"], ["38\\d{5}"]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}", [8, 9]], ["7[3-9]\\d{8}", [10]]]], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|(?:12\\d|30[0-2])\\d|2(?:121|[2689]0\\d)|4(?:111|40\\d))\\d{4}", [6, 7, 10]], ["9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:[0-46]\\d\\d|5[15]0|8(?:[12]\\d|88)|9(?:0[0-3]|[19]\\d|21|69|77|8[7-9])))\\d{5}", [10]], 0, 0, 0, 0, ["96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])", [4, 5]]]], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}", [7]], ["(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}"], ["80[0-8]\\d{4}", [7]], ["90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}", [7]], 0, ["(?:689|8(?:7[18]|80)|95[48])\\d{4}", [7]], ["809\\d{4}", [7]], 0, ["49[0-24-79]\\d{4}", [7]]], "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}", [6, 7, 8, 9, 10, 11]], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876", [["8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0235-9]|[23]\\d|40|5[06]|6[2-589]|7[0-25-9]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}"], ["(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}", [8]], ["7(?:[78][0-25-9]|9\\d)\\d{6}", [9]], ["80\\d{6}", [8]], ["9\\d{7}", [8]], ["70\\d{7}", [9]], 0, ["8(?:10|8\\d)\\d{5}", [8]], ["74(?:66|77)\\d{5}", [9]], 0, ["85\\d{6}", [8]]]], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1", 0, 0, [["(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}", [9]], ["[7-9]0[1-9]\\d{7}", [10]], ["00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}"], ["990\\d{6}", [9]], ["60\\d{7}", [9]], 0, ["570\\d{6}", [9]], ["20\\d{8}", [10]], ["50[1-9]\\d{7}", [10]]]], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}", [7, 8, 9]], ["(?:1(?:0[0-8]|1[0-7]|2[014]|30)|7\\d\\d)\\d{6}", [9]], ["800[02-8]\\d{5,6}", [9, 10]], ["900[02-9]\\d{5}", [9]]]], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}", [9]], ["312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}", [9]], ["800\\d{6,7}"]]], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})", [8, 9]], ["(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}", [8, 9]], ["1800(?:1\\d|2[019])\\d{4}", [10]], ["1900(?:1\\d|2[09])\\d{4}", [10]]]], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0", 0, 0, 0, 0, 0, [["(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}"], ["(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}", [8]], 0, 0, 0, 0, 0, 0, ["30(?:0[01]\\d\\d|12(?:11|20))\\d\\d", [8]]]], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]], 0, 0, 0, 0, 0, 0, [["7[4-7]\\d{5}"], ["[34]\\d{6}"], 0, ["8\\d{6}"]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869", [["869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}"], ["869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}"], ["19[1-3]\\d{7}", [10]]]], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?", 0, 0, 0, [["(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}", [5, 6, 8, 9, 10]], ["1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}", [9, 10]], ["00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|[38]0)\\d{7}", [9, 11, 12, 13, 14]], ["60[2-9]\\d{6}", [9]], ["50\\d{8,9}", [10, 11]], 0, ["1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[0168]|88)|8(?:00|33|55|77|99))\\d{4}", [8]], ["15\\d{7,8}", [9, 10]], ["70\\d{8}", [10]]]], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]], 0, 0, 0, 0, 0, 0, [["2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}", [8]], ["(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|6[16])|2[26]2|3[36]3|4[46]4|7(?:0[013-9]|[67]\\d)|8[68]8|9(?:[069]\\d|3[039]))|9(?:(?:[04679]\\d|8[057-9])\\d|1(?:1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}", [8]], ["18\\d{5}", [7]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345", [["345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|4[89]|88)|9(?:14|4[035-9]))\\d{4}"], ["345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["(?:345976|900[2-9]\\d\\d)\\d{4}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", [["(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9]|97)|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]|59))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}", [10]], ["7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}", [10]], ["8(?:00|108\\d{3})\\d{7}"], ["809\\d{7}", [10]], ["808\\d{7}", [10]], 0, 0, 0, ["751\\d{7}", [10]]], "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[0135-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[13]|[35-7][14]|41|8[1468])\\d{6}", [8]], ["208[78]\\d{6}|(?:20[23579]|30[24])\\d{7}", [10]], 0, 0, 0, 0, ["30[0135-9]\\d{6}", [9]]]], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0", 0, 0, 0, 0, 0, [["7(?:62|8[0-7]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}"], ["793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}"], 0, ["9[01]\\d{6}", [8]], 0, 0, 0, 0, 0, ["80\\d{6}", [8]]]], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758", [["758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}"], ["758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0", 0, 0, 0, [["(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}", [7]], ["(?:6(?:(?:4[5-9]|5[0-469])\\d|6(?:[024-6]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}"], ["8002[28]\\d\\d|80(?:05\\d|9)\\d{4}"], ["90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d", [7]], 0, ["697(?:42|56|[78]\\d)\\d{4}", [9]], ["870(?:28|87)\\d\\d", [7]]]], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}"], ["7(?:[0-25-8]\\d|4[0-4])\\d{6}"], 0, 0, 0, 0, ["1973\\d{5}"]]], LR: ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2\\d{7}", [8]], ["(?:(?:(?:22|33)0|555|(?:77|88)\\d)\\d|4(?:240|[67]))\\d{5}|[56]\\d{6}", [7, 9]], 0, ["332(?:02|[34]\\d)\\d{4}", [9]]]], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]], 0, 0, 0, 0, 0, 0, [["2\\d{7}"], ["[56]\\d{7}"], ["800[1256]\\d{4}"]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]", 0, 0, 0, [["(?:3[1478]|4[124-6]|52)\\d{6}"], ["6\\d{7}"], ["80[02]\\d{5}"], ["9(?:0[0239]|10)\\d{5}"], ["70[05]\\d{5}"], 0, ["70[67]\\d{5}"], 0, ["[89]01\\d{5}"], ["808\\d{5}"]]], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)", 0, 0, 0, [["(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}"], ["6(?:[269][18]|5[1568]|7[189]|81)\\d{6}", [9]], ["800\\d{5}", [8]], ["90[015]\\d{5}", [8]], 0, 0, 0, 0, ["20(?:1\\d{5}|[2-689]\\d{1,7})", [4, 5, 6, 7, 8, 9, 10]], ["801\\d{5}", [8]]]], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]], 0, 0, 0, 0, 0, 0, [["6\\d{7}"], ["2333[0-8]\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[02-9]|3[0-24-9]))\\d{4}"], ["80\\d{6}"], ["90\\d{6}"], 0, 0, 0, 0, 0, ["81\\d{6}"]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}"], ["9[1-6]\\d{7}"]]], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-5]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:870|9[2-47-9]\\d)\\d{5}", [8]], ["4(?:[469]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}"], ["(?:800|90\\d)\\d{5}", [8]]]], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}"], ["562\\d{5}|(?:6\\d|7[16-9])\\d{6}"], ["800\\d{5}"], ["90[056]\\d{5}"], 0, 0, ["803\\d{5}"], 0, ["3[08]\\d{6}"], ["808\\d{5}"]]], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}", [8]], ["6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}", [8]], ["80(?:[0-2578]|9\\d)\\d{5}"], ["9(?:4[1568]|5[178])\\d{5}", [8]], 0, 0, ["77[1-9]\\d{5}", [8]], 0, ["78[1-49]\\d{5}", [8]]]], MF: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1", 0, 0, [["2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[356]|8[268]|9[2457])\\d{5}"], ["3[2-47-9]\\d{7}"], 0, 0, 0, 0, 0, 0, ["22\\d{7}"]]], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1", 0, 0, 0, 0, 0, [["(?:247|528|625)\\d{4}"], ["(?:(?:23|54)5|329|45[35-8])\\d{4}"], 0, 0, 0, 0, 0, 0, ["635\\d{4}"]]], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[0-3]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}"], ["7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-478]\\d|6[01])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}"], ["800\\d{5}"], ["5\\d{7}"], 0, 0, 0, 0, 0, ["8(?:0[1-9]|[1-9]\\d)\\d{5}"]]], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-59]))\\d{5}"], ["2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[2-59])\\d{6}"], ["80\\d{6}"]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:(?:12|[28]\\d|3[56]|7[3-6]|9[0-6])\\d|4(?:2[29]|7[0-2]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|22|7[0-2]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[013])|3(?:20\\d|4(?:70|83)|56)|420\\d|5(?:2\\d|470))|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|2472|3(?:20\\d|470)|4(?:2[04]\\d|472)|7(?:3\\d\\d|4[67]0|8(?:[01459]\\d|8))))\\d{4}|5(?:2(?:2\\d{5,6}|47[02]\\d{4})|(?:3472|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[01])|8(?:20\\d|47[02])|9(?:20\\d|470))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:(?:2\\d|51)\\d|4(?:[1-35-9]\\d|4[0-57-9]))|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|(?:[35]2|64)\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}", [6, 7, 8, 9]], ["(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}", [7, 8, 9, 10]], ["80080(?:0[1-9]|2\\d)\\d{3}", [10]], 0, 0, 0, 0, 0, ["1333\\d{4}", [8]]]], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[12]2[1-3]\\d{5,6}|(?:(?:[12](?:1|27)|5[368])\\d\\d|7(?:0(?:[0-5]\\d|7[078]|80)|128))\\d{4}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}"], ["(?:83[01]|92[039])\\d{5}|(?:5[05]|6[069]|72|8[015689]|9[013-9])\\d{6}", [8]], 0, 0, 0, 0, 0, 0, ["712[0-79]\\d{4}|7(?:1[013-9]|[5-9]\\d)\\d{5}", [8]]]], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]], 0, 0, 0, 0, 0, 0, [["(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}", [8]], ["6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}", [8]], ["0800\\d{3}", [7]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670", [["670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], MQ: ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:596(?:[03-7]\\d|1[05]|2[7-9]|8[0-39]|9[04-9])|80[6-9]\\d\\d|9(?:477[6-9]|767[4589]))\\d{4}"], ["(?:69[67]\\d\\d|7091[0-3])\\d{4}"], ["80[0-5]\\d{6}"], ["8[129]\\d{7}"], 0, 0, 0, 0, ["9(?:397[0-3]|477[0-5]|76(?:6\\d|7[0-367]))\\d{4}"]]], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]], 0, 0, 0, 0, 0, 0, [["(?:25[08]|35\\d|45[1-7])\\d{5}"], ["[2-4][0-46-9]\\d{6}"], ["800\\d{5}"]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664", [["6644(?:1[0-3]|91)\\d{4}"], ["664(?:3(?:49|9[1-6])|49[2-6])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]], 0, 0, 0, 0, 0, 0, [["20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}"], ["(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}"], ["800(?:02|[3467]\\d)\\d{3}"], ["5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}"], 0, 0, ["501\\d{5}"], ["7117\\d{4}"], ["3550\\d{4}"]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[0346-8]\\d|1[0-7])|4(?:[013568]\\d|2[4-8]|71|90)|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}", [7, 8]], ["5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-4]|3[013]))\\d{5}", [8]], ["802\\d{7}|80[0-2]\\d{4}", [7, 10]], ["30\\d{5}", [7]], 0, 0, 0, 0, ["3(?:20|9\\d)\\d{4}", [7]]], "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["(?:3(?:0[0-4]|3[0-59])|6(?:[58][024689]|6[024-68]|7[02468]))\\d{4}", [7]], ["(?:46[46]|[79]\\d\\d)\\d{4}", [7]], ["800\\d{7}", [10]], ["900\\d{7}", [10]], 0, 0, ["4(?:0[01]|50)\\d{4}", [7]]], "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1[2-9]|2[12]\\d\\d)\\d{5}"], ["111\\d{6}|(?:31|77|[89][89])\\d{7}", [9]]]], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-36-9]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}"], ["(?:2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-36-9]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}"], ["8(?:00|88)\\d{7}"], ["900\\d{7}"], ["500\\d{7}"], 0, 0, 0, 0, ["300\\d{7}"]], "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["4270\\d{4}|(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}", [8, 9]], ["1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-7]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}", [9, 10]], ["1[378]00\\d{6}", [10]], ["1600\\d{6}", [10]], 0, 0, 0, 0, ["15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}", [10]]]], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}", [8]], ["8[2-79]\\d{7}", [9]], ["800\\d{6}", [9]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}"], ["(?:60|8[1245])\\d{7}", [9]], ["80\\d{7}", [9]], ["8701\\d{5}", [9]], 0, 0, 0, 0, ["8(?:3\\d\\d|86)\\d{5}"]]], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}"], ["(?:[579]\\d|8[0-79])\\d{4}"], ["050\\d{3}"], ["36\\d{4}"]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]], 0, 0, 0, 0, 0, 0, [["2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}"], ["(?:23|7[0467]|[89]\\d)\\d{6}"], ["08\\d{6}"], ["09\\d{6}"]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1", 0, 0, [["(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}"], ["(?:14|3[58])\\d{4}"]]], NG: ["234", "009", "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}", [8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["3"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:20(?:[1259]\\d|3[013-9]|4[1-8]|6[024-689]|7[1-79]|8[2-9])|38)\\d{6}", [8, 10]], ["(?:702[0-24-9]|819[01])\\d{6}|(?:7(?:0[13-9]|[12]\\d)|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-6]))\\d{7}", [10]], ["800\\d{7,11}", [10, 11, 12, 13, 14]], 0, 0, 0, ["700\\d{7,11}", [10, 11, 12, 13, 14]]]], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]], 0, 0, 0, 0, 0, 0, [["2\\d{7}"], ["(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}"], ["1800\\d{4}"]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}", [9]], ["(?:6[1-58]|970\\d)\\d{7}", [9, 11]], ["800\\d{4,7}", [7, 8, 9, 10]], ["90[069]\\d{4,7}", [7, 8, 9, 10]], 0, 0, ["140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d", [5, 6, 9]], ["66\\d{7}", [9]], ["(?:85|91)\\d{7}", [9]]]], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]", [["(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}", [8]], ["(?:4[015-8]|9\\d)\\d{6}", [8]], ["80[01]\\d{5}", [8]], ["82[09]\\d{5}", [8]], ["880\\d{5}", [8]], ["81[23]\\d{5}", [8]], ["(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}"], 0, ["85[0-5]\\d{5}", [8]], ["810(?:0[0-6]|[2-8]\\d)\\d{3}", [8]]]], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}", [8]], ["9(?:00|6[0-3]|7[024-6]|8[0-24-68])\\d{7}", [10]], ["1(?:66001|800\\d\\d)\\d{5}", [11]]]], NR: ["674", "00", "(?:222|444|(?:55|8\\d)\\d|666|777|999)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[24-9]"]]], 0, 0, 0, 0, 0, 0, [["444\\d{4}"], ["(?:222|55[3-9]|666|777|8\\d\\d|999)\\d{4}"]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, [["[47]\\d{3}", [4]], ["(?:[56]|888[1-9])\\d{3}"]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["240\\d{5}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}", [8]], ["2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}", [8, 9, 10]], ["508\\d{6,7}|80\\d{6,8}", [8, 9, 10]], ["(?:1[13-57-9]\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}", [7, 8, 9, 10]], ["70\\d{7}", [9]], 0, ["8(?:1[16-9]|22|3\\d|4[045]|5[459]|6[235-9]|7[0-3579]|90)\\d{2,7}"]], "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]], 0, 0, 0, 0, 0, 0, [["2[1-6]\\d{6}", [8]], ["(?:1505|90[1-9]\\d)\\d{4}|(?:7[126-9]|9[1-9])\\d{6}", [8]], ["8007\\d{4,5}|(?:500|800[05])\\d{4}"], ["900\\d{5}", [8]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[058]|7[0167]|8[2358]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[07-9]\\d|1[0-7]|2[0-5]|33|4[0-79]|5[0-35]|6[068])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[0156]|7[0-24-9]|8[5-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}", [7]], ["(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}", [7, 8]], ["800\\d{4,5}|(?:00800|800\\d)\\d{6}"], ["(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}", [7]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:(?:(?:4[34]|5[14])[0-8]|687)\\d|7(?:173|(?:3[0-8]|55)\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[0569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}", [8]], ["9\\d{8}", [9]], ["800\\d{5}", [8]], ["805\\d{5}", [8]], ["80[24]\\d{5}", [8]], 0, 0, 0, 0, ["801\\d{5}", [8]]], "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], 0, 0, 0, 0, 0, 0, [["4(?:0[4-689]|9[4-68])\\d{5}", [8]], ["8[7-9]\\d{6}", [8]], ["80[0-5]\\d{6}", [9]], 0, 0, 0, ["44\\d{4}", [6]], 0, ["499\\d{5}", [8]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, [["(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}", [7]], ["(?:7\\d|8[1-38])\\d{6}", [8]], ["180\\d{4}", [7]], 0, 0, 0, 0, ["27[01]\\d{4}", [7]], ["2(?:0[0-57]|7[568])\\d{4}", [7]]], "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}", [6, 8, 9, 10]], ["(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}", [10]], ["1800\\d{7,9}", [11, 12, 13]]]], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}", [9, 10]], ["3(?:[0-247]\\d|3[0-79]|55|64)\\d{7}", [10]], ["800\\d{5}(?:\\d{3})?", [8, 11]], ["900\\d{5}", [8]], ["122\\d{6}", [9]], 0, ["(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}", [11, 12]]]], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))", [7, 9]], ["2131[89]\\d{4}|21(?:1[013-5]|2\\d|3[2-9])\\d{5}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}", [9]], ["800\\d{6,7}", [9, 10]], ["70[01346-8]\\d{6}", [9]], 0, 0, ["804\\d{6}", [9]], ["64\\d{4,7}", [6, 7, 8, 9]], ["39\\d{7}", [9]], ["801\\d{6}", [9]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4[1-35-9]|5[0-47-9]|80[6-9]\\d\\d)\\d{4}"], ["(?:4[02-489]|5[02-9]|708(?:4[0-5]|5[0-6]))\\d{4}"], ["80[0-5]\\d{6}", [9]], ["8[129]\\d{7}", [9]]]], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939", [["(?:787|939)[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}", [8]], ["5[69]\\d{7}", [9]], ["1800\\d{6}", [10]], 0, 0, 0, 0, 0, 0, ["1700\\d{6}", [10]]]], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:[12]\\d|3[1-689]|4[1-59]|[57][1-9]|6[1-35689]|8[1-69]|9[1256])\\d{6}"], ["6(?:[06]92(?:30|9\\d)|[35]92(?:[049]\\d|3[034]))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}"], ["80[02]\\d{6}"], ["(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}"], ["884[0-4689]\\d{5}"], ["600\\d{6}|6[06]92(?:0\\d|3[349]|49)\\d{3}"], ["70(?:38[01]|596|(?:7\\d|8[17])\\d)\\d{4}"], ["6(?:222\\d|8988)\\d{4}"], ["30\\d{7}"], ["80(?:8\\d|9[1579])\\d{5}"]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}"], ["(?:(?:46|83)[0-5]|(?:6[2-4689]|78)0)\\d{4}|(?:45|77|88)\\d{5}"]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}", [7, 8, 9]], ["9(?:51|6[129]|7[1-6]|8[1-7]|9[1-5])\\d{6}", [9]], ["9800\\d{5,7}", [9, 10, 11]], 0, 0, 0, ["[2-9]0\\d{4,7}", [6, 7, 8, 9]], 0, ["8700[0-4]\\d{4}", [9]]]], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]], 0, 0, 0, 0, 0, 0, [["4(?:1111|2022)\\d{3}|4(?:[04]\\d\\d|14[0-6]|999)\\d{4}", [8]], ["[35-7]\\d{7}", [8]], ["800\\d{4}|(?:0080[01]|800)\\d{6}", [7, 9, 11]], 0, 0, 0, 0, ["2[16]\\d{5}", [7]]]], RE: ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[0-3]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d"], ["(?:630|702)0\\d{5}|(?:6(?:00|2\\d)|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-39]))\\d{6}", [9]], ["800\\d{6}", [9]], ["90[0136]\\d{6}", [9]], 0, 0, ["(?:37\\d|80[578])\\d{6}", [9]], 0, 0, ["801\\d{6}", [9]]], 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}", [7, 8, 9, 10, 11, 12]], ["6(?:[0-689]|7\\d)\\d{6,7}", [8, 9, 10]], ["800\\d{3,9}"], ["(?:78\\d|90[0169])\\d{3,7}", [6, 7, 8, 9, 10]], 0, 0, ["7[06]\\d{4,10}"]]], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", [["(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}", [10]], ["9\\d{9}", [10]], ["8(?:0[04]|108\\d{3})\\d{7}"], ["80[39]\\d{7}", [10]], ["808\\d{7}", [10]]], "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:06|2[23568]\\d)\\d{6}"], ["7[237-9]\\d{7}", [9]], ["800\\d{6}", [9]], ["900\\d{6}", [9]]]], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, 0, 0, 0, 0, [["1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}", [9]], ["579[01]\\d{5}|5(?:[013-689]\\d|7[0-8])\\d{6}", [9]], ["800\\d{7}", [10]], ["925\\d{6}", [9]], 0, 0, ["811\\d{7}", [10]], 0, 0, ["920\\d{6}", [9]]]], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]], 0, 0, 0, 0, 0, 0, [["(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}", [5]], ["48\\d{3}|(?:(?:6[89]|7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}"], ["1[38]\\d{3}", [5]], 0, 0, 0, 0, 0, ["5[12]\\d{3}", [5]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, [["4[2-46]\\d{5}"], ["2[125-8]\\d{5}"], ["800[08]\\d{3}"], ["85\\d{5}"], 0, 0, 0, 0, ["971\\d{4}|(?:64|95)\\d{5}"]], "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1(?:5\\d|8[35-7])\\d{6}"], ["(?:1[0-2]|9[0-3569])\\d{7}"]]], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0", 0, 0, 0, 0, 0, [["(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}", [7, 8, 9]], ["7[02369]\\d{7}", [9]], ["20\\d{4,7}", [6, 7, 8, 9]], ["649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}", [7, 8, 9, 10]], ["75[1-8]\\d{6}", [9]], ["(?:25[245]|67[3-68])\\d{9}", [12]], ["10[1-8]\\d{6}", [9]], ["74[02-9]\\d{6}", [9]], 0, ["77[0-7]\\d{6}", [9]]]], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [["662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}", [8]], ["896[0-8]\\d{4}|(?:8(?:0[1-9]|[1-8]\\d|9[0-5])|9[0-8]\\d)\\d{5}", [8]], ["(?:18|8)00\\d{7}", [10, 11]], ["1900\\d{7}", [11]], 0, 0, ["7000\\d{7}", [11]], 0, ["(?:3[12]\\d|666)\\d{5}", [8]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]", [["2(?:[0-57-9]\\d|6[4-9])\\d\\d"], ["[56]\\d{4}", [5]], 0, 0, 0, 0, 0, 0, ["262\\d\\d", [5]]]], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["(?:[1-357][2-8]|4[24-8])\\d{6}", [8]], ["65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}", [8]], ["80\\d{4,6}", [6, 7, 8]], ["89[1-3]\\d{2,5}|90\\d{4,6}"], 0, 0, 0, 0, ["(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}", [8]]], "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79", [["79\\d{6}", [8]], ["(?:4[015-8]|9\\d)\\d{6}", [8]], ["80[01]\\d{5}", [8]], ["82[09]\\d{5}", [8]], ["880\\d{5}", [8]], ["81[23]\\d{5}", [8]], ["(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}"], 0, ["85[0-5]\\d{5}", [8]], ["810(?:0[0-6]|[2-8]\\d)\\d{3}", [8]]]], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d"], ["909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}", [9]], ["800\\d{6}", [9]], ["9(?:00|[78]\\d)\\d{6}", [9]], 0, 0, ["96\\d{7}", [9]], ["9090\\d{3}", [7]], ["6(?:02|5[0-4]|9[0-6])\\d{6}", [9]], ["8[5-9]\\d{7}", [9]]]], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["22[2-4][2-9]\\d{4}"], ["(?:25|3[0-5]|66|7[1-9]|8[08]|9[09])\\d{6}"]]], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1", 0, 0, [["0549(?:8[0157-9]|9\\d)\\d{4}", [10]], ["6[16]\\d{6}", [8]], 0, ["7[178]\\d{6}", [8]], 0, 0, 0, 0, ["5[158]\\d{6}", [8]]]], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]], 0, 0, 0, 0, 0, 0, [["3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}"], ["7(?:(?:[06-8]\\d|[19]0|21)\\d|5(?:0[01]|[19]0|2[25]|3[356]|[4-7]\\d|8[35]))\\d{5}"], ["800\\d{6}"], ["88[4689]\\d{6}"], 0, 0, 0, 0, ["(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}"], ["81[02468]\\d{6}"]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], "0", 0, 0, 0, 0, 0, [["(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}", [6, 7]], ["(?:(?:15|(?:3[59]|4[89]|6\\d|7[679]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}", [7, 8, 9]]]], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]], 0, 0, 0, 0, 0, 0, [["(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}"], ["(?:7[124-7]|8[1-9])\\d{5}", [7]], 0, 0, 0, 0, 0, 0, ["56\\d{4}", [6]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1[89]\\d{7}"], ["(?:12|9[1257-9])\\d{7}"]]], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]], 0, 0, 0, 0, 0, 0, [["22\\d{5}"], ["900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}"]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["2(?:79(?:0[0347-9]|[1-9]\\d)|89(?:0[024589]|[1-9]\\d))\\d{3}|2(?:[1-69]\\d|[78][0-8])\\d{5}", [8]], ["[67]\\d{7}", [8]], ["800\\d{8}|80[01]\\d{4}", [7, 11]], ["900\\d{4}(?:\\d{4})?", [7, 11]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721", [["7215(?:4[2-8]|8[239]|9[056])\\d{4}"], ["7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], SY: ["963", "00", "[1-359]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-4]|5[1-3]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[59]"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}"], ["(?:50|9[1-689])\\d{7}", [9]]]], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]], 0, 0, 0, 0, 0, 0, [["[23][2-5]\\d{6}", [8]], ["7[6-9]\\d{6}", [8]], ["0800\\d{4}", [8]], ["900\\d{6}", [9]], 0, 0, 0, 0, ["70\\d{6}", [8]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8", [["8\\d{3}"]]], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649", [["649(?:266|712|9(?:4\\d|50))\\d{4}"], ["649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["649(?:71[01]|966)\\d{4}"]]], TD: ["235", "00|16", "(?:22|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], 0, 0, 0, 0, 0, 0, [["22(?:[37-9]0|5[0-5]|6[89])\\d{4}"], ["(?:[69]\\d|77|8[56])\\d{6}"]], "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}"], ["(?:7[0-29]|9[0-36-9])\\d{6}"]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}", [8]], ["67(?:1[0-8]|2[4-7])\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}", [9]], ["(?:001800\\d|1800)\\d{6}", [10, 13]], ["1900\\d{6}", [10]], 0, 0, 0, 0, ["6[08]\\d{7}", [9]]]], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}"], ["(?:33[03-9]|4(?:1[18]|4[02-479])|81[1-9])\\d{6}|(?:[09]\\d|1[0-27-9]|2[0-27]|[34]0|5[05]|7[01578]|8[078])\\d{7}"]], "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7], 0, 0, 0, 0, 0, 0, 0, [["(?:2[2-4]|[34]\\d)\\d{2,5}"], ["7[2-4]\\d{2,5}"]]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["(?:2[1-5]|3[1-9]|4[1-4])\\d{5}", [7]], ["7[2-8]\\d{6}", [8]], ["80\\d{5}", [7]], ["90\\d{5}", [7]], ["70\\d{5}", [7]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, [["(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}"], ["(?:6\\d|71)\\d{6}"]], "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]], 0, 0, 0, 0, 0, 0, [["81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}"], ["3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}"], ["8010\\d{4}"], ["88\\d{6}"], 0, 0, 0, 0, 0, ["8[12]10\\d{4}"]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}", [5]], ["(?:5(?:4[0-5]|5[4-6])|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}", [7]], ["0800\\d{3}", [7]], 0, 0, 0, 0, 0, ["55[0-37-9]\\d{4}", [7]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}", [10]], ["561(?:011|61\\d)\\d{4}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}", [10]], ["8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})", [10, 12, 13]], ["(?:8[89]8|900)\\d{7}", [10]], ["592(?:21[12]|461)\\d{4}", [10]], 0, ["444\\d{4}", [7]], ["512\\d{7}", [10]], ["850\\d{7}", [10]]]], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868", [["868(?:2(?:01|1[5-9]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}"], ["868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], ["868619\\d{4}"]]], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["2[02-9]\\d{3}", [5]], ["(?:7[01]\\d|90)\\d{4}", [6, 7]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}", [8, 9]], ["(?:40001[0-2]|9[0-8]\\d{4})\\d{3}", [9]], ["80[0-79]\\d{6}|800\\d{5}", [8, 9]], ["20(?:[013-9]\\d\\d|2)\\d{4}", [7, 9]], ["99\\d{7}", [9]], 0, ["50[0-46-9]\\d{6}", [9]], 0, ["7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}", [10, 11]]], 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2[2-8]\\d{7}"], ["(?:6[125-9]|7[13-9])\\d{7}"], ["80[08]\\d{6}"], ["90\\d{7}"], 0, 0, 0, 0, ["41\\d{7}"], ["8(?:40|6[01])\\d{6}"]]], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}", [9]], ["790\\d{6}|(?:39|50|6[36-8]|7[1-357]|9[1-9])\\d{7}", [9]], ["800[1-8]\\d{5,6}"], ["900[239]\\d{5,6}"], 0, 0, 0, 0, ["89[1-579]\\d{6}", [9]]], "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["20(?:(?:240|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|3[1-4]|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}"], ["72[48]0\\d{5}|7(?:[015-8]\\d|2[067]|36|4[0-8]|9[089])\\d{6}"], ["800[1-3]\\d{5}"], ["90[1-3]\\d{6}"]]], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-468]))\\d{4}|(?:2742|305[3-9]|472[247-9]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, [["(?:1(?:770|9(?:20|[89]7))|(?:2\\d|4[2-7])\\d\\d)\\d{4}", [8]], ["9[1-9]\\d{6}", [8]], ["0004\\d{2,9}|(?:405|80[05])\\d{4}"], ["90[0-8]\\d{4}", [7]]], "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:55\\d\\d|6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|[69]\\d\\d|7(?:[23]\\d|7[69]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|[168]\\d\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|9(?:22|5[1-9])))\\d{5}"], ["(?:(?:[25]0|33|8[78]|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079])))|7(?:[07]\\d{3}|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}"]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698", [["06698\\d{1,6}", [6, 7, 8, 9, 10, 11]], ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784", [["784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}"], ["784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["78451[0-2]\\d{4}"]]], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}"], ["4(?:1[24-8]|2[246])\\d{7}"], ["800\\d{7}"], ["90[01]\\d{7}"], 0, 0, ["501\\d{7}"]]], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284", [["284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}"], ["284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340", [["340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}", [10]], ["(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[1689]|7[06-9]|8[1-8]|9[0-8])\\d{7}", [9]], ["1800\\d{4,6}|12(?:0[13]|28)\\d{4}", [8, 9, 10]], ["1900\\d{4,6}", [8, 9, 10]], 0, 0, ["(?:[17]99|80\\d)\\d{4}|69\\d{5,6}", [7, 8]], 0, ["672\\d{6}", [9]]]], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}", [5]], ["(?:[58]\\d|7[013-7])\\d{5}", [7]], ["81[18]\\d\\d", [5]], 0, 0, 0, ["(?:3[03]|900\\d)\\d{3}"], 0, ["9(?:0[1-9]|1[01])\\d{4}", [7]]]], WF: ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], 0, 0, 0, 0, 0, 0, [["72\\d{4}", [6]], ["(?:72|8[23])\\d{4}", [6]], ["80[0-5]\\d{6}", [9]], 0, 0, ["[48]0\\d{4}", [6]], 0, 0, ["9[23]\\d{4}", [6]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}", [5, 6]], ["(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}", [7, 10]], ["800\\d{3}", [6]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0", 0, 0, 0, 0, 0, [["38\\d{6,10}|(?:2[89]|39)(?:0\\d{5,6}|[1-9]\\d{5})"], ["4[3-9]\\d{6}", [8]], ["800\\d{5}", [8]], ["900\\d{5}", [8]]]], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}", [7, 8]], ["7[01378]\\d{7}", [9]]]], YT: ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}", [9]], ["(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:50[0-2]|6\\d\\d|7(?:[0-46-9]\\d|5[0-4]))\\d\\d|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}", [5, 6, 7, 8, 9]], ["80\\d{7}", [9]], ["(?:86[2-9]|9[0-2]\\d)\\d{6}", [9]], 0, 0, ["861\\d{6,7}", [9, 10]], 0, ["87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}", [9]], ["860\\d{6}", [9]]]], ZM: ["260", "00", "800\\d{6}|(?:21|[579]\\d|63)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[579]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["21[1-8]\\d{6}"], ["(?:[59][5-8]|7[5-9])\\d{7}"], ["800\\d{6}"], 0, 0, 0, 0, 0, ["63\\d{7}"]]], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}"], ["7(?:[1278]\\d|3[1-9])\\d{6}", [9]], ["80(?:[01]\\d|20|8[0-8])\\d{3}", [7]], 0, 0, 0, 0, 0, ["86(?:1[12]|22|30|44|55|77|8[368])\\d{6}", [10]]]] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function dD(e, t) {
  var r = Array.prototype.slice.call(t);
  return r.push(aD), e.apply(this, r);
}
function W9(e, t) {
  e = e.split("-"), t = t.split("-");
  for (var r = e[0].split("."), n = t[0].split("."), o = 0; o < 3; o++) {
    var a = Number(r[o]), d = Number(n[o]);
    if (a > d) return 1;
    if (d > a) return -1;
    if (!isNaN(a) && isNaN(d)) return 1;
    if (isNaN(a) && !isNaN(d)) return -1;
  }
  return e[1] && t[1] ? e[1] > t[1] ? 1 : e[1] < t[1] ? -1 : 0 : !e[1] && t[1] ? 1 : e[1] && !t[1] ? -1 : 0;
}
var iD = {}.constructor;
function xo(e) {
  return e != null && e.constructor === iD;
}
function Zc(e) {
  "@babel/helpers - typeof";
  return Zc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Zc(e);
}
function ii(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function sD(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function si(e, t, r) {
  return t && sD(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var uD = "1.2.0", lD = "1.7.35", z9 = " ext. ", cD = /^\d+$/, vt = /* @__PURE__ */ function() {
  function e(t) {
    ii(this, e), gm(t), this.metadata = t, ym.call(this, t);
  }
  return si(e, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(t) {
        return t !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(t) {
      return this.metadata.countries[t];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(t) {
      return this.getCountryMetadata(t) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(t) {
      if (this.getCountryCodesForCallingCode(t))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[t])
          return !0;
      } else {
        var r = this.countryCallingCodes()[t];
        if (r && r.length === 1 && r[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(t) {
      return this.nonGeographic() ? !!this.nonGeographic()[t] : !this.getCountryCodesForCallingCode(t);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(t) {
      return this.selectNumberingPlan(t);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(t, r) {
      if (t && cD.test(t) && (r = t, t = null), t && t !== "001") {
        if (!this.hasCountry(t))
          throw new Error("Unknown country: ".concat(t));
        this.numberingPlan = new Y9(this.getCountryMetadata(t), this);
      } else if (r) {
        if (!this.hasCallingCode(r))
          throw new Error("Unknown calling code: ".concat(r));
        this.numberingPlan = new Y9(this.getNumberingPlanMetadata(r), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(t) {
      var r = this.countryCallingCodes()[t];
      if (r)
        return r.length === 1 && r[0].length === 3 ? void 0 : r;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(t) {
      var r = this.getCountryCodesForCallingCode(t);
      if (r)
        return r[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(t) {
      var r = this.getCountryCodeForCallingCode(t);
      if (r)
        return this.getCountryMetadata(r);
      if (this.nonGeographic()) {
        var n = this.nonGeographic()[t];
        if (n)
          return n;
      } else {
        var o = this.countryCallingCodes()[t];
        if (o && o.length === 1 && o[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(t) {
      return this.numberingPlan.type(t);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(t) {
      return this.selectNumberingPlan(t);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), e;
}(), Y9 = /* @__PURE__ */ function() {
  function e(t, r) {
    ii(this, e), this.globalMetadataObject = r, this.metadata = t, ym.call(this, r.metadata);
  }
  return si(e, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(t) {
      return t[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var t = this, r = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return r.map(function(n) {
        return new fD(n, t);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(t) {
      return t[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(t) {
      if (this.hasTypes() && X9(this.types(), t))
        return new $D(X9(this.types(), t), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? z9 : this.metadata[13] || z9;
    }
  }]), e;
}(), fD = /* @__PURE__ */ function() {
  function e(t, r) {
    ii(this, e), this._format = t, this.metadata = r;
  }
  return si(e, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !pD.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), e;
}(), pD = /^\(?\$1\)?$/, $D = /* @__PURE__ */ function() {
  function e(t, r) {
    ii(this, e), this.type = t, this.metadata = r;
  }
  return si(e, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), e;
}();
function X9(e, t) {
  switch (t) {
    case "FIXED_LINE":
      return e[0];
    case "MOBILE":
      return e[1];
    case "TOLL_FREE":
      return e[2];
    case "PREMIUM_RATE":
      return e[3];
    case "PERSONAL_NUMBER":
      return e[4];
    case "VOICEMAIL":
      return e[5];
    case "UAN":
      return e[6];
    case "PAGER":
      return e[7];
    case "VOIP":
      return e[8];
    case "SHARED_COST":
      return e[9];
  }
}
function gm(e) {
  if (!e)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!xo(e) || !xo(e.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(xo(e) ? "an object of shape: { " + Object.keys(e).join(", ") + " }" : "a " + vD(e) + ": " + e, "."));
}
var vD = function(e) {
  return Zc(e);
};
function Y1(e, t) {
  if (t = new vt(t), t.hasCountry(e))
    return t.country(e).countryCallingCode();
  throw new Error("Unknown country: ".concat(e));
}
function ym(e) {
  var t = e.version;
  typeof t == "number" ? (this.v1 = t === 1, this.v2 = t === 2, this.v3 = t === 3, this.v4 = t === 4) : t ? W9(t, uD) === -1 ? this.v2 = !0 : W9(t, lD) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
function X1(e, t) {
  return mD(e, void 0, t);
}
function mD(e, t, r) {
  var n = r.type(t), o = n && n.possibleLengths() || r.possibleLengths();
  if (!o)
    return "IS_POSSIBLE";
  var a = e.length, d = o[0];
  return d === a ? "IS_POSSIBLE" : d > a ? "TOO_SHORT" : o[o.length - 1] < a ? "TOO_LONG" : o.indexOf(a, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function hD(e, t, r) {
  if (t === void 0 && (t = {}), r = new vt(r), t.v2) {
    if (!e.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    r.selectNumberingPlan(e.countryCallingCode);
  } else {
    if (!e.phone)
      return !1;
    if (e.country) {
      if (!r.hasCountry(e.country))
        throw new Error("Unknown country: ".concat(e.country));
      r.country(e.country);
    } else {
      if (!e.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      r.selectNumberingPlan(e.countryCallingCode);
    }
  }
  if (r.possibleLengths())
    return bm(e.phone || e.nationalNumber, r);
  if (e.countryCallingCode && r.isNonGeographicCallingCode(e.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function bm(e, t) {
  switch (X1(e, t)) {
    case "IS_POSSIBLE":
      return !0;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational
    default:
      return !1;
  }
}
function _r(e, t) {
  return e = e || "", new RegExp("^(?:" + t + ")$").test(e);
}
function gD(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = yD(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function yD(e, t) {
  if (e) {
    if (typeof e == "string") return q9(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return q9(e, t);
  }
}
function q9(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var bD = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function q1(e, t, r) {
  if (t = t || {}, !(!e.country && !e.countryCallingCode)) {
    r = new vt(r), r.selectNumberingPlan(e.country, e.countryCallingCode);
    var n = t.v2 ? e.nationalNumber : e.phone;
    if (_r(n, r.nationalNumberPattern())) {
      if (g0(n, "FIXED_LINE", r))
        return r.type("MOBILE") && r.type("MOBILE").pattern() === "" || !r.type("MOBILE") || g0(n, "MOBILE", r) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var o = gD(bD), a; !(a = o()).done; ) {
        var d = a.value;
        if (g0(n, d, r))
          return d;
      }
    }
  }
}
function g0(e, t, r) {
  return t = r.type(t), !t || !t.pattern() || t.possibleLengths() && t.possibleLengths().indexOf(e.length) < 0 ? !1 : _r(e, t.pattern());
}
function xD(e, t, r) {
  if (t = t || {}, r = new vt(r), r.selectNumberingPlan(e.country, e.countryCallingCode), r.hasTypes())
    return q1(e, t, r.metadata) !== void 0;
  var n = t.v2 ? e.nationalNumber : e.phone;
  return _r(n, r.nationalNumberPattern());
}
function wD(e, t, r) {
  var n = new vt(r), o = n.getCountryCodesForCallingCode(e);
  return o ? o.filter(function(a) {
    return AD(t, a, r);
  }) : [];
}
function AD(e, t, r) {
  var n = new vt(r);
  return n.selectNumberingPlan(t), n.numberingPlan.possibleLengths().indexOf(e.length) >= 0;
}
var J1 = 2, SD = 17, _D = 3, Wt = "0-9０-９٠-٩۰-۹", ED = "-‐-―−ー－", MD = "／/", CD = "．.", OD = "  ­​⁠　", ND = "()（）［］\\[\\]", ID = "~⁓∼～", Fd = "".concat(ED).concat(MD).concat(CD).concat(OD).concat(ND).concat(ID), Q1 = "+＋", PD = new RegExp("([" + Wt + "])");
function RD(e, t, r, n) {
  if (t) {
    var o = new vt(n);
    o.selectNumberingPlan(t, r);
    var a = new RegExp(o.IDDPrefix());
    if (e.search(a) === 0) {
      e = e.slice(e.match(a)[0].length);
      var d = e.match(PD);
      if (!(d && d[1] != null && d[1].length > 0 && d[1] === "0"))
        return e;
    }
  }
}
function TD(e, t) {
  if (e && t.numberingPlan.nationalPrefixForParsing()) {
    var r = new RegExp("^(?:" + t.numberingPlan.nationalPrefixForParsing() + ")"), n = r.exec(e);
    if (n) {
      var o, a, d = n.length - 1, i = d > 0 && n[d];
      if (t.nationalPrefixTransformRule() && i)
        o = e.replace(r, t.nationalPrefixTransformRule()), d > 1 && (a = n[1]);
      else {
        var s = n[0];
        o = e.slice(s.length), i && (a = n[1]);
      }
      var u;
      if (i) {
        var c = e.indexOf(n[1]), l = e.slice(0, c);
        l === t.numberingPlan.nationalPrefix() && (u = t.numberingPlan.nationalPrefix());
      } else
        u = n[0];
      return {
        nationalNumber: o,
        nationalPrefix: u,
        carrierCode: a
      };
    }
  }
  return {
    nationalNumber: e
  };
}
function Uc(e, t) {
  var r = TD(e, t), n = r.carrierCode, o = r.nationalNumber;
  if (o !== e) {
    if (!DD(e, o, t))
      return {
        nationalNumber: e
      };
    if (t.possibleLengths() && !LD(o, t))
      return {
        nationalNumber: e
      };
  }
  return {
    nationalNumber: o,
    carrierCode: n
  };
}
function DD(e, t, r) {
  return !(_r(e, r.nationalNumberPattern()) && !_r(t, r.nationalNumberPattern()));
}
function LD(e, t) {
  switch (X1(e, t)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function FD(e, t, r, n) {
  var o = t ? Y1(t, n) : r;
  if (e.indexOf(o) === 0) {
    n = new vt(n), n.selectNumberingPlan(t, r);
    var a = e.slice(o.length), d = Uc(a, n), i = d.nationalNumber, s = Uc(e, n), u = s.nationalNumber;
    if (!_r(u, n.nationalNumberPattern()) && _r(i, n.nationalNumberPattern()) || X1(u, n) === "TOO_LONG")
      return {
        countryCallingCode: o,
        number: a
      };
  }
  return {
    number: e
  };
}
function xm(e, t, r, n) {
  if (!e)
    return {};
  var o;
  if (e[0] !== "+") {
    var a = RD(e, t, r, n);
    if (a && a !== e)
      o = !0, e = "+" + a;
    else {
      if (t || r) {
        var d = FD(e, t, r, n), i = d.countryCallingCode, s = d.number;
        if (i)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: i,
            number: s
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: e
      };
    }
  }
  if (e[1] === "0")
    return {};
  n = new vt(n);
  for (var u = 2; u - 1 <= _D && u <= e.length; ) {
    var c = e.slice(1, u);
    if (n.hasCallingCode(c))
      return n.selectNumberingPlan(c), {
        countryCallingCodeSource: o ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: c,
        number: e.slice(u)
      };
    u++;
  }
  return {};
}
function kD(e) {
  return e.replace(new RegExp("[".concat(Fd, "]+"), "g"), " ").trim();
}
var jD = /(\$\d)/;
function BD(e, t, r) {
  var n = r.useInternationalFormat, o = r.withNationalPrefix, a = e.replace(new RegExp(t.pattern()), n ? t.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    o && t.nationalPrefixFormattingRule() ? t.format().replace(jD, t.nationalPrefixFormattingRule()) : t.format()
  ));
  return n ? kD(a) : a;
}
var ZD = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function UD(e, t, r) {
  var n = new vt(r);
  if (n.selectNumberingPlan(e, t), n.defaultIDDPrefix())
    return n.defaultIDDPrefix();
  if (ZD.test(n.IDDPrefix()))
    return n.IDDPrefix();
}
var GD = ";ext=", Ln = function(e) {
  return "([".concat(Wt, "]{1,").concat(e, "})");
};
function wm(e) {
  var t = "20", r = "15", n = "9", o = "6", a = "[  \\t,]*", d = "[:\\.．]?[  \\t,-]*", i = "#?", s = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", u = "(?:[xｘ#＃~～]|int|ｉｎｔ)", c = "[- ]+", l = "[  \\t]*", p = "(?:,{2}|;)", h = GD + Ln(t), m = a + s + d + Ln(t) + i, f = a + u + d + Ln(n) + i, $ = c + Ln(o) + "#", v = l + p + d + Ln(r) + i, y = l + "(?:,)+" + d + Ln(n) + i;
  return h + "|" + m + "|" + f + "|" + $ + "|" + v + "|" + y;
}
var VD = "[" + Wt + "]{" + J1 + "}", HD = "[" + Q1 + "]{0,1}(?:[" + Fd + "]*[" + Wt + "]){3,}[" + Fd + Wt + "]*", KD = new RegExp("^[" + Q1 + "]{0,1}(?:[" + Fd + "]*[" + Wt + "]){1,2}$", "i"), WD = HD + // Phone number extensions
"(?:" + wm() + ")?", zD = new RegExp(
  // Either a short two-digit-only phone number
  "^" + VD + "$|^" + WD + "$",
  "i"
);
function YD(e) {
  return e.length >= J1 && zD.test(e);
}
function XD(e) {
  return KD.test(e);
}
function qD(e) {
  var t = e.number, r = e.ext;
  if (!t)
    return "";
  if (t[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(t).concat(r ? ";ext=" + r : "");
}
function JD(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = QD(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function QD(e, t) {
  if (e) {
    if (typeof e == "string") return J9(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return J9(e, t);
  }
}
function J9(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Q9(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function e3(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Q9(Object(r), !0).forEach(function(n) {
      eL(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Q9(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function eL(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var t3 = {
  formatExtension: function(e, t, r) {
    return "".concat(e).concat(r.ext()).concat(t);
  }
};
function tL(e, t, r, n) {
  if (r ? r = e3(e3({}, t3), r) : r = t3, n = new vt(n), e.country && e.country !== "001") {
    if (!n.hasCountry(e.country))
      throw new Error("Unknown country: ".concat(e.country));
    n.country(e.country);
  } else if (e.countryCallingCode)
    n.selectNumberingPlan(e.countryCallingCode);
  else return e.phone || "";
  var o = n.countryCallingCode(), a = r.v2 ? e.nationalNumber : e.phone, d;
  switch (t) {
    case "NATIONAL":
      return a ? (d = kd(a, e.carrierCode, "NATIONAL", n, r), y0(d, e.ext, n, r.formatExtension)) : "";
    case "INTERNATIONAL":
      return a ? (d = kd(a, null, "INTERNATIONAL", n, r), d = "+".concat(o, " ").concat(d), y0(d, e.ext, n, r.formatExtension)) : "+".concat(o);
    case "E.164":
      return "+".concat(o).concat(a);
    case "RFC3966":
      return qD({
        number: "+".concat(o).concat(a),
        ext: e.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?
    case "IDD":
      if (!r.fromCountry)
        return;
      var i = nL(a, e.carrierCode, o, r.fromCountry, n);
      return y0(i, e.ext, n, r.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(t, '"'));
  }
}
function kd(e, t, r, n, o) {
  var a = rL(n.formats(), e);
  return a ? BD(e, a, {
    useInternationalFormat: r === "INTERNATIONAL",
    withNationalPrefix: !(a.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && o && o.nationalPrefix === !1)
  }) : e;
}
function rL(e, t) {
  for (var r = JD(e), n; !(n = r()).done; ) {
    var o = n.value;
    if (o.leadingDigitsPatterns().length > 0) {
      var a = o.leadingDigitsPatterns()[o.leadingDigitsPatterns().length - 1];
      if (t.search(a) !== 0)
        continue;
    }
    if (_r(t, o.pattern()))
      return o;
  }
}
function y0(e, t, r, n) {
  return t ? n(e, t, r) : e;
}
function nL(e, t, r, n, o) {
  var a = Y1(n, o.metadata);
  if (a === r) {
    var d = kd(e, t, "NATIONAL", o);
    return r === "1" ? r + " " + d : d;
  }
  var i = UD(n, void 0, o.metadata);
  if (i)
    return "".concat(i, " ").concat(r, " ").concat(kd(e, null, "INTERNATIONAL", o));
}
function r3(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function n3(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? r3(Object(r), !0).forEach(function(n) {
      oL(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : r3(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function oL(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function aL(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function dL(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function iL(e, t, r) {
  return t && dL(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var sL = /* @__PURE__ */ function() {
  function e(t, r, n) {
    if (aL(this, e), !t)
      throw new TypeError("First argument is required");
    if (typeof t != "string")
      throw new TypeError("First argument must be a string");
    if (typeof t == "string") {
      if (t[0] === "+" && !r)
        throw new TypeError("`metadata` argument not passed");
      if (xo(r) && xo(r.countries)) {
        n = r;
        var o = t;
        if (!cL.test(o))
          throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
        var a = xm(o, void 0, void 0, n), d = a.countryCallingCode, i = a.number;
        if (r = i, t = d, !r)
          throw new Error("Invalid `number` argument passed: too short");
      }
    }
    if (!r)
      throw new TypeError("`nationalNumber` argument is required");
    if (typeof r != "string")
      throw new TypeError("`nationalNumber` argument must be a string");
    gm(n);
    var s = lL(t, n), u = s.country, c = s.countryCallingCode;
    this.country = u, this.countryCallingCode = c, this.nationalNumber = r, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return n;
    };
  }
  return iL(e, [{
    key: "setExt",
    value: function(t) {
      this.ext = t;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : wD(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return hD(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return xD(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var t = new vt(this.getMetadata());
      return t.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(t) {
      return this.number === t.number && this.ext === t.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return q1(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(t, r) {
      return tL(this, t, r ? n3(n3({}, r), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(t) {
      return this.format("NATIONAL", t);
    }
  }, {
    key: "formatInternational",
    value: function(t) {
      return this.format("INTERNATIONAL", t);
    }
  }, {
    key: "getURI",
    value: function(t) {
      return this.format("RFC3966", t);
    }
  }]), e;
}(), uL = function(e) {
  return /^[A-Z]{2}$/.test(e);
};
function lL(e, t) {
  var r, n, o = new vt(t);
  return uL(e) ? (r = e, o.selectNumberingPlan(r), n = o.countryCallingCode()) : n = e, {
    country: r,
    countryCallingCode: n
  };
}
var cL = /^\+\d+$/;
function Gc(e) {
  "@babel/helpers - typeof";
  return Gc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Gc(e);
}
function fL(e, t, r) {
  return Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function pL(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function $L(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && pa(e, t);
}
function vL(e) {
  var t = Sm();
  return function() {
    var r = $a(e), n;
    if (t) {
      var o = $a(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else
      n = r.apply(this, arguments);
    return mL(this, n);
  };
}
function mL(e, t) {
  if (t && (Gc(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Am(e);
}
function Am(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Vc(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Vc = function(r) {
    if (r === null || !hL(r)) return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(r)) return t.get(r);
      t.set(r, n);
    }
    function n() {
      return Ad(r, arguments, $a(this).constructor);
    }
    return n.prototype = Object.create(r.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } }), pa(n, r);
  }, Vc(e);
}
function Ad(e, t, r) {
  return Sm() ? Ad = Reflect.construct : Ad = function(n, o, a) {
    var d = [null];
    d.push.apply(d, o);
    var i = Function.bind.apply(n, d), s = new i();
    return a && pa(s, a.prototype), s;
  }, Ad.apply(null, arguments);
}
function Sm() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function hL(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function pa(e, t) {
  return pa = Object.setPrototypeOf || function(r, n) {
    return r.__proto__ = n, r;
  }, pa(e, t);
}
function $a(e) {
  return $a = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, $a(e);
}
var Dr = /* @__PURE__ */ function(e) {
  $L(r, e);
  var t = vL(r);
  function r(n) {
    var o;
    return pL(this, r), o = t.call(this, n), Object.setPrototypeOf(Am(o), r.prototype), o.name = o.constructor.name, o;
  }
  return fL(r);
}(/* @__PURE__ */ Vc(Error)), o3 = new RegExp("(?:" + wm() + ")$", "i");
function gL(e) {
  var t = e.search(o3);
  if (t < 0)
    return {};
  for (var r = e.slice(0, t), n = e.match(o3), o = 1; o < n.length; ) {
    if (n[o])
      return {
        number: r,
        ext: n[o]
      };
    o++;
  }
}
var yL = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function bL(e) {
  return yL[e];
}
function xL(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = wL(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function wL(e, t) {
  if (e) {
    if (typeof e == "string") return a3(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return a3(e, t);
  }
}
function a3(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function d3(e) {
  for (var t = "", r = xL(e.split("")), n; !(n = r()).done; ) {
    var o = n.value;
    t += AL(o, t) || "";
  }
  return t;
}
function AL(e, t, r) {
  return e === "+" ? t ? void 0 : "+" : bL(e);
}
function SL(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = _L(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _L(e, t) {
  if (e) {
    if (typeof e == "string") return i3(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return i3(e, t);
  }
}
function i3(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function EL(e, t) {
  var r = t.countries, n = t.metadata;
  n = new vt(n);
  for (var o = SL(r), a; !(a = o()).done; ) {
    var d = a.value;
    if (n.country(d), n.leadingDigits()) {
      if (e && e.search(n.leadingDigits()) === 0)
        return d;
    } else if (q1({
      phone: e,
      country: d
    }, void 0, n.metadata))
      return d;
  }
}
function ML(e, t) {
  var r = t.nationalNumber, n = t.metadata, o = n.getCountryCodesForCallingCode(e);
  if (o)
    return o.length === 1 ? o[0] : EL(r, {
      countries: o,
      metadata: n.metadata
    });
}
var _m = "+", CL = "[\\-\\.\\(\\)]?", s3 = "([" + Wt + "]|" + CL + ")", OL = "^\\" + _m + s3 + "*[" + Wt + "]" + s3 + "*$", NL = new RegExp(OL, "g"), Hc = Wt, IL = "[" + Hc + "]+((\\-)*[" + Hc + "])*", PL = "a-zA-Z", RL = "[" + PL + "]+((\\-)*[" + Hc + "])*", TL = "^(" + IL + "\\.)*" + RL + "\\.?$", DL = new RegExp(TL, "g"), u3 = "tel:", Kc = ";phone-context=", LL = ";isub=";
function FL(e) {
  var t = e.indexOf(Kc);
  if (t < 0)
    return null;
  var r = t + Kc.length;
  if (r >= e.length)
    return "";
  var n = e.indexOf(";", r);
  return n >= 0 ? e.substring(r, n) : e.substring(r);
}
function kL(e) {
  return e === null ? !0 : e.length === 0 ? !1 : NL.test(e) || DL.test(e);
}
function jL(e, t) {
  var r = t.extractFormattedPhoneNumber, n = FL(e);
  if (!kL(n))
    throw new Dr("NOT_A_NUMBER");
  var o;
  if (n === null)
    o = r(e) || "";
  else {
    o = "", n.charAt(0) === _m && (o += n);
    var a = e.indexOf(u3), d;
    a >= 0 ? d = a + u3.length : d = 0;
    var i = e.indexOf(Kc);
    o += e.substring(d, i);
  }
  var s = o.indexOf(LL);
  if (s > 0 && (o = o.substring(0, s)), o !== "")
    return o;
}
var BL = 250, ZL = new RegExp("[" + Q1 + Wt + "]"), UL = new RegExp("[^" + Wt + "#]+$");
function GL(e, t, r) {
  if (t = t || {}, r = new vt(r), t.defaultCountry && !r.hasCountry(t.defaultCountry))
    throw t.v2 ? new Dr("INVALID_COUNTRY") : new Error("Unknown country: ".concat(t.defaultCountry));
  var n = HL(e, t.v2, t.extract), o = n.number, a = n.ext, d = n.error;
  if (!o) {
    if (t.v2)
      throw d === "TOO_SHORT" ? new Dr("TOO_SHORT") : new Dr("NOT_A_NUMBER");
    return {};
  }
  var i = WL(o, t.defaultCountry, t.defaultCallingCode, r), s = i.country, u = i.nationalNumber, c = i.countryCallingCode, l = i.countryCallingCodeSource, p = i.carrierCode;
  if (!r.hasSelectedNumberingPlan()) {
    if (t.v2)
      throw new Dr("INVALID_COUNTRY");
    return {};
  }
  if (!u || u.length < J1) {
    if (t.v2)
      throw new Dr("TOO_SHORT");
    return {};
  }
  if (u.length > SD) {
    if (t.v2)
      throw new Dr("TOO_LONG");
    return {};
  }
  if (t.v2) {
    var h = new sL(c, u, r.metadata);
    return s && (h.country = s), p && (h.carrierCode = p), a && (h.ext = a), h.__countryCallingCodeSource = l, h;
  }
  var m = (t.extended ? r.hasSelectedNumberingPlan() : s) ? _r(u, r.nationalNumberPattern()) : !1;
  return t.extended ? {
    country: s,
    countryCallingCode: c,
    carrierCode: p,
    valid: m,
    possible: m ? !0 : !!(t.extended === !0 && r.possibleLengths() && bm(u, r)),
    phone: u,
    ext: a
  } : m ? KL(s, u, a) : {};
}
function VL(e, t, r) {
  if (e) {
    if (e.length > BL) {
      if (r)
        throw new Dr("TOO_LONG");
      return;
    }
    if (t === !1)
      return e;
    var n = e.search(ZL);
    if (!(n < 0))
      return e.slice(n).replace(UL, "");
  }
}
function HL(e, t, r) {
  var n = jL(e, {
    extractFormattedPhoneNumber: function(a) {
      return VL(a, r, t);
    }
  });
  if (!n)
    return {};
  if (!YD(n))
    return XD(n) ? {
      error: "TOO_SHORT"
    } : {};
  var o = gL(n);
  return o.ext ? o : {
    number: n
  };
}
function KL(e, t, r) {
  var n = {
    country: e,
    phone: t
  };
  return r && (n.ext = r), n;
}
function WL(e, t, r, n) {
  var o = xm(d3(e), t, r, n.metadata), a = o.countryCallingCodeSource, d = o.countryCallingCode, i = o.number, s;
  if (d)
    n.selectNumberingPlan(d);
  else if (i && (t || r))
    n.selectNumberingPlan(t, r), t && (s = t), d = r || Y1(t, n.metadata);
  else return {};
  if (!i)
    return {
      countryCallingCodeSource: a,
      countryCallingCode: d
    };
  var u = Uc(d3(i), n), c = u.nationalNumber, l = u.carrierCode, p = ML(d, {
    nationalNumber: c,
    metadata: n
  });
  return p && (s = p, p === "001" || n.country(s)), {
    country: s,
    countryCallingCode: d,
    countryCallingCodeSource: a,
    nationalNumber: c,
    carrierCode: l
  };
}
function l3(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function c3(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? l3(Object(r), !0).forEach(function(n) {
      zL(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : l3(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function zL(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function YL(e, t, r) {
  return GL(e, c3(c3({}, t), {}, {
    v2: !0
  }), r);
}
function f3(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function XL(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? f3(Object(r), !0).forEach(function(n) {
      qL(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : f3(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function qL(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function JL(e, t) {
  return rF(e) || tF(e, t) || eF(e, t) || QL();
}
function QL() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function eF(e, t) {
  if (e) {
    if (typeof e == "string") return p3(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return p3(e, t);
  }
}
function p3(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function tF(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n = [], o = !0, a = !1, d, i;
    try {
      for (r = r.call(e); !(o = (d = r.next()).done) && (n.push(d.value), !(t && n.length === t)); o = !0)
        ;
    } catch (s) {
      a = !0, i = s;
    } finally {
      try {
        !o && r.return != null && r.return();
      } finally {
        if (a) throw i;
      }
    }
    return n;
  }
}
function rF(e) {
  if (Array.isArray(e)) return e;
}
function nF(e) {
  var t = Array.prototype.slice.call(e), r = JL(t, 4), n = r[0], o = r[1], a = r[2], d = r[3], i, s, u;
  if (typeof n == "string")
    i = n;
  else throw new TypeError("A text for parsing must be a string.");
  if (!o || typeof o == "string")
    d ? (s = a, u = d) : (s = void 0, u = a), o && (s = XL({
      defaultCountry: o
    }, s));
  else if (xo(o))
    a ? (s = o, u = a) : u = o;
  else throw new Error("Invalid second argument: ".concat(o));
  return {
    text: i,
    options: s,
    metadata: u
  };
}
function oF() {
  var e = nF(arguments), t = e.text, r = e.options, n = e.metadata;
  return YL(t, r, n);
}
function aF() {
  return dD(oF, arguments);
}
var Em = "isPhoneNumber";
function Mm(e, t) {
  if (typeof e != "string" || e.trim() !== e)
    return !1;
  try {
    var r = aF(e, t);
    return t && r.country !== t ? !1 : r.isValid();
  } catch {
    return !1;
  }
}
function dF(e, t) {
  return W({
    name: Em,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Mm(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must be a valid phone number";
      }, t)
    }
  }, t);
}
var Cm = "isMilitaryTime";
function Om(e) {
  var t = /^([01]\d|2[0-3]):?([0-5]\d)$/;
  return typeof e == "string" && vm(e, t);
}
function iF(e) {
  return W({
    name: Cm,
    validator: {
      validate: function(t, r) {
        return Om(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be a valid representation of military time in the format HH:MM";
      }, e)
    }
  }, e);
}
var b0 = { exports: {} }, $3;
function Nm() {
  return $3 || ($3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ J());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = {
      md5: 32,
      md4: 32,
      sha1: 40,
      sha256: 64,
      sha384: 96,
      sha512: 128,
      ripemd128: 32,
      ripemd160: 40,
      tiger128: 32,
      tiger160: 40,
      tiger192: 48,
      crc32: 8,
      crc32b: 8
    };
    function a(d, i) {
      (0, r.default)(d);
      var s = new RegExp("^[a-fA-F0-9]{".concat(o[i], "}$"));
      return s.test(d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(b0, b0.exports)), b0.exports;
}
var sF = /* @__PURE__ */ Nm();
const uF = /* @__PURE__ */ $e(sF);
var Im = "isHash";
function Pm(e, t) {
  return typeof e == "string" && uF(e, t);
}
function lF(e, t) {
  return W({
    name: Im,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Pm(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must be a hash of type $constraint1";
      }, t)
    }
  }, t);
}
var x0 = { exports: {} }, v3;
function Rm() {
  return v3 || (v3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ J());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = "^\\d{4}-?\\d{3}[\\dX]$";
    function a(d) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      (0, r.default)(d);
      var s = o;
      if (s = i.require_hyphen ? s.replace("?", "") : s, s = i.case_sensitive ? new RegExp(s) : new RegExp(s, "i"), !s.test(d))
        return !1;
      for (var u = d.replace("-", "").toUpperCase(), c = 0, l = 0; l < u.length; l++) {
        var p = u[l];
        c += (p === "X" ? 10 : +p) * (8 - l);
      }
      return c % 11 === 0;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(x0, x0.exports)), x0.exports;
}
var cF = /* @__PURE__ */ Rm();
const fF = /* @__PURE__ */ $e(cF);
var Tm = "isISSN";
function Dm(e, t) {
  return typeof e == "string" && fF(e, t);
}
function pF(e, t) {
  return W({
    name: Tm,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Dm(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must be a ISSN";
      }, t)
    }
  }, t);
}
var Lm = "isDateString";
function Fm(e, t) {
  return K1(e, t);
}
function $F(e, t) {
  return W({
    name: Lm,
    constraints: [e],
    validator: {
      validate: function(r) {
        return Fm(r, e);
      },
      defaultMessage: K(function(r) {
        return r + "$property must be a valid ISO 8601 date string";
      }, t)
    }
  }, t);
}
var w0 = { exports: {} }, m3;
function km() {
  return m3 || (m3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var r = n(/* @__PURE__ */ J());
    function n(s) {
      return s && s.__esModule ? s : { default: s };
    }
    var o = {
      loose: !1
    }, a = ["true", "false", "1", "0"], d = [].concat(a, ["yes", "no"]);
    function i(s) {
      var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : o;
      return (0, r.default)(s), u.loose ? d.includes(s.toLowerCase()) : a.includes(s);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(w0, w0.exports)), w0.exports;
}
var vF = /* @__PURE__ */ km();
const mF = /* @__PURE__ */ $e(vF);
var jm = "isBooleanString";
function Bm(e) {
  return typeof e == "string" && mF(e);
}
function hF(e) {
  return W({
    name: jm,
    validator: {
      validate: function(t, r) {
        return Bm(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be a boolean string";
      }, e)
    }
  }, e);
}
var A0 = { exports: {} }, h3;
function Zm() {
  return h3 || (h3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = o(/* @__PURE__ */ J()), n = /* @__PURE__ */ Oa();
    function o(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var a = /^[0-9]+$/;
    function d(i, s) {
      return (0, r.default)(i), s && s.no_symbols ? a.test(i) : new RegExp("^[+-]?([0-9]*[".concat((s || {}).locale ? n.decimal[s.locale] : ".", "])?[0-9]+$")).test(i);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(A0, A0.exports)), A0.exports;
}
var gF = /* @__PURE__ */ Zm();
const yF = /* @__PURE__ */ $e(gF);
var Um = "isNumberString";
function Gm(e, t) {
  return typeof e == "string" && yF(e, t);
}
function bF(e, t) {
  return W({
    name: Um,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Gm(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must be a number string";
      }, t)
    }
  }, t);
}
var S0 = { exports: {} }, g3;
function Vm() {
  return g3 || (g3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = s;
    var r = o(/* @__PURE__ */ J()), n = o(/* @__PURE__ */ $t());
    function o(u) {
      return u && u.__esModule ? u : { default: u };
    }
    var a = /^[A-Z2-7]+=*$/, d = /^[A-HJKMNP-TV-Z0-9]+$/, i = {
      crockford: !1
    };
    function s(u, c) {
      if ((0, r.default)(u), c = (0, n.default)(c, i), c.crockford)
        return d.test(u);
      var l = u.length;
      return !!(l % 8 === 0 && a.test(u));
    }
    e.exports = t.default, e.exports.default = t.default;
  }(S0, S0.exports)), S0.exports;
}
var xF = /* @__PURE__ */ Vm();
const wF = /* @__PURE__ */ $e(xF);
var Hm = "isBase32";
function Km(e) {
  return typeof e == "string" && wF(e);
}
function AF(e) {
  return W({
    name: Hm,
    validator: {
      validate: function(t, r) {
        return Km(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be base32 encoded";
      }, e)
    }
  }, e);
}
var _0 = { exports: {} }, y3;
function Wm() {
  return y3 || (y3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = o(/* @__PURE__ */ J()), n = /* @__PURE__ */ W1();
    function o(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var a = /^[A-Za-z]{6}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?$/;
    function d(i) {
      (0, r.default)(i);
      var s = i.slice(4, 6).toUpperCase();
      return !n.CountryCodes.has(s) && s !== "XK" ? !1 : a.test(i);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(_0, _0.exports)), _0.exports;
}
var SF = /* @__PURE__ */ Wm();
const _F = /* @__PURE__ */ $e(SF);
var zm = "isBIC";
function Ym(e) {
  return typeof e == "string" && _F(e);
}
function EF(e) {
  return W({
    name: zm,
    validator: {
      validate: function(t, r) {
        return Ym(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be a BIC or SWIFT code";
      }, e)
    }
  }, e);
}
var E0 = { exports: {} }, b3;
function Xm() {
  return b3 || (b3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = n(/* @__PURE__ */ J());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var o = /^(bc1|tb1|bc1p|tb1p)[ac-hj-np-z02-9]{39,58}$/, a = /^(1|2|3|m)[A-HJ-NP-Za-km-z1-9]{25,39}$/;
    function d(i) {
      return (0, r.default)(i), o.test(i) || a.test(i);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(E0, E0.exports)), E0.exports;
}
var MF = /* @__PURE__ */ Xm();
const CF = /* @__PURE__ */ $e(MF);
var qm = "isBtcAddress";
function Jm(e) {
  return typeof e == "string" && CF(e);
}
function OF(e) {
  return W({
    name: qm,
    validator: {
      validate: function(t, r) {
        return Jm(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be a BTC address";
      }, e)
    }
  }, e);
}
var M0 = { exports: {} }, x3;
function Qm() {
  return x3 || (x3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var r = n(/* @__PURE__ */ J());
    function n(s) {
      return s && s.__esModule ? s : { default: s };
    }
    var o = /^[a-z]+\/[a-z0-9\-\+\._]+$/i, a = /^[a-z\-]+=[a-z0-9\-]+$/i, d = /^[a-z0-9!\$&'\(\)\*\+,;=\-\._~:@\/\?%\s]*$/i;
    function i(s) {
      (0, r.default)(s);
      var u = s.split(",");
      if (u.length < 2)
        return !1;
      var c = u.shift().trim().split(";"), l = c.shift();
      if (l.slice(0, 5) !== "data:")
        return !1;
      var p = l.slice(5);
      if (p !== "" && !o.test(p))
        return !1;
      for (var h = 0; h < c.length; h++)
        if (!(h === c.length - 1 && c[h].toLowerCase() === "base64") && !a.test(c[h]))
          return !1;
      for (var m = 0; m < u.length; m++)
        if (!d.test(u[m]))
          return !1;
      return !0;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(M0, M0.exports)), M0.exports;
}
var NF = /* @__PURE__ */ Qm();
const IF = /* @__PURE__ */ $e(NF);
var eh = "isDataURI";
function th(e) {
  return typeof e == "string" && IF(e);
}
function PF(e) {
  return W({
    name: eh,
    validator: {
      validate: function(t, r) {
        return th(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be a data uri format";
      }, e)
    }
  }, e);
}
var C0 = { exports: {} }, w3;
function rh() {
  return w3 || (w3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = u;
    var r = n(/* @__PURE__ */ J());
    function n(c) {
      return c && c.__esModule ? c : { default: c };
    }
    var o = 8, a = 14, d = /^(\d{8}|\d{13}|\d{14})$/;
    function i(c, l) {
      return c === o || c === a ? l % 2 === 0 ? 3 : 1 : l % 2 === 0 ? 1 : 3;
    }
    function s(c) {
      var l = c.slice(0, -1).split("").map(function(h, m) {
        return Number(h) * i(c.length, m);
      }).reduce(function(h, m) {
        return h + m;
      }, 0), p = 10 - l % 10;
      return p < 10 ? p : 0;
    }
    function u(c) {
      (0, r.default)(c);
      var l = Number(c.slice(-1));
      return d.test(c) && l === s(c);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(C0, C0.exports)), C0.exports;
}
var RF = /* @__PURE__ */ rh();
const TF = /* @__PURE__ */ $e(RF);
var nh = "isEAN";
function oh(e) {
  return typeof e == "string" && TF(e);
}
function DF(e) {
  return W({
    name: nh,
    validator: {
      validate: function(t, r) {
        return oh(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be an EAN (European Article Number)";
      }, e)
    }
  }, e);
}
var O0 = { exports: {} }, A3;
function ah() {
  return A3 || (A3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ J());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /^(0x)[0-9a-f]{40}$/i;
    function a(d) {
      return (0, r.default)(d), o.test(d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(O0, O0.exports)), O0.exports;
}
var LF = /* @__PURE__ */ ah();
const FF = /* @__PURE__ */ $e(LF);
var dh = "isEthereumAddress";
function ih(e) {
  return typeof e == "string" && FF(e);
}
function kF(e) {
  return W({
    name: dh,
    validator: {
      validate: function(t, r) {
        return ih(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be an Ethereum address";
      }, e)
    }
  }, e);
}
var N0 = { exports: {} }, S3;
function sh() {
  return S3 || (S3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = n(/* @__PURE__ */ J());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var o = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(,(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}(,((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?))?\)$/i, a = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(\s(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}\s?(\/\s((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?)\s?)?\)$/i;
    function d(i) {
      (0, r.default)(i);
      var s = i.replace(/\s+/g, " ").replace(/\s?(hsla?\(|\)|,)\s?/ig, "$1");
      return s.indexOf(",") !== -1 ? o.test(s) : a.test(s);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(N0, N0.exports)), N0.exports;
}
var jF = /* @__PURE__ */ sh();
const BF = /* @__PURE__ */ $e(jF);
var uh = "isHSL";
function lh(e) {
  return typeof e == "string" && BF(e);
}
function ZF(e) {
  return W({
    name: uh,
    validator: {
      validate: function(t, r) {
        return lh(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be a HSL color";
      }, e)
    }
  }, e);
}
var Fn = {}, _3;
function ch() {
  if (_3) return Fn;
  _3 = 1, Object.defineProperty(Fn, "__esModule", {
    value: !0
  }), Fn.default = d, Fn.locales = void 0;
  var e = t(/* @__PURE__ */ J());
  function t(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var r = {
    AD: /^(AD[0-9]{2})\d{8}[A-Z0-9]{12}$/,
    AE: /^(AE[0-9]{2})\d{3}\d{16}$/,
    AL: /^(AL[0-9]{2})\d{8}[A-Z0-9]{16}$/,
    AT: /^(AT[0-9]{2})\d{16}$/,
    AZ: /^(AZ[0-9]{2})[A-Z0-9]{4}\d{20}$/,
    BA: /^(BA[0-9]{2})\d{16}$/,
    BE: /^(BE[0-9]{2})\d{12}$/,
    BG: /^(BG[0-9]{2})[A-Z]{4}\d{6}[A-Z0-9]{8}$/,
    BH: /^(BH[0-9]{2})[A-Z]{4}[A-Z0-9]{14}$/,
    BR: /^(BR[0-9]{2})\d{23}[A-Z]{1}[A-Z0-9]{1}$/,
    BY: /^(BY[0-9]{2})[A-Z0-9]{4}\d{20}$/,
    CH: /^(CH[0-9]{2})\d{5}[A-Z0-9]{12}$/,
    CR: /^(CR[0-9]{2})\d{18}$/,
    CY: /^(CY[0-9]{2})\d{8}[A-Z0-9]{16}$/,
    CZ: /^(CZ[0-9]{2})\d{20}$/,
    DE: /^(DE[0-9]{2})\d{18}$/,
    DK: /^(DK[0-9]{2})\d{14}$/,
    DO: /^(DO[0-9]{2})[A-Z]{4}\d{20}$/,
    DZ: /^(DZ\d{24})$/,
    EE: /^(EE[0-9]{2})\d{16}$/,
    EG: /^(EG[0-9]{2})\d{25}$/,
    ES: /^(ES[0-9]{2})\d{20}$/,
    FI: /^(FI[0-9]{2})\d{14}$/,
    FO: /^(FO[0-9]{2})\d{14}$/,
    FR: /^(FR[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
    GB: /^(GB[0-9]{2})[A-Z]{4}\d{14}$/,
    GE: /^(GE[0-9]{2})[A-Z0-9]{2}\d{16}$/,
    GI: /^(GI[0-9]{2})[A-Z]{4}[A-Z0-9]{15}$/,
    GL: /^(GL[0-9]{2})\d{14}$/,
    GR: /^(GR[0-9]{2})\d{7}[A-Z0-9]{16}$/,
    GT: /^(GT[0-9]{2})[A-Z0-9]{4}[A-Z0-9]{20}$/,
    HR: /^(HR[0-9]{2})\d{17}$/,
    HU: /^(HU[0-9]{2})\d{24}$/,
    IE: /^(IE[0-9]{2})[A-Z]{4}\d{14}$/,
    IL: /^(IL[0-9]{2})\d{19}$/,
    IQ: /^(IQ[0-9]{2})[A-Z]{4}\d{15}$/,
    IR: /^(IR[0-9]{2})0\d{2}0\d{18}$/,
    IS: /^(IS[0-9]{2})\d{22}$/,
    IT: /^(IT[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
    JO: /^(JO[0-9]{2})[A-Z]{4}\d{22}$/,
    KW: /^(KW[0-9]{2})[A-Z]{4}[A-Z0-9]{22}$/,
    KZ: /^(KZ[0-9]{2})\d{3}[A-Z0-9]{13}$/,
    LB: /^(LB[0-9]{2})\d{4}[A-Z0-9]{20}$/,
    LC: /^(LC[0-9]{2})[A-Z]{4}[A-Z0-9]{24}$/,
    LI: /^(LI[0-9]{2})\d{5}[A-Z0-9]{12}$/,
    LT: /^(LT[0-9]{2})\d{16}$/,
    LU: /^(LU[0-9]{2})\d{3}[A-Z0-9]{13}$/,
    LV: /^(LV[0-9]{2})[A-Z]{4}[A-Z0-9]{13}$/,
    MA: /^(MA[0-9]{26})$/,
    MC: /^(MC[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
    MD: /^(MD[0-9]{2})[A-Z0-9]{20}$/,
    ME: /^(ME[0-9]{2})\d{18}$/,
    MK: /^(MK[0-9]{2})\d{3}[A-Z0-9]{10}\d{2}$/,
    MR: /^(MR[0-9]{2})\d{23}$/,
    MT: /^(MT[0-9]{2})[A-Z]{4}\d{5}[A-Z0-9]{18}$/,
    MU: /^(MU[0-9]{2})[A-Z]{4}\d{19}[A-Z]{3}$/,
    MZ: /^(MZ[0-9]{2})\d{21}$/,
    NL: /^(NL[0-9]{2})[A-Z]{4}\d{10}$/,
    NO: /^(NO[0-9]{2})\d{11}$/,
    PK: /^(PK[0-9]{2})[A-Z0-9]{4}\d{16}$/,
    PL: /^(PL[0-9]{2})\d{24}$/,
    PS: /^(PS[0-9]{2})[A-Z]{4}[A-Z0-9]{21}$/,
    PT: /^(PT[0-9]{2})\d{21}$/,
    QA: /^(QA[0-9]{2})[A-Z]{4}[A-Z0-9]{21}$/,
    RO: /^(RO[0-9]{2})[A-Z]{4}[A-Z0-9]{16}$/,
    RS: /^(RS[0-9]{2})\d{18}$/,
    SA: /^(SA[0-9]{2})\d{2}[A-Z0-9]{18}$/,
    SC: /^(SC[0-9]{2})[A-Z]{4}\d{20}[A-Z]{3}$/,
    SE: /^(SE[0-9]{2})\d{20}$/,
    SI: /^(SI[0-9]{2})\d{15}$/,
    SK: /^(SK[0-9]{2})\d{20}$/,
    SM: /^(SM[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
    SV: /^(SV[0-9]{2})[A-Z0-9]{4}\d{20}$/,
    TL: /^(TL[0-9]{2})\d{19}$/,
    TN: /^(TN[0-9]{2})\d{20}$/,
    TR: /^(TR[0-9]{2})\d{5}[A-Z0-9]{17}$/,
    UA: /^(UA[0-9]{2})\d{6}[A-Z0-9]{19}$/,
    VA: /^(VA[0-9]{2})\d{18}$/,
    VG: /^(VG[0-9]{2})[A-Z]{4}\d{16}$/,
    XK: /^(XK[0-9]{2})\d{16}$/
  };
  function n(i) {
    var s = i.filter(function(u) {
      return !(u in r);
    });
    return !(s.length > 0);
  }
  function o(i, s) {
    var u = i.replace(/[\s\-]+/gi, "").toUpperCase(), c = u.slice(0, 2).toUpperCase(), l = c in r;
    if (s.whitelist) {
      if (!n(s.whitelist))
        return !1;
      var p = s.whitelist.includes(c);
      if (!p)
        return !1;
    }
    if (s.blacklist) {
      var h = s.blacklist.includes(c);
      if (h)
        return !1;
    }
    return l && r[c].test(u);
  }
  function a(i) {
    var s = i.replace(/[^A-Z0-9]+/gi, "").toUpperCase(), u = s.slice(4) + s.slice(0, 4), c = u.replace(/[A-Z]/g, function(p) {
      return p.charCodeAt(0) - 55;
    }), l = c.match(/\d{1,7}/g).reduce(function(p, h) {
      return Number(p + h) % 97;
    }, "");
    return l === 1;
  }
  function d(i) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return (0, e.default)(i), o(i, s) && a(i);
  }
  return Fn.locales = Object.keys(r), Fn;
}
var UF = /* @__PURE__ */ ch();
const GF = /* @__PURE__ */ $e(UF);
var fh = "isIBAN";
function ph(e) {
  return typeof e == "string" && GF(e);
}
function VF(e) {
  return W({
    name: fh,
    validator: {
      validate: function(t, r) {
        return ph(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be an IBAN";
      }, e)
    }
  }, e);
}
var I0 = { exports: {} }, E3;
function $h() {
  return E3 || (E3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = o(/* @__PURE__ */ J()), n = o(/* @__PURE__ */ H1());
    function o(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var a = {
      PL: function(i) {
        (0, r.default)(i);
        var s = {
          1: 1,
          2: 3,
          3: 7,
          4: 9,
          5: 1,
          6: 3,
          7: 7,
          8: 9,
          9: 1,
          10: 3,
          11: 0
        };
        if (i != null && i.length === 11 && (0, n.default)(i, {
          allow_leading_zeroes: !0
        })) {
          var u = i.split("").slice(0, -1), c = u.reduce(function(h, m, f) {
            return h + Number(m) * s[f + 1];
          }, 0), l = c % 10, p = Number(i.charAt(i.length - 1));
          if (l === 0 && p === 0 || p === 10 - l)
            return !0;
        }
        return !1;
      },
      ES: function(i) {
        (0, r.default)(i);
        var s = /^[0-9X-Z][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/, u = {
          X: 0,
          Y: 1,
          Z: 2
        }, c = ["T", "R", "W", "A", "G", "M", "Y", "F", "P", "D", "X", "B", "N", "J", "Z", "S", "Q", "V", "H", "L", "C", "K", "E"], l = i.trim().toUpperCase();
        if (!s.test(l))
          return !1;
        var p = l.slice(0, -1).replace(/[X,Y,Z]/g, function(h) {
          return u[h];
        });
        return l.endsWith(c[p % 23]);
      },
      FI: function(i) {
        if ((0, r.default)(i), i.length !== 11 || !i.match(/^\d{6}[\-A\+]\d{3}[0-9ABCDEFHJKLMNPRSTUVWXY]{1}$/))
          return !1;
        var s = "0123456789ABCDEFHJKLMNPRSTUVWXY", u = parseInt(i.slice(0, 6), 10) * 1e3 + parseInt(i.slice(7, 10), 10), c = u % 31, l = s[c];
        return l === i.slice(10, 11);
      },
      IN: function(i) {
        var s = /^[1-9]\d{3}\s?\d{4}\s?\d{4}$/, u = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 2, 3, 4, 0, 6, 7, 8, 9, 5], [2, 3, 4, 0, 1, 7, 8, 9, 5, 6], [3, 4, 0, 1, 2, 8, 9, 5, 6, 7], [4, 0, 1, 2, 3, 9, 5, 6, 7, 8], [5, 9, 8, 7, 6, 0, 4, 3, 2, 1], [6, 5, 9, 8, 7, 1, 0, 4, 3, 2], [7, 6, 5, 9, 8, 2, 1, 0, 4, 3], [8, 7, 6, 5, 9, 3, 2, 1, 0, 4], [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]], c = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 5, 7, 6, 2, 8, 3, 0, 9, 4], [5, 8, 0, 3, 7, 9, 6, 1, 4, 2], [8, 9, 1, 6, 0, 4, 3, 5, 2, 7], [9, 4, 5, 3, 1, 2, 6, 8, 7, 0], [4, 2, 8, 6, 5, 7, 3, 9, 0, 1], [2, 7, 9, 3, 8, 0, 6, 4, 1, 5], [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]], l = i.trim();
        if (!s.test(l))
          return !1;
        var p = 0, h = l.replace(/\s/g, "").split("").map(Number).reverse();
        return h.forEach(function(m, f) {
          p = u[p][c[f % 8][m]];
        }), p === 0;
      },
      IR: function(i) {
        if (!i.match(/^\d{10}$/) || (i = "0000".concat(i).slice(i.length - 6), parseInt(i.slice(3, 9), 10) === 0)) return !1;
        for (var s = parseInt(i.slice(9, 10), 10), u = 0, c = 0; c < 9; c++)
          u += parseInt(i.slice(c, c + 1), 10) * (10 - c);
        return u %= 11, u < 2 && s === u || u >= 2 && s === 11 - u;
      },
      IT: function(i) {
        return i.length !== 9 || i === "CA00000AA" ? !1 : i.search(/C[A-Z]\d{5}[A-Z]{2}/i) > -1;
      },
      NO: function(i) {
        var s = i.trim();
        if (isNaN(Number(s)) || s.length !== 11 || s === "00000000000") return !1;
        var u = s.split("").map(Number), c = (11 - (3 * u[0] + 7 * u[1] + 6 * u[2] + 1 * u[3] + 8 * u[4] + 9 * u[5] + 4 * u[6] + 5 * u[7] + 2 * u[8]) % 11) % 11, l = (11 - (5 * u[0] + 4 * u[1] + 3 * u[2] + 2 * u[3] + 7 * u[4] + 6 * u[5] + 5 * u[6] + 4 * u[7] + 3 * u[8] + 2 * c) % 11) % 11;
        return !(c !== u[9] || l !== u[10]);
      },
      TH: function(i) {
        if (!i.match(/^[1-8]\d{12}$/)) return !1;
        for (var s = 0, u = 0; u < 12; u++)
          s += parseInt(i[u], 10) * (13 - u);
        return i[12] === ((11 - s % 11) % 10).toString();
      },
      LK: function(i) {
        var s = /^[1-9]\d{8}[vx]$/i, u = /^[1-9]\d{11}$/i;
        return i.length === 10 && s.test(i) ? !0 : !!(i.length === 12 && u.test(i));
      },
      "he-IL": function(i) {
        var s = /^\d{9}$/, u = i.trim();
        if (!s.test(u))
          return !1;
        for (var c = u, l = 0, p, h = 0; h < c.length; h++)
          p = Number(c[h]) * (h % 2 + 1), l += p > 9 ? p - 9 : p;
        return l % 10 === 0;
      },
      "ar-LY": function(i) {
        var s = /^(1|2)\d{11}$/, u = i.trim();
        return !!s.test(u);
      },
      "ar-TN": function(i) {
        var s = /^\d{8}$/, u = i.trim();
        return !!s.test(u);
      },
      "zh-CN": function(i) {
        var s = [
          "11",
          // 北京
          "12",
          // 天津
          "13",
          // 河北
          "14",
          // 山西
          "15",
          // 内蒙古
          "21",
          // 辽宁
          "22",
          // 吉林
          "23",
          // 黑龙江
          "31",
          // 上海
          "32",
          // 江苏
          "33",
          // 浙江
          "34",
          // 安徽
          "35",
          // 福建
          "36",
          // 江西
          "37",
          // 山东
          "41",
          // 河南
          "42",
          // 湖北
          "43",
          // 湖南
          "44",
          // 广东
          "45",
          // 广西
          "46",
          // 海南
          "50",
          // 重庆
          "51",
          // 四川
          "52",
          // 贵州
          "53",
          // 云南
          "54",
          // 西藏
          "61",
          // 陕西
          "62",
          // 甘肃
          "63",
          // 青海
          "64",
          // 宁夏
          "65",
          // 新疆
          "71",
          // 台湾
          "81",
          // 香港
          "82",
          // 澳门
          "91"
          // 国外
        ], u = ["7", "9", "10", "5", "8", "4", "2", "1", "6", "3", "7", "9", "10", "5", "8", "4", "2"], c = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"], l = function(y) {
          return s.includes(y);
        }, p = function(y) {
          var S = parseInt(y.substring(0, 4), 10), w = parseInt(y.substring(4, 6), 10), _ = parseInt(y.substring(6), 10), I = new Date(S, w - 1, _);
          return I > /* @__PURE__ */ new Date() ? !1 : I.getFullYear() === S && I.getMonth() === w - 1 && I.getDate() === _;
        }, h = function(y) {
          for (var S = y.substring(0, 17), w = 0, _ = 0; _ < 17; _++)
            w += parseInt(S.charAt(_), 10) * parseInt(u[_], 10);
          var I = w % 11;
          return c[I];
        }, m = function(y) {
          return h(y) === y.charAt(17).toUpperCase();
        }, f = function(y) {
          var S = /^[1-9]\d{7}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}$/.test(y);
          if (!S) return !1;
          var w = y.substring(0, 2);
          if (S = l(w), !S) return !1;
          var _ = "19".concat(y.substring(6, 12));
          return S = p(_), !!S;
        }, $ = function(y) {
          var S = /^[1-9]\d{5}[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}(\d|x|X)$/.test(y);
          if (!S) return !1;
          var w = y.substring(0, 2);
          if (S = l(w), !S) return !1;
          var _ = y.substring(6, 14);
          return S = p(_), S ? m(y) : !1;
        }, v = function(y) {
          var S = /^\d{15}|(\d{17}(\d|x|X))$/.test(y);
          return S ? y.length === 15 ? f(y) : $(y) : !1;
        };
        return v(i);
      },
      "zh-HK": function(i) {
        i = i.trim();
        var s = /^[A-Z]{1,2}[0-9]{6}((\([0-9A]\))|(\[[0-9A]\])|([0-9A]))$/, u = /^[0-9]$/;
        if (i = i.toUpperCase(), !s.test(i)) return !1;
        i = i.replace(/\[|\]|\(|\)/g, ""), i.length === 8 && (i = "3".concat(i));
        for (var c = 0, l = 0; l <= 7; l++) {
          var p = void 0;
          u.test(i[l]) ? p = i[l] : p = (i[l].charCodeAt(0) - 55) % 11, c += p * (9 - l);
        }
        c %= 11;
        var h;
        return c === 0 ? h = "0" : c === 1 ? h = "A" : h = String(11 - c), h === i[i.length - 1];
      },
      "zh-TW": function(i) {
        var s = {
          A: 10,
          B: 11,
          C: 12,
          D: 13,
          E: 14,
          F: 15,
          G: 16,
          H: 17,
          I: 34,
          J: 18,
          K: 19,
          L: 20,
          M: 21,
          N: 22,
          O: 35,
          P: 23,
          Q: 24,
          R: 25,
          S: 26,
          T: 27,
          U: 28,
          V: 29,
          W: 32,
          X: 30,
          Y: 31,
          Z: 33
        }, u = i.trim().toUpperCase();
        return /^[A-Z][0-9]{9}$/.test(u) ? Array.from(u).reduce(function(c, l, p) {
          if (p === 0) {
            var h = s[l];
            return h % 10 * 9 + Math.floor(h / 10);
          }
          return p === 9 ? (10 - c % 10 - Number(l)) % 10 === 0 : c + Number(l) * (9 - p);
        }, 0) : !1;
      },
      PK: function(i) {
        var s = /^[1-7][0-9]{4}-[0-9]{7}-[1-9]$/, u = i.trim();
        return s.test(u);
      }
    };
    function d(i, s) {
      if ((0, r.default)(i), s in a)
        return a[s](i);
      if (s === "any") {
        for (var u in a)
          if (a.hasOwnProperty(u)) {
            var c = a[u];
            if (c(i))
              return !0;
          }
        return !1;
      }
      throw new Error("Invalid locale '".concat(s, "'"));
    }
    e.exports = t.default, e.exports.default = t.default;
  }(I0, I0.exports)), I0.exports;
}
var HF = /* @__PURE__ */ $h();
const KF = /* @__PURE__ */ $e(HF);
var vh = "isIdentityCard";
function mh(e, t) {
  return typeof e == "string" && KF(e, t);
}
function WF(e, t) {
  return W({
    name: vh,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return mh(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must be a identity card number";
      }, t)
    }
  }, t);
}
var P0 = { exports: {} }, M3;
function hh() {
  return M3 || (M3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ J());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /^[A-Z]{2}[0-9A-Z]{3}\d{2}\d{5}$/;
    function a(d) {
      return (0, r.default)(d), o.test(d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(P0, P0.exports)), P0.exports;
}
var zF = /* @__PURE__ */ hh();
const YF = /* @__PURE__ */ $e(zF);
var gh = "isISRC";
function yh(e) {
  return typeof e == "string" && YF(e);
}
function XF(e) {
  return W({
    name: gh,
    validator: {
      validate: function(t, r) {
        return yh(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be an ISRC";
      }, e)
    }
  }, e);
}
var R0 = { exports: {} }, C3;
function bh() {
  return C3 || (C3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = y;
    var r = n(/* @__PURE__ */ J());
    function n(S) {
      return S && S.__esModule ? S : { default: S };
    }
    var o = "([A-Za-z]{3}(-[A-Za-z]{3}){0,2})", a = "(([a-zA-Z]{2,3}(-".concat(o, ")?)|([a-zA-Z]{5,8}))"), d = "([A-Za-z]{4})", i = "([A-Za-z]{2}|\\d{3})", s = "([A-Za-z0-9]{5,8}|(\\d[A-Z-a-z0-9]{3}))", u = "(\\d|[A-W]|[Y-Z]|[a-w]|[y-z])", c = "(".concat(u, "(-[A-Za-z0-9]{2,8})+)"), l = "(x(-[A-Za-z0-9]{1,8})+)", p = "((en-GB-oed)|(i-ami)|(i-bnn)|(i-default)|(i-enochian)|(i-hak)|(i-klingon)|(i-lux)|(i-mingo)|(i-navajo)|(i-pwn)|(i-tao)|(i-tay)|(i-tsu)|(sgn-BE-FR)|(sgn-BE-NL)|(sgn-CH-DE))", h = "((art-lojban)|(cel-gaulish)|(no-bok)|(no-nyn)|(zh-guoyu)|(zh-hakka)|(zh-min)|(zh-min-nan)|(zh-xiang))", m = "(".concat(p, "|").concat(h, ")"), f = "(-|_)", $ = "".concat(a, "(").concat(f).concat(d, ")?(").concat(f).concat(i, ")?(").concat(f).concat(s, ")*(").concat(f).concat(c, ")*(").concat(f).concat(l, ")?"), v = new RegExp("(^".concat(l, "$)|(^").concat(m, "$)|(^").concat($, "$)"));
    function y(S) {
      return (0, r.default)(S), v.test(S);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(R0, R0.exports)), R0.exports;
}
var qF = /* @__PURE__ */ bh();
const JF = /* @__PURE__ */ $e(qF);
var xh = "isLocale";
function wh(e) {
  return typeof e == "string" && JF(e);
}
function QF(e) {
  return W({
    name: xh,
    validator: {
      validate: function(t, r) {
        return wh(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be locale";
      }, e)
    }
  }, e);
}
var T0 = { exports: {} }, O3;
function Ah() {
  return O3 || (O3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ J());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /(?:^magnet:\?|[^?&]&)xt(?:\.1)?=urn:(?:(?:aich|bitprint|btih|ed2k|ed2khash|kzhash|md5|sha1|tree:tiger):[a-z0-9]{32}(?:[a-z0-9]{8})?|btmh:1220[a-z0-9]{64})(?:$|&)/i;
    function a(d) {
      return (0, r.default)(d), d.indexOf("magnet:?") !== 0 ? !1 : o.test(d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(T0, T0.exports)), T0.exports;
}
var ek = /* @__PURE__ */ Ah();
const tk = /* @__PURE__ */ $e(ek);
var Sh = "isMagnetURI";
function _h(e) {
  return typeof e == "string" && tk(e);
}
function rk(e) {
  return W({
    name: Sh,
    validator: {
      validate: function(t, r) {
        return _h(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be magnet uri format";
      }, e)
    }
  }, e);
}
var D0 = { exports: {} }, N3;
function Eh() {
  return N3 || (N3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var r = n(/* @__PURE__ */ J());
    function n(s) {
      return s && s.__esModule ? s : { default: s };
    }
    var o = /^(application|audio|font|image|message|model|multipart|text|video)\/[a-zA-Z0-9\.\-\+_]{1,100}$/i, a = /^text\/[a-zA-Z0-9\.\-\+]{1,100};\s?charset=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?$/i, d = /^multipart\/[a-zA-Z0-9\.\-\+]{1,100}(;\s?(boundary|charset)=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?){0,2}$/i;
    function i(s) {
      return (0, r.default)(s), o.test(s) || a.test(s) || d.test(s);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(D0, D0.exports)), D0.exports;
}
var nk = /* @__PURE__ */ Eh();
const ok = /* @__PURE__ */ $e(nk);
var Mh = "isMimeType";
function Ch(e) {
  return typeof e == "string" && ok(e);
}
function ak(e) {
  return W({
    name: Mh,
    validator: {
      validate: function(t, r) {
        return Ch(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be MIME type format";
      }, e)
    }
  }, e);
}
var L0 = { exports: {} }, I3;
function Oh() {
  return I3 || (I3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ J());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /^(0o)?[0-7]+$/i;
    function a(d) {
      return (0, r.default)(d), o.test(d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(L0, L0.exports)), L0.exports;
}
var dk = /* @__PURE__ */ Oh();
const ik = /* @__PURE__ */ $e(dk);
var Nh = "isOctal";
function Ih(e) {
  return typeof e == "string" && ik(e);
}
function sk(e) {
  return W({
    name: Nh,
    validator: {
      validate: function(t, r) {
        return Ih(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be valid octal number";
      }, e)
    }
  }, e);
}
var kn = {}, P3;
function Ph() {
  if (P3) return kn;
  P3 = 1, Object.defineProperty(kn, "__esModule", {
    value: !0
  }), kn.default = n, kn.locales = void 0;
  var e = t(/* @__PURE__ */ J());
  function t(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var r = {
    AM: /^[A-Z]{2}\d{7}$/,
    // ARMENIA
    AR: /^[A-Z]{3}\d{6}$/,
    // ARGENTINA
    AT: /^[A-Z]\d{7}$/,
    // AUSTRIA
    AU: /^[A-Z]\d{7}$/,
    // AUSTRALIA
    AZ: /^[A-Z]{1}\d{8}$/,
    // AZERBAIJAN
    BE: /^[A-Z]{2}\d{6}$/,
    // BELGIUM
    BG: /^\d{9}$/,
    // BULGARIA
    BR: /^[A-Z]{2}\d{6}$/,
    // BRAZIL
    BY: /^[A-Z]{2}\d{7}$/,
    // BELARUS
    CA: /^[A-Z]{2}\d{6}$/,
    // CANADA
    CH: /^[A-Z]\d{7}$/,
    // SWITZERLAND
    CN: /^G\d{8}$|^E(?![IO])[A-Z0-9]\d{7}$/,
    // CHINA [G=Ordinary, E=Electronic] followed by 8-digits, or E followed by any UPPERCASE letter (except I and O) followed by 7 digits
    CY: /^[A-Z](\d{6}|\d{8})$/,
    // CYPRUS
    CZ: /^\d{8}$/,
    // CZECH REPUBLIC
    DE: /^[CFGHJKLMNPRTVWXYZ0-9]{9}$/,
    // GERMANY
    DK: /^\d{9}$/,
    // DENMARK
    DZ: /^\d{9}$/,
    // ALGERIA
    EE: /^([A-Z]\d{7}|[A-Z]{2}\d{7})$/,
    // ESTONIA (K followed by 7-digits), e-passports have 2 UPPERCASE followed by 7 digits
    ES: /^[A-Z0-9]{2}([A-Z0-9]?)\d{6}$/,
    // SPAIN
    FI: /^[A-Z]{2}\d{7}$/,
    // FINLAND
    FR: /^\d{2}[A-Z]{2}\d{5}$/,
    // FRANCE
    GB: /^\d{9}$/,
    // UNITED KINGDOM
    GR: /^[A-Z]{2}\d{7}$/,
    // GREECE
    HR: /^\d{9}$/,
    // CROATIA
    HU: /^[A-Z]{2}(\d{6}|\d{7})$/,
    // HUNGARY
    IE: /^[A-Z0-9]{2}\d{7}$/,
    // IRELAND
    IN: /^[A-Z]{1}-?\d{7}$/,
    // INDIA
    ID: /^[A-C]\d{7}$/,
    // INDONESIA
    IR: /^[A-Z]\d{8}$/,
    // IRAN
    IS: /^(A)\d{7}$/,
    // ICELAND
    IT: /^[A-Z0-9]{2}\d{7}$/,
    // ITALY
    JM: /^[Aa]\d{7}$/,
    // JAMAICA
    JP: /^[A-Z]{2}\d{7}$/,
    // JAPAN
    KR: /^[MS]\d{8}$/,
    // SOUTH KOREA, REPUBLIC OF KOREA, [S=PS Passports, M=PM Passports]
    KZ: /^[a-zA-Z]\d{7}$/,
    // KAZAKHSTAN
    LI: /^[a-zA-Z]\d{5}$/,
    // LIECHTENSTEIN
    LT: /^[A-Z0-9]{8}$/,
    // LITHUANIA
    LU: /^[A-Z0-9]{8}$/,
    // LUXEMBURG
    LV: /^[A-Z0-9]{2}\d{7}$/,
    // LATVIA
    LY: /^[A-Z0-9]{8}$/,
    // LIBYA
    MT: /^\d{7}$/,
    // MALTA
    MZ: /^([A-Z]{2}\d{7})|(\d{2}[A-Z]{2}\d{5})$/,
    // MOZAMBIQUE
    MY: /^[AHK]\d{8}$/,
    // MALAYSIA
    MX: /^\d{10,11}$/,
    // MEXICO
    NL: /^[A-Z]{2}[A-Z0-9]{6}\d$/,
    // NETHERLANDS
    NZ: /^([Ll]([Aa]|[Dd]|[Ff]|[Hh])|[Ee]([Aa]|[Pp])|[Nn])\d{6}$/,
    // NEW ZEALAND
    PH: /^([A-Z](\d{6}|\d{7}[A-Z]))|([A-Z]{2}(\d{6}|\d{7}))$/,
    // PHILIPPINES
    PK: /^[A-Z]{2}\d{7}$/,
    // PAKISTAN
    PL: /^[A-Z]{2}\d{7}$/,
    // POLAND
    PT: /^[A-Z]\d{6}$/,
    // PORTUGAL
    RO: /^\d{8,9}$/,
    // ROMANIA
    RU: /^\d{9}$/,
    // RUSSIAN FEDERATION
    SE: /^\d{8}$/,
    // SWEDEN
    SL: /^(P)[A-Z]\d{7}$/,
    // SLOVENIA
    SK: /^[0-9A-Z]\d{7}$/,
    // SLOVAKIA
    TH: /^[A-Z]{1,2}\d{6,7}$/,
    // THAILAND
    TR: /^[A-Z]\d{8}$/,
    // TURKEY
    UA: /^[A-Z]{2}\d{6}$/,
    // UKRAINE
    US: /^\d{9}$/,
    // UNITED STATES
    ZA: /^[TAMD]\d{8}$/
    // SOUTH AFRICA
  };
  kn.locales = Object.keys(r);
  function n(o, a) {
    (0, e.default)(o);
    var d = o.replace(/\s/g, "").toUpperCase();
    return a.toUpperCase() in r && r[a].test(d);
  }
  return kn;
}
var uk = /* @__PURE__ */ Ph();
const lk = /* @__PURE__ */ $e(uk);
var Rh = "isPassportNumber";
function Th(e, t) {
  return typeof e == "string" && lk(e, t);
}
function ck(e, t) {
  return W({
    name: Rh,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Th(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must be valid passport number";
      }, t)
    }
  }, t);
}
var jn = {}, R3;
function Dh() {
  if (R3) return jn;
  R3 = 1, Object.defineProperty(jn, "__esModule", {
    value: !0
  }), jn.default = i, jn.locales = void 0;
  var e = t(/* @__PURE__ */ J());
  function t(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var r = /^\d{3}$/, n = /^\d{4}$/, o = /^\d{5}$/, a = /^\d{6}$/, d = {
    AD: /^AD\d{3}$/,
    AT: n,
    AU: n,
    AZ: /^AZ\d{4}$/,
    BA: /^([7-8]\d{4}$)/,
    BE: n,
    BG: n,
    BR: /^\d{5}-?\d{3}$/,
    BY: /^2[1-4]\d{4}$/,
    CA: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][\s\-]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
    CH: n,
    CN: /^(0[1-7]|1[012356]|2[0-7]|3[0-6]|4[0-7]|5[1-7]|6[1-7]|7[1-5]|8[1345]|9[09])\d{4}$/,
    CO: /^(05|08|11|13|15|17|18|19|20|23|25|27|41|44|47|50|52|54|63|66|68|70|73|76|81|85|86|88|91|94|95|97|99)(\d{4})$/,
    CZ: /^\d{3}\s?\d{2}$/,
    DE: o,
    DK: n,
    DO: o,
    DZ: o,
    EE: o,
    ES: /^(5[0-2]{1}|[0-4]{1}\d{1})\d{3}$/,
    FI: o,
    FR: /^\d{2}\s?\d{3}$/,
    GB: /^(gir\s?0aa|[a-z]{1,2}\d[\da-z]?\s?(\d[a-z]{2})?)$/i,
    GR: /^\d{3}\s?\d{2}$/,
    HR: /^([1-5]\d{4}$)/,
    HT: /^HT\d{4}$/,
    HU: n,
    ID: o,
    IE: /^(?!.*(?:o))[A-Za-z]\d[\dw]\s\w{4}$/i,
    IL: /^(\d{5}|\d{7})$/,
    IN: /^((?!10|29|35|54|55|65|66|86|87|88|89)[1-9][0-9]{5})$/,
    IR: /^(?!(\d)\1{3})[13-9]{4}[1346-9][013-9]{5}$/,
    IS: r,
    IT: o,
    JP: /^\d{3}\-\d{4}$/,
    KE: o,
    KR: /^(\d{5}|\d{6})$/,
    LI: /^(948[5-9]|949[0-7])$/,
    LT: /^LT\-\d{5}$/,
    LU: n,
    LV: /^LV\-\d{4}$/,
    LK: o,
    MG: r,
    MX: o,
    MT: /^[A-Za-z]{3}\s{0,1}\d{4}$/,
    MY: o,
    NL: /^[1-9]\d{3}\s?(?!sa|sd|ss)[a-z]{2}$/i,
    NO: n,
    NP: /^(10|21|22|32|33|34|44|45|56|57)\d{3}$|^(977)$/i,
    NZ: n,
    PL: /^\d{2}\-\d{3}$/,
    PR: /^00[679]\d{2}([ -]\d{4})?$/,
    PT: /^\d{4}\-\d{3}?$/,
    RO: a,
    RU: a,
    SA: o,
    SE: /^[1-9]\d{2}\s?\d{2}$/,
    SG: a,
    SI: n,
    SK: /^\d{3}\s?\d{2}$/,
    TH: o,
    TN: n,
    TW: /^\d{3}(\d{2})?$/,
    UA: o,
    US: /^\d{5}(-\d{4})?$/,
    ZA: n,
    ZM: o
  };
  jn.locales = Object.keys(d);
  function i(s, u) {
    if ((0, e.default)(s), u in d)
      return d[u].test(s);
    if (u === "any") {
      for (var c in d)
        if (d.hasOwnProperty(c)) {
          var l = d[c];
          if (l.test(s))
            return !0;
        }
      return !1;
    }
    throw new Error("Invalid locale '".concat(u, "'"));
  }
  return jn;
}
var fk = /* @__PURE__ */ Dh();
const pk = /* @__PURE__ */ $e(fk);
var Lh = "isPostalCode";
function Fh(e, t) {
  return typeof e == "string" && pk(e, t);
}
function $k(e, t) {
  return W({
    name: Lh,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Fh(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must be a postal code";
      }, t)
    }
  }, t);
}
var F0 = { exports: {} }, T3;
function kh() {
  return T3 || (T3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = v;
    var r = n(/* @__PURE__ */ J());
    function n(y) {
      return y && y.__esModule ? y : { default: y };
    }
    var o = /[0-9]{4}/, a = /(0[1-9]|1[0-2])/, d = /([12]\d|0[1-9]|3[01])/, i = /([01][0-9]|2[0-3])/, s = /[0-5][0-9]/, u = /([0-5][0-9]|60)/, c = /(\.[0-9]+)?/, l = new RegExp("[-+]".concat(i.source, ":").concat(s.source)), p = new RegExp("([zZ]|".concat(l.source, ")")), h = new RegExp("".concat(i.source, ":").concat(s.source, ":").concat(u.source).concat(c.source)), m = new RegExp("".concat(o.source, "-").concat(a.source, "-").concat(d.source)), f = new RegExp("".concat(h.source).concat(p.source)), $ = new RegExp("^".concat(m.source, "[ tT]").concat(f.source, "$"));
    function v(y) {
      return (0, r.default)(y), $.test(y);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(F0, F0.exports)), F0.exports;
}
var vk = /* @__PURE__ */ kh();
const mk = /* @__PURE__ */ $e(vk);
var jh = "isRFC3339";
function Bh(e) {
  return typeof e == "string" && mk(e);
}
function hk(e) {
  return W({
    name: jh,
    validator: {
      validate: function(t, r) {
        return Bh(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be RFC 3339 date";
      }, e)
    }
  }, e);
}
var k0 = { exports: {} }, D3;
function Zh() {
  return D3 || (D3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = c;
    var r = n(/* @__PURE__ */ J());
    function n(l) {
      return l && l.__esModule ? l : { default: l };
    }
    function o(l) {
      "@babel/helpers - typeof";
      return o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(p) {
        return typeof p;
      } : function(p) {
        return p && typeof Symbol == "function" && p.constructor === Symbol && p !== Symbol.prototype ? "symbol" : typeof p;
      }, o(l);
    }
    var a = /^rgb\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){2}([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\)$/, d = /^rgba\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)$/, i = /^rgb\((([0-9]%|[1-9][0-9]%|100%),){2}([0-9]%|[1-9][0-9]%|100%)\)$/, s = /^rgba\((([0-9]%|[1-9][0-9]%|100%),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)$/, u = /^rgba?/;
    function c(l, p) {
      (0, r.default)(l);
      var h = !1, m = !0;
      if (o(p) !== "object" ? arguments.length >= 2 && (m = arguments[1]) : (h = p.allowSpaces !== void 0 ? p.allowSpaces : h, m = p.includePercentValues !== void 0 ? p.includePercentValues : m), h) {
        if (!u.test(l))
          return !1;
        l = l.replace(/\s/g, "");
      }
      return m ? a.test(l) || d.test(l) || i.test(l) || s.test(l) : a.test(l) || d.test(l);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(k0, k0.exports)), k0.exports;
}
var gk = /* @__PURE__ */ Zh();
const yk = /* @__PURE__ */ $e(gk);
var Uh = "isRgbColor";
function Gh(e, t) {
  return typeof e == "string" && yk(e, t);
}
function bk(e, t) {
  return W({
    name: Uh,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Gh(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must be RGB color";
      }, t)
    }
  }, t);
}
var j0 = { exports: {} }, B0 = { exports: {} }, L3;
function xk() {
  return L3 || (L3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = r;
    function r(n, o) {
      var a = n.join("");
      return new RegExp(a, o);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(B0, B0.exports)), B0.exports;
}
var F3;
function Vh() {
  return F3 || (F3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = o(/* @__PURE__ */ J()), n = o(/* @__PURE__ */ xk());
    function o(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var a = (0, n.default)(["^(0|[1-9]\\d*)\\.(0|[1-9]\\d*)\\.(0|[1-9]\\d*)", "(?:-((?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*)(?:\\.(?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*))*))", "?(?:\\+([0-9a-z-]+(?:\\.[0-9a-z-]+)*))?$"], "i");
    function d(i) {
      return (0, r.default)(i), a.test(i);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(j0, j0.exports)), j0.exports;
}
var wk = /* @__PURE__ */ Vh();
const Ak = /* @__PURE__ */ $e(wk);
var Hh = "isSemVer";
function Kh(e) {
  return typeof e == "string" && Ak(e);
}
function Sk(e) {
  return W({
    name: Hh,
    validator: {
      validate: function(t, r) {
        return Kh(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be a Semantic Versioning Specification";
      }, e)
    }
  }, e);
}
var Z0 = { exports: {} }, U0 = { exports: {} }, k3;
function e2() {
  return k3 || (k3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ J());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a) {
      return (0, r.default)(a), a = Date.parse(a), isNaN(a) ? null : new Date(a);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(U0, U0.exports)), U0.exports;
}
var G0 = { exports: {} }, j3;
function _k() {
  return j3 || (j3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ J());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a, d) {
      return (0, r.default)(a), parseInt(a, d || 10);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(G0, G0.exports)), G0.exports;
}
var V0 = { exports: {} }, B3;
function Ek() {
  return B3 || (B3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ J());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a, d) {
      return (0, r.default)(a), d ? a === "1" || /^true$/i.test(a) : a !== "0" && !/^false$/i.test(a) && a !== "";
    }
    e.exports = t.default, e.exports.default = t.default;
  }(V0, V0.exports)), V0.exports;
}
var H0 = { exports: {} }, Z3;
function Mk() {
  return Z3 || (Z3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ J());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a, d) {
      return (0, r.default)(a), a === d;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(H0, H0.exports)), H0.exports;
}
var K0 = { exports: {} }, U3;
function Ck() {
  return U3 || (U3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = s;
    var r = o(/* @__PURE__ */ J()), n = o(/* @__PURE__ */ Na());
    function o(u) {
      return u && u.__esModule ? u : { default: u };
    }
    var a = /^\d{1,3}$/, d = 32, i = 128;
    function s(u) {
      var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
      (0, r.default)(u);
      var l = u.split("/");
      if (l.length !== 2 || !a.test(l[1]) || l[1].length > 1 && l[1].startsWith("0"))
        return !1;
      var p = (0, n.default)(l[0], c);
      if (!p)
        return !1;
      var h = null;
      switch (String(c)) {
        case "4":
          h = d;
          break;
        case "6":
          h = i;
          break;
        default:
          h = (0, n.default)(l[0], "6") ? i : d;
      }
      return l[1] <= h && l[1] >= 0;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(K0, K0.exports)), K0.exports;
}
var W0 = { exports: {} }, G3;
function Wh() {
  return G3 || (G3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = m;
    var r = n(/* @__PURE__ */ $t());
    function n(f) {
      return f && f.__esModule ? f : { default: f };
    }
    function o(f, $) {
      return i(f) || d(f, $) || u(f, $) || a();
    }
    function a() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function d(f, $) {
      var v = f == null ? null : typeof Symbol < "u" && f[Symbol.iterator] || f["@@iterator"];
      if (v != null) {
        var y, S, w, _, I = [], N = !0, O = !1;
        try {
          if (w = (v = v.call(f)).next, $ !== 0) for (; !(N = (y = w.call(v)).done) && (I.push(y.value), I.length !== $); N = !0) ;
        } catch (E) {
          O = !0, S = E;
        } finally {
          try {
            if (!N && v.return != null && (_ = v.return(), Object(_) !== _)) return;
          } finally {
            if (O) throw S;
          }
        }
        return I;
      }
    }
    function i(f) {
      if (Array.isArray(f)) return f;
    }
    function s(f, $) {
      var v = typeof Symbol < "u" && f[Symbol.iterator] || f["@@iterator"];
      if (!v) {
        if (Array.isArray(f) || (v = u(f)) || $) {
          v && (f = v);
          var y = 0, S = function() {
          };
          return { s: S, n: function() {
            return y >= f.length ? { done: !0 } : { done: !1, value: f[y++] };
          }, e: function(N) {
            throw N;
          }, f: S };
        }
        throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }
      var w, _ = !0, I = !1;
      return { s: function() {
        v = v.call(f);
      }, n: function() {
        var N = v.next();
        return _ = N.done, N;
      }, e: function(N) {
        I = !0, w = N;
      }, f: function() {
        try {
          _ || v.return == null || v.return();
        } finally {
          if (I) throw w;
        }
      } };
    }
    function u(f, $) {
      if (f) {
        if (typeof f == "string") return c(f, $);
        var v = {}.toString.call(f).slice(8, -1);
        return v === "Object" && f.constructor && (v = f.constructor.name), v === "Map" || v === "Set" ? Array.from(f) : v === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(v) ? c(f, $) : void 0;
      }
    }
    function c(f, $) {
      ($ == null || $ > f.length) && ($ = f.length);
      for (var v = 0, y = Array($); v < $; v++) y[v] = f[v];
      return y;
    }
    var l = {
      format: "YYYY/MM/DD",
      delimiters: ["/", "-"],
      strictMode: !1
    };
    function p(f) {
      return /(^(y{4}|y{2})[.\/-](m{1,2})[.\/-](d{1,2})$)|(^(m{1,2})[.\/-](d{1,2})[.\/-]((y{4}|y{2})$))|(^(d{1,2})[.\/-](m{1,2})[.\/-]((y{4}|y{2})$))/gi.test(f);
    }
    function h(f, $) {
      for (var v = [], y = Math.max(f.length, $.length), S = 0; S < y; S++)
        v.push([f[S], $[S]]);
      return v;
    }
    function m(f, $) {
      if (typeof $ == "string" ? $ = (0, r.default)({
        format: $
      }, l) : $ = (0, r.default)($, l), typeof f == "string" && p($.format)) {
        if ($.strictMode && f.length !== $.format.length) return !1;
        var v = $.delimiters.find(function(Z) {
          return $.format.indexOf(Z) !== -1;
        }), y = $.strictMode ? v : $.delimiters.find(function(Z) {
          return f.indexOf(Z) !== -1;
        }), S = h(f.split(y), $.format.toLowerCase().split(v)), w = {}, _ = s(S), I;
        try {
          for (_.s(); !(I = _.n()).done; ) {
            var N = o(I.value, 2), O = N[0], E = N[1];
            if (!O || !E || O.length !== E.length)
              return !1;
            w[E.charAt(0)] = O;
          }
        } catch (Z) {
          _.e(Z);
        } finally {
          _.f();
        }
        var C = w.y;
        if (C.startsWith("-"))
          return !1;
        if (w.y.length === 2) {
          var P = parseInt(w.y, 10);
          if (isNaN(P))
            return !1;
          var T = (/* @__PURE__ */ new Date()).getFullYear() % 100;
          P < T ? C = "20".concat(w.y) : C = "19".concat(w.y);
        }
        var j = w.m;
        w.m.length === 1 && (j = "0".concat(w.m));
        var F = w.d;
        return w.d.length === 1 && (F = "0".concat(w.d)), new Date("".concat(C, "-").concat(j, "-").concat(F, "T00:00:00.000Z")).getUTCDate() === +w.d;
      }
      return $.strictMode ? !1 : Object.prototype.toString.call(f) === "[object Date]" && isFinite(f);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(W0, W0.exports)), W0.exports;
}
var z0 = { exports: {} }, V3;
function Ok() {
  return V3 || (V3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = n(/* @__PURE__ */ $t());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var o = {
      hourFormat: "hour24",
      mode: "default"
    }, a = {
      hour24: {
        default: /^([01]?[0-9]|2[0-3]):([0-5][0-9])$/,
        withSeconds: /^([01]?[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/
      },
      hour12: {
        default: /^(0?[1-9]|1[0-2]):([0-5][0-9]) (A|P)M$/,
        withSeconds: /^(0?[1-9]|1[0-2]):([0-5][0-9]):([0-5][0-9]) (A|P)M$/
      }
    };
    function d(i, s) {
      return s = (0, r.default)(s, o), typeof i != "string" ? !1 : a[s.hourFormat][s.mode].test(i);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(z0, z0.exports)), z0.exports;
}
var Y0 = { exports: {} }, H3;
function Nk() {
  return H3 || (H3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ J());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /^(?!(1[3-9])|(20)|(3[3-9])|(4[0-9])|(5[0-9])|(60)|(7[3-9])|(8[1-9])|(9[0-2])|(9[3-9]))[0-9]{9}$/;
    function a(d) {
      if ((0, r.default)(d), !o.test(d)) return !1;
      for (var i = 0, s = 0; s < d.length; s++)
        s % 3 === 0 ? i += d[s] * 3 : s % 3 === 1 ? i += d[s] * 7 : i += d[s] * 1;
      return i % 10 === 0;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Y0, Y0.exports)), Y0.exports;
}
var X0 = { exports: {} }, K3;
function Ik() {
  return K3 || (K3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = n(/* @__PURE__ */ J());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var o = /^[0-9]{15}$/, a = /^\d{2}-\d{6}-\d{6}-\d{1}$/;
    function d(i, s) {
      (0, r.default)(i), s = s || {};
      var u = o;
      if (s.allow_hyphens && (u = a), !u.test(i))
        return !1;
      i = i.replace(/-/g, "");
      for (var c = 0, l = 2, p = 14, h = 0; h < p; h++) {
        var m = i.substring(p - h - 1, p - h), f = parseInt(m, 10) * l;
        f >= 10 ? c += f % 10 + 1 : c += f, l === 1 ? l += 1 : l -= 1;
      }
      var $ = (10 - c % 10) % 10;
      return $ === parseInt(i.substring(14, 15), 10);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(X0, X0.exports)), X0.exports;
}
var q0 = { exports: {} }, W3;
function Pk() {
  return W3 || (W3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ J());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /^[a-f0-9]{32}$/;
    function a(d) {
      return (0, r.default)(d), o.test(d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(q0, q0.exports)), q0.exports;
}
var J0 = { exports: {} }, z3;
function Rk() {
  return z3 || (z3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = o(/* @__PURE__ */ J()), n = o(/* @__PURE__ */ $t());
    function o(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var a = {
      ignore_whitespace: !1
    };
    function d(i, s) {
      return (0, r.default)(i), s = (0, n.default)(s, a), (s.ignore_whitespace ? i.trim().length : i.length) === 0;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(J0, J0.exports)), J0.exports;
}
var Q0 = { exports: {} }, Y3;
function Tk() {
  return Y3 || (Y3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ J());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a) {
      return (0, r.default)(a), /^[0-7][0-9A-HJKMNP-TV-Z]{25}$/i.test(a);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Q0, Q0.exports)), Q0.exports;
}
var eu = { exports: {} }, X3;
function Dk() {
  return X3 || (X3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ e2());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a, d) {
      var i = (d == null ? void 0 : d.comparisonDate) || d || Date().toString(), s = (0, r.default)(i), u = (0, r.default)(a);
      return !!(u && s && u > s);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(eu, eu.exports)), eu.exports;
}
var tu = { exports: {} }, q3;
function Lk() {
  return q3 || (q3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = o(/* @__PURE__ */ J()), n = o(/* @__PURE__ */ e2());
    function o(d) {
      return d && d.__esModule ? d : { default: d };
    }
    function a(d) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : String(/* @__PURE__ */ new Date());
      (0, r.default)(d);
      var s = (0, n.default)(i), u = (0, n.default)(d);
      return !!(u && s && u < s);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(tu, tu.exports)), tu.exports;
}
var ru = { exports: {} }, J3;
function Fk() {
  return J3 || (J3 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = o(/* @__PURE__ */ J()), n = o(/* @__PURE__ */ v$());
    function o(i) {
      return i && i.__esModule ? i : { default: i };
    }
    function a(i) {
      "@babel/helpers - typeof";
      return a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
        return typeof s;
      } : function(s) {
        return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
      }, a(i);
    }
    function d(i, s) {
      (0, r.default)(i);
      var u;
      if (Object.prototype.toString.call(s) === "[object Array]") {
        var c = [];
        for (u in s)
          ({}).hasOwnProperty.call(s, u) && (c[u] = (0, n.default)(s[u]));
        return c.indexOf(i) >= 0;
      } else {
        if (a(s) === "object")
          return s.hasOwnProperty(i);
        if (s && typeof s.indexOf == "function")
          return s.indexOf(i) >= 0;
      }
      return !1;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(ru, ru.exports)), ru.exports;
}
var nu = { exports: {} }, tn = {}, Q3;
function zh() {
  if (Q3) return tn;
  Q3 = 1, Object.defineProperty(tn, "__esModule", {
    value: !0
  }), tn.iso7064Check = e, tn.luhnCheck = t, tn.reverseMultiplyAndSum = r, tn.verhoeffCheck = n;
  function e(o) {
    for (var a = 10, d = 0; d < o.length - 1; d++)
      a = (parseInt(o[d], 10) + a) % 10 === 0 ? 10 * 2 % 11 : (parseInt(o[d], 10) + a) % 10 * 2 % 11;
    return a = a === 1 ? 0 : 11 - a, a === parseInt(o[10], 10);
  }
  function t(o) {
    for (var a = 0, d = !1, i = o.length - 1; i >= 0; i--) {
      if (d) {
        var s = parseInt(o[i], 10) * 2;
        s > 9 ? a += s.toString().split("").map(function(u) {
          return parseInt(u, 10);
        }).reduce(function(u, c) {
          return u + c;
        }, 0) : a += s;
      } else
        a += parseInt(o[i], 10);
      d = !d;
    }
    return a % 10 === 0;
  }
  function r(o, a) {
    for (var d = 0, i = 0; i < o.length; i++)
      d += o[i] * (a - i);
    return d;
  }
  function n(o) {
    for (var a = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 2, 3, 4, 0, 6, 7, 8, 9, 5], [2, 3, 4, 0, 1, 7, 8, 9, 5, 6], [3, 4, 0, 1, 2, 8, 9, 5, 6, 7], [4, 0, 1, 2, 3, 9, 5, 6, 7, 8], [5, 9, 8, 7, 6, 0, 4, 3, 2, 1], [6, 5, 9, 8, 7, 1, 0, 4, 3, 2], [7, 6, 5, 9, 8, 2, 1, 0, 4, 3], [8, 7, 6, 5, 9, 3, 2, 1, 0, 4], [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]], d = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 5, 7, 6, 2, 8, 3, 0, 9, 4], [5, 8, 0, 3, 7, 9, 6, 1, 4, 2], [8, 9, 1, 6, 0, 4, 3, 5, 2, 7], [9, 4, 5, 3, 1, 2, 6, 8, 7, 0], [4, 2, 8, 6, 5, 7, 3, 9, 0, 1], [2, 7, 9, 3, 8, 0, 6, 4, 1, 5], [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]], i = o.split("").reverse().join(""), s = 0, u = 0; u < i.length; u++)
      s = a[s][d[u % 8][parseInt(i[u], 10)]];
    return s === 0;
  }
  return tn;
}
var e4;
function Yh() {
  return e4 || (e4 = 1, function(e, t) {
    function r(g) {
      "@babel/helpers - typeof";
      return r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(b) {
        return typeof b;
      } : function(b) {
        return b && typeof Symbol == "function" && b.constructor === Symbol && b !== Symbol.prototype ? "symbol" : typeof b;
      }, r(g);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = Rt;
    var n = s(/* @__PURE__ */ J()), o = i(/* @__PURE__ */ zh()), a = s(/* @__PURE__ */ Wh());
    function d(g) {
      if (typeof WeakMap != "function") return null;
      var b = /* @__PURE__ */ new WeakMap(), M = /* @__PURE__ */ new WeakMap();
      return (d = function(D) {
        return D ? M : b;
      })(g);
    }
    function i(g, b) {
      if (g && g.__esModule) return g;
      if (g === null || r(g) != "object" && typeof g != "function") return { default: g };
      var M = d(b);
      if (M && M.has(g)) return M.get(g);
      var D = { __proto__: null }, R = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var L in g) if (L !== "default" && {}.hasOwnProperty.call(g, L)) {
        var B = R ? Object.getOwnPropertyDescriptor(g, L) : null;
        B && (B.get || B.set) ? Object.defineProperty(D, L, B) : D[L] = g[L];
      }
      return D.default = g, M && M.set(g, D), D;
    }
    function s(g) {
      return g && g.__esModule ? g : { default: g };
    }
    function u(g) {
      return h(g) || p(g) || l(g) || c();
    }
    function c() {
      throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function l(g, b) {
      if (g) {
        if (typeof g == "string") return m(g, b);
        var M = {}.toString.call(g).slice(8, -1);
        return M === "Object" && g.constructor && (M = g.constructor.name), M === "Map" || M === "Set" ? Array.from(g) : M === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(M) ? m(g, b) : void 0;
      }
    }
    function p(g) {
      if (typeof Symbol < "u" && g[Symbol.iterator] != null || g["@@iterator"] != null) return Array.from(g);
    }
    function h(g) {
      if (Array.isArray(g)) return m(g);
    }
    function m(g, b) {
      (b == null || b > g.length) && (b = g.length);
      for (var M = 0, D = Array(b); M < b; M++) D[M] = g[M];
      return D;
    }
    function f(g) {
      var b = g.slice(0, 2), M = parseInt(g.slice(2, 4), 10);
      M > 40 ? (M -= 40, b = "20".concat(b)) : M > 20 ? (M -= 20, b = "18".concat(b)) : b = "19".concat(b), M < 10 && (M = "0".concat(M));
      var D = "".concat(b, "/").concat(M, "/").concat(g.slice(4, 6));
      if (!(0, a.default)(D, "YYYY/MM/DD"))
        return !1;
      for (var R = g.split("").map(function(oe) {
        return parseInt(oe, 10);
      }), L = [2, 4, 8, 5, 10, 9, 7, 3, 6], B = 0, V = 0; V < L.length; V++)
        B += R[V] * L[V];
      return B = B % 11 === 10 ? 0 : B % 11, B === R[9];
    }
    function $(g) {
      var b = g.split(""), M = b.filter(function(R, L) {
        return L % 2;
      }).map(function(R) {
        return Number(R) * 2;
      }).join("").split(""), D = b.filter(function(R, L) {
        return !(L % 2);
      }).concat(M).map(function(R) {
        return Number(R);
      }).reduce(function(R, L) {
        return R + L;
      });
      return D % 10 === 0;
    }
    function v(g) {
      g = g.replace(/\W/, "");
      var b = parseInt(g.slice(0, 2), 10);
      if (g.length === 10)
        b < 54 ? b = "20".concat(b) : b = "19".concat(b);
      else {
        if (g.slice(6) === "000")
          return !1;
        if (b < 54)
          b = "19".concat(b);
        else
          return !1;
      }
      b.length === 3 && (b = [b.slice(0, 2), "0", b.slice(2)].join(""));
      var M = parseInt(g.slice(2, 4), 10);
      if (M > 50 && (M -= 50), M > 20) {
        if (parseInt(b, 10) < 2004)
          return !1;
        M -= 20;
      }
      M < 10 && (M = "0".concat(M));
      var D = "".concat(b, "/").concat(M, "/").concat(g.slice(4, 6));
      if (!(0, a.default)(D, "YYYY/MM/DD"))
        return !1;
      if (g.length === 10 && parseInt(g, 10) % 11 !== 0) {
        var R = parseInt(g.slice(0, 9), 10) % 11;
        if (parseInt(b, 10) < 1986 && R === 10) {
          if (parseInt(g.slice(9), 10) !== 0)
            return !1;
        } else
          return !1;
      }
      return !0;
    }
    function y(g) {
      return o.luhnCheck(g);
    }
    function S(g) {
      for (var b = g.split("").map(function(oe) {
        return parseInt(oe, 10);
      }), M = [], D = 0; D < b.length - 1; D++) {
        M.push("");
        for (var R = 0; R < b.length - 1; R++)
          b[D] === b[R] && (M[D] += R);
      }
      if (M = M.filter(function(oe) {
        return oe.length > 1;
      }), M.length !== 2 && M.length !== 3)
        return !1;
      if (M[0].length === 3) {
        for (var L = M[0].split("").map(function(oe) {
          return parseInt(oe, 10);
        }), B = 0, V = 0; V < L.length - 1; V++)
          L[V] + 1 === L[V + 1] && (B += 1);
        if (B === 2)
          return !1;
      }
      return o.iso7064Check(g);
    }
    function w(g) {
      g = g.replace(/\W/, "");
      var b = parseInt(g.slice(4, 6), 10), M = g.slice(6, 7);
      switch (M) {
        case "0":
        case "1":
        case "2":
        case "3":
          b = "19".concat(b);
          break;
        case "4":
        case "9":
          b < 37 ? b = "20".concat(b) : b = "19".concat(b);
          break;
        default:
          if (b < 37)
            b = "20".concat(b);
          else if (b > 58)
            b = "18".concat(b);
          else
            return !1;
          break;
      }
      b.length === 3 && (b = [b.slice(0, 2), "0", b.slice(2)].join(""));
      var D = "".concat(b, "/").concat(g.slice(2, 4), "/").concat(g.slice(0, 2));
      if (!(0, a.default)(D, "YYYY/MM/DD"))
        return !1;
      for (var R = g.split("").map(function(oe) {
        return parseInt(oe, 10);
      }), L = 0, B = 4, V = 0; V < 9; V++)
        L += R[V] * B, B -= 1, B === 1 && (B = 7);
      return L %= 11, L === 1 ? !1 : L === 0 ? R[9] === 0 : R[9] === 11 - L;
    }
    function _(g) {
      for (var b = g.slice(0, 8).split("").map(function(L) {
        return parseInt(L, 10);
      }), M = 0, D = 1; D < b.length; D += 2)
        M += b[D];
      for (var R = 0; R < b.length; R += 2)
        b[R] < 2 ? M += 1 - b[R] : (M += 2 * (b[R] - 2) + 5, b[R] > 4 && (M += 2));
      return String.fromCharCode(M % 26 + 65) === g.charAt(8);
    }
    function I(g) {
      for (var b = g.split("").map(function(R) {
        return parseInt(R, 10);
      }), M = 0, D = 0; D < 8; D++)
        M += b[D] * Math.pow(2, 8 - D);
      return M % 11 % 10 === b[8];
    }
    function N(g) {
      var b = o.reverseMultiplyAndSum(g.split("").slice(0, 7).map(function(M) {
        return parseInt(M, 10);
      }), 8);
      return g.length === 9 && g[8] !== "W" && (b += (g[8].charCodeAt(0) - 64) * 9), b %= 23, b === 0 ? g[7].toUpperCase() === "W" : g[7].toUpperCase() === String.fromCharCode(64 + b);
    }
    var O = {
      andover: ["10", "12"],
      atlanta: ["60", "67"],
      austin: ["50", "53"],
      brookhaven: ["01", "02", "03", "04", "05", "06", "11", "13", "14", "16", "21", "22", "23", "25", "34", "51", "52", "54", "55", "56", "57", "58", "59", "65"],
      cincinnati: ["30", "32", "35", "36", "37", "38", "61"],
      fresno: ["15", "24"],
      internet: ["20", "26", "27", "45", "46", "47"],
      kansas: ["40", "44"],
      memphis: ["94", "95"],
      ogden: ["80", "90"],
      philadelphia: ["33", "39", "41", "42", "43", "46", "48", "62", "63", "64", "66", "68", "71", "72", "73", "74", "75", "76", "77", "81", "82", "83", "84", "85", "86", "87", "88", "91", "92", "93", "98", "99"],
      sba: ["31"]
    };
    function E() {
      var g = [];
      for (var b in O)
        O.hasOwnProperty(b) && g.push.apply(g, u(O[b]));
      return g;
    }
    function C(g) {
      return E().indexOf(g.slice(0, 2)) !== -1;
    }
    function P(g) {
      for (var b = 0, M = g.split(""), D = parseInt(M.pop(), 10), R = 0; R < M.length; R++)
        b += M[9 - R] * (2 + R % 6);
      var L = 11 - b % 11;
      return L === 11 ? L = 0 : L === 10 && (L = 9), D === L;
    }
    function T(g) {
      var b = g.toUpperCase().split("");
      if (isNaN(parseInt(b[0], 10)) && b.length > 1) {
        var M = 0;
        switch (b[0]) {
          case "Y":
            M = 1;
            break;
          case "Z":
            M = 2;
            break;
        }
        b.splice(0, 1, M);
      } else
        for (; b.length < 9; )
          b.unshift(0);
      var D = ["T", "R", "W", "A", "G", "M", "Y", "F", "P", "D", "X", "B", "N", "J", "Z", "S", "Q", "V", "H", "L", "C", "K", "E"];
      b = b.join("");
      var R = parseInt(b.slice(0, 8), 10) % 23;
      return b[8] === D[R];
    }
    function j(g) {
      var b = g.slice(1, 3), M = g.slice(0, 1);
      switch (M) {
        case "1":
        case "2":
          b = "18".concat(b);
          break;
        case "3":
        case "4":
          b = "19".concat(b);
          break;
        default:
          b = "20".concat(b);
          break;
      }
      var D = "".concat(b, "/").concat(g.slice(3, 5), "/").concat(g.slice(5, 7));
      if (!(0, a.default)(D, "YYYY/MM/DD"))
        return !1;
      for (var R = g.split("").map(function(me) {
        return parseInt(me, 10);
      }), L = 0, B = 1, V = 0; V < 10; V++)
        L += R[V] * B, B += 1, B === 10 && (B = 1);
      if (L % 11 === 10) {
        L = 0, B = 3;
        for (var oe = 0; oe < 10; oe++)
          L += R[oe] * B, B += 1, B === 10 && (B = 1);
        if (L % 11 === 10)
          return R[10] === 0;
      }
      return L % 11 === R[10];
    }
    function F(g) {
      var b = g.slice(4, 6), M = g.slice(6, 7);
      switch (M) {
        case "+":
          b = "18".concat(b);
          break;
        case "-":
          b = "19".concat(b);
          break;
        default:
          b = "20".concat(b);
          break;
      }
      var D = "".concat(b, "/").concat(g.slice(2, 4), "/").concat(g.slice(0, 2));
      if (!(0, a.default)(D, "YYYY/MM/DD"))
        return !1;
      var R = parseInt(g.slice(0, 6) + g.slice(7, 10), 10) % 31;
      if (R < 10)
        return R === parseInt(g.slice(10), 10);
      R -= 10;
      var L = ["A", "B", "C", "D", "E", "F", "H", "J", "K", "L", "M", "N", "P", "R", "S", "T", "U", "V", "W", "X", "Y"];
      return L[R] === g.slice(10);
    }
    function Z(g) {
      if (g.slice(2, 4) !== "00" || g.slice(4, 6) !== "00") {
        var b = "".concat(g.slice(0, 2), "/").concat(g.slice(2, 4), "/").concat(g.slice(4, 6));
        if (!(0, a.default)(b, "YY/MM/DD"))
          return !1;
      }
      var M = 97 - parseInt(g.slice(0, 9), 10) % 97, D = parseInt(g.slice(9, 11), 10);
      return !(M !== D && (M = 97 - parseInt("2".concat(g.slice(0, 9)), 10) % 97, M !== D));
    }
    function te(g) {
      g = g.replace(/\s/g, "");
      var b = parseInt(g.slice(0, 10), 10) % 511, M = parseInt(g.slice(10, 13), 10);
      return b === M;
    }
    function H(g) {
      var b = "".concat(g.slice(0, 4), "/").concat(g.slice(4, 6), "/").concat(g.slice(6, 8));
      return !(0, a.default)(b, "YYYY/MM/DD") || !o.luhnCheck(g.slice(0, 12)) ? !1 : o.verhoeffCheck("".concat(g.slice(0, 11)).concat(g[12]));
    }
    function de(g) {
      return o.iso7064Check(g);
    }
    function G(g) {
      for (var b = g.split("").map(function(R) {
        return parseInt(R, 10);
      }), M = 8, D = 1; D < 9; D++)
        M += b[D] * (D + 1);
      return M % 11 === b[9];
    }
    function le(g) {
      for (var b = !1, M = !1, D = 0; D < 3; D++)
        if (!b && /[AEIOU]/.test(g[D]))
          b = !0;
        else if (!M && b && g[D] === "X")
          M = !0;
        else if (D > 0 && (b && !M && !/[AEIOU]/.test(g[D]) || M && !/X/.test(g[D])))
          return !1;
      return !0;
    }
    function fe(g) {
      var b = g.toUpperCase().split("");
      if (!le(b.slice(0, 3)) || !le(b.slice(3, 6)))
        return !1;
      for (var M = [6, 7, 9, 10, 12, 13, 14], D = {
        L: "0",
        M: "1",
        N: "2",
        P: "3",
        Q: "4",
        R: "5",
        S: "6",
        T: "7",
        U: "8",
        V: "9"
      }, R = 0, L = M; R < L.length; R++) {
        var B = L[R];
        b[B] in D && b.splice(B, 1, D[b[B]]);
      }
      var V = {
        A: "01",
        B: "02",
        C: "03",
        D: "04",
        E: "05",
        H: "06",
        L: "07",
        M: "08",
        P: "09",
        R: "10",
        S: "11",
        T: "12"
      }, oe = V[b[8]], me = parseInt(b[9] + b[10], 10);
      me > 40 && (me -= 40), me < 10 && (me = "0".concat(me));
      var He = "".concat(b[6]).concat(b[7], "/").concat(oe, "/").concat(me);
      if (!(0, a.default)(He, "YY/MM/DD"))
        return !1;
      for (var Ke = 0, Le = 1; Le < b.length - 1; Le += 2) {
        var st = parseInt(b[Le], 10);
        isNaN(st) && (st = b[Le].charCodeAt(0) - 65), Ke += st;
      }
      for (var Bt = {
        // Maps of characters at odd places
        A: 1,
        B: 0,
        C: 5,
        D: 7,
        E: 9,
        F: 13,
        G: 15,
        H: 17,
        I: 19,
        J: 21,
        K: 2,
        L: 4,
        M: 18,
        N: 20,
        O: 11,
        P: 3,
        Q: 6,
        R: 8,
        S: 12,
        T: 14,
        U: 16,
        V: 10,
        W: 22,
        X: 25,
        Y: 24,
        Z: 23,
        0: 1,
        1: 0
      }, Qe = 0; Qe < b.length - 1; Qe += 2) {
        var ut = 0;
        if (b[Qe] in Bt)
          ut = Bt[b[Qe]];
        else {
          var Tt = parseInt(b[Qe], 10);
          ut = 2 * Tt + 1, Tt > 4 && (ut += 2);
        }
        Ke += ut;
      }
      return String.fromCharCode(65 + Ke % 26) === b[15];
    }
    function U(g) {
      g = g.replace(/\W/, "");
      var b = g.slice(0, 2);
      if (b !== "32") {
        var M = g.slice(2, 4);
        if (M !== "00") {
          var D = g.slice(4, 6);
          switch (g[6]) {
            case "0":
              D = "18".concat(D);
              break;
            case "1":
              D = "19".concat(D);
              break;
            default:
              D = "20".concat(D);
              break;
          }
          var R = "".concat(D, "/").concat(g.slice(2, 4), "/").concat(b);
          if (!(0, a.default)(R, "YYYY/MM/DD"))
            return !1;
        }
        for (var L = 1101, B = [1, 6, 3, 7, 9, 10, 5, 8, 4, 2], V = 0; V < g.length - 1; V++)
          L -= parseInt(g[V], 10) * B[V];
        return parseInt(g[10], 10) === L % 11;
      }
      return !0;
    }
    function ae(g) {
      if (g.length !== 9) {
        for (var b = g.toUpperCase().split(""); b.length < 8; )
          b.unshift(0);
        switch (g[7]) {
          case "A":
          case "P":
            if (parseInt(b[6], 10) === 0)
              return !1;
            break;
          default: {
            var M = parseInt(b.join("").slice(0, 5), 10);
            if (M > 32e3)
              return !1;
            var D = parseInt(b.join("").slice(5, 7), 10);
            if (M === D)
              return !1;
          }
        }
      }
      return !0;
    }
    function ue(g) {
      return o.reverseMultiplyAndSum(g.split("").slice(0, 8).map(function(b) {
        return parseInt(b, 10);
      }), 9) % 11 === parseInt(g[8], 10);
    }
    function se(g) {
      if (g.length === 10) {
        for (var b = [6, 5, 7, 2, 3, 4, 5, 6, 7], M = 0, D = 0; D < b.length; D++)
          M += parseInt(g[D], 10) * b[D];
        return M %= 11, M === 10 ? !1 : M === parseInt(g[9], 10);
      }
      var R = g.slice(0, 2), L = parseInt(g.slice(2, 4), 10);
      L > 80 ? (R = "18".concat(R), L -= 80) : L > 60 ? (R = "22".concat(R), L -= 60) : L > 40 ? (R = "21".concat(R), L -= 40) : L > 20 ? (R = "20".concat(R), L -= 20) : R = "19".concat(R), L < 10 && (L = "0".concat(L));
      var B = "".concat(R, "/").concat(L, "/").concat(g.slice(4, 6));
      if (!(0, a.default)(B, "YYYY/MM/DD"))
        return !1;
      for (var V = 0, oe = 1, me = 0; me < g.length - 1; me++)
        V += parseInt(g[me], 10) * oe % 10, oe += 2, oe > 10 ? oe = 1 : oe === 5 && (oe += 2);
      return V = 10 - V % 10, V === parseInt(g[10], 10);
    }
    function we(g) {
      if (g.length === 11) {
        var b, M;
        if (b = 0, // Reject known invalid CPFs
        g === "11111111111" || g === "22222222222" || g === "33333333333" || g === "44444444444" || g === "55555555555" || g === "66666666666" || g === "77777777777" || g === "88888888888" || g === "99999999999" || g === "00000000000") return !1;
        for (var D = 1; D <= 9; D++) b += parseInt(g.substring(D - 1, D), 10) * (11 - D);
        if (M = b * 10 % 11, M === 10 && (M = 0), M !== parseInt(g.substring(9, 10), 10)) return !1;
        b = 0;
        for (var R = 1; R <= 10; R++) b += parseInt(g.substring(R - 1, R), 10) * (12 - R);
        return M = b * 10 % 11, M === 10 && (M = 0), M === parseInt(g.substring(10, 11), 10);
      }
      if (
        // Reject know invalid CNPJs
        g === "00000000000000" || g === "11111111111111" || g === "22222222222222" || g === "33333333333333" || g === "44444444444444" || g === "55555555555555" || g === "66666666666666" || g === "77777777777777" || g === "88888888888888" || g === "99999999999999"
      )
        return !1;
      for (var L = g.length - 2, B = g.substring(0, L), V = g.substring(L), oe = 0, me = L - 7, He = L; He >= 1; He--)
        oe += B.charAt(L - He) * me, me -= 1, me < 2 && (me = 9);
      var Ke = oe % 11 < 2 ? 0 : 11 - oe % 11;
      if (Ke !== parseInt(V.charAt(0), 10))
        return !1;
      L += 1, B = g.substring(0, L), oe = 0, me = L - 7;
      for (var Le = L; Le >= 1; Le--)
        oe += B.charAt(L - Le) * me, me -= 1, me < 2 && (me = 9);
      return Ke = oe % 11 < 2 ? 0 : 11 - oe % 11, Ke === parseInt(V.charAt(1), 10);
    }
    function re(g) {
      var b = 11 - o.reverseMultiplyAndSum(g.split("").slice(0, 8).map(function(M) {
        return parseInt(M, 10);
      }), 9) % 11;
      return b > 9 ? parseInt(g[8], 10) === 0 : b === parseInt(g[8], 10);
    }
    function ye(g) {
      if (g.slice(0, 4) !== "9000") {
        var b = g.slice(1, 3);
        switch (g[0]) {
          case "1":
          case "2":
            b = "19".concat(b);
            break;
          case "3":
          case "4":
            b = "18".concat(b);
            break;
          case "5":
          case "6":
            b = "20".concat(b);
            break;
        }
        var M = "".concat(b, "/").concat(g.slice(3, 5), "/").concat(g.slice(5, 7));
        if (M.length === 8) {
          if (!(0, a.default)(M, "YY/MM/DD"))
            return !1;
        } else if (!(0, a.default)(M, "YYYY/MM/DD"))
          return !1;
        for (var D = g.split("").map(function(V) {
          return parseInt(V, 10);
        }), R = [2, 7, 9, 1, 4, 6, 3, 5, 8, 2, 7, 9], L = 0, B = 0; B < R.length; B++)
          L += D[B] * R[B];
        return L % 11 === 10 ? D[12] === 1 : D[12] === L % 11;
      }
      return !0;
    }
    function xe(g) {
      if (g.length === 9) {
        if (g = g.replace(/\W/, ""), g.slice(6) === "000")
          return !1;
        var b = parseInt(g.slice(0, 2), 10);
        if (b > 53)
          return !1;
        b < 10 ? b = "190".concat(b) : b = "19".concat(b);
        var M = parseInt(g.slice(2, 4), 10);
        M > 50 && (M -= 50), M < 10 && (M = "0".concat(M));
        var D = "".concat(b, "/").concat(M, "/").concat(g.slice(4, 6));
        if (!(0, a.default)(D, "YYYY/MM/DD"))
          return !1;
      }
      return !0;
    }
    function be(g) {
      var b = 11 - o.reverseMultiplyAndSum(g.split("").slice(0, 7).map(function(M) {
        return parseInt(M, 10);
      }), 8) % 11;
      return b === 10 ? parseInt(g[7], 10) === 0 : b === parseInt(g[7], 10);
    }
    function ee(g) {
      var b = g.slice(0);
      g.length > 11 && (b = b.slice(2));
      var M = "", D = b.slice(2, 4), R = parseInt(b.slice(4, 6), 10);
      if (g.length > 11)
        M = g.slice(0, 4);
      else if (M = g.slice(0, 2), g.length === 11 && R < 60) {
        var L = (/* @__PURE__ */ new Date()).getFullYear().toString(), B = parseInt(L.slice(0, 2), 10);
        if (L = parseInt(L, 10), g[6] === "-")
          parseInt("".concat(B).concat(M), 10) > L ? M = "".concat(B - 1).concat(M) : M = "".concat(B).concat(M);
        else if (M = "".concat(B - 1).concat(M), L - parseInt(M, 10) < 100)
          return !1;
      }
      R > 60 && (R -= 60), R < 10 && (R = "0".concat(R));
      var V = "".concat(M, "/").concat(D, "/").concat(R);
      if (V.length === 8) {
        if (!(0, a.default)(V, "YY/MM/DD"))
          return !1;
      } else if (!(0, a.default)(V, "YYYY/MM/DD"))
        return !1;
      return o.luhnCheck(g.replace(/\W/, ""));
    }
    function ce(g) {
      for (var b = g.split("").map(function(L) {
        return parseInt(L, 10);
      }), M = [-1, 5, 7, 9, 4, 6, 10, 5, 7], D = 0, R = 0; R < M.length; R++)
        D += b[R] * M[R];
      return D % 11 === 10 ? b[9] === 0 : b[9] === D % 11;
    }
    var he = {
      "bg-BG": /^\d{10}$/,
      "cs-CZ": /^\d{6}\/{0,1}\d{3,4}$/,
      "de-AT": /^\d{9}$/,
      "de-DE": /^[1-9]\d{10}$/,
      "dk-DK": /^\d{6}-{0,1}\d{4}$/,
      "el-CY": /^[09]\d{7}[A-Z]$/,
      "el-GR": /^([0-4]|[7-9])\d{8}$/,
      "en-CA": /^\d{9}$/,
      "en-GB": /^\d{10}$|^(?!GB|NK|TN|ZZ)(?![DFIQUV])[A-Z](?![DFIQUVO])[A-Z]\d{6}[ABCD ]$/i,
      "en-IE": /^\d{7}[A-W][A-IW]{0,1}$/i,
      "en-US": /^\d{2}[- ]{0,1}\d{7}$/,
      "es-AR": /(20|23|24|27|30|33|34)[0-9]{8}[0-9]/,
      "es-ES": /^(\d{0,8}|[XYZKLM]\d{7})[A-HJ-NP-TV-Z]$/i,
      "et-EE": /^[1-6]\d{6}(00[1-9]|0[1-9][0-9]|[1-6][0-9]{2}|70[0-9]|710)\d$/,
      "fi-FI": /^\d{6}[-+A]\d{3}[0-9A-FHJ-NPR-Y]$/i,
      "fr-BE": /^\d{11}$/,
      "fr-FR": /^[0-3]\d{12}$|^[0-3]\d\s\d{2}(\s\d{3}){3}$/,
      // Conforms both to official spec and provided example
      "fr-LU": /^\d{13}$/,
      "hr-HR": /^\d{11}$/,
      "hu-HU": /^8\d{9}$/,
      "it-IT": /^[A-Z]{6}[L-NP-V0-9]{2}[A-EHLMPRST][L-NP-V0-9]{2}[A-ILMZ][L-NP-V0-9]{3}[A-Z]$/i,
      "lv-LV": /^\d{6}-{0,1}\d{5}$/,
      // Conforms both to DG TAXUD spec and original research
      "mt-MT": /^\d{3,7}[APMGLHBZ]$|^([1-8])\1\d{7}$/i,
      "nl-NL": /^\d{9}$/,
      "pl-PL": /^\d{10,11}$/,
      "pt-BR": /(?:^\d{11}$)|(?:^\d{14}$)/,
      "pt-PT": /^\d{9}$/,
      "ro-RO": /^\d{13}$/,
      "sk-SK": /^\d{6}\/{0,1}\d{3,4}$/,
      "sl-SI": /^[1-9]\d{7}$/,
      "sv-SE": /^(\d{6}[-+]{0,1}\d{4}|(18|19|20)\d{6}[-+]{0,1}\d{4})$/,
      "uk-UA": /^\d{10}$/
    };
    he["lb-LU"] = he["fr-LU"], he["lt-LT"] = he["et-EE"], he["nl-BE"] = he["fr-BE"], he["fr-CA"] = he["en-CA"];
    var Ee = {
      "bg-BG": f,
      "cs-CZ": v,
      "de-AT": y,
      "de-DE": S,
      "dk-DK": w,
      "el-CY": _,
      "el-GR": I,
      "en-CA": $,
      "en-IE": N,
      "en-US": C,
      "es-AR": P,
      "es-ES": T,
      "et-EE": j,
      "fi-FI": F,
      "fr-BE": Z,
      "fr-FR": te,
      "fr-LU": H,
      "hr-HR": de,
      "hu-HU": G,
      "it-IT": fe,
      "lv-LV": U,
      "mt-MT": ae,
      "nl-NL": ue,
      "pl-PL": se,
      "pt-BR": we,
      "pt-PT": re,
      "ro-RO": ye,
      "sk-SK": xe,
      "sl-SI": be,
      "sv-SE": ee,
      "uk-UA": ce
    };
    Ee["lb-LU"] = Ee["fr-LU"], Ee["lt-LT"] = Ee["et-EE"], Ee["nl-BE"] = Ee["fr-BE"], Ee["fr-CA"] = Ee["en-CA"];
    var ot = /[-\\\/!@#$%\^&\*\(\)\+\=\[\]]+/g, Ve = {
      "de-AT": ot,
      "de-DE": /[\/\\]/g,
      "fr-BE": ot
    };
    Ve["nl-BE"] = Ve["fr-BE"];
    function Rt(g) {
      var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US";
      (0, n.default)(g);
      var M = g.slice(0);
      if (b in he)
        return b in Ve && (M = M.replace(Ve[b], "")), he[b].test(M) ? b in Ee ? Ee[b](M) : !0 : !1;
      throw new Error("Invalid locale '".concat(b, "'"));
    }
    e.exports = t.default, e.exports.default = t.default;
  }(nu, nu.exports)), nu.exports;
}
var Bn = {}, t4;
function kk() {
  if (t4) return Bn;
  t4 = 1, Object.defineProperty(Bn, "__esModule", {
    value: !0
  }), Bn.isFreightContainerID = void 0, Bn.isISO6346 = o;
  var e = t(/* @__PURE__ */ J());
  function t(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var r = /^[A-Z]{3}(U[0-9]{7})|([J,Z][0-9]{6,7})$/, n = /^[0-9]$/;
  function o(a) {
    if ((0, e.default)(a), a = a.toUpperCase(), !r.test(a)) return !1;
    if (a.length === 11) {
      for (var d = 0, i = 0; i < a.length - 1; i++)
        if (n.test(a[i]))
          d += a[i] * Math.pow(2, i);
        else {
          var s = void 0, u = a.charCodeAt(i) - 55;
          u < 11 ? s = u : u >= 11 && u <= 20 ? s = 12 + u % 11 : u >= 21 && u <= 30 ? s = 23 + u % 21 : s = 34 + u % 31, d += s * Math.pow(2, i);
        }
      var c = d % 11;
      return c === 10 && (c = 0), Number(a[a.length - 1]) === c;
    }
    return !0;
  }
  return Bn.isFreightContainerID = o, Bn;
}
var ou = { exports: {} }, r4;
function jk() {
  return r4 || (r4 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ J());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /* @__PURE__ */ new Set(["aa", "ab", "ae", "af", "ak", "am", "an", "ar", "as", "av", "ay", "az", "az", "ba", "be", "bg", "bh", "bi", "bm", "bn", "bo", "br", "bs", "ca", "ce", "ch", "co", "cr", "cs", "cu", "cv", "cy", "da", "de", "dv", "dz", "ee", "el", "en", "eo", "es", "et", "eu", "fa", "ff", "fi", "fj", "fo", "fr", "fy", "ga", "gd", "gl", "gn", "gu", "gv", "ha", "he", "hi", "ho", "hr", "ht", "hu", "hy", "hz", "ia", "id", "ie", "ig", "ii", "ik", "io", "is", "it", "iu", "ja", "jv", "ka", "kg", "ki", "kj", "kk", "kl", "km", "kn", "ko", "kr", "ks", "ku", "kv", "kw", "ky", "la", "lb", "lg", "li", "ln", "lo", "lt", "lu", "lv", "mg", "mh", "mi", "mk", "ml", "mn", "mr", "ms", "mt", "my", "na", "nb", "nd", "ne", "ng", "nl", "nn", "no", "nr", "nv", "ny", "oc", "oj", "om", "or", "os", "pa", "pi", "pl", "ps", "pt", "qu", "rm", "rn", "ro", "ru", "rw", "sa", "sc", "sd", "se", "sg", "si", "sk", "sl", "sm", "sn", "so", "sq", "sr", "ss", "st", "su", "sv", "sw", "ta", "te", "tg", "th", "ti", "tk", "tl", "tn", "to", "tr", "ts", "tt", "tw", "ty", "ug", "uk", "ur", "uz", "ve", "vi", "vo", "wa", "wo", "xh", "yi", "yo", "za", "zh", "zu"]);
    function a(d) {
      return (0, r.default)(d), o.has(d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(ou, ou.exports)), ou.exports;
}
var Zn = {}, n4;
function Bk() {
  if (n4) return Zn;
  n4 = 1, Object.defineProperty(Zn, "__esModule", {
    value: !0
  }), Zn.ScriptCodes = void 0, Zn.default = n;
  var e = t(/* @__PURE__ */ J());
  function t(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var r = /* @__PURE__ */ new Set(["Adlm", "Afak", "Aghb", "Ahom", "Arab", "Aran", "Armi", "Armn", "Avst", "Bali", "Bamu", "Bass", "Batk", "Beng", "Bhks", "Blis", "Bopo", "Brah", "Brai", "Bugi", "Buhd", "Cakm", "Cans", "Cari", "Cham", "Cher", "Chis", "Chrs", "Cirt", "Copt", "Cpmn", "Cprt", "Cyrl", "Cyrs", "Deva", "Diak", "Dogr", "Dsrt", "Dupl", "Egyd", "Egyh", "Egyp", "Elba", "Elym", "Ethi", "Gara", "Geok", "Geor", "Glag", "Gong", "Gonm", "Goth", "Gran", "Grek", "Gujr", "Gukh", "Guru", "Hanb", "Hang", "Hani", "Hano", "Hans", "Hant", "Hatr", "Hebr", "Hira", "Hluw", "Hmng", "Hmnp", "Hrkt", "Hung", "Inds", "Ital", "Jamo", "Java", "Jpan", "Jurc", "Kali", "Kana", "Kawi", "Khar", "Khmr", "Khoj", "Kitl", "Kits", "Knda", "Kore", "Kpel", "Krai", "Kthi", "Lana", "Laoo", "Latf", "Latg", "Latn", "Leke", "Lepc", "Limb", "Lina", "Linb", "Lisu", "Loma", "Lyci", "Lydi", "Mahj", "Maka", "Mand", "Mani", "Marc", "Maya", "Medf", "Mend", "Merc", "Mero", "Mlym", "Modi", "Mong", "Moon", "Mroo", "Mtei", "Mult", "Mymr", "Nagm", "Nand", "Narb", "Nbat", "Newa", "Nkdb", "Nkgb", "Nkoo", "Nshu", "Ogam", "Olck", "Onao", "Orkh", "Orya", "Osge", "Osma", "Ougr", "Palm", "Pauc", "Pcun", "Pelm", "Perm", "Phag", "Phli", "Phlp", "Phlv", "Phnx", "Plrd", "Piqd", "Prti", "Psin", "Qaaa", "Qaab", "Qaac", "Qaad", "Qaae", "Qaaf", "Qaag", "Qaah", "Qaai", "Qaaj", "Qaak", "Qaal", "Qaam", "Qaan", "Qaao", "Qaap", "Qaaq", "Qaar", "Qaas", "Qaat", "Qaau", "Qaav", "Qaaw", "Qaax", "Qaay", "Qaaz", "Qaba", "Qabb", "Qabc", "Qabd", "Qabe", "Qabf", "Qabg", "Qabh", "Qabi", "Qabj", "Qabk", "Qabl", "Qabm", "Qabn", "Qabo", "Qabp", "Qabq", "Qabr", "Qabs", "Qabt", "Qabu", "Qabv", "Qabw", "Qabx", "Ranj", "Rjng", "Rohg", "Roro", "Runr", "Samr", "Sara", "Sarb", "Saur", "Sgnw", "Shaw", "Shrd", "Shui", "Sidd", "Sidt", "Sind", "Sinh", "Sogd", "Sogo", "Sora", "Soyo", "Sund", "Sunu", "Sylo", "Syrc", "Syre", "Syrj", "Syrn", "Tagb", "Takr", "Tale", "Talu", "Taml", "Tang", "Tavt", "Tayo", "Telu", "Teng", "Tfng", "Tglg", "Thaa", "Thai", "Tibt", "Tirh", "Tnsa", "Todr", "Tols", "Toto", "Tutg", "Ugar", "Vaii", "Visp", "Vith", "Wara", "Wcho", "Wole", "Xpeo", "Xsux", "Yezi", "Yiii", "Zanb", "Zinh", "Zmth", "Zsye", "Zsym", "Zxxx", "Zyyy", "Zzzz"]);
  function n(o) {
    return (0, e.default)(o), r.has(o);
  }
  return Zn.ScriptCodes = r, Zn;
}
var au = { exports: {} }, o4;
function Zk() {
  return o4 || (o4 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ J());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /* @__PURE__ */ new Set(["004", "008", "010", "012", "016", "020", "024", "028", "031", "032", "036", "040", "044", "048", "050", "051", "052", "056", "060", "064", "068", "070", "072", "074", "076", "084", "086", "090", "092", "096", "100", "104", "108", "112", "116", "120", "124", "132", "136", "140", "144", "148", "152", "156", "158", "162", "166", "170", "174", "175", "178", "180", "184", "188", "191", "192", "196", "203", "204", "208", "212", "214", "218", "222", "226", "231", "232", "233", "234", "238", "239", "242", "246", "248", "250", "254", "258", "260", "262", "266", "268", "270", "275", "276", "288", "292", "296", "300", "304", "308", "312", "316", "320", "324", "328", "332", "334", "336", "340", "344", "348", "352", "356", "360", "364", "368", "372", "376", "380", "384", "388", "392", "398", "400", "404", "408", "410", "414", "417", "418", "422", "426", "428", "430", "434", "438", "440", "442", "446", "450", "454", "458", "462", "466", "470", "474", "478", "480", "484", "492", "496", "498", "499", "500", "504", "508", "512", "516", "520", "524", "528", "531", "533", "534", "535", "540", "548", "554", "558", "562", "566", "570", "574", "578", "580", "581", "583", "584", "585", "586", "591", "598", "600", "604", "608", "612", "616", "620", "624", "626", "630", "634", "638", "642", "643", "646", "652", "654", "659", "660", "662", "663", "666", "670", "674", "678", "682", "686", "688", "690", "694", "702", "703", "704", "705", "706", "710", "716", "724", "728", "729", "732", "740", "744", "748", "752", "756", "760", "762", "764", "768", "772", "776", "780", "784", "788", "792", "795", "796", "798", "800", "804", "807", "818", "826", "831", "832", "833", "834", "840", "850", "854", "858", "860", "862", "876", "882", "887", "894"]);
    function a(d) {
      return (0, r.default)(d), o.has(d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(au, au.exports)), au.exports;
}
var Un = {}, a4;
function Xh() {
  if (a4) return Un;
  a4 = 1, Object.defineProperty(Un, "__esModule", {
    value: !0
  }), Un.CurrencyCodes = void 0, Un.default = n;
  var e = t(/* @__PURE__ */ J());
  function t(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var r = /* @__PURE__ */ new Set(["AED", "AFN", "ALL", "AMD", "ANG", "AOA", "ARS", "AUD", "AWG", "AZN", "BAM", "BBD", "BDT", "BGN", "BHD", "BIF", "BMD", "BND", "BOB", "BOV", "BRL", "BSD", "BTN", "BWP", "BYN", "BZD", "CAD", "CDF", "CHE", "CHF", "CHW", "CLF", "CLP", "CNY", "COP", "COU", "CRC", "CUP", "CVE", "CZK", "DJF", "DKK", "DOP", "DZD", "EGP", "ERN", "ETB", "EUR", "FJD", "FKP", "GBP", "GEL", "GHS", "GIP", "GMD", "GNF", "GTQ", "GYD", "HKD", "HNL", "HTG", "HUF", "IDR", "ILS", "INR", "IQD", "IRR", "ISK", "JMD", "JOD", "JPY", "KES", "KGS", "KHR", "KMF", "KPW", "KRW", "KWD", "KYD", "KZT", "LAK", "LBP", "LKR", "LRD", "LSL", "LYD", "MAD", "MDL", "MGA", "MKD", "MMK", "MNT", "MOP", "MRU", "MUR", "MVR", "MWK", "MXN", "MXV", "MYR", "MZN", "NAD", "NGN", "NIO", "NOK", "NPR", "NZD", "OMR", "PAB", "PEN", "PGK", "PHP", "PKR", "PLN", "PYG", "QAR", "RON", "RSD", "RUB", "RWF", "SAR", "SBD", "SCR", "SDG", "SEK", "SGD", "SHP", "SLE", "SLL", "SOS", "SRD", "SSP", "STN", "SVC", "SYP", "SZL", "THB", "TJS", "TMT", "TND", "TOP", "TRY", "TTD", "TWD", "TZS", "UAH", "UGX", "USD", "USN", "UYI", "UYU", "UYW", "UZS", "VED", "VES", "VND", "VUV", "WST", "XAF", "XAG", "XAU", "XBA", "XBB", "XBC", "XBD", "XCD", "XDR", "XOF", "XPD", "XPF", "XPT", "XSU", "XTS", "XUA", "XXX", "YER", "ZAR", "ZMW", "ZWL"]);
  function n(o) {
    return (0, e.default)(o), r.has(o.toUpperCase());
  }
  return Un.CurrencyCodes = r, Un;
}
var du = { exports: {} }, d4;
function qh() {
  return d4 || (d4 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ J());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /^[A-HJ-NP-Za-km-z1-9]*$/;
    function a(d) {
      return (0, r.default)(d), !!o.test(d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(du, du.exports)), du.exports;
}
var iu = { exports: {} }, su = { exports: {} }, uu = { exports: {} }, i4;
function Jh() {
  return i4 || (i4 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ J());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a, d) {
      if ((0, r.default)(a), d) {
        var i = new RegExp("[".concat(d.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "]+$"), "g");
        return a.replace(i, "");
      }
      for (var s = a.length - 1; /\s/.test(a.charAt(s)); )
        s -= 1;
      return a.slice(0, s + 1);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(uu, uu.exports)), uu.exports;
}
var lu = { exports: {} }, s4;
function Qh() {
  return s4 || (s4 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ J());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a, d) {
      (0, r.default)(a);
      var i = d ? new RegExp("^[".concat(d.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "]+"), "g") : /^\s+/g;
      return a.replace(i, "");
    }
    e.exports = t.default, e.exports.default = t.default;
  }(lu, lu.exports)), lu.exports;
}
var u4;
function eg() {
  return u4 || (u4 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = o(/* @__PURE__ */ Jh()), n = o(/* @__PURE__ */ Qh());
    function o(d) {
      return d && d.__esModule ? d : { default: d };
    }
    function a(d, i) {
      return (0, r.default)((0, n.default)(d, i), i);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(su, su.exports)), su.exports;
}
var l4;
function Uk() {
  return l4 || (l4 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = m;
    var r = a(/* @__PURE__ */ eg()), n = a(/* @__PURE__ */ Z1()), o = a(/* @__PURE__ */ J());
    function a(f) {
      return f && f.__esModule ? f : { default: f };
    }
    function d(f, $) {
      return u(f) || s(f, $) || l(f, $) || i();
    }
    function i() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function s(f, $) {
      var v = f == null ? null : typeof Symbol < "u" && f[Symbol.iterator] || f["@@iterator"];
      if (v != null) {
        var y, S, w, _, I = [], N = !0, O = !1;
        try {
          if (w = (v = v.call(f)).next, $ !== 0) for (; !(N = (y = w.call(v)).done) && (I.push(y.value), I.length !== $); N = !0) ;
        } catch (E) {
          O = !0, S = E;
        } finally {
          try {
            if (!N && v.return != null && (_ = v.return(), Object(_) !== _)) return;
          } finally {
            if (O) throw S;
          }
        }
        return I;
      }
    }
    function u(f) {
      if (Array.isArray(f)) return f;
    }
    function c(f, $) {
      var v = typeof Symbol < "u" && f[Symbol.iterator] || f["@@iterator"];
      if (!v) {
        if (Array.isArray(f) || (v = l(f)) || $) {
          v && (f = v);
          var y = 0, S = function() {
          };
          return { s: S, n: function() {
            return y >= f.length ? { done: !0 } : { done: !1, value: f[y++] };
          }, e: function(N) {
            throw N;
          }, f: S };
        }
        throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }
      var w, _ = !0, I = !1;
      return { s: function() {
        v = v.call(f);
      }, n: function() {
        var N = v.next();
        return _ = N.done, N;
      }, e: function(N) {
        I = !0, w = N;
      }, f: function() {
        try {
          _ || v.return == null || v.return();
        } finally {
          if (I) throw w;
        }
      } };
    }
    function l(f, $) {
      if (f) {
        if (typeof f == "string") return p(f, $);
        var v = {}.toString.call(f).slice(8, -1);
        return v === "Object" && f.constructor && (v = f.constructor.name), v === "Map" || v === "Set" ? Array.from(f) : v === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(v) ? p(f, $) : void 0;
      }
    }
    function p(f, $) {
      ($ == null || $ > f.length) && ($ = f.length);
      for (var v = 0, y = Array($); v < $; v++) y[v] = f[v];
      return y;
    }
    function h(f) {
      var $ = /* @__PURE__ */ new Set(["subject", "body", "cc", "bcc"]), v = {
        cc: "",
        bcc: ""
      }, y = !1, S = f.split("&");
      if (S.length > 4)
        return !1;
      var w = c(S), _;
      try {
        for (w.s(); !(_ = w.n()).done; ) {
          var I = _.value, N = I.split("="), O = d(N, 2), E = O[0], C = O[1];
          if (E && !$.has(E)) {
            y = !0;
            break;
          }
          C && (E === "cc" || E === "bcc") && (v[E] = C), E && $.delete(E);
        }
      } catch (P) {
        w.e(P);
      } finally {
        w.f();
      }
      return y ? !1 : v;
    }
    function m(f, $) {
      if ((0, o.default)(f), f.indexOf("mailto:") !== 0)
        return !1;
      var v = f.replace("mailto:", "").split("?"), y = d(v, 2), S = y[0], w = y[1], _ = w === void 0 ? "" : w;
      if (!S && !_)
        return !0;
      var I = h(_);
      return I ? "".concat(S, ",").concat(I.cc, ",").concat(I.bcc).split(",").every(function(N) {
        return N = (0, r.default)(N, " "), N ? (0, n.default)(N, $) : !0;
      }) : !1;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(iu, iu.exports)), iu.exports;
}
var cu = { exports: {} }, c4;
function Gk() {
  return c4 || (c4 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ J());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a) {
      return (0, r.default)(a), a.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\//g, "&#x2F;").replace(/\\/g, "&#x5C;").replace(/`/g, "&#96;");
    }
    e.exports = t.default, e.exports.default = t.default;
  }(cu, cu.exports)), cu.exports;
}
var fu = { exports: {} }, f4;
function Vk() {
  return f4 || (f4 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ J());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a) {
      return (0, r.default)(a), a.replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&#x2F;/g, "/").replace(/&#x5C;/g, "\\").replace(/&#96;/g, "`").replace(/&amp;/g, "&");
    }
    e.exports = t.default, e.exports.default = t.default;
  }(fu, fu.exports)), fu.exports;
}
var pu = { exports: {} }, $u = { exports: {} }, p4;
function tg() {
  return p4 || (p4 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ J());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a, d) {
      return (0, r.default)(a), a.replace(new RegExp("[".concat(d, "]+"), "g"), "");
    }
    e.exports = t.default, e.exports.default = t.default;
  }($u, $u.exports)), $u.exports;
}
var $4;
function Hk() {
  return $4 || ($4 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = o(/* @__PURE__ */ J()), n = o(/* @__PURE__ */ tg());
    function o(d) {
      return d && d.__esModule ? d : { default: d };
    }
    function a(d, i) {
      (0, r.default)(d);
      var s = i ? "\\x00-\\x09\\x0B\\x0C\\x0E-\\x1F\\x7F" : "\\x00-\\x1F\\x7F";
      return (0, n.default)(d, s);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(pu, pu.exports)), pu.exports;
}
var vu = { exports: {} }, v4;
function Kk() {
  return v4 || (v4 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ J());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a, d) {
      return (0, r.default)(a), a.replace(new RegExp("[^".concat(d, "]+"), "g"), "");
    }
    e.exports = t.default, e.exports.default = t.default;
  }(vu, vu.exports)), vu.exports;
}
var mu = { exports: {} }, m4;
function Wk() {
  return m4 || (m4 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ J());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a, d) {
      (0, r.default)(a);
      for (var i = a.length - 1; i >= 0; i--)
        if (d.indexOf(a[i]) === -1)
          return !1;
      return !0;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(mu, mu.exports)), mu.exports;
}
var hu = { exports: {} }, h4;
function zk() {
  return h4 || (h4 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = c;
    var r = n(/* @__PURE__ */ $t());
    function n(l) {
      return l && l.__esModule ? l : { default: l };
    }
    var o = {
      // The following options apply to all email addresses
      // Lowercases the local part of the email address.
      // Please note this may violate RFC 5321 as per http://stackoverflow.com/a/9808332/192024).
      // The domain is always lowercased, as per RFC 1035
      all_lowercase: !0,
      // The following conversions are specific to GMail
      // Lowercases the local part of the GMail address (known to be case-insensitive)
      gmail_lowercase: !0,
      // Removes dots from the local part of the email address, as that's ignored by GMail
      gmail_remove_dots: !0,
      // Removes the subaddress (e.g. "+foo") from the email address
      gmail_remove_subaddress: !0,
      // Conversts the googlemail.com domain to gmail.com
      gmail_convert_googlemaildotcom: !0,
      // The following conversions are specific to Outlook.com / Windows Live / Hotmail
      // Lowercases the local part of the Outlook.com address (known to be case-insensitive)
      outlookdotcom_lowercase: !0,
      // Removes the subaddress (e.g. "+foo") from the email address
      outlookdotcom_remove_subaddress: !0,
      // The following conversions are specific to Yahoo
      // Lowercases the local part of the Yahoo address (known to be case-insensitive)
      yahoo_lowercase: !0,
      // Removes the subaddress (e.g. "-foo") from the email address
      yahoo_remove_subaddress: !0,
      // The following conversions are specific to Yandex
      // Lowercases the local part of the Yandex address (known to be case-insensitive)
      yandex_lowercase: !0,
      // all yandex domains are equal, this explicitly sets the domain to 'yandex.ru'
      yandex_convert_yandexru: !0,
      // The following conversions are specific to iCloud
      // Lowercases the local part of the iCloud address (known to be case-insensitive)
      icloud_lowercase: !0,
      // Removes the subaddress (e.g. "+foo") from the email address
      icloud_remove_subaddress: !0
    }, a = ["icloud.com", "me.com"], d = ["hotmail.at", "hotmail.be", "hotmail.ca", "hotmail.cl", "hotmail.co.il", "hotmail.co.nz", "hotmail.co.th", "hotmail.co.uk", "hotmail.com", "hotmail.com.ar", "hotmail.com.au", "hotmail.com.br", "hotmail.com.gr", "hotmail.com.mx", "hotmail.com.pe", "hotmail.com.tr", "hotmail.com.vn", "hotmail.cz", "hotmail.de", "hotmail.dk", "hotmail.es", "hotmail.fr", "hotmail.hu", "hotmail.id", "hotmail.ie", "hotmail.in", "hotmail.it", "hotmail.jp", "hotmail.kr", "hotmail.lv", "hotmail.my", "hotmail.ph", "hotmail.pt", "hotmail.sa", "hotmail.sg", "hotmail.sk", "live.be", "live.co.uk", "live.com", "live.com.ar", "live.com.mx", "live.de", "live.es", "live.eu", "live.fr", "live.it", "live.nl", "msn.com", "outlook.at", "outlook.be", "outlook.cl", "outlook.co.il", "outlook.co.nz", "outlook.co.th", "outlook.com", "outlook.com.ar", "outlook.com.au", "outlook.com.br", "outlook.com.gr", "outlook.com.pe", "outlook.com.tr", "outlook.com.vn", "outlook.cz", "outlook.de", "outlook.dk", "outlook.es", "outlook.fr", "outlook.hu", "outlook.id", "outlook.ie", "outlook.in", "outlook.it", "outlook.jp", "outlook.kr", "outlook.lv", "outlook.my", "outlook.ph", "outlook.pt", "outlook.sa", "outlook.sg", "outlook.sk", "passport.com"], i = ["rocketmail.com", "yahoo.ca", "yahoo.co.uk", "yahoo.com", "yahoo.de", "yahoo.fr", "yahoo.in", "yahoo.it", "ymail.com"], s = ["yandex.ru", "yandex.ua", "yandex.kz", "yandex.com", "yandex.by", "ya.ru"];
    function u(l) {
      return l.length > 1 ? l : "";
    }
    function c(l, p) {
      p = (0, r.default)(p, o);
      var h = l.split("@"), m = h.pop(), f = h.join("@"), $ = [f, m];
      if ($[1] = $[1].toLowerCase(), $[1] === "gmail.com" || $[1] === "googlemail.com") {
        if (p.gmail_remove_subaddress && ($[0] = $[0].split("+")[0]), p.gmail_remove_dots && ($[0] = $[0].replace(/\.+/g, u)), !$[0].length)
          return !1;
        (p.all_lowercase || p.gmail_lowercase) && ($[0] = $[0].toLowerCase()), $[1] = p.gmail_convert_googlemaildotcom ? "gmail.com" : $[1];
      } else if (a.indexOf($[1]) >= 0) {
        if (p.icloud_remove_subaddress && ($[0] = $[0].split("+")[0]), !$[0].length)
          return !1;
        (p.all_lowercase || p.icloud_lowercase) && ($[0] = $[0].toLowerCase());
      } else if (d.indexOf($[1]) >= 0) {
        if (p.outlookdotcom_remove_subaddress && ($[0] = $[0].split("+")[0]), !$[0].length)
          return !1;
        (p.all_lowercase || p.outlookdotcom_lowercase) && ($[0] = $[0].toLowerCase());
      } else if (i.indexOf($[1]) >= 0) {
        if (p.yahoo_remove_subaddress) {
          var v = $[0].split("-");
          $[0] = v.length > 1 ? v.slice(0, -1).join("-") : v[0];
        }
        if (!$[0].length)
          return !1;
        (p.all_lowercase || p.yahoo_lowercase) && ($[0] = $[0].toLowerCase());
      } else s.indexOf($[1]) >= 0 ? ((p.all_lowercase || p.yandex_lowercase) && ($[0] = $[0].toLowerCase()), $[1] = p.yandex_convert_yandexru ? "yandex.ru" : $[1]) : p.all_lowercase && ($[0] = $[0].toLowerCase());
      return $.join("@");
    }
    e.exports = t.default, e.exports.default = t.default;
  }(hu, hu.exports)), hu.exports;
}
var gu = { exports: {} }, g4;
function Yk() {
  return g4 || (g4 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ J());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /^[^\s-_](?!.*?[-_]{2,})[a-z0-9-\\][^\s]*[^-_\s]$/;
    function a(d) {
      return (0, r.default)(d), o.test(d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(gu, gu.exports)), gu.exports;
}
var yu = { exports: {} }, y4;
function Xk() {
  return y4 || (y4 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ J());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = {
      "cs-CZ": function(d) {
        return /^(([ABCDEFHIJKLMNPRSTUVXYZ]|[0-9])-?){5,8}$/.test(d);
      },
      "de-DE": function(d) {
        return /^((A|AA|AB|AC|AE|AH|AK|AM|AN|AÖ|AP|AS|AT|AU|AW|AZ|B|BA|BB|BC|BE|BF|BH|BI|BK|BL|BM|BN|BO|BÖ|BS|BT|BZ|C|CA|CB|CE|CO|CR|CW|D|DA|DD|DE|DH|DI|DL|DM|DN|DO|DU|DW|DZ|E|EA|EB|ED|EE|EF|EG|EH|EI|EL|EM|EN|ER|ES|EU|EW|F|FB|FD|FF|FG|FI|FL|FN|FO|FR|FS|FT|FÜ|FW|FZ|G|GA|GC|GD|GE|GF|GG|GI|GK|GL|GM|GN|GÖ|GP|GR|GS|GT|GÜ|GV|GW|GZ|H|HA|HB|HC|HD|HE|HF|HG|HH|HI|HK|HL|HM|HN|HO|HP|HR|HS|HU|HV|HX|HY|HZ|IK|IL|IN|IZ|J|JE|JL|K|KA|KB|KC|KE|KF|KG|KH|KI|KK|KL|KM|KN|KO|KR|KS|KT|KU|KW|KY|L|LA|LB|LC|LD|LF|LG|LH|LI|LL|LM|LN|LÖ|LP|LR|LU|M|MA|MB|MC|MD|ME|MG|MH|MI|MK|ML|MM|MN|MO|MQ|MR|MS|MÜ|MW|MY|MZ|N|NB|ND|NE|NF|NH|NI|NK|NM|NÖ|NP|NR|NT|NU|NW|NY|NZ|OA|OB|OC|OD|OE|OF|OG|OH|OK|OL|OP|OS|OZ|P|PA|PB|PE|PF|PI|PL|PM|PN|PR|PS|PW|PZ|R|RA|RC|RD|RE|RG|RH|RI|RL|RM|RN|RO|RP|RS|RT|RU|RV|RW|RZ|S|SB|SC|SE|SG|SI|SK|SL|SM|SN|SO|SP|SR|ST|SU|SW|SY|SZ|TE|TF|TG|TO|TP|TR|TS|TT|TÜ|ÜB|UE|UH|UL|UM|UN|V|VB|VG|VK|VR|VS|W|WA|WB|WE|WF|WI|WK|WL|WM|WN|WO|WR|WS|WT|WÜ|WW|WZ|Z|ZE|ZI|ZP|ZR|ZW|ZZ)[- ]?[A-Z]{1,2}[- ]?\d{1,4}|(ABG|ABI|AIB|AIC|ALF|ALZ|ANA|ANG|ANK|APD|ARN|ART|ASL|ASZ|AUR|AZE|BAD|BAR|BBG|BCH|BED|BER|BGD|BGL|BID|BIN|BIR|BIT|BIW|BKS|BLB|BLK|BNA|BOG|BOH|BOR|BOT|BRA|BRB|BRG|BRK|BRL|BRV|BSB|BSK|BTF|BÜD|BUL|BÜR|BÜS|BÜZ|CAS|CHA|CLP|CLZ|COC|COE|CUX|DAH|DAN|DAU|DBR|DEG|DEL|DGF|DIL|DIN|DIZ|DKB|DLG|DON|DUD|DÜW|EBE|EBN|EBS|ECK|EIC|EIL|EIN|EIS|EMD|EMS|ERB|ERH|ERK|ERZ|ESB|ESW|FDB|FDS|FEU|FFB|FKB|FLÖ|FOR|FRG|FRI|FRW|FTL|FÜS|GAN|GAP|GDB|GEL|GEO|GER|GHA|GHC|GLA|GMN|GNT|GOA|GOH|GRA|GRH|GRI|GRM|GRZ|GTH|GUB|GUN|GVM|HAB|HAL|HAM|HAS|HBN|HBS|HCH|HDH|HDL|HEB|HEF|HEI|HER|HET|HGN|HGW|HHM|HIG|HIP|HMÜ|HOG|HOH|HOL|HOM|HOR|HÖS|HOT|HRO|HSK|HST|HVL|HWI|IGB|ILL|JÜL|KEH|KEL|KEM|KIB|KLE|KLZ|KÖN|KÖT|KÖZ|KRU|KÜN|KUS|KYF|LAN|LAU|LBS|LBZ|LDK|LDS|LEO|LER|LEV|LIB|LIF|LIP|LÖB|LOS|LRO|LSZ|LÜN|LUP|LWL|MAB|MAI|MAK|MAL|MED|MEG|MEI|MEK|MEL|MER|MET|MGH|MGN|MHL|MIL|MKK|MOD|MOL|MON|MOS|MSE|MSH|MSP|MST|MTK|MTL|MÜB|MÜR|MYK|MZG|NAB|NAI|NAU|NDH|NEA|NEB|NEC|NEN|NES|NEW|NMB|NMS|NOH|NOL|NOM|NOR|NVP|NWM|OAL|OBB|OBG|OCH|OHA|ÖHR|OHV|OHZ|OPR|OSL|OVI|OVL|OVP|PAF|PAN|PAR|PCH|PEG|PIR|PLÖ|PRÜ|QFT|QLB|RDG|REG|REH|REI|RID|RIE|ROD|ROF|ROK|ROL|ROS|ROT|ROW|RSL|RÜD|RÜG|SAB|SAD|SAN|SAW|SBG|SBK|SCZ|SDH|SDL|SDT|SEB|SEE|SEF|SEL|SFB|SFT|SGH|SHA|SHG|SHK|SHL|SIG|SIM|SLE|SLF|SLK|SLN|SLS|SLÜ|SLZ|SMÜ|SOB|SOG|SOK|SÖM|SON|SPB|SPN|SRB|SRO|STA|STB|STD|STE|STL|SUL|SÜW|SWA|SZB|TBB|TDO|TET|TIR|TÖL|TUT|UEM|UER|UFF|USI|VAI|VEC|VER|VIB|VIE|VIT|VOH|WAF|WAK|WAN|WAR|WAT|WBS|WDA|WEL|WEN|WER|WES|WHV|WIL|WIS|WIT|WIZ|WLG|WMS|WND|WOB|WOH|WOL|WOR|WOS|WRN|WSF|WST|WSW|WTL|WTM|WUG|WÜM|WUN|WUR|WZL|ZEL|ZIG)[- ]?(([A-Z][- ]?\d{1,4})|([A-Z]{2}[- ]?\d{1,3})))[- ]?(E|H)?$/.test(d);
      },
      "de-LI": function(d) {
        return /^FL[- ]?\d{1,5}[UZ]?$/.test(d);
      },
      "en-IN": function(d) {
        return /^[A-Z]{2}[ -]?[0-9]{1,2}(?:[ -]?[A-Z])(?:[ -]?[A-Z]*)?[ -]?[0-9]{4}$/.test(d);
      },
      "en-SG": function(d) {
        return /^[A-Z]{3}[ -]?[\d]{4}[ -]?[A-Z]{1}$/.test(d);
      },
      "es-AR": function(d) {
        return /^(([A-Z]{2} ?[0-9]{3} ?[A-Z]{2})|([A-Z]{3} ?[0-9]{3}))$/.test(d);
      },
      "fi-FI": function(d) {
        return /^(?=.{4,7})(([A-Z]{1,3}|[0-9]{1,3})[\s-]?([A-Z]{1,3}|[0-9]{1,5}))$/.test(d);
      },
      "hu-HU": function(d) {
        return /^((((?!AAA)(([A-NPRSTVZWXY]{1})([A-PR-Z]{1})([A-HJ-NPR-Z]))|(A[ABC]I)|A[ABC]O|A[A-W]Q|BPI|BPO|UCO|UDO|XAO)-(?!000)\d{3})|(M\d{6})|((CK|DT|CD|HC|H[ABEFIKLMNPRSTVX]|MA|OT|R[A-Z]) \d{2}-\d{2})|(CD \d{3}-\d{3})|(C-(C|X) \d{4})|(X-(A|B|C) \d{4})|(([EPVZ]-\d{5}))|(S A[A-Z]{2} \d{2})|(SP \d{2}-\d{2}))$/.test(d);
      },
      "pt-BR": function(d) {
        return /^[A-Z]{3}[ -]?[0-9][A-Z][0-9]{2}|[A-Z]{3}[ -]?[0-9]{4}$/.test(d);
      },
      "pt-PT": function(d) {
        return /^([A-Z]{2}|[0-9]{2})[ -·]?([A-Z]{2}|[0-9]{2})[ -·]?([A-Z]{2}|[0-9]{2})$/.test(d);
      },
      "sq-AL": function(d) {
        return /^[A-Z]{2}[- ]?((\d{3}[- ]?(([A-Z]{2})|T))|(R[- ]?\d{3}))$/.test(d);
      },
      "sv-SE": function(d) {
        return /^[A-HJ-PR-UW-Z]{3} ?[\d]{2}[A-HJ-PR-UW-Z1-9]$|(^[A-ZÅÄÖ ]{2,7}$)/.test(d.trim());
      },
      "en-PK": function(d) {
        return /(^[A-Z]{2}((\s|-){0,1})[0-9]{3,4}((\s|-)[0-9]{2}){0,1}$)|(^[A-Z]{3}((\s|-){0,1})[0-9]{3,4}((\s|-)[0-9]{2}){0,1}$)|(^[A-Z]{4}((\s|-){0,1})[0-9]{3,4}((\s|-)[0-9]{2}){0,1}$)|(^[A-Z]((\s|-){0,1})[0-9]{4}((\s|-)[0-9]{2}){0,1}$)/.test(d.trim());
      }
    };
    function a(d, i) {
      if ((0, r.default)(d), i in o)
        return o[i](d);
      if (i === "any") {
        for (var s in o) {
          var u = o[s];
          if (u(d))
            return !0;
        }
        return !1;
      }
      throw new Error("Invalid locale '".concat(i, "'"));
    }
    e.exports = t.default, e.exports.default = t.default;
  }(yu, yu.exports)), yu.exports;
}
var bu = { exports: {} }, b4;
function qk() {
  return b4 || (b4 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = h;
    var r = o(/* @__PURE__ */ $t()), n = o(/* @__PURE__ */ J());
    function o(m) {
      return m && m.__esModule ? m : { default: m };
    }
    var a = /^[A-Z]$/, d = /^[a-z]$/, i = /^[0-9]$/, s = /^[-#!$@£%^&*()_+|~=`{}\[\]:";'<>?,.\/\\ ]$/, u = {
      minLength: 8,
      minLowercase: 1,
      minUppercase: 1,
      minNumbers: 1,
      minSymbols: 1,
      returnScore: !1,
      pointsPerUnique: 1,
      pointsPerRepeat: 0.5,
      pointsForContainingLower: 10,
      pointsForContainingUpper: 10,
      pointsForContainingNumber: 10,
      pointsForContainingSymbol: 10
    };
    function c(m) {
      var f = {};
      return Array.from(m).forEach(function($) {
        var v = f[$];
        v ? f[$] += 1 : f[$] = 1;
      }), f;
    }
    function l(m) {
      var f = c(m), $ = {
        length: m.length,
        uniqueChars: Object.keys(f).length,
        uppercaseCount: 0,
        lowercaseCount: 0,
        numberCount: 0,
        symbolCount: 0
      };
      return Object.keys(f).forEach(function(v) {
        a.test(v) ? $.uppercaseCount += f[v] : d.test(v) ? $.lowercaseCount += f[v] : i.test(v) ? $.numberCount += f[v] : s.test(v) && ($.symbolCount += f[v]);
      }), $;
    }
    function p(m, f) {
      var $ = 0;
      return $ += m.uniqueChars * f.pointsPerUnique, $ += (m.length - m.uniqueChars) * f.pointsPerRepeat, m.lowercaseCount > 0 && ($ += f.pointsForContainingLower), m.uppercaseCount > 0 && ($ += f.pointsForContainingUpper), m.numberCount > 0 && ($ += f.pointsForContainingNumber), m.symbolCount > 0 && ($ += f.pointsForContainingSymbol), $;
    }
    function h(m) {
      var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
      (0, n.default)(m);
      var $ = l(m);
      return f = (0, r.default)(f || {}, u), f.returnScore ? p($, f) : $.length >= f.minLength && $.lowercaseCount >= f.minLowercase && $.uppercaseCount >= f.minUppercase && $.numberCount >= f.minNumbers && $.symbolCount >= f.minSymbols;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(bu, bu.exports)), bu.exports;
}
var Gn = {}, x4;
function Jk() {
  if (x4) return Gn;
  x4 = 1;
  function e(l) {
    "@babel/helpers - typeof";
    return e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(p) {
      return typeof p;
    } : function(p) {
      return p && typeof Symbol == "function" && p.constructor === Symbol && p !== Symbol.prototype ? "symbol" : typeof p;
    }, e(l);
  }
  Object.defineProperty(Gn, "__esModule", {
    value: !0
  }), Gn.default = c, Gn.vatMatchers = void 0;
  var t = a(/* @__PURE__ */ J()), r = o(/* @__PURE__ */ zh());
  function n(l) {
    if (typeof WeakMap != "function") return null;
    var p = /* @__PURE__ */ new WeakMap(), h = /* @__PURE__ */ new WeakMap();
    return (n = function(m) {
      return m ? h : p;
    })(l);
  }
  function o(l, p) {
    if (l && l.__esModule) return l;
    if (l === null || e(l) != "object" && typeof l != "function") return { default: l };
    var h = n(p);
    if (h && h.has(l)) return h.get(l);
    var m = { __proto__: null }, f = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var $ in l) if ($ !== "default" && {}.hasOwnProperty.call(l, $)) {
      var v = f ? Object.getOwnPropertyDescriptor(l, $) : null;
      v && (v.get || v.set) ? Object.defineProperty(m, $, v) : m[$] = l[$];
    }
    return m.default = l, h && h.set(l, m), m;
  }
  function a(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var d = function(l) {
    var p = l.match(/^(AU)?(\d{11})$/);
    if (!p)
      return !1;
    var h = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
    l = l.replace(/^AU/, "");
    for (var m = (parseInt(l.slice(0, 1), 10) - 1).toString() + l.slice(1), f = 0, $ = 0; $ < 11; $++)
      f += h[$] * m.charAt($);
    return f !== 0 && f % 89 === 0;
  }, i = function(l) {
    var p = function(h) {
      var m = h.pop(), f = [5, 4, 3, 2, 7, 6, 5, 4], $ = (11 - h.reduce(function(v, y, S) {
        return v + y * f[S];
      }, 0) % 11) % 11;
      return m === $;
    };
    return /^(CHE[- ]?)?(\d{9}|(\d{3}\.\d{3}\.\d{3})|(\d{3} \d{3} \d{3})) ?(TVA|MWST|IVA)?$/.test(l) && p(l.match(/\d/g).map(function(h) {
      return +h;
    }));
  }, s = function(l) {
    var p = l.match(/^(PT)?(\d{9})$/);
    if (!p)
      return !1;
    var h = p[2], m = 11 - r.reverseMultiplyAndSum(h.split("").slice(0, 8).map(function(f) {
      return parseInt(f, 10);
    }), 9) % 11;
    return m > 9 ? parseInt(h[8], 10) === 0 : m === parseInt(h[8], 10);
  }, u = Gn.vatMatchers = {
    /**
     * European Union VAT identification numbers
     */
    AT: function(l) {
      return /^(AT)?U\d{8}$/.test(l);
    },
    BE: function(l) {
      return /^(BE)?\d{10}$/.test(l);
    },
    BG: function(l) {
      return /^(BG)?\d{9,10}$/.test(l);
    },
    HR: function(l) {
      return /^(HR)?\d{11}$/.test(l);
    },
    CY: function(l) {
      return /^(CY)?\w{9}$/.test(l);
    },
    CZ: function(l) {
      return /^(CZ)?\d{8,10}$/.test(l);
    },
    DK: function(l) {
      return /^(DK)?\d{8}$/.test(l);
    },
    EE: function(l) {
      return /^(EE)?\d{9}$/.test(l);
    },
    FI: function(l) {
      return /^(FI)?\d{8}$/.test(l);
    },
    FR: function(l) {
      return /^(FR)?\w{2}\d{9}$/.test(l);
    },
    DE: function(l) {
      return /^(DE)?\d{9}$/.test(l);
    },
    EL: function(l) {
      return /^(EL)?\d{9}$/.test(l);
    },
    HU: function(l) {
      return /^(HU)?\d{8}$/.test(l);
    },
    IE: function(l) {
      return /^(IE)?\d{7}\w{1}(W)?$/.test(l);
    },
    IT: function(l) {
      return /^(IT)?\d{11}$/.test(l);
    },
    LV: function(l) {
      return /^(LV)?\d{11}$/.test(l);
    },
    LT: function(l) {
      return /^(LT)?\d{9,12}$/.test(l);
    },
    LU: function(l) {
      return /^(LU)?\d{8}$/.test(l);
    },
    MT: function(l) {
      return /^(MT)?\d{8}$/.test(l);
    },
    NL: function(l) {
      return /^(NL)?\d{9}B\d{2}$/.test(l);
    },
    PL: function(l) {
      return /^(PL)?(\d{10}|(\d{3}-\d{3}-\d{2}-\d{2})|(\d{3}-\d{2}-\d{2}-\d{3}))$/.test(l);
    },
    PT: s,
    RO: function(l) {
      return /^(RO)?\d{2,10}$/.test(l);
    },
    SK: function(l) {
      return /^(SK)?\d{10}$/.test(l);
    },
    SI: function(l) {
      return /^(SI)?\d{8}$/.test(l);
    },
    ES: function(l) {
      return /^(ES)?\w\d{7}[A-Z]$/.test(l);
    },
    SE: function(l) {
      return /^(SE)?\d{12}$/.test(l);
    },
    /**
     * VAT numbers of non-EU countries
     */
    AL: function(l) {
      return /^(AL)?\w{9}[A-Z]$/.test(l);
    },
    MK: function(l) {
      return /^(MK)?\d{13}$/.test(l);
    },
    AU: d,
    BY: function(l) {
      return /^(УНП )?\d{9}$/.test(l);
    },
    CA: function(l) {
      return /^(CA)?\d{9}$/.test(l);
    },
    IS: function(l) {
      return /^(IS)?\d{5,6}$/.test(l);
    },
    IN: function(l) {
      return /^(IN)?\d{15}$/.test(l);
    },
    ID: function(l) {
      return /^(ID)?(\d{15}|(\d{2}.\d{3}.\d{3}.\d{1}-\d{3}.\d{3}))$/.test(l);
    },
    IL: function(l) {
      return /^(IL)?\d{9}$/.test(l);
    },
    KZ: function(l) {
      return /^(KZ)?\d{12}$/.test(l);
    },
    NZ: function(l) {
      return /^(NZ)?\d{9}$/.test(l);
    },
    NG: function(l) {
      return /^(NG)?(\d{12}|(\d{8}-\d{4}))$/.test(l);
    },
    NO: function(l) {
      return /^(NO)?\d{9}MVA$/.test(l);
    },
    PH: function(l) {
      return /^(PH)?(\d{12}|\d{3} \d{3} \d{3} \d{3})$/.test(l);
    },
    RU: function(l) {
      return /^(RU)?(\d{10}|\d{12})$/.test(l);
    },
    SM: function(l) {
      return /^(SM)?\d{5}$/.test(l);
    },
    SA: function(l) {
      return /^(SA)?\d{15}$/.test(l);
    },
    RS: function(l) {
      return /^(RS)?\d{9}$/.test(l);
    },
    CH: i,
    TR: function(l) {
      return /^(TR)?\d{10}$/.test(l);
    },
    UA: function(l) {
      return /^(UA)?\d{12}$/.test(l);
    },
    GB: function(l) {
      return /^GB((\d{3} \d{4} ([0-8][0-9]|9[0-6]))|(\d{9} \d{3})|(((GD[0-4])|(HA[5-9]))[0-9]{2}))$/.test(l);
    },
    UZ: function(l) {
      return /^(UZ)?\d{9}$/.test(l);
    },
    /**
     * VAT numbers of Latin American countries
     */
    AR: function(l) {
      return /^(AR)?\d{11}$/.test(l);
    },
    BO: function(l) {
      return /^(BO)?\d{7}$/.test(l);
    },
    BR: function(l) {
      return /^(BR)?((\d{2}.\d{3}.\d{3}\/\d{4}-\d{2})|(\d{3}.\d{3}.\d{3}-\d{2}))$/.test(l);
    },
    CL: function(l) {
      return /^(CL)?\d{8}-\d{1}$/.test(l);
    },
    CO: function(l) {
      return /^(CO)?\d{10}$/.test(l);
    },
    CR: function(l) {
      return /^(CR)?\d{9,12}$/.test(l);
    },
    EC: function(l) {
      return /^(EC)?\d{13}$/.test(l);
    },
    SV: function(l) {
      return /^(SV)?\d{4}-\d{6}-\d{3}-\d{1}$/.test(l);
    },
    GT: function(l) {
      return /^(GT)?\d{7}-\d{1}$/.test(l);
    },
    HN: function(l) {
      return /^(HN)?$/.test(l);
    },
    MX: function(l) {
      return /^(MX)?\w{3,4}\d{6}\w{3}$/.test(l);
    },
    NI: function(l) {
      return /^(NI)?\d{3}-\d{6}-\d{4}\w{1}$/.test(l);
    },
    PA: function(l) {
      return /^(PA)?$/.test(l);
    },
    PY: function(l) {
      return /^(PY)?\d{6,8}-\d{1}$/.test(l);
    },
    PE: function(l) {
      return /^(PE)?\d{11}$/.test(l);
    },
    DO: function(l) {
      return /^(DO)?(\d{11}|(\d{3}-\d{7}-\d{1})|[1,4,5]{1}\d{8}|([1,4,5]{1})-\d{2}-\d{5}-\d{1})$/.test(l);
    },
    UY: function(l) {
      return /^(UY)?\d{12}$/.test(l);
    },
    VE: function(l) {
      return /^(VE)?[J,G,V,E]{1}-(\d{9}|(\d{8}-\d{1}))$/.test(l);
    }
  };
  function c(l, p) {
    if ((0, t.default)(l), (0, t.default)(p), p in u)
      return u[p](l);
    throw new Error("Invalid country code: '".concat(p, "'"));
  }
  return Gn;
}
var w4;
function Qk() {
  return w4 || (w4 = 1, function(e, t) {
    function r(Se) {
      "@babel/helpers - typeof";
      return r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(We) {
        return typeof We;
      } : function(We) {
        return We && typeof Symbol == "function" && We.constructor === Symbol && We !== Symbol.prototype ? "symbol" : typeof We;
      }, r(Se);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var n = k(/* @__PURE__ */ e2()), o = k(/* @__PURE__ */ Qp()), a = k(/* @__PURE__ */ _k()), d = k(/* @__PURE__ */ Ek()), i = k(/* @__PURE__ */ Mk()), s = k(/* @__PURE__ */ m$()), u = k(/* @__PURE__ */ $m()), c = k(/* @__PURE__ */ Z1()), l = k(/* @__PURE__ */ Xv()), p = k(/* @__PURE__ */ sv()), h = k(/* @__PURE__ */ Na()), m = k(/* @__PURE__ */ Ck()), f = k(/* @__PURE__ */ di()), $ = k(/* @__PURE__ */ Wh()), v = k(/* @__PURE__ */ Ok()), y = k(/* @__PURE__ */ km()), S = k(/* @__PURE__ */ bh()), w = k(/* @__PURE__ */ Nk()), _ = lt(/* @__PURE__ */ w$()), I = lt(/* @__PURE__ */ _$()), N = k(/* @__PURE__ */ Zm()), O = lt(/* @__PURE__ */ Ph()), E = k(/* @__PURE__ */ pv()), C = k(/* @__PURE__ */ Nv()), P = k(/* @__PURE__ */ om()), T = k(/* @__PURE__ */ Ik()), j = k(/* @__PURE__ */ I$()), F = k(/* @__PURE__ */ U1()), Z = k(/* @__PURE__ */ G1()), te = k(/* @__PURE__ */ ev()), H = k(/* @__PURE__ */ Vv()), de = k(/* @__PURE__ */ Vh()), G = k(/* @__PURE__ */ Wv()), le = k(/* @__PURE__ */ H1()), fe = lt(/* @__PURE__ */ Jp()), U = k(/* @__PURE__ */ C$()), ae = k(/* @__PURE__ */ V1()), ue = k(/* @__PURE__ */ Oh()), se = k(/* @__PURE__ */ e$()), we = k(/* @__PURE__ */ nv()), re = k(/* @__PURE__ */ Zh()), ye = k(/* @__PURE__ */ sh()), xe = k(/* @__PURE__ */ hh()), be = lt(/* @__PURE__ */ ch()), ee = k(/* @__PURE__ */ Wm()), ce = k(/* @__PURE__ */ Pk()), he = k(/* @__PURE__ */ Nm()), Ee = k(/* @__PURE__ */ Mv()), ot = k(/* @__PURE__ */ Sv()), Ve = k(/* @__PURE__ */ Rk()), Rt = k(/* @__PURE__ */ im()), g = k(/* @__PURE__ */ B1()), b = k(/* @__PURE__ */ Tk()), M = k(/* @__PURE__ */ Qv()), D = k(/* @__PURE__ */ Zv()), R = k(/* @__PURE__ */ Dk()), L = k(/* @__PURE__ */ Lk()), B = k(/* @__PURE__ */ Fk()), V = k(/* @__PURE__ */ k$()), oe = k(/* @__PURE__ */ j$()), me = k(/* @__PURE__ */ $h()), He = k(/* @__PURE__ */ rh()), Ke = k(/* @__PURE__ */ yv()), Le = k(/* @__PURE__ */ mv()), st = k(/* @__PURE__ */ Rm()), Bt = k(/* @__PURE__ */ Yh()), Qe = lt(/* @__PURE__ */ Rv()), ut = k(/* @__PURE__ */ ah()), Tt = k(/* @__PURE__ */ U$()), Vi = k(/* @__PURE__ */ Xm()), Uo = /* @__PURE__ */ kk(), Hi = k(/* @__PURE__ */ jk()), Ki = k(/* @__PURE__ */ wv()), Wi = k(/* @__PURE__ */ kh()), zi = k(/* @__PURE__ */ Bk()), Yi = k(/* @__PURE__ */ W1()), Xi = k(/* @__PURE__ */ kv()), qi = k(/* @__PURE__ */ Zk()), Ji = k(/* @__PURE__ */ Xh()), Qi = k(/* @__PURE__ */ Vm()), es = k(/* @__PURE__ */ qh()), ts = k(/* @__PURE__ */ j1()), rs = k(/* @__PURE__ */ Qm()), ns = k(/* @__PURE__ */ Ah()), os = k(/* @__PURE__ */ Uk()), as = k(/* @__PURE__ */ Eh()), ds = k(/* @__PURE__ */ Rp()), Go = lt(/* @__PURE__ */ Dh()), is = k(/* @__PURE__ */ Qh()), ss = k(/* @__PURE__ */ Jh()), us = k(/* @__PURE__ */ eg()), ls = k(/* @__PURE__ */ Gk()), cs = k(/* @__PURE__ */ Vk()), fs = k(/* @__PURE__ */ Hk()), ps = k(/* @__PURE__ */ Kk()), $s = k(/* @__PURE__ */ tg()), vs = k(/* @__PURE__ */ Wk()), ms = k(/* @__PURE__ */ zk()), hs = k(/* @__PURE__ */ Yk()), gs = k(/* @__PURE__ */ Xk()), ys = k(/* @__PURE__ */ qk()), bs = k(/* @__PURE__ */ Jk());
    function Vo(Se) {
      if (typeof WeakMap != "function") return null;
      var We = /* @__PURE__ */ new WeakMap(), ct = /* @__PURE__ */ new WeakMap();
      return (Vo = function(ft) {
        return ft ? ct : We;
      })(Se);
    }
    function lt(Se, We) {
      if (Se && Se.__esModule) return Se;
      if (Se === null || r(Se) != "object" && typeof Se != "function") return { default: Se };
      var ct = Vo(We);
      if (ct && ct.has(Se)) return ct.get(Se);
      var ft = { __proto__: null }, As = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var Et in Se) if (Et !== "default" && {}.hasOwnProperty.call(Se, Et)) {
        var lr = As ? Object.getOwnPropertyDescriptor(Se, Et) : null;
        lr && (lr.get || lr.set) ? Object.defineProperty(ft, Et, lr) : ft[Et] = Se[Et];
      }
      return ft.default = Se, ct && ct.set(Se, ft), ft;
    }
    function k(Se) {
      return Se && Se.__esModule ? Se : { default: Se };
    }
    var xs = "13.15.0", ws = {
      version: xs,
      toDate: n.default,
      toFloat: o.default,
      toInt: a.default,
      toBoolean: d.default,
      equals: i.default,
      contains: s.default,
      matches: u.default,
      isEmail: c.default,
      isURL: l.default,
      isMACAddress: p.default,
      isIP: h.default,
      isIPRange: m.default,
      isFQDN: f.default,
      isBoolean: y.default,
      isIBAN: be.default,
      isBIC: ee.default,
      isAbaRouting: w.default,
      isAlpha: _.default,
      isAlphaLocales: _.locales,
      isAlphanumeric: I.default,
      isAlphanumericLocales: I.locales,
      isNumeric: N.default,
      isPassportNumber: O.default,
      passportNumberLocales: O.locales,
      isPort: E.default,
      isLowercase: C.default,
      isUppercase: P.default,
      isAscii: j.default,
      isFullWidth: F.default,
      isHalfWidth: Z.default,
      isVariableWidth: te.default,
      isMultibyte: H.default,
      isSemVer: de.default,
      isSurrogatePair: G.default,
      isInt: le.default,
      isIMEI: T.default,
      isFloat: fe.default,
      isFloatLocales: fe.locales,
      isDecimal: U.default,
      isHexadecimal: ae.default,
      isOctal: ue.default,
      isDivisibleBy: se.default,
      isHexColor: we.default,
      isRgbColor: re.default,
      isHSL: ye.default,
      isISRC: xe.default,
      isMD5: ce.default,
      isHash: he.default,
      isJWT: Ee.default,
      isJSON: ot.default,
      isEmpty: Ve.default,
      isLength: Rt.default,
      isLocale: S.default,
      isByteLength: g.default,
      isULID: b.default,
      isUUID: M.default,
      isMongoId: D.default,
      isAfter: R.default,
      isBefore: L.default,
      isIn: B.default,
      isLuhnNumber: V.default,
      isCreditCard: oe.default,
      isIdentityCard: me.default,
      isEAN: He.default,
      isISIN: Ke.default,
      isISBN: Le.default,
      isISSN: st.default,
      isMobilePhone: Qe.default,
      isMobilePhoneLocales: Qe.locales,
      isPostalCode: Go.default,
      isPostalCodeLocales: Go.locales,
      isEthereumAddress: ut.default,
      isCurrency: Tt.default,
      isBtcAddress: Vi.default,
      isISO6346: Uo.isISO6346,
      isFreightContainerID: Uo.isFreightContainerID,
      isISO6391: Hi.default,
      isISO8601: Ki.default,
      isISO15924: zi.default,
      isRFC3339: Wi.default,
      isISO31661Alpha2: Yi.default,
      isISO31661Alpha3: Xi.default,
      isISO31661Numeric: qi.default,
      isISO4217: Ji.default,
      isBase32: Qi.default,
      isBase58: es.default,
      isBase64: ts.default,
      isDataURI: rs.default,
      isMagnetURI: ns.default,
      isMailtoURI: os.default,
      isMimeType: as.default,
      isLatLong: ds.default,
      ltrim: is.default,
      rtrim: ss.default,
      trim: us.default,
      escape: ls.default,
      unescape: cs.default,
      stripLow: fs.default,
      whitelist: ps.default,
      blacklist: $s.default,
      isWhitelisted: vs.default,
      normalizeEmail: ms.default,
      toString,
      isSlug: hs.default,
      isStrongPassword: ys.default,
      isTaxID: Bt.default,
      isDate: $.default,
      isTime: v.default,
      isLicensePlate: gs.default,
      isVAT: bs.default,
      ibanLocales: be.locales
    };
    t.default = ws, e.exports = t.default, e.exports.default = t.default;
  }(Z0, Z0.exports)), Z0.exports;
}
var ej = /* @__PURE__ */ Qk(), rg = "isStrongPassword";
function ng(e, t) {
  return typeof e == "string" && ej.isStrongPassword(e, t);
}
function tj(e, t) {
  return W({
    name: rg,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return ng(r, n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property is not strong enough";
      }, t)
    }
  }, t);
}
var og = "isTimeZone";
function ag(e) {
  try {
    return typeof e != "string" ? !1 : (Intl.DateTimeFormat(void 0, { timeZone: e }), !0);
  } catch {
    return !1;
  }
}
function rj(e) {
  return W({
    name: og,
    validator: {
      validate: function(t, r) {
        return ag(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be a valid IANA time-zone";
      }, e)
    }
  }, e);
}
var nj = /* @__PURE__ */ qh();
const oj = /* @__PURE__ */ $e(nj);
var dg = "isBase58";
function ig(e) {
  return typeof e == "string" && oj(e);
}
function aj(e) {
  return W({
    name: dg,
    validator: {
      validate: function(t, r) {
        return ig(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be base58 encoded";
      }, e)
    }
  }, e);
}
var dj = /* @__PURE__ */ Yh();
const ij = /* @__PURE__ */ $e(dj);
var sg = "isTaxId";
function ug(e, t) {
  return typeof e == "string" && ij(e, t || "en-US");
}
function sj(e, t) {
  return W({
    name: sg,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return ug(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must be a Tax Identification Number";
      }, t)
    }
  }, t);
}
var uj = /* @__PURE__ */ Xh();
const lj = /* @__PURE__ */ $e(uj);
var lg = "isISO4217CurrencyCode";
function cg(e) {
  return typeof e == "string" && lj(e);
}
function cj(e) {
  return W({
    name: lg,
    validator: {
      validate: function(t, r) {
        return cg(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be a valid ISO4217 currency code";
      }, e)
    }
  }, e);
}
var fg = "isBoolean";
function pg(e) {
  return e instanceof Boolean || typeof e == "boolean";
}
function fj(e) {
  return W({
    name: fg,
    validator: {
      validate: function(t, r) {
        return pg(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be a boolean value";
      }, e)
    }
  }, e);
}
var $g = "isDate";
function vg(e) {
  return e instanceof Date && !isNaN(e.getTime());
}
function pj(e) {
  return W({
    name: $g,
    validator: {
      validate: function(t, r) {
        return vg(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be a Date instance";
      }, e)
    }
  }, e);
}
var mg = "isNumber";
function hg(e, t) {
  if (t === void 0 && (t = {}), typeof e != "number")
    return !1;
  if (e === 1 / 0 || e === -1 / 0)
    return !!t.allowInfinity;
  if (Number.isNaN(e))
    return !!t.allowNaN;
  if (t.maxDecimalPlaces !== void 0) {
    var r = 0;
    if (e % 1 !== 0 && (r = e.toString().split(".")[1].length), r > t.maxDecimalPlaces)
      return !1;
  }
  return Number.isFinite(e);
}
function $j(e, t) {
  return e === void 0 && (e = {}), W({
    name: mg,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return hg(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must be a number conforming to the specified constraints";
      }, t)
    }
  }, t);
}
var A4 = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), o, a = [], d;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = n.next()).done; ) a.push(o.value);
  } catch (i) {
    d = { error: i };
  } finally {
    try {
      o && !o.done && (r = n.return) && r.call(n);
    } finally {
      if (d) throw d.error;
    }
  }
  return a;
}, gg = "isEnum";
function yg(e, t) {
  var r = Object.keys(t).map(function(n) {
    return t[n];
  });
  return r.includes(e);
}
function vj(e) {
  return Object.entries(e).filter(function(t) {
    var r = A4(t, 2), n = r[0];
    return r[1], isNaN(parseInt(n));
  }).map(function(t) {
    var r = A4(t, 2);
    r[0];
    var n = r[1];
    return n;
  });
}
function mj(e, t) {
  return W({
    name: gg,
    constraints: [e, vj(e)],
    validator: {
      validate: function(r, n) {
        return yg(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must be one of the following values: $constraint2";
      }, t)
    }
  }, t);
}
var bg = "isInt";
function xg(e) {
  return typeof e == "number" && Number.isInteger(e);
}
function hj(e) {
  return W({
    name: bg,
    validator: {
      validate: function(t, r) {
        return xg(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be an integer number";
      }, e)
    }
  }, e);
}
var wg = "isString";
function Ag(e) {
  return e instanceof String || typeof e == "string";
}
function gj(e) {
  return W({
    name: wg,
    validator: {
      validate: function(t, r) {
        return Ag(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be a string";
      }, e)
    }
  }, e);
}
var Sg = "isArray";
function _g(e) {
  return Array.isArray(e);
}
function yj(e) {
  return W({
    name: Sg,
    validator: {
      validate: function(t, r) {
        return _g(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be an array";
      }, e)
    }
  }, e);
}
var Eg = "isObject";
function t2(e) {
  return e != null && (typeof e == "object" || typeof e == "function") && !Array.isArray(e);
}
function bj(e) {
  return W({
    name: Eg,
    validator: {
      validate: function(t, r) {
        return t2(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property must be an object";
      }, e)
    }
  }, e);
}
var Mg = "arrayContains";
function Cg(e, t) {
  return Array.isArray(e) ? t.every(function(r) {
    return e.indexOf(r) !== -1;
  }) : !1;
}
function xj(e, t) {
  return W({
    name: Mg,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Cg(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must contain $constraint1 values";
      }, t)
    }
  }, t);
}
var Og = "arrayNotContains";
function Ng(e, t) {
  return Array.isArray(e) ? t.every(function(r) {
    return e.indexOf(r) === -1;
  }) : !1;
}
function wj(e, t) {
  return W({
    name: Og,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Ng(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property should not contain $constraint1 values";
      }, t)
    }
  }, t);
}
var Ig = "arrayNotEmpty";
function Pg(e) {
  return Array.isArray(e) && e.length > 0;
}
function Aj(e) {
  return W({
    name: Ig,
    validator: {
      validate: function(t, r) {
        return Pg(t);
      },
      defaultMessage: K(function(t) {
        return t + "$property should not be empty";
      }, e)
    }
  }, e);
}
var Rg = "arrayMinSize";
function Tg(e, t) {
  return Array.isArray(e) && e.length >= t;
}
function Sj(e, t) {
  return W({
    name: Rg,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Tg(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must contain at least $constraint1 elements";
      }, t)
    }
  }, t);
}
var Dg = "arrayMaxSize";
function Lg(e, t) {
  return Array.isArray(e) && e.length <= t;
}
function _j(e, t) {
  return W({
    name: Dg,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Lg(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must contain no more than $constraint1 elements";
      }, t)
    }
  }, t);
}
var Fg = "arrayUnique";
function kg(e, t) {
  if (!Array.isArray(e))
    return !1;
  t && (e = e.map(function(n) {
    return n != null ? t(n) : n;
  }));
  var r = e.filter(function(n, o, a) {
    return a.indexOf(n) === o;
  });
  return e.length === r.length;
}
function Ej(e, t) {
  var r = typeof e == "function" ? e : void 0, n = typeof e != "function" ? e : t;
  return W({
    name: Fg,
    validator: {
      validate: function(o, a) {
        return kg(o, r);
      },
      defaultMessage: K(function(o) {
        return o + "All $property's elements must be unique";
      }, n)
    }
  }, n);
}
var jg = "isNotEmptyObject";
function Bg(e, t) {
  if (!t2(e))
    return !1;
  if ((t == null ? void 0 : t.nullable) === !1)
    return !Object.values(e).every(function(n) {
      return n == null;
    });
  for (var r in e)
    if (e.hasOwnProperty(r))
      return !0;
  return !1;
}
function Mj(e, t) {
  return W({
    name: jg,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Bg(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r) {
        return r + "$property must be a non-empty object";
      }, t)
    }
  }, t);
}
var Wc = "isInstance";
function Zg(e, t) {
  return t && typeof t == "function" && e instanceof t;
}
function Cj(e, t) {
  return W({
    name: Wc,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Zg(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: K(function(r, n) {
        return n != null && n.constraints[0] ? r + "$property must be an instance of ".concat(n == null ? void 0 : n.constraints[0].name) : r + "".concat(Wc, " decorator expects and object as value, but got falsy value.");
      }, t)
    }
  }, t);
}
function Oj(e, t, r) {
  return typeof e == "string" ? Sr(fn).validate(e, t, r) : Sr(fn).validate(e, t);
}
function Nj(e, t, r) {
  return typeof e == "string" ? Sr(fn).validateOrReject(e, t, r) : Sr(fn).validateOrReject(e, t);
}
function Ij(e, t, r) {
  return typeof e == "string" ? Sr(fn).validateSync(e, t, r) : Sr(fn).validateSync(e, t);
}
function Pj(e) {
  Ft().addValidationSchema(e);
}
const Rj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ARRAY_CONTAINS: Mg,
  ARRAY_MAX_SIZE: Dg,
  ARRAY_MIN_SIZE: Rg,
  ARRAY_NOT_CONTAINS: Og,
  ARRAY_NOT_EMPTY: Ig,
  ARRAY_UNIQUE: Fg,
  Allow: OP,
  ArrayContains: xj,
  ArrayMaxSize: _j,
  ArrayMinSize: Sj,
  ArrayNotContains: wj,
  ArrayNotEmpty: Aj,
  ArrayUnique: Ej,
  CONTAINS: g$,
  Contains: oR,
  EQUALS: jp,
  Equals: UP,
  IS_ALPHA: A$,
  IS_ALPHANUMERIC: E$,
  IS_ARRAY: Sg,
  IS_ASCII: P$,
  IS_BASE32: Hm,
  IS_BASE58: dg,
  IS_BASE64: T$,
  IS_BIC: zm,
  IS_BOOLEAN: fg,
  IS_BOOLEAN_STRING: jm,
  IS_BTC_ADDRESS: qm,
  IS_BYTE_LENGTH: L$,
  IS_CREDIT_CARD: B$,
  IS_CURRENCY: G$,
  IS_DATA_URI: eh,
  IS_DATE: $g,
  IS_DATE_STRING: Lm,
  IS_DECIMAL: O$,
  IS_DEFINED: Np,
  IS_DIVISIBLE_BY: t$,
  IS_EAN: nh,
  IS_EMAIL: K$,
  IS_EMPTY: Gp,
  IS_ENUM: gg,
  IS_ETHEREUM_ADDRESS: dh,
  IS_FIREBASE_PUSH_ID: rm,
  IS_FQDN: z$,
  IS_FULL_WIDTH: X$,
  IS_HALF_WIDTH: J$,
  IS_HASH: Im,
  IS_HEXADECIMAL: dv,
  IS_HEX_COLOR: ov,
  IS_HSL: uh,
  IS_IBAN: fh,
  IS_IDENTITY_CARD: vh,
  IS_IN: Wp,
  IS_INSTANCE: Wc,
  IS_INT: bg,
  IS_IP: cv,
  IS_ISBN: hv,
  IS_ISIN: bv,
  IS_ISO31661_ALPHA_2: Lv,
  IS_ISO31661_ALPHA_3: jv,
  IS_ISO4217_CURRENCY_CODE: lg,
  IS_ISO8601: Av,
  IS_ISRC: gh,
  IS_ISSN: Tm,
  IS_JSON: _v,
  IS_JWT: Cv,
  IS_LATITUDE: Dp,
  IS_LATLONG: Tp,
  IS_LENGTH: sm,
  IS_LOCALE: xh,
  IS_LONGITUDE: Fp,
  IS_LOWERCASE: Iv,
  IS_MAC_ADDRESS: uv,
  IS_MAGNET_URI: Sh,
  IS_MILITARY_TIME: Cm,
  IS_MIME_TYPE: Mh,
  IS_MOBILE_PHONE: Tv,
  IS_MONGO_ID: Uv,
  IS_MULTIBYTE: Hv,
  IS_NEGATIVE: a$,
  IS_NOT_EMPTY: Hp,
  IS_NOT_EMPTY_OBJECT: jg,
  IS_NOT_IN: Yp,
  IS_NUMBER: mg,
  IS_NUMBER_STRING: Um,
  IS_OBJECT: Eg,
  IS_OCTAL: Nh,
  IS_OPTIONAL: Pp,
  IS_PASSPORT_NUMBER: Rh,
  IS_PHONE_NUMBER: Em,
  IS_PORT: $v,
  IS_POSITIVE: n$,
  IS_POSTAL_CODE: Lh,
  IS_RFC_3339: jh,
  IS_RGB_COLOR: Uh,
  IS_SEM_VER: Hh,
  IS_STRING: wg,
  IS_STRONG_PASSWORD: rg,
  IS_SURROGATE_PAIR: zv,
  IS_TAX_ID: sg,
  IS_TIMEZONE: og,
  IS_UPPERCASE: am,
  IS_URL: qv,
  IS_UUID: em,
  IS_VARIABLE_WIDTH: tv,
  IsAlpha: sR,
  IsAlphanumeric: cR,
  IsArray: yj,
  IsAscii: gR,
  IsBIC: EF,
  IsBase32: AF,
  IsBase58: aj,
  IsBase64: xR,
  IsBoolean: fj,
  IsBooleanString: hF,
  IsBtcAddress: OF,
  IsByteLength: SR,
  IsCreditCard: MR,
  IsCurrency: NR,
  IsDataURI: PF,
  IsDate: pj,
  IsDateString: $F,
  IsDecimal: vR,
  IsDefined: NP,
  IsDivisibleBy: XP,
  IsEAN: DF,
  IsEmail: RR,
  IsEmpty: VP,
  IsEnum: mj,
  IsEthereumAddress: kF,
  IsFQDN: LR,
  IsFirebasePushId: YT,
  IsFullWidth: jR,
  IsHSL: ZF,
  IsHalfWidth: UR,
  IsHash: lF,
  IsHexColor: zR,
  IsHexadecimal: qR,
  IsIBAN: VF,
  IsIP: nT,
  IsISBN: uT,
  IsISIN: fT,
  IsISO31661Alpha2: NT,
  IsISO31661Alpha3: RT,
  IsISO4217CurrencyCode: cj,
  IsISO8601: vT,
  IsISRC: XF,
  IsISSN: pF,
  IsIdentityCard: WF,
  IsIn: KP,
  IsInstance: Cj,
  IsInt: hj,
  IsJSON: gT,
  IsJWT: xT,
  IsLatLong: jP,
  IsLatitude: BP,
  IsLocale: QF,
  IsLongitude: ZP,
  IsLowercase: ST,
  IsMACAddress: eT,
  IsMagnetURI: rk,
  IsMilitaryTime: iF,
  IsMimeType: ak,
  IsMobilePhone: MT,
  IsMongoId: LT,
  IsMultibyte: jT,
  IsNegative: JP,
  IsNotEmpty: HP,
  IsNotEmptyObject: Mj,
  IsNotIn: WP,
  IsNumber: $j,
  IsNumberString: bF,
  IsObject: bj,
  IsOctal: sk,
  IsOptional: IP,
  IsPassportNumber: ck,
  IsPhoneNumber: dF,
  IsPort: dT,
  IsPositive: qP,
  IsPostalCode: $k,
  IsRFC3339: hk,
  IsRgbColor: bk,
  IsSemVer: Sk,
  IsString: gj,
  IsStrongPassword: tj,
  IsSurrogatePair: UT,
  IsTaxId: sj,
  IsTimeZone: rj,
  IsUUID: zT,
  IsUppercase: JT,
  IsUrl: HT,
  IsVariableWidth: HR,
  Length: eD,
  MATCHES: mm,
  MAX: i$,
  MAX_DATE: p$,
  MAX_LENGTH: lm,
  MIN: u$,
  MIN_DATE: c$,
  MIN_LENGTH: fm,
  Matches: oD,
  Max: QP,
  MaxDate: rR,
  MaxLength: tD,
  MetadataStorage: k1,
  Min: eR,
  MinDate: tR,
  MinLength: rD,
  NOT_CONTAINS: b$,
  NOT_EQUALS: Zp,
  NotContains: aR,
  NotEquals: GP,
  Validate: RP,
  ValidateBy: W,
  ValidateIf: TP,
  ValidateNested: DP,
  ValidatePromise: LP,
  ValidationError: Fc,
  ValidationTypes: Xe,
  Validator: fn,
  ValidatorConstraint: PP,
  arrayContains: Cg,
  arrayMaxSize: Lg,
  arrayMinSize: Tg,
  arrayNotContains: Ng,
  arrayNotEmpty: Pg,
  arrayUnique: kg,
  buildMessage: K,
  contains: y$,
  equals: Bp,
  getFromContainer: Sr,
  getMetadataStorage: Ft,
  isAlpha: S$,
  isAlphanumeric: M$,
  isArray: _g,
  isAscii: R$,
  isBIC: Ym,
  isBase32: Km,
  isBase58: ig,
  isBase64: D$,
  isBoolean: pg,
  isBooleanString: Bm,
  isBtcAddress: Jm,
  isByteLength: F$,
  isCreditCard: Z$,
  isCurrency: V$,
  isDataURI: th,
  isDate: vg,
  isDateString: Fm,
  isDecimal: N$,
  isDefined: Ip,
  isDivisibleBy: r$,
  isEAN: oh,
  isEmail: W$,
  isEmpty: Vp,
  isEnum: yg,
  isEthereumAddress: ih,
  isFQDN: Y$,
  isFirebasePushId: nm,
  isFullWidth: q$,
  isHSL: lh,
  isHalfWidth: Q$,
  isHash: Pm,
  isHexColor: av,
  isHexadecimal: iv,
  isIBAN: ph,
  isIP: fv,
  isISBN: gv,
  isISIN: xv,
  isISO31661Alpha2: Fv,
  isISO31661Alpha3: Bv,
  isISO4217CurrencyCode: cg,
  isISO8601: K1,
  isISRC: yh,
  isISSN: Dm,
  isIdentityCard: mh,
  isIn: zp,
  isInstance: Zg,
  isInt: xg,
  isJSON: Ev,
  isJWT: Ov,
  isLatLong: ai,
  isLatitude: Lp,
  isLocale: wh,
  isLongitude: kp,
  isLowercase: Pv,
  isMACAddress: lv,
  isMagnetURI: _h,
  isMilitaryTime: Om,
  isMimeType: Ch,
  isMobilePhone: Dv,
  isMongoId: Gv,
  isMultibyte: Kv,
  isNegative: d$,
  isNotEmpty: Kp,
  isNotEmptyObject: Bg,
  isNotIn: Xp,
  isNumber: hg,
  isNumberString: Gm,
  isObject: t2,
  isOctal: Ih,
  isPassportNumber: Th,
  isPhoneNumber: Mm,
  isPort: vv,
  isPositive: o$,
  isPostalCode: Fh,
  isRFC3339: Bh,
  isRgbColor: Gh,
  isSemVer: Kh,
  isString: Ag,
  isStrongPassword: ng,
  isSurrogatePair: Yv,
  isTaxId: ug,
  isTimeZone: ag,
  isURL: Jv,
  isUUID: tm,
  isUppercase: dm,
  isValidationOptions: Bc,
  isVariableWidth: rv,
  length: um,
  matches: hm,
  max: s$,
  maxDate: $$,
  maxLength: cm,
  min: l$,
  minDate: f$,
  minLength: pm,
  notContains: x$,
  notEquals: Up,
  registerDecorator: Op,
  registerSchema: Pj,
  useContainer: CP,
  validate: Oj,
  validateOrReject: Nj,
  validateSync: Ij
}, Symbol.toStringTag, { value: "Module" })), Tj = /* @__PURE__ */ lP(Rj);
var S4;
function Dj() {
  if (S4) return Jt;
  S4 = 1;
  var e = Jt && Jt.__decorate || function(o, a, d, i) {
    var s = arguments.length, u = s < 3 ? a : i === null ? i = Object.getOwnPropertyDescriptor(a, d) : i, c;
    if (typeof Reflect == "object" && typeof Reflect.decorate == "function") u = Reflect.decorate(o, a, d, i);
    else for (var l = o.length - 1; l >= 0; l--) (c = o[l]) && (u = (s < 3 ? c(u) : s > 3 ? c(a, d, u) : c(a, d)) || u);
    return s > 3 && u && Object.defineProperty(a, d, u), u;
  };
  Object.defineProperty(Jt, "__esModule", { value: !0 }), Jt.MatchConstraint = Jt.Match = void 0;
  const t = Tj, r = (o, a) => (d, i) => (0, t.registerDecorator)({
    target: d.constructor,
    propertyName: i,
    options: a,
    constraints: [o],
    validator: n
  });
  Jt.Match = r;
  let n = class {
    validate(o, a) {
      const [d] = (a == null ? void 0 : a.constraints) || [], i = (a == null ? void 0 : a.object)[d];
      return (0, t.equals)(o, i);
    }
    defaultMessage(o) {
      const [a] = (o == null ? void 0 : o.constraints) || [];
      return `${o == null ? void 0 : o.property} does not match the ${a}`;
    }
  };
  return Jt.MatchConstraint = n, Jt.MatchConstraint = n = e([
    (0, t.ValidatorConstraint)({ name: "Match" })
  ], n), Jt;
}
var _4 = {}, E4;
function Lj() {
  return E4 || (E4 = 1, Object.defineProperty(_4, "__esModule", { value: !0 })), _4;
}
var ed = {}, M4;
function Fj() {
  if (M4) return ed;
  M4 = 1, Object.defineProperty(ed, "__esModule", { value: !0 }), ed.isPlural = r;
  const e = /* @__PURE__ */ new Set([
    "address",
    "athletics",
    "billiards",
    "bowels",
    "business",
    "chaos",
    "chess",
    "crossroads",
    "economics",
    "ethics",
    "gallows",
    "gas",
    "genetics",
    "glass",
    "grass",
    "gymnastics",
    "happiness",
    "kindness",
    "linguistics",
    "loneliness",
    "mathematics",
    "measles",
    "minus",
    "mumps",
    "news",
    "physics",
    "progress",
    "success",
    "tennis",
    "acoustics",
    "aerobics",
    "aerodynamics",
    "aeronautics",
    "classics",
    "electronics",
    "logistics",
    "mechanics",
    "obstetrics",
    "politics",
    "statistics",
    "thermodynamics",
    "bowls",
    "cards",
    "darts",
    "diabetes",
    "rabies",
    "draughts",
    "skittles",
    "rickets",
    "shingles",
    "iris",
    "lens",
    "status"
  ]), t = /* @__PURE__ */ new Set([
    "feet",
    "teeth",
    "geese",
    "men",
    "women",
    "mice",
    "dice",
    "oxen",
    "children",
    "people",
    "pence",
    "foci",
    "radii",
    "fungi",
    "nuclei",
    "cacti",
    "alumni",
    "phenomena",
    "criteria",
    "data",
    "memoranda",
    "bacteria",
    "strata",
    "curricula",
    "media",
    "stadia",
    "syllabi",
    "antennae",
    "lice",
    "genera",
    "stimuli"
  ]);
  function r(n) {
    const o = n.toLowerCase();
    return !e.has(o) && !o.endsWith("itis") && !o.endsWith("osis") && (o.endsWith("s") || t.has(o));
  }
  return ed;
}
var rn = {}, C4;
function kj() {
  if (C4) return rn;
  C4 = 1, Object.defineProperty(rn, "__esModule", { value: !0 }), rn.EnumError = void 0, rn.createLookup = t, rn.createValues = r;
  class e extends Error {
    constructor(o) {
      super(o), Object.setPrototypeOf(this, e.prototype);
    }
  }
  rn.EnumError = e;
  function t(n, o, a) {
    const d = Object.entries(n).reduce((s, [u, c]) => Object.assign(Object.assign({}, s), { [c]: u }), {}), i = Object.values(n).join(", ");
    return (s) => {
      if (s == null)
        return s;
      const u = d[s.trim()];
      if (u === void 0) {
        if (o)
          return o;
        const c = `Enum value ${s.trim()} not found in [${i}].`;
        if (a === !0)
          throw new e(c);
        if (typeof a == "function")
          throw a(c);
      }
      return n[u];
    };
  }
  function r(n) {
    const o = Object.values(n).filter((a) => typeof a != "function");
    return () => o;
  }
  return rn;
}
var O4 = {}, N4;
function jj() {
  return N4 || (N4 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.env = void 0, e.forEnv = a, e.fromEnv = d;
    const t = Ep(), r = Ro();
    e.env = {
      serialize: n,
      deserialize: o
    };
    function n(i) {
      const s = {};
      return Object.entries(i).forEach(([u, c]) => {
        c === void 0 ? s[u] = "u:" : c === null ? s[u] = "n:" : typeof c == "string" ? s[u] = `S:${c}` : typeof c == "boolean" ? s[u] = `B:${c}` : typeof c == "number" ? s[u] = `N:${c}` : c instanceof Date ? s[u] = `D:${c.toISOString()}` : s[u] = `X:${(0, r.json)(c, !1)}`;
      }), s;
    }
    function o(i) {
      const s = {};
      return Object.entries(i).forEach(([u, c]) => {
        if (c == null) {
          s[u] = c;
          return;
        }
        const [l, p] = (0, r.split)(c, 2);
        switch (l) {
          case "S:":
            s[u] = p;
            break;
          case "B:":
            s[u] = p === "true";
            break;
          case "N:":
            s[u] = Number(p);
            break;
          case "D:":
            s[u] = new Date(p);
            break;
          case "X:":
            s[u] = JSON.parse(p);
            break;
          case "u:":
            s[u] = void 0;
            break;
          case "n:":
            s[u] = null;
            break;
          default:
            s[u] = c;
            break;
        }
      }), s;
    }
    function a(i, s, u) {
      return e.env.serialize((0, t.flatten)(i, s, u));
    }
    function d(i, s, u) {
      return (0, t.grow)(e.env.deserialize(i), s, u);
    }
  }(O4)), O4;
}
var Qo = {}, I4;
function Bj() {
  if (I4) return Qo;
  I4 = 1, Object.defineProperty(Qo, "__esModule", { value: !0 }), Qo.noop = e, Qo.debounce = t;
  function e() {
  }
  function t(r, n) {
    let o = null;
    return function(...a) {
      const d = a;
      o && clearTimeout(o), o = setTimeout(() => {
        r(...d), o = null;
      }, n);
    };
  }
  return Qo;
}
var Zt = {}, P4;
function Zj() {
  if (P4) return Zt;
  P4 = 1;
  var e = Zt && Zt.__asyncValues || function(i) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var s = i[Symbol.asyncIterator], u;
    return s ? s.call(i) : (i = typeof __values == "function" ? __values(i) : i[Symbol.iterator](), u = {}, c("next"), c("throw"), c("return"), u[Symbol.asyncIterator] = function() {
      return this;
    }, u);
    function c(p) {
      u[p] = i[p] && function(h) {
        return new Promise(function(m, f) {
          h = i[p](h), l(m, f, h.done, h.value);
        });
      };
    }
    function l(p, h, m, f) {
      Promise.resolve(f).then(function($) {
        p({ value: $, done: m });
      }, h);
    }
  };
  Object.defineProperty(Zt, "__esModule", { value: !0 }), Zt.readBodyBuffer = t, Zt.readBodyData = r, Zt.readBodyJson = n, Zt.parseUrl = o, Zt.urlPathJoin = a, Zt.urlQueryJoin = d;
  async function t(i, s) {
    var u, c, l, p;
    s = s ?? i;
    let h = s.bodyBuffer;
    if (h === void 0) {
      if (!i.readableLength)
        return;
      const v = [];
      try {
        for (var m = !0, f = e(i), $; $ = await f.next(), u = $.done, !u; m = !0) {
          p = $.value, m = !1;
          const y = p;
          v.push(y);
        }
      } catch (y) {
        c = { error: y };
      } finally {
        try {
          !m && !u && (l = f.return) && await l.call(f);
        } finally {
          if (c) throw c.error;
        }
      }
      h = Buffer.concat(v), s.bodyBuffer = h;
    }
    return h;
  }
  async function r(i, s) {
    s = s ?? i;
    let u = s.bodyData;
    if (u === void 0) {
      if (u = await t(i), !u)
        return;
      u = u.toString(), s.bodyData = u;
    }
    return u;
  }
  async function n(i, s) {
    s = s ?? i;
    let u = s.bodyJson;
    if (u === void 0) {
      const c = await r(i);
      if (c === void 0)
        return;
      u = JSON.parse(c), s.bodyJson = u;
    }
    return u;
  }
  function o(i) {
    const s = i.startsWith("https:") ? "https:" : "http:", u = i.indexOf("?");
    let c = i, l = "";
    u !== -1 && (c = i.substr(0, u), l = i.substr(u + 1));
    let p = c.indexOf("://");
    p = p === -1 ? 0 : p + 3;
    let h = c.indexOf("/", p);
    h = h !== -1 ? h : void 0;
    const m = c.substring(p, h);
    let f = "";
    return h !== void 0 && (f = c.substr(h + 1)), {
      protocol: s,
      base: c,
      host: m,
      path: f,
      query: l
    };
  }
  function a(i, ...s) {
    let u = i;
    for (const c of s)
      u.endsWith("/") && c.startsWith("/") ? u += c.substring(1) : u.endsWith("/") || c.startsWith("/") ? u += c : u += "/" + c;
    return u;
  }
  function d(...i) {
    return i.join("&");
  }
  return Zt;
}
var Vn = {}, R4;
function Uj() {
  if (R4) return Vn;
  R4 = 1, Object.defineProperty(Vn, "__esModule", { value: !0 }), Vn.Interval = void 0, Vn.interval = a;
  const e = 1e3, t = 60 * (60 * e), r = 24 * t, n = 7 * r;
  class o {
    constructor(i) {
      this.milliseconds = 0, this.milliseconds = i ?? 0;
    }
    millis(i) {
      return this.milliseconds += i, this;
    }
    sec(i) {
      return this.milliseconds += i * e, this;
    }
    min(i) {
      return this.milliseconds += i * t, this;
    }
    hours(i) {
      return this.milliseconds += i * t, this;
    }
    days(i) {
      return this.milliseconds += i * r, this;
    }
    weeks(i) {
      return this.milliseconds += i * n, this;
    }
    value() {
      return this.milliseconds;
    }
    before(i) {
      var s;
      const u = (s = i == null ? void 0 : i.getDate()) !== null && s !== void 0 ? s : Date.now();
      return new Date(u - this.milliseconds);
    }
    after(i) {
      var s;
      const u = (s = i == null ? void 0 : i.getDate()) !== null && s !== void 0 ? s : Date.now();
      return new Date(u + this.milliseconds);
    }
  }
  Vn.Interval = o;
  function a(d) {
    return new o(d);
  }
  return Vn;
}
var Hn = {}, T4;
function Gj() {
  if (T4) return Hn;
  T4 = 1, Object.defineProperty(Hn, "__esModule", { value: !0 }), Hn.flushPromises = e, Hn.useFakeTimers = t, Hn.advanceTimersByTime = r;
  async function e(n = !1) {
    if (n)
      await new Promise((o) => process.nextTick(o));
    else
      return new Promise(jest.requireActual("timers").setImmediate);
  }
  function t(n = !1) {
    n ? jest.useFakeTimers({ legacyFakeTimers: !0 }) : (jest.useFakeTimers(), jest.setSystemTime(0));
  }
  async function r(n) {
    jest.advanceTimersByTime(n), await e();
  }
  return Hn;
}
var td = {}, D4;
function Vj() {
  if (D4) return td;
  D4 = 1, Object.defineProperty(td, "__esModule", { value: !0 }), td.pluralize = e;
  function e(t, r, n, o) {
    o = o || n;
    const a = t % 10, d = t % 100;
    return d >= 11 && d <= 14 || a === 0 ? o : a === 1 ? r : a <= 4 ? n : o;
  }
  return td;
}
var rd = {}, L4;
function Hj() {
  if (L4) return rd;
  L4 = 1, Object.defineProperty(rd, "__esModule", { value: !0 }), rd.onProcessExit = e;
  function e(t) {
    process.on("exit", () => console.log("EXIT")), process.on("SIGINT", async () => {
      await t(), process.exit();
    }), process.on("SIGTERM", async () => {
      await t(), process.exit();
    }), process.on("SIGUSR1", async () => {
      await t(), process.exit();
    }), process.on("SIGUSR2", async () => {
      await t(), process.exit();
    }), process.on("SIGQUIT", async () => {
      await t(), process.exit();
    });
  }
  return rd;
}
var Ut = {}, F4;
function Kj() {
  if (F4) return Ut;
  F4 = 1, Object.defineProperty(Ut, "__esModule", { value: !0 }), Ut.Deferred = Ut.PromiseStatus = void 0, Ut.promiseWithStatus = t, Ut.resolveDelayed = r, Ut.pause = n, Ut.rejectDelayed = o;
  var e;
  (function(i) {
    i.pending = "pending", i.fulfilled = "fulfilled", i.rejected = "rejected";
  })(e || (Ut.PromiseStatus = e = {}));
  function t(i) {
    const s = Promise.resolve(i);
    return s.status = e.pending, s.then((u) => (s.status = e.fulfilled, u)).catch(() => {
      s.status = e.rejected;
    }), s;
  }
  function r(i, s) {
    return new Promise((u) => {
      setTimeout(() => {
        u(s);
      }, i);
    });
  }
  function n(i) {
    return r(i);
  }
  function o(i, s) {
    return new Promise((u, c) => {
      setTimeout(() => {
        c(s);
      }, i);
    });
  }
  let a = 1;
  class d {
    constructor() {
      this._settled = !1, this._resolved = !1, this._rejected = !1, this._promise = new Promise((s, u) => {
        this.resolveFn = s, this.rejectFn = u;
      }), this.id = a++;
    }
    resolve(s) {
      this.resolveFn(s), this._resolved = !0, this._settled = !0;
    }
    reject(s) {
      this.rejectFn(s), this._rejected = !0, this._settled = !0;
    }
    get promise() {
      return this._promise;
    }
    get isSettled() {
      return this._settled;
    }
    get isRejected() {
      return this._rejected;
    }
    get isResolved() {
      return this._resolved;
    }
  }
  return Ut.Deferred = d, Ut;
}
var k4 = {}, j4;
function Wj() {
  return j4 || (j4 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.resolved = void 0, e.processTemplate = r;
    function t() {
      function n(a) {
        return Promise.all(a.map((d) => Array.isArray(d) ? n(d) : d));
      }
      function o(a, ...d) {
        return d.length === 1 && a.length === 2 && a[0] === "" && a[1] === "";
      }
      return async function(a, ...d) {
        return o(a, d) ? d[0] : n(d).then((i) => String.raw({ raw: a }, i));
      };
    }
    e.resolved = t();
    async function r(n, o = {}, a = {}) {
      const d = Object.assign(Object.assign(Object.assign({}, o), a), { resolved: e.resolved }), i = Object.keys(d), s = Object.values(d);
      return new Function(...i, "return resolved`" + n + "`")(...s);
    }
  }(k4)), k4;
}
var B4 = {}, Z4;
function zj() {
  return Z4 || (Z4 = 1, Object.defineProperty(B4, "__esModule", { value: !0 })), B4;
}
var nd = {}, U4;
function Yj() {
  if (U4) return nd;
  U4 = 1, Object.defineProperty(nd, "__esModule", { value: !0 }), nd.uuid7 = r;
  let e = 0, t = 0;
  function r() {
    function n() {
      const a = o(), d = Math.random(), i = String(a) + String(~~(d * 9e4) + 1e4), s = i.length;
      return `${i.slice(0, 8)}-${i.slice(8, 12)}-4${i.slice(12, 15)}-${[8, 9, "a", "b"][~~(d * 3)]}${i.slice(15, 18)}-${i.slice(18, 24)}${i.slice(s - 12, s - (30 - s))}`;
    }
    function o() {
      const a = Date.now();
      return a !== e && (e = a, t = 1), BigInt(a) * BigInt(1e6) + BigInt(Math.min(t++, 999999));
    }
    return n();
  }
  return nd;
}
var od = {}, G4;
function Xj() {
  if (G4) return od;
  G4 = 1, Object.defineProperty(od, "__esModule", { value: !0 }), od.createEmailAlias = e;
  function e(t, r) {
    const [n, o] = t.split("@");
    return n.includes("+") ? `${n}-${r}@${o}` : `${n}+${r}@${o}`;
  }
  return od;
}
var V4;
function qj() {
  return V4 || (V4 = 1, function(e) {
    var t = Mn && Mn.__createBinding || (Object.create ? function(n, o, a, d) {
      d === void 0 && (d = a);
      var i = Object.getOwnPropertyDescriptor(o, a);
      (!i || ("get" in i ? !o.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
        return o[a];
      } }), Object.defineProperty(n, d, i);
    } : function(n, o, a, d) {
      d === void 0 && (d = a), n[d] = o[a];
    }), r = Mn && Mn.__exportStar || function(n, o) {
      for (var a in n) a !== "default" && !Object.prototype.hasOwnProperty.call(o, a) && t(o, n, a);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), r(pP(), e), r(Ep(), e), r($P(), e), r(vP(), e), r(mP(), e), r(hP(), e), r(Dj(), e), r(Lj(), e), r(Mp(), e), r(Fj(), e), r(kj(), e), r(jj(), e), r(Bj(), e), r(Zj(), e), r(Uj(), e), r(Gj(), e), r(Vj(), e), r(oi(), e), r(Hj(), e), r(Kj(), e), r(Ro(), e), r(Wj(), e), r(zj(), e), r(Yj(), e), r(Xj(), e);
  }(Mn)), Mn;
}
qj();
function H4(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Ug(...e) {
  return (t) => {
    let r = !1;
    const n = e.map((o) => {
      const a = H4(o, t);
      return !r && typeof a == "function" && (r = !0), a;
    });
    if (r)
      return () => {
        for (let o = 0; o < n.length; o++) {
          const a = n[o];
          typeof a == "function" ? a() : H4(e[o], null);
        }
      };
  };
}
function bn(...e) {
  return x.useCallback(Ug(...e), e);
}
var To = x.forwardRef((e, t) => {
  const { children: r, ...n } = e, o = x.Children.toArray(r), a = o.find(Jj);
  if (a) {
    const d = a.props.children, i = o.map((s) => s === a ? x.Children.count(d) > 1 ? x.Children.only(null) : x.isValidElement(d) ? d.props.children : null : s);
    return /* @__PURE__ */ A(zc, { ...n, ref: t, children: x.isValidElement(d) ? x.cloneElement(d, void 0, i) : null });
  }
  return /* @__PURE__ */ A(zc, { ...n, ref: t, children: r });
});
To.displayName = "Slot";
var zc = x.forwardRef((e, t) => {
  const { children: r, ...n } = e;
  if (x.isValidElement(r)) {
    const o = eB(r), a = Qj(n, r.props);
    return r.type !== x.Fragment && (a.ref = t ? Ug(t, o) : o), x.cloneElement(r, a);
  }
  return x.Children.count(r) > 1 ? x.Children.only(null) : null;
});
zc.displayName = "SlotClone";
var Gg = ({ children: e }) => /* @__PURE__ */ A(Ge, { children: e });
function Jj(e) {
  return x.isValidElement(e) && e.type === Gg;
}
function Qj(e, t) {
  const r = { ...t };
  for (const n in t) {
    const o = e[n], a = t[n];
    /^on[A-Z]/.test(n) ? o && a ? r[n] = (...d) => {
      a(...d), o(...d);
    } : o && (r[n] = o) : n === "style" ? r[n] = { ...o, ...a } : n === "className" && (r[n] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function eB(e) {
  var t, r;
  let n = (t = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : t.get, o = n && "isReactWarning" in n && n.isReactWarning;
  return o ? e.ref : (n = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, o = n && "isReactWarning" in n && n.isReactWarning, o ? e.props.ref : e.props.ref || e.ref);
}
const tB = jt(
  "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring active:bg-secondary disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground shadow hover:bg-primary/90",
        destructive: "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        outline: "border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
        ghost: "hover:bg-secondary/50 hover:text-primary-foreground",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "size-9"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), pn = X(
  ({ className: e, variant: t, size: r, asChild: n = !1, ...o }, a) => /* @__PURE__ */ A(n ? To : "button", { className: q(tB({ variant: t, size: r, className: e })), ref: a, ...o })
);
pn.displayName = "Button";
function rB(e, t) {
  const r = x.createContext(t), n = (a) => {
    const { children: d, ...i } = a, s = x.useMemo(() => i, Object.values(i));
    return /* @__PURE__ */ A(r.Provider, { value: s, children: d });
  };
  n.displayName = e + "Provider";
  function o(a) {
    const d = x.useContext(r);
    if (d) return d;
    if (t !== void 0) return t;
    throw new Error(`\`${a}\` must be used within \`${e}\``);
  }
  return [n, o];
}
function At(e, t = []) {
  let r = [];
  function n(a, d) {
    const i = x.createContext(d), s = r.length;
    r = [...r, d];
    const u = (l) => {
      var p;
      const { scope: h, children: m, ...f } = l, $ = ((p = h == null ? void 0 : h[e]) == null ? void 0 : p[s]) || i, v = x.useMemo(() => f, Object.values(f));
      return /* @__PURE__ */ A($.Provider, { value: v, children: m });
    };
    u.displayName = a + "Provider";
    function c(l, p) {
      var h;
      const m = ((h = p == null ? void 0 : p[e]) == null ? void 0 : h[s]) || i, f = x.useContext(m);
      if (f) return f;
      if (d !== void 0) return d;
      throw new Error(`\`${l}\` must be used within \`${a}\``);
    }
    return [u, c];
  }
  const o = () => {
    const a = r.map((d) => x.createContext(d));
    return function(d) {
      const i = (d == null ? void 0 : d[e]) || a;
      return x.useMemo(
        () => ({ [`__scope${e}`]: { ...d, [e]: i } }),
        [d, i]
      );
    };
  };
  return o.scopeName = e, [n, nB(o, ...t)];
}
function nB(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(o) {
      const a = n.reduce((d, { useScope: i, scopeName: s }) => {
        const u = i(o)[`__scope${s}`];
        return { ...d, ...u };
      }, {});
      return x.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
function it(e) {
  const t = x.useRef(e);
  return x.useEffect(() => {
    t.current = e;
  }), x.useMemo(() => (...r) => {
    var n;
    return (n = t.current) == null ? void 0 : n.call(t, ...r);
  }, []);
}
var et = globalThis != null && globalThis.document ? x.useLayoutEffect : () => {
};
function K4(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function ui(...e) {
  return (t) => {
    let r = !1;
    const n = e.map((o) => {
      const a = K4(o, t);
      return !r && typeof a == "function" && (r = !0), a;
    });
    if (r)
      return () => {
        for (let o = 0; o < n.length; o++) {
          const a = n[o];
          typeof a == "function" ? a() : K4(e[o], null);
        }
      };
  };
}
function Oe(...e) {
  return x.useCallback(ui(...e), e);
}
// @__NO_SIDE_EFFECTS__
function $n(e) {
  const t = /* @__PURE__ */ oB(e), r = x.forwardRef((n, o) => {
    const { children: a, ...d } = n, i = x.Children.toArray(a), s = i.find(dB);
    if (s) {
      const u = s.props.children, c = i.map((l) => l === s ? x.Children.count(u) > 1 ? x.Children.only(null) : x.isValidElement(u) ? u.props.children : null : l);
      return /* @__PURE__ */ A(t, { ...d, ref: o, children: x.isValidElement(u) ? x.cloneElement(u, void 0, c) : null });
    }
    return /* @__PURE__ */ A(t, { ...d, ref: o, children: a });
  });
  return r.displayName = `${e}.Slot`, r;
}
// @__NO_SIDE_EFFECTS__
function oB(e) {
  const t = x.forwardRef((r, n) => {
    const { children: o, ...a } = r, d = x.isValidElement(o) ? sB(o) : void 0, i = Oe(d, n);
    if (x.isValidElement(o)) {
      const s = iB(a, o.props);
      return o.type !== x.Fragment && (s.ref = i), x.cloneElement(o, s);
    }
    return x.Children.count(o) > 1 ? x.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var aB = Symbol("radix.slottable");
function dB(e) {
  return x.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === aB;
}
function iB(e, t) {
  const r = { ...t };
  for (const n in t) {
    const o = e[n], a = t[n];
    /^on[A-Z]/.test(n) ? o && a ? r[n] = (...d) => {
      const i = a(...d);
      return o(...d), i;
    } : o && (r[n] = o) : n === "style" ? r[n] = { ...o, ...a } : n === "className" && (r[n] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function sB(e) {
  var t, r;
  let n = (t = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : t.get, o = n && "isReactWarning" in n && n.isReactWarning;
  return o ? e.ref : (n = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, o = n && "isReactWarning" in n && n.isReactWarning, o ? e.props.ref : e.props.ref || e.ref);
}
var uB = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], ge = uB.reduce((e, t) => {
  const r = /* @__PURE__ */ $n(`Primitive.${t}`), n = x.forwardRef((o, a) => {
    const { asChild: d, ...i } = o, s = d ? r : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ A(s, { ...i, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function r2(e, t) {
  e && Oo.flushSync(() => e.dispatchEvent(t));
}
var xu = { exports: {} }, wu = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var W4;
function lB() {
  if (W4) return wu;
  W4 = 1;
  var e = Ae;
  function t(l, p) {
    return l === p && (l !== 0 || 1 / l === 1 / p) || l !== l && p !== p;
  }
  var r = typeof Object.is == "function" ? Object.is : t, n = e.useState, o = e.useEffect, a = e.useLayoutEffect, d = e.useDebugValue;
  function i(l, p) {
    var h = p(), m = n({ inst: { value: h, getSnapshot: p } }), f = m[0].inst, $ = m[1];
    return a(
      function() {
        f.value = h, f.getSnapshot = p, s(f) && $({ inst: f });
      },
      [l, h, p]
    ), o(
      function() {
        return s(f) && $({ inst: f }), l(function() {
          s(f) && $({ inst: f });
        });
      },
      [l]
    ), d(h), h;
  }
  function s(l) {
    var p = l.getSnapshot;
    l = l.value;
    try {
      var h = p();
      return !r(l, h);
    } catch {
      return !0;
    }
  }
  function u(l, p) {
    return p();
  }
  var c = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? u : i;
  return wu.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : c, wu;
}
var z4 = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Y4;
function cB() {
  return Y4 || (Y4 = 1, process.env.NODE_ENV !== "production" && function() {
    function e(h, m) {
      return h === m && (h !== 0 || 1 / h === 1 / m) || h !== h && m !== m;
    }
    function t(h, m) {
      c || o.startTransition === void 0 || (c = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var f = m();
      if (!l) {
        var $ = m();
        a(f, $) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), l = !0);
      }
      $ = d({
        inst: { value: f, getSnapshot: m }
      });
      var v = $[0].inst, y = $[1];
      return s(
        function() {
          v.value = f, v.getSnapshot = m, r(v) && y({ inst: v });
        },
        [h, f, m]
      ), i(
        function() {
          return r(v) && y({ inst: v }), h(function() {
            r(v) && y({ inst: v });
          });
        },
        [h]
      ), u(f), f;
    }
    function r(h) {
      var m = h.getSnapshot;
      h = h.value;
      try {
        var f = m();
        return !a(h, f);
      } catch {
        return !0;
      }
    }
    function n(h, m) {
      return m();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var o = Ae, a = typeof Object.is == "function" ? Object.is : e, d = o.useState, i = o.useEffect, s = o.useLayoutEffect, u = o.useDebugValue, c = !1, l = !1, p = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? n : t;
    z4.useSyncExternalStore = o.useSyncExternalStore !== void 0 ? o.useSyncExternalStore : p, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), z4;
}
var X4;
function fB() {
  return X4 || (X4 = 1, process.env.NODE_ENV === "production" ? xu.exports = lB() : xu.exports = cB()), xu.exports;
}
var Vg = fB();
function pB() {
  return Vg.useSyncExternalStore(
    $B,
    () => !0,
    () => !1
  );
}
function $B() {
  return () => {
  };
}
var n2 = "Avatar", [vB, Une] = At(n2), [mB, Hg] = vB(n2), Kg = x.forwardRef(
  (e, t) => {
    const { __scopeAvatar: r, ...n } = e, [o, a] = x.useState("idle");
    return /* @__PURE__ */ A(
      mB,
      {
        scope: r,
        imageLoadingStatus: o,
        onImageLoadingStatusChange: a,
        children: /* @__PURE__ */ A(ge.span, { ...n, ref: t })
      }
    );
  }
);
Kg.displayName = n2;
var Wg = "AvatarImage", zg = x.forwardRef(
  (e, t) => {
    const { __scopeAvatar: r, src: n, onLoadingStatusChange: o = () => {
    }, ...a } = e, d = Hg(Wg, r), i = hB(n, a), s = it((u) => {
      o(u), d.onImageLoadingStatusChange(u);
    });
    return et(() => {
      i !== "idle" && s(i);
    }, [i, s]), i === "loaded" ? /* @__PURE__ */ A(ge.img, { ...a, ref: t, src: n }) : null;
  }
);
zg.displayName = Wg;
var Yg = "AvatarFallback", Xg = x.forwardRef(
  (e, t) => {
    const { __scopeAvatar: r, delayMs: n, ...o } = e, a = Hg(Yg, r), [d, i] = x.useState(n === void 0);
    return x.useEffect(() => {
      if (n !== void 0) {
        const s = window.setTimeout(() => i(!0), n);
        return () => window.clearTimeout(s);
      }
    }, [n]), d && a.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ A(ge.span, { ...o, ref: t }) : null;
  }
);
Xg.displayName = Yg;
function q4(e, t) {
  return e ? t ? (e.src !== t && (e.src = t), e.complete && e.naturalWidth > 0 ? "loaded" : "loading") : "error" : "idle";
}
function hB(e, { referrerPolicy: t, crossOrigin: r }) {
  const n = pB(), o = x.useRef(null), a = n ? (o.current || (o.current = new window.Image()), o.current) : null, [d, i] = x.useState(
    () => q4(a, e)
  );
  return et(() => {
    i(q4(a, e));
  }, [a, e]), et(() => {
    const s = (l) => () => {
      i(l);
    };
    if (!a) return;
    const u = s("loaded"), c = s("error");
    return a.addEventListener("load", u), a.addEventListener("error", c), t && (a.referrerPolicy = t), typeof r == "string" && (a.crossOrigin = r), () => {
      a.removeEventListener("load", u), a.removeEventListener("error", c);
    };
  }, [a, r, t]), d;
}
var qg = Kg, Jg = zg, Qg = Xg;
const gB = X(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  qg,
  {
    ref: r,
    className: q("relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full", e),
    ...t
  }
));
gB.displayName = qg.displayName;
const yB = X(({ className: e, ...t }, r) => /* @__PURE__ */ A(Jg, { ref: r, className: q("aspect-square h-full w-full", e), ...t }));
yB.displayName = Jg.displayName;
const bB = X(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  Qg,
  {
    ref: r,
    className: q("flex h-full w-full items-center justify-center rounded-full bg-muted", e),
    ...t
  }
));
bB.displayName = Qg.displayName;
const ey = X(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  "textarea",
  {
    className: q(
      "flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
      e
    ),
    ref: r,
    ...t
  }
));
ey.displayName = "Textarea";
/**
 * @license lucide-react v0.508.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xB = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], J4 = Wr("x", xB);
function wB() {
  return /* @__PURE__ */ ie(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      className: "text-foreground",
      children: [
        /* @__PURE__ */ A("circle", { cx: "4", cy: "12", r: "2", fill: "currentColor", children: /* @__PURE__ */ A(
          "animate",
          {
            id: "spinner_qFRN",
            begin: "0;spinner_OcgL.end+0.25s",
            attributeName: "cy",
            calcMode: "spline",
            dur: "0.6s",
            values: "12;6;12",
            keySplines: ".33,.66,.66,1;.33,0,.66,.33"
          }
        ) }),
        /* @__PURE__ */ A("circle", { cx: "12", cy: "12", r: "2", fill: "currentColor", children: /* @__PURE__ */ A(
          "animate",
          {
            begin: "spinner_qFRN.begin+0.1s",
            attributeName: "cy",
            calcMode: "spline",
            dur: "0.6s",
            values: "12;6;12",
            keySplines: ".33,.66,.66,1;.33,0,.66,.33"
          }
        ) }),
        /* @__PURE__ */ A("circle", { cx: "20", cy: "12", r: "2", fill: "currentColor", children: /* @__PURE__ */ A(
          "animate",
          {
            id: "spinner_OcgL",
            begin: "spinner_qFRN.begin+0.2s",
            attributeName: "cy",
            calcMode: "spline",
            dur: "0.6s",
            values: "12;6;12",
            keySplines: ".33,.66,.66,1;.33,0,.66,.33"
          }
        ) })
      ]
    }
  );
}
const AB = jt("group relative flex max-w-[60%] items-end gap-2", {
  variants: {
    variant: {
      received: "self-start",
      sent: "flex-row-reverse self-end"
    },
    layout: {
      default: "",
      ai: "w-full max-w-full items-center"
    }
  },
  defaultVariants: {
    variant: "received",
    layout: "default"
  }
}), SB = X(
  ({ className: e, variant: t, layout: r, children: n, ...o }, a) => /* @__PURE__ */ A(
    "div",
    {
      className: q(AB({ variant: t, layout: r, className: e }), "relative group"),
      ref: a,
      ...o,
      children: n
    }
  )
);
SB.displayName = "ChatBubble";
const _B = jt("p-4", {
  variants: {
    variant: {
      received: "rounded-r-lg rounded-tl-lg bg-secondary text-secondary-foreground",
      sent: "rounded-l-lg rounded-tr-lg bg-primary text-primary-foreground"
    },
    layout: {
      default: "",
      ai: "w-full rounded-none border-t bg-transparent"
    }
  },
  defaultVariants: {
    variant: "received",
    layout: "default"
  }
}), EB = X(
  ({ className: e, variant: t, layout: r, isLoading: n = !1, children: o, ...a }, d) => /* @__PURE__ */ A(
    "div",
    {
      className: q(
        _B({ variant: t, layout: r, className: e }),
        "break-words max-w-full whitespace-pre-wrap"
      ),
      ref: d,
      ...a,
      children: n ? /* @__PURE__ */ A("div", { className: "flex items-center space-x-2", children: /* @__PURE__ */ A(wB, {}) }) : o
    }
  )
);
EB.displayName = "ChatBubbleMessage";
const MB = X(
  ({ className: e, value: t, onKeyDown: r, onChange: n, placeholder: o, ...a }, d) => /* @__PURE__ */ A(
    ey,
    {
      autoComplete: "off",
      value: t,
      ref: d,
      onKeyDown: r,
      onChange: n,
      name: "message",
      placeholder: o,
      className: q(
        "max-h-12 px-4 py-3 bg-background text-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 w-full rounded-md flex items-center h-16 resize-none",
        e
      ),
      ...a
    }
  )
);
MB.displayName = "ChatInput";
const CB = X(
  ({ className: e, children: t, ...r }, n) => /* @__PURE__ */ A(
    "div",
    {
      className: q("flex flex-col w-full h-full p-4 gap-6 overflow-y-auto", e),
      ref: n,
      ...r,
      children: t
    }
  )
);
CB.displayName = "ChatMessageList";
/**
 * @license lucide-react v0.508.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OB = [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }]
];
Wr("message-circle", OB);
function Ia(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), o, a;
  for (a = 0; a < n.length; a++)
    o = n[a], !(t.indexOf(o) >= 0) && (r[o] = e[o]);
  return r;
}
var NB = ["color"], IB = /* @__PURE__ */ X(function(e, t) {
  var r = e.color, n = r === void 0 ? "currentColor" : r, o = Ia(e, NB);
  return _e("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, o, {
    ref: t
  }), _e("path", {
    d: "M11.4669 3.72684C11.7558 3.91574 11.8369 4.30308 11.648 4.59198L7.39799 11.092C7.29783 11.2452 7.13556 11.3467 6.95402 11.3699C6.77247 11.3931 6.58989 11.3355 6.45446 11.2124L3.70446 8.71241C3.44905 8.48022 3.43023 8.08494 3.66242 7.82953C3.89461 7.57412 4.28989 7.55529 4.5453 7.78749L6.75292 9.79441L10.6018 3.90792C10.7907 3.61902 11.178 3.53795 11.4669 3.72684Z",
    fill: n,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), PB = ["color"], RB = /* @__PURE__ */ X(function(e, t) {
  var r = e.color, n = r === void 0 ? "currentColor" : r, o = Ia(e, PB);
  return _e("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, o, {
    ref: t
  }), _e("path", {
    d: "M6.1584 3.13508C6.35985 2.94621 6.67627 2.95642 6.86514 3.15788L10.6151 7.15788C10.7954 7.3502 10.7954 7.64949 10.6151 7.84182L6.86514 11.8418C6.67627 12.0433 6.35985 12.0535 6.1584 11.8646C5.95694 11.6757 5.94673 11.3593 6.1356 11.1579L9.565 7.49985L6.1356 3.84182C5.94673 3.64036 5.95694 3.32394 6.1584 3.13508Z",
    fill: n,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), TB = ["color"], o2 = /* @__PURE__ */ X(function(e, t) {
  var r = e.color, n = r === void 0 ? "currentColor" : r, o = Ia(e, TB);
  return _e("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, o, {
    ref: t
  }), _e("path", {
    d: "M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z",
    fill: n,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), DB = ["color"], LB = /* @__PURE__ */ X(function(e, t) {
  var r = e.color, n = r === void 0 ? "currentColor" : r, o = Ia(e, DB);
  return _e("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, o, {
    ref: t
  }), _e("path", {
    d: "M9.875 7.5C9.875 8.81168 8.81168 9.875 7.5 9.875C6.18832 9.875 5.125 8.81168 5.125 7.5C5.125 6.18832 6.18832 5.125 7.5 5.125C8.81168 5.125 9.875 6.18832 9.875 7.5Z",
    fill: n
  }));
}), FB = ["color"], kB = /* @__PURE__ */ X(function(e, t) {
  var r = e.color, n = r === void 0 ? "currentColor" : r, o = Ia(e, FB);
  return _e("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, o, {
    ref: t
  }), _e("path", {
    d: "M10 6.5C10 8.433 8.433 10 6.5 10C4.567 10 3 8.433 3 6.5C3 4.567 4.567 3 6.5 3C8.433 3 10 4.567 10 6.5ZM9.30884 10.0159C8.53901 10.6318 7.56251 11 6.5 11C4.01472 11 2 8.98528 2 6.5C2 4.01472 4.01472 2 6.5 2C8.98528 2 11 4.01472 11 6.5C11 7.56251 10.6318 8.53901 10.0159 9.30884L12.8536 12.1464C13.0488 12.3417 13.0488 12.6583 12.8536 12.8536C12.6583 13.0488 12.3417 13.0488 12.1464 12.8536L9.30884 10.0159Z",
    fill: n,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
function ne(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(n) {
    if (e == null || e(n), r === !1 || !n.defaultPrevented)
      return t == null ? void 0 : t(n);
  };
}
var jB = x[" useId ".trim().toString()] || (() => {
}), BB = 0;
function It(e) {
  const [t, r] = x.useState(jB());
  return et(() => {
    r((n) => n ?? String(BB++));
  }, [e]), t ? `radix-${t}` : "";
}
var ZB = x[" useInsertionEffect ".trim().toString()] || et;
function Do({
  prop: e,
  defaultProp: t,
  onChange: r = () => {
  },
  caller: n
}) {
  const [o, a, d] = UB({
    defaultProp: t,
    onChange: r
  }), i = e !== void 0, s = i ? e : o;
  {
    const c = x.useRef(e !== void 0);
    x.useEffect(() => {
      const l = c.current;
      l !== i && console.warn(
        `${n} is changing from ${l ? "controlled" : "uncontrolled"} to ${i ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), c.current = i;
    }, [i, n]);
  }
  const u = x.useCallback(
    (c) => {
      var l;
      if (i) {
        const p = GB(c) ? c(e) : c;
        p !== e && ((l = d.current) == null || l.call(d, p));
      } else
        a(c);
    },
    [i, e, a, d]
  );
  return [s, u];
}
function UB({
  defaultProp: e,
  onChange: t
}) {
  const [r, n] = x.useState(e), o = x.useRef(r), a = x.useRef(t);
  return ZB(() => {
    a.current = t;
  }, [t]), x.useEffect(() => {
    var d;
    o.current !== r && ((d = a.current) == null || d.call(a, r), o.current = r);
  }, [r, o]), [r, n, a];
}
function GB(e) {
  return typeof e == "function";
}
function VB(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = it(e);
  x.useEffect(() => {
    const n = (o) => {
      o.key === "Escape" && r(o);
    };
    return t.addEventListener("keydown", n, { capture: !0 }), () => t.removeEventListener("keydown", n, { capture: !0 });
  }, [r, t]);
}
var HB = "DismissableLayer", Yc = "dismissableLayer.update", KB = "dismissableLayer.pointerDownOutside", WB = "dismissableLayer.focusOutside", Q4, ty = x.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), xn = x.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: r = !1,
      onEscapeKeyDown: n,
      onPointerDownOutside: o,
      onFocusOutside: a,
      onInteractOutside: d,
      onDismiss: i,
      ...s
    } = e, u = x.useContext(ty), [c, l] = x.useState(null), p = (c == null ? void 0 : c.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, h] = x.useState({}), m = Oe(t, (N) => l(N)), f = Array.from(u.layers), [$] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), v = f.indexOf($), y = c ? f.indexOf(c) : -1, S = u.layersWithOutsidePointerEventsDisabled.size > 0, w = y >= v, _ = YB((N) => {
      const O = N.target, E = [...u.branches].some((C) => C.contains(O));
      !w || E || (o == null || o(N), d == null || d(N), N.defaultPrevented || i == null || i());
    }, p), I = XB((N) => {
      const O = N.target;
      [...u.branches].some((E) => E.contains(O)) || (a == null || a(N), d == null || d(N), N.defaultPrevented || i == null || i());
    }, p);
    return VB((N) => {
      y === u.layers.size - 1 && (n == null || n(N), !N.defaultPrevented && i && (N.preventDefault(), i()));
    }, p), x.useEffect(() => {
      if (c)
        return r && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (Q4 = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(c)), u.layers.add(c), e8(), () => {
          r && u.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = Q4);
        };
    }, [c, p, r, u]), x.useEffect(() => () => {
      c && (u.layers.delete(c), u.layersWithOutsidePointerEventsDisabled.delete(c), e8());
    }, [c, u]), x.useEffect(() => {
      const N = () => h({});
      return document.addEventListener(Yc, N), () => document.removeEventListener(Yc, N);
    }, []), /* @__PURE__ */ A(
      ge.div,
      {
        ...s,
        ref: m,
        style: {
          pointerEvents: S ? w ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: ne(e.onFocusCapture, I.onFocusCapture),
        onBlurCapture: ne(e.onBlurCapture, I.onBlurCapture),
        onPointerDownCapture: ne(
          e.onPointerDownCapture,
          _.onPointerDownCapture
        )
      }
    );
  }
);
xn.displayName = HB;
var zB = "DismissableLayerBranch", ry = x.forwardRef((e, t) => {
  const r = x.useContext(ty), n = x.useRef(null), o = Oe(t, n);
  return x.useEffect(() => {
    const a = n.current;
    if (a)
      return r.branches.add(a), () => {
        r.branches.delete(a);
      };
  }, [r.branches]), /* @__PURE__ */ A(ge.div, { ...e, ref: o });
});
ry.displayName = zB;
function YB(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = it(e), n = x.useRef(!1), o = x.useRef(() => {
  });
  return x.useEffect(() => {
    const a = (i) => {
      if (i.target && !n.current) {
        let s = function() {
          ny(
            KB,
            r,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: i };
        i.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = s, t.addEventListener("click", o.current, { once: !0 })) : s();
      } else
        t.removeEventListener("click", o.current);
      n.current = !1;
    }, d = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(d), t.removeEventListener("pointerdown", a), t.removeEventListener("click", o.current);
    };
  }, [t, r]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => n.current = !0
  };
}
function XB(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = it(e), n = x.useRef(!1);
  return x.useEffect(() => {
    const o = (a) => {
      a.target && !n.current && ny(WB, r, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, r]), {
    onFocusCapture: () => n.current = !0,
    onBlurCapture: () => n.current = !1
  };
}
function e8() {
  const e = new CustomEvent(Yc);
  document.dispatchEvent(e);
}
function ny(e, t, r, { discrete: n }) {
  const o = r.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: r });
  t && o.addEventListener(e, t, { once: !0 }), n ? r2(o, a) : o.dispatchEvent(a);
}
var qB = xn, JB = ry, Au = "focusScope.autoFocusOnMount", Su = "focusScope.autoFocusOnUnmount", t8 = { bubbles: !1, cancelable: !0 }, QB = "FocusScope", Pa = x.forwardRef((e, t) => {
  const {
    loop: r = !1,
    trapped: n = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: a,
    ...d
  } = e, [i, s] = x.useState(null), u = it(o), c = it(a), l = x.useRef(null), p = Oe(t, (f) => s(f)), h = x.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  x.useEffect(() => {
    if (n) {
      let f = function(S) {
        if (h.paused || !i) return;
        const w = S.target;
        i.contains(w) ? l.current = w : Tr(l.current, { select: !0 });
      }, $ = function(S) {
        if (h.paused || !i) return;
        const w = S.relatedTarget;
        w !== null && (i.contains(w) || Tr(l.current, { select: !0 }));
      }, v = function(S) {
        if (document.activeElement === document.body)
          for (const w of S)
            w.removedNodes.length > 0 && Tr(i);
      };
      document.addEventListener("focusin", f), document.addEventListener("focusout", $);
      const y = new MutationObserver(v);
      return i && y.observe(i, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", f), document.removeEventListener("focusout", $), y.disconnect();
      };
    }
  }, [n, i, h.paused]), x.useEffect(() => {
    if (i) {
      n8.add(h);
      const f = document.activeElement;
      if (!i.contains(f)) {
        const $ = new CustomEvent(Au, t8);
        i.addEventListener(Au, u), i.dispatchEvent($), $.defaultPrevented || (eZ(aZ(oy(i)), { select: !0 }), document.activeElement === f && Tr(i));
      }
      return () => {
        i.removeEventListener(Au, u), setTimeout(() => {
          const $ = new CustomEvent(Su, t8);
          i.addEventListener(Su, c), i.dispatchEvent($), $.defaultPrevented || Tr(f ?? document.body, { select: !0 }), i.removeEventListener(Su, c), n8.remove(h);
        }, 0);
      };
    }
  }, [i, u, c, h]);
  const m = x.useCallback(
    (f) => {
      if (!r && !n || h.paused) return;
      const $ = f.key === "Tab" && !f.altKey && !f.ctrlKey && !f.metaKey, v = document.activeElement;
      if ($ && v) {
        const y = f.currentTarget, [S, w] = tZ(y);
        S && w ? !f.shiftKey && v === w ? (f.preventDefault(), r && Tr(S, { select: !0 })) : f.shiftKey && v === S && (f.preventDefault(), r && Tr(w, { select: !0 })) : v === y && f.preventDefault();
      }
    },
    [r, n, h.paused]
  );
  return /* @__PURE__ */ A(ge.div, { tabIndex: -1, ...d, ref: p, onKeyDown: m });
});
Pa.displayName = QB;
function eZ(e, { select: t = !1 } = {}) {
  const r = document.activeElement;
  for (const n of e)
    if (Tr(n, { select: t }), document.activeElement !== r) return;
}
function tZ(e) {
  const t = oy(e), r = r8(t, e), n = r8(t.reverse(), e);
  return [r, n];
}
function oy(e) {
  const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const o = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || o ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); ) t.push(r.currentNode);
  return t;
}
function r8(e, t) {
  for (const r of e)
    if (!rZ(r, { upTo: t })) return r;
}
function rZ(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function nZ(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Tr(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const r = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== r && nZ(e) && t && e.select();
  }
}
var n8 = oZ();
function oZ() {
  let e = [];
  return {
    add(t) {
      const r = e[0];
      t !== r && (r == null || r.pause()), e = o8(e, t), e.unshift(t);
    },
    remove(t) {
      var r;
      e = o8(e, t), (r = e[0]) == null || r.resume();
    }
  };
}
function o8(e, t) {
  const r = [...e], n = r.indexOf(t);
  return n !== -1 && r.splice(n, 1), r;
}
function aZ(e) {
  return e.filter((t) => t.tagName !== "A");
}
var _u = 0;
function li() {
  x.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? a8()), document.body.insertAdjacentElement("beforeend", e[1] ?? a8()), _u++, () => {
      _u === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), _u--;
    };
  }, []);
}
function a8() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var tr = function() {
  return tr = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, tr.apply(this, arguments);
};
function ay(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
}
function dZ(e, t, r) {
  for (var n = 0, o = t.length, a; n < o; n++)
    (a || !(n in t)) && (a || (a = Array.prototype.slice.call(t, 0, n)), a[n] = t[n]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var Sd = "right-scroll-bar-position", _d = "width-before-scroll-bar", iZ = "with-scroll-bars-hidden", sZ = "--removed-body-scroll-bar-size";
function Eu(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function uZ(e, t) {
  var r = Ie(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return r.value;
        },
        set current(n) {
          var o = r.value;
          o !== n && (r.value = n, r.callback(n, o));
        }
      }
    };
  })[0];
  return r.callback = t, r.facade;
}
var lZ = typeof window < "u" ? x.useLayoutEffect : x.useEffect, d8 = /* @__PURE__ */ new WeakMap();
function cZ(e, t) {
  var r = uZ(null, function(n) {
    return e.forEach(function(o) {
      return Eu(o, n);
    });
  });
  return lZ(function() {
    var n = d8.get(r);
    if (n) {
      var o = new Set(n), a = new Set(e), d = r.current;
      o.forEach(function(i) {
        a.has(i) || Eu(i, null);
      }), a.forEach(function(i) {
        o.has(i) || Eu(i, d);
      });
    }
    d8.set(r, e);
  }, [e]), r;
}
function fZ(e) {
  return e;
}
function pZ(e, t) {
  t === void 0 && (t = fZ);
  var r = [], n = !1, o = {
    read: function() {
      if (n)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return r.length ? r[r.length - 1] : e;
    },
    useMedium: function(a) {
      var d = t(a, n);
      return r.push(d), function() {
        r = r.filter(function(i) {
          return i !== d;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (n = !0; r.length; ) {
        var d = r;
        r = [], d.forEach(a);
      }
      r = {
        push: function(i) {
          return a(i);
        },
        filter: function() {
          return r;
        }
      };
    },
    assignMedium: function(a) {
      n = !0;
      var d = [];
      if (r.length) {
        var i = r;
        r = [], i.forEach(a), d = r;
      }
      var s = function() {
        var c = d;
        d = [], c.forEach(a);
      }, u = function() {
        return Promise.resolve().then(s);
      };
      u(), r = {
        push: function(c) {
          d.push(c), u();
        },
        filter: function(c) {
          return d = d.filter(c), r;
        }
      };
    }
  };
  return o;
}
function $Z(e) {
  e === void 0 && (e = {});
  var t = pZ(null);
  return t.options = tr({ async: !0, ssr: !1 }, e), t;
}
var dy = function(e) {
  var t = e.sideCar, r = ay(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = t.read();
  if (!n)
    throw new Error("Sidecar medium not found");
  return x.createElement(n, tr({}, r));
};
dy.isSideCarExport = !0;
function vZ(e, t) {
  return e.useMedium(t), dy;
}
var iy = $Z(), Mu = function() {
}, ci = x.forwardRef(function(e, t) {
  var r = x.useRef(null), n = x.useState({
    onScrollCapture: Mu,
    onWheelCapture: Mu,
    onTouchMoveCapture: Mu
  }), o = n[0], a = n[1], d = e.forwardProps, i = e.children, s = e.className, u = e.removeScrollBar, c = e.enabled, l = e.shards, p = e.sideCar, h = e.noIsolation, m = e.inert, f = e.allowPinchZoom, $ = e.as, v = $ === void 0 ? "div" : $, y = e.gapMode, S = ay(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), w = p, _ = cZ([r, t]), I = tr(tr({}, S), o);
  return x.createElement(
    x.Fragment,
    null,
    c && x.createElement(w, { sideCar: iy, removeScrollBar: u, shards: l, noIsolation: h, inert: m, setCallbacks: a, allowPinchZoom: !!f, lockRef: r, gapMode: y }),
    d ? x.cloneElement(x.Children.only(i), tr(tr({}, I), { ref: _ })) : x.createElement(v, tr({}, I, { className: s, ref: _ }), i)
  );
});
ci.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
ci.classNames = {
  fullWidth: _d,
  zeroRight: Sd
};
var mZ = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function hZ() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = mZ();
  return t && e.setAttribute("nonce", t), e;
}
function gZ(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function yZ(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var bZ = function() {
  var e = 0, t = null;
  return {
    add: function(r) {
      e == 0 && (t = hZ()) && (gZ(t, r), yZ(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, xZ = function() {
  var e = bZ();
  return function(t, r) {
    x.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && r]);
  };
}, sy = function() {
  var e = xZ(), t = function(r) {
    var n = r.styles, o = r.dynamic;
    return e(n, o), null;
  };
  return t;
}, wZ = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Cu = function(e) {
  return parseInt(e || "", 10) || 0;
}, AZ = function(e) {
  var t = window.getComputedStyle(document.body), r = t[e === "padding" ? "paddingLeft" : "marginLeft"], n = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Cu(r), Cu(n), Cu(o)];
}, SZ = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return wZ;
  var t = AZ(e), r = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, n - r + t[2] - t[0])
  };
}, _Z = sy(), wo = "data-scroll-locked", EZ = function(e, t, r, n) {
  var o = e.left, a = e.top, d = e.right, i = e.gap;
  return r === void 0 && (r = "margin"), `
  .`.concat(iZ, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(i, "px ").concat(n, `;
  }
  body[`).concat(wo, `] {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(n, ";"),
    r === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(d, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(i, "px ").concat(n, `;
    `),
    r === "padding" && "padding-right: ".concat(i, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Sd, ` {
    right: `).concat(i, "px ").concat(n, `;
  }
  
  .`).concat(_d, ` {
    margin-right: `).concat(i, "px ").concat(n, `;
  }
  
  .`).concat(Sd, " .").concat(Sd, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(_d, " .").concat(_d, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body[`).concat(wo, `] {
    `).concat(sZ, ": ").concat(i, `px;
  }
`);
}, i8 = function() {
  var e = parseInt(document.body.getAttribute(wo) || "0", 10);
  return isFinite(e) ? e : 0;
}, MZ = function() {
  x.useEffect(function() {
    return document.body.setAttribute(wo, (i8() + 1).toString()), function() {
      var e = i8() - 1;
      e <= 0 ? document.body.removeAttribute(wo) : document.body.setAttribute(wo, e.toString());
    };
  }, []);
}, CZ = function(e) {
  var t = e.noRelative, r = e.noImportant, n = e.gapMode, o = n === void 0 ? "margin" : n;
  MZ();
  var a = x.useMemo(function() {
    return SZ(o);
  }, [o]);
  return x.createElement(_Z, { styles: EZ(a, !t, o, r ? "" : "!important") });
}, Xc = !1;
if (typeof window < "u")
  try {
    var ad = Object.defineProperty({}, "passive", {
      get: function() {
        return Xc = !0, !0;
      }
    });
    window.addEventListener("test", ad, ad), window.removeEventListener("test", ad, ad);
  } catch {
    Xc = !1;
  }
var Kn = Xc ? { passive: !1 } : !1, OZ = function(e) {
  return e.tagName === "TEXTAREA";
}, uy = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var r = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    r[t] !== "hidden" && // contains scroll inside self
    !(r.overflowY === r.overflowX && !OZ(e) && r[t] === "visible")
  );
}, NZ = function(e) {
  return uy(e, "overflowY");
}, IZ = function(e) {
  return uy(e, "overflowX");
}, s8 = function(e, t) {
  var r = t.ownerDocument, n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var o = ly(e, n);
    if (o) {
      var a = cy(e, n), d = a[1], i = a[2];
      if (d > i)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== r.body);
  return !1;
}, PZ = function(e) {
  var t = e.scrollTop, r = e.scrollHeight, n = e.clientHeight;
  return [
    t,
    r,
    n
  ];
}, RZ = function(e) {
  var t = e.scrollLeft, r = e.scrollWidth, n = e.clientWidth;
  return [
    t,
    r,
    n
  ];
}, ly = function(e, t) {
  return e === "v" ? NZ(t) : IZ(t);
}, cy = function(e, t) {
  return e === "v" ? PZ(t) : RZ(t);
}, TZ = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, DZ = function(e, t, r, n, o) {
  var a = TZ(e, window.getComputedStyle(t).direction), d = a * n, i = r.target, s = t.contains(i), u = !1, c = d > 0, l = 0, p = 0;
  do {
    var h = cy(e, i), m = h[0], f = h[1], $ = h[2], v = f - $ - a * m;
    (m || v) && ly(e, i) && (l += v, p += m), i instanceof ShadowRoot ? i = i.host : i = i.parentNode;
  } while (
    // portaled content
    !s && i !== document.body || // self content
    s && (t.contains(i) || t === i)
  );
  return (c && Math.abs(l) < 1 || !c && Math.abs(p) < 1) && (u = !0), u;
}, dd = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, u8 = function(e) {
  return [e.deltaX, e.deltaY];
}, l8 = function(e) {
  return e && "current" in e ? e.current : e;
}, LZ = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, FZ = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, kZ = 0, Wn = [];
function jZ(e) {
  var t = x.useRef([]), r = x.useRef([0, 0]), n = x.useRef(), o = x.useState(kZ++)[0], a = x.useState(sy)[0], d = x.useRef(e);
  x.useEffect(function() {
    d.current = e;
  }, [e]), x.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var f = dZ([e.lockRef.current], (e.shards || []).map(l8)).filter(Boolean);
      return f.forEach(function($) {
        return $.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), f.forEach(function($) {
          return $.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var i = x.useCallback(function(f, $) {
    if ("touches" in f && f.touches.length === 2 || f.type === "wheel" && f.ctrlKey)
      return !d.current.allowPinchZoom;
    var v = dd(f), y = r.current, S = "deltaX" in f ? f.deltaX : y[0] - v[0], w = "deltaY" in f ? f.deltaY : y[1] - v[1], _, I = f.target, N = Math.abs(S) > Math.abs(w) ? "h" : "v";
    if ("touches" in f && N === "h" && I.type === "range")
      return !1;
    var O = s8(N, I);
    if (!O)
      return !0;
    if (O ? _ = N : (_ = N === "v" ? "h" : "v", O = s8(N, I)), !O)
      return !1;
    if (!n.current && "changedTouches" in f && (S || w) && (n.current = _), !_)
      return !0;
    var E = n.current || _;
    return DZ(E, $, f, E === "h" ? S : w);
  }, []), s = x.useCallback(function(f) {
    var $ = f;
    if (!(!Wn.length || Wn[Wn.length - 1] !== a)) {
      var v = "deltaY" in $ ? u8($) : dd($), y = t.current.filter(function(_) {
        return _.name === $.type && (_.target === $.target || $.target === _.shadowParent) && LZ(_.delta, v);
      })[0];
      if (y && y.should) {
        $.cancelable && $.preventDefault();
        return;
      }
      if (!y) {
        var S = (d.current.shards || []).map(l8).filter(Boolean).filter(function(_) {
          return _.contains($.target);
        }), w = S.length > 0 ? i($, S[0]) : !d.current.noIsolation;
        w && $.cancelable && $.preventDefault();
      }
    }
  }, []), u = x.useCallback(function(f, $, v, y) {
    var S = { name: f, delta: $, target: v, should: y, shadowParent: BZ(v) };
    t.current.push(S), setTimeout(function() {
      t.current = t.current.filter(function(w) {
        return w !== S;
      });
    }, 1);
  }, []), c = x.useCallback(function(f) {
    r.current = dd(f), n.current = void 0;
  }, []), l = x.useCallback(function(f) {
    u(f.type, u8(f), f.target, i(f, e.lockRef.current));
  }, []), p = x.useCallback(function(f) {
    u(f.type, dd(f), f.target, i(f, e.lockRef.current));
  }, []);
  x.useEffect(function() {
    return Wn.push(a), e.setCallbacks({
      onScrollCapture: l,
      onWheelCapture: l,
      onTouchMoveCapture: p
    }), document.addEventListener("wheel", s, Kn), document.addEventListener("touchmove", s, Kn), document.addEventListener("touchstart", c, Kn), function() {
      Wn = Wn.filter(function(f) {
        return f !== a;
      }), document.removeEventListener("wheel", s, Kn), document.removeEventListener("touchmove", s, Kn), document.removeEventListener("touchstart", c, Kn);
    };
  }, []);
  var h = e.removeScrollBar, m = e.inert;
  return x.createElement(
    x.Fragment,
    null,
    m ? x.createElement(a, { styles: FZ(o) }) : null,
    h ? x.createElement(CZ, { gapMode: e.gapMode }) : null
  );
}
function BZ(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const ZZ = vZ(iy, jZ);
var Ra = x.forwardRef(function(e, t) {
  return x.createElement(ci, tr({}, e, { ref: t, sideCar: ZZ }));
});
Ra.classNames = ci.classNames;
var UZ = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, zn = /* @__PURE__ */ new WeakMap(), id = /* @__PURE__ */ new WeakMap(), sd = {}, Ou = 0, fy = function(e) {
  return e && (e.host || fy(e.parentNode));
}, GZ = function(e, t) {
  return t.map(function(r) {
    if (e.contains(r))
      return r;
    var n = fy(r);
    return n && e.contains(n) ? n : (console.error("aria-hidden", r, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(r) {
    return !!r;
  });
}, VZ = function(e, t, r, n) {
  var o = GZ(t, Array.isArray(e) ? e : [e]);
  sd[r] || (sd[r] = /* @__PURE__ */ new WeakMap());
  var a = sd[r], d = [], i = /* @__PURE__ */ new Set(), s = new Set(o), u = function(l) {
    !l || i.has(l) || (i.add(l), u(l.parentNode));
  };
  o.forEach(u);
  var c = function(l) {
    !l || s.has(l) || Array.prototype.forEach.call(l.children, function(p) {
      if (i.has(p))
        c(p);
      else
        try {
          var h = p.getAttribute(n), m = h !== null && h !== "false", f = (zn.get(p) || 0) + 1, $ = (a.get(p) || 0) + 1;
          zn.set(p, f), a.set(p, $), d.push(p), f === 1 && m && id.set(p, !0), $ === 1 && p.setAttribute(r, "true"), m || p.setAttribute(n, "true");
        } catch (v) {
          console.error("aria-hidden: cannot operate on ", p, v);
        }
    });
  };
  return c(t), i.clear(), Ou++, function() {
    d.forEach(function(l) {
      var p = zn.get(l) - 1, h = a.get(l) - 1;
      zn.set(l, p), a.set(l, h), p || (id.has(l) || l.removeAttribute(n), id.delete(l)), h || l.removeAttribute(r);
    }), Ou--, Ou || (zn = /* @__PURE__ */ new WeakMap(), zn = /* @__PURE__ */ new WeakMap(), id = /* @__PURE__ */ new WeakMap(), sd = {});
  };
}, fi = function(e, t, r) {
  r === void 0 && (r = "data-aria-hidden");
  var n = Array.from(Array.isArray(e) ? e : [e]), o = UZ(e);
  return o ? (n.push.apply(n, Array.from(o.querySelectorAll("[aria-live]"))), VZ(n, o, r, "aria-hidden")) : function() {
    return null;
  };
}, HZ = "Portal", Lo = x.forwardRef((e, t) => {
  var r;
  const { container: n, ...o } = e, [a, d] = x.useState(!1);
  et(() => d(!0), []);
  const i = n || a && ((r = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : r.body);
  return i ? OO.createPortal(/* @__PURE__ */ A(ge.div, { ...o, ref: t }), i) : null;
});
Lo.displayName = HZ;
function KZ(e, t) {
  return x.useReducer((r, n) => t[r][n] ?? r, e);
}
var St = (e) => {
  const { present: t, children: r } = e, n = WZ(t), o = typeof r == "function" ? r({ present: n.isPresent }) : x.Children.only(r), a = Oe(n.ref, zZ(o));
  return typeof r == "function" || n.isPresent ? x.cloneElement(o, { ref: a }) : null;
};
St.displayName = "Presence";
function WZ(e) {
  const [t, r] = x.useState(), n = x.useRef(null), o = x.useRef(e), a = x.useRef("none"), d = e ? "mounted" : "unmounted", [i, s] = KZ(d, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return x.useEffect(() => {
    const u = ud(n.current);
    a.current = i === "mounted" ? u : "none";
  }, [i]), et(() => {
    const u = n.current, c = o.current;
    if (c !== e) {
      const l = a.current, p = ud(u);
      e ? s("MOUNT") : p === "none" || (u == null ? void 0 : u.display) === "none" ? s("UNMOUNT") : s(c && l !== p ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, s]), et(() => {
    if (t) {
      let u;
      const c = t.ownerDocument.defaultView ?? window, l = (h) => {
        const m = ud(n.current).includes(h.animationName);
        if (h.target === t && m && (s("ANIMATION_END"), !o.current)) {
          const f = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = c.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = f);
          });
        }
      }, p = (h) => {
        h.target === t && (a.current = ud(n.current));
      };
      return t.addEventListener("animationstart", p), t.addEventListener("animationcancel", l), t.addEventListener("animationend", l), () => {
        c.clearTimeout(u), t.removeEventListener("animationstart", p), t.removeEventListener("animationcancel", l), t.removeEventListener("animationend", l);
      };
    } else
      s("ANIMATION_END");
  }, [t, s]), {
    isPresent: ["mounted", "unmountSuspended"].includes(i),
    ref: x.useCallback((u) => {
      n.current = u ? getComputedStyle(u) : null, r(u);
    }, [])
  };
}
function ud(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function zZ(e) {
  var t, r;
  let n = (t = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : t.get, o = n && "isReactWarning" in n && n.isReactWarning;
  return o ? e.ref : (n = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, o = n && "isReactWarning" in n && n.isReactWarning, o ? e.props.ref : e.props.ref || e.ref);
}
var pi = "Dialog", [py, Gne] = At(pi), [YZ, qt] = py(pi), $y = (e) => {
  const {
    __scopeDialog: t,
    children: r,
    open: n,
    defaultOpen: o,
    onOpenChange: a,
    modal: d = !0
  } = e, i = x.useRef(null), s = x.useRef(null), [u, c] = Do({
    prop: n,
    defaultProp: o ?? !1,
    onChange: a,
    caller: pi
  });
  return /* @__PURE__ */ A(
    YZ,
    {
      scope: t,
      triggerRef: i,
      contentRef: s,
      contentId: It(),
      titleId: It(),
      descriptionId: It(),
      open: u,
      onOpenChange: c,
      onOpenToggle: x.useCallback(() => c((l) => !l), [c]),
      modal: d,
      children: r
    }
  );
};
$y.displayName = pi;
var vy = "DialogTrigger", XZ = x.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, o = qt(vy, r), a = Oe(t, o.triggerRef);
    return /* @__PURE__ */ A(
      ge.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": i2(o.open),
        ...n,
        ref: a,
        onClick: ne(e.onClick, o.onOpenToggle)
      }
    );
  }
);
XZ.displayName = vy;
var a2 = "DialogPortal", [qZ, my] = py(a2, {
  forceMount: void 0
}), hy = (e) => {
  const { __scopeDialog: t, forceMount: r, children: n, container: o } = e, a = qt(a2, t);
  return /* @__PURE__ */ A(qZ, { scope: t, forceMount: r, children: x.Children.map(n, (d) => /* @__PURE__ */ A(St, { present: r || a.open, children: /* @__PURE__ */ A(Lo, { asChild: !0, container: o, children: d }) })) });
};
hy.displayName = a2;
var jd = "DialogOverlay", gy = x.forwardRef(
  (e, t) => {
    const r = my(jd, e.__scopeDialog), { forceMount: n = r.forceMount, ...o } = e, a = qt(jd, e.__scopeDialog);
    return a.modal ? /* @__PURE__ */ A(St, { present: n || a.open, children: /* @__PURE__ */ A(QZ, { ...o, ref: t }) }) : null;
  }
);
gy.displayName = jd;
var JZ = /* @__PURE__ */ $n("DialogOverlay.RemoveScroll"), QZ = x.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, o = qt(jd, r);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ A(Ra, { as: JZ, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ A(
        ge.div,
        {
          "data-state": i2(o.open),
          ...n,
          ref: t,
          style: { pointerEvents: "auto", ...n.style }
        }
      ) })
    );
  }
), vn = "DialogContent", yy = x.forwardRef(
  (e, t) => {
    const r = my(vn, e.__scopeDialog), { forceMount: n = r.forceMount, ...o } = e, a = qt(vn, e.__scopeDialog);
    return /* @__PURE__ */ A(St, { present: n || a.open, children: a.modal ? /* @__PURE__ */ A(eU, { ...o, ref: t }) : /* @__PURE__ */ A(tU, { ...o, ref: t }) });
  }
);
yy.displayName = vn;
var eU = x.forwardRef(
  (e, t) => {
    const r = qt(vn, e.__scopeDialog), n = x.useRef(null), o = Oe(t, r.contentRef, n);
    return x.useEffect(() => {
      const a = n.current;
      if (a) return fi(a);
    }, []), /* @__PURE__ */ A(
      by,
      {
        ...e,
        ref: o,
        trapFocus: r.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: ne(e.onCloseAutoFocus, (a) => {
          var d;
          a.preventDefault(), (d = r.triggerRef.current) == null || d.focus();
        }),
        onPointerDownOutside: ne(e.onPointerDownOutside, (a) => {
          const d = a.detail.originalEvent, i = d.button === 0 && d.ctrlKey === !0;
          (d.button === 2 || i) && a.preventDefault();
        }),
        onFocusOutside: ne(
          e.onFocusOutside,
          (a) => a.preventDefault()
        )
      }
    );
  }
), tU = x.forwardRef(
  (e, t) => {
    const r = qt(vn, e.__scopeDialog), n = x.useRef(!1), o = x.useRef(!1);
    return /* @__PURE__ */ A(
      by,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var d, i;
          (d = e.onCloseAutoFocus) == null || d.call(e, a), a.defaultPrevented || (n.current || (i = r.triggerRef.current) == null || i.focus(), a.preventDefault()), n.current = !1, o.current = !1;
        },
        onInteractOutside: (a) => {
          var d, i;
          (d = e.onInteractOutside) == null || d.call(e, a), a.defaultPrevented || (n.current = !0, a.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const s = a.target;
          (i = r.triggerRef.current) != null && i.contains(s) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && o.current && a.preventDefault();
        }
      }
    );
  }
), by = x.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, trapFocus: n, onOpenAutoFocus: o, onCloseAutoFocus: a, ...d } = e, i = qt(vn, r), s = x.useRef(null), u = Oe(t, s);
    return li(), /* @__PURE__ */ ie(Ge, { children: [
      /* @__PURE__ */ A(
        Pa,
        {
          asChild: !0,
          loop: !0,
          trapped: n,
          onMountAutoFocus: o,
          onUnmountAutoFocus: a,
          children: /* @__PURE__ */ A(
            xn,
            {
              role: "dialog",
              id: i.contentId,
              "aria-describedby": i.descriptionId,
              "aria-labelledby": i.titleId,
              "data-state": i2(i.open),
              ...d,
              ref: u,
              onDismiss: () => i.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ ie(Ge, { children: [
        /* @__PURE__ */ A(rU, { titleId: i.titleId }),
        /* @__PURE__ */ A(oU, { contentRef: s, descriptionId: i.descriptionId })
      ] })
    ] });
  }
), d2 = "DialogTitle", xy = x.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, o = qt(d2, r);
    return /* @__PURE__ */ A(ge.h2, { id: o.titleId, ...n, ref: t });
  }
);
xy.displayName = d2;
var wy = "DialogDescription", Ay = x.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, o = qt(wy, r);
    return /* @__PURE__ */ A(ge.p, { id: o.descriptionId, ...n, ref: t });
  }
);
Ay.displayName = wy;
var Sy = "DialogClose", _y = x.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, o = qt(Sy, r);
    return /* @__PURE__ */ A(
      ge.button,
      {
        type: "button",
        ...n,
        ref: t,
        onClick: ne(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
_y.displayName = Sy;
function i2(e) {
  return e ? "open" : "closed";
}
var Ey = "DialogTitleWarning", [Vne, My] = rB(Ey, {
  contentName: vn,
  titleName: d2,
  docsSlug: "dialog"
}), rU = ({ titleId: e }) => {
  const t = My(Ey), r = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return x.useEffect(() => {
    e && (document.getElementById(e) || console.error(r));
  }, [r, e]), null;
}, nU = "DialogDescriptionWarning", oU = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${My(nU).contentName}}.`;
  return x.useEffect(() => {
    var n;
    const o = (n = e.current) == null ? void 0 : n.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, aU = $y, s2 = hy, Ta = gy, Da = yy, $i = xy, vi = Ay, Cy = _y;
const dU = s2, Oy = X(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  Ta,
  {
    ref: r,
    className: q(
      "fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t
  }
));
Oy.displayName = Ta.displayName;
const iU = X(({ className: e, children: t, ...r }, n) => /* @__PURE__ */ ie(dU, { children: [
  /* @__PURE__ */ A(Oy, {}),
  /* @__PURE__ */ ie(
    Da,
    {
      ref: n,
      className: q(
        "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
        e
      ),
      ...r,
      children: [
        t,
        /* @__PURE__ */ ie(Cy, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground", children: [
          /* @__PURE__ */ A(o2, { className: "size-4" }),
          /* @__PURE__ */ A("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
iU.displayName = Da.displayName;
const sU = X(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  $i,
  {
    ref: r,
    className: q("text-lg font-semibold leading-none tracking-tight", e),
    ...t
  }
));
sU.displayName = $i.displayName;
const uU = X(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  vi,
  {
    ref: r,
    className: q("text-sm text-muted-foreground", e),
    ...t
  }
));
uU.displayName = vi.displayName;
var c8 = 1, lU = 0.9, cU = 0.8, fU = 0.17, Nu = 0.1, Iu = 0.999, pU = 0.9999, $U = 0.99, vU = /[\\\/_+.#"@\[\(\{&]/, mU = /[\\\/_+.#"@\[\(\{&]/g, hU = /[\s-]/, Ny = /[\s-]/g;
function qc(e, t, r, n, o, a, d) {
  if (a === t.length) return o === e.length ? c8 : $U;
  var i = `${o},${a}`;
  if (d[i] !== void 0) return d[i];
  for (var s = n.charAt(a), u = r.indexOf(s, o), c = 0, l, p, h, m; u >= 0; ) l = qc(e, t, r, n, u + 1, a + 1, d), l > c && (u === o ? l *= c8 : vU.test(e.charAt(u - 1)) ? (l *= cU, h = e.slice(o, u - 1).match(mU), h && o > 0 && (l *= Math.pow(Iu, h.length))) : hU.test(e.charAt(u - 1)) ? (l *= lU, m = e.slice(o, u - 1).match(Ny), m && o > 0 && (l *= Math.pow(Iu, m.length))) : (l *= fU, o > 0 && (l *= Math.pow(Iu, u - o))), e.charAt(u) !== t.charAt(a) && (l *= pU)), (l < Nu && r.charAt(u - 1) === n.charAt(a + 1) || n.charAt(a + 1) === n.charAt(a) && r.charAt(u - 1) !== n.charAt(a)) && (p = qc(e, t, r, n, u + 1, a + 2, d), p * Nu > l && (l = p * Nu)), l > c && (c = l), u = r.indexOf(s, u + 1);
  return d[i] = c, c;
}
function f8(e) {
  return e.toLowerCase().replace(Ny, " ");
}
function gU(e, t, r) {
  return e = r && r.length > 0 ? `${e + " " + r.join(" ")}` : e, qc(e, t, f8(e), f8(t), 0, 0, {});
}
var ea = '[cmdk-group=""]', Pu = '[cmdk-group-items=""]', yU = '[cmdk-group-heading=""]', u2 = '[cmdk-item=""]', p8 = `${u2}:not([aria-disabled="true"])`, Jc = "cmdk-item-select", an = "data-value", bU = (e, t, r) => gU(e, t, r), Iy = x.createContext(void 0), La = () => x.useContext(Iy), Py = x.createContext(void 0), l2 = () => x.useContext(Py), Ry = x.createContext(void 0), Ty = x.forwardRef((e, t) => {
  let r = vo(() => {
    var U, ae;
    return { search: "", value: (ae = (U = e.value) != null ? U : e.defaultValue) != null ? ae : "", filtered: { count: 0, items: /* @__PURE__ */ new Map(), groups: /* @__PURE__ */ new Set() } };
  }), n = vo(() => /* @__PURE__ */ new Set()), o = vo(() => /* @__PURE__ */ new Map()), a = vo(() => /* @__PURE__ */ new Map()), d = vo(() => /* @__PURE__ */ new Set()), i = Dy(e), { label: s, children: u, value: c, onValueChange: l, filter: p, shouldFilter: h, loop: m, disablePointerSelection: f = !1, vimBindings: $ = !0, ...v } = e, y = It(), S = It(), w = It(), _ = x.useRef(null), I = IU();
  mn(() => {
    if (c !== void 0) {
      let U = c.trim();
      r.current.value = U, N.emit();
    }
  }, [c]), mn(() => {
    I(6, j);
  }, []);
  let N = x.useMemo(() => ({ subscribe: (U) => (d.current.add(U), () => d.current.delete(U)), snapshot: () => r.current, setState: (U, ae, ue) => {
    var se, we, re;
    if (!Object.is(r.current[U], ae)) {
      if (r.current[U] = ae, U === "search") T(), C(), I(1, P);
      else if (U === "value" && (ue || I(5, j), ((se = i.current) == null ? void 0 : se.value) !== void 0)) {
        let ye = ae ?? "";
        (re = (we = i.current).onValueChange) == null || re.call(we, ye);
        return;
      }
      N.emit();
    }
  }, emit: () => {
    d.current.forEach((U) => U());
  } }), []), O = x.useMemo(() => ({ value: (U, ae, ue) => {
    var se;
    ae !== ((se = a.current.get(U)) == null ? void 0 : se.value) && (a.current.set(U, { value: ae, keywords: ue }), r.current.filtered.items.set(U, E(ae, ue)), I(2, () => {
      C(), N.emit();
    }));
  }, item: (U, ae) => (n.current.add(U), ae && (o.current.has(ae) ? o.current.get(ae).add(U) : o.current.set(ae, /* @__PURE__ */ new Set([U]))), I(3, () => {
    T(), C(), r.current.value || P(), N.emit();
  }), () => {
    a.current.delete(U), n.current.delete(U), r.current.filtered.items.delete(U);
    let ue = F();
    I(4, () => {
      T(), (ue == null ? void 0 : ue.getAttribute("id")) === U && P(), N.emit();
    });
  }), group: (U) => (o.current.has(U) || o.current.set(U, /* @__PURE__ */ new Set()), () => {
    a.current.delete(U), o.current.delete(U);
  }), filter: () => i.current.shouldFilter, label: s || e["aria-label"], getDisablePointerSelection: () => i.current.disablePointerSelection, listId: y, inputId: w, labelId: S, listInnerRef: _ }), []);
  function E(U, ae) {
    var ue, se;
    let we = (se = (ue = i.current) == null ? void 0 : ue.filter) != null ? se : bU;
    return U ? we(U, r.current.search, ae) : 0;
  }
  function C() {
    if (!r.current.search || i.current.shouldFilter === !1) return;
    let U = r.current.filtered.items, ae = [];
    r.current.filtered.groups.forEach((se) => {
      let we = o.current.get(se), re = 0;
      we.forEach((ye) => {
        let xe = U.get(ye);
        re = Math.max(xe, re);
      }), ae.push([se, re]);
    });
    let ue = _.current;
    Z().sort((se, we) => {
      var re, ye;
      let xe = se.getAttribute("id"), be = we.getAttribute("id");
      return ((re = U.get(be)) != null ? re : 0) - ((ye = U.get(xe)) != null ? ye : 0);
    }).forEach((se) => {
      let we = se.closest(Pu);
      we ? we.appendChild(se.parentElement === we ? se : se.closest(`${Pu} > *`)) : ue.appendChild(se.parentElement === ue ? se : se.closest(`${Pu} > *`));
    }), ae.sort((se, we) => we[1] - se[1]).forEach((se) => {
      var we;
      let re = (we = _.current) == null ? void 0 : we.querySelector(`${ea}[${an}="${encodeURIComponent(se[0])}"]`);
      re == null || re.parentElement.appendChild(re);
    });
  }
  function P() {
    let U = Z().find((ue) => ue.getAttribute("aria-disabled") !== "true"), ae = U == null ? void 0 : U.getAttribute(an);
    N.setState("value", ae || void 0);
  }
  function T() {
    var U, ae, ue, se;
    if (!r.current.search || i.current.shouldFilter === !1) {
      r.current.filtered.count = n.current.size;
      return;
    }
    r.current.filtered.groups = /* @__PURE__ */ new Set();
    let we = 0;
    for (let re of n.current) {
      let ye = (ae = (U = a.current.get(re)) == null ? void 0 : U.value) != null ? ae : "", xe = (se = (ue = a.current.get(re)) == null ? void 0 : ue.keywords) != null ? se : [], be = E(ye, xe);
      r.current.filtered.items.set(re, be), be > 0 && we++;
    }
    for (let [re, ye] of o.current) for (let xe of ye) if (r.current.filtered.items.get(xe) > 0) {
      r.current.filtered.groups.add(re);
      break;
    }
    r.current.filtered.count = we;
  }
  function j() {
    var U, ae, ue;
    let se = F();
    se && (((U = se.parentElement) == null ? void 0 : U.firstChild) === se && ((ue = (ae = se.closest(ea)) == null ? void 0 : ae.querySelector(yU)) == null || ue.scrollIntoView({ block: "nearest" })), se.scrollIntoView({ block: "nearest" }));
  }
  function F() {
    var U;
    return (U = _.current) == null ? void 0 : U.querySelector(`${u2}[aria-selected="true"]`);
  }
  function Z() {
    var U;
    return Array.from(((U = _.current) == null ? void 0 : U.querySelectorAll(p8)) || []);
  }
  function te(U) {
    let ae = Z()[U];
    ae && N.setState("value", ae.getAttribute(an));
  }
  function H(U) {
    var ae;
    let ue = F(), se = Z(), we = se.findIndex((ye) => ye === ue), re = se[we + U];
    (ae = i.current) != null && ae.loop && (re = we + U < 0 ? se[se.length - 1] : we + U === se.length ? se[0] : se[we + U]), re && N.setState("value", re.getAttribute(an));
  }
  function de(U) {
    let ae = F(), ue = ae == null ? void 0 : ae.closest(ea), se;
    for (; ue && !se; ) ue = U > 0 ? OU(ue, ea) : NU(ue, ea), se = ue == null ? void 0 : ue.querySelector(p8);
    se ? N.setState("value", se.getAttribute(an)) : H(U);
  }
  let G = () => te(Z().length - 1), le = (U) => {
    U.preventDefault(), U.metaKey ? G() : U.altKey ? de(1) : H(1);
  }, fe = (U) => {
    U.preventDefault(), U.metaKey ? te(0) : U.altKey ? de(-1) : H(-1);
  };
  return x.createElement(ge.div, { ref: t, tabIndex: -1, ...v, "cmdk-root": "", onKeyDown: (U) => {
    var ae;
    if ((ae = v.onKeyDown) == null || ae.call(v, U), !U.defaultPrevented) switch (U.key) {
      case "n":
      case "j": {
        $ && U.ctrlKey && le(U);
        break;
      }
      case "ArrowDown": {
        le(U);
        break;
      }
      case "p":
      case "k": {
        $ && U.ctrlKey && fe(U);
        break;
      }
      case "ArrowUp": {
        fe(U);
        break;
      }
      case "Home": {
        U.preventDefault(), te(0);
        break;
      }
      case "End": {
        U.preventDefault(), G();
        break;
      }
      case "Enter":
        if (!U.nativeEvent.isComposing && U.keyCode !== 229) {
          U.preventDefault();
          let ue = F();
          if (ue) {
            let se = new Event(Jc);
            ue.dispatchEvent(se);
          }
        }
    }
  } }, x.createElement("label", { "cmdk-label": "", htmlFor: O.inputId, id: O.labelId, style: RU }, s), mi(e, (U) => x.createElement(Py.Provider, { value: N }, x.createElement(Iy.Provider, { value: O }, U))));
}), xU = x.forwardRef((e, t) => {
  var r, n;
  let o = It(), a = x.useRef(null), d = x.useContext(Ry), i = La(), s = Dy(e), u = (n = (r = s.current) == null ? void 0 : r.forceMount) != null ? n : d == null ? void 0 : d.forceMount;
  mn(() => {
    if (!u) return i.item(o, d == null ? void 0 : d.id);
  }, [u]);
  let c = Ly(o, a, [e.value, e.children, a], e.keywords), l = l2(), p = Gr((I) => I.value && I.value === c.current), h = Gr((I) => u || i.filter() === !1 ? !0 : I.search ? I.filtered.items.get(o) > 0 : !0);
  x.useEffect(() => {
    let I = a.current;
    if (!(!I || e.disabled)) return I.addEventListener(Jc, m), () => I.removeEventListener(Jc, m);
  }, [h, e.onSelect, e.disabled]);
  function m() {
    var I, N;
    f(), (N = (I = s.current).onSelect) == null || N.call(I, c.current);
  }
  function f() {
    l.setState("value", c.current, !0);
  }
  if (!h) return null;
  let { disabled: $, value: v, onSelect: y, forceMount: S, keywords: w, ..._ } = e;
  return x.createElement(ge.div, { ref: va([a, t]), ..._, id: o, "cmdk-item": "", role: "option", "aria-disabled": !!$, "aria-selected": !!p, "data-disabled": !!$, "data-selected": !!p, onPointerMove: $ || i.getDisablePointerSelection() ? void 0 : f, onClick: $ ? void 0 : m }, e.children);
}), wU = x.forwardRef((e, t) => {
  let { heading: r, children: n, forceMount: o, ...a } = e, d = It(), i = x.useRef(null), s = x.useRef(null), u = It(), c = La(), l = Gr((h) => o || c.filter() === !1 ? !0 : h.search ? h.filtered.groups.has(d) : !0);
  mn(() => c.group(d), []), Ly(d, i, [e.value, e.heading, s]);
  let p = x.useMemo(() => ({ id: d, forceMount: o }), [o]);
  return x.createElement(ge.div, { ref: va([i, t]), ...a, "cmdk-group": "", role: "presentation", hidden: l ? void 0 : !0 }, r && x.createElement("div", { ref: s, "cmdk-group-heading": "", "aria-hidden": !0, id: u }, r), mi(e, (h) => x.createElement("div", { "cmdk-group-items": "", role: "group", "aria-labelledby": r ? u : void 0 }, x.createElement(Ry.Provider, { value: p }, h))));
}), AU = x.forwardRef((e, t) => {
  let { alwaysRender: r, ...n } = e, o = x.useRef(null), a = Gr((d) => !d.search);
  return !r && !a ? null : x.createElement(ge.div, { ref: va([o, t]), ...n, "cmdk-separator": "", role: "separator" });
}), SU = x.forwardRef((e, t) => {
  let { onValueChange: r, ...n } = e, o = e.value != null, a = l2(), d = Gr((c) => c.search), i = Gr((c) => c.value), s = La(), u = x.useMemo(() => {
    var c;
    let l = (c = s.listInnerRef.current) == null ? void 0 : c.querySelector(`${u2}[${an}="${encodeURIComponent(i)}"]`);
    return l == null ? void 0 : l.getAttribute("id");
  }, []);
  return x.useEffect(() => {
    e.value != null && a.setState("search", e.value);
  }, [e.value]), x.createElement(ge.input, { ref: t, ...n, "cmdk-input": "", autoComplete: "off", autoCorrect: "off", spellCheck: !1, "aria-autocomplete": "list", role: "combobox", "aria-expanded": !0, "aria-controls": s.listId, "aria-labelledby": s.labelId, "aria-activedescendant": u, id: s.inputId, type: "text", value: o ? e.value : d, onChange: (c) => {
    o || a.setState("search", c.target.value), r == null || r(c.target.value);
  } });
}), _U = x.forwardRef((e, t) => {
  let { children: r, label: n = "Suggestions", ...o } = e, a = x.useRef(null), d = x.useRef(null), i = La();
  return x.useEffect(() => {
    if (d.current && a.current) {
      let s = d.current, u = a.current, c, l = new ResizeObserver(() => {
        c = requestAnimationFrame(() => {
          let p = s.offsetHeight;
          u.style.setProperty("--cmdk-list-height", p.toFixed(1) + "px");
        });
      });
      return l.observe(s), () => {
        cancelAnimationFrame(c), l.unobserve(s);
      };
    }
  }, []), x.createElement(ge.div, { ref: va([a, t]), ...o, "cmdk-list": "", role: "listbox", "aria-label": n, id: i.listId }, mi(e, (s) => x.createElement("div", { ref: va([d, i.listInnerRef]), "cmdk-list-sizer": "" }, s)));
}), EU = x.forwardRef((e, t) => {
  let { open: r, onOpenChange: n, overlayClassName: o, contentClassName: a, container: d, ...i } = e;
  return x.createElement(aU, { open: r, onOpenChange: n }, x.createElement(s2, { container: d }, x.createElement(Ta, { "cmdk-overlay": "", className: o }), x.createElement(Da, { "aria-label": e.label, "cmdk-dialog": "", className: a }, x.createElement(Ty, { ref: t, ...i }))));
}), MU = x.forwardRef((e, t) => Gr((r) => r.filtered.count === 0) ? x.createElement(ge.div, { ref: t, ...e, "cmdk-empty": "", role: "presentation" }) : null), CU = x.forwardRef((e, t) => {
  let { progress: r, children: n, label: o = "Loading...", ...a } = e;
  return x.createElement(ge.div, { ref: t, ...a, "cmdk-loading": "", role: "progressbar", "aria-valuenow": r, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": o }, mi(e, (d) => x.createElement("div", { "aria-hidden": !0 }, d)));
}), mt = Object.assign(Ty, { List: _U, Item: xU, Input: SU, Group: wU, Separator: AU, Dialog: EU, Empty: MU, Loading: CU });
function OU(e, t) {
  let r = e.nextElementSibling;
  for (; r; ) {
    if (r.matches(t)) return r;
    r = r.nextElementSibling;
  }
}
function NU(e, t) {
  let r = e.previousElementSibling;
  for (; r; ) {
    if (r.matches(t)) return r;
    r = r.previousElementSibling;
  }
}
function Dy(e) {
  let t = x.useRef(e);
  return mn(() => {
    t.current = e;
  }), t;
}
var mn = typeof window > "u" ? x.useEffect : x.useLayoutEffect;
function vo(e) {
  let t = x.useRef();
  return t.current === void 0 && (t.current = e()), t;
}
function va(e) {
  return (t) => {
    e.forEach((r) => {
      typeof r == "function" ? r(t) : r != null && (r.current = t);
    });
  };
}
function Gr(e) {
  let t = l2(), r = () => e(t.snapshot());
  return Vg.useSyncExternalStore(t.subscribe, r, r);
}
function Ly(e, t, r, n = []) {
  let o = x.useRef(), a = La();
  return mn(() => {
    var d;
    let i = (() => {
      var u;
      for (let c of r) {
        if (typeof c == "string") return c.trim();
        if (typeof c == "object" && "current" in c) return c.current ? (u = c.current.textContent) == null ? void 0 : u.trim() : o.current;
      }
    })(), s = n.map((u) => u.trim());
    a.value(e, i, s), (d = t.current) == null || d.setAttribute(an, i), o.current = i;
  }), o;
}
var IU = () => {
  let [e, t] = x.useState(), r = vo(() => /* @__PURE__ */ new Map());
  return mn(() => {
    r.current.forEach((n) => n()), r.current = /* @__PURE__ */ new Map();
  }, [e]), (n, o) => {
    r.current.set(n, o), t({});
  };
};
function PU(e) {
  let t = e.type;
  return typeof t == "function" ? t(e.props) : "render" in t ? t.render(e.props) : e;
}
function mi({ asChild: e, children: t }, r) {
  return e && x.isValidElement(t) ? x.cloneElement(PU(t), { ref: t.ref }, r(t.props.children)) : r(t);
}
var RU = { position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" };
const Fy = X(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  mt,
  {
    ref: r,
    className: q(
      "flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground",
      e
    ),
    ...t
  }
));
Fy.displayName = mt.displayName;
const TU = X(({ className: e, ...t }, r) => /* @__PURE__ */ ie("div", { className: "flex items-center border-b px-3", "cmdk-input-wrapper": "", children: [
  /* @__PURE__ */ A(kB, { className: "mr-2 size-4 shrink-0 opacity-50" }),
  /* @__PURE__ */ A(
    mt.Input,
    {
      ref: r,
      className: q(
        "flex h-10 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ...t
    }
  )
] }));
TU.displayName = mt.Input.displayName;
const ky = X(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  mt.List,
  {
    ref: r,
    className: q("max-h-[300px] overflow-y-auto overflow-x-hidden", e),
    ...t
  }
));
ky.displayName = mt.List.displayName;
const DU = X((e, t) => /* @__PURE__ */ A(mt.Empty, { ref: t, className: "py-6 text-center text-sm", ...e }));
DU.displayName = mt.Empty.displayName;
const jy = X(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  mt.Group,
  {
    ref: r,
    className: q(
      "overflow-hidden p-1 text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground",
      e
    ),
    ...t
  }
));
jy.displayName = mt.Group.displayName;
const LU = X(({ className: e, ...t }, r) => /* @__PURE__ */ A(mt.Separator, { ref: r, className: q("-mx-1 h-px bg-border", e), ...t }));
LU.displayName = mt.Separator.displayName;
const da = X(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  mt.Item,
  {
    ref: r,
    className: q(
      "relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none aria-[selected='true']:bg-accent aria-[selected='true']:text-accent-foreground data-[disabled='true']:pointer-events-none data-[disabled='true']:opacity-50",
      e
    ),
    ...t
  }
));
da.displayName = mt.Item.displayName;
const FU = jt(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
        outline: "text-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function kU({ className: e, variant: t, ...r }) {
  return /* @__PURE__ */ A("div", { className: q(FU({ variant: t }), e), ...r });
}
function jU(e, t) {
  const [r, n] = Ie(e);
  return rt(() => {
    const o = setTimeout(() => {
      n(e);
    }, t);
    return () => {
      clearTimeout(o);
    };
  }, [e, t]), r;
}
function ve(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function BU(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var o = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var Yn = {}, Xn = {}, Ze = {}, Te = {}, $8;
function hi() {
  if ($8) return Te;
  $8 = 1, Object.defineProperty(Te, "__esModule", { value: !0 }), Te.PropValueProvider = Te.IdentityProvider = Te.ValueProvider = void 0, Te.nullIfEmpty = e, Te.trimBlank = t, Te.trimStrings = r, Te.nvl = n, Te.isBlank = o, Te.isBlankObject = a, Te.isEmpty = d, Te.omit = i, Te.omitUntyped = s, Te.pick = u, Te.pickAndSkipUndefined = c, Te.pickUntyped = l, Te.isPrimitiveValue = p, Te.mapObject = h, Te.assignOwnProps = m, Te.prop = f, Te.deepSortObject = S;
  function e(w) {
    return w && Object.entries(w).find(([_, I]) => !o(I)) ? w : null;
  }
  function t(w) {
    if (o(w))
      return;
    if (typeof w != "object" || w instanceof Date)
      return w;
    if (Array.isArray(w))
      return w.map((O) => t(O)).filter((O) => !o(O));
    let _ = !1, I = !1;
    const N = Object.entries(w).reduce((O, [E, C]) => {
      const P = t(C);
      return Array.isArray(P) ? (O[E] = P, P.length && (I = !0)) : o(P) || (O[E] = P, _ = !0), O;
    }, {});
    return _ || I ? N : void 0;
  }
  function r(w) {
    return typeof w == "string" ? w.trim() : typeof w == "object" ? Object.entries(w).reduce((_, [I, N]) => (_[I] = r(N), _), {}) : Array.isArray(w) ? w.map((_) => r(_)) : w;
  }
  function n(w, _) {
    return o(w) ? _ : w;
  }
  function o(w) {
    return w == null;
  }
  function a(w) {
    return w == null ? !0 : !Object.entries(w).find(([_, I]) => !o(I));
  }
  function d(w) {
    return w == null || w === "";
  }
  function i(w, ..._) {
    const I = Object.assign({}, w);
    return _.forEach((N) => delete I[N]), I;
  }
  function s(w, ..._) {
    const I = Object.assign({}, w);
    return _.forEach((N) => delete I[N]), I;
  }
  function u(w, ..._) {
    return _.reduce((I, N) => (I[N] = w[N], I), {});
  }
  function c(w, ..._) {
    return _.reduce((I, N) => (w[N] !== void 0 && (I[N] = w[N]), I), {});
  }
  function l(w, ..._) {
    return _.reduce((I, N) => (I[N] = w[N], I), {});
  }
  function p(w) {
    const _ = typeof w;
    return w == null || _ === "string" || _ === "number" || _ === "boolean" || _ === "undefined" || _ === "bigint" || _ === "symbol" || w instanceof Date;
  }
  function h(w, _) {
    return w && Object.fromEntries(Object.entries(w).map(_));
  }
  function m(w, _) {
    Object.getOwnPropertyNames(w).forEach((I) => {
      w[I] = _[I];
    });
  }
  function f(w, _) {
    if (o(w) || d(_))
      return w;
    let I = w;
    const N = _.split(".");
    for (const O of N)
      if (I = I[O.trim()], o(I))
        return I;
    return I;
  }
  class $ {
    // noinspection TypeScriptAbstractClassConstructorCanBeMadeProtected
    constructor(_) {
      this.obj = _;
    }
  }
  Te.ValueProvider = $;
  class v extends $ {
    get value() {
      return "getId" in this.obj ? { id: this.obj.getId() } : { id: this.obj.id };
    }
  }
  Te.IdentityProvider = v;
  class y extends $ {
    constructor(_, I) {
      super(_), this.prop = I;
    }
    get value() {
      return f(this.obj, this.prop);
    }
  }
  Te.PropValueProvider = y;
  function S(w) {
    const _ = w;
    if (typeof _ != "object" || _ === null)
      return _;
    if (Array.isArray(_))
      return _.map(S);
    const I = Object.keys(_).sort(), N = {};
    return I.forEach((O) => {
      const E = _[O];
      N[O] = typeof E == "object" && E !== null && !(E instanceof Date) ? S(E) : E;
    }), N;
  }
  return Te;
}
var Ue = {}, v8;
function Fo() {
  if (v8) return Ue;
  v8 = 1, Object.defineProperty(Ue, "__esModule", { value: !0 }), Ue.split = t, Ue.camel2snake = r, Ue.camel2spine = n, Ue.pascal2camel = o, Ue.pascal2snake = a, Ue.pascal2spine = d, Ue.toPascal = i, Ue.toSpine = s, Ue.toSnake = u, Ue.toCamel = c, Ue.circularDepsReplacer = l, Ue.json = p, Ue.jsonStable = h, Ue.stringifySafe = m, Ue.lpad = v, Ue.rpad = y, Ue.replaceAll = S, Ue.randomString = w, Ue.randomCode = _, Ue.randomDigits = I, Ue.reverse = N, Ue.hashCode = O;
  const e = hi();
  function t(E, C) {
    return [E.slice(0, C), E.slice(C)];
  }
  function r(E) {
    return E.replace(/[A-Z]/g, (C) => "_" + C.toLowerCase());
  }
  function n(E) {
    return E.replace(/[A-Z]/g, (C) => "-" + C.toLowerCase());
  }
  function o(E) {
    return E.charAt(0).toLowerCase() + E.slice(1);
  }
  function a(E) {
    return E.charAt(0).toLowerCase() + r(E.slice(1));
  }
  function d(E) {
    return E.charAt(0).toLowerCase() + n(E.slice(1));
  }
  function i(E, C = !1) {
    let P = E.split(/([_-]\w)/g).map((T) => T.startsWith("_") || T.startsWith("-") ? T.slice(1).toUpperCase() : T).join("");
    return C && (P = P.split(/([A-Z]+)/g).map((T) => T.length > 1 && T.match(/[A-Z]+/) ? T.charAt(0) + T.slice(1).toLowerCase() : T).join("")), P.charAt(0).toUpperCase() + P.slice(1);
  }
  function s(E) {
    return d(i(E, !0).replace(/ +/, "-"));
  }
  function u(E) {
    return a(i(E, !0).replace(/ +/, "_"));
  }
  function c(E) {
    return o(i(E, !0).replace(/ +/, ""));
  }
  function l() {
    const E = [];
    return function(C, P) {
      if (typeof P == "object" && P !== null) {
        if (E.indexOf(P) !== -1)
          return;
        E.push(P);
      }
      return typeof P == "bigint" ? "big:" + P.toString() : P;
    };
  }
  function p(E, C = " ", P) {
    return JSON.stringify(E, P ?? l(), C === !1 ? "" : C);
  }
  function h(E, C = !1, P) {
    return p((0, e.deepSortObject)(E), C, P);
  }
  function m(E, C, P = "*****") {
    return p(f(E, C ?? [/password/gi, /secret/gi, /key/gi, /token/gi], P));
  }
  function f(E, C, P) {
    return (0, e.isPrimitiveValue)(E) ? E : Object.entries(E).reduce((T, [j, F]) => (C.some((Z) => Z.test(j)) && (0, e.isPrimitiveValue)(F) ? T[j] = P : (0, e.isPrimitiveValue)(F) ? T[j] = F : Array.isArray(F) ? T[j] = F.map((Z) => f(Z, C, P)) : T[j] = f(F, C, P), T), {});
  }
  function $(E, C) {
    return E > 0 ? C.repeat(E / C.length + 1).slice(0, E) : "";
  }
  function v(E, C, P = " ") {
    return $(C - `${E}`.length, P) + E;
  }
  function y(E, C, P = " ") {
    return E + $(C - `${E}`.length, P);
  }
  function S(E, C, P) {
    return E.replace(
      // eslint-disable-next-line security/detect-non-literal-regexp
      typeof C == "string" ? new RegExp(C, "g") : C,
      P
    );
  }
  function w(E, C = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789") {
    return new Array(E).fill(null).map(() => C.charAt(Math.floor(Math.random() * C.length))).join("");
  }
  function _(E, C = "ABCDEFGHIJKLMNPQRSTUVWXYZ123456789") {
    return w(E, C);
  }
  function I(E) {
    return w(E, "0123456789");
  }
  function N(E) {
    return E.split("").reverse().join("");
  }
  function O(E, C = Number.MAX_SAFE_INTEGER, P = !0) {
    E = P ? N(E) : E;
    const T = 37;
    let j = 17;
    if (E.length === 0)
      return j;
    for (let F = 0; F < E.length; F++) {
      const Z = E.charCodeAt(F) + (7 ^ F);
      j = T * j + Z;
    }
    return Math.abs(j) % C;
  }
  return Ue;
}
var m8;
function ZU() {
  if (m8) return Ze;
  m8 = 1, Object.defineProperty(Ze, "__esModule", { value: !0 }), Ze.ConcurrentUpdateError = Ze.DataValidationError = Ze.ValidationError = Ze.NotFoundError = Ze.UnauthorizedImpersonationError = Ze.AuthorizationError = Ze.AuthenticationError = Ze.AppError = Ze.HttpError = Ze.TimeoutError = Ze.Exception = void 0;
  const e = hi(), t = Fo();
  class r extends Error {
    constructor(m, f) {
      var $, v, y, S;
      super(typeof m == "string" ? m : ($ = m == null ? void 0 : m.message) !== null && $ !== void 0 ? $ : (0, t.json)(m, !1)), this.body = m, this.root = f, this.stack = ((v = this.stack) !== null && v !== void 0 ? v : "") + (f ? `
Root: ` + ((S = (y = f.stack) !== null && y !== void 0 ? y : f.message) !== null && S !== void 0 ? S : f) : ""), Object.setPrototypeOf(this, r.prototype);
    }
  }
  Ze.Exception = r;
  class n extends r {
    constructor(m, f) {
      super(m ?? "Timeout happened", f), Object.setPrototypeOf(this, n.prototype);
    }
  }
  Ze.TimeoutError = n;
  class o extends r {
    constructor(m, f, $ = 400) {
      super(m, f), this.status = $, Object.setPrototypeOf(this, o.prototype);
    }
  }
  Ze.HttpError = o;
  class a extends o {
    constructor(m, f, $, v, y = 409) {
      super({ message: m, code: f, args: v }, $, y), this.message = m, this.code = f, this.args = v, Object.setPrototypeOf(this, a.prototype);
    }
  }
  Ze.AppError = a;
  class d extends a {
    constructor(m, f, $) {
      super(m ?? "Authentication failed.", f ?? "authentication-failed", $, void 0, 401), Object.setPrototypeOf(this, d.prototype);
    }
  }
  Ze.AuthenticationError = d;
  class i extends a {
    constructor(m, f, $) {
      super(m ?? "Authorization failed.", f ?? "unauthorized", $, void 0, 403), Object.setPrototypeOf(this, i.prototype);
    }
  }
  Ze.AuthorizationError = i;
  class s extends i {
    constructor(m, f, $) {
      super(m ?? "Unauthorized impersonation.", f ?? "unauthorized-impersonation", $), Object.setPrototypeOf(this, s.prototype);
    }
  }
  Ze.UnauthorizedImpersonationError = s;
  class u extends o {
    constructor(m, f) {
      super((0, e.nullIfEmpty)({ message: m }), f, 404), Object.setPrototypeOf(this, u.prototype);
    }
  }
  Ze.NotFoundError = u;
  class c extends o {
    constructor(m, f) {
      super((0, e.nullIfEmpty)({ message: m }), f, 400), Object.setPrototypeOf(this, c.prototype);
    }
  }
  Ze.ValidationError = c;
  class l extends o {
    constructor(m) {
      super({ errors: m }, 400), Object.setPrototypeOf(this, l.prototype), this.errors = m;
    }
  }
  Ze.DataValidationError = l;
  class p extends r {
    constructor(m, f) {
      super(m ?? "Concurrent update happened", f), Object.setPrototypeOf(this, p.prototype);
    }
  }
  return Ze.ConcurrentUpdateError = p, Ze;
}
var h8 = {}, g8;
function UU() {
  return g8 || (g8 = 1, Object.defineProperty(h8, "__esModule", { value: !0 })), h8;
}
var y8;
function GU() {
  return y8 || (y8 = 1, function(e) {
    var t = Xn && Xn.__createBinding || (Object.create ? function(n, o, a, d) {
      d === void 0 && (d = a);
      var i = Object.getOwnPropertyDescriptor(o, a);
      (!i || ("get" in i ? !o.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
        return o[a];
      } }), Object.defineProperty(n, d, i);
    } : function(n, o, a, d) {
      d === void 0 && (d = a), n[d] = o[a];
    }), r = Xn && Xn.__exportStar || function(n, o) {
      for (var a in n) a !== "default" && !Object.prototype.hasOwnProperty.call(o, a) && t(o, n, a);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), r(ZU(), e), r(UU(), e);
  }(Xn)), Xn;
}
var ta = {}, b8;
function By() {
  if (b8) return ta;
  b8 = 1, Object.defineProperty(ta, "__esModule", { value: !0 }), ta.grow = e, ta.flatten = t;
  function e(d, i = "", s = "_") {
    return Array.isArray(d) ? d.map((u) => n(u, i, s)) : n(d, i, s);
  }
  function t(d, i = "", s = "_") {
    return Array.isArray(d) ? d.map((u) => a(u, s)).map((u) => r(u, i)) : r(a(d, s), i);
  }
  function r(d, i) {
    const s = {};
    return Object.entries(d).forEach(([u, c]) => {
      s[i + u] = c;
    }), s;
  }
  function n(d, i, s) {
    if (d == null)
      return d;
    const u = {};
    return Object.entries(d).filter(([c]) => c.startsWith(i)).map(([c, l]) => [c.replace(i, ""), l]).forEach(([c, l]) => {
      const p = c.split(s), h = p.splice(-1, 1);
      let m = u;
      p.forEach((f) => {
        m = o(m, f);
      }), m[h] = l;
    }), u;
  }
  function o(d, i, s) {
    return d[i] === void 0 && (s === void 0 && (s = {}), d[i] = s), d[i];
  }
  function a(d, i, s = [], u = {}) {
    let c = Object.assign({}, u);
    for (const l in d) {
      const p = [...s, l];
      if (Array.isArray(d[l]))
        c[p.join(i)] = d[l];
      else if (typeof d[l] == "object") {
        const h = a(d[l], i, p, {});
        c = Object.assign(Object.assign({}, c), h);
      } else
        c[p.join(i)] = d[l];
    }
    return c;
  }
  return ta;
}
var x8 = {}, ra = {}, w8;
function Zy() {
  if (w8) return ra;
  w8 = 1, Object.defineProperty(ra, "__esModule", { value: !0 }), ra.inTimezone = t, ra.msToDuration = o;
  const e = Fo();
  function t(a, d, i) {
    return new Date(a.toLocaleString(i, {
      timeZone: d
    }));
  }
  const r = {
    ms: 0,
    s: 1,
    m: 2,
    h: 3,
    d: 4
  };
  function n(a, d) {
    return r[a] > r[d];
  }
  function o(a, d = "d") {
    const i = Math.floor(a % (n(d, "ms") ? 1e3 : Number.MAX_SAFE_INTEGER)), s = Math.floor(a / 1e3 % (n(d, "s") ? 60 : d === "s" ? Number.MAX_SAFE_INTEGER : 1)), u = Math.floor(a / 1e3 / 60 % (n(d, "m") ? 60 : d === "m" ? Number.MAX_SAFE_INTEGER : 1)), c = Math.floor(a / 1e3 / 60 / 60 % (n(d, "h") ? 24 : d === "h" ? Number.MAX_SAFE_INTEGER : 1)), l = d === "d" ? Math.floor(a / 1e3 / 60 / 60 / 24 % 24) : 0;
    let p = "";
    if (l || p.length) {
      const h = `${l}`;
      p += `${h}d `;
    }
    if (c || p.length) {
      const h = n(d, "h") && p.length ? (0, e.lpad)(c, 2, "0") : `${c}`;
      p += `${h}h `;
    }
    if (u || p.length) {
      const h = n(d, "m") && p.length ? (0, e.lpad)(u, 2, "0") : `${u}`;
      p += `${h}m `;
    }
    if (s || p.length) {
      const h = n(d, "s") && p.length ? (0, e.lpad)(s, 2, "0") : `${s}`;
      p += `${h}s `;
    }
    if (i || p.length) {
      const h = n(d, "ms") && p.length ? (0, e.lpad)(i, 3, "0") : `${i}`;
      p += `${h}ms`;
    }
    return p;
  }
  return ra;
}
var A8;
function VU() {
  return A8 || (A8 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.noopLogger = e.NoopLogger = e.SimpleConsoleLogger = e.BareConsoleLogger = e.BaseLogger = e.ContextHolder = e.logLevelWeights = e.LogLevel = void 0, e.utcTimeString = c, e.localTimeString = l, e.getMessageText = h;
    const t = Zy(), r = hi(), n = Fo();
    var o;
    (function(m) {
      m.off = "off", m.fatal = "fatal", m.error = "error", m.warn = "warn", m.info = "info", m.trace = "trace", m.debug = "debug";
    })(o || (e.LogLevel = o = {})), e.logLevelWeights = {
      [o.off]: 0,
      [o.fatal]: 1,
      [o.error]: 2,
      [o.warn]: 3,
      [o.info]: 4,
      [o.trace]: 5,
      [o.debug]: 6
    };
    class a {
      constructor(f) {
        this.name = f;
      }
    }
    e.ContextHolder = a;
    class d {
      constructor(f, $) {
        var v, y;
        this.config = f, this.ctx = $, this._context = (y = (v = this.config) === null || v === void 0 ? void 0 : v.format) === null || y === void 0 ? void 0 : y.context;
      }
      log(f, ...$) {
        var v, y, S, w, _, I;
        if (!this.isEnabled(f))
          return;
        const N = /* @__PURE__ */ new Date(), O = !((y = (v = this.config) === null || v === void 0 ? void 0 : v.format) === null || y === void 0) && y.timezone ? `${l(N, this.config.format.timezone)} in ${this.config.format.timezone}` : "", E = c(N) + (O ? ` (${O})` : "");
        let C = (I = (S = this.getContext()) !== null && S !== void 0 ? S : (_ = (w = this.config) === null || w === void 0 ? void 0 : w.format) === null || _ === void 0 ? void 0 : _.context) !== null && I !== void 0 ? I : "MAIN";
        const P = $[$.length - 1];
        P instanceof a && (C = P.name, $ = $.slice(0, -1));
        const T = {
          timestamp: E,
          context: C
        }, j = $.map((F) => (typeof F == "function" && (F = F()), F)).map((F) => {
          var Z, te;
          return h(F, !1, (te = (Z = this.config) === null || Z === void 0 ? void 0 : Z.format) === null || te === void 0 ? void 0 : te.objectFormat);
        });
        this.logMessages(f, T, ...j);
      }
      debug(...f) {
        this.log(o.debug, ...f);
      }
      info(...f) {
        this.log(o.info, ...f);
      }
      trace(...f) {
        this.log(o.trace, ...f);
      }
      warn(...f) {
        this.log(o.warn, ...f);
      }
      error(...f) {
        this.log(o.error, ...f);
      }
      fatal(...f) {
        this.log(o.fatal, ...f);
      }
      isEnabled(f) {
        var $, v;
        return e.logLevelWeights[(v = ($ = this.config) === null || $ === void 0 ? void 0 : $.level) !== null && v !== void 0 ? v : o.debug] >= e.logLevelWeights[f];
      }
      setContext(f) {
        this._context = f;
      }
      getContext() {
        return this._context;
      }
    }
    e.BaseLogger = d;
    class i extends d {
      constructor(f = o.debug) {
        super({
          level: f
        }), this.level = f;
      }
      clone() {
        return new i(this.level);
      }
      logMessages(f, $, ...v) {
        const y = `${v.join(`
`)}`;
        switch (f) {
          case o.fatal:
          case o.error:
            console.error(y);
            break;
          case o.warn:
            console.warn(y);
            break;
          case o.info:
          case o.trace:
            console.info(y);
            break;
          case o.debug:
            console.debug(y);
            break;
          default:
            console.log(y);
        }
      }
    }
    e.BareConsoleLogger = i;
    class s extends d {
      constructor(f, $) {
        super(typeof f == "string" ? void 0 : f), typeof f == "string" ? this.setContext(f) : (this.config = f, this.ctx = $);
      }
      clone() {
        return new s(this.config, this.ctx);
      }
      logMessages(f, $, ...v) {
        var y, S, w, _;
        const I = !((y = this.ctx) === null || y === void 0) && y.getId() ? ` <${this.ctx.getId()}>` : "", N = `${$.timestamp} ${(0, n.lpad)(f.toUpperCase(), 5)}: [${(0, n.rpad)($.context, (_ = (w = (S = this.config) === null || S === void 0 ? void 0 : S.format) === null || w === void 0 ? void 0 : w.contextPadding) !== null && _ !== void 0 ? _ : 0)}]${I} ${v.join(`
`)}`;
        switch (f) {
          case o.fatal:
          case o.error:
            console.error(N);
            break;
          case o.warn:
            console.warn(N);
            break;
          case o.info:
          case o.trace:
            console.info(N);
            break;
          case o.debug:
            console.debug(N);
            break;
          default:
            console.log(N);
        }
      }
    }
    e.SimpleConsoleLogger = s;
    class u extends s {
      clone() {
        return new u(this.config, this.ctx);
      }
      isEnabled(f) {
        return !1;
      }
    }
    e.NoopLogger = u, e.noopLogger = new u();
    function c(m) {
      return `${m.getUTCFullYear()}-${(0, n.lpad)(m.getUTCMonth() + 1, 2, "0")}-${(0, n.lpad)(m.getUTCDate(), 2, "0")} ${(0, n.lpad)(m.getUTCHours(), 2, "0")}:${(0, n.lpad)(m.getUTCMinutes(), 2, "0")}:${(0, n.lpad)(m.getUTCSeconds(), 2, "0")}.${(0, n.lpad)(m.getUTCMilliseconds(), 3, "0")}`;
    }
    function l(m, f) {
      return m = (0, t.inTimezone)(m, f), `${m.getFullYear()}-${(0, n.lpad)(m.getMonth() + 1, 2, "0")}-${(0, n.lpad)(m.getDate(), 2, "0")} ${(0, n.lpad)(m.getHours(), 2, "0")}:${(0, n.lpad)(m.getMinutes(), 2, "0")}:${(0, n.lpad)(m.getSeconds(), 2, "0")}.${(0, n.lpad)(m.getMilliseconds(), 3, "0")}`;
    }
    function p(m, f) {
      var $;
      return m instanceof Error ? ($ = m.stack) !== null && $ !== void 0 ? $ : m.message : m === null ? "NULL" : m === void 0 ? "UNDEFINED" : (0, r.isPrimitiveValue)(m) ? m : f === "text" ? m.toString() : f === "compact-json" ? (0, n.json)(m, !1) : (0, n.json)(m);
    }
    function h(m, f, $) {
      if (Array.isArray(m)) {
        const v = m.map((y) => p(y, "compact-json"));
        return f ? v.join(`
`) : (0, n.json)(v);
      }
      return m instanceof Map ? (0, n.json)(Object.fromEntries([...m])) : m instanceof Set ? (0, n.json)([...m]) : p(m, $);
    }
  }(x8)), x8;
}
var De = {}, S8;
function HU() {
  if (S8) return De;
  S8 = 1, Object.defineProperty(De, "__esModule", { value: !0 }), De.or = t, De.and = r, De.sum = n, De.count = o, De.avg = a, De.unique = d, De.array2Map = i, De.array2ArrayMap = s, De.zip = u, De.last = c, De.first = l, De.range = p, De.charRange = h, De.splitArray = m, De.chunkArray = f, De.rotateLeft = $, De.rotateRight = v, De.diff = y, De.intersect = S, De.union = w, De.hasAny = _, De.hasAll = I, De.hasNone = N;
  const e = Fo();
  function t(O, E = (C) => !!C) {
    return O.reduce((C, P) => C || E(P), !1);
  }
  function r(O, E = (C) => !!C) {
    return O.reduce((C, P) => C && E(P), !0);
  }
  function n(O, E = (C) => C) {
    return O.reduce((C, P) => C + E(P), 0);
  }
  function o(O, E = (C) => C ? 1 : 0) {
    return O.reduce((C, P) => C + E(P), 0);
  }
  function a(O, E = (C) => C) {
    return O.length ? n(O, E) / O.length : 0;
  }
  function d(O, E, C) {
    if (!(O != null && O.length))
      return [];
    E || (E = (j) => (0, e.json)(j, !1));
    const P = {}, T = [];
    for (const j of O) {
      const F = E(j), Z = P[F];
      Z === void 0 ? (P[F] = T.length, T.push(j)) : C && (T[Z] = j);
    }
    return T;
  }
  function i(O, E = (C) => (0, e.json)(C, !1)) {
    if (!(O != null && O.length))
      return {};
    const C = {};
    for (const P of O) {
      const T = E(P);
      C[T] = P;
    }
    return C;
  }
  function s(O, E = (C) => (0, e.json)(C, !1)) {
    var C;
    if (!(O != null && O.length))
      return {};
    const P = {};
    for (const T of O) {
      const j = E(T);
      ((C = P[j]) !== null && C !== void 0 ? C : P[j] = []).push(T);
    }
    return P;
  }
  function u(...O) {
    return Array(Math.max(...O.map((E) => E.length))).fill(0).map((E, C) => O.map((P) => P[C]));
  }
  function c(O) {
    return O[O.length - 1];
  }
  function l(O) {
    return O[0];
  }
  function p(O, E = 0) {
    return [...Array(O).keys()].map((C) => C + E);
  }
  function h(O, E) {
    return p(E.charCodeAt(0) - O.charCodeAt(0) + 1, O.charCodeAt(0)).map((C) => String.fromCharCode(C));
  }
  function m(O, E) {
    const C = E >= 0 ? E : O.length + E;
    return [O.slice(0, C), O.slice(C)];
  }
  function f(O, E) {
    if (E <= 0)
      throw new Error("Chunk size must be greater than 0");
    const C = [];
    for (let P = 0; P < O.length; P += E)
      C.push(O.slice(P, P + E));
    return C;
  }
  function $(O) {
    const [E, C] = m(O, 1);
    return [...C, ...E];
  }
  function v(O) {
    const [E, C] = m(O, -1);
    return [...C, ...E];
  }
  function y(O, E, C = (P, T) => P === T) {
    const P = [];
    for (const T of O)
      E.some((j) => C(T, j)) || P.push(T);
    return P;
  }
  function S(O, E, C = (P, T) => P === T) {
    const P = [];
    for (const T of O)
      E.some((j) => C(T, j)) && P.push(T);
    return P;
  }
  function w(O, E, C = (P, T) => P === T) {
    const P = [...O];
    for (const T of E)
      P.some((j) => C(T, j)) || P.push(T);
    return P;
  }
  function _(O, E) {
    return O.some((C) => E.includes(C));
  }
  function I(O, E) {
    return O.every((C) => E.includes(C));
  }
  function N(O, E) {
    return !_(O, E);
  }
  return De;
}
var Ct = {}, _8;
function KU() {
  if (_8) return Ct;
  _8 = 1, Object.defineProperty(Ct, "__esModule", { value: !0 }), Ct.FixedBackoff = Ct.ExponentialBackoff = Ct.FibonacciBackoff = Ct.LinearBackoff = Ct.Backoff = void 0;
  class e {
    constructor(d) {
      var i, s;
      this.min = 10, this.max = 1e4, this.jitter = 0, this.cur = 0, this.min = (i = d == null ? void 0 : d.min) !== null && i !== void 0 ? i : 100, this.max = (s = d == null ? void 0 : d.max) !== null && s !== void 0 ? s : 1e4, this.jitter = (d == null ? void 0 : d.jitter) !== void 0 && d.jitter >= 0 && d.jitter <= 1 ? d.jitter : 0, this.reset();
    }
    next() {
      if (this.jitter) {
        const i = this.spread() * this.jitter;
        this.cur += Math.random() * i - i / 2;
      }
      this.cur = Math.max(0, Math.min(this.max, Math.floor(this.cur)));
      const d = this.cur;
      return this.step(), d;
    }
  }
  Ct.Backoff = e;
  class t extends e {
    constructor(d) {
      var i;
      super(d), this._step = 50, this._step = (i = d == null ? void 0 : d.step) !== null && i !== void 0 ? i : 50;
    }
    reset() {
      this.cur = this.min;
    }
    spread() {
      return this._step;
    }
    step() {
      this.cur = this.cur + this._step;
    }
  }
  Ct.LinearBackoff = t;
  class r extends e {
    constructor() {
      super(...arguments), this.last = 0;
    }
    reset() {
      this.cur = this.min, this.last = 0;
    }
    spread() {
      return this.cur === this.last ? this.cur : this.cur - this.last;
    }
    step() {
      let d = this.last + this.cur;
      d === 0 && (d = 1), this.last = this.cur, this.cur = d;
    }
  }
  Ct.FibonacciBackoff = r;
  class n extends e {
    constructor(d) {
      var i;
      super(d), this.factor = 2, this.factor = (i = d == null ? void 0 : d.factor) !== null && i !== void 0 ? i : 2;
    }
    reset() {
      this.cur = this.min;
    }
    spread() {
      return this.cur - this.cur / this.factor;
    }
    step() {
      this.cur === 0 ? this.cur = 1 : this.cur *= this.factor;
    }
  }
  Ct.ExponentialBackoff = n;
  class o extends e {
    constructor(d) {
      super(), this.sequence = d.sequence, this.idx = 0, this.lastIdx = this.sequence.length - 1, this.reset();
    }
    reset() {
      var d;
      this.idx = 0, this.cur = (d = this.sequence) === null || d === void 0 ? void 0 : d[this.idx];
    }
    spread() {
      return this.idx === 0 ? this.sequence[this.idx] : Math.abs(this.sequence[this.idx] - this.sequence[this.idx - 1]);
    }
    step() {
      this.idx = Math.min(this.idx + 1, this.lastIdx), this.cur = this.sequence[this.idx];
    }
  }
  return Ct.FixedBackoff = o, Ct;
}
var ld = {}, E8;
function WU() {
  if (E8) return ld;
  E8 = 1, Object.defineProperty(ld, "__esModule", { value: !0 }), ld.cached = e;
  async function e(t, r, n) {
    let o = t.get(r);
    return o === void 0 && (o = await n(), t.set(r, o)), o;
  }
  return ld;
}
var Qt = {}, Xr = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      this.groups = [], this.each = !1, this.context = void 0, this.type = t.type, this.name = t.name, this.target = t.target, this.propertyName = t.propertyName, this.constraints = t == null ? void 0 : t.constraints, this.constraintCls = t.constraintCls, this.validationTypeOptions = t.validationTypeOptions, t.validationOptions && (this.message = t.validationOptions.message, this.groups = t.validationOptions.groups, this.always = t.validationOptions.always, this.each = t.validationOptions.each, this.context = t.validationOptions.context);
    }
    return e;
  }()
), zU = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.transform = function(t) {
      var r = [];
      return Object.keys(t.properties).forEach(function(n) {
        t.properties[n].forEach(function(o) {
          var a = {
            message: o.message,
            groups: o.groups,
            always: o.always,
            each: o.each
          }, d = {
            type: o.type,
            name: o.name,
            target: t.name,
            propertyName: n,
            constraints: o.constraints,
            validationTypeOptions: o.options,
            validationOptions: a
          };
          r.push(new Xr(d));
        });
      }), r;
    }, e;
  }()
);
function YU(e) {
  return e instanceof Map ? Array.from(e.values()) : Array.isArray(e) ? e : Array.from(e);
}
function XU() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof global < "u")
    return global;
  if (typeof window < "u")
    return window;
  if (typeof self < "u")
    return self;
}
function Ru(e) {
  return e !== null && typeof e == "object" && typeof e.then == "function";
}
var qU = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, M8 = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), o, a = [], d;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = n.next()).done; ) a.push(o.value);
  } catch (i) {
    d = { error: i };
  } finally {
    try {
      o && !o.done && (r = n.return) && r.call(n);
    } finally {
      if (d) throw d.error;
    }
  }
  return a;
}, JU = function(e, t, r) {
  if (arguments.length === 2) for (var n = 0, o = t.length, a; n < o; n++)
    (a || !(n in t)) && (a || (a = Array.prototype.slice.call(t, 0, n)), a[n] = t[n]);
  return e.concat(a || Array.prototype.slice.call(t));
}, c2 = (
  /** @class */
  function() {
    function e() {
      this.validationMetadatas = /* @__PURE__ */ new Map(), this.constraintMetadatas = /* @__PURE__ */ new Map();
    }
    return Object.defineProperty(e.prototype, "hasValidationMetaData", {
      get: function() {
        return !!this.validationMetadatas.size;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.addValidationSchema = function(t) {
      var r = this, n = new zU().transform(t);
      n.forEach(function(o) {
        return r.addValidationMetadata(o);
      });
    }, e.prototype.addValidationMetadata = function(t) {
      var r = this.validationMetadatas.get(t.target);
      r ? r.push(t) : this.validationMetadatas.set(t.target, [t]);
    }, e.prototype.addConstraintMetadata = function(t) {
      var r = this.constraintMetadatas.get(t.target);
      r ? r.push(t) : this.constraintMetadatas.set(t.target, [t]);
    }, e.prototype.groupByPropertyName = function(t) {
      var r = {};
      return t.forEach(function(n) {
        r[n.propertyName] || (r[n.propertyName] = []), r[n.propertyName].push(n);
      }), r;
    }, e.prototype.getTargetValidationMetadatas = function(t, r, n, o, a) {
      var d, i, s = function(w) {
        return typeof w.always < "u" ? w.always : w.groups && w.groups.length ? !1 : n;
      }, u = function(w) {
        return !!(o && (!a || !a.length) && w.groups && w.groups.length);
      }, c = this.validationMetadatas.get(t) || [], l = c.filter(function(w) {
        return w.target !== t && w.target !== r ? !1 : s(w) ? !0 : u(w) ? !1 : a && a.length > 0 ? w.groups && !!w.groups.find(function(_) {
          return a.indexOf(_) !== -1;
        }) : !0;
      }), p = [];
      try {
        for (var h = qU(this.validationMetadatas.entries()), m = h.next(); !m.done; m = h.next()) {
          var f = M8(m.value, 2), $ = f[0], v = f[1];
          t.prototype instanceof $ && p.push.apply(p, JU([], M8(v), !1));
        }
      } catch (w) {
        d = { error: w };
      } finally {
        try {
          m && !m.done && (i = h.return) && i.call(h);
        } finally {
          if (d) throw d.error;
        }
      }
      var y = p.filter(function(w) {
        return typeof w.target == "string" || w.target === t || w.target instanceof Function && !(t.prototype instanceof w.target) ? !1 : s(w) ? !0 : u(w) ? !1 : a && a.length > 0 ? w.groups && !!w.groups.find(function(_) {
          return a.indexOf(_) !== -1;
        }) : !0;
      }), S = y.filter(function(w) {
        return !l.find(function(_) {
          return _.propertyName === w.propertyName && _.type === w.type;
        });
      });
      return l.concat(S);
    }, e.prototype.getTargetValidatorConstraints = function(t) {
      return this.constraintMetadatas.get(t) || [];
    }, e;
  }()
);
function kt() {
  var e = XU();
  return e.classValidatorMetadataStorage || (e.classValidatorMetadataStorage = new c2()), e.classValidatorMetadataStorage;
}
var Qc = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.toString = function(t, r, n, o) {
      var a = this;
      t === void 0 && (t = !1), r === void 0 && (r = !1), n === void 0 && (n = ""), o === void 0 && (o = !1);
      var d = t ? "\x1B[1m" : "", i = t ? "\x1B[22m" : "", s = function() {
        var l;
        return (o ? Object.values : Object.keys)((l = a.constraints) !== null && l !== void 0 ? l : {}).join(", ");
      }, u = function(l) {
        return " - property ".concat(d).concat(n).concat(l).concat(i, " has failed the following constraints: ").concat(d).concat(s()).concat(i, ` 
`);
      };
      if (r) {
        var c = Number.isInteger(+this.property) ? "[".concat(this.property, "]") : "".concat(n ? "." : "").concat(this.property);
        return this.constraints ? u(c) : this.children ? this.children.map(function(l) {
          return l.toString(t, !0, "".concat(n).concat(c), o);
        }).join("") : "";
      } else
        return "An instance of ".concat(d).concat(this.target ? this.target.constructor.name : "an object").concat(i, ` has failed the validation:
`) + (this.constraints ? u(this.property) : "") + (this.children ? this.children.map(function(l) {
          return l.toString(t, !0, a.property, o);
        }).join("") : "");
    }, e;
  }()
), qe = (
  /** @class */
  function() {
    function e() {
    }
    return e.isValid = function(t) {
      var r = this;
      return t !== "isValid" && t !== "getMessage" && Object.keys(this).map(function(n) {
        return r[n];
      }).indexOf(t) !== -1;
    }, e.CUSTOM_VALIDATION = "customValidation", e.NESTED_VALIDATION = "nestedValidation", e.PROMISE_VALIDATION = "promiseValidation", e.CONDITIONAL_VALIDATION = "conditionalValidation", e.WHITELIST = "whitelistValidation", e.IS_DEFINED = "isDefined", e;
  }()
);
function QU(e) {
  return Array.isArray(e) ? e.join(", ") : (typeof e == "symbol" && (e = e.description), "".concat(e));
}
var eG = (
  /** @class */
  function() {
    function e() {
    }
    return e.replaceMessageSpecialTokens = function(t, r) {
      var n;
      return t instanceof Function ? n = t(r) : typeof t == "string" && (n = t), n && Array.isArray(r.constraints) && r.constraints.forEach(function(o, a) {
        n = n.replace(new RegExp("\\$constraint".concat(a + 1), "g"), QU(o));
      }), n && r.value !== void 0 && r.value !== null && ["string", "boolean", "number"].includes(typeof r.value) && (n = n.replace(/\$value/g, r.value)), n && (n = n.replace(/\$property/g, r.property)), n && (n = n.replace(/\$target/g, r.targetName)), n;
    }, e;
  }()
), na = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), o, a = [], d;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = n.next()).done; ) a.push(o.value);
  } catch (i) {
    d = { error: i };
  } finally {
    try {
      o && !o.done && (r = n.return) && r.call(n);
    } finally {
      if (d) throw d.error;
    }
  }
  return a;
}, C8 = (
  /** @class */
  function() {
    function e(t, r) {
      this.validator = t, this.validatorOptions = r, this.awaitingPromises = [], this.ignoreAsyncValidations = !1, this.metadataStorage = kt();
    }
    return e.prototype.execute = function(t, r, n) {
      var o = this, a, d;
      !this.metadataStorage.hasValidationMetaData && ((a = this.validatorOptions) === null || a === void 0 ? void 0 : a.enableDebugMessages) === !0 && console.warn(`No validation metadata found. No validation will be  performed. There are multiple possible reasons:
  - There may be multiple class-validator versions installed. You will need to flatten your dependencies to fix the issue.
  - This validation runs before any file with validation decorator was parsed by NodeJS.`);
      var i = this.validatorOptions ? this.validatorOptions.groups : void 0, s = this.validatorOptions && this.validatorOptions.strictGroups || !1, u = this.validatorOptions && this.validatorOptions.always || !1, c = ((d = this.validatorOptions) === null || d === void 0 ? void 0 : d.forbidUnknownValues) === void 0 || this.validatorOptions.forbidUnknownValues !== !1, l = this.metadataStorage.getTargetValidationMetadatas(t.constructor, r, u, s, i), p = this.metadataStorage.groupByPropertyName(l);
      if (c && !l.length) {
        var h = new Qc();
        (!this.validatorOptions || !this.validatorOptions.validationError || this.validatorOptions.validationError.target === void 0 || this.validatorOptions.validationError.target === !0) && (h.target = t), h.value = void 0, h.property = void 0, h.children = [], h.constraints = { unknownValue: "an unknown value was passed to the validate function" }, n.push(h);
        return;
      }
      this.validatorOptions && this.validatorOptions.whitelist && this.whitelist(t, p, n), Object.keys(p).forEach(function(m) {
        var f = t[m], $ = p[m].filter(function(y) {
          return y.type === qe.IS_DEFINED;
        }), v = p[m].filter(function(y) {
          return y.type !== qe.IS_DEFINED && y.type !== qe.WHITELIST;
        });
        f instanceof Promise && v.find(function(y) {
          return y.type === qe.PROMISE_VALIDATION;
        }) ? o.awaitingPromises.push(f.then(function(y) {
          o.performValidations(t, y, m, $, v, n);
        })) : o.performValidations(t, f, m, $, v, n);
      });
    }, e.prototype.whitelist = function(t, r, n) {
      var o = this, a = [];
      Object.keys(t).forEach(function(d) {
        (!r[d] || r[d].length === 0) && a.push(d);
      }), a.length > 0 && (this.validatorOptions && this.validatorOptions.forbidNonWhitelisted ? a.forEach(function(d) {
        var i, s = o.generateValidationError(t, t[d], d);
        s.constraints = (i = {}, i[qe.WHITELIST] = "property ".concat(d, " should not exist"), i), s.children = void 0, n.push(s);
      }) : a.forEach(function(d) {
        return delete t[d];
      }));
    }, e.prototype.stripEmptyErrors = function(t) {
      var r = this;
      return t.filter(function(n) {
        if (n.children && (n.children = r.stripEmptyErrors(n.children)), Object.keys(n.constraints).length === 0) {
          if (n.children.length === 0)
            return !1;
          delete n.constraints;
        }
        return !0;
      });
    }, e.prototype.performValidations = function(t, r, n, o, a, d) {
      var i = a.filter(function(p) {
        return p.type === qe.CUSTOM_VALIDATION;
      }), s = a.filter(function(p) {
        return p.type === qe.NESTED_VALIDATION;
      }), u = a.filter(function(p) {
        return p.type === qe.CONDITIONAL_VALIDATION;
      }), c = this.generateValidationError(t, r, n);
      d.push(c);
      var l = this.conditionalValidations(t, r, u);
      l && (this.customValidations(t, r, o, c), this.mapContexts(t, r, o, c), !(r === void 0 && this.validatorOptions && this.validatorOptions.skipUndefinedProperties === !0) && (r === null && this.validatorOptions && this.validatorOptions.skipNullProperties === !0 || r == null && this.validatorOptions && this.validatorOptions.skipMissingProperties === !0 || (this.customValidations(t, r, i, c), this.nestedValidations(r, s, c), this.mapContexts(t, r, a, c), this.mapContexts(t, r, i, c))));
    }, e.prototype.generateValidationError = function(t, r, n) {
      var o = new Qc();
      return (!this.validatorOptions || !this.validatorOptions.validationError || this.validatorOptions.validationError.target === void 0 || this.validatorOptions.validationError.target === !0) && (o.target = t), (!this.validatorOptions || !this.validatorOptions.validationError || this.validatorOptions.validationError.value === void 0 || this.validatorOptions.validationError.value === !0) && (o.value = r), o.property = n, o.children = [], o.constraints = {}, o;
    }, e.prototype.conditionalValidations = function(t, r, n) {
      return n.map(function(o) {
        return o.constraints[0](t, r);
      }).reduce(function(o, a) {
        return o && a;
      }, !0);
    }, e.prototype.customValidations = function(t, r, n, o) {
      var a = this;
      n.forEach(function(d) {
        a.metadataStorage.getTargetValidatorConstraints(d.constraintCls).forEach(function(i) {
          if (!(i.async && a.ignoreAsyncValidations) && !(a.validatorOptions && a.validatorOptions.stopAtFirstError && Object.keys(o.constraints || {}).length > 0)) {
            var s = {
              targetName: t.constructor ? t.constructor.name : void 0,
              property: d.propertyName,
              object: t,
              value: r,
              constraints: d.constraints
            };
            if (!d.each || !(Array.isArray(r) || r instanceof Set || r instanceof Map)) {
              var u = i.instance.validate(r, s);
              if (Ru(u)) {
                var c = u.then(function(_) {
                  if (!_) {
                    var I = na(a.createValidationError(t, r, d, i), 2), N = I[0], O = I[1];
                    o.constraints[N] = O, d.context && (o.contexts || (o.contexts = {}), o.contexts[N] = Object.assign(o.contexts[N] || {}, d.context));
                  }
                });
                a.awaitingPromises.push(c);
              } else if (!u) {
                var l = na(a.createValidationError(t, r, d, i), 2), p = l[0], h = l[1];
                o.constraints[p] = h;
              }
              return;
            }
            var m = YU(r), f = m.map(function(_) {
              return i.instance.validate(_, s);
            }), $ = f.some(function(_) {
              return Ru(_);
            });
            if ($) {
              var v = f.map(function(_) {
                return Ru(_) ? _ : Promise.resolve(_);
              }), y = Promise.all(v).then(function(_) {
                var I = _.every(function(C) {
                  return C;
                });
                if (!I) {
                  var N = na(a.createValidationError(t, r, d, i), 2), O = N[0], E = N[1];
                  o.constraints[O] = E, d.context && (o.contexts || (o.contexts = {}), o.contexts[O] = Object.assign(o.contexts[O] || {}, d.context));
                }
              });
              a.awaitingPromises.push(y);
              return;
            }
            var S = f.every(function(_) {
              return _;
            });
            if (!S) {
              var w = na(a.createValidationError(t, r, d, i), 2), p = w[0], h = w[1];
              o.constraints[p] = h;
            }
          }
        });
      });
    }, e.prototype.nestedValidations = function(t, r, n) {
      var o = this;
      t !== void 0 && r.forEach(function(a) {
        if (!(a.type !== qe.NESTED_VALIDATION && a.type !== qe.PROMISE_VALIDATION) && !(o.validatorOptions && o.validatorOptions.stopAtFirstError && Object.keys(n.constraints || {}).length > 0))
          if (Array.isArray(t) || t instanceof Set || t instanceof Map) {
            var d = t instanceof Set ? Array.from(t) : t;
            d.forEach(function(l, p) {
              o.performValidations(t, l, p.toString(), [], r, n.children);
            });
          } else if (t instanceof Object) {
            var i = typeof a.target == "string" ? a.target : a.target.name;
            o.execute(t, i, n.children);
          } else {
            var s = na(o.createValidationError(a.target, t, a), 2), u = s[0], c = s[1];
            n.constraints[u] = c;
          }
      });
    }, e.prototype.mapContexts = function(t, r, n, o) {
      var a = this;
      return n.forEach(function(d) {
        if (d.context) {
          var i = void 0;
          if (d.type === qe.CUSTOM_VALIDATION) {
            var s = a.metadataStorage.getTargetValidatorConstraints(d.constraintCls);
            i = s[0];
          }
          var u = a.getConstraintType(d, i);
          o.constraints[u] && (o.contexts || (o.contexts = {}), o.contexts[u] = Object.assign(o.contexts[u] || {}, d.context));
        }
      });
    }, e.prototype.createValidationError = function(t, r, n, o) {
      var a = t.constructor ? t.constructor.name : void 0, d = this.getConstraintType(n, o), i = {
        targetName: a,
        property: n.propertyName,
        object: t,
        value: r,
        constraints: n.constraints
      }, s = n.message || "";
      !n.message && (!this.validatorOptions || this.validatorOptions && !this.validatorOptions.dismissDefaultMessages) && o && o.instance.defaultMessage instanceof Function && (s = o.instance.defaultMessage(i));
      var u = eG.replaceMessageSpecialTokens(s, i);
      return [d, u];
    }, e.prototype.getConstraintType = function(t, r) {
      var n = r && r.name ? r.name : t.type;
      return n;
    }, e;
  }()
), tG = function(e, t, r, n) {
  function o(a) {
    return a instanceof r ? a : new r(function(d) {
      d(a);
    });
  }
  return new (r || (r = Promise))(function(a, d) {
    function i(c) {
      try {
        u(n.next(c));
      } catch (l) {
        d(l);
      }
    }
    function s(c) {
      try {
        u(n.throw(c));
      } catch (l) {
        d(l);
      }
    }
    function u(c) {
      c.done ? a(c.value) : o(c.value).then(i, s);
    }
    u((n = n.apply(e, [])).next());
  });
}, rG = function(e, t) {
  var r = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, n, o, a, d;
  return d = { next: i(0), throw: i(1), return: i(2) }, typeof Symbol == "function" && (d[Symbol.iterator] = function() {
    return this;
  }), d;
  function i(u) {
    return function(c) {
      return s([u, c]);
    };
  }
  function s(u) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; d && (d = 0, u[0] && (r = 0)), r; ) try {
      if (n = 1, o && (a = u[0] & 2 ? o.return : u[0] ? o.throw || ((a = o.return) && a.call(o), 0) : o.next) && !(a = a.call(o, u[1])).done) return a;
      switch (o = 0, a && (u = [u[0] & 2, a.value]), u[0]) {
        case 0:
        case 1:
          a = u;
          break;
        case 4:
          return r.label++, { value: u[1], done: !1 };
        case 5:
          r.label++, o = u[1], u = [0];
          continue;
        case 7:
          u = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (a = r.trys, !(a = a.length > 0 && a[a.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            r = 0;
            continue;
          }
          if (u[0] === 3 && (!a || u[1] > a[0] && u[1] < a[3])) {
            r.label = u[1];
            break;
          }
          if (u[0] === 6 && r.label < a[1]) {
            r.label = a[1], a = u;
            break;
          }
          if (a && r.label < a[2]) {
            r.label = a[2], r.ops.push(u);
            break;
          }
          a[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      u = t.call(e, r);
    } catch (c) {
      u = [6, c], o = 0;
    } finally {
      n = a = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}, hn = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.validate = function(t, r, n) {
      return this.coreValidate(t, r, n);
    }, e.prototype.validateOrReject = function(t, r, n) {
      return tG(this, void 0, void 0, function() {
        var o;
        return rG(this, function(a) {
          switch (a.label) {
            case 0:
              return [4, this.coreValidate(t, r, n)];
            case 1:
              return o = a.sent(), o.length ? [2, Promise.reject(o)] : [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.validateSync = function(t, r, n) {
      var o = typeof t == "string" ? r : t, a = typeof t == "string" ? n : r, d = typeof t == "string" ? t : void 0, i = new C8(this, a);
      i.ignoreAsyncValidations = !0;
      var s = [];
      return i.execute(o, d, s), i.stripEmptyErrors(s);
    }, e.prototype.coreValidate = function(t, r, n) {
      var o = typeof t == "string" ? r : t, a = typeof t == "string" ? n : r, d = typeof t == "string" ? t : void 0, i = new C8(this, a), s = [];
      return i.execute(o, d, s), Promise.all(i.awaitingPromises).then(function() {
        return i.stripEmptyErrors(s);
      });
    }, e;
  }()
), nG = new /** @class */
(function() {
  function e() {
    this.instances = [];
  }
  return e.prototype.get = function(t) {
    var r = this.instances.find(function(n) {
      return n.type === t;
    });
    return r || (r = { type: t, object: new t() }, this.instances.push(r)), r.object;
  }, e;
}())(), e1, ia;
function oG(e, t) {
  e1 = e, ia = t;
}
function Er(e) {
  if (e1)
    try {
      var t = e1.get(e);
      if (t || !ia || !ia.fallback)
        return t;
    } catch (r) {
      if (!ia || !ia.fallbackOnErrors)
        throw r;
    }
  return nG.get(e);
}
function aG(e) {
  return function(t, r) {
    var n = {
      type: qe.WHITELIST,
      target: t.constructor,
      propertyName: r,
      validationOptions: e
    };
    kt().addValidationMetadata(new Xr(n));
  };
}
var Uy = (
  /** @class */
  function() {
    function e(t, r, n) {
      n === void 0 && (n = !1), this.target = t, this.name = r, this.async = n;
    }
    return Object.defineProperty(e.prototype, "instance", {
      // -------------------------------------------------------------------------
      // Accessors
      // -------------------------------------------------------------------------
      /**
       * Instance of the target custom validation class which performs validation.
       */
      get: function() {
        return Er(this.target);
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }()
);
function Gy(e) {
  var t;
  if (e.validator instanceof Function) {
    t = e.validator;
    var r = Er(c2).getTargetValidatorConstraints(e.validator);
    if (r.length > 1)
      throw "More than one implementation of ValidatorConstraintInterface found for validator on: ".concat(e.target.name, ":").concat(e.propertyName);
  } else {
    var n = e.validator;
    t = /** @class */
    function() {
      function a() {
      }
      return a.prototype.validate = function(d, i) {
        return n.validate(d, i);
      }, a.prototype.defaultMessage = function(d) {
        return n.defaultMessage ? n.defaultMessage(d) : "";
      }, a;
    }(), kt().addConstraintMetadata(new Uy(t, e.name, e.async));
  }
  var o = {
    type: e.name && qe.isValid(e.name) ? e.name : qe.CUSTOM_VALIDATION,
    name: e.name,
    target: e.target,
    propertyName: e.propertyName,
    validationOptions: e.options,
    constraintCls: t,
    constraints: e.constraints
  };
  kt().addValidationMetadata(new Xr(o));
}
function z(e, t) {
  return function(r) {
    var n = t && t.each ? "each value in " : "";
    return e(n, r);
  };
}
function Y(e, t) {
  return function(r, n) {
    Gy({
      name: e.name,
      target: r.constructor,
      propertyName: n,
      options: t,
      constraints: e.constraints,
      validator: e.validator
    });
  };
}
var Vy = qe.IS_DEFINED;
function Hy(e) {
  return e != null;
}
function dG(e) {
  return Y({
    name: Vy,
    validator: {
      validate: function(t) {
        return Hy(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property should not be null or undefined";
      }, e)
    }
  }, e);
}
var Ky = "isOptional";
function iG(e) {
  return function(t, r) {
    var n = {
      type: qe.CONDITIONAL_VALIDATION,
      name: Ky,
      target: t.constructor,
      propertyName: r,
      constraints: [
        function(o, a) {
          return o[r] !== null && o[r] !== void 0;
        }
      ],
      validationOptions: e
    };
    kt().addValidationMetadata(new Xr(n));
  };
}
function sG(e) {
  return function(t) {
    var r = e && e.async, n = e && e.name ? e.name : "";
    n || (n = t.name, n || (n = n.replace(/\.?([A-Z]+)/g, function(a, d) {
      return "_" + d.toLowerCase();
    }).replace(/^_/, "")));
    var o = new Uy(t, n, r);
    kt().addConstraintMetadata(o);
  };
}
function uG(e, t, r) {
  return function(n, o) {
    var a = {
      type: qe.CUSTOM_VALIDATION,
      target: n.constructor,
      propertyName: o,
      constraintCls: e,
      constraints: Array.isArray(t) ? t : void 0,
      validationOptions: Array.isArray(t) ? r : t
    };
    kt().addValidationMetadata(new Xr(a));
  };
}
function lG(e, t) {
  return function(r, n) {
    var o = {
      type: qe.CONDITIONAL_VALIDATION,
      target: r.constructor,
      propertyName: n,
      constraints: [e],
      validationOptions: t
    };
    kt().addValidationMetadata(new Xr(o));
  };
}
var t1 = function() {
  return t1 = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, t1.apply(this, arguments);
};
function cG(e) {
  var t = t1({}, e), r = t.each ? "each value in " : "";
  return t.message = t.message || r + "nested property $property must be either object or array", function(n, o) {
    var a = {
      type: qe.NESTED_VALIDATION,
      target: n.constructor,
      propertyName: o,
      validationOptions: t
    };
    kt().addValidationMetadata(new Xr(a));
  };
}
function fG(e) {
  return function(t, r) {
    var n = {
      type: qe.PROMISE_VALIDATION,
      target: t.constructor,
      propertyName: r,
      validationOptions: e
    };
    kt().addValidationMetadata(new Xr(n));
  };
}
var Tu = { exports: {} }, Du = { exports: {} }, O8;
function Q() {
  return O8 || (O8 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = n;
    function r(o) {
      "@babel/helpers - typeof";
      return r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(a) {
        return typeof a;
      } : function(a) {
        return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
      }, r(o);
    }
    function n(o) {
      var a = typeof o == "string" || o instanceof String;
      if (!a) {
        var d = r(o);
        throw o === null ? d = "null" : d === "object" && (d = o.constructor.name), new TypeError("Expected a string but received a ".concat(d));
      }
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Du, Du.exports)), Du.exports;
}
var Lu = { exports: {} }, N8;
function ht() {
  return N8 || (N8 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = r;
    function r() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = arguments.length > 1 ? arguments[1] : void 0;
      for (var a in o)
        typeof n[a] > "u" && (n[a] = o[a]);
      return n;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Lu, Lu.exports)), Lu.exports;
}
var I8;
function Wy() {
  return I8 || (I8 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = c;
    var r = o(/* @__PURE__ */ Q()), n = o(/* @__PURE__ */ ht());
    function o(l) {
      return l && l.__esModule ? l : { default: l };
    }
    var a = /^\(?[+-]?(90(\.0+)?|[1-8]?\d(\.\d+)?)$/, d = /^\s?[+-]?(180(\.0+)?|1[0-7]\d(\.\d+)?|\d{1,2}(\.\d+)?)\)?$/, i = /^(([1-8]?\d)\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|90\D+0\D+0)\D+[NSns]?$/i, s = /^\s*([1-7]?\d{1,2}\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|180\D+0\D+0)\D+[EWew]?$/i, u = {
      checkDMS: !1
    };
    function c(l, p) {
      if ((0, r.default)(l), p = (0, n.default)(p, u), !l.includes(",")) return !1;
      var h = l.split(",");
      return h[0].startsWith("(") && !h[1].endsWith(")") || h[1].endsWith(")") && !h[0].startsWith("(") ? !1 : p.checkDMS ? i.test(h[0]) && s.test(h[1]) : a.test(h[0]) && d.test(h[1]);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Tu, Tu.exports)), Tu.exports;
}
var pG = /* @__PURE__ */ Wy();
const $G = /* @__PURE__ */ ve(pG);
var zy = "isLatLong";
function gi(e) {
  return typeof e == "string" && $G(e);
}
function vG(e) {
  return Y({
    name: zy,
    validator: {
      validate: function(t, r) {
        return gi(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be a latitude,longitude string";
      }, e)
    }
  }, e);
}
var Yy = "isLatitude";
function Xy(e) {
  return (typeof e == "number" || typeof e == "string") && gi("".concat(e, ",0"));
}
function mG(e) {
  return Y({
    name: Yy,
    validator: {
      validate: function(t, r) {
        return Xy(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be a latitude string or number";
      }, e)
    }
  }, e);
}
var qy = "isLongitude";
function Jy(e) {
  return (typeof e == "number" || typeof e == "string") && gi("0,".concat(e));
}
function hG(e) {
  return Y({
    name: qy,
    validator: {
      validate: function(t, r) {
        return Jy(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be a longitude string or number";
      }, e)
    }
  }, e);
}
var Qy = "equals";
function eb(e, t) {
  return e === t;
}
function gG(e, t) {
  return Y({
    name: Qy,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return eb(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must be equal to $constraint1";
      }, t)
    }
  }, t);
}
var tb = "notEquals";
function rb(e, t) {
  return e !== t;
}
function yG(e, t) {
  return Y({
    name: tb,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return rb(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property should not be equal to $constraint1";
      }, t)
    }
  }, t);
}
var nb = "isEmpty";
function ob(e) {
  return e === "" || e === null || e === void 0;
}
function bG(e) {
  return Y({
    name: nb,
    validator: {
      validate: function(t, r) {
        return ob(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be empty";
      }, e)
    }
  }, e);
}
var ab = "isNotEmpty";
function db(e) {
  return e !== "" && e !== null && e !== void 0;
}
function xG(e) {
  return Y({
    name: ab,
    validator: {
      validate: function(t, r) {
        return db(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property should not be empty";
      }, e)
    }
  }, e);
}
var ib = "isIn";
function sb(e, t) {
  return Array.isArray(t) && t.some(function(r) {
    return r === e;
  });
}
function wG(e, t) {
  return Y({
    name: ib,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return sb(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must be one of the following values: $constraint1";
      }, t)
    }
  }, t);
}
var ub = "isNotIn";
function lb(e, t) {
  return !Array.isArray(t) || !t.some(function(r) {
    return r === e;
  });
}
function AG(e, t) {
  return Y({
    name: ub,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return lb(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property should not be one of the following values: $constraint1";
      }, t)
    }
  }, t);
}
var Fu = { exports: {} }, ku = { exports: {} }, qn = {}, ju = { exports: {} }, P8;
function cb() {
  return P8 || (P8 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = r;
    function r(n) {
      return n == null;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(ju, ju.exports)), ju.exports;
}
var Ye = {}, R8;
function Fa() {
  if (R8) return Ye;
  R8 = 1, Object.defineProperty(Ye, "__esModule", {
    value: !0
  }), Ye.farsiLocales = Ye.englishLocales = Ye.dotDecimal = Ye.decimal = Ye.commaDecimal = Ye.bengaliLocales = Ye.arabicLocales = Ye.alphanumeric = Ye.alpha = void 0;
  for (var e = Ye.alpha = {
    "en-US": /^[A-Z]+$/i,
    "az-AZ": /^[A-VXYZÇƏĞİıÖŞÜ]+$/i,
    "bg-BG": /^[А-Я]+$/i,
    "cs-CZ": /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
    "da-DK": /^[A-ZÆØÅ]+$/i,
    "de-DE": /^[A-ZÄÖÜß]+$/i,
    "el-GR": /^[Α-ώ]+$/i,
    "es-ES": /^[A-ZÁÉÍÑÓÚÜ]+$/i,
    "fa-IR": /^[ابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی]+$/i,
    "fi-FI": /^[A-ZÅÄÖ]+$/i,
    "fr-FR": /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
    "it-IT": /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
    "ja-JP": /^[ぁ-んァ-ヶｦ-ﾟ一-龠ー・。、]+$/i,
    "nb-NO": /^[A-ZÆØÅ]+$/i,
    "nl-NL": /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
    "nn-NO": /^[A-ZÆØÅ]+$/i,
    "hu-HU": /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
    "pl-PL": /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
    "pt-PT": /^[A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
    "ru-RU": /^[А-ЯЁ]+$/i,
    "kk-KZ": /^[А-ЯЁ\u04D8\u04B0\u0406\u04A2\u0492\u04AE\u049A\u04E8\u04BA]+$/i,
    "sl-SI": /^[A-ZČĆĐŠŽ]+$/i,
    "sk-SK": /^[A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
    "sr-RS@latin": /^[A-ZČĆŽŠĐ]+$/i,
    "sr-RS": /^[А-ЯЂЈЉЊЋЏ]+$/i,
    "sv-SE": /^[A-ZÅÄÖ]+$/i,
    "th-TH": /^[ก-๐\s]+$/i,
    "tr-TR": /^[A-ZÇĞİıÖŞÜ]+$/i,
    "uk-UA": /^[А-ЩЬЮЯЄIЇҐі]+$/i,
    "vi-VN": /^[A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
    "ko-KR": /^[ㄱ-ㅎㅏ-ㅣ가-힣]*$/,
    "ku-IQ": /^[ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
    ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
    he: /^[א-ת]+$/,
    fa: /^['آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی']+$/i,
    bn: /^['ঀঁংঃঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহ়ঽািীুূৃৄেৈোৌ্ৎৗড়ঢ়য়ৠৡৢৣৰৱ৲৳৴৵৶৷৸৹৺৻']+$/,
    eo: /^[ABCĈD-GĜHĤIJĴK-PRSŜTUŬVZ]+$/i,
    "hi-IN": /^[\u0900-\u0961]+[\u0972-\u097F]*$/i,
    "si-LK": /^[\u0D80-\u0DFF]+$/
  }, t = Ye.alphanumeric = {
    "en-US": /^[0-9A-Z]+$/i,
    "az-AZ": /^[0-9A-VXYZÇƏĞİıÖŞÜ]+$/i,
    "bg-BG": /^[0-9А-Я]+$/i,
    "cs-CZ": /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
    "da-DK": /^[0-9A-ZÆØÅ]+$/i,
    "de-DE": /^[0-9A-ZÄÖÜß]+$/i,
    "el-GR": /^[0-9Α-ω]+$/i,
    "es-ES": /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
    "fi-FI": /^[0-9A-ZÅÄÖ]+$/i,
    "fr-FR": /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
    "it-IT": /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
    "ja-JP": /^[0-9０-９ぁ-んァ-ヶｦ-ﾟ一-龠ー・。、]+$/i,
    "hu-HU": /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
    "nb-NO": /^[0-9A-ZÆØÅ]+$/i,
    "nl-NL": /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
    "nn-NO": /^[0-9A-ZÆØÅ]+$/i,
    "pl-PL": /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
    "pt-PT": /^[0-9A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
    "ru-RU": /^[0-9А-ЯЁ]+$/i,
    "kk-KZ": /^[0-9А-ЯЁ\u04D8\u04B0\u0406\u04A2\u0492\u04AE\u049A\u04E8\u04BA]+$/i,
    "sl-SI": /^[0-9A-ZČĆĐŠŽ]+$/i,
    "sk-SK": /^[0-9A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
    "sr-RS@latin": /^[0-9A-ZČĆŽŠĐ]+$/i,
    "sr-RS": /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
    "sv-SE": /^[0-9A-ZÅÄÖ]+$/i,
    "th-TH": /^[ก-๙\s]+$/i,
    "tr-TR": /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
    "uk-UA": /^[0-9А-ЩЬЮЯЄIЇҐі]+$/i,
    "ko-KR": /^[0-9ㄱ-ㅎㅏ-ㅣ가-힣]*$/,
    "ku-IQ": /^[٠١٢٣٤٥٦٧٨٩0-9ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
    "vi-VN": /^[0-9A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
    ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
    he: /^[0-9א-ת]+$/,
    fa: /^['0-9آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی۱۲۳۴۵۶۷۸۹۰']+$/i,
    bn: /^['ঀঁংঃঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহ়ঽািীুূৃৄেৈোৌ্ৎৗড়ঢ়য়ৠৡৢৣ০১২৩৪৫৬৭৮৯ৰৱ৲৳৴৵৶৷৸৹৺৻']+$/,
    eo: /^[0-9ABCĈD-GĜHĤIJĴK-PRSŜTUŬVZ]+$/i,
    "hi-IN": /^[\u0900-\u0963]+[\u0966-\u097F]*$/i,
    "si-LK": /^[0-9\u0D80-\u0DFF]+$/
  }, r = Ye.decimal = {
    "en-US": ".",
    ar: "٫"
  }, n = Ye.englishLocales = ["AU", "GB", "HK", "IN", "NZ", "ZA", "ZM"], o, a = 0; a < n.length; a++)
    o = "en-".concat(n[a]), e[o] = e["en-US"], t[o] = t["en-US"], r[o] = r["en-US"];
  for (var d = Ye.arabicLocales = ["AE", "BH", "DZ", "EG", "IQ", "JO", "KW", "LB", "LY", "MA", "QM", "QA", "SA", "SD", "SY", "TN", "YE"], i, s = 0; s < d.length; s++)
    i = "ar-".concat(d[s]), e[i] = e.ar, t[i] = t.ar, r[i] = r.ar;
  for (var u = Ye.farsiLocales = ["IR", "AF"], c, l = 0; l < u.length; l++)
    c = "fa-".concat(u[l]), t[c] = t.fa, r[c] = r.ar;
  for (var p = Ye.bengaliLocales = ["BD", "IN"], h, m = 0; m < p.length; m++)
    h = "bn-".concat(p[m]), e[h] = e.bn, t[h] = t.bn, r[h] = r["en-US"];
  for (var f = Ye.dotDecimal = ["ar-EG", "ar-LB", "ar-LY"], $ = Ye.commaDecimal = ["bg-BG", "cs-CZ", "da-DK", "de-DE", "el-GR", "en-ZM", "eo", "es-ES", "fr-CA", "fr-FR", "id-ID", "it-IT", "ku-IQ", "hi-IN", "hu-HU", "nb-NO", "nn-NO", "nl-NL", "pl-PL", "pt-PT", "ru-RU", "kk-KZ", "si-LK", "sl-SI", "sr-RS@latin", "sr-RS", "sv-SE", "tr-TR", "uk-UA", "vi-VN"], v = 0; v < f.length; v++)
    r[f[v]] = r["en-US"];
  for (var y = 0; y < $.length; y++)
    r[$[y]] = ",";
  return e["fr-CA"] = e["fr-FR"], t["fr-CA"] = t["fr-FR"], e["pt-BR"] = e["pt-PT"], t["pt-BR"] = t["pt-PT"], r["pt-BR"] = r["pt-PT"], e["pl-Pl"] = e["pl-PL"], t["pl-Pl"] = t["pl-PL"], r["pl-Pl"] = r["pl-PL"], e["fa-AF"] = e.fa, Ye;
}
var T8;
function fb() {
  if (T8) return qn;
  T8 = 1, Object.defineProperty(qn, "__esModule", {
    value: !0
  }), qn.default = o, qn.locales = void 0;
  var e = n(/* @__PURE__ */ Q()), t = n(/* @__PURE__ */ cb()), r = /* @__PURE__ */ Fa();
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function o(a, d) {
    (0, e.default)(a), d = d || {};
    var i = new RegExp("^(?:[-+])?(?:[0-9]+)?(?:\\".concat(d.locale ? r.decimal[d.locale] : ".", "[0-9]*)?(?:[eE][\\+\\-]?(?:[0-9]+))?$"));
    if (a === "" || a === "." || a === "," || a === "-" || a === "+")
      return !1;
    var s = parseFloat(a.replace(",", "."));
    return i.test(a) && (!d.hasOwnProperty("min") || (0, t.default)(d.min) || s >= d.min) && (!d.hasOwnProperty("max") || (0, t.default)(d.max) || s <= d.max) && (!d.hasOwnProperty("lt") || (0, t.default)(d.lt) || s < d.lt) && (!d.hasOwnProperty("gt") || (0, t.default)(d.gt) || s > d.gt);
  }
  return qn.locales = Object.keys(r.decimal), qn;
}
var D8;
function pb() {
  return D8 || (D8 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ fb());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a) {
      return (0, r.default)(a) ? parseFloat(a) : NaN;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(ku, ku.exports)), ku.exports;
}
var L8;
function $b() {
  return L8 || (L8 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = o(/* @__PURE__ */ Q()), n = o(/* @__PURE__ */ pb());
    function o(d) {
      return d && d.__esModule ? d : { default: d };
    }
    function a(d, i) {
      return (0, r.default)(d), (0, n.default)(d) % parseInt(i, 10) === 0;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Fu, Fu.exports)), Fu.exports;
}
var SG = /* @__PURE__ */ $b();
const _G = /* @__PURE__ */ ve(SG);
var vb = "isDivisibleBy";
function mb(e, t) {
  return typeof e == "number" && typeof t == "number" && _G(String(e), t);
}
function EG(e, t) {
  return Y({
    name: vb,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return mb(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must be divisible by $constraint1";
      }, t)
    }
  }, t);
}
var hb = "isPositive";
function gb(e) {
  return typeof e == "number" && e > 0;
}
function MG(e) {
  return Y({
    name: hb,
    validator: {
      validate: function(t, r) {
        return gb(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be a positive number";
      }, e)
    }
  }, e);
}
var yb = "isNegative";
function bb(e) {
  return typeof e == "number" && e < 0;
}
function CG(e) {
  return Y({
    name: yb,
    validator: {
      validate: function(t, r) {
        return bb(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be a negative number";
      }, e)
    }
  }, e);
}
var xb = "max";
function wb(e, t) {
  return typeof e == "number" && typeof t == "number" && e <= t;
}
function OG(e, t) {
  return Y({
    name: xb,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return wb(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must not be greater than $constraint1";
      }, t)
    }
  }, t);
}
var Ab = "min";
function Sb(e, t) {
  return typeof e == "number" && typeof t == "number" && e >= t;
}
function NG(e, t) {
  return Y({
    name: Ab,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Sb(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must not be less than $constraint1";
      }, t)
    }
  }, t);
}
var _b = "minDate";
function Eb(e, t) {
  return e instanceof Date && e.getTime() >= (t instanceof Date ? t : t()).getTime();
}
function IG(e, t) {
  return Y({
    name: _b,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Eb(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return "minimal allowed date for " + r + "$property is $constraint1";
      }, t)
    }
  }, t);
}
var Mb = "maxDate";
function Cb(e, t) {
  return e instanceof Date && e.getTime() <= (t instanceof Date ? t : t()).getTime();
}
function PG(e, t) {
  return Y({
    name: Mb,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Cb(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return "maximal allowed date for " + r + "$property is $constraint1";
      }, t)
    }
  }, t);
}
var Bu = { exports: {} }, Zu = { exports: {} }, F8;
function Ob() {
  return F8 || (F8 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = n;
    function r(o) {
      "@babel/helpers - typeof";
      return r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(a) {
        return typeof a;
      } : function(a) {
        return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
      }, r(o);
    }
    function n(o) {
      return r(o) === "object" && o !== null ? typeof o.toString == "function" ? o = o.toString() : o = "[object Object]" : (o === null || typeof o > "u" || isNaN(o) && !o.length) && (o = ""), String(o);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Zu, Zu.exports)), Zu.exports;
}
var k8;
function Nb() {
  return k8 || (k8 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var r = a(/* @__PURE__ */ Q()), n = a(/* @__PURE__ */ Ob()), o = a(/* @__PURE__ */ ht());
    function a(s) {
      return s && s.__esModule ? s : { default: s };
    }
    var d = {
      ignoreCase: !1,
      minOccurrences: 1
    };
    function i(s, u, c) {
      return (0, r.default)(s), c = (0, o.default)(c, d), c.ignoreCase ? s.toLowerCase().split((0, n.default)(u).toLowerCase()).length > c.minOccurrences : s.split((0, n.default)(u)).length > c.minOccurrences;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Bu, Bu.exports)), Bu.exports;
}
var RG = /* @__PURE__ */ Nb();
const Ib = /* @__PURE__ */ ve(RG);
var Pb = "contains";
function Rb(e, t) {
  return typeof e == "string" && Ib(e, t);
}
function TG(e, t) {
  return Y({
    name: Pb,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Rb(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must contain a $constraint1 string";
      }, t)
    }
  }, t);
}
var Tb = "notContains";
function Db(e, t) {
  return typeof e == "string" && !Ib(e, t);
}
function DG(e, t) {
  return Y({
    name: Tb,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Db(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property should not contain a $constraint1 string";
      }, t)
    }
  }, t);
}
var Jn = {}, j8;
function Lb() {
  if (j8) return Jn;
  j8 = 1, Object.defineProperty(Jn, "__esModule", {
    value: !0
  }), Jn.default = n, Jn.locales = void 0;
  var e = r(/* @__PURE__ */ Q()), t = /* @__PURE__ */ Fa();
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function n(o) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US", d = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    (0, e.default)(o);
    var i = o, s = d.ignore;
    if (s)
      if (s instanceof RegExp)
        i = i.replace(s, "");
      else if (typeof s == "string")
        i = i.replace(new RegExp("[".concat(s.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, "\\$&"), "]"), "g"), "");
      else
        throw new Error("ignore should be instance of a String or RegExp");
    if (a in t.alpha)
      return t.alpha[a].test(i);
    throw new Error("Invalid locale '".concat(a, "'"));
  }
  return Jn.locales = Object.keys(t.alpha), Jn;
}
var LG = /* @__PURE__ */ Lb();
const FG = /* @__PURE__ */ ve(LG);
var Fb = "isAlpha";
function kb(e, t) {
  return typeof e == "string" && FG(e, t);
}
function kG(e, t) {
  return Y({
    name: Fb,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return kb(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must contain only letters (a-zA-Z)";
      }, t)
    }
  }, t);
}
var Qn = {}, B8;
function jb() {
  if (B8) return Qn;
  B8 = 1, Object.defineProperty(Qn, "__esModule", {
    value: !0
  }), Qn.default = n, Qn.locales = void 0;
  var e = r(/* @__PURE__ */ Q()), t = /* @__PURE__ */ Fa();
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function n(o) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US", d = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    (0, e.default)(o);
    var i = o, s = d.ignore;
    if (s)
      if (s instanceof RegExp)
        i = i.replace(s, "");
      else if (typeof s == "string")
        i = i.replace(new RegExp("[".concat(s.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, "\\$&"), "]"), "g"), "");
      else
        throw new Error("ignore should be instance of a String or RegExp");
    if (a in t.alphanumeric)
      return t.alphanumeric[a].test(i);
    throw new Error("Invalid locale '".concat(a, "'"));
  }
  return Qn.locales = Object.keys(t.alphanumeric), Qn;
}
var jG = /* @__PURE__ */ jb();
const BG = /* @__PURE__ */ ve(jG);
var Bb = "isAlphanumeric";
function Zb(e, t) {
  return typeof e == "string" && BG(e, t);
}
function ZG(e, t) {
  return Y({
    name: Bb,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Zb(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must contain only letters and numbers";
      }, t)
    }
  }, t);
}
var Uu = { exports: {} }, Gu = { exports: {} }, Z8;
function UG() {
  return Z8 || (Z8 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = function(n, o) {
      return n.some(function(a) {
        return o === a;
      });
    };
    t.default = r, e.exports = t.default, e.exports.default = t.default;
  }(Gu, Gu.exports)), Gu.exports;
}
var U8;
function Ub() {
  return U8 || (U8 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = c;
    var r = d(/* @__PURE__ */ ht()), n = d(/* @__PURE__ */ Q()), o = d(/* @__PURE__ */ UG()), a = /* @__PURE__ */ Fa();
    function d(l) {
      return l && l.__esModule ? l : { default: l };
    }
    function i(l) {
      var p = new RegExp("^[-+]?([0-9]+)?(\\".concat(a.decimal[l.locale], "[0-9]{").concat(l.decimal_digits, "})").concat(l.force_decimal ? "" : "?", "$"));
      return p;
    }
    var s = {
      force_decimal: !1,
      decimal_digits: "1,",
      locale: "en-US"
    }, u = ["", "-", "+"];
    function c(l, p) {
      if ((0, n.default)(l), p = (0, r.default)(p, s), p.locale in a.decimal)
        return !(0, o.default)(u, l.replace(/ /g, "")) && i(p).test(l);
      throw new Error("Invalid locale '".concat(p.locale, "'"));
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Uu, Uu.exports)), Uu.exports;
}
var GG = /* @__PURE__ */ Ub();
const VG = /* @__PURE__ */ ve(GG);
var Gb = "isDecimal";
function Vb(e, t) {
  return typeof e == "string" && VG(e, t);
}
function HG(e, t) {
  return Y({
    name: Gb,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Vb(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property is not a valid decimal number.";
      }, t)
    }
  }, t);
}
var Vu = { exports: {} }, G8;
function Hb() {
  return G8 || (G8 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ Q());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /^[\x00-\x7F]+$/;
    function a(d) {
      return (0, r.default)(d), o.test(d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Vu, Vu.exports)), Vu.exports;
}
var KG = /* @__PURE__ */ Hb();
const WG = /* @__PURE__ */ ve(KG);
var Kb = "isAscii";
function Wb(e) {
  return typeof e == "string" && WG(e);
}
function zG(e) {
  return Y({
    name: Kb,
    validator: {
      validate: function(t, r) {
        return Wb(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must contain only ASCII characters";
      }, e)
    }
  }, e);
}
var Hu = { exports: {} }, V8;
function f2() {
  return V8 || (V8 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = s;
    var r = o(/* @__PURE__ */ Q()), n = o(/* @__PURE__ */ ht());
    function o(u) {
      return u && u.__esModule ? u : { default: u };
    }
    var a = /[^A-Z0-9+\/=]/i, d = /^[A-Z0-9_\-]*$/i, i = {
      urlSafe: !1
    };
    function s(u, c) {
      (0, r.default)(u), c = (0, n.default)(c, i);
      var l = u.length;
      if (c.urlSafe)
        return d.test(u);
      if (l % 4 !== 0 || a.test(u))
        return !1;
      var p = u.indexOf("=");
      return p === -1 || p === l - 1 || p === l - 2 && u[l - 1] === "=";
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Hu, Hu.exports)), Hu.exports;
}
var YG = /* @__PURE__ */ f2();
const XG = /* @__PURE__ */ ve(YG);
var zb = "isBase64";
function Yb(e, t) {
  return typeof e == "string" && XG(e, t);
}
function qG(e, t) {
  return Y({
    name: zb,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Yb(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must be base64 encoded";
      }, t)
    }
  }, t);
}
var Ku = { exports: {} }, H8;
function p2() {
  return H8 || (H8 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ Q());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    function o(d) {
      "@babel/helpers - typeof";
      return o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
        return typeof i;
      } : function(i) {
        return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
      }, o(d);
    }
    function a(d, i) {
      (0, r.default)(d);
      var s, u;
      o(i) === "object" ? (s = i.min || 0, u = i.max) : (s = arguments[1], u = arguments[2]);
      var c = encodeURI(d).split(/%..|./).length - 1;
      return c >= s && (typeof u > "u" || c <= u);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Ku, Ku.exports)), Ku.exports;
}
var JG = /* @__PURE__ */ p2();
const QG = /* @__PURE__ */ ve(JG);
var Xb = "isByteLength";
function qb(e, t, r) {
  return typeof e == "string" && QG(e, { min: t, max: r });
}
function eV(e, t, r) {
  return Y({
    name: Xb,
    constraints: [e, t],
    validator: {
      validate: function(n, o) {
        return qb(n, o == null ? void 0 : o.constraints[0], o == null ? void 0 : o.constraints[1]);
      },
      defaultMessage: z(function(n) {
        return n + "$property's byte length must fall into ($constraint1, $constraint2) range";
      }, r)
    }
  }, r);
}
var Wu = { exports: {} }, zu = { exports: {} }, K8;
function Jb() {
  return K8 || (K8 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ Q());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a) {
      (0, r.default)(a);
      for (var d = a.replace(/[- ]+/g, ""), i = 0, s, u, c, l = d.length - 1; l >= 0; l--)
        s = d.substring(l, l + 1), u = parseInt(s, 10), c ? (u *= 2, u >= 10 ? i += u % 10 + 1 : i += u) : i += u, c = !c;
      return !!(i % 10 === 0 && d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(zu, zu.exports)), zu.exports;
}
var W8;
function Qb() {
  return W8 || (W8 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var r = o(/* @__PURE__ */ Q()), n = o(/* @__PURE__ */ Jb());
    function o(s) {
      return s && s.__esModule ? s : { default: s };
    }
    var a = {
      amex: /^3[47][0-9]{13}$/,
      dinersclub: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
      discover: /^6(?:011|5[0-9][0-9])[0-9]{12,15}$/,
      jcb: /^(?:2131|1800|35\d{3})\d{11}$/,
      mastercard: /^5[1-5][0-9]{2}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/,
      // /^[25][1-7][0-9]{14}$/;
      unionpay: /^(6[27][0-9]{14}|^(81[0-9]{14,17}))$/,
      visa: /^(?:4[0-9]{12})(?:[0-9]{3,6})?$/
    }, d = function() {
      var s = [];
      for (var u in a)
        a.hasOwnProperty(u) && s.push(a[u]);
      return s;
    }();
    function i(s) {
      var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      (0, r.default)(s);
      var c = u.provider, l = s.replace(/[- ]+/g, "");
      if (c && c.toLowerCase() in a) {
        if (!a[c.toLowerCase()].test(l))
          return !1;
      } else {
        if (c && !(c.toLowerCase() in a))
          throw new Error("".concat(c, " is not a valid credit card provider."));
        if (!d.some(function(p) {
          return p.test(l);
        }))
          return !1;
      }
      return (0, n.default)(s);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Wu, Wu.exports)), Wu.exports;
}
var tV = /* @__PURE__ */ Qb();
const rV = /* @__PURE__ */ ve(tV);
var ex = "isCreditCard";
function tx(e) {
  return typeof e == "string" && rV(e);
}
function nV(e) {
  return Y({
    name: ex,
    validator: {
      validate: function(t, r) {
        return tx(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be a credit card";
      }, e)
    }
  }, e);
}
var Yu = { exports: {} }, z8;
function rx() {
  return z8 || (z8 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var r = o(/* @__PURE__ */ ht()), n = o(/* @__PURE__ */ Q());
    function o(s) {
      return s && s.__esModule ? s : { default: s };
    }
    function a(s) {
      var u = "\\d{".concat(s.digits_after_decimal[0], "}");
      s.digits_after_decimal.forEach(function(y, S) {
        S !== 0 && (u = "".concat(u, "|\\d{").concat(y, "}"));
      });
      var c = "(".concat(s.symbol.replace(/\W/, function(y) {
        return "\\".concat(y);
      }), ")").concat(s.require_symbol ? "" : "?"), l = "-?", p = "[1-9]\\d*", h = "[1-9]\\d{0,2}(\\".concat(s.thousands_separator, "\\d{3})*"), m = ["0", p, h], f = "(".concat(m.join("|"), ")?"), $ = "(\\".concat(s.decimal_separator, "(").concat(u, "))").concat(s.require_decimal ? "" : "?"), v = f + (s.allow_decimal || s.require_decimal ? $ : "");
      return s.allow_negatives && !s.parens_for_negatives && (s.negative_sign_after_digits ? v += l : s.negative_sign_before_digits && (v = l + v)), s.allow_negative_sign_placeholder ? v = "( (?!\\-))?".concat(v) : s.allow_space_after_symbol ? v = " ?".concat(v) : s.allow_space_after_digits && (v += "( (?!$))?"), s.symbol_after_digits ? v += c : v = c + v, s.allow_negatives && (s.parens_for_negatives ? v = "(\\(".concat(v, "\\)|").concat(v, ")") : s.negative_sign_before_digits || s.negative_sign_after_digits || (v = l + v)), new RegExp("^(?!-? )(?=.*\\d)".concat(v, "$"));
    }
    var d = {
      symbol: "$",
      require_symbol: !1,
      allow_space_after_symbol: !1,
      symbol_after_digits: !1,
      allow_negatives: !0,
      parens_for_negatives: !1,
      negative_sign_before_digits: !1,
      negative_sign_after_digits: !1,
      allow_negative_sign_placeholder: !1,
      thousands_separator: ",",
      decimal_separator: ".",
      allow_decimal: !0,
      require_decimal: !1,
      digits_after_decimal: [2],
      allow_space_after_digits: !1
    };
    function i(s, u) {
      return (0, n.default)(s), u = (0, r.default)(u, d), a(u).test(s);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Yu, Yu.exports)), Yu.exports;
}
var oV = /* @__PURE__ */ rx();
const aV = /* @__PURE__ */ ve(oV);
var nx = "isCurrency";
function ox(e, t) {
  return typeof e == "string" && aV(e, t);
}
function dV(e, t) {
  return Y({
    name: nx,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return ox(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must be a currency";
      }, t)
    }
  }, t);
}
var Xu = { exports: {} }, qu = { exports: {} }, Y8;
function ax() {
  return Y8 || (Y8 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = n;
    function r(o) {
      return Object.prototype.toString.call(o) === "[object RegExp]";
    }
    function n(o, a) {
      for (var d = 0; d < a.length; d++) {
        var i = a[d];
        if (o === i || r(i) && i.test(o))
          return !0;
      }
      return !1;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(qu, qu.exports)), qu.exports;
}
var Ju = { exports: {} }, X8;
function yi() {
  return X8 || (X8 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = o(/* @__PURE__ */ Q()), n = o(/* @__PURE__ */ ht());
    function o(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var a = {
      require_tld: !0,
      allow_underscores: !1,
      allow_trailing_dot: !1,
      allow_numeric_tld: !1,
      allow_wildcard: !1,
      ignore_max_length: !1
    };
    function d(i, s) {
      (0, r.default)(i), s = (0, n.default)(s, a), s.allow_trailing_dot && i[i.length - 1] === "." && (i = i.substring(0, i.length - 1)), s.allow_wildcard === !0 && i.indexOf("*.") === 0 && (i = i.substring(2));
      var u = i.split("."), c = u[u.length - 1];
      return s.require_tld && (u.length < 2 || !s.allow_numeric_tld && !/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(c) || /\s/.test(c)) || !s.allow_numeric_tld && /^\d+$/.test(c) ? !1 : u.every(function(l) {
        return !(l.length > 63 && !s.ignore_max_length || !/^[a-z_\u00a1-\uffff0-9-]+$/i.test(l) || /[\uff01-\uff5e]/.test(l) || /^-|-$/.test(l) || !s.allow_underscores && /_/.test(l));
      });
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Ju, Ju.exports)), Ju.exports;
}
var Qu = { exports: {} }, q8;
function ka() {
  return q8 || (q8 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = u;
    var r = n(/* @__PURE__ */ Q());
    function n(c) {
      return c && c.__esModule ? c : { default: c };
    }
    var o = "(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])", a = "(".concat(o, "[.]){3}").concat(o), d = new RegExp("^".concat(a, "$")), i = "(?:[0-9a-fA-F]{1,4})", s = new RegExp("^(" + "(?:".concat(i, ":){7}(?:").concat(i, "|:)|") + "(?:".concat(i, ":){6}(?:").concat(a, "|:").concat(i, "|:)|") + "(?:".concat(i, ":){5}(?::").concat(a, "|(:").concat(i, "){1,2}|:)|") + "(?:".concat(i, ":){4}(?:(:").concat(i, "){0,1}:").concat(a, "|(:").concat(i, "){1,3}|:)|") + "(?:".concat(i, ":){3}(?:(:").concat(i, "){0,2}:").concat(a, "|(:").concat(i, "){1,4}|:)|") + "(?:".concat(i, ":){2}(?:(:").concat(i, "){0,3}:").concat(a, "|(:").concat(i, "){1,5}|:)|") + "(?:".concat(i, ":){1}(?:(:").concat(i, "){0,4}:").concat(a, "|(:").concat(i, "){1,6}|:)|") + "(?::((?::".concat(i, "){0,5}:").concat(a, "|(?::").concat(i, "){1,7}|:))") + ")(%[0-9a-zA-Z-.:]{1,})?$");
    function u(c) {
      var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
      return (0, r.default)(c), l = String(l), l ? l === "4" ? d.test(c) : l === "6" ? s.test(c) : !1 : u(c, 4) || u(c, 6);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Qu, Qu.exports)), Qu.exports;
}
var J8;
function $2() {
  return J8 || (J8 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = y;
    var r = s(/* @__PURE__ */ Q()), n = s(/* @__PURE__ */ ax()), o = s(/* @__PURE__ */ p2()), a = s(/* @__PURE__ */ yi()), d = s(/* @__PURE__ */ ka()), i = s(/* @__PURE__ */ ht());
    function s(S) {
      return S && S.__esModule ? S : { default: S };
    }
    var u = {
      allow_display_name: !1,
      allow_underscores: !1,
      require_display_name: !1,
      allow_utf8_local_part: !0,
      require_tld: !0,
      blacklisted_chars: "",
      ignore_max_length: !1,
      host_blacklist: [],
      host_whitelist: []
    }, c = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i, l = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i, p = /^[a-z\d]+$/, h = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i, m = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A1-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i, f = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i, $ = 254;
    function v(S) {
      var w = S.replace(/^"(.+)"$/, "$1");
      if (!w.trim())
        return !1;
      var _ = /[\.";<>]/.test(w);
      if (_) {
        if (w === S)
          return !1;
        var I = w.split('"').length === w.split('\\"').length;
        if (!I)
          return !1;
      }
      return !0;
    }
    function y(S, w) {
      if ((0, r.default)(S), w = (0, i.default)(w, u), w.require_display_name || w.allow_display_name) {
        var _ = S.match(c);
        if (_) {
          var I = _[1];
          if (S = S.replace(I, "").replace(/(^<|>$)/g, ""), I.endsWith(" ") && (I = I.slice(0, -1)), !v(I))
            return !1;
        } else if (w.require_display_name)
          return !1;
      }
      if (!w.ignore_max_length && S.length > $)
        return !1;
      var N = S.split("@"), O = N.pop(), E = O.toLowerCase();
      if (w.host_blacklist.length > 0 && (0, n.default)(E, w.host_blacklist) || w.host_whitelist.length > 0 && !(0, n.default)(E, w.host_whitelist))
        return !1;
      var C = N.join("@");
      if (w.domain_specific_validation && (E === "gmail.com" || E === "googlemail.com")) {
        C = C.toLowerCase();
        var P = C.split("+")[0];
        if (!(0, o.default)(P.replace(/\./g, ""), {
          min: 6,
          max: 30
        }))
          return !1;
        for (var T = P.split("."), j = 0; j < T.length; j++)
          if (!p.test(T[j]))
            return !1;
      }
      if (w.ignore_max_length === !1 && (!(0, o.default)(C, {
        max: 64
      }) || !(0, o.default)(O, {
        max: 254
      })))
        return !1;
      if (!(0, a.default)(O, {
        require_tld: w.require_tld,
        ignore_max_length: w.ignore_max_length,
        allow_underscores: w.allow_underscores
      })) {
        if (!w.allow_ip_domain)
          return !1;
        if (!(0, d.default)(O)) {
          if (!O.startsWith("[") || !O.endsWith("]"))
            return !1;
          var F = O.slice(1, -1);
          if (F.length === 0 || !(0, d.default)(F))
            return !1;
        }
      }
      if (w.blacklisted_chars && C.search(new RegExp("[".concat(w.blacklisted_chars, "]+"), "g")) !== -1)
        return !1;
      if (C[0] === '"' && C[C.length - 1] === '"')
        return C = C.slice(1, C.length - 1), w.allow_utf8_local_part ? f.test(C) : h.test(C);
      for (var Z = w.allow_utf8_local_part ? m : l, te = C.split("."), H = 0; H < te.length; H++)
        if (!Z.test(te[H]))
          return !1;
      return !0;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Xu, Xu.exports)), Xu.exports;
}
var iV = /* @__PURE__ */ $2();
const sV = /* @__PURE__ */ ve(iV);
var dx = "isEmail";
function ix(e, t) {
  return typeof e == "string" && sV(e, t);
}
function uV(e, t) {
  return Y({
    name: dx,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return ix(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must be an email";
      }, t)
    }
  }, t);
}
var lV = /* @__PURE__ */ yi();
const cV = /* @__PURE__ */ ve(lV);
var sx = "isFqdn";
function ux(e, t) {
  return typeof e == "string" && cV(e, t);
}
function fV(e, t) {
  return Y({
    name: sx,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return ux(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must be a valid domain name";
      }, t)
    }
  }, t);
}
var eo = {}, Q8;
function v2() {
  if (Q8) return eo;
  Q8 = 1, Object.defineProperty(eo, "__esModule", {
    value: !0
  }), eo.default = n, eo.fullWidth = void 0;
  var e = t(/* @__PURE__ */ Q());
  function t(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var r = eo.fullWidth = /[^\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
  function n(o) {
    return (0, e.default)(o), r.test(o);
  }
  return eo;
}
var pV = /* @__PURE__ */ v2();
const $V = /* @__PURE__ */ ve(pV);
var lx = "isFullWidth";
function cx(e) {
  return typeof e == "string" && $V(e);
}
function vV(e) {
  return Y({
    name: lx,
    validator: {
      validate: function(t, r) {
        return cx(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must contain a full-width characters";
      }, e)
    }
  }, e);
}
var to = {}, e5;
function m2() {
  if (e5) return to;
  e5 = 1, Object.defineProperty(to, "__esModule", {
    value: !0
  }), to.default = n, to.halfWidth = void 0;
  var e = t(/* @__PURE__ */ Q());
  function t(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var r = to.halfWidth = /[\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
  function n(o) {
    return (0, e.default)(o), r.test(o);
  }
  return to;
}
var mV = /* @__PURE__ */ m2();
const hV = /* @__PURE__ */ ve(mV);
var fx = "isHalfWidth";
function px(e) {
  return typeof e == "string" && hV(e);
}
function gV(e) {
  return Y({
    name: fx,
    validator: {
      validate: function(t, r) {
        return px(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must contain a half-width characters";
      }, e)
    }
  }, e);
}
var el = { exports: {} }, t5;
function $x() {
  return t5 || (t5 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = a(/* @__PURE__ */ Q()), n = /* @__PURE__ */ v2(), o = /* @__PURE__ */ m2();
    function a(i) {
      return i && i.__esModule ? i : { default: i };
    }
    function d(i) {
      return (0, r.default)(i), n.fullWidth.test(i) && o.halfWidth.test(i);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(el, el.exports)), el.exports;
}
var yV = /* @__PURE__ */ $x();
const bV = /* @__PURE__ */ ve(yV);
var vx = "isVariableWidth";
function mx(e) {
  return typeof e == "string" && bV(e);
}
function xV(e) {
  return Y({
    name: vx,
    validator: {
      validate: function(t, r) {
        return mx(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must contain a full-width and half-width characters";
      }, e)
    }
  }, e);
}
var tl = { exports: {} }, r5;
function hx() {
  return r5 || (r5 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ Q());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /^#?([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$/i;
    function a(d) {
      return (0, r.default)(d), o.test(d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(tl, tl.exports)), tl.exports;
}
var wV = /* @__PURE__ */ hx();
const AV = /* @__PURE__ */ ve(wV);
var gx = "isHexColor";
function yx(e) {
  return typeof e == "string" && AV(e);
}
function SV(e) {
  return Y({
    name: gx,
    validator: {
      validate: function(t, r) {
        return yx(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be a hexadecimal color";
      }, e)
    }
  }, e);
}
var rl = { exports: {} }, n5;
function h2() {
  return n5 || (n5 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ Q());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /^(0x|0h)?[0-9A-F]+$/i;
    function a(d) {
      return (0, r.default)(d), o.test(d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(rl, rl.exports)), rl.exports;
}
var _V = /* @__PURE__ */ h2();
const EV = /* @__PURE__ */ ve(_V);
var bx = "isHexadecimal";
function xx(e) {
  return typeof e == "string" && EV(e);
}
function MV(e) {
  return Y({
    name: bx,
    validator: {
      validate: function(t, r) {
        return xx(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be a hexadecimal number";
      }, e)
    }
  }, e);
}
function r1(e) {
  return e ? "each" in e || "message" in e || "groups" in e || "always" in e || "context" in e : !1;
}
var nl = { exports: {} }, o5;
function wx() {
  return o5 || (o5 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = c;
    var r = n(/* @__PURE__ */ Q());
    function n(l) {
      return l && l.__esModule ? l : { default: l };
    }
    var o = /^(?:[0-9a-fA-F]{2}([-:\s]))([0-9a-fA-F]{2}\1){4}([0-9a-fA-F]{2})$/, a = /^([0-9a-fA-F]){12}$/, d = /^([0-9a-fA-F]{4}\.){2}([0-9a-fA-F]{4})$/, i = /^(?:[0-9a-fA-F]{2}([-:\s]))([0-9a-fA-F]{2}\1){6}([0-9a-fA-F]{2})$/, s = /^([0-9a-fA-F]){16}$/, u = /^([0-9a-fA-F]{4}\.){3}([0-9a-fA-F]{4})$/;
    function c(l, p) {
      return (0, r.default)(l), p != null && p.eui && (p.eui = String(p.eui)), p != null && p.no_colons || p != null && p.no_separators ? p.eui === "48" ? a.test(l) : p.eui === "64" ? s.test(l) : a.test(l) || s.test(l) : (p == null ? void 0 : p.eui) === "48" ? o.test(l) || d.test(l) : (p == null ? void 0 : p.eui) === "64" ? i.test(l) || u.test(l) : c(l, {
        eui: "48"
      }) || c(l, {
        eui: "64"
      });
    }
    e.exports = t.default, e.exports.default = t.default;
  }(nl, nl.exports)), nl.exports;
}
var CV = /* @__PURE__ */ wx();
const OV = /* @__PURE__ */ ve(CV);
var Ax = "isMacAddress";
function Sx(e, t) {
  return typeof e == "string" && OV(e, t);
}
function NV(e, t) {
  var r = r1(e) ? void 0 : e, n = r1(e) ? e : t;
  return Y({
    name: Ax,
    constraints: [r],
    validator: {
      validate: function(o, a) {
        return Sx(o, r);
      },
      defaultMessage: z(function(o) {
        return o + "$property must be a MAC Address";
      }, n)
    }
  }, n);
}
var IV = /* @__PURE__ */ ka();
const PV = /* @__PURE__ */ ve(IV);
var _x = "isIp";
function Ex(e, t) {
  var r = t ? "".concat(t) : void 0;
  return typeof e == "string" && PV(e, r);
}
function RV(e, t) {
  return Y({
    name: _x,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Ex(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must be an ip address";
      }, t)
    }
  }, t);
}
var ol = { exports: {} }, al = { exports: {} }, a5;
function g2() {
  return a5 || (a5 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var r = o(/* @__PURE__ */ Q()), n = o(/* @__PURE__ */ cb());
    function o(s) {
      return s && s.__esModule ? s : { default: s };
    }
    var a = /^(?:[-+]?(?:0|[1-9][0-9]*))$/, d = /^[-+]?[0-9]+$/;
    function i(s, u) {
      (0, r.default)(s), u = u || {};
      var c = u.allow_leading_zeroes === !1 ? a : d, l = !u.hasOwnProperty("min") || (0, n.default)(u.min) || s >= u.min, p = !u.hasOwnProperty("max") || (0, n.default)(u.max) || s <= u.max, h = !u.hasOwnProperty("lt") || (0, n.default)(u.lt) || s < u.lt, m = !u.hasOwnProperty("gt") || (0, n.default)(u.gt) || s > u.gt;
      return c.test(s) && l && p && h && m;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(al, al.exports)), al.exports;
}
var d5;
function Mx() {
  return d5 || (d5 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ g2());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a) {
      return (0, r.default)(a, {
        allow_leading_zeroes: !1,
        min: 0,
        max: 65535
      });
    }
    e.exports = t.default, e.exports.default = t.default;
  }(ol, ol.exports)), ol.exports;
}
var TV = /* @__PURE__ */ Mx();
const DV = /* @__PURE__ */ ve(TV);
var Cx = "isPort";
function Ox(e) {
  return typeof e == "string" && DV(e);
}
function LV(e) {
  return Y({
    name: Cx,
    validator: {
      validate: function(t, r) {
        return Ox(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be a port";
      }, e)
    }
  }, e);
}
var dl = { exports: {} }, i5;
function Nx() {
  return i5 || (i5 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var r = n(/* @__PURE__ */ Q());
    function n(s) {
      return s && s.__esModule ? s : { default: s };
    }
    var o = /^(?:[0-9]{9}X|[0-9]{10})$/, a = /^(?:[0-9]{13})$/, d = [1, 3];
    function i(s, u) {
      (0, r.default)(s);
      var c = String((u == null ? void 0 : u.version) || u);
      if (!(u != null && u.version || u))
        return i(s, {
          version: 10
        }) || i(s, {
          version: 13
        });
      var l = s.replace(/[\s-]+/g, ""), p = 0;
      if (c === "10") {
        if (!o.test(l))
          return !1;
        for (var h = 0; h < c - 1; h++)
          p += (h + 1) * l.charAt(h);
        if (l.charAt(9) === "X" ? p += 10 * 10 : p += 10 * l.charAt(9), p % 11 === 0)
          return !0;
      } else if (c === "13") {
        if (!a.test(l))
          return !1;
        for (var m = 0; m < 12; m++)
          p += d[m % 2] * l.charAt(m);
        if (l.charAt(12) - (10 - p % 10) % 10 === 0)
          return !0;
      }
      return !1;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(dl, dl.exports)), dl.exports;
}
var FV = /* @__PURE__ */ Nx();
const kV = /* @__PURE__ */ ve(FV);
var Ix = "isIsbn";
function Px(e, t) {
  var r = t ? "".concat(t) : void 0;
  return typeof e == "string" && kV(e, r);
}
function jV(e, t) {
  return Y({
    name: Ix,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Px(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must be an ISBN";
      }, t)
    }
  }, t);
}
var il = { exports: {} }, s5;
function Rx() {
  return s5 || (s5 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ Q());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /^[A-Z]{2}[0-9A-Z]{9}[0-9]$/;
    function a(d) {
      if ((0, r.default)(d), !o.test(d))
        return !1;
      for (var i = !0, s = 0, u = d.length - 2; u >= 0; u--)
        if (d[u] >= "A" && d[u] <= "Z")
          for (var c = d[u].charCodeAt(0) - 55, l = c % 10, p = Math.trunc(c / 10), h = 0, m = [l, p]; h < m.length; h++) {
            var f = m[h];
            i ? f >= 5 ? s += 1 + (f - 5) * 2 : s += f * 2 : s += f, i = !i;
          }
        else {
          var $ = d[u].charCodeAt(0) - 48;
          i ? $ >= 5 ? s += 1 + ($ - 5) * 2 : s += $ * 2 : s += $, i = !i;
        }
      var v = Math.trunc((s + 9) / 10) * 10 - s;
      return +d[d.length - 1] === v;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(il, il.exports)), il.exports;
}
var BV = /* @__PURE__ */ Rx();
const ZV = /* @__PURE__ */ ve(BV);
var Tx = "isIsin";
function Dx(e) {
  return typeof e == "string" && ZV(e);
}
function UV(e) {
  return Y({
    name: Tx,
    validator: {
      validate: function(t, r) {
        return Dx(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be an ISIN (stock/security identifier)";
      }, e)
    }
  }, e);
}
var sl = { exports: {} }, u5;
function Lx() {
  return u5 || (u5 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var r = n(/* @__PURE__ */ Q());
    function n(s) {
      return s && s.__esModule ? s : { default: s };
    }
    var o = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/, a = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/, d = function(s) {
      var u = s.match(/^(\d{4})-?(\d{3})([ T]{1}\.*|$)/);
      if (u) {
        var c = Number(u[1]), l = Number(u[2]);
        return c % 4 === 0 && c % 100 !== 0 || c % 400 === 0 ? l <= 366 : l <= 365;
      }
      var p = s.match(/(\d{4})-?(\d{0,2})-?(\d*)/).map(Number), h = p[1], m = p[2], f = p[3], $ = m && "0".concat(m).slice(-2), v = f && "0".concat(f).slice(-2), y = new Date("".concat(h, "-").concat($ || "01", "-").concat(v || "01"));
      return m && f ? y.getUTCFullYear() === h && y.getUTCMonth() + 1 === m && y.getUTCDate() === f : !0;
    };
    function i(s) {
      var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      (0, r.default)(s);
      var c = u.strictSeparator ? a.test(s) : o.test(s);
      return c && u.strict ? d(s) : c;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(sl, sl.exports)), sl.exports;
}
var GV = /* @__PURE__ */ Lx();
const VV = /* @__PURE__ */ ve(GV);
var Fx = "isIso8601";
function y2(e, t) {
  return typeof e == "string" && VV(e, t);
}
function HV(e, t) {
  return Y({
    name: Fx,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return y2(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must be a valid ISO 8601 date string";
      }, t)
    }
  }, t);
}
var ul = { exports: {} }, l5;
function kx() {
  return l5 || (l5 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var r = o(/* @__PURE__ */ Q()), n = o(/* @__PURE__ */ ht());
    function o(s) {
      return s && s.__esModule ? s : { default: s };
    }
    function a(s) {
      "@babel/helpers - typeof";
      return a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(u) {
        return typeof u;
      } : function(u) {
        return u && typeof Symbol == "function" && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
      }, a(s);
    }
    var d = {
      allow_primitives: !1
    };
    function i(s, u) {
      (0, r.default)(s);
      try {
        u = (0, n.default)(u, d);
        var c = [];
        u.allow_primitives && (c = [null, !1, !0]);
        var l = JSON.parse(s);
        return c.includes(l) || !!l && a(l) === "object";
      } catch {
      }
      return !1;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(ul, ul.exports)), ul.exports;
}
var KV = /* @__PURE__ */ kx();
const WV = /* @__PURE__ */ ve(KV);
var jx = "isJson";
function Bx(e) {
  return typeof e == "string" && WV(e);
}
function zV(e) {
  return Y({
    name: jx,
    validator: {
      validate: function(t, r) {
        return Bx(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be a json string";
      }, e)
    }
  }, e);
}
var ll = { exports: {} }, c5;
function Zx() {
  return c5 || (c5 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = o(/* @__PURE__ */ Q()), n = o(/* @__PURE__ */ f2());
    function o(d) {
      return d && d.__esModule ? d : { default: d };
    }
    function a(d) {
      (0, r.default)(d);
      var i = d.split("."), s = i.length;
      return s !== 3 ? !1 : i.reduce(function(u, c) {
        return u && (0, n.default)(c, {
          urlSafe: !0
        });
      }, !0);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(ll, ll.exports)), ll.exports;
}
var YV = /* @__PURE__ */ Zx();
const XV = /* @__PURE__ */ ve(YV);
var Ux = "isJwt";
function Gx(e) {
  return typeof e == "string" && XV(e);
}
function qV(e) {
  return Y({
    name: Ux,
    validator: {
      validate: function(t, r) {
        return Gx(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be a jwt string";
      }, e)
    }
  }, e);
}
var cl = { exports: {} }, f5;
function Vx() {
  return f5 || (f5 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ Q());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a) {
      return (0, r.default)(a), a === a.toLowerCase();
    }
    e.exports = t.default, e.exports.default = t.default;
  }(cl, cl.exports)), cl.exports;
}
var JV = /* @__PURE__ */ Vx();
const QV = /* @__PURE__ */ ve(JV);
var Hx = "isLowercase";
function Kx(e) {
  return typeof e == "string" && QV(e);
}
function eH(e) {
  return Y({
    name: Hx,
    validator: {
      validate: function(t, r) {
        return Kx(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be a lowercase string";
      }, e)
    }
  }, e);
}
var ro = {}, p5;
function Wx() {
  if (p5) return ro;
  p5 = 1, Object.defineProperty(ro, "__esModule", {
    value: !0
  }), ro.default = n, ro.locales = void 0;
  var e = t(/* @__PURE__ */ Q());
  function t(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var r = {
    "am-AM": /^(\+?374|0)(33|4[134]|55|77|88|9[13-689])\d{6}$/,
    "ar-AE": /^((\+?971)|0)?5[024568]\d{7}$/,
    "ar-BH": /^(\+?973)?(3|6)\d{7}$/,
    "ar-DZ": /^(\+?213|0)(5|6|7)\d{8}$/,
    "ar-LB": /^(\+?961)?((3|81)\d{6}|7\d{7})$/,
    "ar-EG": /^((\+?20)|0)?1[0125]\d{8}$/,
    "ar-IQ": /^(\+?964|0)?7[0-9]\d{8}$/,
    "ar-JO": /^(\+?962|0)?7[789]\d{7}$/,
    "ar-KW": /^(\+?965)([569]\d{7}|41\d{6})$/,
    "ar-LY": /^((\+?218)|0)?(9[1-6]\d{7}|[1-8]\d{7,9})$/,
    "ar-MA": /^(?:(?:\+|00)212|0)[5-7]\d{8}$/,
    "ar-OM": /^((\+|00)968)?(9[1-9])\d{6}$/,
    "ar-PS": /^(\+?970|0)5[6|9](\d{7})$/,
    "ar-SA": /^(!?(\+?966)|0)?5\d{8}$/,
    "ar-SD": /^((\+?249)|0)?(9[012369]|1[012])\d{7}$/,
    "ar-SY": /^(!?(\+?963)|0)?9\d{8}$/,
    "ar-TN": /^(\+?216)?[2459]\d{7}$/,
    "az-AZ": /^(\+994|0)(10|5[015]|7[07]|99)\d{7}$/,
    "bs-BA": /^((((\+|00)3876)|06))((([0-3]|[5-6])\d{6})|(4\d{7}))$/,
    "be-BY": /^(\+?375)?(24|25|29|33|44)\d{7}$/,
    "bg-BG": /^(\+?359|0)?8[789]\d{7}$/,
    "bn-BD": /^(\+?880|0)1[13456789][0-9]{8}$/,
    "ca-AD": /^(\+376)?[346]\d{5}$/,
    "cs-CZ": /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
    "da-DK": /^(\+?45)?\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
    "de-DE": /^((\+49|0)1)(5[0-25-9]\d|6([23]|0\d?)|7([0-57-9]|6\d))\d{7,9}$/,
    "de-AT": /^(\+43|0)\d{1,4}\d{3,12}$/,
    "de-CH": /^(\+41|0)([1-9])\d{1,9}$/,
    "de-LU": /^(\+352)?((6\d1)\d{6})$/,
    "dv-MV": /^(\+?960)?(7[2-9]|9[1-9])\d{5}$/,
    "el-GR": /^(\+?30|0)?6(8[5-9]|9(?![26])[0-9])\d{7}$/,
    "el-CY": /^(\+?357?)?(9(9|6)\d{6})$/,
    "en-AI": /^(\+?1|0)264(?:2(35|92)|4(?:6[1-2]|76|97)|5(?:3[6-9]|8[1-4])|7(?:2(4|9)|72))\d{4}$/,
    "en-AU": /^(\+?61|0)4\d{8}$/,
    "en-AG": /^(?:\+1|1)268(?:464|7(?:1[3-9]|[28]\d|3[0246]|64|7[0-689]))\d{4}$/,
    "en-BM": /^(\+?1)?441(((3|7)\d{6}$)|(5[0-3][0-9]\d{4}$)|(59\d{5}$))/,
    "en-BS": /^(\+?1[-\s]?|0)?\(?242\)?[-\s]?\d{3}[-\s]?\d{4}$/,
    "en-GB": /^(\+?44|0)7[1-9]\d{8}$/,
    "en-GG": /^(\+?44|0)1481\d{6}$/,
    "en-GH": /^(\+233|0)(20|50|24|54|27|57|26|56|23|53|28|55|59)\d{7}$/,
    "en-GY": /^(\+592|0)6\d{6}$/,
    "en-HK": /^(\+?852[-\s]?)?[456789]\d{3}[-\s]?\d{4}$/,
    "en-MO": /^(\+?853[-\s]?)?[6]\d{3}[-\s]?\d{4}$/,
    "en-IE": /^(\+?353|0)8[356789]\d{7}$/,
    "en-IN": /^(\+?91|0)?[6789]\d{9}$/,
    "en-JM": /^(\+?876)?\d{7}$/,
    "en-KE": /^(\+?254|0)(7|1)\d{8}$/,
    "fr-CF": /^(\+?236| ?)(70|75|77|72|21|22)\d{6}$/,
    "en-SS": /^(\+?211|0)(9[1257])\d{7}$/,
    "en-KI": /^((\+686|686)?)?( )?((6|7)(2|3|8)[0-9]{6})$/,
    "en-KN": /^(?:\+1|1)869(?:46\d|48[89]|55[6-8]|66\d|76[02-7])\d{4}$/,
    "en-LS": /^(\+?266)(22|28|57|58|59|27|52)\d{6}$/,
    "en-MT": /^(\+?356|0)?(99|79|77|21|27|22|25)[0-9]{6}$/,
    "en-MU": /^(\+?230|0)?\d{8}$/,
    "en-MW": /^(\+?265|0)(((77|88|31|99|98|21)\d{7})|(((111)|1)\d{6})|(32000\d{4}))$/,
    "en-NA": /^(\+?264|0)(6|8)\d{7}$/,
    "en-NG": /^(\+?234|0)?[789]\d{9}$/,
    "en-NZ": /^(\+?64|0)[28]\d{7,9}$/,
    "en-PG": /^(\+?675|0)?(7\d|8[18])\d{6}$/,
    "en-PK": /^((00|\+)?92|0)3[0-6]\d{8}$/,
    "en-PH": /^(09|\+639)\d{9}$/,
    "en-RW": /^(\+?250|0)?[7]\d{8}$/,
    "en-SG": /^(\+65)?[3689]\d{7}$/,
    "en-SL": /^(\+?232|0)\d{8}$/,
    "en-TZ": /^(\+?255|0)?[67]\d{8}$/,
    "en-UG": /^(\+?256|0)?[7]\d{8}$/,
    "en-US": /^((\+1|1)?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/,
    "en-ZA": /^(\+?27|0)\d{9}$/,
    "en-ZM": /^(\+?26)?0[79][567]\d{7}$/,
    "en-ZW": /^(\+263)[0-9]{9}$/,
    "en-BW": /^(\+?267)?(7[1-8]{1})\d{6}$/,
    "es-AR": /^\+?549(11|[2368]\d)\d{8}$/,
    "es-BO": /^(\+?591)?(6|7)\d{7}$/,
    "es-CO": /^(\+?57)?3(0(0|1|2|4|5)|1\d|2[0-4]|5(0|1))\d{7}$/,
    "es-CL": /^(\+?56|0)[2-9]\d{1}\d{7}$/,
    "es-CR": /^(\+506)?[2-8]\d{7}$/,
    "es-CU": /^(\+53|0053)?5\d{7}$/,
    "es-DO": /^(\+?1)?8[024]9\d{7}$/,
    "es-HN": /^(\+?504)?[9|8|3|2]\d{7}$/,
    "es-EC": /^(\+?593|0)([2-7]|9[2-9])\d{7}$/,
    "es-ES": /^(\+?34)?[6|7]\d{8}$/,
    "es-GT": /^(\+?502)?[2|6|7]\d{7}$/,
    "es-PE": /^(\+?51)?9\d{8}$/,
    "es-MX": /^(\+?52)?(1|01)?\d{10,11}$/,
    "es-NI": /^(\+?505)\d{7,8}$/,
    "es-PA": /^(\+?507)\d{7,8}$/,
    "es-PY": /^(\+?595|0)9[9876]\d{7}$/,
    "es-SV": /^(\+?503)?[67]\d{7}$/,
    "es-UY": /^(\+598|0)9[1-9][\d]{6}$/,
    "es-VE": /^(\+?58)?(2|4)\d{9}$/,
    "et-EE": /^(\+?372)?\s?(5|8[1-4])\s?([0-9]\s?){6,7}$/,
    "fa-IR": /^(\+?98[\-\s]?|0)9[0-39]\d[\-\s]?\d{3}[\-\s]?\d{4}$/,
    "fi-FI": /^(\+?358|0)\s?(4[0-6]|50)\s?(\d\s?){4,8}$/,
    "fj-FJ": /^(\+?679)?\s?\d{3}\s?\d{4}$/,
    "fo-FO": /^(\+?298)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
    "fr-BF": /^(\+226|0)[67]\d{7}$/,
    "fr-BJ": /^(\+229)\d{8}$/,
    "fr-CD": /^(\+?243|0)?(8|9)\d{8}$/,
    "fr-CM": /^(\+?237)6[0-9]{8}$/,
    "fr-FR": /^(\+?33|0)[67]\d{8}$/,
    "fr-GF": /^(\+?594|0|00594)[67]\d{8}$/,
    "fr-GP": /^(\+?590|0|00590)[67]\d{8}$/,
    "fr-MQ": /^(\+?596|0|00596)[67]\d{8}$/,
    "fr-PF": /^(\+?689)?8[789]\d{6}$/,
    "fr-RE": /^(\+?262|0|00262)[67]\d{8}$/,
    "fr-WF": /^(\+681)?\d{6}$/,
    "he-IL": /^(\+972|0)([23489]|5[012345689]|77)[1-9]\d{6}$/,
    "hu-HU": /^(\+?36|06)(20|30|31|50|70)\d{7}$/,
    "id-ID": /^(\+?62|0)8(1[123456789]|2[1238]|3[1238]|5[12356789]|7[78]|9[56789]|8[123456789])([\s?|\d]{5,11})$/,
    "ir-IR": /^(\+98|0)?9\d{9}$/,
    "it-IT": /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
    "it-SM": /^((\+378)|(0549)|(\+390549)|(\+3780549))?6\d{5,9}$/,
    "ja-JP": /^(\+81[ \-]?(\(0\))?|0)[6789]0[ \-]?\d{4}[ \-]?\d{4}$/,
    "ka-GE": /^(\+?995)?(79\d{7}|5\d{8})$/,
    "kk-KZ": /^(\+?7|8)?7\d{9}$/,
    "kl-GL": /^(\+?299)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
    "ko-KR": /^((\+?82)[ \-]?)?0?1([0|1|6|7|8|9]{1})[ \-]?\d{3,4}[ \-]?\d{4}$/,
    "ky-KG": /^(\+996\s?)?(22[0-9]|50[0-9]|55[0-9]|70[0-9]|75[0-9]|77[0-9]|880|990|995|996|997|998)\s?\d{3}\s?\d{3}$/,
    "lt-LT": /^(\+370|8)\d{8}$/,
    "lv-LV": /^(\+?371)2\d{7}$/,
    "mg-MG": /^((\+?261|0)(2|3)\d)?\d{7}$/,
    "mn-MN": /^(\+|00|011)?976(77|81|88|91|94|95|96|99)\d{6}$/,
    "my-MM": /^(\+?959|09|9)(2[5-7]|3[1-2]|4[0-5]|6[6-9]|7[5-9]|9[6-9])[0-9]{7}$/,
    "ms-MY": /^(\+?60|0)1(([0145](-|\s)?\d{7,8})|([236-9](-|\s)?\d{7}))$/,
    "mz-MZ": /^(\+?258)?8[234567]\d{7}$/,
    "nb-NO": /^(\+?47)?[49]\d{7}$/,
    "ne-NP": /^(\+?977)?9[78]\d{8}$/,
    "nl-BE": /^(\+?32|0)4\d{8}$/,
    "nl-NL": /^(((\+|00)?31\(0\))|((\+|00)?31)|0)6{1}\d{8}$/,
    "nl-AW": /^(\+)?297(56|59|64|73|74|99)\d{5}$/,
    "nn-NO": /^(\+?47)?[49]\d{7}$/,
    "pl-PL": /^(\+?48)? ?([5-8]\d|45) ?\d{3} ?\d{2} ?\d{2}$/,
    "pt-BR": /^((\+?55\ ?[1-9]{2}\ ?)|(\+?55\ ?\([1-9]{2}\)\ ?)|(0[1-9]{2}\ ?)|(\([1-9]{2}\)\ ?)|([1-9]{2}\ ?))((\d{4}\-?\d{4})|(9[1-9]{1}\d{3}\-?\d{4}))$/,
    "pt-PT": /^(\+?351)?9[1236]\d{7}$/,
    "pt-AO": /^(\+244)\d{9}$/,
    "ro-MD": /^(\+?373|0)((6(0|1|2|6|7|8|9))|(7(6|7|8|9)))\d{6}$/,
    "ro-RO": /^(\+?40|0)\s?7\d{2}(\/|\s|\.|-)?\d{3}(\s|\.|-)?\d{3}$/,
    "ru-RU": /^(\+?7|8)?9\d{9}$/,
    "si-LK": /^(?:0|94|\+94)?(7(0|1|2|4|5|6|7|8)( |-)?)\d{7}$/,
    "sl-SI": /^(\+386\s?|0)(\d{1}\s?\d{3}\s?\d{2}\s?\d{2}|\d{2}\s?\d{3}\s?\d{3})$/,
    "sk-SK": /^(\+?421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
    "so-SO": /^(\+?252|0)((6[0-9])\d{7}|(7[1-9])\d{7})$/,
    "sq-AL": /^(\+355|0)6[2-9]\d{7}$/,
    "sr-RS": /^(\+3816|06)[- \d]{5,9}$/,
    "sv-SE": /^(\+?46|0)[\s\-]?7[\s\-]?[02369]([\s\-]?\d){7}$/,
    "tg-TJ": /^(\+?992)?[5][5]\d{7}$/,
    "th-TH": /^(\+66|66|0)\d{9}$/,
    "tr-TR": /^(\+?90|0)?5\d{9}$/,
    "tk-TM": /^(\+993|993|8)\d{8}$/,
    "uk-UA": /^(\+?38)?0(50|6[36-8]|7[357]|9[1-9])\d{7}$/,
    "uz-UZ": /^(\+?998)?(6[125-79]|7[1-69]|88|9\d)\d{7}$/,
    "vi-VN": /^((\+?84)|0)((3([2-9]))|(5([25689]))|(7([0|6-9]))|(8([1-9]))|(9([0-9])))([0-9]{7})$/,
    "zh-CN": /^((\+|00)86)?(1[3-9]|9[28])\d{9}$/,
    "zh-TW": /^(\+?886\-?|0)?9\d{8}$/,
    "dz-BT": /^(\+?975|0)?(17|16|77|02)\d{6}$/,
    "ar-YE": /^(((\+|00)9677|0?7)[0137]\d{7}|((\+|00)967|0)[1-7]\d{6})$/,
    "ar-EH": /^(\+?212|0)[\s\-]?(5288|5289)[\s\-]?\d{5}$/,
    "fa-AF": /^(\+93|0)?(2{1}[0-8]{1}|[3-5]{1}[0-4]{1})(\d{7})$/,
    "mk-MK": /^(\+?389|0)?((?:2[2-9]\d{6}|(?:3[1-4]|4[2-8])\d{6}|500\d{5}|5[2-9]\d{6}|7[0-9][2-9]\d{5}|8[1-9]\d{6}|800\d{5}|8009\d{4}))$/
  };
  r["en-CA"] = r["en-US"], r["fr-CA"] = r["en-CA"], r["fr-BE"] = r["nl-BE"], r["zh-HK"] = r["en-HK"], r["zh-MO"] = r["en-MO"], r["ga-IE"] = r["en-IE"], r["fr-CH"] = r["de-CH"], r["it-CH"] = r["fr-CH"];
  function n(o, a, d) {
    if ((0, e.default)(o), d && d.strictMode && !o.startsWith("+"))
      return !1;
    if (Array.isArray(a))
      return a.some(function(u) {
        if (r.hasOwnProperty(u)) {
          var c = r[u];
          if (c.test(o))
            return !0;
        }
        return !1;
      });
    if (a in r)
      return r[a].test(o);
    if (!a || a === "any") {
      for (var i in r)
        if (r.hasOwnProperty(i)) {
          var s = r[i];
          if (s.test(o))
            return !0;
        }
      return !1;
    }
    throw new Error("Invalid locale '".concat(a, "'"));
  }
  return ro.locales = Object.keys(r), ro;
}
var tH = /* @__PURE__ */ Wx();
const rH = /* @__PURE__ */ ve(tH);
var zx = "isMobilePhone";
function Yx(e, t, r) {
  return typeof e == "string" && rH(e, t, r);
}
function nH(e, t, r) {
  return Y({
    name: zx,
    constraints: [e, t],
    validator: {
      validate: function(n, o) {
        return Yx(n, o == null ? void 0 : o.constraints[0], o == null ? void 0 : o.constraints[1]);
      },
      defaultMessage: z(function(n) {
        return n + "$property must be a phone number";
      }, r)
    }
  }, r);
}
var no = {}, $5;
function b2() {
  if ($5) return no;
  $5 = 1, Object.defineProperty(no, "__esModule", {
    value: !0
  }), no.CountryCodes = void 0, no.default = n;
  var e = t(/* @__PURE__ */ Q());
  function t(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var r = /* @__PURE__ */ new Set(["AD", "AE", "AF", "AG", "AI", "AL", "AM", "AO", "AQ", "AR", "AS", "AT", "AU", "AW", "AX", "AZ", "BA", "BB", "BD", "BE", "BF", "BG", "BH", "BI", "BJ", "BL", "BM", "BN", "BO", "BQ", "BR", "BS", "BT", "BV", "BW", "BY", "BZ", "CA", "CC", "CD", "CF", "CG", "CH", "CI", "CK", "CL", "CM", "CN", "CO", "CR", "CU", "CV", "CW", "CX", "CY", "CZ", "DE", "DJ", "DK", "DM", "DO", "DZ", "EC", "EE", "EG", "EH", "ER", "ES", "ET", "FI", "FJ", "FK", "FM", "FO", "FR", "GA", "GB", "GD", "GE", "GF", "GG", "GH", "GI", "GL", "GM", "GN", "GP", "GQ", "GR", "GS", "GT", "GU", "GW", "GY", "HK", "HM", "HN", "HR", "HT", "HU", "ID", "IE", "IL", "IM", "IN", "IO", "IQ", "IR", "IS", "IT", "JE", "JM", "JO", "JP", "KE", "KG", "KH", "KI", "KM", "KN", "KP", "KR", "KW", "KY", "KZ", "LA", "LB", "LC", "LI", "LK", "LR", "LS", "LT", "LU", "LV", "LY", "MA", "MC", "MD", "ME", "MF", "MG", "MH", "MK", "ML", "MM", "MN", "MO", "MP", "MQ", "MR", "MS", "MT", "MU", "MV", "MW", "MX", "MY", "MZ", "NA", "NC", "NE", "NF", "NG", "NI", "NL", "NO", "NP", "NR", "NU", "NZ", "OM", "PA", "PE", "PF", "PG", "PH", "PK", "PL", "PM", "PN", "PR", "PS", "PT", "PW", "PY", "QA", "RE", "RO", "RS", "RU", "RW", "SA", "SB", "SC", "SD", "SE", "SG", "SH", "SI", "SJ", "SK", "SL", "SM", "SN", "SO", "SR", "SS", "ST", "SV", "SX", "SY", "SZ", "TC", "TD", "TF", "TG", "TH", "TJ", "TK", "TL", "TM", "TN", "TO", "TR", "TT", "TV", "TW", "TZ", "UA", "UG", "UM", "US", "UY", "UZ", "VA", "VC", "VE", "VG", "VI", "VN", "VU", "WF", "WS", "YE", "YT", "ZA", "ZM", "ZW"]);
  function n(o) {
    return (0, e.default)(o), r.has(o.toUpperCase());
  }
  return no.CountryCodes = r, no;
}
var oH = /* @__PURE__ */ b2();
const aH = /* @__PURE__ */ ve(oH);
var Xx = "isISO31661Alpha2";
function qx(e) {
  return typeof e == "string" && aH(e);
}
function dH(e) {
  return Y({
    name: Xx,
    validator: {
      validate: function(t, r) {
        return qx(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be a valid ISO31661 Alpha2 code";
      }, e)
    }
  }, e);
}
var fl = { exports: {} }, v5;
function Jx() {
  return v5 || (v5 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ Q());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /* @__PURE__ */ new Set(["AFG", "ALA", "ALB", "DZA", "ASM", "AND", "AGO", "AIA", "ATA", "ATG", "ARG", "ARM", "ABW", "AUS", "AUT", "AZE", "BHS", "BHR", "BGD", "BRB", "BLR", "BEL", "BLZ", "BEN", "BMU", "BTN", "BOL", "BES", "BIH", "BWA", "BVT", "BRA", "IOT", "BRN", "BGR", "BFA", "BDI", "KHM", "CMR", "CAN", "CPV", "CYM", "CAF", "TCD", "CHL", "CHN", "CXR", "CCK", "COL", "COM", "COG", "COD", "COK", "CRI", "CIV", "HRV", "CUB", "CUW", "CYP", "CZE", "DNK", "DJI", "DMA", "DOM", "ECU", "EGY", "SLV", "GNQ", "ERI", "EST", "ETH", "FLK", "FRO", "FJI", "FIN", "FRA", "GUF", "PYF", "ATF", "GAB", "GMB", "GEO", "DEU", "GHA", "GIB", "GRC", "GRL", "GRD", "GLP", "GUM", "GTM", "GGY", "GIN", "GNB", "GUY", "HTI", "HMD", "VAT", "HND", "HKG", "HUN", "ISL", "IND", "IDN", "IRN", "IRQ", "IRL", "IMN", "ISR", "ITA", "JAM", "JPN", "JEY", "JOR", "KAZ", "KEN", "KIR", "PRK", "KOR", "KWT", "KGZ", "LAO", "LVA", "LBN", "LSO", "LBR", "LBY", "LIE", "LTU", "LUX", "MAC", "MKD", "MDG", "MWI", "MYS", "MDV", "MLI", "MLT", "MHL", "MTQ", "MRT", "MUS", "MYT", "MEX", "FSM", "MDA", "MCO", "MNG", "MNE", "MSR", "MAR", "MOZ", "MMR", "NAM", "NRU", "NPL", "NLD", "NCL", "NZL", "NIC", "NER", "NGA", "NIU", "NFK", "MNP", "NOR", "OMN", "PAK", "PLW", "PSE", "PAN", "PNG", "PRY", "PER", "PHL", "PCN", "POL", "PRT", "PRI", "QAT", "REU", "ROU", "RUS", "RWA", "BLM", "SHN", "KNA", "LCA", "MAF", "SPM", "VCT", "WSM", "SMR", "STP", "SAU", "SEN", "SRB", "SYC", "SLE", "SGP", "SXM", "SVK", "SVN", "SLB", "SOM", "ZAF", "SGS", "SSD", "ESP", "LKA", "SDN", "SUR", "SJM", "SWZ", "SWE", "CHE", "SYR", "TWN", "TJK", "TZA", "THA", "TLS", "TGO", "TKL", "TON", "TTO", "TUN", "TUR", "TKM", "TCA", "TUV", "UGA", "UKR", "ARE", "GBR", "USA", "UMI", "URY", "UZB", "VUT", "VEN", "VNM", "VGB", "VIR", "WLF", "ESH", "YEM", "ZMB", "ZWE"]);
    function a(d) {
      return (0, r.default)(d), o.has(d.toUpperCase());
    }
    e.exports = t.default, e.exports.default = t.default;
  }(fl, fl.exports)), fl.exports;
}
var iH = /* @__PURE__ */ Jx();
const sH = /* @__PURE__ */ ve(iH);
var Qx = "isISO31661Alpha3";
function ew(e) {
  return typeof e == "string" && sH(e);
}
function uH(e) {
  return Y({
    name: Qx,
    validator: {
      validate: function(t, r) {
        return ew(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be a valid ISO31661 Alpha3 code";
      }, e)
    }
  }, e);
}
var pl = { exports: {} }, m5;
function tw() {
  return m5 || (m5 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = o(/* @__PURE__ */ Q()), n = o(/* @__PURE__ */ h2());
    function o(d) {
      return d && d.__esModule ? d : { default: d };
    }
    function a(d) {
      return (0, r.default)(d), (0, n.default)(d) && d.length === 24;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(pl, pl.exports)), pl.exports;
}
var lH = /* @__PURE__ */ tw();
const cH = /* @__PURE__ */ ve(lH);
var rw = "isMongoId";
function nw(e) {
  return typeof e == "string" && cH(e);
}
function fH(e) {
  return Y({
    name: rw,
    validator: {
      validate: function(t, r) {
        return nw(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be a mongodb id";
      }, e)
    }
  }, e);
}
var $l = { exports: {} }, h5;
function ow() {
  return h5 || (h5 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ Q());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /[^\x00-\x7F]/;
    function a(d) {
      return (0, r.default)(d), o.test(d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }($l, $l.exports)), $l.exports;
}
var pH = /* @__PURE__ */ ow();
const $H = /* @__PURE__ */ ve(pH);
var aw = "isMultibyte";
function dw(e) {
  return typeof e == "string" && $H(e);
}
function vH(e) {
  return Y({
    name: aw,
    validator: {
      validate: function(t, r) {
        return dw(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must contain one or more multibyte chars";
      }, e)
    }
  }, e);
}
var vl = { exports: {} }, g5;
function iw() {
  return g5 || (g5 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ Q());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;
    function a(d) {
      return (0, r.default)(d), o.test(d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(vl, vl.exports)), vl.exports;
}
var mH = /* @__PURE__ */ iw();
const hH = /* @__PURE__ */ ve(mH);
var sw = "isSurrogatePair";
function uw(e) {
  return typeof e == "string" && hH(e);
}
function gH(e) {
  return Y({
    name: sw,
    validator: {
      validate: function(t, r) {
        return uw(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must contain any surrogate pairs chars";
      }, e)
    }
  }, e);
}
var ml = { exports: {} }, y5;
function lw() {
  return y5 || (y5 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = $;
    var r = i(/* @__PURE__ */ Q()), n = i(/* @__PURE__ */ ax()), o = i(/* @__PURE__ */ yi()), a = i(/* @__PURE__ */ ka()), d = i(/* @__PURE__ */ ht());
    function i(v) {
      return v && v.__esModule ? v : { default: v };
    }
    function s(v, y) {
      return h(v) || p(v, y) || c(v, y) || u();
    }
    function u() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function c(v, y) {
      if (v) {
        if (typeof v == "string") return l(v, y);
        var S = {}.toString.call(v).slice(8, -1);
        return S === "Object" && v.constructor && (S = v.constructor.name), S === "Map" || S === "Set" ? Array.from(v) : S === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(S) ? l(v, y) : void 0;
      }
    }
    function l(v, y) {
      (y == null || y > v.length) && (y = v.length);
      for (var S = 0, w = Array(y); S < y; S++) w[S] = v[S];
      return w;
    }
    function p(v, y) {
      var S = v == null ? null : typeof Symbol < "u" && v[Symbol.iterator] || v["@@iterator"];
      if (S != null) {
        var w, _, I, N, O = [], E = !0, C = !1;
        try {
          if (I = (S = S.call(v)).next, y !== 0) for (; !(E = (w = I.call(S)).done) && (O.push(w.value), O.length !== y); E = !0) ;
        } catch (P) {
          C = !0, _ = P;
        } finally {
          try {
            if (!E && S.return != null && (N = S.return(), Object(N) !== N)) return;
          } finally {
            if (C) throw _;
          }
        }
        return O;
      }
    }
    function h(v) {
      if (Array.isArray(v)) return v;
    }
    var m = {
      protocols: ["http", "https", "ftp"],
      require_tld: !0,
      require_protocol: !1,
      require_host: !0,
      require_port: !1,
      require_valid_protocol: !0,
      allow_underscores: !1,
      allow_trailing_dot: !1,
      allow_protocol_relative_urls: !1,
      allow_fragments: !0,
      allow_query_components: !0,
      validate_length: !0,
      max_allowed_length: 2084
    }, f = /^\[([^\]]+)\](?::([0-9]+))?$/;
    function $(v, y) {
      if ((0, r.default)(v), !v || /[\s<>]/.test(v) || v.indexOf("mailto:") === 0 || (y = (0, d.default)(y, m), y.validate_length && v.length > y.max_allowed_length) || !y.allow_fragments && v.includes("#") || !y.allow_query_components && (v.includes("?") || v.includes("&")))
        return !1;
      var S, w, _, I, N, O, E, C;
      if (E = v.split("#"), v = E.shift(), E = v.split("?"), v = E.shift(), E = v.split("://"), E.length > 1) {
        if (S = E.shift().toLowerCase(), y.require_valid_protocol && y.protocols.indexOf(S) === -1)
          return !1;
      } else {
        if (y.require_protocol)
          return !1;
        if (v.slice(0, 2) === "//") {
          if (!y.allow_protocol_relative_urls)
            return !1;
          E[0] = v.slice(2);
        }
      }
      if (v = E.join("://"), v === "")
        return !1;
      if (E = v.split("/"), v = E.shift(), v === "" && !y.require_host)
        return !0;
      if (E = v.split("@"), E.length > 1) {
        if (y.disallow_auth || E[0] === "" || (w = E.shift(), w.indexOf(":") >= 0 && w.split(":").length > 2))
          return !1;
        var P = w.split(":"), T = s(P, 2), j = T[0], F = T[1];
        if (j === "" && F === "")
          return !1;
      }
      I = E.join("@"), O = null, C = null;
      var Z = I.match(f);
      if (Z ? (_ = "", C = Z[1], O = Z[2] || null) : (E = I.split(":"), _ = E.shift(), E.length && (O = E.join(":"))), O !== null && O.length > 0) {
        if (N = parseInt(O, 10), !/^[0-9]+$/.test(O) || N <= 0 || N > 65535)
          return !1;
      } else if (y.require_port)
        return !1;
      return y.host_whitelist ? (0, n.default)(_, y.host_whitelist) : _ === "" && !y.require_host ? !0 : !(!(0, a.default)(_) && !(0, o.default)(_, y) && (!C || !(0, a.default)(C, 6)) || (_ = _ || C, y.host_blacklist && (0, n.default)(_, y.host_blacklist)));
    }
    e.exports = t.default, e.exports.default = t.default;
  }(ml, ml.exports)), ml.exports;
}
var yH = /* @__PURE__ */ lw();
const bH = /* @__PURE__ */ ve(yH);
var cw = "isUrl";
function fw(e, t) {
  return typeof e == "string" && bH(e, t);
}
function xH(e, t) {
  return Y({
    name: cw,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return fw(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must be a URL address";
      }, t)
    }
  }, t);
}
var hl = { exports: {} }, b5;
function pw() {
  return b5 || (b5 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ Q());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = {
      1: /^[0-9A-F]{8}-[0-9A-F]{4}-1[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      2: /^[0-9A-F]{8}-[0-9A-F]{4}-2[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      6: /^[0-9A-F]{8}-[0-9A-F]{4}-6[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      7: /^[0-9A-F]{8}-[0-9A-F]{4}-7[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      8: /^[0-9A-F]{8}-[0-9A-F]{4}-8[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      nil: /^00000000-0000-0000-0000-000000000000$/i,
      max: /^ffffffff-ffff-ffff-ffff-ffffffffffff$/i,
      // From https://github.com/uuidjs/uuid/blob/main/src/regex.js
      all: /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i
    };
    function a(d, i) {
      return (0, r.default)(d), i == null && (i = "all"), i in o ? o[i].test(d) : !1;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(hl, hl.exports)), hl.exports;
}
var wH = /* @__PURE__ */ pw();
const AH = /* @__PURE__ */ ve(wH);
var $w = "isUuid";
function vw(e, t) {
  return typeof e == "string" && AH(e, t);
}
function SH(e, t) {
  return Y({
    name: $w,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return vw(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must be a UUID";
      }, t)
    }
  }, t);
}
var mw = "IsFirebasePushId";
function hw(e) {
  var t = /^[a-zA-Z0-9_-]*$/;
  return typeof e == "string" && e.length === 20 && t.test(e);
}
function _H(e) {
  return Y({
    name: mw,
    validator: {
      validate: function(t, r) {
        return hw(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be a Firebase Push Id";
      }, e)
    }
  }, e);
}
var gl = { exports: {} }, x5;
function gw() {
  return x5 || (x5 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ Q());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a) {
      return (0, r.default)(a), a === a.toUpperCase();
    }
    e.exports = t.default, e.exports.default = t.default;
  }(gl, gl.exports)), gl.exports;
}
var EH = /* @__PURE__ */ gw();
const MH = /* @__PURE__ */ ve(EH);
var yw = "isUppercase";
function bw(e) {
  return typeof e == "string" && MH(e);
}
function CH(e) {
  return Y({
    name: yw,
    validator: {
      validate: function(t, r) {
        return bw(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be uppercase";
      }, e)
    }
  }, e);
}
var yl = { exports: {} }, w5;
function xw() {
  return w5 || (w5 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ Q());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    function o(d) {
      "@babel/helpers - typeof";
      return o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
        return typeof i;
      } : function(i) {
        return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
      }, o(d);
    }
    function a(d, i) {
      (0, r.default)(d);
      var s, u;
      o(i) === "object" ? (s = i.min || 0, u = i.max) : (s = arguments[1] || 0, u = arguments[2]);
      var c = d.match(/(\uFE0F|\uFE0E)/g) || [], l = d.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [], p = d.length - c.length - l.length, h = p >= s && (typeof u > "u" || p <= u);
      return h && Array.isArray(i == null ? void 0 : i.discreteLengths) ? i.discreteLengths.some(function(m) {
        return m === p;
      }) : h;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(yl, yl.exports)), yl.exports;
}
var OH = /* @__PURE__ */ xw();
const x2 = /* @__PURE__ */ ve(OH);
var ww = "isLength";
function Aw(e, t, r) {
  return typeof e == "string" && x2(e, { min: t, max: r });
}
function NH(e, t, r) {
  return Y({
    name: ww,
    constraints: [e, t],
    validator: {
      validate: function(n, o) {
        return Aw(n, o == null ? void 0 : o.constraints[0], o == null ? void 0 : o.constraints[1]);
      },
      defaultMessage: z(function(n, o) {
        var a = (o == null ? void 0 : o.constraints[0]) !== null && (o == null ? void 0 : o.constraints[0]) !== void 0, d = (o == null ? void 0 : o.constraints[1]) !== null && (o == null ? void 0 : o.constraints[1]) !== void 0;
        return a && (!o.value || o.value.length < (o == null ? void 0 : o.constraints[0])) ? n + "$property must be longer than or equal to $constraint1 characters" : d && o.value.length > (o == null ? void 0 : o.constraints[1]) ? n + "$property must be shorter than or equal to $constraint2 characters" : n + "$property must be longer than or equal to $constraint1 and shorter than or equal to $constraint2 characters";
      }, r)
    }
  }, r);
}
var Sw = "maxLength";
function _w(e, t) {
  return typeof e == "string" && x2(e, { min: 0, max: t });
}
function IH(e, t) {
  return Y({
    name: Sw,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return _w(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must be shorter than or equal to $constraint1 characters";
      }, t)
    }
  }, t);
}
var Ew = "minLength";
function Mw(e, t) {
  return typeof e == "string" && x2(e, { min: t });
}
function PH(e, t) {
  return Y({
    name: Ew,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Mw(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must be longer than or equal to $constraint1 characters";
      }, t)
    }
  }, t);
}
var bl = { exports: {} }, A5;
function Cw() {
  return A5 || (A5 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ Q());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a, d, i) {
      return (0, r.default)(a), Object.prototype.toString.call(d) !== "[object RegExp]" && (d = new RegExp(d, i)), !!a.match(d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(bl, bl.exports)), bl.exports;
}
var RH = /* @__PURE__ */ Cw();
const Ow = /* @__PURE__ */ ve(RH);
var Nw = "matches";
function Iw(e, t, r) {
  return typeof e == "string" && Ow(e, t, r);
}
function TH(e, t, r) {
  var n;
  return t && t instanceof Object && !r ? r = t : n = t, Y({
    name: Nw,
    constraints: [e, n],
    validator: {
      validate: function(o, a) {
        return Iw(o, a == null ? void 0 : a.constraints[0], a == null ? void 0 : a.constraints[1]);
      },
      defaultMessage: z(function(o, a) {
        return o + "$property must match $constraint1 regular expression";
      }, r)
    }
  }, r);
}
const DH = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6], 0, 0, 0, 0, 0, 0, 0, [["6[2-467]\\d{3}", [5]], ["4\\d{4}", [5]], 0, 0, 0, 0, ["(?:0[1-9]|[1589]\\d)\\d{4}", [6]]]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [["[78]\\d{5}", [6]], ["690\\d{6}|[356]\\d{5}", [6, 9]], ["180[02]\\d{4}", [8]], ["[19]\\d{5}", [6]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[2-4679][2-8]\\d{6}", [8]], ["5[024-68]\\d{7}", [9]], ["400\\d{6}|800\\d{2,9}"], ["900[02]\\d{5}", [9]], 0, 0, ["600[25]\\d{5}", [9]], 0, 0, ["700[05]\\d{5}", [9]]]], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}"], ["7\\d{8}"]]], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268", [["268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}"], ["268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, ["26840[69]\\d{4}"], ["26848[01]\\d{4}"]]], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264", [["264(?:292|4(?:6[12]|9[78]))\\d{4}"], ["264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, ["264724\\d{4}"]]], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}", [8]], ["6(?:[78][2-9]|9\\d)\\d{6}", [9]], ["800\\d{4}", [7]], ["900[1-9]\\d\\d", [6]], ["700[2-9]\\d{4}", [8]], 0, 0, 0, 0, ["808[1-9]\\d\\d", [6]]]], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}"], ["(?:33|4[1349]|55|77|88|9[13-9])\\d{6}"], ["800\\d{5}"], ["90[016]\\d{5}"], 0, 0, 0, 0, ["60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[0-2])\\d{4}"], ["80[1-4]\\d{5}"]]], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]], 0, 0, 0, 0, 0, 0, [["2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}"], ["9[1-79]\\d{7}"]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1", 0, 0, [["3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:657|9(?:54|66))|3(?:48[27]|7(?:55|77)|8(?:65|78)))[2-8]\\d{5}|(?:2(?:284|3(?:02|23)|477|622|920)|3(?:4(?:46|89|92)|541))[2-7]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[25][4-6]|3[3-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|1[2-7]|3[4-6]|5[3-6]|7[2-6]|8[3-68])))\\d{6}|(?:2(?:2(?:62|81)|320|9(?:42|83))|3(?:329|4(?:62|7[16])|5(?:43|64)|7(?:18|5[17])))[2-6]\\d{5}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|64)|5(?:25|37|4[47]|71)|7(?:35|72)|825))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[035-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[3-5]|8[26])|8(?:2[67]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}", [10]], ["93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:657|9(?:54|66))|3(?:48[27]|7(?:55|77)|8(?:65|78)))[2-8]\\d{5}|9(?:2(?:284|3(?:02|23)|477|622|920)|3(?:4(?:46|89|92)|541))[2-7]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[25][4-6]|3[3-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|1[2-7]|3[4-6]|5[3-6]|7[2-6]|8[3-68]))))\\d{6}|9(?:2(?:2(?:62|81)|320|9(?:42|83))|3(?:329|4(?:62|7[16])|5(?:43|64)|7(?:18|5[17])))[2-6]\\d{5}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|64)|5(?:25|37|4[47]|71)|7(?:35|72)|825))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[035-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[3-5]|8[26])|8(?:2[67]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}"], ["800\\d{7,8}"], ["60[04579]\\d{7}", [10]], 0, 0, ["810\\d{7}", [10]]]], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684", [["6846(?:22|33|44|55|77|88|9[19])\\d{4}"], ["684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]", "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1(?:11\\d|[2-9]\\d{3,11})|(?:316|463)\\d{3,10}|648[34]\\d{3,9}|(?:51|66|73)2\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-7]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}"], ["6(?:485|(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d)\\d{3,9}", [7, 8, 9, 10, 11, 12, 13]], ["800\\d{6,10}", [9, 10, 11, 12, 13]], ["(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}", [9, 10, 11, 12, 13]], 0, 0, 0, 0, ["5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}", [5, 6, 7, 8, 9, 10, 11, 12, 13]], ["8(?:10|2[018])\\d{6,10}|828\\d{5}", [8, 9, 10, 11, 12, 13]]]], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]], 0, 0, 0, 0, 0, 0, [["5(?:2\\d|8[1-9])\\d{4}"], ["(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}"], ["800\\d{4}"], ["900\\d{4}"], 0, 0, 0, 0, ["(?:28\\d|501)\\d{4}"]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", [["18[1-8]\\d{3,6}", [6, 7, 8, 9]], ["4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", [6, 7, 8, 9, 10]], ["800\\d{4,6}", [7, 8, 9]], ["[67]00\\d{5,6}", [8, 9]], 0, 0, ["20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}"]], "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}"], ["36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}"], ["88\\d{7}"], ["900200\\d{3}"]]], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}", [8]], ["6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}"], ["8[08]\\d{6}", [8]], ["9[0246]\\d{6}", [8]], 0, 0, ["703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}", [8]], 0, 0, ["8[12]\\d{6}", [8]]]], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246", [["246521[0369]\\d{3}|246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}"], ["246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["(?:246976|900[2-9]\\d\\d)\\d{4}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, ["246(?:292|367|4(?:1[7-9]|3[01]|4[47-9]|67)|7(?:1[2-9]|2\\d|3[016]|53))\\d{4}"], 0, ["24631\\d{5}"]]], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:[23]\\d|[45])\\d\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}"], ["(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}", [10]], ["80[03]\\d{7}", [10]], 0, 0, 0, 0, 0, ["96(?:0[469]|1[0-47]|3[389]|43|6[69]|7[78])\\d{6}", [10]]]], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0", 0, 0, 0, 0, 0, [["80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}", [8]], ["4[5-9]\\d{7}", [9]], ["800[1-9]\\d{4}", [8]], ["(?:70(?:2[0-57]|3[04-7]|44|6[04-69]|7[0579])|90\\d\\d)\\d{4}", [8]], 0, 0, ["78(?:0[578]|1[014-8]|2[25]|3[15-8]|48|5[05]|60|7[06-8]|9\\d)\\d{4}", [8]], 0, 0, ["7879\\d{4}", [8]]]], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]], 0, 0, 0, 0, 0, 0, [["2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}"], ["(?:0[1-7]|5[0-8]|[67]\\d)\\d{6}"]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}", [6, 7, 8]], ["(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}", [8, 9]], ["(?:00800\\d\\d|800)\\d{5}", [8, 12]], ["90\\d{6}", [8]], 0, 0, 0, 0, 0, ["700\\d{5}", [8]]]], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]], 0, 0, 0, 0, 0, 0, [["(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|55|7[7-9]|88)|9[69][69])|7(?:[07]\\d\\d|1(?:11|78)))\\d{4}"], ["(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-689])))\\d{4}"], ["8[02369]\\d{6}"], ["(?:87|9[0-8])\\d{6}"], 0, 0, 0, 0, 0, ["84\\d{6}"]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]], 0, 0, 0, 0, 0, 0, [["(?:22|31)\\d{6}"], ["(?:29|[67][125-9])\\d{6}"]]], BJ: ["229", "00", "(?:01\\d|[24-689])\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]], 0, 0, 0, 0, 0, 0, [["2090\\d{4}|(?:012\\d\\d|2(?:02|1[037]|2[45]|3[68]|4\\d))\\d{5}"], ["(?:01(?:2[5-9]|[4-69]\\d)|4[0-8]|[56]\\d|9[013-9])\\d{6}"], 0, 0, 0, 0, ["81\\d{6}", [8]], 0, ["857[58]\\d{4}", [8]]]], BL: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441", [["441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}"], ["441(?:[2378]\\d|5[0-39]|9[02])\\d{5}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]], 0, 0, 0, 0, 0, 0, [["22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}"], ["(?:22[89]|[78]\\d\\d)\\d{4}"], 0, 0, 0, 0, 0, 0, ["5[34]\\d{5}"]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?", 0, 0, 0, [["(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}", [8]], ["[67]\\d{7}", [8]], ["8001[07]\\d{4}", [9]], 0, 0, 0, 0, 0, ["50\\d{6}", [8]]]], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]", [["(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}"], ["(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}"]]], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2", 0, 0, [["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}", [10]], ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}", [10, 11]], ["800\\d{6,7}", [9, 10]], ["300\\d{6}|[59]00\\d{6,7}", [9, 10]], 0, 0, 0, 0, 0, ["(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370))\\d{4}|300\\d{5}", [8, 10]]]], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242", [["242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-5]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}"], ["242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|3[0-4]|[89]9))\\d{4}"], ["242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, ["242225\\d{4}"]]], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], 0, 0, 0, 0, 0, 0, [["(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}", [7]], ["(?:1[67]|77)\\d{6}", [8]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013]|81)|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[013467]))\\d{4}", [7]], ["(?:321|7[1-8]\\d)\\d{5}", [8]], ["(?:0800|800\\d)\\d{6}", [10]], ["90\\d{5}", [7]], 0, 0, 0, 0, ["79(?:1(?:[0-2]\\d|3[0-3])|2[0-7]\\d)\\d{3}", [8]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, [["(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}", [9]], ["(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}", [9]], ["800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}"], ["(?:810|902)\\d{7}", [10]], 0, 0, 0, 0, ["249\\d{6}", [9]]], "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}", [7]], ["6[0-35-7]\\d{5}", [7]], ["0800\\d{7}", [11]]]], CA: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:12|573)\\d\\d|276)\\d{5}|[1-6]\\d{6}"], ["88\\d{5}|(?:8[0-69]|9[017-9])\\d{7}", [7, 9]]]], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]], 0, 0, 0, 0, 0, 0, [["2[12]\\d{6}"], ["7[024-7]\\d{6}"], 0, ["8776\\d{4}"]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]], 0, 0, 0, 0, 0, 0, [["222[1-589]\\d{5}"], ["026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}"], 0, ["80[0-2]\\d{6}"]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}", [9]], ["(?:6[89]|7[235-9])\\d{7}", [9]], ["800\\d{6}", [9]], ["90[016]\\d{6}", [9]], ["878\\d{6}", [9]], ["860\\d{9}", [12]], ["5[18]\\d{7}", [9]], ["74[0248]\\d{6}", [9]], 0, ["84[0248]\\d{6}", [9]]]], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]], 0, 0, 0, 0, 0, 0, [["2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|2[245]|3[45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}"], ["0[157]\\d{8}"]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[13-7]|4[1-5])\\d{3}"], ["[578]\\d{4}"]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], 0, 0, 0, 0, 0, 0, [["2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}", [9]], ["", [9]], ["(?:123|8)00\\d{6}", [9, 11]], 0, 0, 0, 0, 0, ["44\\d{7}", [9]], ["600\\d{7,8}", [10, 11]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]], 0, 0, 0, 0, 0, 0, [["2(?:22|33)\\d{6}", [9]], ["(?:24[23]|6(?:[25-9]\\d|40))\\d{6}", [9]], ["88\\d{6,7}"]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, [["(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|2(?:[02-57-9]\\d{3}|1(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))|(?:41[03]|8078|9(?:78|94))\\d\\d)\\d{5}|(?:10|2[0-57-9])(?:1(?:00|23)\\d\\d|95\\d{3,4})|(?:41[03]|9(?:78|94))(?:100\\d\\d|95\\d{3,4})|8078123|(?:43[35]|754|851)\\d{7,8}|(?:43[35]|754|851)(?:1(?:00\\d|23)\\d|95\\d{3,4})|(?:3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[13-9]\\d{6}|2(?:[0-24-9]\\d{5}|3\\d(?:\\d{4})?))|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[24-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[13-9]\\d{5}|2(?:[0-24-9]\\d{4}|3\\d(?:\\d{3})?))|9(?:[0-46-9]\\d{5}|5\\d{3,5}))", [7, 8, 9, 10, 11]], ["1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}", [11]], ["(?:(?:10|21)8|8)00\\d{7}", [10, 12]], ["16[08]\\d{5}", [8]], 0, 0, 0, 0, 0, ["10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}", [7, 8, 9, 10, 11]]], "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?", 0, 0, 0, [["601055(?:[0-4]\\d|50)\\d\\d|6010(?:[0-4]\\d|5[0-4])\\d{4}|(?:46|60(?:[124-7][2-9]|8[1-9]))\\d{6}", [8, 10]], ["333301[0-5]\\d{3}|3333(?:00|2[5-9]|[3-9]\\d)\\d{4}|(?:3(?:24[1-9]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}", [10]], ["1800\\d{7}", [11]], ["(?:19(?:0[01]|4[78])|901)\\d{7}", [10, 11]]]], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))", 0, 0, 0, [["210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}", [8]], ["(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}", [8]], ["800\\d{7}", [10]], ["90[059]\\d{7}", [10]], 0, 0, 0, 0, ["(?:210[0-6]|4\\d{3}|5100)\\d{4}", [8]]]], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3[23]|4[89])\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}"], ["(?:5\\d|6[2-4])\\d{6}", [8]], ["800\\d{7}", [10]], 0, 0, 0, 0, 0, 0, ["807\\d{7}", [10]]]], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}"], ["(?:36|5[1-389]|9\\d)\\d{5}"], ["800\\d{4}"], 0, 0, 0, 0, 0, ["(?:3[3-5]|4[356])\\d{5}"]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]", [["9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}"], ["953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}"], 0, 0, 0, 0, 0, ["955\\d{5}", [8]], 0, ["60[0-2]\\d{4}", [7]]]], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]], 0, 0, 0, 0, 0, 0, [["2[2-6]\\d{6}"], ["9(?:10|[4-79]\\d)\\d{5}"], ["800\\d{5}"], ["90[09]\\d{5}"], ["700\\d{5}"], 0, ["(?:50|77)\\d{6}"], 0, 0, ["80[1-9]\\d{5}"]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}", [9]], ["(?:60[1-8]\\d|7(?:0(?:[2-5]\\d|60)|19[0-2]|[2379]\\d\\d))\\d{5}", [9]], ["800\\d{6}", [9]], ["9(?:0[05689]|76)\\d{6}", [9]], ["70[01]\\d{6}", [9]], ["9(?:3\\d{9}|6\\d{7,10})"], ["9(?:5\\d|7[2-4])\\d{6}", [9]], 0, ["9[17]0\\d{6}", [9]], ["8[134]\\d{7}", [9]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0", 0, 0, 0, 0, 0, [["32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}", [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]], ["1(?:(?:5(?:[0-25-9]\\d\\d|310)|76\\d\\d)\\d{6}|6[023]\\d{7,8})|17\\d{8}", [10, 11]], ["800\\d{7,12}", [10, 11, 12, 13, 14, 15]], ["(?:137[7-9]|900(?:[135]|9\\d))\\d{6}", [10, 11]], ["700\\d{8}", [11]], ["1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}", [12, 13]], ["18(?:1\\d{5,11}|[2-9]\\d{8})", [8, 9, 10, 11, 12, 13, 14]], ["16(?:4\\d{1,10}|[89]\\d{1,11})", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]], 0, ["180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}", [7, 8, 9, 10, 11, 12, 13, 14]]]], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]], 0, 0, 0, 0, 0, 0, [["2(?:1[2-5]|7[45])\\d{5}"], ["77\\d{6}"]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[0-59][1-9]|[6-8]\\d)|3(?:[0-3][1-9]|4[13]|5[1-58]|6[1347-9]|7\\d|8[1-8]|9[1-79])|4(?:[0-25][1-9]|[34][2-9]|6[13-579]|7[13579]|8[1-47]|9[127])|5(?:[0-36][1-9]|4[146-9]|5[3-57-9]|7[568]|8[1-358]|9[1-69])|6(?:[0135][1-9]|2[1-68]|4[2-8]|6[1689]|[78]\\d|9[15689])|7(?:[0-69][1-9]|7[3-9]|8[147])|8(?:[16-9][1-9]|2[1-58])|9(?:[1-47-9][1-9]|6\\d))\\d{5}"], ["(?:2[6-8]|37|6[78]|96)\\d{6}|(?:2[0-59]|3[0-689]|[457]\\d|6[0-69]|8[126-9]|9[1-47-9])[1-9]\\d{5}"], ["80\\d{6}"], ["90\\d{6}"]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767", [["767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}"], ["767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9", [["8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}"], ["8[024]9[2-9]\\d{6}"], ["8(?:00(?:14|[2-9]\\d)|(?:33|44|55|66|77|88)[2-9]\\d)\\d{5}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[013-689])\\d{6}"], ["(?:5(?:4[0-29]|5\\d|6[0-3])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}", [9]], ["800\\d{6}", [9]], ["80[3-689]1\\d{5}", [9]], 0, 0, 0, 0, ["98[23]\\d{6}", [9]], ["80[12]1\\d{5}", [9]]]], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["[2-7][2-7]\\d{6}", [8]], ["964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}", [9]], ["1800\\d{7}|1[78]00\\d{6}", [10, 11]], 0, 0, 0, 0, 0, ["[2-7]890\\d{4}", [8]]]], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}", [7]], ["(?:5\\d{5}|8(?:1(?:0(?:0(?:00|[178]\\d)|[3-9]\\d\\d)|(?:1(?:0[2-6]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:0(?:00|4\\d)|(?:19|[2-7]\\d)\\d)|(?:(?:[124-69]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}", [7, 8]], ["800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}"], ["(?:40\\d\\d|900)\\d{4}", [7, 8]], ["70[0-2]\\d{5}", [8]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2\\d|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}", [8, 9]], ["1[0-25]\\d{8}", [10]], ["800\\d{7}", [10]], ["900\\d{7}", [10]]]], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]", [["528[89]\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-5]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}"], ["(?:17[1-3]|7\\d\\d)\\d{4}"]]], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]], 0, 0, 0, 0, 0, 0, [["96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}"], ["(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}"], ["[89]00\\d{6}"], ["80[367]\\d{6}"], ["70\\d{7}"], 0, ["51\\d{7}"], 0, 0, ["90[12]\\d{6}"]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8]|7\\d)|5(?:1[578]|44|5[0-4])|6(?:1[578]|2[69]|39|4[5-7]|5[0-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}"], ["700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|22|77|86|99)|9\\d\\d)\\d{6}"]]], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", [["1[3-7][1-8]\\d{3,6}|(?:19[1-8]|[23568][1-8]\\d|9(?:00|[1-8]\\d))\\d{2,6}", [5, 6, 7, 8, 9]], ["4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", [6, 7, 8, 9, 10]], ["800\\d{4,6}", [7, 8, 9]], ["[67]00\\d{5,6}", [8, 9]], 0, 0, ["20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}"]], "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, [["603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}", [7]], ["(?:[279]\\d|45|5[01568]|8[034679])\\d{5}", [7]], ["0800\\d{7}", [11]]], "00"], FK: ["500", "00", "[2-7]\\d{4}", [5], 0, 0, 0, 0, 0, 0, 0, [["[2-47]\\d{4}"], ["[56]\\d{4}"]]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]], 0, 0, 0, 0, 0, 0, [["31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}"], ["31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}"]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))", 0, 0, 0, [["(?:20|[34]\\d|8[19])\\d{4}"], ["(?:[27][1-9]|5\\d|9[16])\\d{4}"], ["80[257-9]\\d{3}"], ["90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d"], 0, 0, 0, 0, ["(?:6[0-36]|88)\\d{4}"]]], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:26[013-9]|59[1-35-9])\\d{6}|(?:[13]\\d|2[0-57-9]|4[1-9]|5[0-8])\\d{7}"], ["(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}"], ["80[0-5]\\d{6}"], ["836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}"], 0, 0, ["80[6-9]\\d{6}"], 0, ["9\\d{8}"], ["8(?:1[01]|2[0156]|4[024]|84)\\d{6}"]]], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1", 0, 0, [["[01]1\\d{6}", [8]], ["(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}"]]], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473", [["473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-4]|5[59]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}"], ["473(?:4(?:0[2-79]|1[04-9]|2[0-5]|49|5[6-8])|5(?:2[01]|3[3-8])|901)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}"], ["5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|5(?:0(?:0[17]0|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}|(?:5(?:0(?:0(?:0\\d|11|22|3[0-6]|44|5[05]|77|88|9[09])|(?:[14]\\d|77)\\d|22[02])|1(?:1(?:[03][01]|[124]\\d|5[2-6]|7[0-4])|4\\d\\d)|[23]555|4(?:4\\d\\d|555)|5(?:[0157-9]\\d\\d|200|333|444)|6[89]\\d\\d|7(?:[0147-9]\\d\\d|5(?:00|[57]5))|8(?:0(?:[018]\\d|2[0-4])|5(?:55|8[89])|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}"], ["800\\d{6}"], 0, 0, 0, 0, 0, ["70[67]\\d{6}"]]], GF: ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["594(?:[02-49]\\d|1[0-5]|5[6-9]|6[0-3]|80)\\d{4}"], ["(?:694(?:[0-249]\\d|3[0-8])|7093[0-3])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:396|76\\d)\\d|476[0-6])\\d{4}"]]], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}", [9]], ["(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}", [9]], ["800\\d{5}", [8]]]], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]], 0, 0, 0, 0, 0, 0, [["2190[0-2]\\d{3}|2(?:0(?:[02]\\d|3[01])|16[24-9]|2[2-5]\\d)\\d{4}"], ["5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}"]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:19|3[1-7]|[68][1-9]|70|9\\d)\\d{4}"], ["[245]\\d{5}"], ["80\\d{4}"], 0, 0, 0, 0, 0, ["3[89]\\d{4}"]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}"], ["(?:[23679]\\d|4[015]|5[0-489])\\d{5}"]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]], 0, 0, 0, 0, 0, 0, [["3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}", [8]], ["6[0-356]\\d{7}", [9]], 0, 0, 0, 0, 0, 0, ["722\\d{6}", [9]]]], GP: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}"], ["(?:222|55\\d)\\d{6}"], ["80\\d[1-9]\\d{5}"], ["90\\d[1-9]\\d{5}"]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}", [10]], ["68[57-9]\\d{7}|(?:69|94)\\d{8}", [10]], ["800\\d{7,9}"], ["90[19]\\d{7}", [10]], ["70\\d{8}", [10]], 0, ["5005000\\d{3}", [10]], 0, 0, ["8(?:0[16]|12|[27]5|50)\\d{7}", [10]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [["[267][2-9]\\d{6}", [8]], ["(?:[3-5]\\d\\d|80[0-4])\\d{5}", [8]], ["18[01]\\d{8}", [11]], ["19\\d{9}", [11]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671", [["671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[478])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]], 0, 0, 0, 0, 0, 0, [["443\\d{6}", [9]], ["9(?:5\\d|6[569]|77)\\d{6}", [9]], 0, 0, 0, 0, 0, 0, ["40\\d{5}", [7]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|50[0-6]|77[1-57])\\d{4}"], ["(?:510|6\\d\\d|7(?:[0-5]\\d|6[01]))\\d{4}"], ["(?:289|8(?:00|6[28]|88|99))\\d{4}"], ["9008\\d{3}"], 0, 0, 0, 0, ["515\\d{4}"]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:4[0-8]|[579]\\d|6[0-2]))|58(?:0[1-9]|1[2-9]))\\d{4}", [8]], ["(?:4(?:44[0-35-9]|6(?:1[0-79]|4[0-57-9]|6[0-4])|7(?:[26][0-5]|4[0-28]))|5(?:73[0-6]|95[0-8])|6(?:26[013-8]|66[0-3]|78[0-5])|70(?:7[1-8]|8[0-4])|84(?:4[0-2]|8[0-35-9])|9(?:29[013-9]|39[014-9]|59[0-4]|899))\\d{4}|(?:4(?:4[0-35-9]|6[02357-9]|7[015])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|70[1-59]|84[0-39]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}", [8]], ["800\\d{6}", [9]], ["900(?:[0-24-9]\\d{7}|3\\d{1,4})", [5, 6, 7, 8, 11]], ["8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}", [8]], 0, ["30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}", [8]], ["7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}", [8]]], "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2(?:0[0-59]|1[1-9]|[23]\\d|4[02-7]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[578]|2[3-59]|3[13-9]|4[0-68]|5[1-3589])|5(?:0[2357-9]|1[1-356]|4[03-5]|5\\d|6[014-69]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[047]|4[0-378]|[78][0-8]|9[01])|7(?:0[5-79]|6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}", [8]], ["[37-9]\\d{7}", [8]], ["8002\\d{7}", [11]]]], HR: ["385", "00", "[2-69]\\d{8}|80\\d{5,7}|[1-79]\\d{7}|6\\d{6}", [7, 8, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}", [8, 9]], ["9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|55|77|9[5-79])))\\d{4}|98\\d{6}", [8, 9]], ["80\\d{5,7}"], ["6[01459]\\d{6}|6[01]\\d{5}", [7, 8]], ["7[45]\\d{6}", [8]], 0, ["62\\d{6,7}|72\\d{6}", [8, 9]]]], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2\\d|5[1-5]|81|9[149])\\d{5}"], ["(?:[34]\\d|55)\\d{6}"], ["8\\d{7}"], 0, 0, 0, 0, 0, ["9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}"]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06", 0, 0, 0, 0, 0, [["(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}", [8]], ["(?:[257]0|3[01])\\d{7}", [9]], ["(?:[48]0\\d|680[29])\\d{5}"], ["9[01]\\d{6}", [8]], 0, 0, ["38\\d{7}", [9]], 0, ["21\\d{7}", [9]]]], ID: ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}", [7, 8, 9, 10, 11]], ["8[1-35-9]\\d{7,10}", [9, 10, 11, 12]], ["00(?:1803\\d{5,11}|7803\\d{7})|(?:177\\d|800)\\d{5,7}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17]], ["809\\d{7}", [10]], 0, 0, ["(?:1500|8071\\d{3})\\d{3}", [7, 10]], 0, 0, ["804\\d{7}", [10]]]], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}"], ["8(?:22|[35-9]\\d)\\d{6}", [9]], ["1800\\d{6}", [10]], ["15(?:1[2-8]|[2-8]0|9[089])\\d{6}", [10]], ["700\\d{6}", [9]], ["88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}", [10]], ["818\\d{6}", [9]], 0, ["76\\d{7}", [9]], ["18[59]0\\d{6}", [10]]]], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0", 0, 0, 0, 0, 0, [["153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}", [8, 11, 12]], ["55(?:4(?:[01]0|5[0-2])|57[0-289])\\d{4}|5(?:(?:[0-2][02-9]|[36]\\d|[49][2-9]|8[3-7])\\d|5(?:01|2\\d|3[0-3]|4[34]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}", [9]], ["1(?:255|80[019]\\d{3})\\d{3}", [7, 10]], ["1212\\d{4}|1(?:200|9(?:0[0-2]|19))\\d{6}", [8, 10]], 0, ["151\\d{8,9}", [11, 12]], ["1599\\d{6}", [10]], 0, ["7(?:38(?:0\\d|5[0-3569]|88)|8(?:33|55|77|81)\\d)\\d{4}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}", [9]], ["1700\\d{6}", [10]]]], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24", [["1624(?:230|[5-8]\\d\\d)\\d{3}"], ["76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}"], ["808162\\d{4}"], ["8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}"], ["70\\d{8}"], 0, ["3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}"], 0, ["56\\d{8}"]]], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0", 0, 0, 0, 0, 0, [["2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}", [10]], ["(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}", [10]], ["000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))"], ["186[12]\\d{9}", [13]], 0, 0, ["140\\d{7}", [10]], 0, 0, ["1860\\d{7}", [11]]]], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]], 0, 0, 0, 0, 0, 0, [["37\\d{5}"], ["38\\d{5}"]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}", [8, 9]], ["7[3-9]\\d{8}", [10]]]], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|(?:12\\d|30[0-2])\\d|2(?:121|[2689]0\\d)|4(?:111|40\\d))\\d{4}", [6, 7, 10]], ["9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:[0-46]\\d\\d|5[15]0|8(?:[12]\\d|88)|9(?:0[0-3]|[19]\\d|21|69|77|8[7-9])))\\d{5}", [10]], 0, 0, 0, 0, ["96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])", [4, 5]]]], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}", [7]], ["(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}"], ["80[0-8]\\d{4}", [7]], ["90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}", [7]], 0, ["(?:689|8(?:7[18]|80)|95[48])\\d{4}", [7]], ["809\\d{4}", [7]], 0, ["49[0-24-79]\\d{4}", [7]]], "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}", [6, 7, 8, 9, 10, 11]], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876", [["8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0235-9]|[23]\\d|40|5[06]|6[2-589]|7[0-25-9]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}"], ["(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}", [8]], ["7(?:[78][0-25-9]|9\\d)\\d{6}", [9]], ["80\\d{6}", [8]], ["9\\d{7}", [8]], ["70\\d{7}", [9]], 0, ["8(?:10|8\\d)\\d{5}", [8]], ["74(?:66|77)\\d{5}", [9]], 0, ["85\\d{6}", [8]]]], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1", 0, 0, [["(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}", [9]], ["[7-9]0[1-9]\\d{7}", [10]], ["00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}"], ["990\\d{6}", [9]], ["60\\d{7}", [9]], 0, ["570\\d{6}", [9]], ["20\\d{8}", [10]], ["50[1-9]\\d{7}", [10]]]], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}", [7, 8, 9]], ["(?:1(?:0[0-8]|1[0-7]|2[014]|30)|7\\d\\d)\\d{6}", [9]], ["800[02-8]\\d{5,6}", [9, 10]], ["900[02-9]\\d{5}", [9]]]], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}", [9]], ["312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}", [9]], ["800\\d{6,7}"]]], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})", [8, 9]], ["(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}", [8, 9]], ["1800(?:1\\d|2[019])\\d{4}", [10]], ["1900(?:1\\d|2[09])\\d{4}", [10]]]], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0", 0, 0, 0, 0, 0, [["(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}"], ["(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}", [8]], 0, 0, 0, 0, 0, 0, ["30(?:0[01]\\d\\d|12(?:11|20))\\d\\d", [8]]]], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]], 0, 0, 0, 0, 0, 0, [["7[4-7]\\d{5}"], ["[34]\\d{6}"], 0, ["8\\d{6}"]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869", [["869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}"], ["869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}"], ["19[1-3]\\d{7}", [10]]]], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?", 0, 0, 0, [["(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}", [5, 6, 8, 9, 10]], ["1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}", [9, 10]], ["00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|[38]0)\\d{7}", [9, 11, 12, 13, 14]], ["60[2-9]\\d{6}", [9]], ["50\\d{8,9}", [10, 11]], 0, ["1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[0168]|88)|8(?:00|33|55|77|99))\\d{4}", [8]], ["15\\d{7,8}", [9, 10]], ["70\\d{8}", [10]]]], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]], 0, 0, 0, 0, 0, 0, [["2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}", [8]], ["(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|6[16])|2[26]2|3[36]3|4[46]4|7(?:0[013-9]|[67]\\d)|8[68]8|9(?:[069]\\d|3[039]))|9(?:(?:[04679]\\d|8[057-9])\\d|1(?:1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}", [8]], ["18\\d{5}", [7]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345", [["345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|4[89]|88)|9(?:14|4[035-9]))\\d{4}"], ["345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["(?:345976|900[2-9]\\d\\d)\\d{4}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", [["(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9]|97)|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]|59))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}", [10]], ["7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}", [10]], ["8(?:00|108\\d{3})\\d{7}"], ["809\\d{7}", [10]], ["808\\d{7}", [10]], 0, 0, 0, ["751\\d{7}", [10]]], "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[0135-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[13]|[35-7][14]|41|8[1468])\\d{6}", [8]], ["208[78]\\d{6}|(?:20[23579]|30[24])\\d{7}", [10]], 0, 0, 0, 0, ["30[0135-9]\\d{6}", [9]]]], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0", 0, 0, 0, 0, 0, [["7(?:62|8[0-7]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}"], ["793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}"], 0, ["9[01]\\d{6}", [8]], 0, 0, 0, 0, 0, ["80\\d{6}", [8]]]], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758", [["758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}"], ["758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0", 0, 0, 0, [["(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}", [7]], ["(?:6(?:(?:4[5-9]|5[0-469])\\d|6(?:[024-6]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}"], ["8002[28]\\d\\d|80(?:05\\d|9)\\d{4}"], ["90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d", [7]], 0, ["697(?:42|56|[78]\\d)\\d{4}", [9]], ["870(?:28|87)\\d\\d", [7]]]], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}"], ["7(?:[0-25-8]\\d|4[0-4])\\d{6}"], 0, 0, 0, 0, ["1973\\d{5}"]]], LR: ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2\\d{7}", [8]], ["(?:(?:(?:22|33)0|555|(?:77|88)\\d)\\d|4(?:240|[67]))\\d{5}|[56]\\d{6}", [7, 9]], 0, ["332(?:02|[34]\\d)\\d{4}", [9]]]], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]], 0, 0, 0, 0, 0, 0, [["2\\d{7}"], ["[56]\\d{7}"], ["800[1256]\\d{4}"]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]", 0, 0, 0, [["(?:3[1478]|4[124-6]|52)\\d{6}"], ["6\\d{7}"], ["80[02]\\d{5}"], ["9(?:0[0239]|10)\\d{5}"], ["70[05]\\d{5}"], 0, ["70[67]\\d{5}"], 0, ["[89]01\\d{5}"], ["808\\d{5}"]]], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)", 0, 0, 0, [["(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}"], ["6(?:[269][18]|5[1568]|7[189]|81)\\d{6}", [9]], ["800\\d{5}", [8]], ["90[015]\\d{5}", [8]], 0, 0, 0, 0, ["20(?:1\\d{5}|[2-689]\\d{1,7})", [4, 5, 6, 7, 8, 9, 10]], ["801\\d{5}", [8]]]], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]], 0, 0, 0, 0, 0, 0, [["6\\d{7}"], ["2333[0-8]\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[02-9]|3[0-24-9]))\\d{4}"], ["80\\d{6}"], ["90\\d{6}"], 0, 0, 0, 0, 0, ["81\\d{6}"]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}"], ["9[1-6]\\d{7}"]]], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-5]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:870|9[2-47-9]\\d)\\d{5}", [8]], ["4(?:[469]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}"], ["(?:800|90\\d)\\d{5}", [8]]]], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}"], ["562\\d{5}|(?:6\\d|7[16-9])\\d{6}"], ["800\\d{5}"], ["90[056]\\d{5}"], 0, 0, ["803\\d{5}"], 0, ["3[08]\\d{6}"], ["808\\d{5}"]]], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}", [8]], ["6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}", [8]], ["80(?:[0-2578]|9\\d)\\d{5}"], ["9(?:4[1568]|5[178])\\d{5}", [8]], 0, 0, ["77[1-9]\\d{5}", [8]], 0, ["78[1-49]\\d{5}", [8]]]], MF: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1", 0, 0, [["2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[356]|8[268]|9[2457])\\d{5}"], ["3[2-47-9]\\d{7}"], 0, 0, 0, 0, 0, 0, ["22\\d{7}"]]], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1", 0, 0, 0, 0, 0, [["(?:247|528|625)\\d{4}"], ["(?:(?:23|54)5|329|45[35-8])\\d{4}"], 0, 0, 0, 0, 0, 0, ["635\\d{4}"]]], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[0-3]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}"], ["7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-478]\\d|6[01])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}"], ["800\\d{5}"], ["5\\d{7}"], 0, 0, 0, 0, 0, ["8(?:0[1-9]|[1-9]\\d)\\d{5}"]]], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-59]))\\d{5}"], ["2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[2-59])\\d{6}"], ["80\\d{6}"]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:(?:12|[28]\\d|3[56]|7[3-6]|9[0-6])\\d|4(?:2[29]|7[0-2]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|22|7[0-2]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[013])|3(?:20\\d|4(?:70|83)|56)|420\\d|5(?:2\\d|470))|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|2472|3(?:20\\d|470)|4(?:2[04]\\d|472)|7(?:3\\d\\d|4[67]0|8(?:[01459]\\d|8))))\\d{4}|5(?:2(?:2\\d{5,6}|47[02]\\d{4})|(?:3472|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[01])|8(?:20\\d|47[02])|9(?:20\\d|470))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:(?:2\\d|51)\\d|4(?:[1-35-9]\\d|4[0-57-9]))|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|(?:[35]2|64)\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}", [6, 7, 8, 9]], ["(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}", [7, 8, 9, 10]], ["80080(?:0[1-9]|2\\d)\\d{3}", [10]], 0, 0, 0, 0, 0, ["1333\\d{4}", [8]]]], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[12]2[1-3]\\d{5,6}|(?:(?:[12](?:1|27)|5[368])\\d\\d|7(?:0(?:[0-5]\\d|7[078]|80)|128))\\d{4}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}"], ["(?:83[01]|92[039])\\d{5}|(?:5[05]|6[069]|72|8[015689]|9[013-9])\\d{6}", [8]], 0, 0, 0, 0, 0, 0, ["712[0-79]\\d{4}|7(?:1[013-9]|[5-9]\\d)\\d{5}", [8]]]], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]], 0, 0, 0, 0, 0, 0, [["(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}", [8]], ["6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}", [8]], ["0800\\d{3}", [7]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670", [["670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], MQ: ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:596(?:[03-7]\\d|1[05]|2[7-9]|8[0-39]|9[04-9])|80[6-9]\\d\\d|9(?:477[6-9]|767[4589]))\\d{4}"], ["(?:69[67]\\d\\d|7091[0-3])\\d{4}"], ["80[0-5]\\d{6}"], ["8[129]\\d{7}"], 0, 0, 0, 0, ["9(?:397[0-3]|477[0-5]|76(?:6\\d|7[0-367]))\\d{4}"]]], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]], 0, 0, 0, 0, 0, 0, [["(?:25[08]|35\\d|45[1-7])\\d{5}"], ["[2-4][0-46-9]\\d{6}"], ["800\\d{5}"]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664", [["6644(?:1[0-3]|91)\\d{4}"], ["664(?:3(?:49|9[1-6])|49[2-6])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]], 0, 0, 0, 0, 0, 0, [["20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}"], ["(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}"], ["800(?:02|[3467]\\d)\\d{3}"], ["5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}"], 0, 0, ["501\\d{5}"], ["7117\\d{4}"], ["3550\\d{4}"]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[0346-8]\\d|1[0-7])|4(?:[013568]\\d|2[4-8]|71|90)|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}", [7, 8]], ["5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-4]|3[013]))\\d{5}", [8]], ["802\\d{7}|80[0-2]\\d{4}", [7, 10]], ["30\\d{5}", [7]], 0, 0, 0, 0, ["3(?:20|9\\d)\\d{4}", [7]]], "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["(?:3(?:0[0-4]|3[0-59])|6(?:[58][024689]|6[024-68]|7[02468]))\\d{4}", [7]], ["(?:46[46]|[79]\\d\\d)\\d{4}", [7]], ["800\\d{7}", [10]], ["900\\d{7}", [10]], 0, 0, ["4(?:0[01]|50)\\d{4}", [7]]], "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1[2-9]|2[12]\\d\\d)\\d{5}"], ["111\\d{6}|(?:31|77|[89][89])\\d{7}", [9]]]], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-36-9]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}"], ["(?:2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-36-9]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}"], ["8(?:00|88)\\d{7}"], ["900\\d{7}"], ["500\\d{7}"], 0, 0, 0, 0, ["300\\d{7}"]], "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["4270\\d{4}|(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}", [8, 9]], ["1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-7]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}", [9, 10]], ["1[378]00\\d{6}", [10]], ["1600\\d{6}", [10]], 0, 0, 0, 0, ["15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}", [10]]]], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}", [8]], ["8[2-79]\\d{7}", [9]], ["800\\d{6}", [9]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}"], ["(?:60|8[1245])\\d{7}", [9]], ["80\\d{7}", [9]], ["8701\\d{5}", [9]], 0, 0, 0, 0, ["8(?:3\\d\\d|86)\\d{5}"]]], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}"], ["(?:[579]\\d|8[0-79])\\d{4}"], ["050\\d{3}"], ["36\\d{4}"]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]], 0, 0, 0, 0, 0, 0, [["2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}"], ["(?:23|7[0467]|[89]\\d)\\d{6}"], ["08\\d{6}"], ["09\\d{6}"]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1", 0, 0, [["(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}"], ["(?:14|3[58])\\d{4}"]]], NG: ["234", "009", "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}", [8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["3"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:20(?:[1259]\\d|3[013-9]|4[1-8]|6[024-689]|7[1-79]|8[2-9])|38)\\d{6}", [8, 10]], ["(?:702[0-24-9]|819[01])\\d{6}|(?:7(?:0[13-9]|[12]\\d)|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-6]))\\d{7}", [10]], ["800\\d{7,11}", [10, 11, 12, 13, 14]], 0, 0, 0, ["700\\d{7,11}", [10, 11, 12, 13, 14]]]], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]], 0, 0, 0, 0, 0, 0, [["2\\d{7}"], ["(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}"], ["1800\\d{4}"]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}", [9]], ["(?:6[1-58]|970\\d)\\d{7}", [9, 11]], ["800\\d{4,7}", [7, 8, 9, 10]], ["90[069]\\d{4,7}", [7, 8, 9, 10]], 0, 0, ["140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d", [5, 6, 9]], ["66\\d{7}", [9]], ["(?:85|91)\\d{7}", [9]]]], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]", [["(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}", [8]], ["(?:4[015-8]|9\\d)\\d{6}", [8]], ["80[01]\\d{5}", [8]], ["82[09]\\d{5}", [8]], ["880\\d{5}", [8]], ["81[23]\\d{5}", [8]], ["(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}"], 0, ["85[0-5]\\d{5}", [8]], ["810(?:0[0-6]|[2-8]\\d)\\d{3}", [8]]]], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}", [8]], ["9(?:00|6[0-3]|7[024-6]|8[0-24-68])\\d{7}", [10]], ["1(?:66001|800\\d\\d)\\d{5}", [11]]]], NR: ["674", "00", "(?:222|444|(?:55|8\\d)\\d|666|777|999)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[24-9]"]]], 0, 0, 0, 0, 0, 0, [["444\\d{4}"], ["(?:222|55[3-9]|666|777|8\\d\\d|999)\\d{4}"]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, [["[47]\\d{3}", [4]], ["(?:[56]|888[1-9])\\d{3}"]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["240\\d{5}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}", [8]], ["2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}", [8, 9, 10]], ["508\\d{6,7}|80\\d{6,8}", [8, 9, 10]], ["(?:1[13-57-9]\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}", [7, 8, 9, 10]], ["70\\d{7}", [9]], 0, ["8(?:1[16-9]|22|3\\d|4[045]|5[459]|6[235-9]|7[0-3579]|90)\\d{2,7}"]], "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]], 0, 0, 0, 0, 0, 0, [["2[1-6]\\d{6}", [8]], ["(?:1505|90[1-9]\\d)\\d{4}|(?:7[126-9]|9[1-9])\\d{6}", [8]], ["8007\\d{4,5}|(?:500|800[05])\\d{4}"], ["900\\d{5}", [8]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[058]|7[0167]|8[2358]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[07-9]\\d|1[0-7]|2[0-5]|33|4[0-79]|5[0-35]|6[068])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[0156]|7[0-24-9]|8[5-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}", [7]], ["(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}", [7, 8]], ["800\\d{4,5}|(?:00800|800\\d)\\d{6}"], ["(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}", [7]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:(?:(?:4[34]|5[14])[0-8]|687)\\d|7(?:173|(?:3[0-8]|55)\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[0569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}", [8]], ["9\\d{8}", [9]], ["800\\d{5}", [8]], ["805\\d{5}", [8]], ["80[24]\\d{5}", [8]], 0, 0, 0, 0, ["801\\d{5}", [8]]], "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], 0, 0, 0, 0, 0, 0, [["4(?:0[4-689]|9[4-68])\\d{5}", [8]], ["8[7-9]\\d{6}", [8]], ["80[0-5]\\d{6}", [9]], 0, 0, 0, ["44\\d{4}", [6]], 0, ["499\\d{5}", [8]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, [["(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}", [7]], ["(?:7\\d|8[1-38])\\d{6}", [8]], ["180\\d{4}", [7]], 0, 0, 0, 0, ["27[01]\\d{4}", [7]], ["2(?:0[0-57]|7[568])\\d{4}", [7]]], "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}", [6, 8, 9, 10]], ["(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}", [10]], ["1800\\d{7,9}", [11, 12, 13]]]], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}", [9, 10]], ["3(?:[0-247]\\d|3[0-79]|55|64)\\d{7}", [10]], ["800\\d{5}(?:\\d{3})?", [8, 11]], ["900\\d{5}", [8]], ["122\\d{6}", [9]], 0, ["(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}", [11, 12]]]], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))", [7, 9]], ["2131[89]\\d{4}|21(?:1[013-5]|2\\d|3[2-9])\\d{5}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}", [9]], ["800\\d{6,7}", [9, 10]], ["70[01346-8]\\d{6}", [9]], 0, 0, ["804\\d{6}", [9]], ["64\\d{4,7}", [6, 7, 8, 9]], ["39\\d{7}", [9]], ["801\\d{6}", [9]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4[1-35-9]|5[0-47-9]|80[6-9]\\d\\d)\\d{4}"], ["(?:4[02-489]|5[02-9]|708(?:4[0-5]|5[0-6]))\\d{4}"], ["80[0-5]\\d{6}", [9]], ["8[129]\\d{7}", [9]]]], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939", [["(?:787|939)[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}", [8]], ["5[69]\\d{7}", [9]], ["1800\\d{6}", [10]], 0, 0, 0, 0, 0, 0, ["1700\\d{6}", [10]]]], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:[12]\\d|3[1-689]|4[1-59]|[57][1-9]|6[1-35689]|8[1-69]|9[1256])\\d{6}"], ["6(?:[06]92(?:30|9\\d)|[35]92(?:[049]\\d|3[034]))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}"], ["80[02]\\d{6}"], ["(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}"], ["884[0-4689]\\d{5}"], ["600\\d{6}|6[06]92(?:0\\d|3[349]|49)\\d{3}"], ["70(?:38[01]|596|(?:7\\d|8[17])\\d)\\d{4}"], ["6(?:222\\d|8988)\\d{4}"], ["30\\d{7}"], ["80(?:8\\d|9[1579])\\d{5}"]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}"], ["(?:(?:46|83)[0-5]|(?:6[2-4689]|78)0)\\d{4}|(?:45|77|88)\\d{5}"]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}", [7, 8, 9]], ["9(?:51|6[129]|7[1-6]|8[1-7]|9[1-5])\\d{6}", [9]], ["9800\\d{5,7}", [9, 10, 11]], 0, 0, 0, ["[2-9]0\\d{4,7}", [6, 7, 8, 9]], 0, ["8700[0-4]\\d{4}", [9]]]], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]], 0, 0, 0, 0, 0, 0, [["4(?:1111|2022)\\d{3}|4(?:[04]\\d\\d|14[0-6]|999)\\d{4}", [8]], ["[35-7]\\d{7}", [8]], ["800\\d{4}|(?:0080[01]|800)\\d{6}", [7, 9, 11]], 0, 0, 0, 0, ["2[16]\\d{5}", [7]]]], RE: ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[0-3]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d"], ["(?:630|702)0\\d{5}|(?:6(?:00|2\\d)|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-39]))\\d{6}", [9]], ["800\\d{6}", [9]], ["90[0136]\\d{6}", [9]], 0, 0, ["(?:37\\d|80[578])\\d{6}", [9]], 0, 0, ["801\\d{6}", [9]]], 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}", [7, 8, 9, 10, 11, 12]], ["6(?:[0-689]|7\\d)\\d{6,7}", [8, 9, 10]], ["800\\d{3,9}"], ["(?:78\\d|90[0169])\\d{3,7}", [6, 7, 8, 9, 10]], 0, 0, ["7[06]\\d{4,10}"]]], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", [["(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}", [10]], ["9\\d{9}", [10]], ["8(?:0[04]|108\\d{3})\\d{7}"], ["80[39]\\d{7}", [10]], ["808\\d{7}", [10]]], "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:06|2[23568]\\d)\\d{6}"], ["7[237-9]\\d{7}", [9]], ["800\\d{6}", [9]], ["900\\d{6}", [9]]]], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, 0, 0, 0, 0, [["1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}", [9]], ["579[01]\\d{5}|5(?:[013-689]\\d|7[0-8])\\d{6}", [9]], ["800\\d{7}", [10]], ["925\\d{6}", [9]], 0, 0, ["811\\d{7}", [10]], 0, 0, ["920\\d{6}", [9]]]], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]], 0, 0, 0, 0, 0, 0, [["(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}", [5]], ["48\\d{3}|(?:(?:6[89]|7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}"], ["1[38]\\d{3}", [5]], 0, 0, 0, 0, 0, ["5[12]\\d{3}", [5]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, [["4[2-46]\\d{5}"], ["2[125-8]\\d{5}"], ["800[08]\\d{3}"], ["85\\d{5}"], 0, 0, 0, 0, ["971\\d{4}|(?:64|95)\\d{5}"]], "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1(?:5\\d|8[35-7])\\d{6}"], ["(?:1[0-2]|9[0-3569])\\d{7}"]]], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0", 0, 0, 0, 0, 0, [["(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}", [7, 8, 9]], ["7[02369]\\d{7}", [9]], ["20\\d{4,7}", [6, 7, 8, 9]], ["649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}", [7, 8, 9, 10]], ["75[1-8]\\d{6}", [9]], ["(?:25[245]|67[3-68])\\d{9}", [12]], ["10[1-8]\\d{6}", [9]], ["74[02-9]\\d{6}", [9]], 0, ["77[0-7]\\d{6}", [9]]]], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [["662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}", [8]], ["896[0-8]\\d{4}|(?:8(?:0[1-9]|[1-8]\\d|9[0-5])|9[0-8]\\d)\\d{5}", [8]], ["(?:18|8)00\\d{7}", [10, 11]], ["1900\\d{7}", [11]], 0, 0, ["7000\\d{7}", [11]], 0, ["(?:3[12]\\d|666)\\d{5}", [8]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]", [["2(?:[0-57-9]\\d|6[4-9])\\d\\d"], ["[56]\\d{4}", [5]], 0, 0, 0, 0, 0, 0, ["262\\d\\d", [5]]]], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["(?:[1-357][2-8]|4[24-8])\\d{6}", [8]], ["65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}", [8]], ["80\\d{4,6}", [6, 7, 8]], ["89[1-3]\\d{2,5}|90\\d{4,6}"], 0, 0, 0, 0, ["(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}", [8]]], "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79", [["79\\d{6}", [8]], ["(?:4[015-8]|9\\d)\\d{6}", [8]], ["80[01]\\d{5}", [8]], ["82[09]\\d{5}", [8]], ["880\\d{5}", [8]], ["81[23]\\d{5}", [8]], ["(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}"], 0, ["85[0-5]\\d{5}", [8]], ["810(?:0[0-6]|[2-8]\\d)\\d{3}", [8]]]], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d"], ["909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}", [9]], ["800\\d{6}", [9]], ["9(?:00|[78]\\d)\\d{6}", [9]], 0, 0, ["96\\d{7}", [9]], ["9090\\d{3}", [7]], ["6(?:02|5[0-4]|9[0-6])\\d{6}", [9]], ["8[5-9]\\d{7}", [9]]]], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["22[2-4][2-9]\\d{4}"], ["(?:25|3[0-5]|66|7[1-9]|8[08]|9[09])\\d{6}"]]], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1", 0, 0, [["0549(?:8[0157-9]|9\\d)\\d{4}", [10]], ["6[16]\\d{6}", [8]], 0, ["7[178]\\d{6}", [8]], 0, 0, 0, 0, ["5[158]\\d{6}", [8]]]], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]], 0, 0, 0, 0, 0, 0, [["3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}"], ["7(?:(?:[06-8]\\d|[19]0|21)\\d|5(?:0[01]|[19]0|2[25]|3[356]|[4-7]\\d|8[35]))\\d{5}"], ["800\\d{6}"], ["88[4689]\\d{6}"], 0, 0, 0, 0, ["(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}"], ["81[02468]\\d{6}"]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], "0", 0, 0, 0, 0, 0, [["(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}", [6, 7]], ["(?:(?:15|(?:3[59]|4[89]|6\\d|7[679]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}", [7, 8, 9]]]], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]], 0, 0, 0, 0, 0, 0, [["(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}"], ["(?:7[124-7]|8[1-9])\\d{5}", [7]], 0, 0, 0, 0, 0, 0, ["56\\d{4}", [6]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1[89]\\d{7}"], ["(?:12|9[1257-9])\\d{7}"]]], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]], 0, 0, 0, 0, 0, 0, [["22\\d{5}"], ["900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}"]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["2(?:79(?:0[0347-9]|[1-9]\\d)|89(?:0[024589]|[1-9]\\d))\\d{3}|2(?:[1-69]\\d|[78][0-8])\\d{5}", [8]], ["[67]\\d{7}", [8]], ["800\\d{8}|80[01]\\d{4}", [7, 11]], ["900\\d{4}(?:\\d{4})?", [7, 11]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721", [["7215(?:4[2-8]|8[239]|9[056])\\d{4}"], ["7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], SY: ["963", "00", "[1-359]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-4]|5[1-3]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[59]"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}"], ["(?:50|9[1-689])\\d{7}", [9]]]], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]], 0, 0, 0, 0, 0, 0, [["[23][2-5]\\d{6}", [8]], ["7[6-9]\\d{6}", [8]], ["0800\\d{4}", [8]], ["900\\d{6}", [9]], 0, 0, 0, 0, ["70\\d{6}", [8]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8", [["8\\d{3}"]]], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649", [["649(?:266|712|9(?:4\\d|50))\\d{4}"], ["649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["649(?:71[01]|966)\\d{4}"]]], TD: ["235", "00|16", "(?:22|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], 0, 0, 0, 0, 0, 0, [["22(?:[37-9]0|5[0-5]|6[89])\\d{4}"], ["(?:[69]\\d|77|8[56])\\d{6}"]], "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}"], ["(?:7[0-29]|9[0-36-9])\\d{6}"]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}", [8]], ["67(?:1[0-8]|2[4-7])\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}", [9]], ["(?:001800\\d|1800)\\d{6}", [10, 13]], ["1900\\d{6}", [10]], 0, 0, 0, 0, ["6[08]\\d{7}", [9]]]], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}"], ["(?:33[03-9]|4(?:1[18]|4[02-479])|81[1-9])\\d{6}|(?:[09]\\d|1[0-27-9]|2[0-27]|[34]0|5[05]|7[01578]|8[078])\\d{7}"]], "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7], 0, 0, 0, 0, 0, 0, 0, [["(?:2[2-4]|[34]\\d)\\d{2,5}"], ["7[2-4]\\d{2,5}"]]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["(?:2[1-5]|3[1-9]|4[1-4])\\d{5}", [7]], ["7[2-8]\\d{6}", [8]], ["80\\d{5}", [7]], ["90\\d{5}", [7]], ["70\\d{5}", [7]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, [["(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}"], ["(?:6\\d|71)\\d{6}"]], "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]], 0, 0, 0, 0, 0, 0, [["81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}"], ["3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}"], ["8010\\d{4}"], ["88\\d{6}"], 0, 0, 0, 0, 0, ["8[12]10\\d{4}"]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}", [5]], ["(?:5(?:4[0-5]|5[4-6])|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}", [7]], ["0800\\d{3}", [7]], 0, 0, 0, 0, 0, ["55[0-37-9]\\d{4}", [7]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}", [10]], ["561(?:011|61\\d)\\d{4}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}", [10]], ["8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})", [10, 12, 13]], ["(?:8[89]8|900)\\d{7}", [10]], ["592(?:21[12]|461)\\d{4}", [10]], 0, ["444\\d{4}", [7]], ["512\\d{7}", [10]], ["850\\d{7}", [10]]]], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868", [["868(?:2(?:01|1[5-9]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}"], ["868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], ["868619\\d{4}"]]], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["2[02-9]\\d{3}", [5]], ["(?:7[01]\\d|90)\\d{4}", [6, 7]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}", [8, 9]], ["(?:40001[0-2]|9[0-8]\\d{4})\\d{3}", [9]], ["80[0-79]\\d{6}|800\\d{5}", [8, 9]], ["20(?:[013-9]\\d\\d|2)\\d{4}", [7, 9]], ["99\\d{7}", [9]], 0, ["50[0-46-9]\\d{6}", [9]], 0, ["7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}", [10, 11]]], 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2[2-8]\\d{7}"], ["(?:6[125-9]|7[13-9])\\d{7}"], ["80[08]\\d{6}"], ["90\\d{7}"], 0, 0, 0, 0, ["41\\d{7}"], ["8(?:40|6[01])\\d{6}"]]], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}", [9]], ["790\\d{6}|(?:39|50|6[36-8]|7[1-357]|9[1-9])\\d{7}", [9]], ["800[1-8]\\d{5,6}"], ["900[239]\\d{5,6}"], 0, 0, 0, 0, ["89[1-579]\\d{6}", [9]]], "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["20(?:(?:240|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|3[1-4]|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}"], ["72[48]0\\d{5}|7(?:[015-8]\\d|2[067]|36|4[0-8]|9[089])\\d{6}"], ["800[1-3]\\d{5}"], ["90[1-3]\\d{6}"]]], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-468]))\\d{4}|(?:2742|305[3-9]|472[247-9]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, [["(?:1(?:770|9(?:20|[89]7))|(?:2\\d|4[2-7])\\d\\d)\\d{4}", [8]], ["9[1-9]\\d{6}", [8]], ["0004\\d{2,9}|(?:405|80[05])\\d{4}"], ["90[0-8]\\d{4}", [7]]], "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:55\\d\\d|6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|[69]\\d\\d|7(?:[23]\\d|7[69]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|[168]\\d\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|9(?:22|5[1-9])))\\d{5}"], ["(?:(?:[25]0|33|8[78]|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079])))|7(?:[07]\\d{3}|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}"]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698", [["06698\\d{1,6}", [6, 7, 8, 9, 10, 11]], ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784", [["784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}"], ["784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["78451[0-2]\\d{4}"]]], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}"], ["4(?:1[24-8]|2[246])\\d{7}"], ["800\\d{7}"], ["90[01]\\d{7}"], 0, 0, ["501\\d{7}"]]], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284", [["284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}"], ["284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340", [["340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}", [10]], ["(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[1689]|7[06-9]|8[1-8]|9[0-8])\\d{7}", [9]], ["1800\\d{4,6}|12(?:0[13]|28)\\d{4}", [8, 9, 10]], ["1900\\d{4,6}", [8, 9, 10]], 0, 0, ["(?:[17]99|80\\d)\\d{4}|69\\d{5,6}", [7, 8]], 0, ["672\\d{6}", [9]]]], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}", [5]], ["(?:[58]\\d|7[013-7])\\d{5}", [7]], ["81[18]\\d\\d", [5]], 0, 0, 0, ["(?:3[03]|900\\d)\\d{3}"], 0, ["9(?:0[1-9]|1[01])\\d{4}", [7]]]], WF: ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], 0, 0, 0, 0, 0, 0, [["72\\d{4}", [6]], ["(?:72|8[23])\\d{4}", [6]], ["80[0-5]\\d{6}", [9]], 0, 0, ["[48]0\\d{4}", [6]], 0, 0, ["9[23]\\d{4}", [6]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}", [5, 6]], ["(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}", [7, 10]], ["800\\d{3}", [6]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0", 0, 0, 0, 0, 0, [["38\\d{6,10}|(?:2[89]|39)(?:0\\d{5,6}|[1-9]\\d{5})"], ["4[3-9]\\d{6}", [8]], ["800\\d{5}", [8]], ["900\\d{5}", [8]]]], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}", [7, 8]], ["7[01378]\\d{7}", [9]]]], YT: ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}", [9]], ["(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:50[0-2]|6\\d\\d|7(?:[0-46-9]\\d|5[0-4]))\\d\\d|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}", [5, 6, 7, 8, 9]], ["80\\d{7}", [9]], ["(?:86[2-9]|9[0-2]\\d)\\d{6}", [9]], 0, 0, ["861\\d{6,7}", [9, 10]], 0, ["87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}", [9]], ["860\\d{6}", [9]]]], ZM: ["260", "00", "800\\d{6}|(?:21|[579]\\d|63)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[579]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["21[1-8]\\d{6}"], ["(?:[59][5-8]|7[5-9])\\d{7}"], ["800\\d{6}"], 0, 0, 0, 0, 0, ["63\\d{7}"]]], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}"], ["7(?:[1278]\\d|3[1-9])\\d{6}", [9]], ["80(?:[01]\\d|20|8[0-8])\\d{3}", [7]], 0, 0, 0, 0, 0, ["86(?:1[12]|22|30|44|55|77|8[368])\\d{6}", [10]]]] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function LH(e, t) {
  var r = Array.prototype.slice.call(t);
  return r.push(DH), e.apply(this, r);
}
function S5(e, t) {
  e = e.split("-"), t = t.split("-");
  for (var r = e[0].split("."), n = t[0].split("."), o = 0; o < 3; o++) {
    var a = Number(r[o]), d = Number(n[o]);
    if (a > d) return 1;
    if (d > a) return -1;
    if (!isNaN(a) && isNaN(d)) return 1;
    if (isNaN(a) && !isNaN(d)) return -1;
  }
  return e[1] && t[1] ? e[1] > t[1] ? 1 : e[1] < t[1] ? -1 : 0 : !e[1] && t[1] ? 1 : e[1] && !t[1] ? -1 : 0;
}
var FH = {}.constructor;
function Ao(e) {
  return e != null && e.constructor === FH;
}
function n1(e) {
  "@babel/helpers - typeof";
  return n1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, n1(e);
}
function bi(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function kH(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function xi(e, t, r) {
  return t && kH(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var jH = "1.2.0", BH = "1.7.35", _5 = " ext. ", ZH = /^\d+$/, gt = /* @__PURE__ */ function() {
  function e(t) {
    bi(this, e), Pw(t), this.metadata = t, Rw.call(this, t);
  }
  return xi(e, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(t) {
        return t !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(t) {
      return this.metadata.countries[t];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(t) {
      return this.getCountryMetadata(t) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(t) {
      if (this.getCountryCodesForCallingCode(t))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[t])
          return !0;
      } else {
        var r = this.countryCallingCodes()[t];
        if (r && r.length === 1 && r[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(t) {
      return this.nonGeographic() ? !!this.nonGeographic()[t] : !this.getCountryCodesForCallingCode(t);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(t) {
      return this.selectNumberingPlan(t);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(t, r) {
      if (t && ZH.test(t) && (r = t, t = null), t && t !== "001") {
        if (!this.hasCountry(t))
          throw new Error("Unknown country: ".concat(t));
        this.numberingPlan = new E5(this.getCountryMetadata(t), this);
      } else if (r) {
        if (!this.hasCallingCode(r))
          throw new Error("Unknown calling code: ".concat(r));
        this.numberingPlan = new E5(this.getNumberingPlanMetadata(r), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(t) {
      var r = this.countryCallingCodes()[t];
      if (r)
        return r.length === 1 && r[0].length === 3 ? void 0 : r;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(t) {
      var r = this.getCountryCodesForCallingCode(t);
      if (r)
        return r[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(t) {
      var r = this.getCountryCodeForCallingCode(t);
      if (r)
        return this.getCountryMetadata(r);
      if (this.nonGeographic()) {
        var n = this.nonGeographic()[t];
        if (n)
          return n;
      } else {
        var o = this.countryCallingCodes()[t];
        if (o && o.length === 1 && o[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(t) {
      return this.numberingPlan.type(t);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(t) {
      return this.selectNumberingPlan(t);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), e;
}(), E5 = /* @__PURE__ */ function() {
  function e(t, r) {
    bi(this, e), this.globalMetadataObject = r, this.metadata = t, Rw.call(this, r.metadata);
  }
  return xi(e, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(t) {
      return t[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var t = this, r = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return r.map(function(n) {
        return new UH(n, t);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(t) {
      return t[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(t) {
      if (this.hasTypes() && M5(this.types(), t))
        return new VH(M5(this.types(), t), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? _5 : this.metadata[13] || _5;
    }
  }]), e;
}(), UH = /* @__PURE__ */ function() {
  function e(t, r) {
    bi(this, e), this._format = t, this.metadata = r;
  }
  return xi(e, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !GH.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), e;
}(), GH = /^\(?\$1\)?$/, VH = /* @__PURE__ */ function() {
  function e(t, r) {
    bi(this, e), this.type = t, this.metadata = r;
  }
  return xi(e, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), e;
}();
function M5(e, t) {
  switch (t) {
    case "FIXED_LINE":
      return e[0];
    case "MOBILE":
      return e[1];
    case "TOLL_FREE":
      return e[2];
    case "PREMIUM_RATE":
      return e[3];
    case "PERSONAL_NUMBER":
      return e[4];
    case "VOICEMAIL":
      return e[5];
    case "UAN":
      return e[6];
    case "PAGER":
      return e[7];
    case "VOIP":
      return e[8];
    case "SHARED_COST":
      return e[9];
  }
}
function Pw(e) {
  if (!e)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!Ao(e) || !Ao(e.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(Ao(e) ? "an object of shape: { " + Object.keys(e).join(", ") + " }" : "a " + HH(e) + ": " + e, "."));
}
var HH = function(e) {
  return n1(e);
};
function w2(e, t) {
  if (t = new gt(t), t.hasCountry(e))
    return t.country(e).countryCallingCode();
  throw new Error("Unknown country: ".concat(e));
}
function Rw(e) {
  var t = e.version;
  typeof t == "number" ? (this.v1 = t === 1, this.v2 = t === 2, this.v3 = t === 3, this.v4 = t === 4) : t ? S5(t, jH) === -1 ? this.v2 = !0 : S5(t, BH) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
function A2(e, t) {
  return KH(e, void 0, t);
}
function KH(e, t, r) {
  var n = r.type(t), o = n && n.possibleLengths() || r.possibleLengths();
  if (!o)
    return "IS_POSSIBLE";
  var a = e.length, d = o[0];
  return d === a ? "IS_POSSIBLE" : d > a ? "TOO_SHORT" : o[o.length - 1] < a ? "TOO_LONG" : o.indexOf(a, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function WH(e, t, r) {
  if (t === void 0 && (t = {}), r = new gt(r), t.v2) {
    if (!e.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    r.selectNumberingPlan(e.countryCallingCode);
  } else {
    if (!e.phone)
      return !1;
    if (e.country) {
      if (!r.hasCountry(e.country))
        throw new Error("Unknown country: ".concat(e.country));
      r.country(e.country);
    } else {
      if (!e.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      r.selectNumberingPlan(e.countryCallingCode);
    }
  }
  if (r.possibleLengths())
    return Tw(e.phone || e.nationalNumber, r);
  if (e.countryCallingCode && r.isNonGeographicCallingCode(e.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function Tw(e, t) {
  switch (A2(e, t)) {
    case "IS_POSSIBLE":
      return !0;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational
    default:
      return !1;
  }
}
function Mr(e, t) {
  return e = e || "", new RegExp("^(?:" + t + ")$").test(e);
}
function zH(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = YH(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function YH(e, t) {
  if (e) {
    if (typeof e == "string") return C5(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return C5(e, t);
  }
}
function C5(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var XH = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function S2(e, t, r) {
  if (t = t || {}, !(!e.country && !e.countryCallingCode)) {
    r = new gt(r), r.selectNumberingPlan(e.country, e.countryCallingCode);
    var n = t.v2 ? e.nationalNumber : e.phone;
    if (Mr(n, r.nationalNumberPattern())) {
      if (xl(n, "FIXED_LINE", r))
        return r.type("MOBILE") && r.type("MOBILE").pattern() === "" || !r.type("MOBILE") || xl(n, "MOBILE", r) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var o = zH(XH), a; !(a = o()).done; ) {
        var d = a.value;
        if (xl(n, d, r))
          return d;
      }
    }
  }
}
function xl(e, t, r) {
  return t = r.type(t), !t || !t.pattern() || t.possibleLengths() && t.possibleLengths().indexOf(e.length) < 0 ? !1 : Mr(e, t.pattern());
}
function qH(e, t, r) {
  if (t = t || {}, r = new gt(r), r.selectNumberingPlan(e.country, e.countryCallingCode), r.hasTypes())
    return S2(e, t, r.metadata) !== void 0;
  var n = t.v2 ? e.nationalNumber : e.phone;
  return Mr(n, r.nationalNumberPattern());
}
function JH(e, t, r) {
  var n = new gt(r), o = n.getCountryCodesForCallingCode(e);
  return o ? o.filter(function(a) {
    return QH(t, a, r);
  }) : [];
}
function QH(e, t, r) {
  var n = new gt(r);
  return n.selectNumberingPlan(t), n.numberingPlan.possibleLengths().indexOf(e.length) >= 0;
}
var _2 = 2, eK = 17, tK = 3, zt = "0-9０-９٠-٩۰-۹", rK = "-‐-―−ー－", nK = "／/", oK = "．.", aK = "  ­​⁠　", dK = "()（）［］\\[\\]", iK = "~⁓∼～", Bd = "".concat(rK).concat(nK).concat(oK).concat(aK).concat(dK).concat(iK), E2 = "+＋", sK = new RegExp("([" + zt + "])");
function uK(e, t, r, n) {
  if (t) {
    var o = new gt(n);
    o.selectNumberingPlan(t, r);
    var a = new RegExp(o.IDDPrefix());
    if (e.search(a) === 0) {
      e = e.slice(e.match(a)[0].length);
      var d = e.match(sK);
      if (!(d && d[1] != null && d[1].length > 0 && d[1] === "0"))
        return e;
    }
  }
}
function lK(e, t) {
  if (e && t.numberingPlan.nationalPrefixForParsing()) {
    var r = new RegExp("^(?:" + t.numberingPlan.nationalPrefixForParsing() + ")"), n = r.exec(e);
    if (n) {
      var o, a, d = n.length - 1, i = d > 0 && n[d];
      if (t.nationalPrefixTransformRule() && i)
        o = e.replace(r, t.nationalPrefixTransformRule()), d > 1 && (a = n[1]);
      else {
        var s = n[0];
        o = e.slice(s.length), i && (a = n[1]);
      }
      var u;
      if (i) {
        var c = e.indexOf(n[1]), l = e.slice(0, c);
        l === t.numberingPlan.nationalPrefix() && (u = t.numberingPlan.nationalPrefix());
      } else
        u = n[0];
      return {
        nationalNumber: o,
        nationalPrefix: u,
        carrierCode: a
      };
    }
  }
  return {
    nationalNumber: e
  };
}
function o1(e, t) {
  var r = lK(e, t), n = r.carrierCode, o = r.nationalNumber;
  if (o !== e) {
    if (!cK(e, o, t))
      return {
        nationalNumber: e
      };
    if (t.possibleLengths() && !fK(o, t))
      return {
        nationalNumber: e
      };
  }
  return {
    nationalNumber: o,
    carrierCode: n
  };
}
function cK(e, t, r) {
  return !(Mr(e, r.nationalNumberPattern()) && !Mr(t, r.nationalNumberPattern()));
}
function fK(e, t) {
  switch (A2(e, t)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function pK(e, t, r, n) {
  var o = t ? w2(t, n) : r;
  if (e.indexOf(o) === 0) {
    n = new gt(n), n.selectNumberingPlan(t, r);
    var a = e.slice(o.length), d = o1(a, n), i = d.nationalNumber, s = o1(e, n), u = s.nationalNumber;
    if (!Mr(u, n.nationalNumberPattern()) && Mr(i, n.nationalNumberPattern()) || A2(u, n) === "TOO_LONG")
      return {
        countryCallingCode: o,
        number: a
      };
  }
  return {
    number: e
  };
}
function Dw(e, t, r, n) {
  if (!e)
    return {};
  var o;
  if (e[0] !== "+") {
    var a = uK(e, t, r, n);
    if (a && a !== e)
      o = !0, e = "+" + a;
    else {
      if (t || r) {
        var d = pK(e, t, r, n), i = d.countryCallingCode, s = d.number;
        if (i)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: i,
            number: s
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: e
      };
    }
  }
  if (e[1] === "0")
    return {};
  n = new gt(n);
  for (var u = 2; u - 1 <= tK && u <= e.length; ) {
    var c = e.slice(1, u);
    if (n.hasCallingCode(c))
      return n.selectNumberingPlan(c), {
        countryCallingCodeSource: o ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: c,
        number: e.slice(u)
      };
    u++;
  }
  return {};
}
function $K(e) {
  return e.replace(new RegExp("[".concat(Bd, "]+"), "g"), " ").trim();
}
var vK = /(\$\d)/;
function mK(e, t, r) {
  var n = r.useInternationalFormat, o = r.withNationalPrefix, a = e.replace(new RegExp(t.pattern()), n ? t.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    o && t.nationalPrefixFormattingRule() ? t.format().replace(vK, t.nationalPrefixFormattingRule()) : t.format()
  ));
  return n ? $K(a) : a;
}
var hK = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function gK(e, t, r) {
  var n = new gt(r);
  if (n.selectNumberingPlan(e, t), n.defaultIDDPrefix())
    return n.defaultIDDPrefix();
  if (hK.test(n.IDDPrefix()))
    return n.IDDPrefix();
}
var yK = ";ext=", oo = function(e) {
  return "([".concat(zt, "]{1,").concat(e, "})");
};
function Lw(e) {
  var t = "20", r = "15", n = "9", o = "6", a = "[  \\t,]*", d = "[:\\.．]?[  \\t,-]*", i = "#?", s = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", u = "(?:[xｘ#＃~～]|int|ｉｎｔ)", c = "[- ]+", l = "[  \\t]*", p = "(?:,{2}|;)", h = yK + oo(t), m = a + s + d + oo(t) + i, f = a + u + d + oo(n) + i, $ = c + oo(o) + "#", v = l + p + d + oo(r) + i, y = l + "(?:,)+" + d + oo(n) + i;
  return h + "|" + m + "|" + f + "|" + $ + "|" + v + "|" + y;
}
var bK = "[" + zt + "]{" + _2 + "}", xK = "[" + E2 + "]{0,1}(?:[" + Bd + "]*[" + zt + "]){3,}[" + Bd + zt + "]*", wK = new RegExp("^[" + E2 + "]{0,1}(?:[" + Bd + "]*[" + zt + "]){1,2}$", "i"), AK = xK + // Phone number extensions
"(?:" + Lw() + ")?", SK = new RegExp(
  // Either a short two-digit-only phone number
  "^" + bK + "$|^" + AK + "$",
  "i"
);
function _K(e) {
  return e.length >= _2 && SK.test(e);
}
function EK(e) {
  return wK.test(e);
}
function MK(e) {
  var t = e.number, r = e.ext;
  if (!t)
    return "";
  if (t[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(t).concat(r ? ";ext=" + r : "");
}
function CK(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = OK(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function OK(e, t) {
  if (e) {
    if (typeof e == "string") return O5(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return O5(e, t);
  }
}
function O5(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function N5(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function I5(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? N5(Object(r), !0).forEach(function(n) {
      NK(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : N5(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function NK(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var P5 = {
  formatExtension: function(e, t, r) {
    return "".concat(e).concat(r.ext()).concat(t);
  }
};
function IK(e, t, r, n) {
  if (r ? r = I5(I5({}, P5), r) : r = P5, n = new gt(n), e.country && e.country !== "001") {
    if (!n.hasCountry(e.country))
      throw new Error("Unknown country: ".concat(e.country));
    n.country(e.country);
  } else if (e.countryCallingCode)
    n.selectNumberingPlan(e.countryCallingCode);
  else return e.phone || "";
  var o = n.countryCallingCode(), a = r.v2 ? e.nationalNumber : e.phone, d;
  switch (t) {
    case "NATIONAL":
      return a ? (d = Zd(a, e.carrierCode, "NATIONAL", n, r), wl(d, e.ext, n, r.formatExtension)) : "";
    case "INTERNATIONAL":
      return a ? (d = Zd(a, null, "INTERNATIONAL", n, r), d = "+".concat(o, " ").concat(d), wl(d, e.ext, n, r.formatExtension)) : "+".concat(o);
    case "E.164":
      return "+".concat(o).concat(a);
    case "RFC3966":
      return MK({
        number: "+".concat(o).concat(a),
        ext: e.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?
    case "IDD":
      if (!r.fromCountry)
        return;
      var i = RK(a, e.carrierCode, o, r.fromCountry, n);
      return wl(i, e.ext, n, r.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(t, '"'));
  }
}
function Zd(e, t, r, n, o) {
  var a = PK(n.formats(), e);
  return a ? mK(e, a, {
    useInternationalFormat: r === "INTERNATIONAL",
    withNationalPrefix: !(a.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && o && o.nationalPrefix === !1)
  }) : e;
}
function PK(e, t) {
  for (var r = CK(e), n; !(n = r()).done; ) {
    var o = n.value;
    if (o.leadingDigitsPatterns().length > 0) {
      var a = o.leadingDigitsPatterns()[o.leadingDigitsPatterns().length - 1];
      if (t.search(a) !== 0)
        continue;
    }
    if (Mr(t, o.pattern()))
      return o;
  }
}
function wl(e, t, r, n) {
  return t ? n(e, t, r) : e;
}
function RK(e, t, r, n, o) {
  var a = w2(n, o.metadata);
  if (a === r) {
    var d = Zd(e, t, "NATIONAL", o);
    return r === "1" ? r + " " + d : d;
  }
  var i = gK(n, void 0, o.metadata);
  if (i)
    return "".concat(i, " ").concat(r, " ").concat(Zd(e, null, "INTERNATIONAL", o));
}
function R5(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function T5(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? R5(Object(r), !0).forEach(function(n) {
      TK(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : R5(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function TK(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function DK(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function LK(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function FK(e, t, r) {
  return t && LK(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var kK = /* @__PURE__ */ function() {
  function e(t, r, n) {
    if (DK(this, e), !t)
      throw new TypeError("First argument is required");
    if (typeof t != "string")
      throw new TypeError("First argument must be a string");
    if (typeof t == "string") {
      if (t[0] === "+" && !r)
        throw new TypeError("`metadata` argument not passed");
      if (Ao(r) && Ao(r.countries)) {
        n = r;
        var o = t;
        if (!ZK.test(o))
          throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
        var a = Dw(o, void 0, void 0, n), d = a.countryCallingCode, i = a.number;
        if (r = i, t = d, !r)
          throw new Error("Invalid `number` argument passed: too short");
      }
    }
    if (!r)
      throw new TypeError("`nationalNumber` argument is required");
    if (typeof r != "string")
      throw new TypeError("`nationalNumber` argument must be a string");
    Pw(n);
    var s = BK(t, n), u = s.country, c = s.countryCallingCode;
    this.country = u, this.countryCallingCode = c, this.nationalNumber = r, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return n;
    };
  }
  return FK(e, [{
    key: "setExt",
    value: function(t) {
      this.ext = t;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : JH(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return WH(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return qH(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var t = new gt(this.getMetadata());
      return t.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(t) {
      return this.number === t.number && this.ext === t.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return S2(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(t, r) {
      return IK(this, t, r ? T5(T5({}, r), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(t) {
      return this.format("NATIONAL", t);
    }
  }, {
    key: "formatInternational",
    value: function(t) {
      return this.format("INTERNATIONAL", t);
    }
  }, {
    key: "getURI",
    value: function(t) {
      return this.format("RFC3966", t);
    }
  }]), e;
}(), jK = function(e) {
  return /^[A-Z]{2}$/.test(e);
};
function BK(e, t) {
  var r, n, o = new gt(t);
  return jK(e) ? (r = e, o.selectNumberingPlan(r), n = o.countryCallingCode()) : n = e, {
    country: r,
    countryCallingCode: n
  };
}
var ZK = /^\+\d+$/;
function a1(e) {
  "@babel/helpers - typeof";
  return a1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, a1(e);
}
function UK(e, t, r) {
  return Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function GK(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function VK(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && ma(e, t);
}
function HK(e) {
  var t = kw();
  return function() {
    var r = ha(e), n;
    if (t) {
      var o = ha(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else
      n = r.apply(this, arguments);
    return KK(this, n);
  };
}
function KK(e, t) {
  if (t && (a1(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Fw(e);
}
function Fw(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function d1(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return d1 = function(r) {
    if (r === null || !WK(r)) return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(r)) return t.get(r);
      t.set(r, n);
    }
    function n() {
      return Ed(r, arguments, ha(this).constructor);
    }
    return n.prototype = Object.create(r.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } }), ma(n, r);
  }, d1(e);
}
function Ed(e, t, r) {
  return kw() ? Ed = Reflect.construct : Ed = function(n, o, a) {
    var d = [null];
    d.push.apply(d, o);
    var i = Function.bind.apply(n, d), s = new i();
    return a && ma(s, a.prototype), s;
  }, Ed.apply(null, arguments);
}
function kw() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function WK(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function ma(e, t) {
  return ma = Object.setPrototypeOf || function(r, n) {
    return r.__proto__ = n, r;
  }, ma(e, t);
}
function ha(e) {
  return ha = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, ha(e);
}
var Lr = /* @__PURE__ */ function(e) {
  VK(r, e);
  var t = HK(r);
  function r(n) {
    var o;
    return GK(this, r), o = t.call(this, n), Object.setPrototypeOf(Fw(o), r.prototype), o.name = o.constructor.name, o;
  }
  return UK(r);
}(/* @__PURE__ */ d1(Error)), D5 = new RegExp("(?:" + Lw() + ")$", "i");
function zK(e) {
  var t = e.search(D5);
  if (t < 0)
    return {};
  for (var r = e.slice(0, t), n = e.match(D5), o = 1; o < n.length; ) {
    if (n[o])
      return {
        number: r,
        ext: n[o]
      };
    o++;
  }
}
var YK = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function XK(e) {
  return YK[e];
}
function qK(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = JK(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function JK(e, t) {
  if (e) {
    if (typeof e == "string") return L5(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return L5(e, t);
  }
}
function L5(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function F5(e) {
  for (var t = "", r = qK(e.split("")), n; !(n = r()).done; ) {
    var o = n.value;
    t += QK(o, t) || "";
  }
  return t;
}
function QK(e, t, r) {
  return e === "+" ? t ? void 0 : "+" : XK(e);
}
function eW(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = tW(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function tW(e, t) {
  if (e) {
    if (typeof e == "string") return k5(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return k5(e, t);
  }
}
function k5(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function rW(e, t) {
  var r = t.countries, n = t.metadata;
  n = new gt(n);
  for (var o = eW(r), a; !(a = o()).done; ) {
    var d = a.value;
    if (n.country(d), n.leadingDigits()) {
      if (e && e.search(n.leadingDigits()) === 0)
        return d;
    } else if (S2({
      phone: e,
      country: d
    }, void 0, n.metadata))
      return d;
  }
}
function nW(e, t) {
  var r = t.nationalNumber, n = t.metadata, o = n.getCountryCodesForCallingCode(e);
  if (o)
    return o.length === 1 ? o[0] : rW(r, {
      countries: o,
      metadata: n.metadata
    });
}
var jw = "+", oW = "[\\-\\.\\(\\)]?", j5 = "([" + zt + "]|" + oW + ")", aW = "^\\" + jw + j5 + "*[" + zt + "]" + j5 + "*$", dW = new RegExp(aW, "g"), i1 = zt, iW = "[" + i1 + "]+((\\-)*[" + i1 + "])*", sW = "a-zA-Z", uW = "[" + sW + "]+((\\-)*[" + i1 + "])*", lW = "^(" + iW + "\\.)*" + uW + "\\.?$", cW = new RegExp(lW, "g"), B5 = "tel:", s1 = ";phone-context=", fW = ";isub=";
function pW(e) {
  var t = e.indexOf(s1);
  if (t < 0)
    return null;
  var r = t + s1.length;
  if (r >= e.length)
    return "";
  var n = e.indexOf(";", r);
  return n >= 0 ? e.substring(r, n) : e.substring(r);
}
function $W(e) {
  return e === null ? !0 : e.length === 0 ? !1 : dW.test(e) || cW.test(e);
}
function vW(e, t) {
  var r = t.extractFormattedPhoneNumber, n = pW(e);
  if (!$W(n))
    throw new Lr("NOT_A_NUMBER");
  var o;
  if (n === null)
    o = r(e) || "";
  else {
    o = "", n.charAt(0) === jw && (o += n);
    var a = e.indexOf(B5), d;
    a >= 0 ? d = a + B5.length : d = 0;
    var i = e.indexOf(s1);
    o += e.substring(d, i);
  }
  var s = o.indexOf(fW);
  if (s > 0 && (o = o.substring(0, s)), o !== "")
    return o;
}
var mW = 250, hW = new RegExp("[" + E2 + zt + "]"), gW = new RegExp("[^" + zt + "#]+$");
function yW(e, t, r) {
  if (t = t || {}, r = new gt(r), t.defaultCountry && !r.hasCountry(t.defaultCountry))
    throw t.v2 ? new Lr("INVALID_COUNTRY") : new Error("Unknown country: ".concat(t.defaultCountry));
  var n = xW(e, t.v2, t.extract), o = n.number, a = n.ext, d = n.error;
  if (!o) {
    if (t.v2)
      throw d === "TOO_SHORT" ? new Lr("TOO_SHORT") : new Lr("NOT_A_NUMBER");
    return {};
  }
  var i = AW(o, t.defaultCountry, t.defaultCallingCode, r), s = i.country, u = i.nationalNumber, c = i.countryCallingCode, l = i.countryCallingCodeSource, p = i.carrierCode;
  if (!r.hasSelectedNumberingPlan()) {
    if (t.v2)
      throw new Lr("INVALID_COUNTRY");
    return {};
  }
  if (!u || u.length < _2) {
    if (t.v2)
      throw new Lr("TOO_SHORT");
    return {};
  }
  if (u.length > eK) {
    if (t.v2)
      throw new Lr("TOO_LONG");
    return {};
  }
  if (t.v2) {
    var h = new kK(c, u, r.metadata);
    return s && (h.country = s), p && (h.carrierCode = p), a && (h.ext = a), h.__countryCallingCodeSource = l, h;
  }
  var m = (t.extended ? r.hasSelectedNumberingPlan() : s) ? Mr(u, r.nationalNumberPattern()) : !1;
  return t.extended ? {
    country: s,
    countryCallingCode: c,
    carrierCode: p,
    valid: m,
    possible: m ? !0 : !!(t.extended === !0 && r.possibleLengths() && Tw(u, r)),
    phone: u,
    ext: a
  } : m ? wW(s, u, a) : {};
}
function bW(e, t, r) {
  if (e) {
    if (e.length > mW) {
      if (r)
        throw new Lr("TOO_LONG");
      return;
    }
    if (t === !1)
      return e;
    var n = e.search(hW);
    if (!(n < 0))
      return e.slice(n).replace(gW, "");
  }
}
function xW(e, t, r) {
  var n = vW(e, {
    extractFormattedPhoneNumber: function(a) {
      return bW(a, r, t);
    }
  });
  if (!n)
    return {};
  if (!_K(n))
    return EK(n) ? {
      error: "TOO_SHORT"
    } : {};
  var o = zK(n);
  return o.ext ? o : {
    number: n
  };
}
function wW(e, t, r) {
  var n = {
    country: e,
    phone: t
  };
  return r && (n.ext = r), n;
}
function AW(e, t, r, n) {
  var o = Dw(F5(e), t, r, n.metadata), a = o.countryCallingCodeSource, d = o.countryCallingCode, i = o.number, s;
  if (d)
    n.selectNumberingPlan(d);
  else if (i && (t || r))
    n.selectNumberingPlan(t, r), t && (s = t), d = r || w2(t, n.metadata);
  else return {};
  if (!i)
    return {
      countryCallingCodeSource: a,
      countryCallingCode: d
    };
  var u = o1(F5(i), n), c = u.nationalNumber, l = u.carrierCode, p = nW(d, {
    nationalNumber: c,
    metadata: n
  });
  return p && (s = p, p === "001" || n.country(s)), {
    country: s,
    countryCallingCode: d,
    countryCallingCodeSource: a,
    nationalNumber: c,
    carrierCode: l
  };
}
function Z5(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function U5(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Z5(Object(r), !0).forEach(function(n) {
      SW(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Z5(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function SW(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function _W(e, t, r) {
  return yW(e, U5(U5({}, t), {}, {
    v2: !0
  }), r);
}
function G5(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function EW(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? G5(Object(r), !0).forEach(function(n) {
      MW(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : G5(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function MW(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function CW(e, t) {
  return PW(e) || IW(e, t) || NW(e, t) || OW();
}
function OW() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function NW(e, t) {
  if (e) {
    if (typeof e == "string") return V5(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return V5(e, t);
  }
}
function V5(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function IW(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n = [], o = !0, a = !1, d, i;
    try {
      for (r = r.call(e); !(o = (d = r.next()).done) && (n.push(d.value), !(t && n.length === t)); o = !0)
        ;
    } catch (s) {
      a = !0, i = s;
    } finally {
      try {
        !o && r.return != null && r.return();
      } finally {
        if (a) throw i;
      }
    }
    return n;
  }
}
function PW(e) {
  if (Array.isArray(e)) return e;
}
function RW(e) {
  var t = Array.prototype.slice.call(e), r = CW(t, 4), n = r[0], o = r[1], a = r[2], d = r[3], i, s, u;
  if (typeof n == "string")
    i = n;
  else throw new TypeError("A text for parsing must be a string.");
  if (!o || typeof o == "string")
    d ? (s = a, u = d) : (s = void 0, u = a), o && (s = EW({
      defaultCountry: o
    }, s));
  else if (Ao(o))
    a ? (s = o, u = a) : u = o;
  else throw new Error("Invalid second argument: ".concat(o));
  return {
    text: i,
    options: s,
    metadata: u
  };
}
function TW() {
  var e = RW(arguments), t = e.text, r = e.options, n = e.metadata;
  return _W(t, r, n);
}
function DW() {
  return LH(TW, arguments);
}
var Bw = "isPhoneNumber";
function Zw(e, t) {
  if (typeof e != "string" || e.trim() !== e)
    return !1;
  try {
    var r = DW(e, t);
    return t && r.country !== t ? !1 : r.isValid();
  } catch {
    return !1;
  }
}
function LW(e, t) {
  return Y({
    name: Bw,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Zw(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must be a valid phone number";
      }, t)
    }
  }, t);
}
var Uw = "isMilitaryTime";
function Gw(e) {
  var t = /^([01]\d|2[0-3]):?([0-5]\d)$/;
  return typeof e == "string" && Ow(e, t);
}
function FW(e) {
  return Y({
    name: Uw,
    validator: {
      validate: function(t, r) {
        return Gw(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be a valid representation of military time in the format HH:MM";
      }, e)
    }
  }, e);
}
var Al = { exports: {} }, H5;
function Vw() {
  return H5 || (H5 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ Q());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = {
      md5: 32,
      md4: 32,
      sha1: 40,
      sha256: 64,
      sha384: 96,
      sha512: 128,
      ripemd128: 32,
      ripemd160: 40,
      tiger128: 32,
      tiger160: 40,
      tiger192: 48,
      crc32: 8,
      crc32b: 8
    };
    function a(d, i) {
      (0, r.default)(d);
      var s = new RegExp("^[a-fA-F0-9]{".concat(o[i], "}$"));
      return s.test(d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Al, Al.exports)), Al.exports;
}
var kW = /* @__PURE__ */ Vw();
const jW = /* @__PURE__ */ ve(kW);
var Hw = "isHash";
function Kw(e, t) {
  return typeof e == "string" && jW(e, t);
}
function BW(e, t) {
  return Y({
    name: Hw,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Kw(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must be a hash of type $constraint1";
      }, t)
    }
  }, t);
}
var Sl = { exports: {} }, K5;
function Ww() {
  return K5 || (K5 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ Q());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = "^\\d{4}-?\\d{3}[\\dX]$";
    function a(d) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      (0, r.default)(d);
      var s = o;
      if (s = i.require_hyphen ? s.replace("?", "") : s, s = i.case_sensitive ? new RegExp(s) : new RegExp(s, "i"), !s.test(d))
        return !1;
      for (var u = d.replace("-", "").toUpperCase(), c = 0, l = 0; l < u.length; l++) {
        var p = u[l];
        c += (p === "X" ? 10 : +p) * (8 - l);
      }
      return c % 11 === 0;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Sl, Sl.exports)), Sl.exports;
}
var ZW = /* @__PURE__ */ Ww();
const UW = /* @__PURE__ */ ve(ZW);
var zw = "isISSN";
function Yw(e, t) {
  return typeof e == "string" && UW(e, t);
}
function GW(e, t) {
  return Y({
    name: zw,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Yw(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must be a ISSN";
      }, t)
    }
  }, t);
}
var Xw = "isDateString";
function qw(e, t) {
  return y2(e, t);
}
function VW(e, t) {
  return Y({
    name: Xw,
    constraints: [e],
    validator: {
      validate: function(r) {
        return qw(r, e);
      },
      defaultMessage: z(function(r) {
        return r + "$property must be a valid ISO 8601 date string";
      }, t)
    }
  }, t);
}
var _l = { exports: {} }, W5;
function Jw() {
  return W5 || (W5 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var r = n(/* @__PURE__ */ Q());
    function n(s) {
      return s && s.__esModule ? s : { default: s };
    }
    var o = {
      loose: !1
    }, a = ["true", "false", "1", "0"], d = [].concat(a, ["yes", "no"]);
    function i(s) {
      var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : o;
      return (0, r.default)(s), u.loose ? d.includes(s.toLowerCase()) : a.includes(s);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(_l, _l.exports)), _l.exports;
}
var HW = /* @__PURE__ */ Jw();
const KW = /* @__PURE__ */ ve(HW);
var Qw = "isBooleanString";
function eA(e) {
  return typeof e == "string" && KW(e);
}
function WW(e) {
  return Y({
    name: Qw,
    validator: {
      validate: function(t, r) {
        return eA(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be a boolean string";
      }, e)
    }
  }, e);
}
var El = { exports: {} }, z5;
function tA() {
  return z5 || (z5 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = o(/* @__PURE__ */ Q()), n = /* @__PURE__ */ Fa();
    function o(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var a = /^[0-9]+$/;
    function d(i, s) {
      return (0, r.default)(i), s && s.no_symbols ? a.test(i) : new RegExp("^[+-]?([0-9]*[".concat((s || {}).locale ? n.decimal[s.locale] : ".", "])?[0-9]+$")).test(i);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(El, El.exports)), El.exports;
}
var zW = /* @__PURE__ */ tA();
const YW = /* @__PURE__ */ ve(zW);
var rA = "isNumberString";
function nA(e, t) {
  return typeof e == "string" && YW(e, t);
}
function XW(e, t) {
  return Y({
    name: rA,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return nA(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must be a number string";
      }, t)
    }
  }, t);
}
var Ml = { exports: {} }, Y5;
function oA() {
  return Y5 || (Y5 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = s;
    var r = o(/* @__PURE__ */ Q()), n = o(/* @__PURE__ */ ht());
    function o(u) {
      return u && u.__esModule ? u : { default: u };
    }
    var a = /^[A-Z2-7]+=*$/, d = /^[A-HJKMNP-TV-Z0-9]+$/, i = {
      crockford: !1
    };
    function s(u, c) {
      if ((0, r.default)(u), c = (0, n.default)(c, i), c.crockford)
        return d.test(u);
      var l = u.length;
      return !!(l % 8 === 0 && a.test(u));
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Ml, Ml.exports)), Ml.exports;
}
var qW = /* @__PURE__ */ oA();
const JW = /* @__PURE__ */ ve(qW);
var aA = "isBase32";
function dA(e) {
  return typeof e == "string" && JW(e);
}
function QW(e) {
  return Y({
    name: aA,
    validator: {
      validate: function(t, r) {
        return dA(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be base32 encoded";
      }, e)
    }
  }, e);
}
var Cl = { exports: {} }, X5;
function iA() {
  return X5 || (X5 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = o(/* @__PURE__ */ Q()), n = /* @__PURE__ */ b2();
    function o(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var a = /^[A-Za-z]{6}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?$/;
    function d(i) {
      (0, r.default)(i);
      var s = i.slice(4, 6).toUpperCase();
      return !n.CountryCodes.has(s) && s !== "XK" ? !1 : a.test(i);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Cl, Cl.exports)), Cl.exports;
}
var ez = /* @__PURE__ */ iA();
const tz = /* @__PURE__ */ ve(ez);
var sA = "isBIC";
function uA(e) {
  return typeof e == "string" && tz(e);
}
function rz(e) {
  return Y({
    name: sA,
    validator: {
      validate: function(t, r) {
        return uA(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be a BIC or SWIFT code";
      }, e)
    }
  }, e);
}
var Ol = { exports: {} }, q5;
function lA() {
  return q5 || (q5 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = n(/* @__PURE__ */ Q());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var o = /^(bc1|tb1|bc1p|tb1p)[ac-hj-np-z02-9]{39,58}$/, a = /^(1|2|3|m)[A-HJ-NP-Za-km-z1-9]{25,39}$/;
    function d(i) {
      return (0, r.default)(i), o.test(i) || a.test(i);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Ol, Ol.exports)), Ol.exports;
}
var nz = /* @__PURE__ */ lA();
const oz = /* @__PURE__ */ ve(nz);
var cA = "isBtcAddress";
function fA(e) {
  return typeof e == "string" && oz(e);
}
function az(e) {
  return Y({
    name: cA,
    validator: {
      validate: function(t, r) {
        return fA(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be a BTC address";
      }, e)
    }
  }, e);
}
var Nl = { exports: {} }, J5;
function pA() {
  return J5 || (J5 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var r = n(/* @__PURE__ */ Q());
    function n(s) {
      return s && s.__esModule ? s : { default: s };
    }
    var o = /^[a-z]+\/[a-z0-9\-\+\._]+$/i, a = /^[a-z\-]+=[a-z0-9\-]+$/i, d = /^[a-z0-9!\$&'\(\)\*\+,;=\-\._~:@\/\?%\s]*$/i;
    function i(s) {
      (0, r.default)(s);
      var u = s.split(",");
      if (u.length < 2)
        return !1;
      var c = u.shift().trim().split(";"), l = c.shift();
      if (l.slice(0, 5) !== "data:")
        return !1;
      var p = l.slice(5);
      if (p !== "" && !o.test(p))
        return !1;
      for (var h = 0; h < c.length; h++)
        if (!(h === c.length - 1 && c[h].toLowerCase() === "base64") && !a.test(c[h]))
          return !1;
      for (var m = 0; m < u.length; m++)
        if (!d.test(u[m]))
          return !1;
      return !0;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Nl, Nl.exports)), Nl.exports;
}
var dz = /* @__PURE__ */ pA();
const iz = /* @__PURE__ */ ve(dz);
var $A = "isDataURI";
function vA(e) {
  return typeof e == "string" && iz(e);
}
function sz(e) {
  return Y({
    name: $A,
    validator: {
      validate: function(t, r) {
        return vA(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be a data uri format";
      }, e)
    }
  }, e);
}
var Il = { exports: {} }, Q5;
function mA() {
  return Q5 || (Q5 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = u;
    var r = n(/* @__PURE__ */ Q());
    function n(c) {
      return c && c.__esModule ? c : { default: c };
    }
    var o = 8, a = 14, d = /^(\d{8}|\d{13}|\d{14})$/;
    function i(c, l) {
      return c === o || c === a ? l % 2 === 0 ? 3 : 1 : l % 2 === 0 ? 1 : 3;
    }
    function s(c) {
      var l = c.slice(0, -1).split("").map(function(h, m) {
        return Number(h) * i(c.length, m);
      }).reduce(function(h, m) {
        return h + m;
      }, 0), p = 10 - l % 10;
      return p < 10 ? p : 0;
    }
    function u(c) {
      (0, r.default)(c);
      var l = Number(c.slice(-1));
      return d.test(c) && l === s(c);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Il, Il.exports)), Il.exports;
}
var uz = /* @__PURE__ */ mA();
const lz = /* @__PURE__ */ ve(uz);
var hA = "isEAN";
function gA(e) {
  return typeof e == "string" && lz(e);
}
function cz(e) {
  return Y({
    name: hA,
    validator: {
      validate: function(t, r) {
        return gA(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be an EAN (European Article Number)";
      }, e)
    }
  }, e);
}
var Pl = { exports: {} }, e6;
function yA() {
  return e6 || (e6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ Q());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /^(0x)[0-9a-f]{40}$/i;
    function a(d) {
      return (0, r.default)(d), o.test(d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Pl, Pl.exports)), Pl.exports;
}
var fz = /* @__PURE__ */ yA();
const pz = /* @__PURE__ */ ve(fz);
var bA = "isEthereumAddress";
function xA(e) {
  return typeof e == "string" && pz(e);
}
function $z(e) {
  return Y({
    name: bA,
    validator: {
      validate: function(t, r) {
        return xA(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be an Ethereum address";
      }, e)
    }
  }, e);
}
var Rl = { exports: {} }, t6;
function wA() {
  return t6 || (t6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = n(/* @__PURE__ */ Q());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var o = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(,(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}(,((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?))?\)$/i, a = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(\s(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}\s?(\/\s((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?)\s?)?\)$/i;
    function d(i) {
      (0, r.default)(i);
      var s = i.replace(/\s+/g, " ").replace(/\s?(hsla?\(|\)|,)\s?/ig, "$1");
      return s.indexOf(",") !== -1 ? o.test(s) : a.test(s);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Rl, Rl.exports)), Rl.exports;
}
var vz = /* @__PURE__ */ wA();
const mz = /* @__PURE__ */ ve(vz);
var AA = "isHSL";
function SA(e) {
  return typeof e == "string" && mz(e);
}
function hz(e) {
  return Y({
    name: AA,
    validator: {
      validate: function(t, r) {
        return SA(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be a HSL color";
      }, e)
    }
  }, e);
}
var ao = {}, r6;
function _A() {
  if (r6) return ao;
  r6 = 1, Object.defineProperty(ao, "__esModule", {
    value: !0
  }), ao.default = d, ao.locales = void 0;
  var e = t(/* @__PURE__ */ Q());
  function t(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var r = {
    AD: /^(AD[0-9]{2})\d{8}[A-Z0-9]{12}$/,
    AE: /^(AE[0-9]{2})\d{3}\d{16}$/,
    AL: /^(AL[0-9]{2})\d{8}[A-Z0-9]{16}$/,
    AT: /^(AT[0-9]{2})\d{16}$/,
    AZ: /^(AZ[0-9]{2})[A-Z0-9]{4}\d{20}$/,
    BA: /^(BA[0-9]{2})\d{16}$/,
    BE: /^(BE[0-9]{2})\d{12}$/,
    BG: /^(BG[0-9]{2})[A-Z]{4}\d{6}[A-Z0-9]{8}$/,
    BH: /^(BH[0-9]{2})[A-Z]{4}[A-Z0-9]{14}$/,
    BR: /^(BR[0-9]{2})\d{23}[A-Z]{1}[A-Z0-9]{1}$/,
    BY: /^(BY[0-9]{2})[A-Z0-9]{4}\d{20}$/,
    CH: /^(CH[0-9]{2})\d{5}[A-Z0-9]{12}$/,
    CR: /^(CR[0-9]{2})\d{18}$/,
    CY: /^(CY[0-9]{2})\d{8}[A-Z0-9]{16}$/,
    CZ: /^(CZ[0-9]{2})\d{20}$/,
    DE: /^(DE[0-9]{2})\d{18}$/,
    DK: /^(DK[0-9]{2})\d{14}$/,
    DO: /^(DO[0-9]{2})[A-Z]{4}\d{20}$/,
    DZ: /^(DZ\d{24})$/,
    EE: /^(EE[0-9]{2})\d{16}$/,
    EG: /^(EG[0-9]{2})\d{25}$/,
    ES: /^(ES[0-9]{2})\d{20}$/,
    FI: /^(FI[0-9]{2})\d{14}$/,
    FO: /^(FO[0-9]{2})\d{14}$/,
    FR: /^(FR[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
    GB: /^(GB[0-9]{2})[A-Z]{4}\d{14}$/,
    GE: /^(GE[0-9]{2})[A-Z0-9]{2}\d{16}$/,
    GI: /^(GI[0-9]{2})[A-Z]{4}[A-Z0-9]{15}$/,
    GL: /^(GL[0-9]{2})\d{14}$/,
    GR: /^(GR[0-9]{2})\d{7}[A-Z0-9]{16}$/,
    GT: /^(GT[0-9]{2})[A-Z0-9]{4}[A-Z0-9]{20}$/,
    HR: /^(HR[0-9]{2})\d{17}$/,
    HU: /^(HU[0-9]{2})\d{24}$/,
    IE: /^(IE[0-9]{2})[A-Z]{4}\d{14}$/,
    IL: /^(IL[0-9]{2})\d{19}$/,
    IQ: /^(IQ[0-9]{2})[A-Z]{4}\d{15}$/,
    IR: /^(IR[0-9]{2})0\d{2}0\d{18}$/,
    IS: /^(IS[0-9]{2})\d{22}$/,
    IT: /^(IT[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
    JO: /^(JO[0-9]{2})[A-Z]{4}\d{22}$/,
    KW: /^(KW[0-9]{2})[A-Z]{4}[A-Z0-9]{22}$/,
    KZ: /^(KZ[0-9]{2})\d{3}[A-Z0-9]{13}$/,
    LB: /^(LB[0-9]{2})\d{4}[A-Z0-9]{20}$/,
    LC: /^(LC[0-9]{2})[A-Z]{4}[A-Z0-9]{24}$/,
    LI: /^(LI[0-9]{2})\d{5}[A-Z0-9]{12}$/,
    LT: /^(LT[0-9]{2})\d{16}$/,
    LU: /^(LU[0-9]{2})\d{3}[A-Z0-9]{13}$/,
    LV: /^(LV[0-9]{2})[A-Z]{4}[A-Z0-9]{13}$/,
    MA: /^(MA[0-9]{26})$/,
    MC: /^(MC[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
    MD: /^(MD[0-9]{2})[A-Z0-9]{20}$/,
    ME: /^(ME[0-9]{2})\d{18}$/,
    MK: /^(MK[0-9]{2})\d{3}[A-Z0-9]{10}\d{2}$/,
    MR: /^(MR[0-9]{2})\d{23}$/,
    MT: /^(MT[0-9]{2})[A-Z]{4}\d{5}[A-Z0-9]{18}$/,
    MU: /^(MU[0-9]{2})[A-Z]{4}\d{19}[A-Z]{3}$/,
    MZ: /^(MZ[0-9]{2})\d{21}$/,
    NL: /^(NL[0-9]{2})[A-Z]{4}\d{10}$/,
    NO: /^(NO[0-9]{2})\d{11}$/,
    PK: /^(PK[0-9]{2})[A-Z0-9]{4}\d{16}$/,
    PL: /^(PL[0-9]{2})\d{24}$/,
    PS: /^(PS[0-9]{2})[A-Z]{4}[A-Z0-9]{21}$/,
    PT: /^(PT[0-9]{2})\d{21}$/,
    QA: /^(QA[0-9]{2})[A-Z]{4}[A-Z0-9]{21}$/,
    RO: /^(RO[0-9]{2})[A-Z]{4}[A-Z0-9]{16}$/,
    RS: /^(RS[0-9]{2})\d{18}$/,
    SA: /^(SA[0-9]{2})\d{2}[A-Z0-9]{18}$/,
    SC: /^(SC[0-9]{2})[A-Z]{4}\d{20}[A-Z]{3}$/,
    SE: /^(SE[0-9]{2})\d{20}$/,
    SI: /^(SI[0-9]{2})\d{15}$/,
    SK: /^(SK[0-9]{2})\d{20}$/,
    SM: /^(SM[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
    SV: /^(SV[0-9]{2})[A-Z0-9]{4}\d{20}$/,
    TL: /^(TL[0-9]{2})\d{19}$/,
    TN: /^(TN[0-9]{2})\d{20}$/,
    TR: /^(TR[0-9]{2})\d{5}[A-Z0-9]{17}$/,
    UA: /^(UA[0-9]{2})\d{6}[A-Z0-9]{19}$/,
    VA: /^(VA[0-9]{2})\d{18}$/,
    VG: /^(VG[0-9]{2})[A-Z]{4}\d{16}$/,
    XK: /^(XK[0-9]{2})\d{16}$/
  };
  function n(i) {
    var s = i.filter(function(u) {
      return !(u in r);
    });
    return !(s.length > 0);
  }
  function o(i, s) {
    var u = i.replace(/[\s\-]+/gi, "").toUpperCase(), c = u.slice(0, 2).toUpperCase(), l = c in r;
    if (s.whitelist) {
      if (!n(s.whitelist))
        return !1;
      var p = s.whitelist.includes(c);
      if (!p)
        return !1;
    }
    if (s.blacklist) {
      var h = s.blacklist.includes(c);
      if (h)
        return !1;
    }
    return l && r[c].test(u);
  }
  function a(i) {
    var s = i.replace(/[^A-Z0-9]+/gi, "").toUpperCase(), u = s.slice(4) + s.slice(0, 4), c = u.replace(/[A-Z]/g, function(p) {
      return p.charCodeAt(0) - 55;
    }), l = c.match(/\d{1,7}/g).reduce(function(p, h) {
      return Number(p + h) % 97;
    }, "");
    return l === 1;
  }
  function d(i) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return (0, e.default)(i), o(i, s) && a(i);
  }
  return ao.locales = Object.keys(r), ao;
}
var gz = /* @__PURE__ */ _A();
const yz = /* @__PURE__ */ ve(gz);
var EA = "isIBAN";
function MA(e) {
  return typeof e == "string" && yz(e);
}
function bz(e) {
  return Y({
    name: EA,
    validator: {
      validate: function(t, r) {
        return MA(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be an IBAN";
      }, e)
    }
  }, e);
}
var Tl = { exports: {} }, n6;
function CA() {
  return n6 || (n6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = o(/* @__PURE__ */ Q()), n = o(/* @__PURE__ */ g2());
    function o(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var a = {
      PL: function(i) {
        (0, r.default)(i);
        var s = {
          1: 1,
          2: 3,
          3: 7,
          4: 9,
          5: 1,
          6: 3,
          7: 7,
          8: 9,
          9: 1,
          10: 3,
          11: 0
        };
        if (i != null && i.length === 11 && (0, n.default)(i, {
          allow_leading_zeroes: !0
        })) {
          var u = i.split("").slice(0, -1), c = u.reduce(function(h, m, f) {
            return h + Number(m) * s[f + 1];
          }, 0), l = c % 10, p = Number(i.charAt(i.length - 1));
          if (l === 0 && p === 0 || p === 10 - l)
            return !0;
        }
        return !1;
      },
      ES: function(i) {
        (0, r.default)(i);
        var s = /^[0-9X-Z][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/, u = {
          X: 0,
          Y: 1,
          Z: 2
        }, c = ["T", "R", "W", "A", "G", "M", "Y", "F", "P", "D", "X", "B", "N", "J", "Z", "S", "Q", "V", "H", "L", "C", "K", "E"], l = i.trim().toUpperCase();
        if (!s.test(l))
          return !1;
        var p = l.slice(0, -1).replace(/[X,Y,Z]/g, function(h) {
          return u[h];
        });
        return l.endsWith(c[p % 23]);
      },
      FI: function(i) {
        if ((0, r.default)(i), i.length !== 11 || !i.match(/^\d{6}[\-A\+]\d{3}[0-9ABCDEFHJKLMNPRSTUVWXY]{1}$/))
          return !1;
        var s = "0123456789ABCDEFHJKLMNPRSTUVWXY", u = parseInt(i.slice(0, 6), 10) * 1e3 + parseInt(i.slice(7, 10), 10), c = u % 31, l = s[c];
        return l === i.slice(10, 11);
      },
      IN: function(i) {
        var s = /^[1-9]\d{3}\s?\d{4}\s?\d{4}$/, u = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 2, 3, 4, 0, 6, 7, 8, 9, 5], [2, 3, 4, 0, 1, 7, 8, 9, 5, 6], [3, 4, 0, 1, 2, 8, 9, 5, 6, 7], [4, 0, 1, 2, 3, 9, 5, 6, 7, 8], [5, 9, 8, 7, 6, 0, 4, 3, 2, 1], [6, 5, 9, 8, 7, 1, 0, 4, 3, 2], [7, 6, 5, 9, 8, 2, 1, 0, 4, 3], [8, 7, 6, 5, 9, 3, 2, 1, 0, 4], [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]], c = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 5, 7, 6, 2, 8, 3, 0, 9, 4], [5, 8, 0, 3, 7, 9, 6, 1, 4, 2], [8, 9, 1, 6, 0, 4, 3, 5, 2, 7], [9, 4, 5, 3, 1, 2, 6, 8, 7, 0], [4, 2, 8, 6, 5, 7, 3, 9, 0, 1], [2, 7, 9, 3, 8, 0, 6, 4, 1, 5], [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]], l = i.trim();
        if (!s.test(l))
          return !1;
        var p = 0, h = l.replace(/\s/g, "").split("").map(Number).reverse();
        return h.forEach(function(m, f) {
          p = u[p][c[f % 8][m]];
        }), p === 0;
      },
      IR: function(i) {
        if (!i.match(/^\d{10}$/) || (i = "0000".concat(i).slice(i.length - 6), parseInt(i.slice(3, 9), 10) === 0)) return !1;
        for (var s = parseInt(i.slice(9, 10), 10), u = 0, c = 0; c < 9; c++)
          u += parseInt(i.slice(c, c + 1), 10) * (10 - c);
        return u %= 11, u < 2 && s === u || u >= 2 && s === 11 - u;
      },
      IT: function(i) {
        return i.length !== 9 || i === "CA00000AA" ? !1 : i.search(/C[A-Z]\d{5}[A-Z]{2}/i) > -1;
      },
      NO: function(i) {
        var s = i.trim();
        if (isNaN(Number(s)) || s.length !== 11 || s === "00000000000") return !1;
        var u = s.split("").map(Number), c = (11 - (3 * u[0] + 7 * u[1] + 6 * u[2] + 1 * u[3] + 8 * u[4] + 9 * u[5] + 4 * u[6] + 5 * u[7] + 2 * u[8]) % 11) % 11, l = (11 - (5 * u[0] + 4 * u[1] + 3 * u[2] + 2 * u[3] + 7 * u[4] + 6 * u[5] + 5 * u[6] + 4 * u[7] + 3 * u[8] + 2 * c) % 11) % 11;
        return !(c !== u[9] || l !== u[10]);
      },
      TH: function(i) {
        if (!i.match(/^[1-8]\d{12}$/)) return !1;
        for (var s = 0, u = 0; u < 12; u++)
          s += parseInt(i[u], 10) * (13 - u);
        return i[12] === ((11 - s % 11) % 10).toString();
      },
      LK: function(i) {
        var s = /^[1-9]\d{8}[vx]$/i, u = /^[1-9]\d{11}$/i;
        return i.length === 10 && s.test(i) ? !0 : !!(i.length === 12 && u.test(i));
      },
      "he-IL": function(i) {
        var s = /^\d{9}$/, u = i.trim();
        if (!s.test(u))
          return !1;
        for (var c = u, l = 0, p, h = 0; h < c.length; h++)
          p = Number(c[h]) * (h % 2 + 1), l += p > 9 ? p - 9 : p;
        return l % 10 === 0;
      },
      "ar-LY": function(i) {
        var s = /^(1|2)\d{11}$/, u = i.trim();
        return !!s.test(u);
      },
      "ar-TN": function(i) {
        var s = /^\d{8}$/, u = i.trim();
        return !!s.test(u);
      },
      "zh-CN": function(i) {
        var s = [
          "11",
          // 北京
          "12",
          // 天津
          "13",
          // 河北
          "14",
          // 山西
          "15",
          // 内蒙古
          "21",
          // 辽宁
          "22",
          // 吉林
          "23",
          // 黑龙江
          "31",
          // 上海
          "32",
          // 江苏
          "33",
          // 浙江
          "34",
          // 安徽
          "35",
          // 福建
          "36",
          // 江西
          "37",
          // 山东
          "41",
          // 河南
          "42",
          // 湖北
          "43",
          // 湖南
          "44",
          // 广东
          "45",
          // 广西
          "46",
          // 海南
          "50",
          // 重庆
          "51",
          // 四川
          "52",
          // 贵州
          "53",
          // 云南
          "54",
          // 西藏
          "61",
          // 陕西
          "62",
          // 甘肃
          "63",
          // 青海
          "64",
          // 宁夏
          "65",
          // 新疆
          "71",
          // 台湾
          "81",
          // 香港
          "82",
          // 澳门
          "91"
          // 国外
        ], u = ["7", "9", "10", "5", "8", "4", "2", "1", "6", "3", "7", "9", "10", "5", "8", "4", "2"], c = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"], l = function(y) {
          return s.includes(y);
        }, p = function(y) {
          var S = parseInt(y.substring(0, 4), 10), w = parseInt(y.substring(4, 6), 10), _ = parseInt(y.substring(6), 10), I = new Date(S, w - 1, _);
          return I > /* @__PURE__ */ new Date() ? !1 : I.getFullYear() === S && I.getMonth() === w - 1 && I.getDate() === _;
        }, h = function(y) {
          for (var S = y.substring(0, 17), w = 0, _ = 0; _ < 17; _++)
            w += parseInt(S.charAt(_), 10) * parseInt(u[_], 10);
          var I = w % 11;
          return c[I];
        }, m = function(y) {
          return h(y) === y.charAt(17).toUpperCase();
        }, f = function(y) {
          var S = /^[1-9]\d{7}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}$/.test(y);
          if (!S) return !1;
          var w = y.substring(0, 2);
          if (S = l(w), !S) return !1;
          var _ = "19".concat(y.substring(6, 12));
          return S = p(_), !!S;
        }, $ = function(y) {
          var S = /^[1-9]\d{5}[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}(\d|x|X)$/.test(y);
          if (!S) return !1;
          var w = y.substring(0, 2);
          if (S = l(w), !S) return !1;
          var _ = y.substring(6, 14);
          return S = p(_), S ? m(y) : !1;
        }, v = function(y) {
          var S = /^\d{15}|(\d{17}(\d|x|X))$/.test(y);
          return S ? y.length === 15 ? f(y) : $(y) : !1;
        };
        return v(i);
      },
      "zh-HK": function(i) {
        i = i.trim();
        var s = /^[A-Z]{1,2}[0-9]{6}((\([0-9A]\))|(\[[0-9A]\])|([0-9A]))$/, u = /^[0-9]$/;
        if (i = i.toUpperCase(), !s.test(i)) return !1;
        i = i.replace(/\[|\]|\(|\)/g, ""), i.length === 8 && (i = "3".concat(i));
        for (var c = 0, l = 0; l <= 7; l++) {
          var p = void 0;
          u.test(i[l]) ? p = i[l] : p = (i[l].charCodeAt(0) - 55) % 11, c += p * (9 - l);
        }
        c %= 11;
        var h;
        return c === 0 ? h = "0" : c === 1 ? h = "A" : h = String(11 - c), h === i[i.length - 1];
      },
      "zh-TW": function(i) {
        var s = {
          A: 10,
          B: 11,
          C: 12,
          D: 13,
          E: 14,
          F: 15,
          G: 16,
          H: 17,
          I: 34,
          J: 18,
          K: 19,
          L: 20,
          M: 21,
          N: 22,
          O: 35,
          P: 23,
          Q: 24,
          R: 25,
          S: 26,
          T: 27,
          U: 28,
          V: 29,
          W: 32,
          X: 30,
          Y: 31,
          Z: 33
        }, u = i.trim().toUpperCase();
        return /^[A-Z][0-9]{9}$/.test(u) ? Array.from(u).reduce(function(c, l, p) {
          if (p === 0) {
            var h = s[l];
            return h % 10 * 9 + Math.floor(h / 10);
          }
          return p === 9 ? (10 - c % 10 - Number(l)) % 10 === 0 : c + Number(l) * (9 - p);
        }, 0) : !1;
      },
      PK: function(i) {
        var s = /^[1-7][0-9]{4}-[0-9]{7}-[1-9]$/, u = i.trim();
        return s.test(u);
      }
    };
    function d(i, s) {
      if ((0, r.default)(i), s in a)
        return a[s](i);
      if (s === "any") {
        for (var u in a)
          if (a.hasOwnProperty(u)) {
            var c = a[u];
            if (c(i))
              return !0;
          }
        return !1;
      }
      throw new Error("Invalid locale '".concat(s, "'"));
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Tl, Tl.exports)), Tl.exports;
}
var xz = /* @__PURE__ */ CA();
const wz = /* @__PURE__ */ ve(xz);
var OA = "isIdentityCard";
function NA(e, t) {
  return typeof e == "string" && wz(e, t);
}
function Az(e, t) {
  return Y({
    name: OA,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return NA(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must be a identity card number";
      }, t)
    }
  }, t);
}
var Dl = { exports: {} }, o6;
function IA() {
  return o6 || (o6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ Q());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /^[A-Z]{2}[0-9A-Z]{3}\d{2}\d{5}$/;
    function a(d) {
      return (0, r.default)(d), o.test(d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Dl, Dl.exports)), Dl.exports;
}
var Sz = /* @__PURE__ */ IA();
const _z = /* @__PURE__ */ ve(Sz);
var PA = "isISRC";
function RA(e) {
  return typeof e == "string" && _z(e);
}
function Ez(e) {
  return Y({
    name: PA,
    validator: {
      validate: function(t, r) {
        return RA(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be an ISRC";
      }, e)
    }
  }, e);
}
var Ll = { exports: {} }, a6;
function TA() {
  return a6 || (a6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = y;
    var r = n(/* @__PURE__ */ Q());
    function n(S) {
      return S && S.__esModule ? S : { default: S };
    }
    var o = "([A-Za-z]{3}(-[A-Za-z]{3}){0,2})", a = "(([a-zA-Z]{2,3}(-".concat(o, ")?)|([a-zA-Z]{5,8}))"), d = "([A-Za-z]{4})", i = "([A-Za-z]{2}|\\d{3})", s = "([A-Za-z0-9]{5,8}|(\\d[A-Z-a-z0-9]{3}))", u = "(\\d|[A-W]|[Y-Z]|[a-w]|[y-z])", c = "(".concat(u, "(-[A-Za-z0-9]{2,8})+)"), l = "(x(-[A-Za-z0-9]{1,8})+)", p = "((en-GB-oed)|(i-ami)|(i-bnn)|(i-default)|(i-enochian)|(i-hak)|(i-klingon)|(i-lux)|(i-mingo)|(i-navajo)|(i-pwn)|(i-tao)|(i-tay)|(i-tsu)|(sgn-BE-FR)|(sgn-BE-NL)|(sgn-CH-DE))", h = "((art-lojban)|(cel-gaulish)|(no-bok)|(no-nyn)|(zh-guoyu)|(zh-hakka)|(zh-min)|(zh-min-nan)|(zh-xiang))", m = "(".concat(p, "|").concat(h, ")"), f = "(-|_)", $ = "".concat(a, "(").concat(f).concat(d, ")?(").concat(f).concat(i, ")?(").concat(f).concat(s, ")*(").concat(f).concat(c, ")*(").concat(f).concat(l, ")?"), v = new RegExp("(^".concat(l, "$)|(^").concat(m, "$)|(^").concat($, "$)"));
    function y(S) {
      return (0, r.default)(S), v.test(S);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Ll, Ll.exports)), Ll.exports;
}
var Mz = /* @__PURE__ */ TA();
const Cz = /* @__PURE__ */ ve(Mz);
var DA = "isLocale";
function LA(e) {
  return typeof e == "string" && Cz(e);
}
function Oz(e) {
  return Y({
    name: DA,
    validator: {
      validate: function(t, r) {
        return LA(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be locale";
      }, e)
    }
  }, e);
}
var Fl = { exports: {} }, d6;
function FA() {
  return d6 || (d6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ Q());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /(?:^magnet:\?|[^?&]&)xt(?:\.1)?=urn:(?:(?:aich|bitprint|btih|ed2k|ed2khash|kzhash|md5|sha1|tree:tiger):[a-z0-9]{32}(?:[a-z0-9]{8})?|btmh:1220[a-z0-9]{64})(?:$|&)/i;
    function a(d) {
      return (0, r.default)(d), d.indexOf("magnet:?") !== 0 ? !1 : o.test(d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Fl, Fl.exports)), Fl.exports;
}
var Nz = /* @__PURE__ */ FA();
const Iz = /* @__PURE__ */ ve(Nz);
var kA = "isMagnetURI";
function jA(e) {
  return typeof e == "string" && Iz(e);
}
function Pz(e) {
  return Y({
    name: kA,
    validator: {
      validate: function(t, r) {
        return jA(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be magnet uri format";
      }, e)
    }
  }, e);
}
var kl = { exports: {} }, i6;
function BA() {
  return i6 || (i6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var r = n(/* @__PURE__ */ Q());
    function n(s) {
      return s && s.__esModule ? s : { default: s };
    }
    var o = /^(application|audio|font|image|message|model|multipart|text|video)\/[a-zA-Z0-9\.\-\+_]{1,100}$/i, a = /^text\/[a-zA-Z0-9\.\-\+]{1,100};\s?charset=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?$/i, d = /^multipart\/[a-zA-Z0-9\.\-\+]{1,100}(;\s?(boundary|charset)=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?){0,2}$/i;
    function i(s) {
      return (0, r.default)(s), o.test(s) || a.test(s) || d.test(s);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(kl, kl.exports)), kl.exports;
}
var Rz = /* @__PURE__ */ BA();
const Tz = /* @__PURE__ */ ve(Rz);
var ZA = "isMimeType";
function UA(e) {
  return typeof e == "string" && Tz(e);
}
function Dz(e) {
  return Y({
    name: ZA,
    validator: {
      validate: function(t, r) {
        return UA(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be MIME type format";
      }, e)
    }
  }, e);
}
var jl = { exports: {} }, s6;
function GA() {
  return s6 || (s6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ Q());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /^(0o)?[0-7]+$/i;
    function a(d) {
      return (0, r.default)(d), o.test(d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(jl, jl.exports)), jl.exports;
}
var Lz = /* @__PURE__ */ GA();
const Fz = /* @__PURE__ */ ve(Lz);
var VA = "isOctal";
function HA(e) {
  return typeof e == "string" && Fz(e);
}
function kz(e) {
  return Y({
    name: VA,
    validator: {
      validate: function(t, r) {
        return HA(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be valid octal number";
      }, e)
    }
  }, e);
}
var io = {}, u6;
function KA() {
  if (u6) return io;
  u6 = 1, Object.defineProperty(io, "__esModule", {
    value: !0
  }), io.default = n, io.locales = void 0;
  var e = t(/* @__PURE__ */ Q());
  function t(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var r = {
    AM: /^[A-Z]{2}\d{7}$/,
    // ARMENIA
    AR: /^[A-Z]{3}\d{6}$/,
    // ARGENTINA
    AT: /^[A-Z]\d{7}$/,
    // AUSTRIA
    AU: /^[A-Z]\d{7}$/,
    // AUSTRALIA
    AZ: /^[A-Z]{1}\d{8}$/,
    // AZERBAIJAN
    BE: /^[A-Z]{2}\d{6}$/,
    // BELGIUM
    BG: /^\d{9}$/,
    // BULGARIA
    BR: /^[A-Z]{2}\d{6}$/,
    // BRAZIL
    BY: /^[A-Z]{2}\d{7}$/,
    // BELARUS
    CA: /^[A-Z]{2}\d{6}$/,
    // CANADA
    CH: /^[A-Z]\d{7}$/,
    // SWITZERLAND
    CN: /^G\d{8}$|^E(?![IO])[A-Z0-9]\d{7}$/,
    // CHINA [G=Ordinary, E=Electronic] followed by 8-digits, or E followed by any UPPERCASE letter (except I and O) followed by 7 digits
    CY: /^[A-Z](\d{6}|\d{8})$/,
    // CYPRUS
    CZ: /^\d{8}$/,
    // CZECH REPUBLIC
    DE: /^[CFGHJKLMNPRTVWXYZ0-9]{9}$/,
    // GERMANY
    DK: /^\d{9}$/,
    // DENMARK
    DZ: /^\d{9}$/,
    // ALGERIA
    EE: /^([A-Z]\d{7}|[A-Z]{2}\d{7})$/,
    // ESTONIA (K followed by 7-digits), e-passports have 2 UPPERCASE followed by 7 digits
    ES: /^[A-Z0-9]{2}([A-Z0-9]?)\d{6}$/,
    // SPAIN
    FI: /^[A-Z]{2}\d{7}$/,
    // FINLAND
    FR: /^\d{2}[A-Z]{2}\d{5}$/,
    // FRANCE
    GB: /^\d{9}$/,
    // UNITED KINGDOM
    GR: /^[A-Z]{2}\d{7}$/,
    // GREECE
    HR: /^\d{9}$/,
    // CROATIA
    HU: /^[A-Z]{2}(\d{6}|\d{7})$/,
    // HUNGARY
    IE: /^[A-Z0-9]{2}\d{7}$/,
    // IRELAND
    IN: /^[A-Z]{1}-?\d{7}$/,
    // INDIA
    ID: /^[A-C]\d{7}$/,
    // INDONESIA
    IR: /^[A-Z]\d{8}$/,
    // IRAN
    IS: /^(A)\d{7}$/,
    // ICELAND
    IT: /^[A-Z0-9]{2}\d{7}$/,
    // ITALY
    JM: /^[Aa]\d{7}$/,
    // JAMAICA
    JP: /^[A-Z]{2}\d{7}$/,
    // JAPAN
    KR: /^[MS]\d{8}$/,
    // SOUTH KOREA, REPUBLIC OF KOREA, [S=PS Passports, M=PM Passports]
    KZ: /^[a-zA-Z]\d{7}$/,
    // KAZAKHSTAN
    LI: /^[a-zA-Z]\d{5}$/,
    // LIECHTENSTEIN
    LT: /^[A-Z0-9]{8}$/,
    // LITHUANIA
    LU: /^[A-Z0-9]{8}$/,
    // LUXEMBURG
    LV: /^[A-Z0-9]{2}\d{7}$/,
    // LATVIA
    LY: /^[A-Z0-9]{8}$/,
    // LIBYA
    MT: /^\d{7}$/,
    // MALTA
    MZ: /^([A-Z]{2}\d{7})|(\d{2}[A-Z]{2}\d{5})$/,
    // MOZAMBIQUE
    MY: /^[AHK]\d{8}$/,
    // MALAYSIA
    MX: /^\d{10,11}$/,
    // MEXICO
    NL: /^[A-Z]{2}[A-Z0-9]{6}\d$/,
    // NETHERLANDS
    NZ: /^([Ll]([Aa]|[Dd]|[Ff]|[Hh])|[Ee]([Aa]|[Pp])|[Nn])\d{6}$/,
    // NEW ZEALAND
    PH: /^([A-Z](\d{6}|\d{7}[A-Z]))|([A-Z]{2}(\d{6}|\d{7}))$/,
    // PHILIPPINES
    PK: /^[A-Z]{2}\d{7}$/,
    // PAKISTAN
    PL: /^[A-Z]{2}\d{7}$/,
    // POLAND
    PT: /^[A-Z]\d{6}$/,
    // PORTUGAL
    RO: /^\d{8,9}$/,
    // ROMANIA
    RU: /^\d{9}$/,
    // RUSSIAN FEDERATION
    SE: /^\d{8}$/,
    // SWEDEN
    SL: /^(P)[A-Z]\d{7}$/,
    // SLOVENIA
    SK: /^[0-9A-Z]\d{7}$/,
    // SLOVAKIA
    TH: /^[A-Z]{1,2}\d{6,7}$/,
    // THAILAND
    TR: /^[A-Z]\d{8}$/,
    // TURKEY
    UA: /^[A-Z]{2}\d{6}$/,
    // UKRAINE
    US: /^\d{9}$/,
    // UNITED STATES
    ZA: /^[TAMD]\d{8}$/
    // SOUTH AFRICA
  };
  io.locales = Object.keys(r);
  function n(o, a) {
    (0, e.default)(o);
    var d = o.replace(/\s/g, "").toUpperCase();
    return a.toUpperCase() in r && r[a].test(d);
  }
  return io;
}
var jz = /* @__PURE__ */ KA();
const Bz = /* @__PURE__ */ ve(jz);
var WA = "isPassportNumber";
function zA(e, t) {
  return typeof e == "string" && Bz(e, t);
}
function Zz(e, t) {
  return Y({
    name: WA,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return zA(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must be valid passport number";
      }, t)
    }
  }, t);
}
var so = {}, l6;
function YA() {
  if (l6) return so;
  l6 = 1, Object.defineProperty(so, "__esModule", {
    value: !0
  }), so.default = i, so.locales = void 0;
  var e = t(/* @__PURE__ */ Q());
  function t(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var r = /^\d{3}$/, n = /^\d{4}$/, o = /^\d{5}$/, a = /^\d{6}$/, d = {
    AD: /^AD\d{3}$/,
    AT: n,
    AU: n,
    AZ: /^AZ\d{4}$/,
    BA: /^([7-8]\d{4}$)/,
    BE: n,
    BG: n,
    BR: /^\d{5}-?\d{3}$/,
    BY: /^2[1-4]\d{4}$/,
    CA: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][\s\-]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
    CH: n,
    CN: /^(0[1-7]|1[012356]|2[0-7]|3[0-6]|4[0-7]|5[1-7]|6[1-7]|7[1-5]|8[1345]|9[09])\d{4}$/,
    CO: /^(05|08|11|13|15|17|18|19|20|23|25|27|41|44|47|50|52|54|63|66|68|70|73|76|81|85|86|88|91|94|95|97|99)(\d{4})$/,
    CZ: /^\d{3}\s?\d{2}$/,
    DE: o,
    DK: n,
    DO: o,
    DZ: o,
    EE: o,
    ES: /^(5[0-2]{1}|[0-4]{1}\d{1})\d{3}$/,
    FI: o,
    FR: /^\d{2}\s?\d{3}$/,
    GB: /^(gir\s?0aa|[a-z]{1,2}\d[\da-z]?\s?(\d[a-z]{2})?)$/i,
    GR: /^\d{3}\s?\d{2}$/,
    HR: /^([1-5]\d{4}$)/,
    HT: /^HT\d{4}$/,
    HU: n,
    ID: o,
    IE: /^(?!.*(?:o))[A-Za-z]\d[\dw]\s\w{4}$/i,
    IL: /^(\d{5}|\d{7})$/,
    IN: /^((?!10|29|35|54|55|65|66|86|87|88|89)[1-9][0-9]{5})$/,
    IR: /^(?!(\d)\1{3})[13-9]{4}[1346-9][013-9]{5}$/,
    IS: r,
    IT: o,
    JP: /^\d{3}\-\d{4}$/,
    KE: o,
    KR: /^(\d{5}|\d{6})$/,
    LI: /^(948[5-9]|949[0-7])$/,
    LT: /^LT\-\d{5}$/,
    LU: n,
    LV: /^LV\-\d{4}$/,
    LK: o,
    MG: r,
    MX: o,
    MT: /^[A-Za-z]{3}\s{0,1}\d{4}$/,
    MY: o,
    NL: /^[1-9]\d{3}\s?(?!sa|sd|ss)[a-z]{2}$/i,
    NO: n,
    NP: /^(10|21|22|32|33|34|44|45|56|57)\d{3}$|^(977)$/i,
    NZ: n,
    PL: /^\d{2}\-\d{3}$/,
    PR: /^00[679]\d{2}([ -]\d{4})?$/,
    PT: /^\d{4}\-\d{3}?$/,
    RO: a,
    RU: a,
    SA: o,
    SE: /^[1-9]\d{2}\s?\d{2}$/,
    SG: a,
    SI: n,
    SK: /^\d{3}\s?\d{2}$/,
    TH: o,
    TN: n,
    TW: /^\d{3}(\d{2})?$/,
    UA: o,
    US: /^\d{5}(-\d{4})?$/,
    ZA: n,
    ZM: o
  };
  so.locales = Object.keys(d);
  function i(s, u) {
    if ((0, e.default)(s), u in d)
      return d[u].test(s);
    if (u === "any") {
      for (var c in d)
        if (d.hasOwnProperty(c)) {
          var l = d[c];
          if (l.test(s))
            return !0;
        }
      return !1;
    }
    throw new Error("Invalid locale '".concat(u, "'"));
  }
  return so;
}
var Uz = /* @__PURE__ */ YA();
const Gz = /* @__PURE__ */ ve(Uz);
var XA = "isPostalCode";
function qA(e, t) {
  return typeof e == "string" && Gz(e, t);
}
function Vz(e, t) {
  return Y({
    name: XA,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return qA(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must be a postal code";
      }, t)
    }
  }, t);
}
var Bl = { exports: {} }, c6;
function JA() {
  return c6 || (c6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = v;
    var r = n(/* @__PURE__ */ Q());
    function n(y) {
      return y && y.__esModule ? y : { default: y };
    }
    var o = /[0-9]{4}/, a = /(0[1-9]|1[0-2])/, d = /([12]\d|0[1-9]|3[01])/, i = /([01][0-9]|2[0-3])/, s = /[0-5][0-9]/, u = /([0-5][0-9]|60)/, c = /(\.[0-9]+)?/, l = new RegExp("[-+]".concat(i.source, ":").concat(s.source)), p = new RegExp("([zZ]|".concat(l.source, ")")), h = new RegExp("".concat(i.source, ":").concat(s.source, ":").concat(u.source).concat(c.source)), m = new RegExp("".concat(o.source, "-").concat(a.source, "-").concat(d.source)), f = new RegExp("".concat(h.source).concat(p.source)), $ = new RegExp("^".concat(m.source, "[ tT]").concat(f.source, "$"));
    function v(y) {
      return (0, r.default)(y), $.test(y);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Bl, Bl.exports)), Bl.exports;
}
var Hz = /* @__PURE__ */ JA();
const Kz = /* @__PURE__ */ ve(Hz);
var QA = "isRFC3339";
function eS(e) {
  return typeof e == "string" && Kz(e);
}
function Wz(e) {
  return Y({
    name: QA,
    validator: {
      validate: function(t, r) {
        return eS(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be RFC 3339 date";
      }, e)
    }
  }, e);
}
var Zl = { exports: {} }, f6;
function tS() {
  return f6 || (f6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = c;
    var r = n(/* @__PURE__ */ Q());
    function n(l) {
      return l && l.__esModule ? l : { default: l };
    }
    function o(l) {
      "@babel/helpers - typeof";
      return o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(p) {
        return typeof p;
      } : function(p) {
        return p && typeof Symbol == "function" && p.constructor === Symbol && p !== Symbol.prototype ? "symbol" : typeof p;
      }, o(l);
    }
    var a = /^rgb\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){2}([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\)$/, d = /^rgba\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)$/, i = /^rgb\((([0-9]%|[1-9][0-9]%|100%),){2}([0-9]%|[1-9][0-9]%|100%)\)$/, s = /^rgba\((([0-9]%|[1-9][0-9]%|100%),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)$/, u = /^rgba?/;
    function c(l, p) {
      (0, r.default)(l);
      var h = !1, m = !0;
      if (o(p) !== "object" ? arguments.length >= 2 && (m = arguments[1]) : (h = p.allowSpaces !== void 0 ? p.allowSpaces : h, m = p.includePercentValues !== void 0 ? p.includePercentValues : m), h) {
        if (!u.test(l))
          return !1;
        l = l.replace(/\s/g, "");
      }
      return m ? a.test(l) || d.test(l) || i.test(l) || s.test(l) : a.test(l) || d.test(l);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Zl, Zl.exports)), Zl.exports;
}
var zz = /* @__PURE__ */ tS();
const Yz = /* @__PURE__ */ ve(zz);
var rS = "isRgbColor";
function nS(e, t) {
  return typeof e == "string" && Yz(e, t);
}
function Xz(e, t) {
  return Y({
    name: rS,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return nS(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must be RGB color";
      }, t)
    }
  }, t);
}
var Ul = { exports: {} }, Gl = { exports: {} }, p6;
function qz() {
  return p6 || (p6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = r;
    function r(n, o) {
      var a = n.join("");
      return new RegExp(a, o);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Gl, Gl.exports)), Gl.exports;
}
var $6;
function oS() {
  return $6 || ($6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = o(/* @__PURE__ */ Q()), n = o(/* @__PURE__ */ qz());
    function o(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var a = (0, n.default)(["^(0|[1-9]\\d*)\\.(0|[1-9]\\d*)\\.(0|[1-9]\\d*)", "(?:-((?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*)(?:\\.(?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*))*))", "?(?:\\+([0-9a-z-]+(?:\\.[0-9a-z-]+)*))?$"], "i");
    function d(i) {
      return (0, r.default)(i), a.test(i);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Ul, Ul.exports)), Ul.exports;
}
var Jz = /* @__PURE__ */ oS();
const Qz = /* @__PURE__ */ ve(Jz);
var aS = "isSemVer";
function dS(e) {
  return typeof e == "string" && Qz(e);
}
function eY(e) {
  return Y({
    name: aS,
    validator: {
      validate: function(t, r) {
        return dS(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be a Semantic Versioning Specification";
      }, e)
    }
  }, e);
}
var Vl = { exports: {} }, Hl = { exports: {} }, v6;
function M2() {
  return v6 || (v6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ Q());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a) {
      return (0, r.default)(a), a = Date.parse(a), isNaN(a) ? null : new Date(a);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Hl, Hl.exports)), Hl.exports;
}
var Kl = { exports: {} }, m6;
function tY() {
  return m6 || (m6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ Q());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a, d) {
      return (0, r.default)(a), parseInt(a, d || 10);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Kl, Kl.exports)), Kl.exports;
}
var Wl = { exports: {} }, h6;
function rY() {
  return h6 || (h6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ Q());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a, d) {
      return (0, r.default)(a), d ? a === "1" || /^true$/i.test(a) : a !== "0" && !/^false$/i.test(a) && a !== "";
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Wl, Wl.exports)), Wl.exports;
}
var zl = { exports: {} }, g6;
function nY() {
  return g6 || (g6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ Q());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a, d) {
      return (0, r.default)(a), a === d;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(zl, zl.exports)), zl.exports;
}
var Yl = { exports: {} }, y6;
function oY() {
  return y6 || (y6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = s;
    var r = o(/* @__PURE__ */ Q()), n = o(/* @__PURE__ */ ka());
    function o(u) {
      return u && u.__esModule ? u : { default: u };
    }
    var a = /^\d{1,3}$/, d = 32, i = 128;
    function s(u) {
      var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
      (0, r.default)(u);
      var l = u.split("/");
      if (l.length !== 2 || !a.test(l[1]) || l[1].length > 1 && l[1].startsWith("0"))
        return !1;
      var p = (0, n.default)(l[0], c);
      if (!p)
        return !1;
      var h = null;
      switch (String(c)) {
        case "4":
          h = d;
          break;
        case "6":
          h = i;
          break;
        default:
          h = (0, n.default)(l[0], "6") ? i : d;
      }
      return l[1] <= h && l[1] >= 0;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Yl, Yl.exports)), Yl.exports;
}
var Xl = { exports: {} }, b6;
function iS() {
  return b6 || (b6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = m;
    var r = n(/* @__PURE__ */ ht());
    function n(f) {
      return f && f.__esModule ? f : { default: f };
    }
    function o(f, $) {
      return i(f) || d(f, $) || u(f, $) || a();
    }
    function a() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function d(f, $) {
      var v = f == null ? null : typeof Symbol < "u" && f[Symbol.iterator] || f["@@iterator"];
      if (v != null) {
        var y, S, w, _, I = [], N = !0, O = !1;
        try {
          if (w = (v = v.call(f)).next, $ !== 0) for (; !(N = (y = w.call(v)).done) && (I.push(y.value), I.length !== $); N = !0) ;
        } catch (E) {
          O = !0, S = E;
        } finally {
          try {
            if (!N && v.return != null && (_ = v.return(), Object(_) !== _)) return;
          } finally {
            if (O) throw S;
          }
        }
        return I;
      }
    }
    function i(f) {
      if (Array.isArray(f)) return f;
    }
    function s(f, $) {
      var v = typeof Symbol < "u" && f[Symbol.iterator] || f["@@iterator"];
      if (!v) {
        if (Array.isArray(f) || (v = u(f)) || $) {
          v && (f = v);
          var y = 0, S = function() {
          };
          return { s: S, n: function() {
            return y >= f.length ? { done: !0 } : { done: !1, value: f[y++] };
          }, e: function(N) {
            throw N;
          }, f: S };
        }
        throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }
      var w, _ = !0, I = !1;
      return { s: function() {
        v = v.call(f);
      }, n: function() {
        var N = v.next();
        return _ = N.done, N;
      }, e: function(N) {
        I = !0, w = N;
      }, f: function() {
        try {
          _ || v.return == null || v.return();
        } finally {
          if (I) throw w;
        }
      } };
    }
    function u(f, $) {
      if (f) {
        if (typeof f == "string") return c(f, $);
        var v = {}.toString.call(f).slice(8, -1);
        return v === "Object" && f.constructor && (v = f.constructor.name), v === "Map" || v === "Set" ? Array.from(f) : v === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(v) ? c(f, $) : void 0;
      }
    }
    function c(f, $) {
      ($ == null || $ > f.length) && ($ = f.length);
      for (var v = 0, y = Array($); v < $; v++) y[v] = f[v];
      return y;
    }
    var l = {
      format: "YYYY/MM/DD",
      delimiters: ["/", "-"],
      strictMode: !1
    };
    function p(f) {
      return /(^(y{4}|y{2})[.\/-](m{1,2})[.\/-](d{1,2})$)|(^(m{1,2})[.\/-](d{1,2})[.\/-]((y{4}|y{2})$))|(^(d{1,2})[.\/-](m{1,2})[.\/-]((y{4}|y{2})$))/gi.test(f);
    }
    function h(f, $) {
      for (var v = [], y = Math.max(f.length, $.length), S = 0; S < y; S++)
        v.push([f[S], $[S]]);
      return v;
    }
    function m(f, $) {
      if (typeof $ == "string" ? $ = (0, r.default)({
        format: $
      }, l) : $ = (0, r.default)($, l), typeof f == "string" && p($.format)) {
        if ($.strictMode && f.length !== $.format.length) return !1;
        var v = $.delimiters.find(function(Z) {
          return $.format.indexOf(Z) !== -1;
        }), y = $.strictMode ? v : $.delimiters.find(function(Z) {
          return f.indexOf(Z) !== -1;
        }), S = h(f.split(y), $.format.toLowerCase().split(v)), w = {}, _ = s(S), I;
        try {
          for (_.s(); !(I = _.n()).done; ) {
            var N = o(I.value, 2), O = N[0], E = N[1];
            if (!O || !E || O.length !== E.length)
              return !1;
            w[E.charAt(0)] = O;
          }
        } catch (Z) {
          _.e(Z);
        } finally {
          _.f();
        }
        var C = w.y;
        if (C.startsWith("-"))
          return !1;
        if (w.y.length === 2) {
          var P = parseInt(w.y, 10);
          if (isNaN(P))
            return !1;
          var T = (/* @__PURE__ */ new Date()).getFullYear() % 100;
          P < T ? C = "20".concat(w.y) : C = "19".concat(w.y);
        }
        var j = w.m;
        w.m.length === 1 && (j = "0".concat(w.m));
        var F = w.d;
        return w.d.length === 1 && (F = "0".concat(w.d)), new Date("".concat(C, "-").concat(j, "-").concat(F, "T00:00:00.000Z")).getUTCDate() === +w.d;
      }
      return $.strictMode ? !1 : Object.prototype.toString.call(f) === "[object Date]" && isFinite(f);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Xl, Xl.exports)), Xl.exports;
}
var ql = { exports: {} }, x6;
function aY() {
  return x6 || (x6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = n(/* @__PURE__ */ ht());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var o = {
      hourFormat: "hour24",
      mode: "default"
    }, a = {
      hour24: {
        default: /^([01]?[0-9]|2[0-3]):([0-5][0-9])$/,
        withSeconds: /^([01]?[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/
      },
      hour12: {
        default: /^(0?[1-9]|1[0-2]):([0-5][0-9]) (A|P)M$/,
        withSeconds: /^(0?[1-9]|1[0-2]):([0-5][0-9]):([0-5][0-9]) (A|P)M$/
      }
    };
    function d(i, s) {
      return s = (0, r.default)(s, o), typeof i != "string" ? !1 : a[s.hourFormat][s.mode].test(i);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(ql, ql.exports)), ql.exports;
}
var Jl = { exports: {} }, w6;
function dY() {
  return w6 || (w6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ Q());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /^(?!(1[3-9])|(20)|(3[3-9])|(4[0-9])|(5[0-9])|(60)|(7[3-9])|(8[1-9])|(9[0-2])|(9[3-9]))[0-9]{9}$/;
    function a(d) {
      if ((0, r.default)(d), !o.test(d)) return !1;
      for (var i = 0, s = 0; s < d.length; s++)
        s % 3 === 0 ? i += d[s] * 3 : s % 3 === 1 ? i += d[s] * 7 : i += d[s] * 1;
      return i % 10 === 0;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Jl, Jl.exports)), Jl.exports;
}
var Ql = { exports: {} }, A6;
function iY() {
  return A6 || (A6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = n(/* @__PURE__ */ Q());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var o = /^[0-9]{15}$/, a = /^\d{2}-\d{6}-\d{6}-\d{1}$/;
    function d(i, s) {
      (0, r.default)(i), s = s || {};
      var u = o;
      if (s.allow_hyphens && (u = a), !u.test(i))
        return !1;
      i = i.replace(/-/g, "");
      for (var c = 0, l = 2, p = 14, h = 0; h < p; h++) {
        var m = i.substring(p - h - 1, p - h), f = parseInt(m, 10) * l;
        f >= 10 ? c += f % 10 + 1 : c += f, l === 1 ? l += 1 : l -= 1;
      }
      var $ = (10 - c % 10) % 10;
      return $ === parseInt(i.substring(14, 15), 10);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Ql, Ql.exports)), Ql.exports;
}
var ec = { exports: {} }, S6;
function sY() {
  return S6 || (S6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ Q());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /^[a-f0-9]{32}$/;
    function a(d) {
      return (0, r.default)(d), o.test(d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(ec, ec.exports)), ec.exports;
}
var tc = { exports: {} }, _6;
function uY() {
  return _6 || (_6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = o(/* @__PURE__ */ Q()), n = o(/* @__PURE__ */ ht());
    function o(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var a = {
      ignore_whitespace: !1
    };
    function d(i, s) {
      return (0, r.default)(i), s = (0, n.default)(s, a), (s.ignore_whitespace ? i.trim().length : i.length) === 0;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(tc, tc.exports)), tc.exports;
}
var rc = { exports: {} }, E6;
function lY() {
  return E6 || (E6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ Q());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a) {
      return (0, r.default)(a), /^[0-7][0-9A-HJKMNP-TV-Z]{25}$/i.test(a);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(rc, rc.exports)), rc.exports;
}
var nc = { exports: {} }, M6;
function cY() {
  return M6 || (M6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ M2());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a, d) {
      var i = (d == null ? void 0 : d.comparisonDate) || d || Date().toString(), s = (0, r.default)(i), u = (0, r.default)(a);
      return !!(u && s && u > s);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(nc, nc.exports)), nc.exports;
}
var oc = { exports: {} }, C6;
function fY() {
  return C6 || (C6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = o(/* @__PURE__ */ Q()), n = o(/* @__PURE__ */ M2());
    function o(d) {
      return d && d.__esModule ? d : { default: d };
    }
    function a(d) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : String(/* @__PURE__ */ new Date());
      (0, r.default)(d);
      var s = (0, n.default)(i), u = (0, n.default)(d);
      return !!(u && s && u < s);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(oc, oc.exports)), oc.exports;
}
var ac = { exports: {} }, O6;
function pY() {
  return O6 || (O6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = o(/* @__PURE__ */ Q()), n = o(/* @__PURE__ */ Ob());
    function o(i) {
      return i && i.__esModule ? i : { default: i };
    }
    function a(i) {
      "@babel/helpers - typeof";
      return a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
        return typeof s;
      } : function(s) {
        return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
      }, a(i);
    }
    function d(i, s) {
      (0, r.default)(i);
      var u;
      if (Object.prototype.toString.call(s) === "[object Array]") {
        var c = [];
        for (u in s)
          ({}).hasOwnProperty.call(s, u) && (c[u] = (0, n.default)(s[u]));
        return c.indexOf(i) >= 0;
      } else {
        if (a(s) === "object")
          return s.hasOwnProperty(i);
        if (s && typeof s.indexOf == "function")
          return s.indexOf(i) >= 0;
      }
      return !1;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(ac, ac.exports)), ac.exports;
}
var dc = { exports: {} }, nn = {}, N6;
function sS() {
  if (N6) return nn;
  N6 = 1, Object.defineProperty(nn, "__esModule", {
    value: !0
  }), nn.iso7064Check = e, nn.luhnCheck = t, nn.reverseMultiplyAndSum = r, nn.verhoeffCheck = n;
  function e(o) {
    for (var a = 10, d = 0; d < o.length - 1; d++)
      a = (parseInt(o[d], 10) + a) % 10 === 0 ? 10 * 2 % 11 : (parseInt(o[d], 10) + a) % 10 * 2 % 11;
    return a = a === 1 ? 0 : 11 - a, a === parseInt(o[10], 10);
  }
  function t(o) {
    for (var a = 0, d = !1, i = o.length - 1; i >= 0; i--) {
      if (d) {
        var s = parseInt(o[i], 10) * 2;
        s > 9 ? a += s.toString().split("").map(function(u) {
          return parseInt(u, 10);
        }).reduce(function(u, c) {
          return u + c;
        }, 0) : a += s;
      } else
        a += parseInt(o[i], 10);
      d = !d;
    }
    return a % 10 === 0;
  }
  function r(o, a) {
    for (var d = 0, i = 0; i < o.length; i++)
      d += o[i] * (a - i);
    return d;
  }
  function n(o) {
    for (var a = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 2, 3, 4, 0, 6, 7, 8, 9, 5], [2, 3, 4, 0, 1, 7, 8, 9, 5, 6], [3, 4, 0, 1, 2, 8, 9, 5, 6, 7], [4, 0, 1, 2, 3, 9, 5, 6, 7, 8], [5, 9, 8, 7, 6, 0, 4, 3, 2, 1], [6, 5, 9, 8, 7, 1, 0, 4, 3, 2], [7, 6, 5, 9, 8, 2, 1, 0, 4, 3], [8, 7, 6, 5, 9, 3, 2, 1, 0, 4], [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]], d = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 5, 7, 6, 2, 8, 3, 0, 9, 4], [5, 8, 0, 3, 7, 9, 6, 1, 4, 2], [8, 9, 1, 6, 0, 4, 3, 5, 2, 7], [9, 4, 5, 3, 1, 2, 6, 8, 7, 0], [4, 2, 8, 6, 5, 7, 3, 9, 0, 1], [2, 7, 9, 3, 8, 0, 6, 4, 1, 5], [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]], i = o.split("").reverse().join(""), s = 0, u = 0; u < i.length; u++)
      s = a[s][d[u % 8][parseInt(i[u], 10)]];
    return s === 0;
  }
  return nn;
}
var I6;
function uS() {
  return I6 || (I6 = 1, function(e, t) {
    function r(g) {
      "@babel/helpers - typeof";
      return r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(b) {
        return typeof b;
      } : function(b) {
        return b && typeof Symbol == "function" && b.constructor === Symbol && b !== Symbol.prototype ? "symbol" : typeof b;
      }, r(g);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = Rt;
    var n = s(/* @__PURE__ */ Q()), o = i(/* @__PURE__ */ sS()), a = s(/* @__PURE__ */ iS());
    function d(g) {
      if (typeof WeakMap != "function") return null;
      var b = /* @__PURE__ */ new WeakMap(), M = /* @__PURE__ */ new WeakMap();
      return (d = function(D) {
        return D ? M : b;
      })(g);
    }
    function i(g, b) {
      if (g && g.__esModule) return g;
      if (g === null || r(g) != "object" && typeof g != "function") return { default: g };
      var M = d(b);
      if (M && M.has(g)) return M.get(g);
      var D = { __proto__: null }, R = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var L in g) if (L !== "default" && {}.hasOwnProperty.call(g, L)) {
        var B = R ? Object.getOwnPropertyDescriptor(g, L) : null;
        B && (B.get || B.set) ? Object.defineProperty(D, L, B) : D[L] = g[L];
      }
      return D.default = g, M && M.set(g, D), D;
    }
    function s(g) {
      return g && g.__esModule ? g : { default: g };
    }
    function u(g) {
      return h(g) || p(g) || l(g) || c();
    }
    function c() {
      throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function l(g, b) {
      if (g) {
        if (typeof g == "string") return m(g, b);
        var M = {}.toString.call(g).slice(8, -1);
        return M === "Object" && g.constructor && (M = g.constructor.name), M === "Map" || M === "Set" ? Array.from(g) : M === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(M) ? m(g, b) : void 0;
      }
    }
    function p(g) {
      if (typeof Symbol < "u" && g[Symbol.iterator] != null || g["@@iterator"] != null) return Array.from(g);
    }
    function h(g) {
      if (Array.isArray(g)) return m(g);
    }
    function m(g, b) {
      (b == null || b > g.length) && (b = g.length);
      for (var M = 0, D = Array(b); M < b; M++) D[M] = g[M];
      return D;
    }
    function f(g) {
      var b = g.slice(0, 2), M = parseInt(g.slice(2, 4), 10);
      M > 40 ? (M -= 40, b = "20".concat(b)) : M > 20 ? (M -= 20, b = "18".concat(b)) : b = "19".concat(b), M < 10 && (M = "0".concat(M));
      var D = "".concat(b, "/").concat(M, "/").concat(g.slice(4, 6));
      if (!(0, a.default)(D, "YYYY/MM/DD"))
        return !1;
      for (var R = g.split("").map(function(oe) {
        return parseInt(oe, 10);
      }), L = [2, 4, 8, 5, 10, 9, 7, 3, 6], B = 0, V = 0; V < L.length; V++)
        B += R[V] * L[V];
      return B = B % 11 === 10 ? 0 : B % 11, B === R[9];
    }
    function $(g) {
      var b = g.split(""), M = b.filter(function(R, L) {
        return L % 2;
      }).map(function(R) {
        return Number(R) * 2;
      }).join("").split(""), D = b.filter(function(R, L) {
        return !(L % 2);
      }).concat(M).map(function(R) {
        return Number(R);
      }).reduce(function(R, L) {
        return R + L;
      });
      return D % 10 === 0;
    }
    function v(g) {
      g = g.replace(/\W/, "");
      var b = parseInt(g.slice(0, 2), 10);
      if (g.length === 10)
        b < 54 ? b = "20".concat(b) : b = "19".concat(b);
      else {
        if (g.slice(6) === "000")
          return !1;
        if (b < 54)
          b = "19".concat(b);
        else
          return !1;
      }
      b.length === 3 && (b = [b.slice(0, 2), "0", b.slice(2)].join(""));
      var M = parseInt(g.slice(2, 4), 10);
      if (M > 50 && (M -= 50), M > 20) {
        if (parseInt(b, 10) < 2004)
          return !1;
        M -= 20;
      }
      M < 10 && (M = "0".concat(M));
      var D = "".concat(b, "/").concat(M, "/").concat(g.slice(4, 6));
      if (!(0, a.default)(D, "YYYY/MM/DD"))
        return !1;
      if (g.length === 10 && parseInt(g, 10) % 11 !== 0) {
        var R = parseInt(g.slice(0, 9), 10) % 11;
        if (parseInt(b, 10) < 1986 && R === 10) {
          if (parseInt(g.slice(9), 10) !== 0)
            return !1;
        } else
          return !1;
      }
      return !0;
    }
    function y(g) {
      return o.luhnCheck(g);
    }
    function S(g) {
      for (var b = g.split("").map(function(oe) {
        return parseInt(oe, 10);
      }), M = [], D = 0; D < b.length - 1; D++) {
        M.push("");
        for (var R = 0; R < b.length - 1; R++)
          b[D] === b[R] && (M[D] += R);
      }
      if (M = M.filter(function(oe) {
        return oe.length > 1;
      }), M.length !== 2 && M.length !== 3)
        return !1;
      if (M[0].length === 3) {
        for (var L = M[0].split("").map(function(oe) {
          return parseInt(oe, 10);
        }), B = 0, V = 0; V < L.length - 1; V++)
          L[V] + 1 === L[V + 1] && (B += 1);
        if (B === 2)
          return !1;
      }
      return o.iso7064Check(g);
    }
    function w(g) {
      g = g.replace(/\W/, "");
      var b = parseInt(g.slice(4, 6), 10), M = g.slice(6, 7);
      switch (M) {
        case "0":
        case "1":
        case "2":
        case "3":
          b = "19".concat(b);
          break;
        case "4":
        case "9":
          b < 37 ? b = "20".concat(b) : b = "19".concat(b);
          break;
        default:
          if (b < 37)
            b = "20".concat(b);
          else if (b > 58)
            b = "18".concat(b);
          else
            return !1;
          break;
      }
      b.length === 3 && (b = [b.slice(0, 2), "0", b.slice(2)].join(""));
      var D = "".concat(b, "/").concat(g.slice(2, 4), "/").concat(g.slice(0, 2));
      if (!(0, a.default)(D, "YYYY/MM/DD"))
        return !1;
      for (var R = g.split("").map(function(oe) {
        return parseInt(oe, 10);
      }), L = 0, B = 4, V = 0; V < 9; V++)
        L += R[V] * B, B -= 1, B === 1 && (B = 7);
      return L %= 11, L === 1 ? !1 : L === 0 ? R[9] === 0 : R[9] === 11 - L;
    }
    function _(g) {
      for (var b = g.slice(0, 8).split("").map(function(L) {
        return parseInt(L, 10);
      }), M = 0, D = 1; D < b.length; D += 2)
        M += b[D];
      for (var R = 0; R < b.length; R += 2)
        b[R] < 2 ? M += 1 - b[R] : (M += 2 * (b[R] - 2) + 5, b[R] > 4 && (M += 2));
      return String.fromCharCode(M % 26 + 65) === g.charAt(8);
    }
    function I(g) {
      for (var b = g.split("").map(function(R) {
        return parseInt(R, 10);
      }), M = 0, D = 0; D < 8; D++)
        M += b[D] * Math.pow(2, 8 - D);
      return M % 11 % 10 === b[8];
    }
    function N(g) {
      var b = o.reverseMultiplyAndSum(g.split("").slice(0, 7).map(function(M) {
        return parseInt(M, 10);
      }), 8);
      return g.length === 9 && g[8] !== "W" && (b += (g[8].charCodeAt(0) - 64) * 9), b %= 23, b === 0 ? g[7].toUpperCase() === "W" : g[7].toUpperCase() === String.fromCharCode(64 + b);
    }
    var O = {
      andover: ["10", "12"],
      atlanta: ["60", "67"],
      austin: ["50", "53"],
      brookhaven: ["01", "02", "03", "04", "05", "06", "11", "13", "14", "16", "21", "22", "23", "25", "34", "51", "52", "54", "55", "56", "57", "58", "59", "65"],
      cincinnati: ["30", "32", "35", "36", "37", "38", "61"],
      fresno: ["15", "24"],
      internet: ["20", "26", "27", "45", "46", "47"],
      kansas: ["40", "44"],
      memphis: ["94", "95"],
      ogden: ["80", "90"],
      philadelphia: ["33", "39", "41", "42", "43", "46", "48", "62", "63", "64", "66", "68", "71", "72", "73", "74", "75", "76", "77", "81", "82", "83", "84", "85", "86", "87", "88", "91", "92", "93", "98", "99"],
      sba: ["31"]
    };
    function E() {
      var g = [];
      for (var b in O)
        O.hasOwnProperty(b) && g.push.apply(g, u(O[b]));
      return g;
    }
    function C(g) {
      return E().indexOf(g.slice(0, 2)) !== -1;
    }
    function P(g) {
      for (var b = 0, M = g.split(""), D = parseInt(M.pop(), 10), R = 0; R < M.length; R++)
        b += M[9 - R] * (2 + R % 6);
      var L = 11 - b % 11;
      return L === 11 ? L = 0 : L === 10 && (L = 9), D === L;
    }
    function T(g) {
      var b = g.toUpperCase().split("");
      if (isNaN(parseInt(b[0], 10)) && b.length > 1) {
        var M = 0;
        switch (b[0]) {
          case "Y":
            M = 1;
            break;
          case "Z":
            M = 2;
            break;
        }
        b.splice(0, 1, M);
      } else
        for (; b.length < 9; )
          b.unshift(0);
      var D = ["T", "R", "W", "A", "G", "M", "Y", "F", "P", "D", "X", "B", "N", "J", "Z", "S", "Q", "V", "H", "L", "C", "K", "E"];
      b = b.join("");
      var R = parseInt(b.slice(0, 8), 10) % 23;
      return b[8] === D[R];
    }
    function j(g) {
      var b = g.slice(1, 3), M = g.slice(0, 1);
      switch (M) {
        case "1":
        case "2":
          b = "18".concat(b);
          break;
        case "3":
        case "4":
          b = "19".concat(b);
          break;
        default:
          b = "20".concat(b);
          break;
      }
      var D = "".concat(b, "/").concat(g.slice(3, 5), "/").concat(g.slice(5, 7));
      if (!(0, a.default)(D, "YYYY/MM/DD"))
        return !1;
      for (var R = g.split("").map(function(me) {
        return parseInt(me, 10);
      }), L = 0, B = 1, V = 0; V < 10; V++)
        L += R[V] * B, B += 1, B === 10 && (B = 1);
      if (L % 11 === 10) {
        L = 0, B = 3;
        for (var oe = 0; oe < 10; oe++)
          L += R[oe] * B, B += 1, B === 10 && (B = 1);
        if (L % 11 === 10)
          return R[10] === 0;
      }
      return L % 11 === R[10];
    }
    function F(g) {
      var b = g.slice(4, 6), M = g.slice(6, 7);
      switch (M) {
        case "+":
          b = "18".concat(b);
          break;
        case "-":
          b = "19".concat(b);
          break;
        default:
          b = "20".concat(b);
          break;
      }
      var D = "".concat(b, "/").concat(g.slice(2, 4), "/").concat(g.slice(0, 2));
      if (!(0, a.default)(D, "YYYY/MM/DD"))
        return !1;
      var R = parseInt(g.slice(0, 6) + g.slice(7, 10), 10) % 31;
      if (R < 10)
        return R === parseInt(g.slice(10), 10);
      R -= 10;
      var L = ["A", "B", "C", "D", "E", "F", "H", "J", "K", "L", "M", "N", "P", "R", "S", "T", "U", "V", "W", "X", "Y"];
      return L[R] === g.slice(10);
    }
    function Z(g) {
      if (g.slice(2, 4) !== "00" || g.slice(4, 6) !== "00") {
        var b = "".concat(g.slice(0, 2), "/").concat(g.slice(2, 4), "/").concat(g.slice(4, 6));
        if (!(0, a.default)(b, "YY/MM/DD"))
          return !1;
      }
      var M = 97 - parseInt(g.slice(0, 9), 10) % 97, D = parseInt(g.slice(9, 11), 10);
      return !(M !== D && (M = 97 - parseInt("2".concat(g.slice(0, 9)), 10) % 97, M !== D));
    }
    function te(g) {
      g = g.replace(/\s/g, "");
      var b = parseInt(g.slice(0, 10), 10) % 511, M = parseInt(g.slice(10, 13), 10);
      return b === M;
    }
    function H(g) {
      var b = "".concat(g.slice(0, 4), "/").concat(g.slice(4, 6), "/").concat(g.slice(6, 8));
      return !(0, a.default)(b, "YYYY/MM/DD") || !o.luhnCheck(g.slice(0, 12)) ? !1 : o.verhoeffCheck("".concat(g.slice(0, 11)).concat(g[12]));
    }
    function de(g) {
      return o.iso7064Check(g);
    }
    function G(g) {
      for (var b = g.split("").map(function(R) {
        return parseInt(R, 10);
      }), M = 8, D = 1; D < 9; D++)
        M += b[D] * (D + 1);
      return M % 11 === b[9];
    }
    function le(g) {
      for (var b = !1, M = !1, D = 0; D < 3; D++)
        if (!b && /[AEIOU]/.test(g[D]))
          b = !0;
        else if (!M && b && g[D] === "X")
          M = !0;
        else if (D > 0 && (b && !M && !/[AEIOU]/.test(g[D]) || M && !/X/.test(g[D])))
          return !1;
      return !0;
    }
    function fe(g) {
      var b = g.toUpperCase().split("");
      if (!le(b.slice(0, 3)) || !le(b.slice(3, 6)))
        return !1;
      for (var M = [6, 7, 9, 10, 12, 13, 14], D = {
        L: "0",
        M: "1",
        N: "2",
        P: "3",
        Q: "4",
        R: "5",
        S: "6",
        T: "7",
        U: "8",
        V: "9"
      }, R = 0, L = M; R < L.length; R++) {
        var B = L[R];
        b[B] in D && b.splice(B, 1, D[b[B]]);
      }
      var V = {
        A: "01",
        B: "02",
        C: "03",
        D: "04",
        E: "05",
        H: "06",
        L: "07",
        M: "08",
        P: "09",
        R: "10",
        S: "11",
        T: "12"
      }, oe = V[b[8]], me = parseInt(b[9] + b[10], 10);
      me > 40 && (me -= 40), me < 10 && (me = "0".concat(me));
      var He = "".concat(b[6]).concat(b[7], "/").concat(oe, "/").concat(me);
      if (!(0, a.default)(He, "YY/MM/DD"))
        return !1;
      for (var Ke = 0, Le = 1; Le < b.length - 1; Le += 2) {
        var st = parseInt(b[Le], 10);
        isNaN(st) && (st = b[Le].charCodeAt(0) - 65), Ke += st;
      }
      for (var Bt = {
        // Maps of characters at odd places
        A: 1,
        B: 0,
        C: 5,
        D: 7,
        E: 9,
        F: 13,
        G: 15,
        H: 17,
        I: 19,
        J: 21,
        K: 2,
        L: 4,
        M: 18,
        N: 20,
        O: 11,
        P: 3,
        Q: 6,
        R: 8,
        S: 12,
        T: 14,
        U: 16,
        V: 10,
        W: 22,
        X: 25,
        Y: 24,
        Z: 23,
        0: 1,
        1: 0
      }, Qe = 0; Qe < b.length - 1; Qe += 2) {
        var ut = 0;
        if (b[Qe] in Bt)
          ut = Bt[b[Qe]];
        else {
          var Tt = parseInt(b[Qe], 10);
          ut = 2 * Tt + 1, Tt > 4 && (ut += 2);
        }
        Ke += ut;
      }
      return String.fromCharCode(65 + Ke % 26) === b[15];
    }
    function U(g) {
      g = g.replace(/\W/, "");
      var b = g.slice(0, 2);
      if (b !== "32") {
        var M = g.slice(2, 4);
        if (M !== "00") {
          var D = g.slice(4, 6);
          switch (g[6]) {
            case "0":
              D = "18".concat(D);
              break;
            case "1":
              D = "19".concat(D);
              break;
            default:
              D = "20".concat(D);
              break;
          }
          var R = "".concat(D, "/").concat(g.slice(2, 4), "/").concat(b);
          if (!(0, a.default)(R, "YYYY/MM/DD"))
            return !1;
        }
        for (var L = 1101, B = [1, 6, 3, 7, 9, 10, 5, 8, 4, 2], V = 0; V < g.length - 1; V++)
          L -= parseInt(g[V], 10) * B[V];
        return parseInt(g[10], 10) === L % 11;
      }
      return !0;
    }
    function ae(g) {
      if (g.length !== 9) {
        for (var b = g.toUpperCase().split(""); b.length < 8; )
          b.unshift(0);
        switch (g[7]) {
          case "A":
          case "P":
            if (parseInt(b[6], 10) === 0)
              return !1;
            break;
          default: {
            var M = parseInt(b.join("").slice(0, 5), 10);
            if (M > 32e3)
              return !1;
            var D = parseInt(b.join("").slice(5, 7), 10);
            if (M === D)
              return !1;
          }
        }
      }
      return !0;
    }
    function ue(g) {
      return o.reverseMultiplyAndSum(g.split("").slice(0, 8).map(function(b) {
        return parseInt(b, 10);
      }), 9) % 11 === parseInt(g[8], 10);
    }
    function se(g) {
      if (g.length === 10) {
        for (var b = [6, 5, 7, 2, 3, 4, 5, 6, 7], M = 0, D = 0; D < b.length; D++)
          M += parseInt(g[D], 10) * b[D];
        return M %= 11, M === 10 ? !1 : M === parseInt(g[9], 10);
      }
      var R = g.slice(0, 2), L = parseInt(g.slice(2, 4), 10);
      L > 80 ? (R = "18".concat(R), L -= 80) : L > 60 ? (R = "22".concat(R), L -= 60) : L > 40 ? (R = "21".concat(R), L -= 40) : L > 20 ? (R = "20".concat(R), L -= 20) : R = "19".concat(R), L < 10 && (L = "0".concat(L));
      var B = "".concat(R, "/").concat(L, "/").concat(g.slice(4, 6));
      if (!(0, a.default)(B, "YYYY/MM/DD"))
        return !1;
      for (var V = 0, oe = 1, me = 0; me < g.length - 1; me++)
        V += parseInt(g[me], 10) * oe % 10, oe += 2, oe > 10 ? oe = 1 : oe === 5 && (oe += 2);
      return V = 10 - V % 10, V === parseInt(g[10], 10);
    }
    function we(g) {
      if (g.length === 11) {
        var b, M;
        if (b = 0, // Reject known invalid CPFs
        g === "11111111111" || g === "22222222222" || g === "33333333333" || g === "44444444444" || g === "55555555555" || g === "66666666666" || g === "77777777777" || g === "88888888888" || g === "99999999999" || g === "00000000000") return !1;
        for (var D = 1; D <= 9; D++) b += parseInt(g.substring(D - 1, D), 10) * (11 - D);
        if (M = b * 10 % 11, M === 10 && (M = 0), M !== parseInt(g.substring(9, 10), 10)) return !1;
        b = 0;
        for (var R = 1; R <= 10; R++) b += parseInt(g.substring(R - 1, R), 10) * (12 - R);
        return M = b * 10 % 11, M === 10 && (M = 0), M === parseInt(g.substring(10, 11), 10);
      }
      if (
        // Reject know invalid CNPJs
        g === "00000000000000" || g === "11111111111111" || g === "22222222222222" || g === "33333333333333" || g === "44444444444444" || g === "55555555555555" || g === "66666666666666" || g === "77777777777777" || g === "88888888888888" || g === "99999999999999"
      )
        return !1;
      for (var L = g.length - 2, B = g.substring(0, L), V = g.substring(L), oe = 0, me = L - 7, He = L; He >= 1; He--)
        oe += B.charAt(L - He) * me, me -= 1, me < 2 && (me = 9);
      var Ke = oe % 11 < 2 ? 0 : 11 - oe % 11;
      if (Ke !== parseInt(V.charAt(0), 10))
        return !1;
      L += 1, B = g.substring(0, L), oe = 0, me = L - 7;
      for (var Le = L; Le >= 1; Le--)
        oe += B.charAt(L - Le) * me, me -= 1, me < 2 && (me = 9);
      return Ke = oe % 11 < 2 ? 0 : 11 - oe % 11, Ke === parseInt(V.charAt(1), 10);
    }
    function re(g) {
      var b = 11 - o.reverseMultiplyAndSum(g.split("").slice(0, 8).map(function(M) {
        return parseInt(M, 10);
      }), 9) % 11;
      return b > 9 ? parseInt(g[8], 10) === 0 : b === parseInt(g[8], 10);
    }
    function ye(g) {
      if (g.slice(0, 4) !== "9000") {
        var b = g.slice(1, 3);
        switch (g[0]) {
          case "1":
          case "2":
            b = "19".concat(b);
            break;
          case "3":
          case "4":
            b = "18".concat(b);
            break;
          case "5":
          case "6":
            b = "20".concat(b);
            break;
        }
        var M = "".concat(b, "/").concat(g.slice(3, 5), "/").concat(g.slice(5, 7));
        if (M.length === 8) {
          if (!(0, a.default)(M, "YY/MM/DD"))
            return !1;
        } else if (!(0, a.default)(M, "YYYY/MM/DD"))
          return !1;
        for (var D = g.split("").map(function(V) {
          return parseInt(V, 10);
        }), R = [2, 7, 9, 1, 4, 6, 3, 5, 8, 2, 7, 9], L = 0, B = 0; B < R.length; B++)
          L += D[B] * R[B];
        return L % 11 === 10 ? D[12] === 1 : D[12] === L % 11;
      }
      return !0;
    }
    function xe(g) {
      if (g.length === 9) {
        if (g = g.replace(/\W/, ""), g.slice(6) === "000")
          return !1;
        var b = parseInt(g.slice(0, 2), 10);
        if (b > 53)
          return !1;
        b < 10 ? b = "190".concat(b) : b = "19".concat(b);
        var M = parseInt(g.slice(2, 4), 10);
        M > 50 && (M -= 50), M < 10 && (M = "0".concat(M));
        var D = "".concat(b, "/").concat(M, "/").concat(g.slice(4, 6));
        if (!(0, a.default)(D, "YYYY/MM/DD"))
          return !1;
      }
      return !0;
    }
    function be(g) {
      var b = 11 - o.reverseMultiplyAndSum(g.split("").slice(0, 7).map(function(M) {
        return parseInt(M, 10);
      }), 8) % 11;
      return b === 10 ? parseInt(g[7], 10) === 0 : b === parseInt(g[7], 10);
    }
    function ee(g) {
      var b = g.slice(0);
      g.length > 11 && (b = b.slice(2));
      var M = "", D = b.slice(2, 4), R = parseInt(b.slice(4, 6), 10);
      if (g.length > 11)
        M = g.slice(0, 4);
      else if (M = g.slice(0, 2), g.length === 11 && R < 60) {
        var L = (/* @__PURE__ */ new Date()).getFullYear().toString(), B = parseInt(L.slice(0, 2), 10);
        if (L = parseInt(L, 10), g[6] === "-")
          parseInt("".concat(B).concat(M), 10) > L ? M = "".concat(B - 1).concat(M) : M = "".concat(B).concat(M);
        else if (M = "".concat(B - 1).concat(M), L - parseInt(M, 10) < 100)
          return !1;
      }
      R > 60 && (R -= 60), R < 10 && (R = "0".concat(R));
      var V = "".concat(M, "/").concat(D, "/").concat(R);
      if (V.length === 8) {
        if (!(0, a.default)(V, "YY/MM/DD"))
          return !1;
      } else if (!(0, a.default)(V, "YYYY/MM/DD"))
        return !1;
      return o.luhnCheck(g.replace(/\W/, ""));
    }
    function ce(g) {
      for (var b = g.split("").map(function(L) {
        return parseInt(L, 10);
      }), M = [-1, 5, 7, 9, 4, 6, 10, 5, 7], D = 0, R = 0; R < M.length; R++)
        D += b[R] * M[R];
      return D % 11 === 10 ? b[9] === 0 : b[9] === D % 11;
    }
    var he = {
      "bg-BG": /^\d{10}$/,
      "cs-CZ": /^\d{6}\/{0,1}\d{3,4}$/,
      "de-AT": /^\d{9}$/,
      "de-DE": /^[1-9]\d{10}$/,
      "dk-DK": /^\d{6}-{0,1}\d{4}$/,
      "el-CY": /^[09]\d{7}[A-Z]$/,
      "el-GR": /^([0-4]|[7-9])\d{8}$/,
      "en-CA": /^\d{9}$/,
      "en-GB": /^\d{10}$|^(?!GB|NK|TN|ZZ)(?![DFIQUV])[A-Z](?![DFIQUVO])[A-Z]\d{6}[ABCD ]$/i,
      "en-IE": /^\d{7}[A-W][A-IW]{0,1}$/i,
      "en-US": /^\d{2}[- ]{0,1}\d{7}$/,
      "es-AR": /(20|23|24|27|30|33|34)[0-9]{8}[0-9]/,
      "es-ES": /^(\d{0,8}|[XYZKLM]\d{7})[A-HJ-NP-TV-Z]$/i,
      "et-EE": /^[1-6]\d{6}(00[1-9]|0[1-9][0-9]|[1-6][0-9]{2}|70[0-9]|710)\d$/,
      "fi-FI": /^\d{6}[-+A]\d{3}[0-9A-FHJ-NPR-Y]$/i,
      "fr-BE": /^\d{11}$/,
      "fr-FR": /^[0-3]\d{12}$|^[0-3]\d\s\d{2}(\s\d{3}){3}$/,
      // Conforms both to official spec and provided example
      "fr-LU": /^\d{13}$/,
      "hr-HR": /^\d{11}$/,
      "hu-HU": /^8\d{9}$/,
      "it-IT": /^[A-Z]{6}[L-NP-V0-9]{2}[A-EHLMPRST][L-NP-V0-9]{2}[A-ILMZ][L-NP-V0-9]{3}[A-Z]$/i,
      "lv-LV": /^\d{6}-{0,1}\d{5}$/,
      // Conforms both to DG TAXUD spec and original research
      "mt-MT": /^\d{3,7}[APMGLHBZ]$|^([1-8])\1\d{7}$/i,
      "nl-NL": /^\d{9}$/,
      "pl-PL": /^\d{10,11}$/,
      "pt-BR": /(?:^\d{11}$)|(?:^\d{14}$)/,
      "pt-PT": /^\d{9}$/,
      "ro-RO": /^\d{13}$/,
      "sk-SK": /^\d{6}\/{0,1}\d{3,4}$/,
      "sl-SI": /^[1-9]\d{7}$/,
      "sv-SE": /^(\d{6}[-+]{0,1}\d{4}|(18|19|20)\d{6}[-+]{0,1}\d{4})$/,
      "uk-UA": /^\d{10}$/
    };
    he["lb-LU"] = he["fr-LU"], he["lt-LT"] = he["et-EE"], he["nl-BE"] = he["fr-BE"], he["fr-CA"] = he["en-CA"];
    var Ee = {
      "bg-BG": f,
      "cs-CZ": v,
      "de-AT": y,
      "de-DE": S,
      "dk-DK": w,
      "el-CY": _,
      "el-GR": I,
      "en-CA": $,
      "en-IE": N,
      "en-US": C,
      "es-AR": P,
      "es-ES": T,
      "et-EE": j,
      "fi-FI": F,
      "fr-BE": Z,
      "fr-FR": te,
      "fr-LU": H,
      "hr-HR": de,
      "hu-HU": G,
      "it-IT": fe,
      "lv-LV": U,
      "mt-MT": ae,
      "nl-NL": ue,
      "pl-PL": se,
      "pt-BR": we,
      "pt-PT": re,
      "ro-RO": ye,
      "sk-SK": xe,
      "sl-SI": be,
      "sv-SE": ee,
      "uk-UA": ce
    };
    Ee["lb-LU"] = Ee["fr-LU"], Ee["lt-LT"] = Ee["et-EE"], Ee["nl-BE"] = Ee["fr-BE"], Ee["fr-CA"] = Ee["en-CA"];
    var ot = /[-\\\/!@#$%\^&\*\(\)\+\=\[\]]+/g, Ve = {
      "de-AT": ot,
      "de-DE": /[\/\\]/g,
      "fr-BE": ot
    };
    Ve["nl-BE"] = Ve["fr-BE"];
    function Rt(g) {
      var b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US";
      (0, n.default)(g);
      var M = g.slice(0);
      if (b in he)
        return b in Ve && (M = M.replace(Ve[b], "")), he[b].test(M) ? b in Ee ? Ee[b](M) : !0 : !1;
      throw new Error("Invalid locale '".concat(b, "'"));
    }
    e.exports = t.default, e.exports.default = t.default;
  }(dc, dc.exports)), dc.exports;
}
var uo = {}, P6;
function $Y() {
  if (P6) return uo;
  P6 = 1, Object.defineProperty(uo, "__esModule", {
    value: !0
  }), uo.isFreightContainerID = void 0, uo.isISO6346 = o;
  var e = t(/* @__PURE__ */ Q());
  function t(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var r = /^[A-Z]{3}(U[0-9]{7})|([J,Z][0-9]{6,7})$/, n = /^[0-9]$/;
  function o(a) {
    if ((0, e.default)(a), a = a.toUpperCase(), !r.test(a)) return !1;
    if (a.length === 11) {
      for (var d = 0, i = 0; i < a.length - 1; i++)
        if (n.test(a[i]))
          d += a[i] * Math.pow(2, i);
        else {
          var s = void 0, u = a.charCodeAt(i) - 55;
          u < 11 ? s = u : u >= 11 && u <= 20 ? s = 12 + u % 11 : u >= 21 && u <= 30 ? s = 23 + u % 21 : s = 34 + u % 31, d += s * Math.pow(2, i);
        }
      var c = d % 11;
      return c === 10 && (c = 0), Number(a[a.length - 1]) === c;
    }
    return !0;
  }
  return uo.isFreightContainerID = o, uo;
}
var ic = { exports: {} }, R6;
function vY() {
  return R6 || (R6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ Q());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /* @__PURE__ */ new Set(["aa", "ab", "ae", "af", "ak", "am", "an", "ar", "as", "av", "ay", "az", "az", "ba", "be", "bg", "bh", "bi", "bm", "bn", "bo", "br", "bs", "ca", "ce", "ch", "co", "cr", "cs", "cu", "cv", "cy", "da", "de", "dv", "dz", "ee", "el", "en", "eo", "es", "et", "eu", "fa", "ff", "fi", "fj", "fo", "fr", "fy", "ga", "gd", "gl", "gn", "gu", "gv", "ha", "he", "hi", "ho", "hr", "ht", "hu", "hy", "hz", "ia", "id", "ie", "ig", "ii", "ik", "io", "is", "it", "iu", "ja", "jv", "ka", "kg", "ki", "kj", "kk", "kl", "km", "kn", "ko", "kr", "ks", "ku", "kv", "kw", "ky", "la", "lb", "lg", "li", "ln", "lo", "lt", "lu", "lv", "mg", "mh", "mi", "mk", "ml", "mn", "mr", "ms", "mt", "my", "na", "nb", "nd", "ne", "ng", "nl", "nn", "no", "nr", "nv", "ny", "oc", "oj", "om", "or", "os", "pa", "pi", "pl", "ps", "pt", "qu", "rm", "rn", "ro", "ru", "rw", "sa", "sc", "sd", "se", "sg", "si", "sk", "sl", "sm", "sn", "so", "sq", "sr", "ss", "st", "su", "sv", "sw", "ta", "te", "tg", "th", "ti", "tk", "tl", "tn", "to", "tr", "ts", "tt", "tw", "ty", "ug", "uk", "ur", "uz", "ve", "vi", "vo", "wa", "wo", "xh", "yi", "yo", "za", "zh", "zu"]);
    function a(d) {
      return (0, r.default)(d), o.has(d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(ic, ic.exports)), ic.exports;
}
var lo = {}, T6;
function mY() {
  if (T6) return lo;
  T6 = 1, Object.defineProperty(lo, "__esModule", {
    value: !0
  }), lo.ScriptCodes = void 0, lo.default = n;
  var e = t(/* @__PURE__ */ Q());
  function t(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var r = /* @__PURE__ */ new Set(["Adlm", "Afak", "Aghb", "Ahom", "Arab", "Aran", "Armi", "Armn", "Avst", "Bali", "Bamu", "Bass", "Batk", "Beng", "Bhks", "Blis", "Bopo", "Brah", "Brai", "Bugi", "Buhd", "Cakm", "Cans", "Cari", "Cham", "Cher", "Chis", "Chrs", "Cirt", "Copt", "Cpmn", "Cprt", "Cyrl", "Cyrs", "Deva", "Diak", "Dogr", "Dsrt", "Dupl", "Egyd", "Egyh", "Egyp", "Elba", "Elym", "Ethi", "Gara", "Geok", "Geor", "Glag", "Gong", "Gonm", "Goth", "Gran", "Grek", "Gujr", "Gukh", "Guru", "Hanb", "Hang", "Hani", "Hano", "Hans", "Hant", "Hatr", "Hebr", "Hira", "Hluw", "Hmng", "Hmnp", "Hrkt", "Hung", "Inds", "Ital", "Jamo", "Java", "Jpan", "Jurc", "Kali", "Kana", "Kawi", "Khar", "Khmr", "Khoj", "Kitl", "Kits", "Knda", "Kore", "Kpel", "Krai", "Kthi", "Lana", "Laoo", "Latf", "Latg", "Latn", "Leke", "Lepc", "Limb", "Lina", "Linb", "Lisu", "Loma", "Lyci", "Lydi", "Mahj", "Maka", "Mand", "Mani", "Marc", "Maya", "Medf", "Mend", "Merc", "Mero", "Mlym", "Modi", "Mong", "Moon", "Mroo", "Mtei", "Mult", "Mymr", "Nagm", "Nand", "Narb", "Nbat", "Newa", "Nkdb", "Nkgb", "Nkoo", "Nshu", "Ogam", "Olck", "Onao", "Orkh", "Orya", "Osge", "Osma", "Ougr", "Palm", "Pauc", "Pcun", "Pelm", "Perm", "Phag", "Phli", "Phlp", "Phlv", "Phnx", "Plrd", "Piqd", "Prti", "Psin", "Qaaa", "Qaab", "Qaac", "Qaad", "Qaae", "Qaaf", "Qaag", "Qaah", "Qaai", "Qaaj", "Qaak", "Qaal", "Qaam", "Qaan", "Qaao", "Qaap", "Qaaq", "Qaar", "Qaas", "Qaat", "Qaau", "Qaav", "Qaaw", "Qaax", "Qaay", "Qaaz", "Qaba", "Qabb", "Qabc", "Qabd", "Qabe", "Qabf", "Qabg", "Qabh", "Qabi", "Qabj", "Qabk", "Qabl", "Qabm", "Qabn", "Qabo", "Qabp", "Qabq", "Qabr", "Qabs", "Qabt", "Qabu", "Qabv", "Qabw", "Qabx", "Ranj", "Rjng", "Rohg", "Roro", "Runr", "Samr", "Sara", "Sarb", "Saur", "Sgnw", "Shaw", "Shrd", "Shui", "Sidd", "Sidt", "Sind", "Sinh", "Sogd", "Sogo", "Sora", "Soyo", "Sund", "Sunu", "Sylo", "Syrc", "Syre", "Syrj", "Syrn", "Tagb", "Takr", "Tale", "Talu", "Taml", "Tang", "Tavt", "Tayo", "Telu", "Teng", "Tfng", "Tglg", "Thaa", "Thai", "Tibt", "Tirh", "Tnsa", "Todr", "Tols", "Toto", "Tutg", "Ugar", "Vaii", "Visp", "Vith", "Wara", "Wcho", "Wole", "Xpeo", "Xsux", "Yezi", "Yiii", "Zanb", "Zinh", "Zmth", "Zsye", "Zsym", "Zxxx", "Zyyy", "Zzzz"]);
  function n(o) {
    return (0, e.default)(o), r.has(o);
  }
  return lo.ScriptCodes = r, lo;
}
var sc = { exports: {} }, D6;
function hY() {
  return D6 || (D6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ Q());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /* @__PURE__ */ new Set(["004", "008", "010", "012", "016", "020", "024", "028", "031", "032", "036", "040", "044", "048", "050", "051", "052", "056", "060", "064", "068", "070", "072", "074", "076", "084", "086", "090", "092", "096", "100", "104", "108", "112", "116", "120", "124", "132", "136", "140", "144", "148", "152", "156", "158", "162", "166", "170", "174", "175", "178", "180", "184", "188", "191", "192", "196", "203", "204", "208", "212", "214", "218", "222", "226", "231", "232", "233", "234", "238", "239", "242", "246", "248", "250", "254", "258", "260", "262", "266", "268", "270", "275", "276", "288", "292", "296", "300", "304", "308", "312", "316", "320", "324", "328", "332", "334", "336", "340", "344", "348", "352", "356", "360", "364", "368", "372", "376", "380", "384", "388", "392", "398", "400", "404", "408", "410", "414", "417", "418", "422", "426", "428", "430", "434", "438", "440", "442", "446", "450", "454", "458", "462", "466", "470", "474", "478", "480", "484", "492", "496", "498", "499", "500", "504", "508", "512", "516", "520", "524", "528", "531", "533", "534", "535", "540", "548", "554", "558", "562", "566", "570", "574", "578", "580", "581", "583", "584", "585", "586", "591", "598", "600", "604", "608", "612", "616", "620", "624", "626", "630", "634", "638", "642", "643", "646", "652", "654", "659", "660", "662", "663", "666", "670", "674", "678", "682", "686", "688", "690", "694", "702", "703", "704", "705", "706", "710", "716", "724", "728", "729", "732", "740", "744", "748", "752", "756", "760", "762", "764", "768", "772", "776", "780", "784", "788", "792", "795", "796", "798", "800", "804", "807", "818", "826", "831", "832", "833", "834", "840", "850", "854", "858", "860", "862", "876", "882", "887", "894"]);
    function a(d) {
      return (0, r.default)(d), o.has(d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(sc, sc.exports)), sc.exports;
}
var co = {}, L6;
function lS() {
  if (L6) return co;
  L6 = 1, Object.defineProperty(co, "__esModule", {
    value: !0
  }), co.CurrencyCodes = void 0, co.default = n;
  var e = t(/* @__PURE__ */ Q());
  function t(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var r = /* @__PURE__ */ new Set(["AED", "AFN", "ALL", "AMD", "ANG", "AOA", "ARS", "AUD", "AWG", "AZN", "BAM", "BBD", "BDT", "BGN", "BHD", "BIF", "BMD", "BND", "BOB", "BOV", "BRL", "BSD", "BTN", "BWP", "BYN", "BZD", "CAD", "CDF", "CHE", "CHF", "CHW", "CLF", "CLP", "CNY", "COP", "COU", "CRC", "CUP", "CVE", "CZK", "DJF", "DKK", "DOP", "DZD", "EGP", "ERN", "ETB", "EUR", "FJD", "FKP", "GBP", "GEL", "GHS", "GIP", "GMD", "GNF", "GTQ", "GYD", "HKD", "HNL", "HTG", "HUF", "IDR", "ILS", "INR", "IQD", "IRR", "ISK", "JMD", "JOD", "JPY", "KES", "KGS", "KHR", "KMF", "KPW", "KRW", "KWD", "KYD", "KZT", "LAK", "LBP", "LKR", "LRD", "LSL", "LYD", "MAD", "MDL", "MGA", "MKD", "MMK", "MNT", "MOP", "MRU", "MUR", "MVR", "MWK", "MXN", "MXV", "MYR", "MZN", "NAD", "NGN", "NIO", "NOK", "NPR", "NZD", "OMR", "PAB", "PEN", "PGK", "PHP", "PKR", "PLN", "PYG", "QAR", "RON", "RSD", "RUB", "RWF", "SAR", "SBD", "SCR", "SDG", "SEK", "SGD", "SHP", "SLE", "SLL", "SOS", "SRD", "SSP", "STN", "SVC", "SYP", "SZL", "THB", "TJS", "TMT", "TND", "TOP", "TRY", "TTD", "TWD", "TZS", "UAH", "UGX", "USD", "USN", "UYI", "UYU", "UYW", "UZS", "VED", "VES", "VND", "VUV", "WST", "XAF", "XAG", "XAU", "XBA", "XBB", "XBC", "XBD", "XCD", "XDR", "XOF", "XPD", "XPF", "XPT", "XSU", "XTS", "XUA", "XXX", "YER", "ZAR", "ZMW", "ZWL"]);
  function n(o) {
    return (0, e.default)(o), r.has(o.toUpperCase());
  }
  return co.CurrencyCodes = r, co;
}
var uc = { exports: {} }, F6;
function cS() {
  return F6 || (F6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ Q());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /^[A-HJ-NP-Za-km-z1-9]*$/;
    function a(d) {
      return (0, r.default)(d), !!o.test(d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(uc, uc.exports)), uc.exports;
}
var lc = { exports: {} }, cc = { exports: {} }, fc = { exports: {} }, k6;
function fS() {
  return k6 || (k6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ Q());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a, d) {
      if ((0, r.default)(a), d) {
        var i = new RegExp("[".concat(d.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "]+$"), "g");
        return a.replace(i, "");
      }
      for (var s = a.length - 1; /\s/.test(a.charAt(s)); )
        s -= 1;
      return a.slice(0, s + 1);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(fc, fc.exports)), fc.exports;
}
var pc = { exports: {} }, j6;
function pS() {
  return j6 || (j6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ Q());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a, d) {
      (0, r.default)(a);
      var i = d ? new RegExp("^[".concat(d.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "]+"), "g") : /^\s+/g;
      return a.replace(i, "");
    }
    e.exports = t.default, e.exports.default = t.default;
  }(pc, pc.exports)), pc.exports;
}
var B6;
function $S() {
  return B6 || (B6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = o(/* @__PURE__ */ fS()), n = o(/* @__PURE__ */ pS());
    function o(d) {
      return d && d.__esModule ? d : { default: d };
    }
    function a(d, i) {
      return (0, r.default)((0, n.default)(d, i), i);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(cc, cc.exports)), cc.exports;
}
var Z6;
function gY() {
  return Z6 || (Z6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = m;
    var r = a(/* @__PURE__ */ $S()), n = a(/* @__PURE__ */ $2()), o = a(/* @__PURE__ */ Q());
    function a(f) {
      return f && f.__esModule ? f : { default: f };
    }
    function d(f, $) {
      return u(f) || s(f, $) || l(f, $) || i();
    }
    function i() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function s(f, $) {
      var v = f == null ? null : typeof Symbol < "u" && f[Symbol.iterator] || f["@@iterator"];
      if (v != null) {
        var y, S, w, _, I = [], N = !0, O = !1;
        try {
          if (w = (v = v.call(f)).next, $ !== 0) for (; !(N = (y = w.call(v)).done) && (I.push(y.value), I.length !== $); N = !0) ;
        } catch (E) {
          O = !0, S = E;
        } finally {
          try {
            if (!N && v.return != null && (_ = v.return(), Object(_) !== _)) return;
          } finally {
            if (O) throw S;
          }
        }
        return I;
      }
    }
    function u(f) {
      if (Array.isArray(f)) return f;
    }
    function c(f, $) {
      var v = typeof Symbol < "u" && f[Symbol.iterator] || f["@@iterator"];
      if (!v) {
        if (Array.isArray(f) || (v = l(f)) || $) {
          v && (f = v);
          var y = 0, S = function() {
          };
          return { s: S, n: function() {
            return y >= f.length ? { done: !0 } : { done: !1, value: f[y++] };
          }, e: function(N) {
            throw N;
          }, f: S };
        }
        throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }
      var w, _ = !0, I = !1;
      return { s: function() {
        v = v.call(f);
      }, n: function() {
        var N = v.next();
        return _ = N.done, N;
      }, e: function(N) {
        I = !0, w = N;
      }, f: function() {
        try {
          _ || v.return == null || v.return();
        } finally {
          if (I) throw w;
        }
      } };
    }
    function l(f, $) {
      if (f) {
        if (typeof f == "string") return p(f, $);
        var v = {}.toString.call(f).slice(8, -1);
        return v === "Object" && f.constructor && (v = f.constructor.name), v === "Map" || v === "Set" ? Array.from(f) : v === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(v) ? p(f, $) : void 0;
      }
    }
    function p(f, $) {
      ($ == null || $ > f.length) && ($ = f.length);
      for (var v = 0, y = Array($); v < $; v++) y[v] = f[v];
      return y;
    }
    function h(f) {
      var $ = /* @__PURE__ */ new Set(["subject", "body", "cc", "bcc"]), v = {
        cc: "",
        bcc: ""
      }, y = !1, S = f.split("&");
      if (S.length > 4)
        return !1;
      var w = c(S), _;
      try {
        for (w.s(); !(_ = w.n()).done; ) {
          var I = _.value, N = I.split("="), O = d(N, 2), E = O[0], C = O[1];
          if (E && !$.has(E)) {
            y = !0;
            break;
          }
          C && (E === "cc" || E === "bcc") && (v[E] = C), E && $.delete(E);
        }
      } catch (P) {
        w.e(P);
      } finally {
        w.f();
      }
      return y ? !1 : v;
    }
    function m(f, $) {
      if ((0, o.default)(f), f.indexOf("mailto:") !== 0)
        return !1;
      var v = f.replace("mailto:", "").split("?"), y = d(v, 2), S = y[0], w = y[1], _ = w === void 0 ? "" : w;
      if (!S && !_)
        return !0;
      var I = h(_);
      return I ? "".concat(S, ",").concat(I.cc, ",").concat(I.bcc).split(",").every(function(N) {
        return N = (0, r.default)(N, " "), N ? (0, n.default)(N, $) : !0;
      }) : !1;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(lc, lc.exports)), lc.exports;
}
var $c = { exports: {} }, U6;
function yY() {
  return U6 || (U6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ Q());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a) {
      return (0, r.default)(a), a.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\//g, "&#x2F;").replace(/\\/g, "&#x5C;").replace(/`/g, "&#96;");
    }
    e.exports = t.default, e.exports.default = t.default;
  }($c, $c.exports)), $c.exports;
}
var vc = { exports: {} }, G6;
function bY() {
  return G6 || (G6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ Q());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a) {
      return (0, r.default)(a), a.replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&#x2F;/g, "/").replace(/&#x5C;/g, "\\").replace(/&#96;/g, "`").replace(/&amp;/g, "&");
    }
    e.exports = t.default, e.exports.default = t.default;
  }(vc, vc.exports)), vc.exports;
}
var mc = { exports: {} }, hc = { exports: {} }, V6;
function vS() {
  return V6 || (V6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ Q());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a, d) {
      return (0, r.default)(a), a.replace(new RegExp("[".concat(d, "]+"), "g"), "");
    }
    e.exports = t.default, e.exports.default = t.default;
  }(hc, hc.exports)), hc.exports;
}
var H6;
function xY() {
  return H6 || (H6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = o(/* @__PURE__ */ Q()), n = o(/* @__PURE__ */ vS());
    function o(d) {
      return d && d.__esModule ? d : { default: d };
    }
    function a(d, i) {
      (0, r.default)(d);
      var s = i ? "\\x00-\\x09\\x0B\\x0C\\x0E-\\x1F\\x7F" : "\\x00-\\x1F\\x7F";
      return (0, n.default)(d, s);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(mc, mc.exports)), mc.exports;
}
var gc = { exports: {} }, K6;
function wY() {
  return K6 || (K6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ Q());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a, d) {
      return (0, r.default)(a), a.replace(new RegExp("[^".concat(d, "]+"), "g"), "");
    }
    e.exports = t.default, e.exports.default = t.default;
  }(gc, gc.exports)), gc.exports;
}
var yc = { exports: {} }, W6;
function AY() {
  return W6 || (W6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ Q());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a, d) {
      (0, r.default)(a);
      for (var i = a.length - 1; i >= 0; i--)
        if (d.indexOf(a[i]) === -1)
          return !1;
      return !0;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(yc, yc.exports)), yc.exports;
}
var bc = { exports: {} }, z6;
function SY() {
  return z6 || (z6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = c;
    var r = n(/* @__PURE__ */ ht());
    function n(l) {
      return l && l.__esModule ? l : { default: l };
    }
    var o = {
      // The following options apply to all email addresses
      // Lowercases the local part of the email address.
      // Please note this may violate RFC 5321 as per http://stackoverflow.com/a/9808332/192024).
      // The domain is always lowercased, as per RFC 1035
      all_lowercase: !0,
      // The following conversions are specific to GMail
      // Lowercases the local part of the GMail address (known to be case-insensitive)
      gmail_lowercase: !0,
      // Removes dots from the local part of the email address, as that's ignored by GMail
      gmail_remove_dots: !0,
      // Removes the subaddress (e.g. "+foo") from the email address
      gmail_remove_subaddress: !0,
      // Conversts the googlemail.com domain to gmail.com
      gmail_convert_googlemaildotcom: !0,
      // The following conversions are specific to Outlook.com / Windows Live / Hotmail
      // Lowercases the local part of the Outlook.com address (known to be case-insensitive)
      outlookdotcom_lowercase: !0,
      // Removes the subaddress (e.g. "+foo") from the email address
      outlookdotcom_remove_subaddress: !0,
      // The following conversions are specific to Yahoo
      // Lowercases the local part of the Yahoo address (known to be case-insensitive)
      yahoo_lowercase: !0,
      // Removes the subaddress (e.g. "-foo") from the email address
      yahoo_remove_subaddress: !0,
      // The following conversions are specific to Yandex
      // Lowercases the local part of the Yandex address (known to be case-insensitive)
      yandex_lowercase: !0,
      // all yandex domains are equal, this explicitly sets the domain to 'yandex.ru'
      yandex_convert_yandexru: !0,
      // The following conversions are specific to iCloud
      // Lowercases the local part of the iCloud address (known to be case-insensitive)
      icloud_lowercase: !0,
      // Removes the subaddress (e.g. "+foo") from the email address
      icloud_remove_subaddress: !0
    }, a = ["icloud.com", "me.com"], d = ["hotmail.at", "hotmail.be", "hotmail.ca", "hotmail.cl", "hotmail.co.il", "hotmail.co.nz", "hotmail.co.th", "hotmail.co.uk", "hotmail.com", "hotmail.com.ar", "hotmail.com.au", "hotmail.com.br", "hotmail.com.gr", "hotmail.com.mx", "hotmail.com.pe", "hotmail.com.tr", "hotmail.com.vn", "hotmail.cz", "hotmail.de", "hotmail.dk", "hotmail.es", "hotmail.fr", "hotmail.hu", "hotmail.id", "hotmail.ie", "hotmail.in", "hotmail.it", "hotmail.jp", "hotmail.kr", "hotmail.lv", "hotmail.my", "hotmail.ph", "hotmail.pt", "hotmail.sa", "hotmail.sg", "hotmail.sk", "live.be", "live.co.uk", "live.com", "live.com.ar", "live.com.mx", "live.de", "live.es", "live.eu", "live.fr", "live.it", "live.nl", "msn.com", "outlook.at", "outlook.be", "outlook.cl", "outlook.co.il", "outlook.co.nz", "outlook.co.th", "outlook.com", "outlook.com.ar", "outlook.com.au", "outlook.com.br", "outlook.com.gr", "outlook.com.pe", "outlook.com.tr", "outlook.com.vn", "outlook.cz", "outlook.de", "outlook.dk", "outlook.es", "outlook.fr", "outlook.hu", "outlook.id", "outlook.ie", "outlook.in", "outlook.it", "outlook.jp", "outlook.kr", "outlook.lv", "outlook.my", "outlook.ph", "outlook.pt", "outlook.sa", "outlook.sg", "outlook.sk", "passport.com"], i = ["rocketmail.com", "yahoo.ca", "yahoo.co.uk", "yahoo.com", "yahoo.de", "yahoo.fr", "yahoo.in", "yahoo.it", "ymail.com"], s = ["yandex.ru", "yandex.ua", "yandex.kz", "yandex.com", "yandex.by", "ya.ru"];
    function u(l) {
      return l.length > 1 ? l : "";
    }
    function c(l, p) {
      p = (0, r.default)(p, o);
      var h = l.split("@"), m = h.pop(), f = h.join("@"), $ = [f, m];
      if ($[1] = $[1].toLowerCase(), $[1] === "gmail.com" || $[1] === "googlemail.com") {
        if (p.gmail_remove_subaddress && ($[0] = $[0].split("+")[0]), p.gmail_remove_dots && ($[0] = $[0].replace(/\.+/g, u)), !$[0].length)
          return !1;
        (p.all_lowercase || p.gmail_lowercase) && ($[0] = $[0].toLowerCase()), $[1] = p.gmail_convert_googlemaildotcom ? "gmail.com" : $[1];
      } else if (a.indexOf($[1]) >= 0) {
        if (p.icloud_remove_subaddress && ($[0] = $[0].split("+")[0]), !$[0].length)
          return !1;
        (p.all_lowercase || p.icloud_lowercase) && ($[0] = $[0].toLowerCase());
      } else if (d.indexOf($[1]) >= 0) {
        if (p.outlookdotcom_remove_subaddress && ($[0] = $[0].split("+")[0]), !$[0].length)
          return !1;
        (p.all_lowercase || p.outlookdotcom_lowercase) && ($[0] = $[0].toLowerCase());
      } else if (i.indexOf($[1]) >= 0) {
        if (p.yahoo_remove_subaddress) {
          var v = $[0].split("-");
          $[0] = v.length > 1 ? v.slice(0, -1).join("-") : v[0];
        }
        if (!$[0].length)
          return !1;
        (p.all_lowercase || p.yahoo_lowercase) && ($[0] = $[0].toLowerCase());
      } else s.indexOf($[1]) >= 0 ? ((p.all_lowercase || p.yandex_lowercase) && ($[0] = $[0].toLowerCase()), $[1] = p.yandex_convert_yandexru ? "yandex.ru" : $[1]) : p.all_lowercase && ($[0] = $[0].toLowerCase());
      return $.join("@");
    }
    e.exports = t.default, e.exports.default = t.default;
  }(bc, bc.exports)), bc.exports;
}
var xc = { exports: {} }, Y6;
function _Y() {
  return Y6 || (Y6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ Q());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = /^[^\s-_](?!.*?[-_]{2,})[a-z0-9-\\][^\s]*[^-_\s]$/;
    function a(d) {
      return (0, r.default)(d), o.test(d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(xc, xc.exports)), xc.exports;
}
var wc = { exports: {} }, X6;
function EY() {
  return X6 || (X6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ Q());
    function n(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var o = {
      "cs-CZ": function(d) {
        return /^(([ABCDEFHIJKLMNPRSTUVXYZ]|[0-9])-?){5,8}$/.test(d);
      },
      "de-DE": function(d) {
        return /^((A|AA|AB|AC|AE|AH|AK|AM|AN|AÖ|AP|AS|AT|AU|AW|AZ|B|BA|BB|BC|BE|BF|BH|BI|BK|BL|BM|BN|BO|BÖ|BS|BT|BZ|C|CA|CB|CE|CO|CR|CW|D|DA|DD|DE|DH|DI|DL|DM|DN|DO|DU|DW|DZ|E|EA|EB|ED|EE|EF|EG|EH|EI|EL|EM|EN|ER|ES|EU|EW|F|FB|FD|FF|FG|FI|FL|FN|FO|FR|FS|FT|FÜ|FW|FZ|G|GA|GC|GD|GE|GF|GG|GI|GK|GL|GM|GN|GÖ|GP|GR|GS|GT|GÜ|GV|GW|GZ|H|HA|HB|HC|HD|HE|HF|HG|HH|HI|HK|HL|HM|HN|HO|HP|HR|HS|HU|HV|HX|HY|HZ|IK|IL|IN|IZ|J|JE|JL|K|KA|KB|KC|KE|KF|KG|KH|KI|KK|KL|KM|KN|KO|KR|KS|KT|KU|KW|KY|L|LA|LB|LC|LD|LF|LG|LH|LI|LL|LM|LN|LÖ|LP|LR|LU|M|MA|MB|MC|MD|ME|MG|MH|MI|MK|ML|MM|MN|MO|MQ|MR|MS|MÜ|MW|MY|MZ|N|NB|ND|NE|NF|NH|NI|NK|NM|NÖ|NP|NR|NT|NU|NW|NY|NZ|OA|OB|OC|OD|OE|OF|OG|OH|OK|OL|OP|OS|OZ|P|PA|PB|PE|PF|PI|PL|PM|PN|PR|PS|PW|PZ|R|RA|RC|RD|RE|RG|RH|RI|RL|RM|RN|RO|RP|RS|RT|RU|RV|RW|RZ|S|SB|SC|SE|SG|SI|SK|SL|SM|SN|SO|SP|SR|ST|SU|SW|SY|SZ|TE|TF|TG|TO|TP|TR|TS|TT|TÜ|ÜB|UE|UH|UL|UM|UN|V|VB|VG|VK|VR|VS|W|WA|WB|WE|WF|WI|WK|WL|WM|WN|WO|WR|WS|WT|WÜ|WW|WZ|Z|ZE|ZI|ZP|ZR|ZW|ZZ)[- ]?[A-Z]{1,2}[- ]?\d{1,4}|(ABG|ABI|AIB|AIC|ALF|ALZ|ANA|ANG|ANK|APD|ARN|ART|ASL|ASZ|AUR|AZE|BAD|BAR|BBG|BCH|BED|BER|BGD|BGL|BID|BIN|BIR|BIT|BIW|BKS|BLB|BLK|BNA|BOG|BOH|BOR|BOT|BRA|BRB|BRG|BRK|BRL|BRV|BSB|BSK|BTF|BÜD|BUL|BÜR|BÜS|BÜZ|CAS|CHA|CLP|CLZ|COC|COE|CUX|DAH|DAN|DAU|DBR|DEG|DEL|DGF|DIL|DIN|DIZ|DKB|DLG|DON|DUD|DÜW|EBE|EBN|EBS|ECK|EIC|EIL|EIN|EIS|EMD|EMS|ERB|ERH|ERK|ERZ|ESB|ESW|FDB|FDS|FEU|FFB|FKB|FLÖ|FOR|FRG|FRI|FRW|FTL|FÜS|GAN|GAP|GDB|GEL|GEO|GER|GHA|GHC|GLA|GMN|GNT|GOA|GOH|GRA|GRH|GRI|GRM|GRZ|GTH|GUB|GUN|GVM|HAB|HAL|HAM|HAS|HBN|HBS|HCH|HDH|HDL|HEB|HEF|HEI|HER|HET|HGN|HGW|HHM|HIG|HIP|HMÜ|HOG|HOH|HOL|HOM|HOR|HÖS|HOT|HRO|HSK|HST|HVL|HWI|IGB|ILL|JÜL|KEH|KEL|KEM|KIB|KLE|KLZ|KÖN|KÖT|KÖZ|KRU|KÜN|KUS|KYF|LAN|LAU|LBS|LBZ|LDK|LDS|LEO|LER|LEV|LIB|LIF|LIP|LÖB|LOS|LRO|LSZ|LÜN|LUP|LWL|MAB|MAI|MAK|MAL|MED|MEG|MEI|MEK|MEL|MER|MET|MGH|MGN|MHL|MIL|MKK|MOD|MOL|MON|MOS|MSE|MSH|MSP|MST|MTK|MTL|MÜB|MÜR|MYK|MZG|NAB|NAI|NAU|NDH|NEA|NEB|NEC|NEN|NES|NEW|NMB|NMS|NOH|NOL|NOM|NOR|NVP|NWM|OAL|OBB|OBG|OCH|OHA|ÖHR|OHV|OHZ|OPR|OSL|OVI|OVL|OVP|PAF|PAN|PAR|PCH|PEG|PIR|PLÖ|PRÜ|QFT|QLB|RDG|REG|REH|REI|RID|RIE|ROD|ROF|ROK|ROL|ROS|ROT|ROW|RSL|RÜD|RÜG|SAB|SAD|SAN|SAW|SBG|SBK|SCZ|SDH|SDL|SDT|SEB|SEE|SEF|SEL|SFB|SFT|SGH|SHA|SHG|SHK|SHL|SIG|SIM|SLE|SLF|SLK|SLN|SLS|SLÜ|SLZ|SMÜ|SOB|SOG|SOK|SÖM|SON|SPB|SPN|SRB|SRO|STA|STB|STD|STE|STL|SUL|SÜW|SWA|SZB|TBB|TDO|TET|TIR|TÖL|TUT|UEM|UER|UFF|USI|VAI|VEC|VER|VIB|VIE|VIT|VOH|WAF|WAK|WAN|WAR|WAT|WBS|WDA|WEL|WEN|WER|WES|WHV|WIL|WIS|WIT|WIZ|WLG|WMS|WND|WOB|WOH|WOL|WOR|WOS|WRN|WSF|WST|WSW|WTL|WTM|WUG|WÜM|WUN|WUR|WZL|ZEL|ZIG)[- ]?(([A-Z][- ]?\d{1,4})|([A-Z]{2}[- ]?\d{1,3})))[- ]?(E|H)?$/.test(d);
      },
      "de-LI": function(d) {
        return /^FL[- ]?\d{1,5}[UZ]?$/.test(d);
      },
      "en-IN": function(d) {
        return /^[A-Z]{2}[ -]?[0-9]{1,2}(?:[ -]?[A-Z])(?:[ -]?[A-Z]*)?[ -]?[0-9]{4}$/.test(d);
      },
      "en-SG": function(d) {
        return /^[A-Z]{3}[ -]?[\d]{4}[ -]?[A-Z]{1}$/.test(d);
      },
      "es-AR": function(d) {
        return /^(([A-Z]{2} ?[0-9]{3} ?[A-Z]{2})|([A-Z]{3} ?[0-9]{3}))$/.test(d);
      },
      "fi-FI": function(d) {
        return /^(?=.{4,7})(([A-Z]{1,3}|[0-9]{1,3})[\s-]?([A-Z]{1,3}|[0-9]{1,5}))$/.test(d);
      },
      "hu-HU": function(d) {
        return /^((((?!AAA)(([A-NPRSTVZWXY]{1})([A-PR-Z]{1})([A-HJ-NPR-Z]))|(A[ABC]I)|A[ABC]O|A[A-W]Q|BPI|BPO|UCO|UDO|XAO)-(?!000)\d{3})|(M\d{6})|((CK|DT|CD|HC|H[ABEFIKLMNPRSTVX]|MA|OT|R[A-Z]) \d{2}-\d{2})|(CD \d{3}-\d{3})|(C-(C|X) \d{4})|(X-(A|B|C) \d{4})|(([EPVZ]-\d{5}))|(S A[A-Z]{2} \d{2})|(SP \d{2}-\d{2}))$/.test(d);
      },
      "pt-BR": function(d) {
        return /^[A-Z]{3}[ -]?[0-9][A-Z][0-9]{2}|[A-Z]{3}[ -]?[0-9]{4}$/.test(d);
      },
      "pt-PT": function(d) {
        return /^([A-Z]{2}|[0-9]{2})[ -·]?([A-Z]{2}|[0-9]{2})[ -·]?([A-Z]{2}|[0-9]{2})$/.test(d);
      },
      "sq-AL": function(d) {
        return /^[A-Z]{2}[- ]?((\d{3}[- ]?(([A-Z]{2})|T))|(R[- ]?\d{3}))$/.test(d);
      },
      "sv-SE": function(d) {
        return /^[A-HJ-PR-UW-Z]{3} ?[\d]{2}[A-HJ-PR-UW-Z1-9]$|(^[A-ZÅÄÖ ]{2,7}$)/.test(d.trim());
      },
      "en-PK": function(d) {
        return /(^[A-Z]{2}((\s|-){0,1})[0-9]{3,4}((\s|-)[0-9]{2}){0,1}$)|(^[A-Z]{3}((\s|-){0,1})[0-9]{3,4}((\s|-)[0-9]{2}){0,1}$)|(^[A-Z]{4}((\s|-){0,1})[0-9]{3,4}((\s|-)[0-9]{2}){0,1}$)|(^[A-Z]((\s|-){0,1})[0-9]{4}((\s|-)[0-9]{2}){0,1}$)/.test(d.trim());
      }
    };
    function a(d, i) {
      if ((0, r.default)(d), i in o)
        return o[i](d);
      if (i === "any") {
        for (var s in o) {
          var u = o[s];
          if (u(d))
            return !0;
        }
        return !1;
      }
      throw new Error("Invalid locale '".concat(i, "'"));
    }
    e.exports = t.default, e.exports.default = t.default;
  }(wc, wc.exports)), wc.exports;
}
var Ac = { exports: {} }, q6;
function MY() {
  return q6 || (q6 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = h;
    var r = o(/* @__PURE__ */ ht()), n = o(/* @__PURE__ */ Q());
    function o(m) {
      return m && m.__esModule ? m : { default: m };
    }
    var a = /^[A-Z]$/, d = /^[a-z]$/, i = /^[0-9]$/, s = /^[-#!$@£%^&*()_+|~=`{}\[\]:";'<>?,.\/\\ ]$/, u = {
      minLength: 8,
      minLowercase: 1,
      minUppercase: 1,
      minNumbers: 1,
      minSymbols: 1,
      returnScore: !1,
      pointsPerUnique: 1,
      pointsPerRepeat: 0.5,
      pointsForContainingLower: 10,
      pointsForContainingUpper: 10,
      pointsForContainingNumber: 10,
      pointsForContainingSymbol: 10
    };
    function c(m) {
      var f = {};
      return Array.from(m).forEach(function($) {
        var v = f[$];
        v ? f[$] += 1 : f[$] = 1;
      }), f;
    }
    function l(m) {
      var f = c(m), $ = {
        length: m.length,
        uniqueChars: Object.keys(f).length,
        uppercaseCount: 0,
        lowercaseCount: 0,
        numberCount: 0,
        symbolCount: 0
      };
      return Object.keys(f).forEach(function(v) {
        a.test(v) ? $.uppercaseCount += f[v] : d.test(v) ? $.lowercaseCount += f[v] : i.test(v) ? $.numberCount += f[v] : s.test(v) && ($.symbolCount += f[v]);
      }), $;
    }
    function p(m, f) {
      var $ = 0;
      return $ += m.uniqueChars * f.pointsPerUnique, $ += (m.length - m.uniqueChars) * f.pointsPerRepeat, m.lowercaseCount > 0 && ($ += f.pointsForContainingLower), m.uppercaseCount > 0 && ($ += f.pointsForContainingUpper), m.numberCount > 0 && ($ += f.pointsForContainingNumber), m.symbolCount > 0 && ($ += f.pointsForContainingSymbol), $;
    }
    function h(m) {
      var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
      (0, n.default)(m);
      var $ = l(m);
      return f = (0, r.default)(f || {}, u), f.returnScore ? p($, f) : $.length >= f.minLength && $.lowercaseCount >= f.minLowercase && $.uppercaseCount >= f.minUppercase && $.numberCount >= f.minNumbers && $.symbolCount >= f.minSymbols;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Ac, Ac.exports)), Ac.exports;
}
var fo = {}, J6;
function CY() {
  if (J6) return fo;
  J6 = 1;
  function e(l) {
    "@babel/helpers - typeof";
    return e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(p) {
      return typeof p;
    } : function(p) {
      return p && typeof Symbol == "function" && p.constructor === Symbol && p !== Symbol.prototype ? "symbol" : typeof p;
    }, e(l);
  }
  Object.defineProperty(fo, "__esModule", {
    value: !0
  }), fo.default = c, fo.vatMatchers = void 0;
  var t = a(/* @__PURE__ */ Q()), r = o(/* @__PURE__ */ sS());
  function n(l) {
    if (typeof WeakMap != "function") return null;
    var p = /* @__PURE__ */ new WeakMap(), h = /* @__PURE__ */ new WeakMap();
    return (n = function(m) {
      return m ? h : p;
    })(l);
  }
  function o(l, p) {
    if (l && l.__esModule) return l;
    if (l === null || e(l) != "object" && typeof l != "function") return { default: l };
    var h = n(p);
    if (h && h.has(l)) return h.get(l);
    var m = { __proto__: null }, f = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var $ in l) if ($ !== "default" && {}.hasOwnProperty.call(l, $)) {
      var v = f ? Object.getOwnPropertyDescriptor(l, $) : null;
      v && (v.get || v.set) ? Object.defineProperty(m, $, v) : m[$] = l[$];
    }
    return m.default = l, h && h.set(l, m), m;
  }
  function a(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var d = function(l) {
    var p = l.match(/^(AU)?(\d{11})$/);
    if (!p)
      return !1;
    var h = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
    l = l.replace(/^AU/, "");
    for (var m = (parseInt(l.slice(0, 1), 10) - 1).toString() + l.slice(1), f = 0, $ = 0; $ < 11; $++)
      f += h[$] * m.charAt($);
    return f !== 0 && f % 89 === 0;
  }, i = function(l) {
    var p = function(h) {
      var m = h.pop(), f = [5, 4, 3, 2, 7, 6, 5, 4], $ = (11 - h.reduce(function(v, y, S) {
        return v + y * f[S];
      }, 0) % 11) % 11;
      return m === $;
    };
    return /^(CHE[- ]?)?(\d{9}|(\d{3}\.\d{3}\.\d{3})|(\d{3} \d{3} \d{3})) ?(TVA|MWST|IVA)?$/.test(l) && p(l.match(/\d/g).map(function(h) {
      return +h;
    }));
  }, s = function(l) {
    var p = l.match(/^(PT)?(\d{9})$/);
    if (!p)
      return !1;
    var h = p[2], m = 11 - r.reverseMultiplyAndSum(h.split("").slice(0, 8).map(function(f) {
      return parseInt(f, 10);
    }), 9) % 11;
    return m > 9 ? parseInt(h[8], 10) === 0 : m === parseInt(h[8], 10);
  }, u = fo.vatMatchers = {
    /**
     * European Union VAT identification numbers
     */
    AT: function(l) {
      return /^(AT)?U\d{8}$/.test(l);
    },
    BE: function(l) {
      return /^(BE)?\d{10}$/.test(l);
    },
    BG: function(l) {
      return /^(BG)?\d{9,10}$/.test(l);
    },
    HR: function(l) {
      return /^(HR)?\d{11}$/.test(l);
    },
    CY: function(l) {
      return /^(CY)?\w{9}$/.test(l);
    },
    CZ: function(l) {
      return /^(CZ)?\d{8,10}$/.test(l);
    },
    DK: function(l) {
      return /^(DK)?\d{8}$/.test(l);
    },
    EE: function(l) {
      return /^(EE)?\d{9}$/.test(l);
    },
    FI: function(l) {
      return /^(FI)?\d{8}$/.test(l);
    },
    FR: function(l) {
      return /^(FR)?\w{2}\d{9}$/.test(l);
    },
    DE: function(l) {
      return /^(DE)?\d{9}$/.test(l);
    },
    EL: function(l) {
      return /^(EL)?\d{9}$/.test(l);
    },
    HU: function(l) {
      return /^(HU)?\d{8}$/.test(l);
    },
    IE: function(l) {
      return /^(IE)?\d{7}\w{1}(W)?$/.test(l);
    },
    IT: function(l) {
      return /^(IT)?\d{11}$/.test(l);
    },
    LV: function(l) {
      return /^(LV)?\d{11}$/.test(l);
    },
    LT: function(l) {
      return /^(LT)?\d{9,12}$/.test(l);
    },
    LU: function(l) {
      return /^(LU)?\d{8}$/.test(l);
    },
    MT: function(l) {
      return /^(MT)?\d{8}$/.test(l);
    },
    NL: function(l) {
      return /^(NL)?\d{9}B\d{2}$/.test(l);
    },
    PL: function(l) {
      return /^(PL)?(\d{10}|(\d{3}-\d{3}-\d{2}-\d{2})|(\d{3}-\d{2}-\d{2}-\d{3}))$/.test(l);
    },
    PT: s,
    RO: function(l) {
      return /^(RO)?\d{2,10}$/.test(l);
    },
    SK: function(l) {
      return /^(SK)?\d{10}$/.test(l);
    },
    SI: function(l) {
      return /^(SI)?\d{8}$/.test(l);
    },
    ES: function(l) {
      return /^(ES)?\w\d{7}[A-Z]$/.test(l);
    },
    SE: function(l) {
      return /^(SE)?\d{12}$/.test(l);
    },
    /**
     * VAT numbers of non-EU countries
     */
    AL: function(l) {
      return /^(AL)?\w{9}[A-Z]$/.test(l);
    },
    MK: function(l) {
      return /^(MK)?\d{13}$/.test(l);
    },
    AU: d,
    BY: function(l) {
      return /^(УНП )?\d{9}$/.test(l);
    },
    CA: function(l) {
      return /^(CA)?\d{9}$/.test(l);
    },
    IS: function(l) {
      return /^(IS)?\d{5,6}$/.test(l);
    },
    IN: function(l) {
      return /^(IN)?\d{15}$/.test(l);
    },
    ID: function(l) {
      return /^(ID)?(\d{15}|(\d{2}.\d{3}.\d{3}.\d{1}-\d{3}.\d{3}))$/.test(l);
    },
    IL: function(l) {
      return /^(IL)?\d{9}$/.test(l);
    },
    KZ: function(l) {
      return /^(KZ)?\d{12}$/.test(l);
    },
    NZ: function(l) {
      return /^(NZ)?\d{9}$/.test(l);
    },
    NG: function(l) {
      return /^(NG)?(\d{12}|(\d{8}-\d{4}))$/.test(l);
    },
    NO: function(l) {
      return /^(NO)?\d{9}MVA$/.test(l);
    },
    PH: function(l) {
      return /^(PH)?(\d{12}|\d{3} \d{3} \d{3} \d{3})$/.test(l);
    },
    RU: function(l) {
      return /^(RU)?(\d{10}|\d{12})$/.test(l);
    },
    SM: function(l) {
      return /^(SM)?\d{5}$/.test(l);
    },
    SA: function(l) {
      return /^(SA)?\d{15}$/.test(l);
    },
    RS: function(l) {
      return /^(RS)?\d{9}$/.test(l);
    },
    CH: i,
    TR: function(l) {
      return /^(TR)?\d{10}$/.test(l);
    },
    UA: function(l) {
      return /^(UA)?\d{12}$/.test(l);
    },
    GB: function(l) {
      return /^GB((\d{3} \d{4} ([0-8][0-9]|9[0-6]))|(\d{9} \d{3})|(((GD[0-4])|(HA[5-9]))[0-9]{2}))$/.test(l);
    },
    UZ: function(l) {
      return /^(UZ)?\d{9}$/.test(l);
    },
    /**
     * VAT numbers of Latin American countries
     */
    AR: function(l) {
      return /^(AR)?\d{11}$/.test(l);
    },
    BO: function(l) {
      return /^(BO)?\d{7}$/.test(l);
    },
    BR: function(l) {
      return /^(BR)?((\d{2}.\d{3}.\d{3}\/\d{4}-\d{2})|(\d{3}.\d{3}.\d{3}-\d{2}))$/.test(l);
    },
    CL: function(l) {
      return /^(CL)?\d{8}-\d{1}$/.test(l);
    },
    CO: function(l) {
      return /^(CO)?\d{10}$/.test(l);
    },
    CR: function(l) {
      return /^(CR)?\d{9,12}$/.test(l);
    },
    EC: function(l) {
      return /^(EC)?\d{13}$/.test(l);
    },
    SV: function(l) {
      return /^(SV)?\d{4}-\d{6}-\d{3}-\d{1}$/.test(l);
    },
    GT: function(l) {
      return /^(GT)?\d{7}-\d{1}$/.test(l);
    },
    HN: function(l) {
      return /^(HN)?$/.test(l);
    },
    MX: function(l) {
      return /^(MX)?\w{3,4}\d{6}\w{3}$/.test(l);
    },
    NI: function(l) {
      return /^(NI)?\d{3}-\d{6}-\d{4}\w{1}$/.test(l);
    },
    PA: function(l) {
      return /^(PA)?$/.test(l);
    },
    PY: function(l) {
      return /^(PY)?\d{6,8}-\d{1}$/.test(l);
    },
    PE: function(l) {
      return /^(PE)?\d{11}$/.test(l);
    },
    DO: function(l) {
      return /^(DO)?(\d{11}|(\d{3}-\d{7}-\d{1})|[1,4,5]{1}\d{8}|([1,4,5]{1})-\d{2}-\d{5}-\d{1})$/.test(l);
    },
    UY: function(l) {
      return /^(UY)?\d{12}$/.test(l);
    },
    VE: function(l) {
      return /^(VE)?[J,G,V,E]{1}-(\d{9}|(\d{8}-\d{1}))$/.test(l);
    }
  };
  function c(l, p) {
    if ((0, t.default)(l), (0, t.default)(p), p in u)
      return u[p](l);
    throw new Error("Invalid country code: '".concat(p, "'"));
  }
  return fo;
}
var Q6;
function OY() {
  return Q6 || (Q6 = 1, function(e, t) {
    function r(Se) {
      "@babel/helpers - typeof";
      return r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(We) {
        return typeof We;
      } : function(We) {
        return We && typeof Symbol == "function" && We.constructor === Symbol && We !== Symbol.prototype ? "symbol" : typeof We;
      }, r(Se);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var n = k(/* @__PURE__ */ M2()), o = k(/* @__PURE__ */ pb()), a = k(/* @__PURE__ */ tY()), d = k(/* @__PURE__ */ rY()), i = k(/* @__PURE__ */ nY()), s = k(/* @__PURE__ */ Nb()), u = k(/* @__PURE__ */ Cw()), c = k(/* @__PURE__ */ $2()), l = k(/* @__PURE__ */ lw()), p = k(/* @__PURE__ */ wx()), h = k(/* @__PURE__ */ ka()), m = k(/* @__PURE__ */ oY()), f = k(/* @__PURE__ */ yi()), $ = k(/* @__PURE__ */ iS()), v = k(/* @__PURE__ */ aY()), y = k(/* @__PURE__ */ Jw()), S = k(/* @__PURE__ */ TA()), w = k(/* @__PURE__ */ dY()), _ = lt(/* @__PURE__ */ Lb()), I = lt(/* @__PURE__ */ jb()), N = k(/* @__PURE__ */ tA()), O = lt(/* @__PURE__ */ KA()), E = k(/* @__PURE__ */ Mx()), C = k(/* @__PURE__ */ Vx()), P = k(/* @__PURE__ */ gw()), T = k(/* @__PURE__ */ iY()), j = k(/* @__PURE__ */ Hb()), F = k(/* @__PURE__ */ v2()), Z = k(/* @__PURE__ */ m2()), te = k(/* @__PURE__ */ $x()), H = k(/* @__PURE__ */ ow()), de = k(/* @__PURE__ */ oS()), G = k(/* @__PURE__ */ iw()), le = k(/* @__PURE__ */ g2()), fe = lt(/* @__PURE__ */ fb()), U = k(/* @__PURE__ */ Ub()), ae = k(/* @__PURE__ */ h2()), ue = k(/* @__PURE__ */ GA()), se = k(/* @__PURE__ */ $b()), we = k(/* @__PURE__ */ hx()), re = k(/* @__PURE__ */ tS()), ye = k(/* @__PURE__ */ wA()), xe = k(/* @__PURE__ */ IA()), be = lt(/* @__PURE__ */ _A()), ee = k(/* @__PURE__ */ iA()), ce = k(/* @__PURE__ */ sY()), he = k(/* @__PURE__ */ Vw()), Ee = k(/* @__PURE__ */ Zx()), ot = k(/* @__PURE__ */ kx()), Ve = k(/* @__PURE__ */ uY()), Rt = k(/* @__PURE__ */ xw()), g = k(/* @__PURE__ */ p2()), b = k(/* @__PURE__ */ lY()), M = k(/* @__PURE__ */ pw()), D = k(/* @__PURE__ */ tw()), R = k(/* @__PURE__ */ cY()), L = k(/* @__PURE__ */ fY()), B = k(/* @__PURE__ */ pY()), V = k(/* @__PURE__ */ Jb()), oe = k(/* @__PURE__ */ Qb()), me = k(/* @__PURE__ */ CA()), He = k(/* @__PURE__ */ mA()), Ke = k(/* @__PURE__ */ Rx()), Le = k(/* @__PURE__ */ Nx()), st = k(/* @__PURE__ */ Ww()), Bt = k(/* @__PURE__ */ uS()), Qe = lt(/* @__PURE__ */ Wx()), ut = k(/* @__PURE__ */ yA()), Tt = k(/* @__PURE__ */ rx()), Vi = k(/* @__PURE__ */ lA()), Uo = /* @__PURE__ */ $Y(), Hi = k(/* @__PURE__ */ vY()), Ki = k(/* @__PURE__ */ Lx()), Wi = k(/* @__PURE__ */ JA()), zi = k(/* @__PURE__ */ mY()), Yi = k(/* @__PURE__ */ b2()), Xi = k(/* @__PURE__ */ Jx()), qi = k(/* @__PURE__ */ hY()), Ji = k(/* @__PURE__ */ lS()), Qi = k(/* @__PURE__ */ oA()), es = k(/* @__PURE__ */ cS()), ts = k(/* @__PURE__ */ f2()), rs = k(/* @__PURE__ */ pA()), ns = k(/* @__PURE__ */ FA()), os = k(/* @__PURE__ */ gY()), as = k(/* @__PURE__ */ BA()), ds = k(/* @__PURE__ */ Wy()), Go = lt(/* @__PURE__ */ YA()), is = k(/* @__PURE__ */ pS()), ss = k(/* @__PURE__ */ fS()), us = k(/* @__PURE__ */ $S()), ls = k(/* @__PURE__ */ yY()), cs = k(/* @__PURE__ */ bY()), fs = k(/* @__PURE__ */ xY()), ps = k(/* @__PURE__ */ wY()), $s = k(/* @__PURE__ */ vS()), vs = k(/* @__PURE__ */ AY()), ms = k(/* @__PURE__ */ SY()), hs = k(/* @__PURE__ */ _Y()), gs = k(/* @__PURE__ */ EY()), ys = k(/* @__PURE__ */ MY()), bs = k(/* @__PURE__ */ CY());
    function Vo(Se) {
      if (typeof WeakMap != "function") return null;
      var We = /* @__PURE__ */ new WeakMap(), ct = /* @__PURE__ */ new WeakMap();
      return (Vo = function(ft) {
        return ft ? ct : We;
      })(Se);
    }
    function lt(Se, We) {
      if (Se && Se.__esModule) return Se;
      if (Se === null || r(Se) != "object" && typeof Se != "function") return { default: Se };
      var ct = Vo(We);
      if (ct && ct.has(Se)) return ct.get(Se);
      var ft = { __proto__: null }, As = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var Et in Se) if (Et !== "default" && {}.hasOwnProperty.call(Se, Et)) {
        var lr = As ? Object.getOwnPropertyDescriptor(Se, Et) : null;
        lr && (lr.get || lr.set) ? Object.defineProperty(ft, Et, lr) : ft[Et] = Se[Et];
      }
      return ft.default = Se, ct && ct.set(Se, ft), ft;
    }
    function k(Se) {
      return Se && Se.__esModule ? Se : { default: Se };
    }
    var xs = "13.15.0", ws = {
      version: xs,
      toDate: n.default,
      toFloat: o.default,
      toInt: a.default,
      toBoolean: d.default,
      equals: i.default,
      contains: s.default,
      matches: u.default,
      isEmail: c.default,
      isURL: l.default,
      isMACAddress: p.default,
      isIP: h.default,
      isIPRange: m.default,
      isFQDN: f.default,
      isBoolean: y.default,
      isIBAN: be.default,
      isBIC: ee.default,
      isAbaRouting: w.default,
      isAlpha: _.default,
      isAlphaLocales: _.locales,
      isAlphanumeric: I.default,
      isAlphanumericLocales: I.locales,
      isNumeric: N.default,
      isPassportNumber: O.default,
      passportNumberLocales: O.locales,
      isPort: E.default,
      isLowercase: C.default,
      isUppercase: P.default,
      isAscii: j.default,
      isFullWidth: F.default,
      isHalfWidth: Z.default,
      isVariableWidth: te.default,
      isMultibyte: H.default,
      isSemVer: de.default,
      isSurrogatePair: G.default,
      isInt: le.default,
      isIMEI: T.default,
      isFloat: fe.default,
      isFloatLocales: fe.locales,
      isDecimal: U.default,
      isHexadecimal: ae.default,
      isOctal: ue.default,
      isDivisibleBy: se.default,
      isHexColor: we.default,
      isRgbColor: re.default,
      isHSL: ye.default,
      isISRC: xe.default,
      isMD5: ce.default,
      isHash: he.default,
      isJWT: Ee.default,
      isJSON: ot.default,
      isEmpty: Ve.default,
      isLength: Rt.default,
      isLocale: S.default,
      isByteLength: g.default,
      isULID: b.default,
      isUUID: M.default,
      isMongoId: D.default,
      isAfter: R.default,
      isBefore: L.default,
      isIn: B.default,
      isLuhnNumber: V.default,
      isCreditCard: oe.default,
      isIdentityCard: me.default,
      isEAN: He.default,
      isISIN: Ke.default,
      isISBN: Le.default,
      isISSN: st.default,
      isMobilePhone: Qe.default,
      isMobilePhoneLocales: Qe.locales,
      isPostalCode: Go.default,
      isPostalCodeLocales: Go.locales,
      isEthereumAddress: ut.default,
      isCurrency: Tt.default,
      isBtcAddress: Vi.default,
      isISO6346: Uo.isISO6346,
      isFreightContainerID: Uo.isFreightContainerID,
      isISO6391: Hi.default,
      isISO8601: Ki.default,
      isISO15924: zi.default,
      isRFC3339: Wi.default,
      isISO31661Alpha2: Yi.default,
      isISO31661Alpha3: Xi.default,
      isISO31661Numeric: qi.default,
      isISO4217: Ji.default,
      isBase32: Qi.default,
      isBase58: es.default,
      isBase64: ts.default,
      isDataURI: rs.default,
      isMagnetURI: ns.default,
      isMailtoURI: os.default,
      isMimeType: as.default,
      isLatLong: ds.default,
      ltrim: is.default,
      rtrim: ss.default,
      trim: us.default,
      escape: ls.default,
      unescape: cs.default,
      stripLow: fs.default,
      whitelist: ps.default,
      blacklist: $s.default,
      isWhitelisted: vs.default,
      normalizeEmail: ms.default,
      toString,
      isSlug: hs.default,
      isStrongPassword: ys.default,
      isTaxID: Bt.default,
      isDate: $.default,
      isTime: v.default,
      isLicensePlate: gs.default,
      isVAT: bs.default,
      ibanLocales: be.locales
    };
    t.default = ws, e.exports = t.default, e.exports.default = t.default;
  }(Vl, Vl.exports)), Vl.exports;
}
var NY = /* @__PURE__ */ OY(), mS = "isStrongPassword";
function hS(e, t) {
  return typeof e == "string" && NY.isStrongPassword(e, t);
}
function IY(e, t) {
  return Y({
    name: mS,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return hS(r, n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property is not strong enough";
      }, t)
    }
  }, t);
}
var gS = "isTimeZone";
function yS(e) {
  try {
    return typeof e != "string" ? !1 : (Intl.DateTimeFormat(void 0, { timeZone: e }), !0);
  } catch {
    return !1;
  }
}
function PY(e) {
  return Y({
    name: gS,
    validator: {
      validate: function(t, r) {
        return yS(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be a valid IANA time-zone";
      }, e)
    }
  }, e);
}
var RY = /* @__PURE__ */ cS();
const TY = /* @__PURE__ */ ve(RY);
var bS = "isBase58";
function xS(e) {
  return typeof e == "string" && TY(e);
}
function DY(e) {
  return Y({
    name: bS,
    validator: {
      validate: function(t, r) {
        return xS(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be base58 encoded";
      }, e)
    }
  }, e);
}
var LY = /* @__PURE__ */ uS();
const FY = /* @__PURE__ */ ve(LY);
var wS = "isTaxId";
function AS(e, t) {
  return typeof e == "string" && FY(e, t || "en-US");
}
function kY(e, t) {
  return Y({
    name: wS,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return AS(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must be a Tax Identification Number";
      }, t)
    }
  }, t);
}
var jY = /* @__PURE__ */ lS();
const BY = /* @__PURE__ */ ve(jY);
var SS = "isISO4217CurrencyCode";
function _S(e) {
  return typeof e == "string" && BY(e);
}
function ZY(e) {
  return Y({
    name: SS,
    validator: {
      validate: function(t, r) {
        return _S(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be a valid ISO4217 currency code";
      }, e)
    }
  }, e);
}
var ES = "isBoolean";
function MS(e) {
  return e instanceof Boolean || typeof e == "boolean";
}
function UY(e) {
  return Y({
    name: ES,
    validator: {
      validate: function(t, r) {
        return MS(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be a boolean value";
      }, e)
    }
  }, e);
}
var CS = "isDate";
function OS(e) {
  return e instanceof Date && !isNaN(e.getTime());
}
function GY(e) {
  return Y({
    name: CS,
    validator: {
      validate: function(t, r) {
        return OS(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be a Date instance";
      }, e)
    }
  }, e);
}
var NS = "isNumber";
function IS(e, t) {
  if (t === void 0 && (t = {}), typeof e != "number")
    return !1;
  if (e === 1 / 0 || e === -1 / 0)
    return !!t.allowInfinity;
  if (Number.isNaN(e))
    return !!t.allowNaN;
  if (t.maxDecimalPlaces !== void 0) {
    var r = 0;
    if (e % 1 !== 0 && (r = e.toString().split(".")[1].length), r > t.maxDecimalPlaces)
      return !1;
  }
  return Number.isFinite(e);
}
function VY(e, t) {
  return e === void 0 && (e = {}), Y({
    name: NS,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return IS(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must be a number conforming to the specified constraints";
      }, t)
    }
  }, t);
}
var e7 = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), o, a = [], d;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = n.next()).done; ) a.push(o.value);
  } catch (i) {
    d = { error: i };
  } finally {
    try {
      o && !o.done && (r = n.return) && r.call(n);
    } finally {
      if (d) throw d.error;
    }
  }
  return a;
}, PS = "isEnum";
function RS(e, t) {
  var r = Object.keys(t).map(function(n) {
    return t[n];
  });
  return r.includes(e);
}
function HY(e) {
  return Object.entries(e).filter(function(t) {
    var r = e7(t, 2), n = r[0];
    return r[1], isNaN(parseInt(n));
  }).map(function(t) {
    var r = e7(t, 2);
    r[0];
    var n = r[1];
    return n;
  });
}
function KY(e, t) {
  return Y({
    name: PS,
    constraints: [e, HY(e)],
    validator: {
      validate: function(r, n) {
        return RS(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must be one of the following values: $constraint2";
      }, t)
    }
  }, t);
}
var TS = "isInt";
function DS(e) {
  return typeof e == "number" && Number.isInteger(e);
}
function WY(e) {
  return Y({
    name: TS,
    validator: {
      validate: function(t, r) {
        return DS(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be an integer number";
      }, e)
    }
  }, e);
}
var LS = "isString";
function FS(e) {
  return e instanceof String || typeof e == "string";
}
function zY(e) {
  return Y({
    name: LS,
    validator: {
      validate: function(t, r) {
        return FS(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be a string";
      }, e)
    }
  }, e);
}
var kS = "isArray";
function jS(e) {
  return Array.isArray(e);
}
function YY(e) {
  return Y({
    name: kS,
    validator: {
      validate: function(t, r) {
        return jS(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be an array";
      }, e)
    }
  }, e);
}
var BS = "isObject";
function C2(e) {
  return e != null && (typeof e == "object" || typeof e == "function") && !Array.isArray(e);
}
function XY(e) {
  return Y({
    name: BS,
    validator: {
      validate: function(t, r) {
        return C2(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property must be an object";
      }, e)
    }
  }, e);
}
var ZS = "arrayContains";
function US(e, t) {
  return Array.isArray(e) ? t.every(function(r) {
    return e.indexOf(r) !== -1;
  }) : !1;
}
function qY(e, t) {
  return Y({
    name: ZS,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return US(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must contain $constraint1 values";
      }, t)
    }
  }, t);
}
var GS = "arrayNotContains";
function VS(e, t) {
  return Array.isArray(e) ? t.every(function(r) {
    return e.indexOf(r) === -1;
  }) : !1;
}
function JY(e, t) {
  return Y({
    name: GS,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return VS(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property should not contain $constraint1 values";
      }, t)
    }
  }, t);
}
var HS = "arrayNotEmpty";
function KS(e) {
  return Array.isArray(e) && e.length > 0;
}
function QY(e) {
  return Y({
    name: HS,
    validator: {
      validate: function(t, r) {
        return KS(t);
      },
      defaultMessage: z(function(t) {
        return t + "$property should not be empty";
      }, e)
    }
  }, e);
}
var WS = "arrayMinSize";
function zS(e, t) {
  return Array.isArray(e) && e.length >= t;
}
function eX(e, t) {
  return Y({
    name: WS,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return zS(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must contain at least $constraint1 elements";
      }, t)
    }
  }, t);
}
var YS = "arrayMaxSize";
function XS(e, t) {
  return Array.isArray(e) && e.length <= t;
}
function tX(e, t) {
  return Y({
    name: YS,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return XS(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must contain no more than $constraint1 elements";
      }, t)
    }
  }, t);
}
var qS = "arrayUnique";
function JS(e, t) {
  if (!Array.isArray(e))
    return !1;
  t && (e = e.map(function(n) {
    return n != null ? t(n) : n;
  }));
  var r = e.filter(function(n, o, a) {
    return a.indexOf(n) === o;
  });
  return e.length === r.length;
}
function rX(e, t) {
  var r = typeof e == "function" ? e : void 0, n = typeof e != "function" ? e : t;
  return Y({
    name: qS,
    validator: {
      validate: function(o, a) {
        return JS(o, r);
      },
      defaultMessage: z(function(o) {
        return o + "All $property's elements must be unique";
      }, n)
    }
  }, n);
}
var QS = "isNotEmptyObject";
function e_(e, t) {
  if (!C2(e))
    return !1;
  if ((t == null ? void 0 : t.nullable) === !1)
    return !Object.values(e).every(function(n) {
      return n == null;
    });
  for (var r in e)
    if (e.hasOwnProperty(r))
      return !0;
  return !1;
}
function nX(e, t) {
  return Y({
    name: QS,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return e_(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r) {
        return r + "$property must be a non-empty object";
      }, t)
    }
  }, t);
}
var u1 = "isInstance";
function t_(e, t) {
  return t && typeof t == "function" && e instanceof t;
}
function oX(e, t) {
  return Y({
    name: u1,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return t_(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: z(function(r, n) {
        return n != null && n.constraints[0] ? r + "$property must be an instance of ".concat(n == null ? void 0 : n.constraints[0].name) : r + "".concat(u1, " decorator expects and object as value, but got falsy value.");
      }, t)
    }
  }, t);
}
function aX(e, t, r) {
  return typeof e == "string" ? Er(hn).validate(e, t, r) : Er(hn).validate(e, t);
}
function dX(e, t, r) {
  return typeof e == "string" ? Er(hn).validateOrReject(e, t, r) : Er(hn).validateOrReject(e, t);
}
function iX(e, t, r) {
  return typeof e == "string" ? Er(hn).validateSync(e, t, r) : Er(hn).validateSync(e, t);
}
function sX(e) {
  kt().addValidationSchema(e);
}
const uX = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ARRAY_CONTAINS: ZS,
  ARRAY_MAX_SIZE: YS,
  ARRAY_MIN_SIZE: WS,
  ARRAY_NOT_CONTAINS: GS,
  ARRAY_NOT_EMPTY: HS,
  ARRAY_UNIQUE: qS,
  Allow: aG,
  ArrayContains: qY,
  ArrayMaxSize: tX,
  ArrayMinSize: eX,
  ArrayNotContains: JY,
  ArrayNotEmpty: QY,
  ArrayUnique: rX,
  CONTAINS: Pb,
  Contains: TG,
  EQUALS: Qy,
  Equals: gG,
  IS_ALPHA: Fb,
  IS_ALPHANUMERIC: Bb,
  IS_ARRAY: kS,
  IS_ASCII: Kb,
  IS_BASE32: aA,
  IS_BASE58: bS,
  IS_BASE64: zb,
  IS_BIC: sA,
  IS_BOOLEAN: ES,
  IS_BOOLEAN_STRING: Qw,
  IS_BTC_ADDRESS: cA,
  IS_BYTE_LENGTH: Xb,
  IS_CREDIT_CARD: ex,
  IS_CURRENCY: nx,
  IS_DATA_URI: $A,
  IS_DATE: CS,
  IS_DATE_STRING: Xw,
  IS_DECIMAL: Gb,
  IS_DEFINED: Vy,
  IS_DIVISIBLE_BY: vb,
  IS_EAN: hA,
  IS_EMAIL: dx,
  IS_EMPTY: nb,
  IS_ENUM: PS,
  IS_ETHEREUM_ADDRESS: bA,
  IS_FIREBASE_PUSH_ID: mw,
  IS_FQDN: sx,
  IS_FULL_WIDTH: lx,
  IS_HALF_WIDTH: fx,
  IS_HASH: Hw,
  IS_HEXADECIMAL: bx,
  IS_HEX_COLOR: gx,
  IS_HSL: AA,
  IS_IBAN: EA,
  IS_IDENTITY_CARD: OA,
  IS_IN: ib,
  IS_INSTANCE: u1,
  IS_INT: TS,
  IS_IP: _x,
  IS_ISBN: Ix,
  IS_ISIN: Tx,
  IS_ISO31661_ALPHA_2: Xx,
  IS_ISO31661_ALPHA_3: Qx,
  IS_ISO4217_CURRENCY_CODE: SS,
  IS_ISO8601: Fx,
  IS_ISRC: PA,
  IS_ISSN: zw,
  IS_JSON: jx,
  IS_JWT: Ux,
  IS_LATITUDE: Yy,
  IS_LATLONG: zy,
  IS_LENGTH: ww,
  IS_LOCALE: DA,
  IS_LONGITUDE: qy,
  IS_LOWERCASE: Hx,
  IS_MAC_ADDRESS: Ax,
  IS_MAGNET_URI: kA,
  IS_MILITARY_TIME: Uw,
  IS_MIME_TYPE: ZA,
  IS_MOBILE_PHONE: zx,
  IS_MONGO_ID: rw,
  IS_MULTIBYTE: aw,
  IS_NEGATIVE: yb,
  IS_NOT_EMPTY: ab,
  IS_NOT_EMPTY_OBJECT: QS,
  IS_NOT_IN: ub,
  IS_NUMBER: NS,
  IS_NUMBER_STRING: rA,
  IS_OBJECT: BS,
  IS_OCTAL: VA,
  IS_OPTIONAL: Ky,
  IS_PASSPORT_NUMBER: WA,
  IS_PHONE_NUMBER: Bw,
  IS_PORT: Cx,
  IS_POSITIVE: hb,
  IS_POSTAL_CODE: XA,
  IS_RFC_3339: QA,
  IS_RGB_COLOR: rS,
  IS_SEM_VER: aS,
  IS_STRING: LS,
  IS_STRONG_PASSWORD: mS,
  IS_SURROGATE_PAIR: sw,
  IS_TAX_ID: wS,
  IS_TIMEZONE: gS,
  IS_UPPERCASE: yw,
  IS_URL: cw,
  IS_UUID: $w,
  IS_VARIABLE_WIDTH: vx,
  IsAlpha: kG,
  IsAlphanumeric: ZG,
  IsArray: YY,
  IsAscii: zG,
  IsBIC: rz,
  IsBase32: QW,
  IsBase58: DY,
  IsBase64: qG,
  IsBoolean: UY,
  IsBooleanString: WW,
  IsBtcAddress: az,
  IsByteLength: eV,
  IsCreditCard: nV,
  IsCurrency: dV,
  IsDataURI: sz,
  IsDate: GY,
  IsDateString: VW,
  IsDecimal: HG,
  IsDefined: dG,
  IsDivisibleBy: EG,
  IsEAN: cz,
  IsEmail: uV,
  IsEmpty: bG,
  IsEnum: KY,
  IsEthereumAddress: $z,
  IsFQDN: fV,
  IsFirebasePushId: _H,
  IsFullWidth: vV,
  IsHSL: hz,
  IsHalfWidth: gV,
  IsHash: BW,
  IsHexColor: SV,
  IsHexadecimal: MV,
  IsIBAN: bz,
  IsIP: RV,
  IsISBN: jV,
  IsISIN: UV,
  IsISO31661Alpha2: dH,
  IsISO31661Alpha3: uH,
  IsISO4217CurrencyCode: ZY,
  IsISO8601: HV,
  IsISRC: Ez,
  IsISSN: GW,
  IsIdentityCard: Az,
  IsIn: wG,
  IsInstance: oX,
  IsInt: WY,
  IsJSON: zV,
  IsJWT: qV,
  IsLatLong: vG,
  IsLatitude: mG,
  IsLocale: Oz,
  IsLongitude: hG,
  IsLowercase: eH,
  IsMACAddress: NV,
  IsMagnetURI: Pz,
  IsMilitaryTime: FW,
  IsMimeType: Dz,
  IsMobilePhone: nH,
  IsMongoId: fH,
  IsMultibyte: vH,
  IsNegative: CG,
  IsNotEmpty: xG,
  IsNotEmptyObject: nX,
  IsNotIn: AG,
  IsNumber: VY,
  IsNumberString: XW,
  IsObject: XY,
  IsOctal: kz,
  IsOptional: iG,
  IsPassportNumber: Zz,
  IsPhoneNumber: LW,
  IsPort: LV,
  IsPositive: MG,
  IsPostalCode: Vz,
  IsRFC3339: Wz,
  IsRgbColor: Xz,
  IsSemVer: eY,
  IsString: zY,
  IsStrongPassword: IY,
  IsSurrogatePair: gH,
  IsTaxId: kY,
  IsTimeZone: PY,
  IsUUID: SH,
  IsUppercase: CH,
  IsUrl: xH,
  IsVariableWidth: xV,
  Length: NH,
  MATCHES: Nw,
  MAX: xb,
  MAX_DATE: Mb,
  MAX_LENGTH: Sw,
  MIN: Ab,
  MIN_DATE: _b,
  MIN_LENGTH: Ew,
  Matches: TH,
  Max: OG,
  MaxDate: PG,
  MaxLength: IH,
  MetadataStorage: c2,
  Min: NG,
  MinDate: IG,
  MinLength: PH,
  NOT_CONTAINS: Tb,
  NOT_EQUALS: tb,
  NotContains: DG,
  NotEquals: yG,
  Validate: uG,
  ValidateBy: Y,
  ValidateIf: lG,
  ValidateNested: cG,
  ValidatePromise: fG,
  ValidationError: Qc,
  ValidationTypes: qe,
  Validator: hn,
  ValidatorConstraint: sG,
  arrayContains: US,
  arrayMaxSize: XS,
  arrayMinSize: zS,
  arrayNotContains: VS,
  arrayNotEmpty: KS,
  arrayUnique: JS,
  buildMessage: z,
  contains: Rb,
  equals: eb,
  getFromContainer: Er,
  getMetadataStorage: kt,
  isAlpha: kb,
  isAlphanumeric: Zb,
  isArray: jS,
  isAscii: Wb,
  isBIC: uA,
  isBase32: dA,
  isBase58: xS,
  isBase64: Yb,
  isBoolean: MS,
  isBooleanString: eA,
  isBtcAddress: fA,
  isByteLength: qb,
  isCreditCard: tx,
  isCurrency: ox,
  isDataURI: vA,
  isDate: OS,
  isDateString: qw,
  isDecimal: Vb,
  isDefined: Hy,
  isDivisibleBy: mb,
  isEAN: gA,
  isEmail: ix,
  isEmpty: ob,
  isEnum: RS,
  isEthereumAddress: xA,
  isFQDN: ux,
  isFirebasePushId: hw,
  isFullWidth: cx,
  isHSL: SA,
  isHalfWidth: px,
  isHash: Kw,
  isHexColor: yx,
  isHexadecimal: xx,
  isIBAN: MA,
  isIP: Ex,
  isISBN: Px,
  isISIN: Dx,
  isISO31661Alpha2: qx,
  isISO31661Alpha3: ew,
  isISO4217CurrencyCode: _S,
  isISO8601: y2,
  isISRC: RA,
  isISSN: Yw,
  isIdentityCard: NA,
  isIn: sb,
  isInstance: t_,
  isInt: DS,
  isJSON: Bx,
  isJWT: Gx,
  isLatLong: gi,
  isLatitude: Xy,
  isLocale: LA,
  isLongitude: Jy,
  isLowercase: Kx,
  isMACAddress: Sx,
  isMagnetURI: jA,
  isMilitaryTime: Gw,
  isMimeType: UA,
  isMobilePhone: Yx,
  isMongoId: nw,
  isMultibyte: dw,
  isNegative: bb,
  isNotEmpty: db,
  isNotEmptyObject: e_,
  isNotIn: lb,
  isNumber: IS,
  isNumberString: nA,
  isObject: C2,
  isOctal: HA,
  isPassportNumber: zA,
  isPhoneNumber: Zw,
  isPort: Ox,
  isPositive: gb,
  isPostalCode: qA,
  isRFC3339: eS,
  isRgbColor: nS,
  isSemVer: dS,
  isString: FS,
  isStrongPassword: hS,
  isSurrogatePair: uw,
  isTaxId: AS,
  isTimeZone: yS,
  isURL: fw,
  isUUID: vw,
  isUppercase: bw,
  isValidationOptions: r1,
  isVariableWidth: mx,
  length: Aw,
  matches: Iw,
  max: wb,
  maxDate: Cb,
  maxLength: _w,
  min: Sb,
  minDate: Eb,
  minLength: Mw,
  notContains: Db,
  notEquals: rb,
  registerDecorator: Gy,
  registerSchema: sX,
  useContainer: oG,
  validate: aX,
  validateOrReject: dX,
  validateSync: iX
}, Symbol.toStringTag, { value: "Module" })), lX = /* @__PURE__ */ BU(uX);
var t7;
function cX() {
  if (t7) return Qt;
  t7 = 1;
  var e = Qt && Qt.__decorate || function(o, a, d, i) {
    var s = arguments.length, u = s < 3 ? a : i === null ? i = Object.getOwnPropertyDescriptor(a, d) : i, c;
    if (typeof Reflect == "object" && typeof Reflect.decorate == "function") u = Reflect.decorate(o, a, d, i);
    else for (var l = o.length - 1; l >= 0; l--) (c = o[l]) && (u = (s < 3 ? c(u) : s > 3 ? c(a, d, u) : c(a, d)) || u);
    return s > 3 && u && Object.defineProperty(a, d, u), u;
  };
  Object.defineProperty(Qt, "__esModule", { value: !0 }), Qt.MatchConstraint = Qt.Match = void 0;
  const t = lX, r = (o, a) => (d, i) => (0, t.registerDecorator)({
    target: d.constructor,
    propertyName: i,
    options: a,
    constraints: [o],
    validator: n
  });
  Qt.Match = r;
  let n = class {
    validate(o, a) {
      const [d] = (a == null ? void 0 : a.constraints) || [], i = (a == null ? void 0 : a.object)[d];
      return (0, t.equals)(o, i);
    }
    defaultMessage(o) {
      const [a] = (o == null ? void 0 : o.constraints) || [];
      return `${o == null ? void 0 : o.property} does not match the ${a}`;
    }
  };
  return Qt.MatchConstraint = n, Qt.MatchConstraint = n = e([
    (0, t.ValidatorConstraint)({ name: "Match" })
  ], n), Qt;
}
var r7 = {}, n7;
function fX() {
  return n7 || (n7 = 1, Object.defineProperty(r7, "__esModule", { value: !0 })), r7;
}
var cd = {}, o7;
function pX() {
  if (o7) return cd;
  o7 = 1, Object.defineProperty(cd, "__esModule", { value: !0 }), cd.isPlural = r;
  const e = /* @__PURE__ */ new Set([
    "address",
    "athletics",
    "billiards",
    "bowels",
    "business",
    "chaos",
    "chess",
    "crossroads",
    "economics",
    "ethics",
    "gallows",
    "gas",
    "genetics",
    "glass",
    "grass",
    "gymnastics",
    "happiness",
    "kindness",
    "linguistics",
    "loneliness",
    "mathematics",
    "measles",
    "minus",
    "mumps",
    "news",
    "physics",
    "progress",
    "success",
    "tennis",
    "acoustics",
    "aerobics",
    "aerodynamics",
    "aeronautics",
    "classics",
    "electronics",
    "logistics",
    "mechanics",
    "obstetrics",
    "politics",
    "statistics",
    "thermodynamics",
    "bowls",
    "cards",
    "darts",
    "diabetes",
    "rabies",
    "draughts",
    "skittles",
    "rickets",
    "shingles",
    "iris",
    "lens",
    "status"
  ]), t = /* @__PURE__ */ new Set([
    "feet",
    "teeth",
    "geese",
    "men",
    "women",
    "mice",
    "dice",
    "oxen",
    "children",
    "people",
    "pence",
    "foci",
    "radii",
    "fungi",
    "nuclei",
    "cacti",
    "alumni",
    "phenomena",
    "criteria",
    "data",
    "memoranda",
    "bacteria",
    "strata",
    "curricula",
    "media",
    "stadia",
    "syllabi",
    "antennae",
    "lice",
    "genera",
    "stimuli"
  ]);
  function r(n) {
    const o = n.toLowerCase();
    return !e.has(o) && !o.endsWith("itis") && !o.endsWith("osis") && (o.endsWith("s") || t.has(o));
  }
  return cd;
}
var on = {}, a7;
function $X() {
  if (a7) return on;
  a7 = 1, Object.defineProperty(on, "__esModule", { value: !0 }), on.EnumError = void 0, on.createLookup = t, on.createValues = r;
  class e extends Error {
    constructor(o) {
      super(o), Object.setPrototypeOf(this, e.prototype);
    }
  }
  on.EnumError = e;
  function t(n, o, a) {
    const d = Object.entries(n).reduce((s, [u, c]) => Object.assign(Object.assign({}, s), { [c]: u }), {}), i = Object.values(n).join(", ");
    return (s) => {
      if (s == null)
        return s;
      const u = d[s.trim()];
      if (u === void 0) {
        if (o)
          return o;
        const c = `Enum value ${s.trim()} not found in [${i}].`;
        if (a === !0)
          throw new e(c);
        if (typeof a == "function")
          throw a(c);
      }
      return n[u];
    };
  }
  function r(n) {
    const o = Object.values(n).filter((a) => typeof a != "function");
    return () => o;
  }
  return on;
}
var d7 = {}, i7;
function vX() {
  return i7 || (i7 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.env = void 0, e.forEnv = a, e.fromEnv = d;
    const t = By(), r = Fo();
    e.env = {
      serialize: n,
      deserialize: o
    };
    function n(i) {
      const s = {};
      return Object.entries(i).forEach(([u, c]) => {
        c === void 0 ? s[u] = "u:" : c === null ? s[u] = "n:" : typeof c == "string" ? s[u] = `S:${c}` : typeof c == "boolean" ? s[u] = `B:${c}` : typeof c == "number" ? s[u] = `N:${c}` : c instanceof Date ? s[u] = `D:${c.toISOString()}` : s[u] = `X:${(0, r.json)(c, !1)}`;
      }), s;
    }
    function o(i) {
      const s = {};
      return Object.entries(i).forEach(([u, c]) => {
        if (c == null) {
          s[u] = c;
          return;
        }
        const [l, p] = (0, r.split)(c, 2);
        switch (l) {
          case "S:":
            s[u] = p;
            break;
          case "B:":
            s[u] = p === "true";
            break;
          case "N:":
            s[u] = Number(p);
            break;
          case "D:":
            s[u] = new Date(p);
            break;
          case "X:":
            s[u] = JSON.parse(p);
            break;
          case "u:":
            s[u] = void 0;
            break;
          case "n:":
            s[u] = null;
            break;
          default:
            s[u] = c;
            break;
        }
      }), s;
    }
    function a(i, s, u) {
      return e.env.serialize((0, t.flatten)(i, s, u));
    }
    function d(i, s, u) {
      return (0, t.grow)(e.env.deserialize(i), s, u);
    }
  }(d7)), d7;
}
var oa = {}, s7;
function mX() {
  if (s7) return oa;
  s7 = 1, Object.defineProperty(oa, "__esModule", { value: !0 }), oa.noop = e, oa.debounce = t;
  function e() {
  }
  function t(r, n) {
    let o = null;
    return function(...a) {
      const d = a;
      o && clearTimeout(o), o = setTimeout(() => {
        r(...d), o = null;
      }, n);
    };
  }
  return oa;
}
var Gt = {}, u7;
function hX() {
  if (u7) return Gt;
  u7 = 1;
  var e = Gt && Gt.__asyncValues || function(i) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var s = i[Symbol.asyncIterator], u;
    return s ? s.call(i) : (i = typeof __values == "function" ? __values(i) : i[Symbol.iterator](), u = {}, c("next"), c("throw"), c("return"), u[Symbol.asyncIterator] = function() {
      return this;
    }, u);
    function c(p) {
      u[p] = i[p] && function(h) {
        return new Promise(function(m, f) {
          h = i[p](h), l(m, f, h.done, h.value);
        });
      };
    }
    function l(p, h, m, f) {
      Promise.resolve(f).then(function($) {
        p({ value: $, done: m });
      }, h);
    }
  };
  Object.defineProperty(Gt, "__esModule", { value: !0 }), Gt.readBodyBuffer = t, Gt.readBodyData = r, Gt.readBodyJson = n, Gt.parseUrl = o, Gt.urlPathJoin = a, Gt.urlQueryJoin = d;
  async function t(i, s) {
    var u, c, l, p;
    s = s ?? i;
    let h = s.bodyBuffer;
    if (h === void 0) {
      if (!i.readableLength)
        return;
      const v = [];
      try {
        for (var m = !0, f = e(i), $; $ = await f.next(), u = $.done, !u; m = !0) {
          p = $.value, m = !1;
          const y = p;
          v.push(y);
        }
      } catch (y) {
        c = { error: y };
      } finally {
        try {
          !m && !u && (l = f.return) && await l.call(f);
        } finally {
          if (c) throw c.error;
        }
      }
      h = Buffer.concat(v), s.bodyBuffer = h;
    }
    return h;
  }
  async function r(i, s) {
    s = s ?? i;
    let u = s.bodyData;
    if (u === void 0) {
      if (u = await t(i), !u)
        return;
      u = u.toString(), s.bodyData = u;
    }
    return u;
  }
  async function n(i, s) {
    s = s ?? i;
    let u = s.bodyJson;
    if (u === void 0) {
      const c = await r(i);
      if (c === void 0)
        return;
      u = JSON.parse(c), s.bodyJson = u;
    }
    return u;
  }
  function o(i) {
    const s = i.startsWith("https:") ? "https:" : "http:", u = i.indexOf("?");
    let c = i, l = "";
    u !== -1 && (c = i.substr(0, u), l = i.substr(u + 1));
    let p = c.indexOf("://");
    p = p === -1 ? 0 : p + 3;
    let h = c.indexOf("/", p);
    h = h !== -1 ? h : void 0;
    const m = c.substring(p, h);
    let f = "";
    return h !== void 0 && (f = c.substr(h + 1)), {
      protocol: s,
      base: c,
      host: m,
      path: f,
      query: l
    };
  }
  function a(i, ...s) {
    let u = i;
    for (const c of s)
      u.endsWith("/") && c.startsWith("/") ? u += c.substring(1) : u.endsWith("/") || c.startsWith("/") ? u += c : u += "/" + c;
    return u;
  }
  function d(...i) {
    return i.join("&");
  }
  return Gt;
}
var po = {}, l7;
function gX() {
  if (l7) return po;
  l7 = 1, Object.defineProperty(po, "__esModule", { value: !0 }), po.Interval = void 0, po.interval = a;
  const e = 1e3, t = 60 * (60 * e), r = 24 * t, n = 7 * r;
  class o {
    constructor(i) {
      this.milliseconds = 0, this.milliseconds = i ?? 0;
    }
    millis(i) {
      return this.milliseconds += i, this;
    }
    sec(i) {
      return this.milliseconds += i * e, this;
    }
    min(i) {
      return this.milliseconds += i * t, this;
    }
    hours(i) {
      return this.milliseconds += i * t, this;
    }
    days(i) {
      return this.milliseconds += i * r, this;
    }
    weeks(i) {
      return this.milliseconds += i * n, this;
    }
    value() {
      return this.milliseconds;
    }
    before(i) {
      var s;
      const u = (s = i == null ? void 0 : i.getDate()) !== null && s !== void 0 ? s : Date.now();
      return new Date(u - this.milliseconds);
    }
    after(i) {
      var s;
      const u = (s = i == null ? void 0 : i.getDate()) !== null && s !== void 0 ? s : Date.now();
      return new Date(u + this.milliseconds);
    }
  }
  po.Interval = o;
  function a(d) {
    return new o(d);
  }
  return po;
}
var $o = {}, c7;
function yX() {
  if (c7) return $o;
  c7 = 1, Object.defineProperty($o, "__esModule", { value: !0 }), $o.flushPromises = e, $o.useFakeTimers = t, $o.advanceTimersByTime = r;
  async function e(n = !1) {
    if (n)
      await new Promise((o) => process.nextTick(o));
    else
      return new Promise(jest.requireActual("timers").setImmediate);
  }
  function t(n = !1) {
    n ? jest.useFakeTimers({ legacyFakeTimers: !0 }) : (jest.useFakeTimers(), jest.setSystemTime(0));
  }
  async function r(n) {
    jest.advanceTimersByTime(n), await e();
  }
  return $o;
}
var fd = {}, f7;
function bX() {
  if (f7) return fd;
  f7 = 1, Object.defineProperty(fd, "__esModule", { value: !0 }), fd.pluralize = e;
  function e(t, r, n, o) {
    o = o || n;
    const a = t % 10, d = t % 100;
    return d >= 11 && d <= 14 || a === 0 ? o : a === 1 ? r : a <= 4 ? n : o;
  }
  return fd;
}
var pd = {}, p7;
function xX() {
  if (p7) return pd;
  p7 = 1, Object.defineProperty(pd, "__esModule", { value: !0 }), pd.onProcessExit = e;
  function e(t) {
    process.on("exit", () => console.log("EXIT")), process.on("SIGINT", async () => {
      await t(), process.exit();
    }), process.on("SIGTERM", async () => {
      await t(), process.exit();
    }), process.on("SIGUSR1", async () => {
      await t(), process.exit();
    }), process.on("SIGUSR2", async () => {
      await t(), process.exit();
    }), process.on("SIGQUIT", async () => {
      await t(), process.exit();
    });
  }
  return pd;
}
var Vt = {}, $7;
function wX() {
  if ($7) return Vt;
  $7 = 1, Object.defineProperty(Vt, "__esModule", { value: !0 }), Vt.Deferred = Vt.PromiseStatus = void 0, Vt.promiseWithStatus = t, Vt.resolveDelayed = r, Vt.pause = n, Vt.rejectDelayed = o;
  var e;
  (function(i) {
    i.pending = "pending", i.fulfilled = "fulfilled", i.rejected = "rejected";
  })(e || (Vt.PromiseStatus = e = {}));
  function t(i) {
    const s = Promise.resolve(i);
    return s.status = e.pending, s.then((u) => (s.status = e.fulfilled, u)).catch(() => {
      s.status = e.rejected;
    }), s;
  }
  function r(i, s) {
    return new Promise((u) => {
      setTimeout(() => {
        u(s);
      }, i);
    });
  }
  function n(i) {
    return r(i);
  }
  function o(i, s) {
    return new Promise((u, c) => {
      setTimeout(() => {
        c(s);
      }, i);
    });
  }
  let a = 1;
  class d {
    constructor() {
      this._settled = !1, this._resolved = !1, this._rejected = !1, this._promise = new Promise((s, u) => {
        this.resolveFn = s, this.rejectFn = u;
      }), this.id = a++;
    }
    resolve(s) {
      this.resolveFn(s), this._resolved = !0, this._settled = !0;
    }
    reject(s) {
      this.rejectFn(s), this._rejected = !0, this._settled = !0;
    }
    get promise() {
      return this._promise;
    }
    get isSettled() {
      return this._settled;
    }
    get isRejected() {
      return this._rejected;
    }
    get isResolved() {
      return this._resolved;
    }
  }
  return Vt.Deferred = d, Vt;
}
var v7 = {}, m7;
function AX() {
  return m7 || (m7 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.resolved = void 0, e.processTemplate = r;
    function t() {
      function n(a) {
        return Promise.all(a.map((d) => Array.isArray(d) ? n(d) : d));
      }
      function o(a, ...d) {
        return d.length === 1 && a.length === 2 && a[0] === "" && a[1] === "";
      }
      return async function(a, ...d) {
        return o(a, d) ? d[0] : n(d).then((i) => String.raw({ raw: a }, i));
      };
    }
    e.resolved = t();
    async function r(n, o = {}, a = {}) {
      const d = Object.assign(Object.assign(Object.assign({}, o), a), { resolved: e.resolved }), i = Object.keys(d), s = Object.values(d);
      return new Function(...i, "return resolved`" + n + "`")(...s);
    }
  }(v7)), v7;
}
var h7 = {}, g7;
function SX() {
  return g7 || (g7 = 1, Object.defineProperty(h7, "__esModule", { value: !0 })), h7;
}
var $d = {}, y7;
function _X() {
  if (y7) return $d;
  y7 = 1, Object.defineProperty($d, "__esModule", { value: !0 }), $d.uuid7 = r;
  let e = 0, t = 0;
  function r() {
    function n() {
      const a = o(), d = Math.random(), i = String(a) + String(~~(d * 9e4) + 1e4), s = i.length;
      return `${i.slice(0, 8)}-${i.slice(8, 12)}-4${i.slice(12, 15)}-${[8, 9, "a", "b"][~~(d * 3)]}${i.slice(15, 18)}-${i.slice(18, 24)}${i.slice(s - 12, s - (30 - s))}`;
    }
    function o() {
      const a = Date.now();
      return a !== e && (e = a, t = 1), BigInt(a) * BigInt(1e6) + BigInt(Math.min(t++, 999999));
    }
    return n();
  }
  return $d;
}
var vd = {}, b7;
function EX() {
  if (b7) return vd;
  b7 = 1, Object.defineProperty(vd, "__esModule", { value: !0 }), vd.createEmailAlias = e;
  function e(t, r) {
    const [n, o] = t.split("@");
    return n.includes("+") ? `${n}-${r}@${o}` : `${n}+${r}@${o}`;
  }
  return vd;
}
var x7;
function MX() {
  return x7 || (x7 = 1, function(e) {
    var t = Yn && Yn.__createBinding || (Object.create ? function(n, o, a, d) {
      d === void 0 && (d = a);
      var i = Object.getOwnPropertyDescriptor(o, a);
      (!i || ("get" in i ? !o.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
        return o[a];
      } }), Object.defineProperty(n, d, i);
    } : function(n, o, a, d) {
      d === void 0 && (d = a), n[d] = o[a];
    }), r = Yn && Yn.__exportStar || function(n, o) {
      for (var a in n) a !== "default" && !Object.prototype.hasOwnProperty.call(o, a) && t(o, n, a);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), r(GU(), e), r(By(), e), r(VU(), e), r(HU(), e), r(KU(), e), r(WU(), e), r(cX(), e), r(fX(), e), r(Zy(), e), r(pX(), e), r($X(), e), r(vX(), e), r(mX(), e), r(hX(), e), r(gX(), e), r(yX(), e), r(bX(), e), r(hi(), e), r(xX(), e), r(wX(), e), r(Fo(), e), r(AX(), e), r(SX(), e), r(_X(), e), r(EX(), e);
  }(Yn)), Yn;
}
MX();
function md(e, t) {
  if (e.length === 0)
    return {};
  if (!t)
    return {
      "": e
    };
  const r = {};
  return e.forEach((n) => {
    const o = n[t] || "";
    r[o] || (r[o] = []), r[o].push(n);
  }), r;
}
function CX(e, t) {
  const r = JSON.parse(JSON.stringify(e));
  for (const [n, o] of Object.entries(r))
    r[n] = o.filter((a) => !t.find((d) => d.value === a.value));
  return r;
}
function OX(e, t) {
  for (const [, r] of Object.entries(e))
    if (r.some((n) => t.find((o) => o.value === n.value)))
      return !0;
  return !1;
}
const r_ = X(
  ({ className: e, ...t }, r) => Gr((n) => n.filtered.count === 0) ? /* @__PURE__ */ A(
    "div",
    {
      ref: r,
      className: q("py-6 text-center text-sm", e),
      "cmdk-empty": "",
      role: "presentation",
      ...t
    }
  ) : null
);
r_.displayName = "CommandEmpty";
const NX = X(
  ({
    value: e,
    onChange: t,
    placeholder: r,
    defaultOptions: n = [],
    options: o,
    delay: a,
    onSearch: d,
    onSearchSync: i,
    loadingIndicator: s,
    emptyIndicator: u,
    maxSelected: c = Number.MAX_SAFE_INTEGER,
    onMaxSelected: l,
    hidePlaceholderWhenSelected: p,
    disabled: h,
    groupBy: m,
    className: f,
    badgeClassName: $,
    selectFirstItem: v = !0,
    creatable: y = !1,
    triggerSearchOnFocus: S = !1,
    commandProps: w,
    inputProps: _,
    hideClearAllButton: I = !1,
    tabIndex: N
  }, O) => {
    const E = Nt(null), [C, P] = Ie(!1), [T, j] = Ie(!1), [F, Z] = Ie(!1), te = Nt(null), [H, de] = Ie(e || []), [G, le] = Ie(md(n, m)), [fe, U] = Ie(""), ae = jU(fe, a || 500);
    EO(
      O,
      () => ({
        selectedValue: [...H],
        input: E.current,
        focus: () => {
          var ee;
          return (ee = E.current) == null ? void 0 : ee.focus();
        }
      }),
      [H]
    );
    const ue = (ee) => {
      te.current && !te.current.contains(ee.target) && E.current && !E.current.contains(ee.target) && P(!1);
    }, se = rr(
      (ee) => {
        const ce = H.filter((he) => he.value !== ee.value);
        de(ce), t == null || t(ce);
      },
      [t, H]
    ), we = rr(
      (ee) => {
        const ce = E.current;
        ce && ((ee.key === "Delete" || ee.key === "Backspace") && ce.value === "" && H.length > 0 && (H[H.length - 1].fixed || se(H[H.length - 1])), ee.key === "Escape" && ce.blur(), ee.key === "Enter" && ce.focus());
      },
      [se, H]
    );
    rt(() => (C ? (document.addEventListener("mousedown", ue), document.addEventListener("touchend", ue)) : (document.removeEventListener("mousedown", ue), document.removeEventListener("touchend", ue)), () => {
      document.removeEventListener("mousedown", ue), document.removeEventListener("touchend", ue);
    }), [C]), rt(() => {
      e && de(e);
    }, [e]), rt(() => {
      if (!o || d)
        return;
      const ee = md(o || [], m);
      JSON.stringify(ee) !== JSON.stringify(G) && le(ee);
    }, [n, o, m, d, G]), rt(() => {
      const ee = () => {
        const ce = i == null ? void 0 : i(ae);
        le(md(ce || [], m));
      };
      (async () => !i || !C || (S && ee(), ae && ee()))();
    }, [ae, m, C, S]), rt(() => {
      const ee = async () => {
        Z(!0);
        const ce = await (d == null ? void 0 : d(ae));
        le(md(ce || [], m)), Z(!1);
      };
      (async () => !d || !C || (S && await ee(), ae && await ee()))();
    }, [ae, m, C, S]);
    const re = () => {
      if (!y || OX(G, [{ value: fe, label: fe }]) || H.find((ce) => ce.value === fe))
        return;
      const ee = /* @__PURE__ */ A(
        da,
        {
          value: fe,
          className: "cursor-pointer",
          onMouseDown: (ce) => {
            ce.preventDefault(), ce.stopPropagation();
          },
          onSelect: (ce) => {
            if (H.length >= c) {
              l == null || l(H.length);
              return;
            }
            U("");
            const he = [...H, { value: ce, label: ce }];
            de(he), t == null || t(he);
          },
          children: `Create "${fe}"`
        }
      );
      if (!d && fe.length > 0 || d && ae.length > 0 && !F)
        return ee;
    }, ye = rr(() => {
      if (u)
        return d && !y && Object.keys(G).length === 0 ? /* @__PURE__ */ A(da, { value: "-", disabled: !0, children: u }) : /* @__PURE__ */ A(r_, { children: u });
    }, [y, u, d, G]), xe = ar(() => CX(G, H), [G, H]), be = rr(() => {
      if (w != null && w.filter)
        return w.filter;
      if (y)
        return (ee, ce) => ee.toLowerCase().includes(ce.toLowerCase()) ? 1 : -1;
    }, [y, w == null ? void 0 : w.filter]);
    return /* @__PURE__ */ ie(
      Fy,
      {
        tabIndex: N,
        ref: te,
        ...w,
        onKeyDown: (ee) => {
          var ce;
          we(ee), (ce = w == null ? void 0 : w.onKeyDown) == null || ce.call(w, ee);
        },
        className: q(
          "outline-border outline-1 h-auto overflow-visible bg-transparent",
          w == null ? void 0 : w.className
        ),
        shouldFilter: (w == null ? void 0 : w.shouldFilter) !== void 0 ? w.shouldFilter : !d,
        filter: be(),
        children: [
          /* @__PURE__ */ A(
            "div",
            {
              className: q(
                "min-h-10 rounded-md border border-input text-sm ring-offset-background focus-visible:ring-0 focus-within:ring-1 focus-within:ring-ring focus-within:ring-offset-1",
                {
                  "px-3 py-2": H.length !== 0,
                  "cursor-text": !h && H.length !== 0
                },
                f
              ),
              onClick: () => {
                var ee;
                h || (ee = E.current) == null || ee.focus();
              },
              children: /* @__PURE__ */ ie("div", { className: "relative flex flex-wrap gap-1", children: [
                H.map((ee) => /* @__PURE__ */ ie(
                  kU,
                  {
                    className: q(
                      "data-[disabled]:bg-muted-foreground data-[disabled]:text-muted data-[disabled]:hover:bg-muted-foreground",
                      "data-[fixed]:bg-muted-foreground data-[fixed]:text-muted data-[fixed]:hover:bg-muted-foreground",
                      $
                    ),
                    "data-fixed": ee.fixed,
                    "data-disabled": h || void 0,
                    children: [
                      ee.label,
                      /* @__PURE__ */ A(
                        "button",
                        {
                          className: q(
                            "ml-1 rounded-full outline-none ring-offset-background focus:ring-2 focus:ring-ring focus:ring-offset-2",
                            (h || ee.fixed) && "hidden"
                          ),
                          onKeyDown: (ce) => {
                            ce.key === "Enter" && se(ee);
                          },
                          onMouseDown: (ce) => {
                            ce.preventDefault(), ce.stopPropagation();
                          },
                          onClick: () => se(ee),
                          children: /* @__PURE__ */ A(J4, { className: "size-3 text-muted-foreground hover:text-foreground" })
                        }
                      )
                    ]
                  },
                  ee.value
                )),
                /* @__PURE__ */ A(
                  mt.Input,
                  {
                    ..._,
                    ref: E,
                    value: fe,
                    disabled: h,
                    onValueChange: (ee) => {
                      var ce;
                      U(ee), (ce = _ == null ? void 0 : _.onValueChange) == null || ce.call(_, ee);
                    },
                    onBlur: (ee) => {
                      var ce;
                      T || P(!1), (ce = _ == null ? void 0 : _.onBlur) == null || ce.call(_, ee);
                    },
                    onFocus: (ee) => {
                      var ce;
                      P(!0), S && (d == null || d(ae)), (ce = _ == null ? void 0 : _.onFocus) == null || ce.call(_, ee);
                    },
                    placeholder: p && H.length !== 0 ? "" : r,
                    className: q(
                      "flex-1 bg-transparent outline-none placeholder:text-muted-foreground",
                      {
                        "w-full": p,
                        "px-3 py-2": H.length === 0,
                        "ml-1": H.length !== 0
                      },
                      _ == null ? void 0 : _.className
                    )
                  }
                ),
                /* @__PURE__ */ A(
                  "button",
                  {
                    type: "button",
                    onClick: () => {
                      de(H.filter((ee) => ee.fixed)), t == null || t(H.filter((ee) => ee.fixed));
                    },
                    className: q(
                      "absolute right-0 h-6 w-6 p-0",
                      (I || h || H.length < 1 || H.filter((ee) => ee.fixed).length === H.length) && "hidden"
                    ),
                    children: /* @__PURE__ */ A(J4, { className: "size-4 text-muted-foreground hover:text-foreground" })
                  }
                )
              ] })
            }
          ),
          /* @__PURE__ */ A("div", { className: "relative", children: C && /* @__PURE__ */ A(
            ky,
            {
              className: "absolute top-1 z-10 w-full rounded-md border bg-popover text-popover-foreground shadow-md outline-none animate-in",
              onMouseLeave: () => {
                j(!1);
              },
              onMouseEnter: () => {
                j(!0);
              },
              onMouseUp: () => {
                var ee;
                (ee = E.current) == null || ee.focus();
              },
              children: F ? /* @__PURE__ */ A(Ge, { children: s }) : /* @__PURE__ */ ie(Ge, { children: [
                ye(),
                re(),
                !v && /* @__PURE__ */ A(da, { value: "-", className: "hidden" }),
                Object.entries(xe).map(([ee, ce]) => /* @__PURE__ */ A(jy, { heading: ee, className: "h-full overflow-auto", children: /* @__PURE__ */ A(Ge, { children: ce.map((he) => /* @__PURE__ */ A(
                  da,
                  {
                    value: he.value,
                    disabled: he.disable,
                    onMouseDown: (Ee) => {
                      Ee.preventDefault(), Ee.stopPropagation();
                    },
                    onSelect: () => {
                      if (H.length >= c) {
                        l == null || l(H.length);
                        return;
                      }
                      U("");
                      const Ee = [...H, he];
                      de(Ee), t == null || t(Ee);
                    },
                    className: q(
                      "cursor-pointer",
                      he.disable && "cursor-default text-muted-foreground"
                    ),
                    children: he.label
                  },
                  he.value
                )) }) }, ee))
              ] })
            }
          ) })
        ]
      }
    );
  }
);
NX.displayName = "Multiselect";
function wi(e) {
  const t = e + "CollectionProvider", [r, n] = At(t), [o, a] = r(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), d = (f) => {
    const { scope: $, children: v } = f, y = Ae.useRef(null), S = Ae.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ A(o, { scope: $, itemMap: S, collectionRef: y, children: v });
  };
  d.displayName = t;
  const i = e + "CollectionSlot", s = /* @__PURE__ */ $n(i), u = Ae.forwardRef(
    (f, $) => {
      const { scope: v, children: y } = f, S = a(i, v), w = Oe($, S.collectionRef);
      return /* @__PURE__ */ A(s, { ref: w, children: y });
    }
  );
  u.displayName = i;
  const c = e + "CollectionItemSlot", l = "data-radix-collection-item", p = /* @__PURE__ */ $n(c), h = Ae.forwardRef(
    (f, $) => {
      const { scope: v, children: y, ...S } = f, w = Ae.useRef(null), _ = Oe($, w), I = a(c, v);
      return Ae.useEffect(() => (I.itemMap.set(w, { ref: w, ...S }), () => void I.itemMap.delete(w))), /* @__PURE__ */ A(p, { [l]: "", ref: _, children: y });
    }
  );
  h.displayName = c;
  function m(f) {
    const $ = a(e + "CollectionConsumer", f);
    return Ae.useCallback(() => {
      const v = $.collectionRef.current;
      if (!v) return [];
      const y = Array.from(v.querySelectorAll(`[${l}]`));
      return Array.from($.itemMap.values()).sort(
        (S, w) => y.indexOf(S.ref.current) - y.indexOf(w.ref.current)
      );
    }, [$.collectionRef, $.itemMap]);
  }
  return [
    { Provider: d, Slot: u, ItemSlot: h },
    m,
    n
  ];
}
var n_ = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), IX = "VisuallyHidden", O2 = x.forwardRef(
  (e, t) => /* @__PURE__ */ A(
    ge.span,
    {
      ...e,
      ref: t,
      style: { ...n_, ...e.style }
    }
  )
);
O2.displayName = IX;
var N2 = "ToastProvider", [I2, PX, RX] = wi("Toast"), [o_, Hne] = At("Toast", [RX]), [TX, Ai] = o_(N2), a_ = (e) => {
  const {
    __scopeToast: t,
    label: r = "Notification",
    duration: n = 5e3,
    swipeDirection: o = "right",
    swipeThreshold: a = 50,
    children: d
  } = e, [i, s] = x.useState(null), [u, c] = x.useState(0), l = x.useRef(!1), p = x.useRef(!1);
  return r.trim() || console.error(
    `Invalid prop \`label\` supplied to \`${N2}\`. Expected non-empty \`string\`.`
  ), /* @__PURE__ */ A(I2.Provider, { scope: t, children: /* @__PURE__ */ A(
    TX,
    {
      scope: t,
      label: r,
      duration: n,
      swipeDirection: o,
      swipeThreshold: a,
      toastCount: u,
      viewport: i,
      onViewportChange: s,
      onToastAdd: x.useCallback(() => c((h) => h + 1), []),
      onToastRemove: x.useCallback(() => c((h) => h - 1), []),
      isFocusedToastEscapeKeyDownRef: l,
      isClosePausedRef: p,
      children: d
    }
  ) });
};
a_.displayName = N2;
var d_ = "ToastViewport", DX = ["F8"], l1 = "toast.viewportPause", c1 = "toast.viewportResume", i_ = x.forwardRef(
  (e, t) => {
    const {
      __scopeToast: r,
      hotkey: n = DX,
      label: o = "Notifications ({hotkey})",
      ...a
    } = e, d = Ai(d_, r), i = PX(r), s = x.useRef(null), u = x.useRef(null), c = x.useRef(null), l = x.useRef(null), p = Oe(t, l, d.onViewportChange), h = n.join("+").replace(/Key/g, "").replace(/Digit/g, ""), m = d.toastCount > 0;
    x.useEffect(() => {
      const $ = (v) => {
        var y;
        n.length !== 0 && n.every((S) => v[S] || v.code === S) && ((y = l.current) == null || y.focus());
      };
      return document.addEventListener("keydown", $), () => document.removeEventListener("keydown", $);
    }, [n]), x.useEffect(() => {
      const $ = s.current, v = l.current;
      if (m && $ && v) {
        const y = () => {
          if (!d.isClosePausedRef.current) {
            const I = new CustomEvent(l1);
            v.dispatchEvent(I), d.isClosePausedRef.current = !0;
          }
        }, S = () => {
          if (d.isClosePausedRef.current) {
            const I = new CustomEvent(c1);
            v.dispatchEvent(I), d.isClosePausedRef.current = !1;
          }
        }, w = (I) => {
          !$.contains(I.relatedTarget) && S();
        }, _ = () => {
          $.contains(document.activeElement) || S();
        };
        return $.addEventListener("focusin", y), $.addEventListener("focusout", w), $.addEventListener("pointermove", y), $.addEventListener("pointerleave", _), window.addEventListener("blur", y), window.addEventListener("focus", S), () => {
          $.removeEventListener("focusin", y), $.removeEventListener("focusout", w), $.removeEventListener("pointermove", y), $.removeEventListener("pointerleave", _), window.removeEventListener("blur", y), window.removeEventListener("focus", S);
        };
      }
    }, [m, d.isClosePausedRef]);
    const f = x.useCallback(
      ({ tabbingDirection: $ }) => {
        const v = i().map((y) => {
          const S = y.ref.current, w = [S, ...zX(S)];
          return $ === "forwards" ? w : w.reverse();
        });
        return ($ === "forwards" ? v.reverse() : v).flat();
      },
      [i]
    );
    return x.useEffect(() => {
      const $ = l.current;
      if ($) {
        const v = (y) => {
          var S, w, _;
          const I = y.altKey || y.ctrlKey || y.metaKey;
          if (y.key === "Tab" && !I) {
            const N = document.activeElement, O = y.shiftKey;
            if (y.target === $ && O) {
              (S = u.current) == null || S.focus();
              return;
            }
            const E = f({ tabbingDirection: O ? "backwards" : "forwards" }), C = E.findIndex((P) => P === N);
            Sc(E.slice(C + 1)) ? y.preventDefault() : O ? (w = u.current) == null || w.focus() : (_ = c.current) == null || _.focus();
          }
        };
        return $.addEventListener("keydown", v), () => $.removeEventListener("keydown", v);
      }
    }, [i, f]), /* @__PURE__ */ ie(
      JB,
      {
        ref: s,
        role: "region",
        "aria-label": o.replace("{hotkey}", h),
        tabIndex: -1,
        style: { pointerEvents: m ? void 0 : "none" },
        children: [
          m && /* @__PURE__ */ A(
            f1,
            {
              ref: u,
              onFocusFromOutsideViewport: () => {
                const $ = f({
                  tabbingDirection: "forwards"
                });
                Sc($);
              }
            }
          ),
          /* @__PURE__ */ A(I2.Slot, { scope: r, children: /* @__PURE__ */ A(ge.ol, { tabIndex: -1, ...a, ref: p }) }),
          m && /* @__PURE__ */ A(
            f1,
            {
              ref: c,
              onFocusFromOutsideViewport: () => {
                const $ = f({
                  tabbingDirection: "backwards"
                });
                Sc($);
              }
            }
          )
        ]
      }
    );
  }
);
i_.displayName = d_;
var s_ = "ToastFocusProxy", f1 = x.forwardRef(
  (e, t) => {
    const { __scopeToast: r, onFocusFromOutsideViewport: n, ...o } = e, a = Ai(s_, r);
    return /* @__PURE__ */ A(
      O2,
      {
        "aria-hidden": !0,
        tabIndex: 0,
        ...o,
        ref: t,
        style: { position: "fixed" },
        onFocus: (d) => {
          var i;
          const s = d.relatedTarget;
          !((i = a.viewport) != null && i.contains(s)) && n();
        }
      }
    );
  }
);
f1.displayName = s_;
var ja = "Toast", LX = "toast.swipeStart", FX = "toast.swipeMove", kX = "toast.swipeCancel", jX = "toast.swipeEnd", u_ = x.forwardRef(
  (e, t) => {
    const { forceMount: r, open: n, defaultOpen: o, onOpenChange: a, ...d } = e, [i, s] = Do({
      prop: n,
      defaultProp: o ?? !0,
      onChange: a,
      caller: ja
    });
    return /* @__PURE__ */ A(St, { present: r || i, children: /* @__PURE__ */ A(
      UX,
      {
        open: i,
        ...d,
        ref: t,
        onClose: () => s(!1),
        onPause: it(e.onPause),
        onResume: it(e.onResume),
        onSwipeStart: ne(e.onSwipeStart, (u) => {
          u.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: ne(e.onSwipeMove, (u) => {
          const { x: c, y: l } = u.detail.delta;
          u.currentTarget.setAttribute("data-swipe", "move"), u.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${c}px`), u.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${l}px`);
        }),
        onSwipeCancel: ne(e.onSwipeCancel, (u) => {
          u.currentTarget.setAttribute("data-swipe", "cancel"), u.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), u.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), u.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), u.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: ne(e.onSwipeEnd, (u) => {
          const { x: c, y: l } = u.detail.delta;
          u.currentTarget.setAttribute("data-swipe", "end"), u.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), u.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), u.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${c}px`), u.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${l}px`), s(!1);
        })
      }
    ) });
  }
);
u_.displayName = ja;
var [BX, ZX] = o_(ja, {
  onClose() {
  }
}), UX = x.forwardRef(
  (e, t) => {
    const {
      __scopeToast: r,
      type: n = "foreground",
      duration: o,
      open: a,
      onClose: d,
      onEscapeKeyDown: i,
      onPause: s,
      onResume: u,
      onSwipeStart: c,
      onSwipeMove: l,
      onSwipeCancel: p,
      onSwipeEnd: h,
      ...m
    } = e, f = Ai(ja, r), [$, v] = x.useState(null), y = Oe(t, (F) => v(F)), S = x.useRef(null), w = x.useRef(null), _ = o || f.duration, I = x.useRef(0), N = x.useRef(_), O = x.useRef(0), { onToastAdd: E, onToastRemove: C } = f, P = it(() => {
      var F;
      $ != null && $.contains(document.activeElement) && ((F = f.viewport) == null || F.focus()), d();
    }), T = x.useCallback(
      (F) => {
        !F || F === 1 / 0 || (window.clearTimeout(O.current), I.current = (/* @__PURE__ */ new Date()).getTime(), O.current = window.setTimeout(P, F));
      },
      [P]
    );
    x.useEffect(() => {
      const F = f.viewport;
      if (F) {
        const Z = () => {
          T(N.current), u == null || u();
        }, te = () => {
          const H = (/* @__PURE__ */ new Date()).getTime() - I.current;
          N.current = N.current - H, window.clearTimeout(O.current), s == null || s();
        };
        return F.addEventListener(l1, te), F.addEventListener(c1, Z), () => {
          F.removeEventListener(l1, te), F.removeEventListener(c1, Z);
        };
      }
    }, [f.viewport, _, s, u, T]), x.useEffect(() => {
      a && !f.isClosePausedRef.current && T(_);
    }, [a, _, f.isClosePausedRef, T]), x.useEffect(() => (E(), () => C()), [E, C]);
    const j = x.useMemo(() => $ ? m_($) : null, [$]);
    return f.viewport ? /* @__PURE__ */ ie(Ge, { children: [
      j && /* @__PURE__ */ A(
        GX,
        {
          __scopeToast: r,
          role: "status",
          "aria-live": n === "foreground" ? "assertive" : "polite",
          "aria-atomic": !0,
          children: j
        }
      ),
      /* @__PURE__ */ A(BX, { scope: r, onClose: P, children: Oo.createPortal(
        /* @__PURE__ */ A(I2.ItemSlot, { scope: r, children: /* @__PURE__ */ A(
          qB,
          {
            asChild: !0,
            onEscapeKeyDown: ne(i, () => {
              f.isFocusedToastEscapeKeyDownRef.current || P(), f.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ A(
              ge.li,
              {
                role: "status",
                "aria-live": "off",
                "aria-atomic": !0,
                tabIndex: 0,
                "data-state": a ? "open" : "closed",
                "data-swipe-direction": f.swipeDirection,
                ...m,
                ref: y,
                style: { userSelect: "none", touchAction: "none", ...e.style },
                onKeyDown: ne(e.onKeyDown, (F) => {
                  F.key === "Escape" && (i == null || i(F.nativeEvent), F.nativeEvent.defaultPrevented || (f.isFocusedToastEscapeKeyDownRef.current = !0, P()));
                }),
                onPointerDown: ne(e.onPointerDown, (F) => {
                  F.button === 0 && (S.current = { x: F.clientX, y: F.clientY });
                }),
                onPointerMove: ne(e.onPointerMove, (F) => {
                  if (!S.current) return;
                  const Z = F.clientX - S.current.x, te = F.clientY - S.current.y, H = !!w.current, de = ["left", "right"].includes(f.swipeDirection), G = ["left", "up"].includes(f.swipeDirection) ? Math.min : Math.max, le = de ? G(0, Z) : 0, fe = de ? 0 : G(0, te), U = F.pointerType === "touch" ? 10 : 2, ae = { x: le, y: fe }, ue = { originalEvent: F, delta: ae };
                  H ? (w.current = ae, hd(FX, l, ue, {
                    discrete: !1
                  })) : w7(ae, f.swipeDirection, U) ? (w.current = ae, hd(LX, c, ue, {
                    discrete: !1
                  }), F.target.setPointerCapture(F.pointerId)) : (Math.abs(Z) > U || Math.abs(te) > U) && (S.current = null);
                }),
                onPointerUp: ne(e.onPointerUp, (F) => {
                  const Z = w.current, te = F.target;
                  if (te.hasPointerCapture(F.pointerId) && te.releasePointerCapture(F.pointerId), w.current = null, S.current = null, Z) {
                    const H = F.currentTarget, de = { originalEvent: F, delta: Z };
                    w7(Z, f.swipeDirection, f.swipeThreshold) ? hd(jX, h, de, {
                      discrete: !0
                    }) : hd(
                      kX,
                      p,
                      de,
                      {
                        discrete: !0
                      }
                    ), H.addEventListener("click", (G) => G.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        f.viewport
      ) })
    ] }) : null;
  }
), GX = (e) => {
  const { __scopeToast: t, children: r, ...n } = e, o = Ai(ja, t), [a, d] = x.useState(!1), [i, s] = x.useState(!1);
  return KX(() => d(!0)), x.useEffect(() => {
    const u = window.setTimeout(() => s(!0), 1e3);
    return () => window.clearTimeout(u);
  }, []), i ? null : /* @__PURE__ */ A(Lo, { asChild: !0, children: /* @__PURE__ */ A(O2, { ...n, children: a && /* @__PURE__ */ ie(Ge, { children: [
    o.label,
    " ",
    r
  ] }) }) });
}, VX = "ToastTitle", l_ = x.forwardRef(
  (e, t) => {
    const { __scopeToast: r, ...n } = e;
    return /* @__PURE__ */ A(ge.div, { ...n, ref: t });
  }
);
l_.displayName = VX;
var HX = "ToastDescription", c_ = x.forwardRef(
  (e, t) => {
    const { __scopeToast: r, ...n } = e;
    return /* @__PURE__ */ A(ge.div, { ...n, ref: t });
  }
);
c_.displayName = HX;
var f_ = "ToastAction", p_ = x.forwardRef(
  (e, t) => {
    const { altText: r, ...n } = e;
    return r.trim() ? /* @__PURE__ */ A(v_, { altText: r, asChild: !0, children: /* @__PURE__ */ A(P2, { ...n, ref: t }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${f_}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
p_.displayName = f_;
var $_ = "ToastClose", P2 = x.forwardRef(
  (e, t) => {
    const { __scopeToast: r, ...n } = e, o = ZX($_, r);
    return /* @__PURE__ */ A(v_, { asChild: !0, children: /* @__PURE__ */ A(
      ge.button,
      {
        type: "button",
        ...n,
        ref: t,
        onClick: ne(e.onClick, o.onClose)
      }
    ) });
  }
);
P2.displayName = $_;
var v_ = x.forwardRef((e, t) => {
  const { __scopeToast: r, altText: n, ...o } = e;
  return /* @__PURE__ */ A(
    ge.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": n || void 0,
      ...o,
      ref: t
    }
  );
});
function m_(e) {
  const t = [];
  return Array.from(e.childNodes).forEach((r) => {
    if (r.nodeType === r.TEXT_NODE && r.textContent && t.push(r.textContent), WX(r)) {
      const n = r.ariaHidden || r.hidden || r.style.display === "none", o = r.dataset.radixToastAnnounceExclude === "";
      if (!n)
        if (o) {
          const a = r.dataset.radixToastAnnounceAlt;
          a && t.push(a);
        } else
          t.push(...m_(r));
    }
  }), t;
}
function hd(e, t, r, { discrete: n }) {
  const o = r.originalEvent.currentTarget, a = new CustomEvent(e, { bubbles: !0, cancelable: !0, detail: r });
  t && o.addEventListener(e, t, { once: !0 }), n ? r2(o, a) : o.dispatchEvent(a);
}
var w7 = (e, t, r = 0) => {
  const n = Math.abs(e.x), o = Math.abs(e.y), a = n > o;
  return t === "left" || t === "right" ? a && n > r : !a && o > r;
};
function KX(e = () => {
}) {
  const t = it(e);
  et(() => {
    let r = 0, n = 0;
    return r = window.requestAnimationFrame(() => n = window.requestAnimationFrame(t)), () => {
      window.cancelAnimationFrame(r), window.cancelAnimationFrame(n);
    };
  }, [t]);
}
function WX(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function zX(e) {
  const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const o = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || o ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); ) t.push(r.currentNode);
  return t;
}
function Sc(e) {
  const t = document.activeElement;
  return e.some((r) => r === t ? !0 : (r.focus(), document.activeElement !== t));
}
var YX = a_, h_ = i_, g_ = u_, y_ = l_, b_ = c_, x_ = p_, w_ = P2;
const XX = YX, A_ = X(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  h_,
  {
    ref: r,
    className: q(
      "fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]",
      e
    ),
    ...t
  }
));
A_.displayName = h_.displayName;
const qX = jt(
  "group pointer-events-auto relative flex w-full items-center justify-between space-x-2 overflow-hidden rounded-md border p-4 pr-6 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full",
  {
    variants: {
      variant: {
        default: "border bg-background text-foreground",
        destructive: "destructive group border-destructive bg-destructive text-destructive-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), S_ = X(({ className: e, variant: t, ...r }, n) => /* @__PURE__ */ A(g_, { ref: n, className: q(qX({ variant: t }), e), ...r }));
S_.displayName = g_.displayName;
const JX = X(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  x_,
  {
    ref: r,
    className: q(
      "inline-flex h-8 shrink-0 items-center justify-center rounded-md border bg-transparent px-3 text-sm font-medium transition-colors hover:bg-secondary focus:outline-none focus:ring-1 focus:ring-ring disabled:pointer-events-none disabled:opacity-50 group-[.destructive]:border-muted/40 group-[.destructive]:hover:border-destructive/30 group-[.destructive]:hover:bg-destructive group-[.destructive]:hover:text-destructive-foreground group-[.destructive]:focus:ring-destructive",
      e
    ),
    ...t
  }
));
JX.displayName = x_.displayName;
const __ = X(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  w_,
  {
    ref: r,
    className: q(
      "absolute right-1 top-1 rounded-md p-1 text-foreground/50 opacity-0 transition-opacity hover:text-foreground focus:opacity-100 focus:outline-none focus:ring-1 group-hover:opacity-100 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600",
      e
    ),
    "toast-close": "",
    ...t,
    children: /* @__PURE__ */ A(o2, { className: "size-4" })
  }
));
__.displayName = w_.displayName;
const E_ = X(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  y_,
  {
    ref: r,
    className: q("text-sm font-semibold [&+div]:text-xs", e),
    ...t
  }
));
E_.displayName = y_.displayName;
const M_ = X(({ className: e, ...t }, r) => /* @__PURE__ */ A(b_, { ref: r, className: q("text-sm opacity-90", e), ...t }));
M_.displayName = b_.displayName;
const QX = X(({ ...e }, t) => /* @__PURE__ */ A("nav", { ref: t, "aria-label": "breadcrumb", ...e }));
QX.displayName = "Breadcrumb";
const eq = X(
  ({ className: e, ...t }, r) => /* @__PURE__ */ A(
    "ol",
    {
      ref: r,
      className: q(
        "flex flex-wrap items-center gap-1.5 break-words text-sm text-muted-foreground sm:gap-2.5",
        e
      ),
      ...t
    }
  )
);
eq.displayName = "BreadcrumbList";
const tq = X(
  ({ className: e, ...t }, r) => /* @__PURE__ */ A("li", { ref: r, className: q("inline-flex items-center gap-1.5", e), ...t })
);
tq.displayName = "BreadcrumbItem";
const rq = X(({ asChild: e, className: t, ...r }, n) => /* @__PURE__ */ A(e ? To : "a", { ref: n, className: q("transition-colors hover:text-foreground", t), ...r }));
rq.displayName = "BreadcrumbLink";
const nq = X(
  ({ className: e, ...t }, r) => /* @__PURE__ */ A(
    "span",
    {
      ref: r,
      role: "link",
      "aria-disabled": "true",
      "aria-current": "page",
      className: q("font-normal text-foreground", e),
      ...t
    }
  )
);
nq.displayName = "BreadcrumbPage";
/**
 * @license lucide-react v0.508.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oq = [["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]];
Wr("chevron-left", oq);
/**
 * @license lucide-react v0.508.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aq = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]];
Wr("chevron-right", aq);
var ca = function() {
  return ca = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, ca.apply(this, arguments);
}, dq = dt(void 0);
function iq() {
  var e = Ar(dq);
  if (!e)
    throw new Error("useDayPicker must be used within a DayPickerProvider.");
  return e;
}
dt(void 0);
X(function(e, t) {
  var r = iq(), n = r.classNames, o = r.styles, a = [n.button_reset, n.button];
  e.className && a.push(e.className);
  var d = a.join(" "), i = ca(ca({}, o.button_reset), o.button);
  return e.style && Object.assign(i, e.style), A("button", ca({}, e, { ref: t, type: "button", className: d, style: i }));
});
dt(void 0);
dt(void 0);
var ir;
(function(e) {
  e.Outside = "outside", e.Disabled = "disabled", e.Selected = "selected", e.Hidden = "hidden", e.Today = "today", e.RangeStart = "range_start", e.RangeEnd = "range_end", e.RangeMiddle = "range_middle";
})(ir || (ir = {}));
ir.Selected;
ir.Disabled;
ir.Hidden;
ir.Today;
ir.RangeEnd;
ir.RangeMiddle;
ir.RangeStart;
ir.Outside;
dt(void 0);
dt(void 0);
dt(void 0);
const sq = X(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  "div",
  {
    ref: r,
    className: q("rounded-xl border bg-card text-card-foreground shadow", e),
    ...t
  }
));
sq.displayName = "Card";
const uq = X(
  ({ className: e, ...t }, r) => /* @__PURE__ */ A("div", { ref: r, className: q("flex flex-col space-y-1.5 p-6", e), ...t })
);
uq.displayName = "CardHeader";
const lq = X(
  ({ className: e, ...t }, r) => /* @__PURE__ */ A("h3", { ref: r, className: q("font-semibold leading-none tracking-tight", e), ...t })
);
lq.displayName = "CardTitle";
const cq = X(
  ({ className: e, ...t }, r) => /* @__PURE__ */ A("p", { ref: r, className: q("text-sm text-muted-foreground", e), ...t })
);
cq.displayName = "CardDescription";
const fq = X(
  ({ className: e, ...t }, r) => /* @__PURE__ */ A("div", { ref: r, className: q("p-6 pt-0", e), ...t })
);
fq.displayName = "CardContent";
const pq = X(
  ({ className: e, ...t }, r) => /* @__PURE__ */ A("div", { ref: r, className: q("flex items-center p-6 pt-0", e), ...t })
);
pq.displayName = "CardFooter";
function R2(e) {
  const t = x.useRef({ value: e, previous: e });
  return x.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function T2(e) {
  const [t, r] = x.useState(void 0);
  return et(() => {
    if (e) {
      r({ width: e.offsetWidth, height: e.offsetHeight });
      const n = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const a = o[0];
        let d, i;
        if ("borderBoxSize" in a) {
          const s = a.borderBoxSize, u = Array.isArray(s) ? s[0] : s;
          d = u.inlineSize, i = u.blockSize;
        } else
          d = e.offsetWidth, i = e.offsetHeight;
        r({ width: d, height: i });
      });
      return n.observe(e, { box: "border-box" }), () => n.unobserve(e);
    } else
      r(void 0);
  }, [e]), t;
}
// @__NO_SIDE_EFFECTS__
function C_(e) {
  const t = /* @__PURE__ */ $q(e), r = x.forwardRef((n, o) => {
    const { children: a, ...d } = n, i = x.Children.toArray(a), s = i.find(mq);
    if (s) {
      const u = s.props.children, c = i.map((l) => l === s ? x.Children.count(u) > 1 ? x.Children.only(null) : x.isValidElement(u) ? u.props.children : null : l);
      return /* @__PURE__ */ A(t, { ...d, ref: o, children: x.isValidElement(u) ? x.cloneElement(u, void 0, c) : null });
    }
    return /* @__PURE__ */ A(t, { ...d, ref: o, children: a });
  });
  return r.displayName = `${e}.Slot`, r;
}
// @__NO_SIDE_EFFECTS__
function $q(e) {
  const t = x.forwardRef((r, n) => {
    const { children: o, ...a } = r;
    if (x.isValidElement(o)) {
      const d = gq(o), i = hq(a, o.props);
      return o.type !== x.Fragment && (i.ref = n ? ui(n, d) : d), x.cloneElement(o, i);
    }
    return x.Children.count(o) > 1 ? x.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var vq = Symbol("radix.slottable");
function mq(e) {
  return x.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === vq;
}
function hq(e, t) {
  const r = { ...t };
  for (const n in t) {
    const o = e[n], a = t[n];
    /^on[A-Z]/.test(n) ? o && a ? r[n] = (...d) => {
      a(...d), o(...d);
    } : o && (r[n] = o) : n === "style" ? r[n] = { ...o, ...a } : n === "className" && (r[n] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function gq(e) {
  var t, r;
  let n = (t = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : t.get, o = n && "isReactWarning" in n && n.isReactWarning;
  return o ? e.ref : (n = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, o = n && "isReactWarning" in n && n.isReactWarning, o ? e.props.ref : e.props.ref || e.ref);
}
/**
 * @license lucide-react v0.508.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yq = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], O_ = Wr("check", yq);
var bq = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], D2 = bq.reduce((e, t) => {
  const r = /* @__PURE__ */ C_(`Primitive.${t}`), n = x.forwardRef((o, a) => {
    const { asChild: d, ...i } = o, s = d ? r : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ A(s, { ...i, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), Si = "Checkbox", [xq, Kne] = At(Si), [wq, Aq] = xq(Si), N_ = x.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: r,
      name: n,
      checked: o,
      defaultChecked: a,
      required: d,
      disabled: i,
      value: s = "on",
      onCheckedChange: u,
      form: c,
      ...l
    } = e, [p, h] = x.useState(null), m = Oe(t, (w) => h(w)), f = x.useRef(!1), $ = p ? c || !!p.closest("form") : !0, [v, y] = Do({
      prop: o,
      defaultProp: a ?? !1,
      onChange: u,
      caller: Si
    }), S = x.useRef(v);
    return x.useEffect(() => {
      const w = p == null ? void 0 : p.form;
      if (w) {
        const _ = () => y(S.current);
        return w.addEventListener("reset", _), () => w.removeEventListener("reset", _);
      }
    }, [p, y]), /* @__PURE__ */ ie(wq, { scope: r, state: v, disabled: i, children: [
      /* @__PURE__ */ A(
        D2.button,
        {
          type: "button",
          role: "checkbox",
          "aria-checked": Br(v) ? "mixed" : v,
          "aria-required": d,
          "data-state": T_(v),
          "data-disabled": i ? "" : void 0,
          disabled: i,
          value: s,
          ...l,
          ref: m,
          onKeyDown: ne(e.onKeyDown, (w) => {
            w.key === "Enter" && w.preventDefault();
          }),
          onClick: ne(e.onClick, (w) => {
            y((_) => Br(_) ? !0 : !_), $ && (f.current = w.isPropagationStopped(), f.current || w.stopPropagation());
          })
        }
      ),
      $ && /* @__PURE__ */ A(
        R_,
        {
          control: p,
          bubbles: !f.current,
          name: n,
          value: s,
          checked: v,
          required: d,
          disabled: i,
          form: c,
          style: { transform: "translateX(-100%)" },
          defaultChecked: Br(a) ? !1 : a
        }
      )
    ] });
  }
);
N_.displayName = Si;
var I_ = "CheckboxIndicator", P_ = x.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: r, forceMount: n, ...o } = e, a = Aq(I_, r);
    return /* @__PURE__ */ A(St, { present: n || Br(a.state) || a.state === !0, children: /* @__PURE__ */ A(
      D2.span,
      {
        "data-state": T_(a.state),
        "data-disabled": a.disabled ? "" : void 0,
        ...o,
        ref: t,
        style: { pointerEvents: "none", ...e.style }
      }
    ) });
  }
);
P_.displayName = I_;
var Sq = "CheckboxBubbleInput", R_ = x.forwardRef(
  ({
    __scopeCheckbox: e,
    control: t,
    checked: r,
    bubbles: n = !0,
    defaultChecked: o,
    ...a
  }, d) => {
    const i = x.useRef(null), s = Oe(i, d), u = R2(r), c = T2(t);
    x.useEffect(() => {
      const p = i.current;
      if (!p) return;
      const h = window.HTMLInputElement.prototype, m = Object.getOwnPropertyDescriptor(
        h,
        "checked"
      ).set;
      if (u !== r && m) {
        const f = new Event("click", { bubbles: n });
        p.indeterminate = Br(r), m.call(p, Br(r) ? !1 : r), p.dispatchEvent(f);
      }
    }, [u, r, n]);
    const l = x.useRef(Br(r) ? !1 : r);
    return /* @__PURE__ */ A(
      D2.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: o ?? l.current,
        ...a,
        tabIndex: -1,
        ref: s,
        style: {
          ...a.style,
          ...c,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
R_.displayName = Sq;
function Br(e) {
  return e === "indeterminate";
}
function T_(e) {
  return Br(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
var D_ = N_, _q = P_;
const Eq = x.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  D_,
  {
    ref: r,
    className: q(
      "peer h-4 w-4 shrink-0 rounded-sm border border-primary shadow focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
      e
    ),
    ...t,
    children: /* @__PURE__ */ A(_q, { className: q("flex items-center justify-center text-current"), children: /* @__PURE__ */ A(O_, { className: "size-4" }) })
  }
));
Eq.displayName = D_.displayName;
const Mq = {
  theme: "system",
  computedTheme: "light",
  setTheme: () => null
};
dt(Mq);
const Cq = ["top", "right", "bottom", "left"], Vr = Math.min, Ot = Math.max, Ud = Math.round, gd = Math.floor, or = (e) => ({
  x: e,
  y: e
}), Oq = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Nq = {
  start: "end",
  end: "start"
};
function p1(e, t, r) {
  return Ot(e, Vr(t, r));
}
function Cr(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Or(e) {
  return e.split("-")[0];
}
function ko(e) {
  return e.split("-")[1];
}
function L2(e) {
  return e === "x" ? "y" : "x";
}
function F2(e) {
  return e === "y" ? "height" : "width";
}
function hr(e) {
  return ["top", "bottom"].includes(Or(e)) ? "y" : "x";
}
function k2(e) {
  return L2(hr(e));
}
function Iq(e, t, r) {
  r === void 0 && (r = !1);
  const n = ko(e), o = k2(e), a = F2(o);
  let d = o === "x" ? n === (r ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (d = Gd(d)), [d, Gd(d)];
}
function Pq(e) {
  const t = Gd(e);
  return [$1(e), t, $1(t)];
}
function $1(e) {
  return e.replace(/start|end/g, (t) => Nq[t]);
}
function Rq(e, t, r) {
  const n = ["left", "right"], o = ["right", "left"], a = ["top", "bottom"], d = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? o : n : t ? n : o;
    case "left":
    case "right":
      return t ? a : d;
    default:
      return [];
  }
}
function Tq(e, t, r, n) {
  const o = ko(e);
  let a = Rq(Or(e), r === "start", n);
  return o && (a = a.map((d) => d + "-" + o), t && (a = a.concat(a.map($1)))), a;
}
function Gd(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Oq[t]);
}
function Dq(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function L_(e) {
  return typeof e != "number" ? Dq(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Vd(e) {
  const {
    x: t,
    y: r,
    width: n,
    height: o
  } = e;
  return {
    width: n,
    height: o,
    top: r,
    left: t,
    right: t + n,
    bottom: r + o,
    x: t,
    y: r
  };
}
function A7(e, t, r) {
  let {
    reference: n,
    floating: o
  } = e;
  const a = hr(t), d = k2(t), i = F2(d), s = Or(t), u = a === "y", c = n.x + n.width / 2 - o.width / 2, l = n.y + n.height / 2 - o.height / 2, p = n[i] / 2 - o[i] / 2;
  let h;
  switch (s) {
    case "top":
      h = {
        x: c,
        y: n.y - o.height
      };
      break;
    case "bottom":
      h = {
        x: c,
        y: n.y + n.height
      };
      break;
    case "right":
      h = {
        x: n.x + n.width,
        y: l
      };
      break;
    case "left":
      h = {
        x: n.x - o.width,
        y: l
      };
      break;
    default:
      h = {
        x: n.x,
        y: n.y
      };
  }
  switch (ko(t)) {
    case "start":
      h[d] -= p * (r && u ? -1 : 1);
      break;
    case "end":
      h[d] += p * (r && u ? -1 : 1);
      break;
  }
  return h;
}
const Lq = async (e, t, r) => {
  const {
    placement: n = "bottom",
    strategy: o = "absolute",
    middleware: a = [],
    platform: d
  } = r, i = a.filter(Boolean), s = await (d.isRTL == null ? void 0 : d.isRTL(t));
  let u = await d.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: c,
    y: l
  } = A7(u, n, s), p = n, h = {}, m = 0;
  for (let f = 0; f < i.length; f++) {
    const {
      name: $,
      fn: v
    } = i[f], {
      x: y,
      y: S,
      data: w,
      reset: _
    } = await v({
      x: c,
      y: l,
      initialPlacement: n,
      placement: p,
      strategy: o,
      middlewareData: h,
      rects: u,
      platform: d,
      elements: {
        reference: e,
        floating: t
      }
    });
    c = y ?? c, l = S ?? l, h = {
      ...h,
      [$]: {
        ...h[$],
        ...w
      }
    }, _ && m <= 50 && (m++, typeof _ == "object" && (_.placement && (p = _.placement), _.rects && (u = _.rects === !0 ? await d.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : _.rects), {
      x: c,
      y: l
    } = A7(u, p, s)), f = -1);
  }
  return {
    x: c,
    y: l,
    placement: p,
    strategy: o,
    middlewareData: h
  };
};
async function ga(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    x: n,
    y: o,
    platform: a,
    rects: d,
    elements: i,
    strategy: s
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: c = "viewport",
    elementContext: l = "floating",
    altBoundary: p = !1,
    padding: h = 0
  } = Cr(t, e), m = L_(h), f = i[p ? l === "floating" ? "reference" : "floating" : l], $ = Vd(await a.getClippingRect({
    element: (r = await (a.isElement == null ? void 0 : a.isElement(f))) == null || r ? f : f.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(i.floating)),
    boundary: u,
    rootBoundary: c,
    strategy: s
  })), v = l === "floating" ? {
    x: n,
    y: o,
    width: d.floating.width,
    height: d.floating.height
  } : d.reference, y = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(i.floating)), S = await (a.isElement == null ? void 0 : a.isElement(y)) ? await (a.getScale == null ? void 0 : a.getScale(y)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, w = Vd(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: i,
    rect: v,
    offsetParent: y,
    strategy: s
  }) : v);
  return {
    top: ($.top - w.top + m.top) / S.y,
    bottom: (w.bottom - $.bottom + m.bottom) / S.y,
    left: ($.left - w.left + m.left) / S.x,
    right: (w.right - $.right + m.right) / S.x
  };
}
const Fq = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: r,
      y: n,
      placement: o,
      rects: a,
      platform: d,
      elements: i,
      middlewareData: s
    } = t, {
      element: u,
      padding: c = 0
    } = Cr(e, t) || {};
    if (u == null)
      return {};
    const l = L_(c), p = {
      x: r,
      y: n
    }, h = k2(o), m = F2(h), f = await d.getDimensions(u), $ = h === "y", v = $ ? "top" : "left", y = $ ? "bottom" : "right", S = $ ? "clientHeight" : "clientWidth", w = a.reference[m] + a.reference[h] - p[h] - a.floating[m], _ = p[h] - a.reference[h], I = await (d.getOffsetParent == null ? void 0 : d.getOffsetParent(u));
    let N = I ? I[S] : 0;
    (!N || !await (d.isElement == null ? void 0 : d.isElement(I))) && (N = i.floating[S] || a.floating[m]);
    const O = w / 2 - _ / 2, E = N / 2 - f[m] / 2 - 1, C = Vr(l[v], E), P = Vr(l[y], E), T = C, j = N - f[m] - P, F = N / 2 - f[m] / 2 + O, Z = p1(T, F, j), te = !s.arrow && ko(o) != null && F !== Z && a.reference[m] / 2 - (F < T ? C : P) - f[m] / 2 < 0, H = te ? F < T ? F - T : F - j : 0;
    return {
      [h]: p[h] + H,
      data: {
        [h]: Z,
        centerOffset: F - Z - H,
        ...te && {
          alignmentOffset: H
        }
      },
      reset: te
    };
  }
}), kq = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: o,
        middlewareData: a,
        rects: d,
        initialPlacement: i,
        platform: s,
        elements: u
      } = t, {
        mainAxis: c = !0,
        crossAxis: l = !0,
        fallbackPlacements: p,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: f = !0,
        ...$
      } = Cr(e, t);
      if ((r = a.arrow) != null && r.alignmentOffset)
        return {};
      const v = Or(o), y = hr(i), S = Or(i) === i, w = await (s.isRTL == null ? void 0 : s.isRTL(u.floating)), _ = p || (S || !f ? [Gd(i)] : Pq(i)), I = m !== "none";
      !p && I && _.push(...Tq(i, f, m, w));
      const N = [i, ..._], O = await ga(t, $), E = [];
      let C = ((n = a.flip) == null ? void 0 : n.overflows) || [];
      if (c && E.push(O[v]), l) {
        const Z = Iq(o, d, w);
        E.push(O[Z[0]], O[Z[1]]);
      }
      if (C = [...C, {
        placement: o,
        overflows: E
      }], !E.every((Z) => Z <= 0)) {
        var P, T;
        const Z = (((P = a.flip) == null ? void 0 : P.index) || 0) + 1, te = N[Z];
        if (te) {
          var j;
          const de = l === "alignment" ? y !== hr(te) : !1, G = ((j = C[0]) == null ? void 0 : j.overflows[0]) > 0;
          if (!de || G)
            return {
              data: {
                index: Z,
                overflows: C
              },
              reset: {
                placement: te
              }
            };
        }
        let H = (T = C.filter((de) => de.overflows[0] <= 0).sort((de, G) => de.overflows[1] - G.overflows[1])[0]) == null ? void 0 : T.placement;
        if (!H)
          switch (h) {
            case "bestFit": {
              var F;
              const de = (F = C.filter((G) => {
                if (I) {
                  const le = hr(G.placement);
                  return le === y || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  le === "y";
                }
                return !0;
              }).map((G) => [G.placement, G.overflows.filter((le) => le > 0).reduce((le, fe) => le + fe, 0)]).sort((G, le) => G[1] - le[1])[0]) == null ? void 0 : F[0];
              de && (H = de);
              break;
            }
            case "initialPlacement":
              H = i;
              break;
          }
        if (o !== H)
          return {
            reset: {
              placement: H
            }
          };
      }
      return {};
    }
  };
};
function S7(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function _7(e) {
  return Cq.some((t) => e[t] >= 0);
}
const jq = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: r
      } = t, {
        strategy: n = "referenceHidden",
        ...o
      } = Cr(e, t);
      switch (n) {
        case "referenceHidden": {
          const a = await ga(t, {
            ...o,
            elementContext: "reference"
          }), d = S7(a, r.reference);
          return {
            data: {
              referenceHiddenOffsets: d,
              referenceHidden: _7(d)
            }
          };
        }
        case "escaped": {
          const a = await ga(t, {
            ...o,
            altBoundary: !0
          }), d = S7(a, r.floating);
          return {
            data: {
              escapedOffsets: d,
              escaped: _7(d)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function Bq(e, t) {
  const {
    placement: r,
    platform: n,
    elements: o
  } = e, a = await (n.isRTL == null ? void 0 : n.isRTL(o.floating)), d = Or(r), i = ko(r), s = hr(r) === "y", u = ["left", "top"].includes(d) ? -1 : 1, c = a && s ? -1 : 1, l = Cr(t, e);
  let {
    mainAxis: p,
    crossAxis: h,
    alignmentAxis: m
  } = typeof l == "number" ? {
    mainAxis: l,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: l.mainAxis || 0,
    crossAxis: l.crossAxis || 0,
    alignmentAxis: l.alignmentAxis
  };
  return i && typeof m == "number" && (h = i === "end" ? m * -1 : m), s ? {
    x: h * c,
    y: p * u
  } : {
    x: p * u,
    y: h * c
  };
}
const Zq = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var r, n;
      const {
        x: o,
        y: a,
        placement: d,
        middlewareData: i
      } = t, s = await Bq(t, e);
      return d === ((r = i.offset) == null ? void 0 : r.placement) && (n = i.arrow) != null && n.alignmentOffset ? {} : {
        x: o + s.x,
        y: a + s.y,
        data: {
          ...s,
          placement: d
        }
      };
    }
  };
}, Uq = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: n,
        placement: o
      } = t, {
        mainAxis: a = !0,
        crossAxis: d = !1,
        limiter: i = {
          fn: ($) => {
            let {
              x: v,
              y
            } = $;
            return {
              x: v,
              y
            };
          }
        },
        ...s
      } = Cr(e, t), u = {
        x: r,
        y: n
      }, c = await ga(t, s), l = hr(Or(o)), p = L2(l);
      let h = u[p], m = u[l];
      if (a) {
        const $ = p === "y" ? "top" : "left", v = p === "y" ? "bottom" : "right", y = h + c[$], S = h - c[v];
        h = p1(y, h, S);
      }
      if (d) {
        const $ = l === "y" ? "top" : "left", v = l === "y" ? "bottom" : "right", y = m + c[$], S = m - c[v];
        m = p1(y, m, S);
      }
      const f = i.fn({
        ...t,
        [p]: h,
        [l]: m
      });
      return {
        ...f,
        data: {
          x: f.x - r,
          y: f.y - n,
          enabled: {
            [p]: a,
            [l]: d
          }
        }
      };
    }
  };
}, Gq = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: r,
        y: n,
        placement: o,
        rects: a,
        middlewareData: d
      } = t, {
        offset: i = 0,
        mainAxis: s = !0,
        crossAxis: u = !0
      } = Cr(e, t), c = {
        x: r,
        y: n
      }, l = hr(o), p = L2(l);
      let h = c[p], m = c[l];
      const f = Cr(i, t), $ = typeof f == "number" ? {
        mainAxis: f,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...f
      };
      if (s) {
        const S = p === "y" ? "height" : "width", w = a.reference[p] - a.floating[S] + $.mainAxis, _ = a.reference[p] + a.reference[S] - $.mainAxis;
        h < w ? h = w : h > _ && (h = _);
      }
      if (u) {
        var v, y;
        const S = p === "y" ? "width" : "height", w = ["top", "left"].includes(Or(o)), _ = a.reference[l] - a.floating[S] + (w && ((v = d.offset) == null ? void 0 : v[l]) || 0) + (w ? 0 : $.crossAxis), I = a.reference[l] + a.reference[S] + (w ? 0 : ((y = d.offset) == null ? void 0 : y[l]) || 0) - (w ? $.crossAxis : 0);
        m < _ ? m = _ : m > I && (m = I);
      }
      return {
        [p]: h,
        [l]: m
      };
    }
  };
}, Vq = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: o,
        rects: a,
        platform: d,
        elements: i
      } = t, {
        apply: s = () => {
        },
        ...u
      } = Cr(e, t), c = await ga(t, u), l = Or(o), p = ko(o), h = hr(o) === "y", {
        width: m,
        height: f
      } = a.floating;
      let $, v;
      l === "top" || l === "bottom" ? ($ = l, v = p === (await (d.isRTL == null ? void 0 : d.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (v = l, $ = p === "end" ? "top" : "bottom");
      const y = f - c.top - c.bottom, S = m - c.left - c.right, w = Vr(f - c[$], y), _ = Vr(m - c[v], S), I = !t.middlewareData.shift;
      let N = w, O = _;
      if ((r = t.middlewareData.shift) != null && r.enabled.x && (O = S), (n = t.middlewareData.shift) != null && n.enabled.y && (N = y), I && !p) {
        const C = Ot(c.left, 0), P = Ot(c.right, 0), T = Ot(c.top, 0), j = Ot(c.bottom, 0);
        h ? O = m - 2 * (C !== 0 || P !== 0 ? C + P : Ot(c.left, c.right)) : N = f - 2 * (T !== 0 || j !== 0 ? T + j : Ot(c.top, c.bottom));
      }
      await s({
        ...t,
        availableWidth: O,
        availableHeight: N
      });
      const E = await d.getDimensions(i.floating);
      return m !== E.width || f !== E.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function _i() {
  return typeof window < "u";
}
function jo(e) {
  return F_(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Pt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function ur(e) {
  var t;
  return (t = (F_(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function F_(e) {
  return _i() ? e instanceof Node || e instanceof Pt(e).Node : !1;
}
function Yt(e) {
  return _i() ? e instanceof Element || e instanceof Pt(e).Element : !1;
}
function sr(e) {
  return _i() ? e instanceof HTMLElement || e instanceof Pt(e).HTMLElement : !1;
}
function E7(e) {
  return !_i() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Pt(e).ShadowRoot;
}
function Ba(e) {
  const {
    overflow: t,
    overflowX: r,
    overflowY: n,
    display: o
  } = Xt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + r) && !["inline", "contents"].includes(o);
}
function Hq(e) {
  return ["table", "td", "th"].includes(jo(e));
}
function Ei(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function j2(e) {
  const t = B2(), r = Yt(e) ? Xt(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((n) => r[n] ? r[n] !== "none" : !1) || (r.containerType ? r.containerType !== "normal" : !1) || !t && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !t && (r.filter ? r.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((n) => (r.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (r.contain || "").includes(n));
}
function Kq(e) {
  let t = Hr(e);
  for (; sr(t) && !_o(t); ) {
    if (j2(t))
      return t;
    if (Ei(t))
      return null;
    t = Hr(t);
  }
  return null;
}
function B2() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function _o(e) {
  return ["html", "body", "#document"].includes(jo(e));
}
function Xt(e) {
  return Pt(e).getComputedStyle(e);
}
function Mi(e) {
  return Yt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Hr(e) {
  if (jo(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    E7(e) && e.host || // Fallback.
    ur(e)
  );
  return E7(t) ? t.host : t;
}
function k_(e) {
  const t = Hr(e);
  return _o(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : sr(t) && Ba(t) ? t : k_(t);
}
function ya(e, t, r) {
  var n;
  t === void 0 && (t = []), r === void 0 && (r = !0);
  const o = k_(e), a = o === ((n = e.ownerDocument) == null ? void 0 : n.body), d = Pt(o);
  if (a) {
    const i = v1(d);
    return t.concat(d, d.visualViewport || [], Ba(o) ? o : [], i && r ? ya(i) : []);
  }
  return t.concat(o, ya(o, [], r));
}
function v1(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function j_(e) {
  const t = Xt(e);
  let r = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const o = sr(e), a = o ? e.offsetWidth : r, d = o ? e.offsetHeight : n, i = Ud(r) !== a || Ud(n) !== d;
  return i && (r = a, n = d), {
    width: r,
    height: n,
    $: i
  };
}
function Z2(e) {
  return Yt(e) ? e : e.contextElement;
}
function So(e) {
  const t = Z2(e);
  if (!sr(t))
    return or(1);
  const r = t.getBoundingClientRect(), {
    width: n,
    height: o,
    $: a
  } = j_(t);
  let d = (a ? Ud(r.width) : r.width) / n, i = (a ? Ud(r.height) : r.height) / o;
  return (!d || !Number.isFinite(d)) && (d = 1), (!i || !Number.isFinite(i)) && (i = 1), {
    x: d,
    y: i
  };
}
const Wq = /* @__PURE__ */ or(0);
function B_(e) {
  const t = Pt(e);
  return !B2() || !t.visualViewport ? Wq : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function zq(e, t, r) {
  return t === void 0 && (t = !1), !r || t && r !== Pt(e) ? !1 : t;
}
function gn(e, t, r, n) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const o = e.getBoundingClientRect(), a = Z2(e);
  let d = or(1);
  t && (n ? Yt(n) && (d = So(n)) : d = So(e));
  const i = zq(a, r, n) ? B_(a) : or(0);
  let s = (o.left + i.x) / d.x, u = (o.top + i.y) / d.y, c = o.width / d.x, l = o.height / d.y;
  if (a) {
    const p = Pt(a), h = n && Yt(n) ? Pt(n) : n;
    let m = p, f = v1(m);
    for (; f && n && h !== m; ) {
      const $ = So(f), v = f.getBoundingClientRect(), y = Xt(f), S = v.left + (f.clientLeft + parseFloat(y.paddingLeft)) * $.x, w = v.top + (f.clientTop + parseFloat(y.paddingTop)) * $.y;
      s *= $.x, u *= $.y, c *= $.x, l *= $.y, s += S, u += w, m = Pt(f), f = v1(m);
    }
  }
  return Vd({
    width: c,
    height: l,
    x: s,
    y: u
  });
}
function U2(e, t) {
  const r = Mi(e).scrollLeft;
  return t ? t.left + r : gn(ur(e)).left + r;
}
function Z_(e, t, r) {
  r === void 0 && (r = !1);
  const n = e.getBoundingClientRect(), o = n.left + t.scrollLeft - (r ? 0 : (
    // RTL <body> scrollbar.
    U2(e, n)
  )), a = n.top + t.scrollTop;
  return {
    x: o,
    y: a
  };
}
function Yq(e) {
  let {
    elements: t,
    rect: r,
    offsetParent: n,
    strategy: o
  } = e;
  const a = o === "fixed", d = ur(n), i = t ? Ei(t.floating) : !1;
  if (n === d || i && a)
    return r;
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = or(1);
  const c = or(0), l = sr(n);
  if ((l || !l && !a) && ((jo(n) !== "body" || Ba(d)) && (s = Mi(n)), sr(n))) {
    const h = gn(n);
    u = So(n), c.x = h.x + n.clientLeft, c.y = h.y + n.clientTop;
  }
  const p = d && !l && !a ? Z_(d, s, !0) : or(0);
  return {
    width: r.width * u.x,
    height: r.height * u.y,
    x: r.x * u.x - s.scrollLeft * u.x + c.x + p.x,
    y: r.y * u.y - s.scrollTop * u.y + c.y + p.y
  };
}
function Xq(e) {
  return Array.from(e.getClientRects());
}
function qq(e) {
  const t = ur(e), r = Mi(e), n = e.ownerDocument.body, o = Ot(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), a = Ot(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let d = -r.scrollLeft + U2(e);
  const i = -r.scrollTop;
  return Xt(n).direction === "rtl" && (d += Ot(t.clientWidth, n.clientWidth) - o), {
    width: o,
    height: a,
    x: d,
    y: i
  };
}
function Jq(e, t) {
  const r = Pt(e), n = ur(e), o = r.visualViewport;
  let a = n.clientWidth, d = n.clientHeight, i = 0, s = 0;
  if (o) {
    a = o.width, d = o.height;
    const u = B2();
    (!u || u && t === "fixed") && (i = o.offsetLeft, s = o.offsetTop);
  }
  return {
    width: a,
    height: d,
    x: i,
    y: s
  };
}
function Qq(e, t) {
  const r = gn(e, !0, t === "fixed"), n = r.top + e.clientTop, o = r.left + e.clientLeft, a = sr(e) ? So(e) : or(1), d = e.clientWidth * a.x, i = e.clientHeight * a.y, s = o * a.x, u = n * a.y;
  return {
    width: d,
    height: i,
    x: s,
    y: u
  };
}
function M7(e, t, r) {
  let n;
  if (t === "viewport")
    n = Jq(e, r);
  else if (t === "document")
    n = qq(ur(e));
  else if (Yt(t))
    n = Qq(t, r);
  else {
    const o = B_(e);
    n = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return Vd(n);
}
function U_(e, t) {
  const r = Hr(e);
  return r === t || !Yt(r) || _o(r) ? !1 : Xt(r).position === "fixed" || U_(r, t);
}
function eJ(e, t) {
  const r = t.get(e);
  if (r)
    return r;
  let n = ya(e, [], !1).filter((i) => Yt(i) && jo(i) !== "body"), o = null;
  const a = Xt(e).position === "fixed";
  let d = a ? Hr(e) : e;
  for (; Yt(d) && !_o(d); ) {
    const i = Xt(d), s = j2(d);
    !s && i.position === "fixed" && (o = null), (a ? !s && !o : !s && i.position === "static" && o && ["absolute", "fixed"].includes(o.position) || Ba(d) && !s && U_(e, d)) ? n = n.filter((u) => u !== d) : o = i, d = Hr(d);
  }
  return t.set(e, n), n;
}
function tJ(e) {
  let {
    element: t,
    boundary: r,
    rootBoundary: n,
    strategy: o
  } = e;
  const a = [...r === "clippingAncestors" ? Ei(t) ? [] : eJ(t, this._c) : [].concat(r), n], d = a[0], i = a.reduce((s, u) => {
    const c = M7(t, u, o);
    return s.top = Ot(c.top, s.top), s.right = Vr(c.right, s.right), s.bottom = Vr(c.bottom, s.bottom), s.left = Ot(c.left, s.left), s;
  }, M7(t, d, o));
  return {
    width: i.right - i.left,
    height: i.bottom - i.top,
    x: i.left,
    y: i.top
  };
}
function rJ(e) {
  const {
    width: t,
    height: r
  } = j_(e);
  return {
    width: t,
    height: r
  };
}
function nJ(e, t, r) {
  const n = sr(t), o = ur(t), a = r === "fixed", d = gn(e, !0, a, t);
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const s = or(0);
  function u() {
    s.x = U2(o);
  }
  if (n || !n && !a)
    if ((jo(t) !== "body" || Ba(o)) && (i = Mi(t)), n) {
      const h = gn(t, !0, a, t);
      s.x = h.x + t.clientLeft, s.y = h.y + t.clientTop;
    } else o && u();
  a && !n && o && u();
  const c = o && !n && !a ? Z_(o, i) : or(0), l = d.left + i.scrollLeft - s.x - c.x, p = d.top + i.scrollTop - s.y - c.y;
  return {
    x: l,
    y: p,
    width: d.width,
    height: d.height
  };
}
function _c(e) {
  return Xt(e).position === "static";
}
function C7(e, t) {
  if (!sr(e) || Xt(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let r = e.offsetParent;
  return ur(e) === r && (r = r.ownerDocument.body), r;
}
function G_(e, t) {
  const r = Pt(e);
  if (Ei(e))
    return r;
  if (!sr(e)) {
    let o = Hr(e);
    for (; o && !_o(o); ) {
      if (Yt(o) && !_c(o))
        return o;
      o = Hr(o);
    }
    return r;
  }
  let n = C7(e, t);
  for (; n && Hq(n) && _c(n); )
    n = C7(n, t);
  return n && _o(n) && _c(n) && !j2(n) ? r : n || Kq(e) || r;
}
const oJ = async function(e) {
  const t = this.getOffsetParent || G_, r = this.getDimensions, n = await r(e.floating);
  return {
    reference: nJ(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function aJ(e) {
  return Xt(e).direction === "rtl";
}
const dJ = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Yq,
  getDocumentElement: ur,
  getClippingRect: tJ,
  getOffsetParent: G_,
  getElementRects: oJ,
  getClientRects: Xq,
  getDimensions: rJ,
  getScale: So,
  isElement: Yt,
  isRTL: aJ
};
function V_(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function iJ(e, t) {
  let r = null, n;
  const o = ur(e);
  function a() {
    var i;
    clearTimeout(n), (i = r) == null || i.disconnect(), r = null;
  }
  function d(i, s) {
    i === void 0 && (i = !1), s === void 0 && (s = 1), a();
    const u = e.getBoundingClientRect(), {
      left: c,
      top: l,
      width: p,
      height: h
    } = u;
    if (i || t(), !p || !h)
      return;
    const m = gd(l), f = gd(o.clientWidth - (c + p)), $ = gd(o.clientHeight - (l + h)), v = gd(c), y = {
      rootMargin: -m + "px " + -f + "px " + -$ + "px " + -v + "px",
      threshold: Ot(0, Vr(1, s)) || 1
    };
    let S = !0;
    function w(_) {
      const I = _[0].intersectionRatio;
      if (I !== s) {
        if (!S)
          return d();
        I ? d(!1, I) : n = setTimeout(() => {
          d(!1, 1e-7);
        }, 1e3);
      }
      I === 1 && !V_(u, e.getBoundingClientRect()) && d(), S = !1;
    }
    try {
      r = new IntersectionObserver(w, {
        ...y,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(w, y);
    }
    r.observe(e);
  }
  return d(!0), a;
}
function H_(e, t, r, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: a = !0,
    elementResize: d = typeof ResizeObserver == "function",
    layoutShift: i = typeof IntersectionObserver == "function",
    animationFrame: s = !1
  } = n, u = Z2(e), c = o || a ? [...u ? ya(u) : [], ...ya(t)] : [];
  c.forEach((v) => {
    o && v.addEventListener("scroll", r, {
      passive: !0
    }), a && v.addEventListener("resize", r);
  });
  const l = u && i ? iJ(u, r) : null;
  let p = -1, h = null;
  d && (h = new ResizeObserver((v) => {
    let [y] = v;
    y && y.target === u && h && (h.unobserve(t), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var S;
      (S = h) == null || S.observe(t);
    })), r();
  }), u && !s && h.observe(u), h.observe(t));
  let m, f = s ? gn(e) : null;
  s && $();
  function $() {
    const v = gn(e);
    f && !V_(f, v) && r(), f = v, m = requestAnimationFrame($);
  }
  return r(), () => {
    var v;
    c.forEach((y) => {
      o && y.removeEventListener("scroll", r), a && y.removeEventListener("resize", r);
    }), l == null || l(), (v = h) == null || v.disconnect(), h = null, s && cancelAnimationFrame(m);
  };
}
const sJ = Zq, uJ = Uq, lJ = kq, cJ = Vq, fJ = jq, O7 = Fq, pJ = Gq, $J = (e, t, r) => {
  const n = /* @__PURE__ */ new Map(), o = {
    platform: dJ,
    ...r
  }, a = {
    ...o.platform,
    _c: n
  };
  return Lq(e, t, {
    ...o,
    platform: a
  });
};
var Md = typeof document < "u" ? V7 : rt;
function Hd(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let r, n, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (r = e.length, r !== t.length) return !1;
      for (n = r; n-- !== 0; )
        if (!Hd(e[n], t[n]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), r = o.length, r !== Object.keys(t).length)
      return !1;
    for (n = r; n-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[n]))
        return !1;
    for (n = r; n-- !== 0; ) {
      const a = o[n];
      if (!(a === "_owner" && e.$$typeof) && !Hd(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function K_(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function N7(e, t) {
  const r = K_(e);
  return Math.round(t * r) / r;
}
function Ec(e) {
  const t = x.useRef(e);
  return Md(() => {
    t.current = e;
  }), t;
}
function W_(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: r = "absolute",
    middleware: n = [],
    platform: o,
    elements: {
      reference: a,
      floating: d
    } = {},
    transform: i = !0,
    whileElementsMounted: s,
    open: u
  } = e, [c, l] = x.useState({
    x: 0,
    y: 0,
    strategy: r,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [p, h] = x.useState(n);
  Hd(p, n) || h(n);
  const [m, f] = x.useState(null), [$, v] = x.useState(null), y = x.useCallback((de) => {
    de !== I.current && (I.current = de, f(de));
  }, []), S = x.useCallback((de) => {
    de !== N.current && (N.current = de, v(de));
  }, []), w = a || m, _ = d || $, I = x.useRef(null), N = x.useRef(null), O = x.useRef(c), E = s != null, C = Ec(s), P = Ec(o), T = Ec(u), j = x.useCallback(() => {
    if (!I.current || !N.current)
      return;
    const de = {
      placement: t,
      strategy: r,
      middleware: p
    };
    P.current && (de.platform = P.current), $J(I.current, N.current, de).then((G) => {
      const le = {
        ...G,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: T.current !== !1
      };
      F.current && !Hd(O.current, le) && (O.current = le, Oo.flushSync(() => {
        l(le);
      }));
    });
  }, [p, t, r, P, T]);
  Md(() => {
    u === !1 && O.current.isPositioned && (O.current.isPositioned = !1, l((de) => ({
      ...de,
      isPositioned: !1
    })));
  }, [u]);
  const F = x.useRef(!1);
  Md(() => (F.current = !0, () => {
    F.current = !1;
  }), []), Md(() => {
    if (w && (I.current = w), _ && (N.current = _), w && _) {
      if (C.current)
        return C.current(w, _, j);
      j();
    }
  }, [w, _, j, C, E]);
  const Z = x.useMemo(() => ({
    reference: I,
    floating: N,
    setReference: y,
    setFloating: S
  }), [y, S]), te = x.useMemo(() => ({
    reference: w,
    floating: _
  }), [w, _]), H = x.useMemo(() => {
    const de = {
      position: r,
      left: 0,
      top: 0
    };
    if (!te.floating)
      return de;
    const G = N7(te.floating, c.x), le = N7(te.floating, c.y);
    return i ? {
      ...de,
      transform: "translate(" + G + "px, " + le + "px)",
      ...K_(te.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: r,
      left: G,
      top: le
    };
  }, [r, i, te.floating, c.x, c.y]);
  return x.useMemo(() => ({
    ...c,
    update: j,
    refs: Z,
    elements: te,
    floatingStyles: H
  }), [c, j, Z, te, H]);
}
const vJ = (e) => {
  function t(r) {
    return {}.hasOwnProperty.call(r, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(r) {
      const {
        element: n,
        padding: o
      } = typeof e == "function" ? e(r) : e;
      return n && t(n) ? n.current != null ? O7({
        element: n.current,
        padding: o
      }).fn(r) : {} : n ? O7({
        element: n,
        padding: o
      }).fn(r) : {};
    }
  };
}, z_ = (e, t) => ({
  ...sJ(e),
  options: [e, t]
}), Y_ = (e, t) => ({
  ...uJ(e),
  options: [e, t]
}), X_ = (e, t) => ({
  ...pJ(e),
  options: [e, t]
}), q_ = (e, t) => ({
  ...lJ(e),
  options: [e, t]
}), J_ = (e, t) => ({
  ...cJ(e),
  options: [e, t]
}), Q_ = (e, t) => ({
  ...fJ(e),
  options: [e, t]
}), eE = (e, t) => ({
  ...vJ(e),
  options: [e, t]
});
var mJ = "Arrow", tE = x.forwardRef((e, t) => {
  const { children: r, width: n = 10, height: o = 5, ...a } = e;
  return /* @__PURE__ */ A(
    ge.svg,
    {
      ...a,
      ref: t,
      width: n,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? r : /* @__PURE__ */ A("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
tE.displayName = mJ;
var hJ = tE, rE = "Popper", [nE, qr] = At(rE), [Wne, oE] = nE(rE), aE = "PopperAnchor", dE = x.forwardRef(
  (e, t) => {
    const { __scopePopper: r, virtualRef: n, ...o } = e, a = oE(aE, r), d = x.useRef(null), i = Oe(t, d);
    return x.useEffect(() => {
      a.onAnchorChange((n == null ? void 0 : n.current) || d.current);
    }), n ? null : /* @__PURE__ */ A(ge.div, { ...o, ref: i });
  }
);
dE.displayName = aE;
var G2 = "PopperContent", [gJ, yJ] = nE(G2), iE = x.forwardRef(
  (e, t) => {
    var r, n, o, a, d, i;
    const {
      __scopePopper: s,
      side: u = "bottom",
      sideOffset: c = 0,
      align: l = "center",
      alignOffset: p = 0,
      arrowPadding: h = 0,
      avoidCollisions: m = !0,
      collisionBoundary: f = [],
      collisionPadding: $ = 0,
      sticky: v = "partial",
      hideWhenDetached: y = !1,
      updatePositionStrategy: S = "optimized",
      onPlaced: w,
      ..._
    } = e, I = oE(G2, s), [N, O] = x.useState(null), E = Oe(t, (he) => O(he)), [C, P] = x.useState(null), T = T2(C), j = (T == null ? void 0 : T.width) ?? 0, F = (T == null ? void 0 : T.height) ?? 0, Z = u + (l !== "center" ? "-" + l : ""), te = typeof $ == "number" ? $ : { top: 0, right: 0, bottom: 0, left: 0, ...$ }, H = Array.isArray(f) ? f : [f], de = H.length > 0, G = {
      padding: te,
      boundary: H.filter(xJ),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: de
    }, { refs: le, floatingStyles: fe, placement: U, isPositioned: ae, middlewareData: ue } = W_({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: Z,
      whileElementsMounted: (...he) => H_(...he, {
        animationFrame: S === "always"
      }),
      elements: {
        reference: I.anchor
      },
      middleware: [
        z_({ mainAxis: c + F, alignmentAxis: p }),
        m && Y_({
          mainAxis: !0,
          crossAxis: !1,
          limiter: v === "partial" ? X_() : void 0,
          ...G
        }),
        m && q_({ ...G }),
        J_({
          ...G,
          apply: ({ elements: he, rects: Ee, availableWidth: ot, availableHeight: Ve }) => {
            const { width: Rt, height: g } = Ee.reference, b = he.floating.style;
            b.setProperty("--radix-popper-available-width", `${ot}px`), b.setProperty("--radix-popper-available-height", `${Ve}px`), b.setProperty("--radix-popper-anchor-width", `${Rt}px`), b.setProperty("--radix-popper-anchor-height", `${g}px`);
          }
        }),
        C && eE({ element: C, padding: h }),
        wJ({ arrowWidth: j, arrowHeight: F }),
        y && Q_({ strategy: "referenceHidden", ...G })
      ]
    }), [se, we] = lE(U), re = it(w);
    et(() => {
      ae && (re == null || re());
    }, [ae, re]);
    const ye = (r = ue.arrow) == null ? void 0 : r.x, xe = (n = ue.arrow) == null ? void 0 : n.y, be = ((o = ue.arrow) == null ? void 0 : o.centerOffset) !== 0, [ee, ce] = x.useState();
    return et(() => {
      N && ce(window.getComputedStyle(N).zIndex);
    }, [N]), /* @__PURE__ */ A(
      "div",
      {
        ref: le.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...fe,
          transform: ae ? fe.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: ee,
          "--radix-popper-transform-origin": [
            (a = ue.transformOrigin) == null ? void 0 : a.x,
            (d = ue.transformOrigin) == null ? void 0 : d.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((i = ue.hide) == null ? void 0 : i.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ A(
          gJ,
          {
            scope: s,
            placedSide: se,
            onArrowChange: P,
            arrowX: ye,
            arrowY: xe,
            shouldHideArrow: be,
            children: /* @__PURE__ */ A(
              ge.div,
              {
                "data-side": se,
                "data-align": we,
                ..._,
                ref: E,
                style: {
                  ..._.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: ae ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
iE.displayName = G2;
var sE = "PopperArrow", bJ = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, uE = x.forwardRef(function(e, t) {
  const { __scopePopper: r, ...n } = e, o = yJ(sE, r), a = bJ[o.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ A(
      "span",
      {
        ref: o.onArrowChange,
        style: {
          position: "absolute",
          left: o.arrowX,
          top: o.arrowY,
          [a]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[o.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[o.placedSide],
          visibility: o.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ A(
          hJ,
          {
            ...n,
            ref: t,
            style: {
              ...n.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
uE.displayName = sE;
function xJ(e) {
  return e !== null;
}
var wJ = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var r, n, o;
    const { placement: a, rects: d, middlewareData: i } = t, s = ((r = i.arrow) == null ? void 0 : r.centerOffset) !== 0, u = s ? 0 : e.arrowWidth, c = s ? 0 : e.arrowHeight, [l, p] = lE(a), h = { start: "0%", center: "50%", end: "100%" }[p], m = (((n = i.arrow) == null ? void 0 : n.x) ?? 0) + u / 2, f = (((o = i.arrow) == null ? void 0 : o.y) ?? 0) + c / 2;
    let $ = "", v = "";
    return l === "bottom" ? ($ = s ? h : `${m}px`, v = `${-c}px`) : l === "top" ? ($ = s ? h : `${m}px`, v = `${d.floating.height + c}px`) : l === "right" ? ($ = `${-c}px`, v = s ? h : `${f}px`) : l === "left" && ($ = `${d.floating.width + c}px`, v = s ? h : `${f}px`), { data: { x: $, y: v } };
  }
});
function lE(e) {
  const [t, r = "center"] = e.split("-");
  return [t, r];
}
var Za = dE, Ci = iE, Oi = uE, cE = "Popover", [fE, zne] = At(cE, [
  qr
]), Ni = qr(), [Yne, Jr] = fE(cE), pE = "PopoverAnchor", AJ = x.forwardRef(
  (e, t) => {
    const { __scopePopover: r, ...n } = e, o = Jr(pE, r), a = Ni(r), { onCustomAnchorAdd: d, onCustomAnchorRemove: i } = o;
    return x.useEffect(() => (d(), () => i()), [d, i]), /* @__PURE__ */ A(Za, { ...a, ...n, ref: t });
  }
);
AJ.displayName = pE;
var $E = "PopoverTrigger", SJ = x.forwardRef(
  (e, t) => {
    const { __scopePopover: r, ...n } = e, o = Jr($E, r), a = Ni(r), d = Oe(t, o.triggerRef), i = /* @__PURE__ */ A(
      ge.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": yE(o.open),
        ...n,
        ref: d,
        onClick: ne(e.onClick, o.onOpenToggle)
      }
    );
    return o.hasCustomAnchor ? i : /* @__PURE__ */ A(Za, { asChild: !0, ...a, children: i });
  }
);
SJ.displayName = $E;
var V2 = "PopoverPortal", [_J, EJ] = fE(V2, {
  forceMount: void 0
}), vE = (e) => {
  const { __scopePopover: t, forceMount: r, children: n, container: o } = e, a = Jr(V2, t);
  return /* @__PURE__ */ A(_J, { scope: t, forceMount: r, children: /* @__PURE__ */ A(St, { present: r || a.open, children: /* @__PURE__ */ A(Lo, { asChild: !0, container: o, children: n }) }) });
};
vE.displayName = V2;
var Eo = "PopoverContent", mE = x.forwardRef(
  (e, t) => {
    const r = EJ(Eo, e.__scopePopover), { forceMount: n = r.forceMount, ...o } = e, a = Jr(Eo, e.__scopePopover);
    return /* @__PURE__ */ A(St, { present: n || a.open, children: a.modal ? /* @__PURE__ */ A(CJ, { ...o, ref: t }) : /* @__PURE__ */ A(OJ, { ...o, ref: t }) });
  }
);
mE.displayName = Eo;
var MJ = /* @__PURE__ */ $n("PopoverContent.RemoveScroll"), CJ = x.forwardRef(
  (e, t) => {
    const r = Jr(Eo, e.__scopePopover), n = x.useRef(null), o = Oe(t, n), a = x.useRef(!1);
    return x.useEffect(() => {
      const d = n.current;
      if (d) return fi(d);
    }, []), /* @__PURE__ */ A(Ra, { as: MJ, allowPinchZoom: !0, children: /* @__PURE__ */ A(
      hE,
      {
        ...e,
        ref: o,
        trapFocus: r.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: ne(e.onCloseAutoFocus, (d) => {
          var i;
          d.preventDefault(), a.current || (i = r.triggerRef.current) == null || i.focus();
        }),
        onPointerDownOutside: ne(
          e.onPointerDownOutside,
          (d) => {
            const i = d.detail.originalEvent, s = i.button === 0 && i.ctrlKey === !0, u = i.button === 2 || s;
            a.current = u;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: ne(
          e.onFocusOutside,
          (d) => d.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), OJ = x.forwardRef(
  (e, t) => {
    const r = Jr(Eo, e.__scopePopover), n = x.useRef(!1), o = x.useRef(!1);
    return /* @__PURE__ */ A(
      hE,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var d, i;
          (d = e.onCloseAutoFocus) == null || d.call(e, a), a.defaultPrevented || (n.current || (i = r.triggerRef.current) == null || i.focus(), a.preventDefault()), n.current = !1, o.current = !1;
        },
        onInteractOutside: (a) => {
          var d, i;
          (d = e.onInteractOutside) == null || d.call(e, a), a.defaultPrevented || (n.current = !0, a.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const s = a.target;
          (i = r.triggerRef.current) != null && i.contains(s) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && o.current && a.preventDefault();
        }
      }
    );
  }
), hE = x.forwardRef(
  (e, t) => {
    const {
      __scopePopover: r,
      trapFocus: n,
      onOpenAutoFocus: o,
      onCloseAutoFocus: a,
      disableOutsidePointerEvents: d,
      onEscapeKeyDown: i,
      onPointerDownOutside: s,
      onFocusOutside: u,
      onInteractOutside: c,
      ...l
    } = e, p = Jr(Eo, r), h = Ni(r);
    return li(), /* @__PURE__ */ A(
      Pa,
      {
        asChild: !0,
        loop: !0,
        trapped: n,
        onMountAutoFocus: o,
        onUnmountAutoFocus: a,
        children: /* @__PURE__ */ A(
          xn,
          {
            asChild: !0,
            disableOutsidePointerEvents: d,
            onInteractOutside: c,
            onEscapeKeyDown: i,
            onPointerDownOutside: s,
            onFocusOutside: u,
            onDismiss: () => p.onOpenChange(!1),
            children: /* @__PURE__ */ A(
              Ci,
              {
                "data-state": yE(p.open),
                role: "dialog",
                id: p.contentId,
                ...h,
                ...l,
                ref: t,
                style: {
                  ...l.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), gE = "PopoverClose", NJ = x.forwardRef(
  (e, t) => {
    const { __scopePopover: r, ...n } = e, o = Jr(gE, r);
    return /* @__PURE__ */ A(
      ge.button,
      {
        type: "button",
        ...n,
        ref: t,
        onClick: ne(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
NJ.displayName = gE;
var IJ = "PopoverArrow", PJ = x.forwardRef(
  (e, t) => {
    const { __scopePopover: r, ...n } = e, o = Ni(r);
    return /* @__PURE__ */ A(Oi, { ...o, ...n, ref: t });
  }
);
PJ.displayName = IJ;
function yE(e) {
  return e ? "open" : "closed";
}
var RJ = vE, bE = mE;
const TJ = X(({ className: e, align: t = "center", sideOffset: r = 4, ...n }, o) => /* @__PURE__ */ A(RJ, { children: /* @__PURE__ */ A(
  bE,
  {
    ref: o,
    align: t,
    sideOffset: r,
    className: q(
      "z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...n
  }
) }));
TJ.displayName = bE.displayName;
var DJ = x.createContext(void 0);
function xE(e) {
  const t = x.useContext(DJ);
  return e || t || "ltr";
}
var Mc = "rovingFocusGroup.onEntryFocus", LJ = { bubbles: !1, cancelable: !0 }, Ua = "RovingFocusGroup", [m1, wE, FJ] = wi(Ua), [kJ, Ii] = At(
  Ua,
  [FJ]
), [jJ, BJ] = kJ(Ua), AE = x.forwardRef(
  (e, t) => /* @__PURE__ */ A(m1.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ A(m1.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ A(ZJ, { ...e, ref: t }) }) })
);
AE.displayName = Ua;
var ZJ = x.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: r,
    orientation: n,
    loop: o = !1,
    dir: a,
    currentTabStopId: d,
    defaultCurrentTabStopId: i,
    onCurrentTabStopIdChange: s,
    onEntryFocus: u,
    preventScrollOnEntryFocus: c = !1,
    ...l
  } = e, p = x.useRef(null), h = Oe(t, p), m = xE(a), [f, $] = Do({
    prop: d,
    defaultProp: i ?? null,
    onChange: s,
    caller: Ua
  }), [v, y] = x.useState(!1), S = it(u), w = wE(r), _ = x.useRef(!1), [I, N] = x.useState(0);
  return x.useEffect(() => {
    const O = p.current;
    if (O)
      return O.addEventListener(Mc, S), () => O.removeEventListener(Mc, S);
  }, [S]), /* @__PURE__ */ A(
    jJ,
    {
      scope: r,
      orientation: n,
      dir: m,
      loop: o,
      currentTabStopId: f,
      onItemFocus: x.useCallback(
        (O) => $(O),
        [$]
      ),
      onItemShiftTab: x.useCallback(() => y(!0), []),
      onFocusableItemAdd: x.useCallback(
        () => N((O) => O + 1),
        []
      ),
      onFocusableItemRemove: x.useCallback(
        () => N((O) => O - 1),
        []
      ),
      children: /* @__PURE__ */ A(
        ge.div,
        {
          tabIndex: v || I === 0 ? -1 : 0,
          "data-orientation": n,
          ...l,
          ref: h,
          style: { outline: "none", ...e.style },
          onMouseDown: ne(e.onMouseDown, () => {
            _.current = !0;
          }),
          onFocus: ne(e.onFocus, (O) => {
            const E = !_.current;
            if (O.target === O.currentTarget && E && !v) {
              const C = new CustomEvent(Mc, LJ);
              if (O.currentTarget.dispatchEvent(C), !C.defaultPrevented) {
                const P = w().filter((Z) => Z.focusable), T = P.find((Z) => Z.active), j = P.find((Z) => Z.id === f), F = [T, j, ...P].filter(
                  Boolean
                ).map((Z) => Z.ref.current);
                EE(F, c);
              }
            }
            _.current = !1;
          }),
          onBlur: ne(e.onBlur, () => y(!1))
        }
      )
    }
  );
}), SE = "RovingFocusGroupItem", _E = x.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: r,
      focusable: n = !0,
      active: o = !1,
      tabStopId: a,
      children: d,
      ...i
    } = e, s = It(), u = a || s, c = BJ(SE, r), l = c.currentTabStopId === u, p = wE(r), { onFocusableItemAdd: h, onFocusableItemRemove: m, currentTabStopId: f } = c;
    return x.useEffect(() => {
      if (n)
        return h(), () => m();
    }, [n, h, m]), /* @__PURE__ */ A(
      m1.ItemSlot,
      {
        scope: r,
        id: u,
        focusable: n,
        active: o,
        children: /* @__PURE__ */ A(
          ge.span,
          {
            tabIndex: l ? 0 : -1,
            "data-orientation": c.orientation,
            ...i,
            ref: t,
            onMouseDown: ne(e.onMouseDown, ($) => {
              n ? c.onItemFocus(u) : $.preventDefault();
            }),
            onFocus: ne(e.onFocus, () => c.onItemFocus(u)),
            onKeyDown: ne(e.onKeyDown, ($) => {
              if ($.key === "Tab" && $.shiftKey) {
                c.onItemShiftTab();
                return;
              }
              if ($.target !== $.currentTarget) return;
              const v = VJ($, c.orientation, c.dir);
              if (v !== void 0) {
                if ($.metaKey || $.ctrlKey || $.altKey || $.shiftKey) return;
                $.preventDefault();
                let y = p().filter((S) => S.focusable).map((S) => S.ref.current);
                if (v === "last") y.reverse();
                else if (v === "prev" || v === "next") {
                  v === "prev" && y.reverse();
                  const S = y.indexOf($.currentTarget);
                  y = c.loop ? HJ(y, S + 1) : y.slice(S + 1);
                }
                setTimeout(() => EE(y));
              }
            }),
            children: typeof d == "function" ? d({ isCurrentTabStop: l, hasTabStop: f != null }) : d
          }
        )
      }
    );
  }
);
_E.displayName = SE;
var UJ = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function GJ(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function VJ(e, t, r) {
  const n = GJ(e.key, r);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(n)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(n)))
    return UJ[n];
}
function EE(e, t = !1) {
  const r = document.activeElement;
  for (const n of e)
    if (n === r || (n.focus({ preventScroll: t }), document.activeElement !== r)) return;
}
function HJ(e, t) {
  return e.map((r, n) => e[(t + n) % e.length]);
}
var ME = AE, CE = _E, h1 = ["Enter", " "], KJ = ["ArrowDown", "PageUp", "Home"], OE = ["ArrowUp", "PageDown", "End"], WJ = [...KJ, ...OE], zJ = {
  ltr: [...h1, "ArrowRight"],
  rtl: [...h1, "ArrowLeft"]
}, YJ = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, Pi = "Menu", [ba, XJ, qJ] = wi(Pi), [wn, NE] = At(Pi, [
  qJ,
  qr,
  Ii
]), H2 = qr(), IE = Ii(), [Xne, An] = wn(Pi), [qne, Ga] = wn(Pi), JJ = "MenuAnchor", K2 = x.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, ...n } = e, o = H2(r);
    return /* @__PURE__ */ A(Za, { ...o, ...n, ref: t });
  }
);
K2.displayName = JJ;
var W2 = "MenuPortal", [QJ, PE] = wn(W2, {
  forceMount: void 0
}), RE = (e) => {
  const { __scopeMenu: t, forceMount: r, children: n, container: o } = e, a = An(W2, t);
  return /* @__PURE__ */ A(QJ, { scope: t, forceMount: r, children: /* @__PURE__ */ A(St, { present: r || a.open, children: /* @__PURE__ */ A(Lo, { asChild: !0, container: o, children: n }) }) });
};
RE.displayName = W2;
var Lt = "MenuContent", [eQ, z2] = wn(Lt), TE = x.forwardRef(
  (e, t) => {
    const r = PE(Lt, e.__scopeMenu), { forceMount: n = r.forceMount, ...o } = e, a = An(Lt, e.__scopeMenu), d = Ga(Lt, e.__scopeMenu);
    return /* @__PURE__ */ A(ba.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ A(St, { present: n || a.open, children: /* @__PURE__ */ A(ba.Slot, { scope: e.__scopeMenu, children: d.modal ? /* @__PURE__ */ A(tQ, { ...o, ref: t }) : /* @__PURE__ */ A(rQ, { ...o, ref: t }) }) }) });
  }
), tQ = x.forwardRef(
  (e, t) => {
    const r = An(Lt, e.__scopeMenu), n = x.useRef(null), o = Oe(t, n);
    return x.useEffect(() => {
      const a = n.current;
      if (a) return fi(a);
    }, []), /* @__PURE__ */ A(
      Y2,
      {
        ...e,
        ref: o,
        trapFocus: r.open,
        disableOutsidePointerEvents: r.open,
        disableOutsideScroll: !0,
        onFocusOutside: ne(
          e.onFocusOutside,
          (a) => a.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => r.onOpenChange(!1)
      }
    );
  }
), rQ = x.forwardRef((e, t) => {
  const r = An(Lt, e.__scopeMenu);
  return /* @__PURE__ */ A(
    Y2,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => r.onOpenChange(!1)
    }
  );
}), nQ = /* @__PURE__ */ $n("MenuContent.ScrollLock"), Y2 = x.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: r,
      loop: n = !1,
      trapFocus: o,
      onOpenAutoFocus: a,
      onCloseAutoFocus: d,
      disableOutsidePointerEvents: i,
      onEntryFocus: s,
      onEscapeKeyDown: u,
      onPointerDownOutside: c,
      onFocusOutside: l,
      onInteractOutside: p,
      onDismiss: h,
      disableOutsideScroll: m,
      ...f
    } = e, $ = An(Lt, r), v = Ga(Lt, r), y = H2(r), S = IE(r), w = XJ(r), [_, I] = x.useState(null), N = x.useRef(null), O = Oe(t, N, $.onContentChange), E = x.useRef(0), C = x.useRef(""), P = x.useRef(0), T = x.useRef(null), j = x.useRef("right"), F = x.useRef(0), Z = m ? Ra : x.Fragment, te = m ? { as: nQ, allowPinchZoom: !0 } : void 0, H = (G) => {
      var le, fe;
      const U = C.current + G, ae = w().filter((xe) => !xe.disabled), ue = document.activeElement, se = (le = ae.find((xe) => xe.ref.current === ue)) == null ? void 0 : le.textValue, we = ae.map((xe) => xe.textValue), re = vQ(we, U, se), ye = (fe = ae.find((xe) => xe.textValue === re)) == null ? void 0 : fe.ref.current;
      (function xe(be) {
        C.current = be, window.clearTimeout(E.current), be !== "" && (E.current = window.setTimeout(() => xe(""), 1e3));
      })(U), ye && setTimeout(() => ye.focus());
    };
    x.useEffect(() => () => window.clearTimeout(E.current), []), li();
    const de = x.useCallback((G) => {
      var le, fe;
      return j.current === ((le = T.current) == null ? void 0 : le.side) && hQ(G, (fe = T.current) == null ? void 0 : fe.area);
    }, []);
    return /* @__PURE__ */ A(
      eQ,
      {
        scope: r,
        searchRef: C,
        onItemEnter: x.useCallback(
          (G) => {
            de(G) && G.preventDefault();
          },
          [de]
        ),
        onItemLeave: x.useCallback(
          (G) => {
            var le;
            de(G) || ((le = N.current) == null || le.focus(), I(null));
          },
          [de]
        ),
        onTriggerLeave: x.useCallback(
          (G) => {
            de(G) && G.preventDefault();
          },
          [de]
        ),
        pointerGraceTimerRef: P,
        onPointerGraceIntentChange: x.useCallback((G) => {
          T.current = G;
        }, []),
        children: /* @__PURE__ */ A(Z, { ...te, children: /* @__PURE__ */ A(
          Pa,
          {
            asChild: !0,
            trapped: o,
            onMountAutoFocus: ne(a, (G) => {
              var le;
              G.preventDefault(), (le = N.current) == null || le.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: d,
            children: /* @__PURE__ */ A(
              xn,
              {
                asChild: !0,
                disableOutsidePointerEvents: i,
                onEscapeKeyDown: u,
                onPointerDownOutside: c,
                onFocusOutside: l,
                onInteractOutside: p,
                onDismiss: h,
                children: /* @__PURE__ */ A(
                  ME,
                  {
                    asChild: !0,
                    ...S,
                    dir: v.dir,
                    orientation: "vertical",
                    loop: n,
                    currentTabStopId: _,
                    onCurrentTabStopIdChange: I,
                    onEntryFocus: ne(s, (G) => {
                      v.isUsingKeyboardRef.current || G.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ A(
                      Ci,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": XE($.open),
                        "data-radix-menu-content": "",
                        dir: v.dir,
                        ...y,
                        ...f,
                        ref: O,
                        style: { outline: "none", ...f.style },
                        onKeyDown: ne(f.onKeyDown, (G) => {
                          const le = G.target.closest("[data-radix-menu-content]") === G.currentTarget, fe = G.ctrlKey || G.altKey || G.metaKey, U = G.key.length === 1;
                          le && (G.key === "Tab" && G.preventDefault(), !fe && U && H(G.key));
                          const ae = N.current;
                          if (G.target !== ae || !WJ.includes(G.key)) return;
                          G.preventDefault();
                          const ue = w().filter((se) => !se.disabled).map((se) => se.ref.current);
                          OE.includes(G.key) && ue.reverse(), pQ(ue);
                        }),
                        onBlur: ne(e.onBlur, (G) => {
                          G.currentTarget.contains(G.target) || (window.clearTimeout(E.current), C.current = "");
                        }),
                        onPointerMove: ne(
                          e.onPointerMove,
                          xa((G) => {
                            const le = G.target, fe = F.current !== G.clientX;
                            if (G.currentTarget.contains(le) && fe) {
                              const U = G.clientX > F.current ? "right" : "left";
                              j.current = U, F.current = G.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
TE.displayName = Lt;
var oQ = "MenuGroup", X2 = x.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, ...n } = e;
    return /* @__PURE__ */ A(ge.div, { role: "group", ...n, ref: t });
  }
);
X2.displayName = oQ;
var aQ = "MenuLabel", DE = x.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, ...n } = e;
    return /* @__PURE__ */ A(ge.div, { ...n, ref: t });
  }
);
DE.displayName = aQ;
var Kd = "MenuItem", I7 = "menu.itemSelect", Ri = x.forwardRef(
  (e, t) => {
    const { disabled: r = !1, onSelect: n, ...o } = e, a = x.useRef(null), d = Ga(Kd, e.__scopeMenu), i = z2(Kd, e.__scopeMenu), s = Oe(t, a), u = x.useRef(!1), c = () => {
      const l = a.current;
      if (!r && l) {
        const p = new CustomEvent(I7, { bubbles: !0, cancelable: !0 });
        l.addEventListener(I7, (h) => n == null ? void 0 : n(h), { once: !0 }), r2(l, p), p.defaultPrevented ? u.current = !1 : d.onClose();
      }
    };
    return /* @__PURE__ */ A(
      LE,
      {
        ...o,
        ref: s,
        disabled: r,
        onClick: ne(e.onClick, c),
        onPointerDown: (l) => {
          var p;
          (p = e.onPointerDown) == null || p.call(e, l), u.current = !0;
        },
        onPointerUp: ne(e.onPointerUp, (l) => {
          var p;
          u.current || (p = l.currentTarget) == null || p.click();
        }),
        onKeyDown: ne(e.onKeyDown, (l) => {
          const p = i.searchRef.current !== "";
          r || p && l.key === " " || h1.includes(l.key) && (l.currentTarget.click(), l.preventDefault());
        })
      }
    );
  }
);
Ri.displayName = Kd;
var LE = x.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, disabled: n = !1, textValue: o, ...a } = e, d = z2(Kd, r), i = IE(r), s = x.useRef(null), u = Oe(t, s), [c, l] = x.useState(!1), [p, h] = x.useState("");
    return x.useEffect(() => {
      const m = s.current;
      m && h((m.textContent ?? "").trim());
    }, [a.children]), /* @__PURE__ */ A(
      ba.ItemSlot,
      {
        scope: r,
        disabled: n,
        textValue: o ?? p,
        children: /* @__PURE__ */ A(CE, { asChild: !0, ...i, focusable: !n, children: /* @__PURE__ */ A(
          ge.div,
          {
            role: "menuitem",
            "data-highlighted": c ? "" : void 0,
            "aria-disabled": n || void 0,
            "data-disabled": n ? "" : void 0,
            ...a,
            ref: u,
            onPointerMove: ne(
              e.onPointerMove,
              xa((m) => {
                n ? d.onItemLeave(m) : (d.onItemEnter(m), m.defaultPrevented || m.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: ne(
              e.onPointerLeave,
              xa((m) => d.onItemLeave(m))
            ),
            onFocus: ne(e.onFocus, () => l(!0)),
            onBlur: ne(e.onBlur, () => l(!1))
          }
        ) })
      }
    );
  }
), dQ = "MenuCheckboxItem", FE = x.forwardRef(
  (e, t) => {
    const { checked: r = !1, onCheckedChange: n, ...o } = e;
    return /* @__PURE__ */ A(UE, { scope: e.__scopeMenu, checked: r, children: /* @__PURE__ */ A(
      Ri,
      {
        role: "menuitemcheckbox",
        "aria-checked": Wd(r) ? "mixed" : r,
        ...o,
        ref: t,
        "data-state": J2(r),
        onSelect: ne(
          o.onSelect,
          () => n == null ? void 0 : n(Wd(r) ? !0 : !r),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
FE.displayName = dQ;
var kE = "MenuRadioGroup", [iQ, sQ] = wn(
  kE,
  { value: void 0, onValueChange: () => {
  } }
), jE = x.forwardRef(
  (e, t) => {
    const { value: r, onValueChange: n, ...o } = e, a = it(n);
    return /* @__PURE__ */ A(iQ, { scope: e.__scopeMenu, value: r, onValueChange: a, children: /* @__PURE__ */ A(X2, { ...o, ref: t }) });
  }
);
jE.displayName = kE;
var BE = "MenuRadioItem", ZE = x.forwardRef(
  (e, t) => {
    const { value: r, ...n } = e, o = sQ(BE, e.__scopeMenu), a = r === o.value;
    return /* @__PURE__ */ A(UE, { scope: e.__scopeMenu, checked: a, children: /* @__PURE__ */ A(
      Ri,
      {
        role: "menuitemradio",
        "aria-checked": a,
        ...n,
        ref: t,
        "data-state": J2(a),
        onSelect: ne(
          n.onSelect,
          () => {
            var d;
            return (d = o.onValueChange) == null ? void 0 : d.call(o, r);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
ZE.displayName = BE;
var q2 = "MenuItemIndicator", [UE, uQ] = wn(
  q2,
  { checked: !1 }
), GE = x.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, forceMount: n, ...o } = e, a = uQ(q2, r);
    return /* @__PURE__ */ A(
      St,
      {
        present: n || Wd(a.checked) || a.checked === !0,
        children: /* @__PURE__ */ A(
          ge.span,
          {
            ...o,
            ref: t,
            "data-state": J2(a.checked)
          }
        )
      }
    );
  }
);
GE.displayName = q2;
var lQ = "MenuSeparator", VE = x.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, ...n } = e;
    return /* @__PURE__ */ A(
      ge.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...n,
        ref: t
      }
    );
  }
);
VE.displayName = lQ;
var cQ = "MenuArrow", HE = x.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, ...n } = e, o = H2(r);
    return /* @__PURE__ */ A(Oi, { ...o, ...n, ref: t });
  }
);
HE.displayName = cQ;
var fQ = "MenuSub", [Jne, KE] = wn(fQ), sa = "MenuSubTrigger", WE = x.forwardRef(
  (e, t) => {
    const r = An(sa, e.__scopeMenu), n = Ga(sa, e.__scopeMenu), o = KE(sa, e.__scopeMenu), a = z2(sa, e.__scopeMenu), d = x.useRef(null), { pointerGraceTimerRef: i, onPointerGraceIntentChange: s } = a, u = { __scopeMenu: e.__scopeMenu }, c = x.useCallback(() => {
      d.current && window.clearTimeout(d.current), d.current = null;
    }, []);
    return x.useEffect(() => c, [c]), x.useEffect(() => {
      const l = i.current;
      return () => {
        window.clearTimeout(l), s(null);
      };
    }, [i, s]), /* @__PURE__ */ A(K2, { asChild: !0, ...u, children: /* @__PURE__ */ A(
      LE,
      {
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": r.open,
        "aria-controls": o.contentId,
        "data-state": XE(r.open),
        ...e,
        ref: ui(t, o.onTriggerChange),
        onClick: (l) => {
          var p;
          (p = e.onClick) == null || p.call(e, l), !(e.disabled || l.defaultPrevented) && (l.currentTarget.focus(), r.open || r.onOpenChange(!0));
        },
        onPointerMove: ne(
          e.onPointerMove,
          xa((l) => {
            a.onItemEnter(l), !l.defaultPrevented && !e.disabled && !r.open && !d.current && (a.onPointerGraceIntentChange(null), d.current = window.setTimeout(() => {
              r.onOpenChange(!0), c();
            }, 100));
          })
        ),
        onPointerLeave: ne(
          e.onPointerLeave,
          xa((l) => {
            var p, h;
            c();
            const m = (p = r.content) == null ? void 0 : p.getBoundingClientRect();
            if (m) {
              const f = (h = r.content) == null ? void 0 : h.dataset.side, $ = f === "right", v = $ ? -5 : 5, y = m[$ ? "left" : "right"], S = m[$ ? "right" : "left"];
              a.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: l.clientX + v, y: l.clientY },
                  { x: y, y: m.top },
                  { x: S, y: m.top },
                  { x: S, y: m.bottom },
                  { x: y, y: m.bottom }
                ],
                side: f
              }), window.clearTimeout(i.current), i.current = window.setTimeout(
                () => a.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (a.onTriggerLeave(l), l.defaultPrevented) return;
              a.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: ne(e.onKeyDown, (l) => {
          var p;
          const h = a.searchRef.current !== "";
          e.disabled || h && l.key === " " || zJ[n.dir].includes(l.key) && (r.onOpenChange(!0), (p = r.content) == null || p.focus(), l.preventDefault());
        })
      }
    ) });
  }
);
WE.displayName = sa;
var zE = "MenuSubContent", YE = x.forwardRef(
  (e, t) => {
    const r = PE(Lt, e.__scopeMenu), { forceMount: n = r.forceMount, ...o } = e, a = An(Lt, e.__scopeMenu), d = Ga(Lt, e.__scopeMenu), i = KE(zE, e.__scopeMenu), s = x.useRef(null), u = Oe(t, s);
    return /* @__PURE__ */ A(ba.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ A(St, { present: n || a.open, children: /* @__PURE__ */ A(ba.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ A(
      Y2,
      {
        id: i.contentId,
        "aria-labelledby": i.triggerId,
        ...o,
        ref: u,
        align: "start",
        side: d.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (c) => {
          var l;
          d.isUsingKeyboardRef.current && ((l = s.current) == null || l.focus()), c.preventDefault();
        },
        onCloseAutoFocus: (c) => c.preventDefault(),
        onFocusOutside: ne(e.onFocusOutside, (c) => {
          c.target !== i.trigger && a.onOpenChange(!1);
        }),
        onEscapeKeyDown: ne(e.onEscapeKeyDown, (c) => {
          d.onClose(), c.preventDefault();
        }),
        onKeyDown: ne(e.onKeyDown, (c) => {
          var l;
          const p = c.currentTarget.contains(c.target), h = YJ[d.dir].includes(c.key);
          p && h && (a.onOpenChange(!1), (l = i.trigger) == null || l.focus(), c.preventDefault());
        })
      }
    ) }) }) });
  }
);
YE.displayName = zE;
function XE(e) {
  return e ? "open" : "closed";
}
function Wd(e) {
  return e === "indeterminate";
}
function J2(e) {
  return Wd(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function pQ(e) {
  const t = document.activeElement;
  for (const r of e)
    if (r === t || (r.focus(), document.activeElement !== t)) return;
}
function $Q(e, t) {
  return e.map((r, n) => e[(t + n) % e.length]);
}
function vQ(e, t, r) {
  const n = t.length > 1 && Array.from(t).every((i) => i === t[0]) ? t[0] : t, o = r ? e.indexOf(r) : -1;
  let a = $Q(e, Math.max(o, 0));
  n.length === 1 && (a = a.filter((i) => i !== r));
  const d = a.find(
    (i) => i.toLowerCase().startsWith(n.toLowerCase())
  );
  return d !== r ? d : void 0;
}
function mQ(e, t) {
  const { x: r, y: n } = e;
  let o = !1;
  for (let a = 0, d = t.length - 1; a < t.length; d = a++) {
    const i = t[a], s = t[d], u = i.x, c = i.y, l = s.x, p = s.y;
    c > n != p > n && r < (l - u) * (n - c) / (p - c) + u && (o = !o);
  }
  return o;
}
function hQ(e, t) {
  if (!t) return !1;
  const r = { x: e.clientX, y: e.clientY };
  return mQ(r, t);
}
function xa(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var gQ = K2, yQ = RE, bQ = TE, xQ = X2, wQ = DE, AQ = Ri, SQ = FE, _Q = jE, EQ = ZE, MQ = GE, CQ = VE, OQ = HE, NQ = WE, IQ = YE, qE = "DropdownMenu", [PQ, Qne] = At(
  qE,
  [NE]
), _t = NE(), [eoe, JE] = PQ(qE), QE = "DropdownMenuTrigger", RQ = x.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: r, disabled: n = !1, ...o } = e, a = JE(QE, r), d = _t(r);
    return /* @__PURE__ */ A(gQ, { asChild: !0, ...d, children: /* @__PURE__ */ A(
      ge.button,
      {
        type: "button",
        id: a.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": a.open,
        "aria-controls": a.open ? a.contentId : void 0,
        "data-state": a.open ? "open" : "closed",
        "data-disabled": n ? "" : void 0,
        disabled: n,
        ...o,
        ref: ui(t, a.triggerRef),
        onPointerDown: ne(e.onPointerDown, (i) => {
          !n && i.button === 0 && i.ctrlKey === !1 && (a.onOpenToggle(), a.open || i.preventDefault());
        }),
        onKeyDown: ne(e.onKeyDown, (i) => {
          n || (["Enter", " "].includes(i.key) && a.onOpenToggle(), i.key === "ArrowDown" && a.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(i.key) && i.preventDefault());
        })
      }
    ) });
  }
);
RQ.displayName = QE;
var TQ = "DropdownMenuPortal", eM = (e) => {
  const { __scopeDropdownMenu: t, ...r } = e, n = _t(t);
  return /* @__PURE__ */ A(yQ, { ...n, ...r });
};
eM.displayName = TQ;
var tM = "DropdownMenuContent", rM = x.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: r, ...n } = e, o = JE(tM, r), a = _t(r), d = x.useRef(!1);
    return /* @__PURE__ */ A(
      bQ,
      {
        id: o.contentId,
        "aria-labelledby": o.triggerId,
        ...a,
        ...n,
        ref: t,
        onCloseAutoFocus: ne(e.onCloseAutoFocus, (i) => {
          var s;
          d.current || (s = o.triggerRef.current) == null || s.focus(), d.current = !1, i.preventDefault();
        }),
        onInteractOutside: ne(e.onInteractOutside, (i) => {
          const s = i.detail.originalEvent, u = s.button === 0 && s.ctrlKey === !0, c = s.button === 2 || u;
          (!o.modal || c) && (d.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
rM.displayName = tM;
var DQ = "DropdownMenuGroup", LQ = x.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: r, ...n } = e, o = _t(r);
    return /* @__PURE__ */ A(xQ, { ...o, ...n, ref: t });
  }
);
LQ.displayName = DQ;
var FQ = "DropdownMenuLabel", nM = x.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: r, ...n } = e, o = _t(r);
    return /* @__PURE__ */ A(wQ, { ...o, ...n, ref: t });
  }
);
nM.displayName = FQ;
var kQ = "DropdownMenuItem", oM = x.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: r, ...n } = e, o = _t(r);
    return /* @__PURE__ */ A(AQ, { ...o, ...n, ref: t });
  }
);
oM.displayName = kQ;
var jQ = "DropdownMenuCheckboxItem", aM = x.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, o = _t(r);
  return /* @__PURE__ */ A(SQ, { ...o, ...n, ref: t });
});
aM.displayName = jQ;
var BQ = "DropdownMenuRadioGroup", ZQ = x.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, o = _t(r);
  return /* @__PURE__ */ A(_Q, { ...o, ...n, ref: t });
});
ZQ.displayName = BQ;
var UQ = "DropdownMenuRadioItem", dM = x.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, o = _t(r);
  return /* @__PURE__ */ A(EQ, { ...o, ...n, ref: t });
});
dM.displayName = UQ;
var GQ = "DropdownMenuItemIndicator", iM = x.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, o = _t(r);
  return /* @__PURE__ */ A(MQ, { ...o, ...n, ref: t });
});
iM.displayName = GQ;
var VQ = "DropdownMenuSeparator", sM = x.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, o = _t(r);
  return /* @__PURE__ */ A(CQ, { ...o, ...n, ref: t });
});
sM.displayName = VQ;
var HQ = "DropdownMenuArrow", KQ = x.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: r, ...n } = e, o = _t(r);
    return /* @__PURE__ */ A(OQ, { ...o, ...n, ref: t });
  }
);
KQ.displayName = HQ;
var WQ = "DropdownMenuSubTrigger", uM = x.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, o = _t(r);
  return /* @__PURE__ */ A(NQ, { ...o, ...n, ref: t });
});
uM.displayName = WQ;
var zQ = "DropdownMenuSubContent", lM = x.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, o = _t(r);
  return /* @__PURE__ */ A(
    IQ,
    {
      ...o,
      ...n,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
lM.displayName = zQ;
var YQ = eM, cM = rM, fM = nM, pM = oM, $M = aM, vM = dM, mM = iM, hM = sM, gM = uM, yM = lM;
const XQ = X(({ className: e, inset: t, children: r, ...n }, o) => /* @__PURE__ */ ie(
  gM,
  {
    ref: o,
    className: q(
      "flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent data-[state=open]:bg-accent",
      t && "pl-8",
      e
    ),
    ...n,
    children: [
      r,
      /* @__PURE__ */ A(RB, { className: "ml-auto size-4" })
    ]
  }
));
XQ.displayName = gM.displayName;
const qQ = X(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  yM,
  {
    ref: r,
    className: q(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...t
  }
));
qQ.displayName = yM.displayName;
const JQ = X(({ className: e, sideOffset: t = 4, ...r }, n) => /* @__PURE__ */ A(YQ, { children: /* @__PURE__ */ A(
  cM,
  {
    ref: n,
    sideOffset: t,
    className: q(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...r
  }
) }));
JQ.displayName = cM.displayName;
const QQ = X(({ className: e, inset: t, ...r }, n) => /* @__PURE__ */ A(
  pM,
  {
    ref: n,
    className: q(
      "relative flex cursor-pointer select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      t && "pl-8",
      e
    ),
    ...r
  }
));
QQ.displayName = pM.displayName;
const eee = X(({ className: e, children: t, checked: r, ...n }, o) => /* @__PURE__ */ ie(
  $M,
  {
    ref: o,
    className: q(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    checked: r,
    ...n,
    children: [
      /* @__PURE__ */ A("span", { className: "absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ A(mM, { children: /* @__PURE__ */ A(IB, { className: "size-4" }) }) }),
      t
    ]
  }
));
eee.displayName = $M.displayName;
const tee = X(({ className: e, children: t, ...r }, n) => /* @__PURE__ */ ie(
  vM,
  {
    ref: n,
    className: q(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...r,
    children: [
      /* @__PURE__ */ A("span", { className: "absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ A(mM, { children: /* @__PURE__ */ A(LB, { className: "size-4 fill-current" }) }) }),
      t
    ]
  }
));
tee.displayName = vM.displayName;
const ree = X(({ className: e, inset: t, ...r }, n) => /* @__PURE__ */ A(
  fM,
  {
    ref: n,
    className: q("px-2 py-1.5 text-sm font-semibold", t && "pl-8", e),
    ...r
  }
));
ree.displayName = fM.displayName;
const nee = X(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  hM,
  {
    ref: r,
    className: q("-mx-1 my-1 h-px bg-muted", e),
    ...t
  }
));
nee.displayName = hM.displayName;
var Cc, bM = "HoverCard", [xM, toe] = At(bM, [
  qr
]), Q2 = qr(), [roe, ef] = xM(bM), wM = "HoverCardTrigger", oee = x.forwardRef(
  (e, t) => {
    const { __scopeHoverCard: r, ...n } = e, o = ef(wM, r), a = Q2(r);
    return /* @__PURE__ */ A(Za, { asChild: !0, ...a, children: /* @__PURE__ */ A(
      ge.a,
      {
        "data-state": o.open ? "open" : "closed",
        ...n,
        ref: t,
        onPointerEnter: ne(e.onPointerEnter, Yd(o.onOpen)),
        onPointerLeave: ne(e.onPointerLeave, Yd(o.onClose)),
        onFocus: ne(e.onFocus, o.onOpen),
        onBlur: ne(e.onBlur, o.onClose),
        onTouchStart: ne(e.onTouchStart, (d) => d.preventDefault())
      }
    ) });
  }
);
oee.displayName = wM;
var aee = "HoverCardPortal", [noe, dee] = xM(aee, {
  forceMount: void 0
}), zd = "HoverCardContent", AM = x.forwardRef(
  (e, t) => {
    const r = dee(zd, e.__scopeHoverCard), { forceMount: n = r.forceMount, ...o } = e, a = ef(zd, e.__scopeHoverCard);
    return /* @__PURE__ */ A(St, { present: n || a.open, children: /* @__PURE__ */ A(
      iee,
      {
        "data-state": a.open ? "open" : "closed",
        ...o,
        onPointerEnter: ne(e.onPointerEnter, Yd(a.onOpen)),
        onPointerLeave: ne(e.onPointerLeave, Yd(a.onClose)),
        ref: t
      }
    ) });
  }
);
AM.displayName = zd;
var iee = x.forwardRef((e, t) => {
  const {
    __scopeHoverCard: r,
    onEscapeKeyDown: n,
    onPointerDownOutside: o,
    onFocusOutside: a,
    onInteractOutside: d,
    ...i
  } = e, s = ef(zd, r), u = Q2(r), c = x.useRef(null), l = Oe(t, c), [p, h] = x.useState(!1);
  return x.useEffect(() => {
    if (p) {
      const m = document.body;
      return Cc = m.style.userSelect || m.style.webkitUserSelect, m.style.userSelect = "none", m.style.webkitUserSelect = "none", () => {
        m.style.userSelect = Cc, m.style.webkitUserSelect = Cc;
      };
    }
  }, [p]), x.useEffect(() => {
    if (c.current) {
      const m = () => {
        h(!1), s.isPointerDownOnContentRef.current = !1, setTimeout(() => {
          var f;
          ((f = document.getSelection()) == null ? void 0 : f.toString()) !== "" && (s.hasSelectionRef.current = !0);
        });
      };
      return document.addEventListener("pointerup", m), () => {
        document.removeEventListener("pointerup", m), s.hasSelectionRef.current = !1, s.isPointerDownOnContentRef.current = !1;
      };
    }
  }, [s.isPointerDownOnContentRef, s.hasSelectionRef]), x.useEffect(() => {
    c.current && lee(c.current).forEach((m) => m.setAttribute("tabindex", "-1"));
  }), /* @__PURE__ */ A(
    xn,
    {
      asChild: !0,
      disableOutsidePointerEvents: !1,
      onInteractOutside: d,
      onEscapeKeyDown: n,
      onPointerDownOutside: o,
      onFocusOutside: ne(a, (m) => {
        m.preventDefault();
      }),
      onDismiss: s.onDismiss,
      children: /* @__PURE__ */ A(
        Ci,
        {
          ...u,
          ...i,
          onPointerDown: ne(i.onPointerDown, (m) => {
            m.currentTarget.contains(m.target) && h(!0), s.hasSelectionRef.current = !1, s.isPointerDownOnContentRef.current = !0;
          }),
          ref: l,
          style: {
            ...i.style,
            userSelect: p ? "text" : void 0,
            // Safari requires prefix
            WebkitUserSelect: p ? "text" : void 0,
            "--radix-hover-card-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-hover-card-content-available-width": "var(--radix-popper-available-width)",
            "--radix-hover-card-content-available-height": "var(--radix-popper-available-height)",
            "--radix-hover-card-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-hover-card-trigger-height": "var(--radix-popper-anchor-height)"
          }
        }
      )
    }
  );
}), see = "HoverCardArrow", uee = x.forwardRef(
  (e, t) => {
    const { __scopeHoverCard: r, ...n } = e, o = Q2(r);
    return /* @__PURE__ */ A(Oi, { ...o, ...n, ref: t });
  }
);
uee.displayName = see;
function Yd(e) {
  return (t) => t.pointerType === "touch" ? void 0 : e();
}
function lee(e) {
  const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP
  });
  for (; r.nextNode(); ) t.push(r.currentNode);
  return t;
}
var SM = AM;
const cee = x.forwardRef(({ className: e, align: t = "center", sideOffset: r = 4, ...n }, o) => /* @__PURE__ */ A(
  SM,
  {
    ref: o,
    align: t,
    sideOffset: r,
    className: q(
      "z-50 w-64 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-hover-card-content-transform-origin]",
      e
    ),
    ...n
  }
));
cee.displayName = SM.displayName;
const gr = X(({ className: e, type: t, ...r }, n) => /* @__PURE__ */ A(
  "input",
  {
    type: t,
    className: q(
      "focus-visible:outline-0 ring-ring/80 ring-1 ring-inset focus:ring-ring focus:ring-2 focus:ring-inset flex h-9 w-full rounded-md border-0 border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
      e
    ),
    ref: n,
    ...r
  }
));
gr.displayName = "Input";
var fee = "Label", _M = x.forwardRef((e, t) => /* @__PURE__ */ A(
  ge.label,
  {
    ...e,
    ref: t,
    onMouseDown: (r) => {
      var n;
      r.target.closest("button, input, select, textarea") || ((n = e.onMouseDown) == null || n.call(e, r), !r.defaultPrevented && r.detail > 1 && r.preventDefault());
    }
  }
));
_M.displayName = fee;
var EM = _M;
const pee = jt(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
), MM = X(({ className: e, ...t }, r) => /* @__PURE__ */ A(EM, { ref: r, className: q(pee(), e), ...t }));
MM.displayName = EM.displayName;
const P7 = jt(
  "inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "size-10"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), $ee = X(
  ({ className: e, variant: t, size: r, asChild: n = !1, loading: o, children: a, ...d }, i) => n ? /* @__PURE__ */ A(To, { ref: i, ...d, children: /* @__PURE__ */ A(Ge, { children: bo.map(a, (s) => {
    if (!Ae.isValidElement(s)) return null;
    const u = s;
    return C1(u, {
      className: q(P7({ variant: t, size: r }), e),
      children: /* @__PURE__ */ ie(Ge, { children: [
        o && /* @__PURE__ */ A(Rc, { className: q("h-4 w-4 animate-spin", a && "mr-2") }),
        u.props.children
      ] })
    });
  }) }) }) : /* @__PURE__ */ ie(
    "button",
    {
      className: q(P7({ variant: t, size: r, className: e })),
      disabled: o,
      ref: i,
      ...d,
      children: [
        o && /* @__PURE__ */ A(Rc, { className: q("h-4 w-4 animate-spin", a && "mr-2") }),
        a
      ]
    }
  )
);
$ee.displayName = "LoadingButton";
function vr(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(n) {
    if (e == null || e(n), r === !1 || !n.defaultPrevented)
      return t == null ? void 0 : t(n);
  };
}
function CM(e, t = []) {
  let r = [];
  function n(a, d) {
    const i = x.createContext(d), s = r.length;
    r = [...r, d];
    const u = (l) => {
      var p;
      const { scope: h, children: m, ...f } = l, $ = ((p = h == null ? void 0 : h[e]) == null ? void 0 : p[s]) || i, v = x.useMemo(() => f, Object.values(f));
      return /* @__PURE__ */ A($.Provider, { value: v, children: m });
    };
    u.displayName = a + "Provider";
    function c(l, p) {
      var h;
      const m = ((h = p == null ? void 0 : p[e]) == null ? void 0 : h[s]) || i, f = x.useContext(m);
      if (f) return f;
      if (d !== void 0) return d;
      throw new Error(`\`${l}\` must be used within \`${a}\``);
    }
    return [u, c];
  }
  const o = () => {
    const a = r.map((d) => x.createContext(d));
    return function(d) {
      const i = (d == null ? void 0 : d[e]) || a;
      return x.useMemo(
        () => ({ [`__scope${e}`]: { ...d, [e]: i } }),
        [d, i]
      );
    };
  };
  return o.scopeName = e, [n, vee(o, ...t)];
}
function vee(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(o) {
      const a = n.reduce((d, { useScope: i, scopeName: s }) => {
        const u = i(o)[`__scope${s}`];
        return { ...d, ...u };
      }, {});
      return x.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
var mee = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Sn = mee.reduce((e, t) => {
  const r = x.forwardRef((n, o) => {
    const { asChild: a, ...d } = n, i = a ? To : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ A(i, { ...d, ref: o });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function hee(e, t) {
  e && Oo.flushSync(() => e.dispatchEvent(t));
}
function Ti(e) {
  const t = x.useRef(e);
  return x.useEffect(() => {
    t.current = e;
  }), x.useMemo(() => (...r) => {
    var n;
    return (n = t.current) == null ? void 0 : n.call(t, ...r);
  }, []);
}
function gee(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = Ti(e);
  x.useEffect(() => {
    const n = (o) => {
      o.key === "Escape" && r(o);
    };
    return t.addEventListener("keydown", n, { capture: !0 }), () => t.removeEventListener("keydown", n, { capture: !0 });
  }, [r, t]);
}
var yee = "DismissableLayer", g1 = "dismissableLayer.update", bee = "dismissableLayer.pointerDownOutside", xee = "dismissableLayer.focusOutside", R7, OM = x.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), NM = x.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: r = !1,
      onEscapeKeyDown: n,
      onPointerDownOutside: o,
      onFocusOutside: a,
      onInteractOutside: d,
      onDismiss: i,
      ...s
    } = e, u = x.useContext(OM), [c, l] = x.useState(null), p = (c == null ? void 0 : c.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, h] = x.useState({}), m = bn(t, (N) => l(N)), f = Array.from(u.layers), [$] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), v = f.indexOf($), y = c ? f.indexOf(c) : -1, S = u.layersWithOutsidePointerEventsDisabled.size > 0, w = y >= v, _ = See((N) => {
      const O = N.target, E = [...u.branches].some((C) => C.contains(O));
      !w || E || (o == null || o(N), d == null || d(N), N.defaultPrevented || i == null || i());
    }, p), I = _ee((N) => {
      const O = N.target;
      [...u.branches].some((E) => E.contains(O)) || (a == null || a(N), d == null || d(N), N.defaultPrevented || i == null || i());
    }, p);
    return gee((N) => {
      y === u.layers.size - 1 && (n == null || n(N), !N.defaultPrevented && i && (N.preventDefault(), i()));
    }, p), x.useEffect(() => {
      if (c)
        return r && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (R7 = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(c)), u.layers.add(c), T7(), () => {
          r && u.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = R7);
        };
    }, [c, p, r, u]), x.useEffect(() => () => {
      c && (u.layers.delete(c), u.layersWithOutsidePointerEventsDisabled.delete(c), T7());
    }, [c, u]), x.useEffect(() => {
      const N = () => h({});
      return document.addEventListener(g1, N), () => document.removeEventListener(g1, N);
    }, []), /* @__PURE__ */ A(
      Sn.div,
      {
        ...s,
        ref: m,
        style: {
          pointerEvents: S ? w ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: vr(e.onFocusCapture, I.onFocusCapture),
        onBlurCapture: vr(e.onBlurCapture, I.onBlurCapture),
        onPointerDownCapture: vr(
          e.onPointerDownCapture,
          _.onPointerDownCapture
        )
      }
    );
  }
);
NM.displayName = yee;
var wee = "DismissableLayerBranch", Aee = x.forwardRef((e, t) => {
  const r = x.useContext(OM), n = x.useRef(null), o = bn(t, n);
  return x.useEffect(() => {
    const a = n.current;
    if (a)
      return r.branches.add(a), () => {
        r.branches.delete(a);
      };
  }, [r.branches]), /* @__PURE__ */ A(Sn.div, { ...e, ref: o });
});
Aee.displayName = wee;
function See(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = Ti(e), n = x.useRef(!1), o = x.useRef(() => {
  });
  return x.useEffect(() => {
    const a = (i) => {
      if (i.target && !n.current) {
        let s = function() {
          IM(
            bee,
            r,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: i };
        i.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = s, t.addEventListener("click", o.current, { once: !0 })) : s();
      } else
        t.removeEventListener("click", o.current);
      n.current = !1;
    }, d = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(d), t.removeEventListener("pointerdown", a), t.removeEventListener("click", o.current);
    };
  }, [t, r]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => n.current = !0
  };
}
function _ee(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = Ti(e), n = x.useRef(!1);
  return x.useEffect(() => {
    const o = (a) => {
      a.target && !n.current && IM(xee, r, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, r]), {
    onFocusCapture: () => n.current = !0,
    onBlurCapture: () => n.current = !1
  };
}
function T7() {
  const e = new CustomEvent(g1);
  document.dispatchEvent(e);
}
function IM(e, t, r, { discrete: n }) {
  const o = r.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: r });
  t && o.addEventListener(e, t, { once: !0 }), n ? hee(o, a) : o.dispatchEvent(a);
}
var wa = globalThis != null && globalThis.document ? x.useLayoutEffect : () => {
}, Eee = "Arrow", PM = x.forwardRef((e, t) => {
  const { children: r, width: n = 10, height: o = 5, ...a } = e;
  return /* @__PURE__ */ A(
    Sn.svg,
    {
      ...a,
      ref: t,
      width: n,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? r : /* @__PURE__ */ A("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
PM.displayName = Eee;
var Mee = PM;
function Cee(e) {
  const [t, r] = x.useState(void 0);
  return wa(() => {
    if (e) {
      r({ width: e.offsetWidth, height: e.offsetHeight });
      const n = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const a = o[0];
        let d, i;
        if ("borderBoxSize" in a) {
          const s = a.borderBoxSize, u = Array.isArray(s) ? s[0] : s;
          d = u.inlineSize, i = u.blockSize;
        } else
          d = e.offsetWidth, i = e.offsetHeight;
        r({ width: d, height: i });
      });
      return n.observe(e, { box: "border-box" }), () => n.unobserve(e);
    } else
      r(void 0);
  }, [e]), t;
}
var RM = "Popper", [TM, DM] = CM(RM), [ooe, LM] = TM(RM), FM = "PopperAnchor", kM = x.forwardRef(
  (e, t) => {
    const { __scopePopper: r, virtualRef: n, ...o } = e, a = LM(FM, r), d = x.useRef(null), i = bn(t, d);
    return x.useEffect(() => {
      a.onAnchorChange((n == null ? void 0 : n.current) || d.current);
    }), n ? null : /* @__PURE__ */ A(Sn.div, { ...o, ref: i });
  }
);
kM.displayName = FM;
var tf = "PopperContent", [Oee, Nee] = TM(tf), jM = x.forwardRef(
  (e, t) => {
    var r, n, o, a, d, i;
    const {
      __scopePopper: s,
      side: u = "bottom",
      sideOffset: c = 0,
      align: l = "center",
      alignOffset: p = 0,
      arrowPadding: h = 0,
      avoidCollisions: m = !0,
      collisionBoundary: f = [],
      collisionPadding: $ = 0,
      sticky: v = "partial",
      hideWhenDetached: y = !1,
      updatePositionStrategy: S = "optimized",
      onPlaced: w,
      ..._
    } = e, I = LM(tf, s), [N, O] = x.useState(null), E = bn(t, (he) => O(he)), [C, P] = x.useState(null), T = Cee(C), j = (T == null ? void 0 : T.width) ?? 0, F = (T == null ? void 0 : T.height) ?? 0, Z = u + (l !== "center" ? "-" + l : ""), te = typeof $ == "number" ? $ : { top: 0, right: 0, bottom: 0, left: 0, ...$ }, H = Array.isArray(f) ? f : [f], de = H.length > 0, G = {
      padding: te,
      boundary: H.filter(Pee),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: de
    }, { refs: le, floatingStyles: fe, placement: U, isPositioned: ae, middlewareData: ue } = W_({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: Z,
      whileElementsMounted: (...he) => H_(...he, {
        animationFrame: S === "always"
      }),
      elements: {
        reference: I.anchor
      },
      middleware: [
        z_({ mainAxis: c + F, alignmentAxis: p }),
        m && Y_({
          mainAxis: !0,
          crossAxis: !1,
          limiter: v === "partial" ? X_() : void 0,
          ...G
        }),
        m && q_({ ...G }),
        J_({
          ...G,
          apply: ({ elements: he, rects: Ee, availableWidth: ot, availableHeight: Ve }) => {
            const { width: Rt, height: g } = Ee.reference, b = he.floating.style;
            b.setProperty("--radix-popper-available-width", `${ot}px`), b.setProperty("--radix-popper-available-height", `${Ve}px`), b.setProperty("--radix-popper-anchor-width", `${Rt}px`), b.setProperty("--radix-popper-anchor-height", `${g}px`);
          }
        }),
        C && eE({ element: C, padding: h }),
        Ree({ arrowWidth: j, arrowHeight: F }),
        y && Q_({ strategy: "referenceHidden", ...G })
      ]
    }), [se, we] = UM(U), re = Ti(w);
    wa(() => {
      ae && (re == null || re());
    }, [ae, re]);
    const ye = (r = ue.arrow) == null ? void 0 : r.x, xe = (n = ue.arrow) == null ? void 0 : n.y, be = ((o = ue.arrow) == null ? void 0 : o.centerOffset) !== 0, [ee, ce] = x.useState();
    return wa(() => {
      N && ce(window.getComputedStyle(N).zIndex);
    }, [N]), /* @__PURE__ */ A(
      "div",
      {
        ref: le.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...fe,
          transform: ae ? fe.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: ee,
          "--radix-popper-transform-origin": [
            (a = ue.transformOrigin) == null ? void 0 : a.x,
            (d = ue.transformOrigin) == null ? void 0 : d.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((i = ue.hide) == null ? void 0 : i.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ A(
          Oee,
          {
            scope: s,
            placedSide: se,
            onArrowChange: P,
            arrowX: ye,
            arrowY: xe,
            shouldHideArrow: be,
            children: /* @__PURE__ */ A(
              Sn.div,
              {
                "data-side": se,
                "data-align": we,
                ..._,
                ref: E,
                style: {
                  ..._.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: ae ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
jM.displayName = tf;
var BM = "PopperArrow", Iee = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, ZM = x.forwardRef(function(e, t) {
  const { __scopePopper: r, ...n } = e, o = Nee(BM, r), a = Iee[o.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ A(
      "span",
      {
        ref: o.onArrowChange,
        style: {
          position: "absolute",
          left: o.arrowX,
          top: o.arrowY,
          [a]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[o.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[o.placedSide],
          visibility: o.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ A(
          Mee,
          {
            ...n,
            ref: t,
            style: {
              ...n.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
ZM.displayName = BM;
function Pee(e) {
  return e !== null;
}
var Ree = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var r, n, o;
    const { placement: a, rects: d, middlewareData: i } = t, s = ((r = i.arrow) == null ? void 0 : r.centerOffset) !== 0, u = s ? 0 : e.arrowWidth, c = s ? 0 : e.arrowHeight, [l, p] = UM(a), h = { start: "0%", center: "50%", end: "100%" }[p], m = (((n = i.arrow) == null ? void 0 : n.x) ?? 0) + u / 2, f = (((o = i.arrow) == null ? void 0 : o.y) ?? 0) + c / 2;
    let $ = "", v = "";
    return l === "bottom" ? ($ = s ? h : `${m}px`, v = `${-c}px`) : l === "top" ? ($ = s ? h : `${m}px`, v = `${d.floating.height + c}px`) : l === "right" ? ($ = `${-c}px`, v = s ? h : `${f}px`) : l === "left" && ($ = `${d.floating.width + c}px`, v = s ? h : `${f}px`), { data: { x: $, y: v } };
  }
});
function UM(e) {
  const [t, r = "center"] = e.split("-");
  return [t, r];
}
var Tee = kM, Dee = jM, Lee = ZM;
function Fee(e, t) {
  return x.useReducer((r, n) => t[r][n] ?? r, e);
}
var GM = (e) => {
  const { present: t, children: r } = e, n = kee(t), o = typeof r == "function" ? r({ present: n.isPresent }) : x.Children.only(r), a = bn(n.ref, jee(o));
  return typeof r == "function" || n.isPresent ? x.cloneElement(o, { ref: a }) : null;
};
GM.displayName = "Presence";
function kee(e) {
  const [t, r] = x.useState(), n = x.useRef({}), o = x.useRef(e), a = x.useRef("none"), d = e ? "mounted" : "unmounted", [i, s] = Fee(d, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return x.useEffect(() => {
    const u = yd(n.current);
    a.current = i === "mounted" ? u : "none";
  }, [i]), wa(() => {
    const u = n.current, c = o.current;
    if (c !== e) {
      const l = a.current, p = yd(u);
      e ? s("MOUNT") : p === "none" || (u == null ? void 0 : u.display) === "none" ? s("UNMOUNT") : s(c && l !== p ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, s]), wa(() => {
    if (t) {
      let u;
      const c = t.ownerDocument.defaultView ?? window, l = (h) => {
        const m = yd(n.current).includes(h.animationName);
        if (h.target === t && m && (s("ANIMATION_END"), !o.current)) {
          const f = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = c.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = f);
          });
        }
      }, p = (h) => {
        h.target === t && (a.current = yd(n.current));
      };
      return t.addEventListener("animationstart", p), t.addEventListener("animationcancel", l), t.addEventListener("animationend", l), () => {
        c.clearTimeout(u), t.removeEventListener("animationstart", p), t.removeEventListener("animationcancel", l), t.removeEventListener("animationend", l);
      };
    } else
      s("ANIMATION_END");
  }, [t, s]), {
    isPresent: ["mounted", "unmountSuspended"].includes(i),
    ref: x.useCallback((u) => {
      u && (n.current = getComputedStyle(u)), r(u);
    }, [])
  };
}
function yd(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function jee(e) {
  var t, r;
  let n = (t = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : t.get, o = n && "isReactWarning" in n && n.isReactWarning;
  return o ? e.ref : (n = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, o = n && "isReactWarning" in n && n.isReactWarning, o ? e.props.ref : e.props.ref || e.ref);
}
var Bee = "VisuallyHidden", VM = x.forwardRef(
  (e, t) => /* @__PURE__ */ A(
    Sn.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
VM.displayName = Bee;
var Zee = VM, [Di, aoe] = CM("Tooltip", [
  DM
]), rf = DM(), Uee = "TooltipProvider", D7 = "tooltip.open", [doe, HM] = Di(Uee), KM = "Tooltip", [ioe, Li] = Di(KM), y1 = "TooltipTrigger", Gee = x.forwardRef(
  (e, t) => {
    const { __scopeTooltip: r, ...n } = e, o = Li(y1, r), a = HM(y1, r), d = rf(r), i = x.useRef(null), s = bn(t, i, o.onTriggerChange), u = x.useRef(!1), c = x.useRef(!1), l = x.useCallback(() => u.current = !1, []);
    return x.useEffect(() => () => document.removeEventListener("pointerup", l), [l]), /* @__PURE__ */ A(Tee, { asChild: !0, ...d, children: /* @__PURE__ */ A(
      Sn.button,
      {
        "aria-describedby": o.open ? o.contentId : void 0,
        "data-state": o.stateAttribute,
        ...n,
        ref: s,
        onPointerMove: vr(e.onPointerMove, (p) => {
          p.pointerType !== "touch" && !c.current && !a.isPointerInTransitRef.current && (o.onTriggerEnter(), c.current = !0);
        }),
        onPointerLeave: vr(e.onPointerLeave, () => {
          o.onTriggerLeave(), c.current = !1;
        }),
        onPointerDown: vr(e.onPointerDown, () => {
          u.current = !0, document.addEventListener("pointerup", l, { once: !0 });
        }),
        onFocus: vr(e.onFocus, () => {
          u.current || o.onOpen();
        }),
        onBlur: vr(e.onBlur, o.onClose),
        onClick: vr(e.onClick, o.onClose)
      }
    ) });
  }
);
Gee.displayName = y1;
var Vee = "TooltipPortal", [soe, Hee] = Di(Vee, {
  forceMount: void 0
}), Mo = "TooltipContent", WM = x.forwardRef(
  (e, t) => {
    const r = Hee(Mo, e.__scopeTooltip), { forceMount: n = r.forceMount, side: o = "top", ...a } = e, d = Li(Mo, e.__scopeTooltip);
    return /* @__PURE__ */ A(GM, { present: n || d.open, children: d.disableHoverableContent ? /* @__PURE__ */ A(zM, { side: o, ...a, ref: t }) : /* @__PURE__ */ A(Kee, { side: o, ...a, ref: t }) });
  }
), Kee = x.forwardRef((e, t) => {
  const r = Li(Mo, e.__scopeTooltip), n = HM(Mo, e.__scopeTooltip), o = x.useRef(null), a = bn(t, o), [d, i] = x.useState(null), { trigger: s, onClose: u } = r, c = o.current, { onPointerInTransitChange: l } = n, p = x.useCallback(() => {
    i(null), l(!1);
  }, [l]), h = x.useCallback(
    (m, f) => {
      const $ = m.currentTarget, v = { x: m.clientX, y: m.clientY }, y = Xee(v, $.getBoundingClientRect()), S = qee(v, y), w = Jee(f.getBoundingClientRect()), _ = ete([...S, ...w]);
      i(_), l(!0);
    },
    [l]
  );
  return x.useEffect(() => () => p(), [p]), x.useEffect(() => {
    if (s && c) {
      const m = ($) => h($, c), f = ($) => h($, s);
      return s.addEventListener("pointerleave", m), c.addEventListener("pointerleave", f), () => {
        s.removeEventListener("pointerleave", m), c.removeEventListener("pointerleave", f);
      };
    }
  }, [s, c, h, p]), x.useEffect(() => {
    if (d) {
      const m = (f) => {
        const $ = f.target, v = { x: f.clientX, y: f.clientY }, y = (s == null ? void 0 : s.contains($)) || (c == null ? void 0 : c.contains($)), S = !Qee(v, d);
        y ? p() : S && (p(), u());
      };
      return document.addEventListener("pointermove", m), () => document.removeEventListener("pointermove", m);
    }
  }, [s, c, d, u, p]), /* @__PURE__ */ A(zM, { ...e, ref: a });
}), [Wee, zee] = Di(KM, { isInside: !1 }), zM = x.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: r,
      children: n,
      "aria-label": o,
      onEscapeKeyDown: a,
      onPointerDownOutside: d,
      ...i
    } = e, s = Li(Mo, r), u = rf(r), { onClose: c } = s;
    return x.useEffect(() => (document.addEventListener(D7, c), () => document.removeEventListener(D7, c)), [c]), x.useEffect(() => {
      if (s.trigger) {
        const l = (p) => {
          const h = p.target;
          h != null && h.contains(s.trigger) && c();
        };
        return window.addEventListener("scroll", l, { capture: !0 }), () => window.removeEventListener("scroll", l, { capture: !0 });
      }
    }, [s.trigger, c]), /* @__PURE__ */ A(
      NM,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: a,
        onPointerDownOutside: d,
        onFocusOutside: (l) => l.preventDefault(),
        onDismiss: c,
        children: /* @__PURE__ */ ie(
          Dee,
          {
            "data-state": s.stateAttribute,
            ...u,
            ...i,
            ref: t,
            style: {
              ...i.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ A(Gg, { children: n }),
              /* @__PURE__ */ A(Wee, { scope: r, isInside: !0, children: /* @__PURE__ */ A(Zee, { id: s.contentId, role: "tooltip", children: o || n }) })
            ]
          }
        )
      }
    );
  }
);
WM.displayName = Mo;
var YM = "TooltipArrow", Yee = x.forwardRef(
  (e, t) => {
    const { __scopeTooltip: r, ...n } = e, o = rf(r);
    return zee(
      YM,
      r
    ).isInside ? null : /* @__PURE__ */ A(Lee, { ...o, ...n, ref: t });
  }
);
Yee.displayName = YM;
function Xee(e, t) {
  const r = Math.abs(t.top - e.y), n = Math.abs(t.bottom - e.y), o = Math.abs(t.right - e.x), a = Math.abs(t.left - e.x);
  switch (Math.min(r, n, o, a)) {
    case a:
      return "left";
    case o:
      return "right";
    case r:
      return "top";
    case n:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function qee(e, t, r = 5) {
  const n = [];
  switch (t) {
    case "top":
      n.push(
        { x: e.x - r, y: e.y + r },
        { x: e.x + r, y: e.y + r }
      );
      break;
    case "bottom":
      n.push(
        { x: e.x - r, y: e.y - r },
        { x: e.x + r, y: e.y - r }
      );
      break;
    case "left":
      n.push(
        { x: e.x + r, y: e.y - r },
        { x: e.x + r, y: e.y + r }
      );
      break;
    case "right":
      n.push(
        { x: e.x - r, y: e.y - r },
        { x: e.x - r, y: e.y + r }
      );
      break;
  }
  return n;
}
function Jee(e) {
  const { top: t, right: r, bottom: n, left: o } = e;
  return [
    { x: o, y: t },
    { x: r, y: t },
    { x: r, y: n },
    { x: o, y: n }
  ];
}
function Qee(e, t) {
  const { x: r, y: n } = e;
  let o = !1;
  for (let a = 0, d = t.length - 1; a < t.length; d = a++) {
    const i = t[a].x, s = t[a].y, u = t[d].x, c = t[d].y;
    s > n != c > n && r < (u - i) * (n - s) / (c - s) + i && (o = !o);
  }
  return o;
}
function ete(e) {
  const t = e.slice();
  return t.sort((r, n) => r.x < n.x ? -1 : r.x > n.x ? 1 : r.y < n.y ? -1 : r.y > n.y ? 1 : 0), tte(t);
}
function tte(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let n = 0; n < e.length; n++) {
    const o = e[n];
    for (; t.length >= 2; ) {
      const a = t[t.length - 1], d = t[t.length - 2];
      if ((a.x - d.x) * (o.y - d.y) >= (a.y - d.y) * (o.x - d.x)) t.pop();
      else break;
    }
    t.push(o);
  }
  t.pop();
  const r = [];
  for (let n = e.length - 1; n >= 0; n--) {
    const o = e[n];
    for (; r.length >= 2; ) {
      const a = r[r.length - 1], d = r[r.length - 2];
      if ((a.x - d.x) * (o.y - d.y) >= (a.y - d.y) * (o.x - d.x)) r.pop();
      else break;
    }
    r.push(o);
  }
  return r.pop(), t.length === 1 && r.length === 1 && t[0].x === r[0].x && t[0].y === r[0].y ? t : t.concat(r);
}
var XM = WM;
const rte = X(({ className: e, sideOffset: t = 4, ...r }, n) => /* @__PURE__ */ A(
  XM,
  {
    ref: n,
    sideOffset: t,
    className: q(
      "z-50 overflow-hidden rounded-md bg-primary px-3 py-1.5 text-xs text-primary-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...r
  }
));
rte.displayName = XM.displayName;
/**
 * @license lucide-react v0.508.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nte = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], qM = Wr("chevron-down", nte);
/**
 * @license lucide-react v0.508.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ote = [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]], ate = Wr("chevron-up", ote);
function L7(e, [t, r]) {
  return Math.min(r, Math.max(t, e));
}
var dte = [" ", "Enter", "ArrowUp", "ArrowDown"], ite = [" ", "Enter"], Fi = "Select", [nf, ki, ste] = wi(Fi), [Bo, uoe] = At(Fi, [
  ste,
  qr
]), of = qr(), [loe, Qr] = Bo(Fi), [coe, ute] = Bo(Fi), JM = "SelectTrigger", QM = x.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, disabled: n = !1, ...o } = e, a = of(r), d = Qr(JM, r), i = d.disabled || n, s = Oe(t, d.onTriggerChange), u = ki(r), c = x.useRef("touch"), [l, p, h] = xC((f) => {
      const $ = u().filter((S) => !S.disabled), v = $.find((S) => S.value === d.value), y = wC($, f, v);
      y !== void 0 && d.onValueChange(y.value);
    }), m = (f) => {
      i || (d.onOpenChange(!0), h()), f && (d.triggerPointerDownPosRef.current = {
        x: Math.round(f.pageX),
        y: Math.round(f.pageY)
      });
    };
    return /* @__PURE__ */ A(Za, { asChild: !0, ...a, children: /* @__PURE__ */ A(
      ge.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": d.contentId,
        "aria-expanded": d.open,
        "aria-required": d.required,
        "aria-autocomplete": "none",
        dir: d.dir,
        "data-state": d.open ? "open" : "closed",
        disabled: i,
        "data-disabled": i ? "" : void 0,
        "data-placeholder": bC(d.value) ? "" : void 0,
        ...o,
        ref: s,
        onClick: ne(o.onClick, (f) => {
          f.currentTarget.focus(), c.current !== "mouse" && m(f);
        }),
        onPointerDown: ne(o.onPointerDown, (f) => {
          c.current = f.pointerType;
          const $ = f.target;
          $.hasPointerCapture(f.pointerId) && $.releasePointerCapture(f.pointerId), f.button === 0 && f.ctrlKey === !1 && f.pointerType === "mouse" && (m(f), f.preventDefault());
        }),
        onKeyDown: ne(o.onKeyDown, (f) => {
          const $ = l.current !== "";
          !(f.ctrlKey || f.altKey || f.metaKey) && f.key.length === 1 && p(f.key), !($ && f.key === " ") && dte.includes(f.key) && (m(), f.preventDefault());
        })
      }
    ) });
  }
);
QM.displayName = JM;
var eC = "SelectValue", lte = x.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, className: n, style: o, children: a, placeholder: d = "", ...i } = e, s = Qr(eC, r), { onValueNodeHasChildrenChange: u } = s, c = a !== void 0, l = Oe(t, s.onValueNodeChange);
    return et(() => {
      u(c);
    }, [u, c]), /* @__PURE__ */ A(
      ge.span,
      {
        ...i,
        ref: l,
        style: { pointerEvents: "none" },
        children: bC(s.value) ? /* @__PURE__ */ A(Ge, { children: d }) : a
      }
    );
  }
);
lte.displayName = eC;
var cte = "SelectIcon", tC = x.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, children: n, ...o } = e;
    return /* @__PURE__ */ A(ge.span, { "aria-hidden": !0, ...o, ref: t, children: n || "▼" });
  }
);
tC.displayName = cte;
var fte = "SelectPortal", rC = (e) => /* @__PURE__ */ A(Lo, { asChild: !0, ...e });
rC.displayName = fte;
var yn = "SelectContent", nC = x.forwardRef(
  (e, t) => {
    const r = Qr(yn, e.__scopeSelect), [n, o] = x.useState();
    if (et(() => {
      o(new DocumentFragment());
    }, []), !r.open) {
      const a = n;
      return a ? Oo.createPortal(
        /* @__PURE__ */ A(oC, { scope: e.__scopeSelect, children: /* @__PURE__ */ A(nf.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ A("div", { children: e.children }) }) }),
        a
      ) : null;
    }
    return /* @__PURE__ */ A(aC, { ...e, ref: t });
  }
);
nC.displayName = yn;
var Ht = 10, [oC, en] = Bo(yn), pte = "SelectContentImpl", $te = /* @__PURE__ */ $n("SelectContent.RemoveScroll"), aC = x.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: r,
      position: n = "item-aligned",
      onCloseAutoFocus: o,
      onEscapeKeyDown: a,
      onPointerDownOutside: d,
      //
      // PopperContent props
      side: i,
      sideOffset: s,
      align: u,
      alignOffset: c,
      arrowPadding: l,
      collisionBoundary: p,
      collisionPadding: h,
      sticky: m,
      hideWhenDetached: f,
      avoidCollisions: $,
      //
      ...v
    } = e, y = Qr(yn, r), [S, w] = x.useState(null), [_, I] = x.useState(null), N = Oe(t, (re) => w(re)), [O, E] = x.useState(null), [C, P] = x.useState(
      null
    ), T = ki(r), [j, F] = x.useState(!1), Z = x.useRef(!1);
    x.useEffect(() => {
      if (S) return fi(S);
    }, [S]), li();
    const te = x.useCallback(
      (re) => {
        const [ye, ...xe] = T().map((ce) => ce.ref.current), [be] = xe.slice(-1), ee = document.activeElement;
        for (const ce of re)
          if (ce === ee || (ce == null || ce.scrollIntoView({ block: "nearest" }), ce === ye && _ && (_.scrollTop = 0), ce === be && _ && (_.scrollTop = _.scrollHeight), ce == null || ce.focus(), document.activeElement !== ee)) return;
      },
      [T, _]
    ), H = x.useCallback(
      () => te([O, S]),
      [te, O, S]
    );
    x.useEffect(() => {
      j && H();
    }, [j, H]);
    const { onOpenChange: de, triggerPointerDownPosRef: G } = y;
    x.useEffect(() => {
      if (S) {
        let re = { x: 0, y: 0 };
        const ye = (be) => {
          var ee, ce;
          re = {
            x: Math.abs(Math.round(be.pageX) - (((ee = G.current) == null ? void 0 : ee.x) ?? 0)),
            y: Math.abs(Math.round(be.pageY) - (((ce = G.current) == null ? void 0 : ce.y) ?? 0))
          };
        }, xe = (be) => {
          re.x <= 10 && re.y <= 10 ? be.preventDefault() : S.contains(be.target) || de(!1), document.removeEventListener("pointermove", ye), G.current = null;
        };
        return G.current !== null && (document.addEventListener("pointermove", ye), document.addEventListener("pointerup", xe, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", ye), document.removeEventListener("pointerup", xe, { capture: !0 });
        };
      }
    }, [S, de, G]), x.useEffect(() => {
      const re = () => de(!1);
      return window.addEventListener("blur", re), window.addEventListener("resize", re), () => {
        window.removeEventListener("blur", re), window.removeEventListener("resize", re);
      };
    }, [de]);
    const [le, fe] = xC((re) => {
      const ye = T().filter((ee) => !ee.disabled), xe = ye.find((ee) => ee.ref.current === document.activeElement), be = wC(ye, re, xe);
      be && setTimeout(() => be.ref.current.focus());
    }), U = x.useCallback(
      (re, ye, xe) => {
        const be = !Z.current && !xe;
        (y.value !== void 0 && y.value === ye || be) && (E(re), be && (Z.current = !0));
      },
      [y.value]
    ), ae = x.useCallback(() => S == null ? void 0 : S.focus(), [S]), ue = x.useCallback(
      (re, ye, xe) => {
        const be = !Z.current && !xe;
        (y.value !== void 0 && y.value === ye || be) && P(re);
      },
      [y.value]
    ), se = n === "popper" ? b1 : dC, we = se === b1 ? {
      side: i,
      sideOffset: s,
      align: u,
      alignOffset: c,
      arrowPadding: l,
      collisionBoundary: p,
      collisionPadding: h,
      sticky: m,
      hideWhenDetached: f,
      avoidCollisions: $
    } : {};
    return /* @__PURE__ */ A(
      oC,
      {
        scope: r,
        content: S,
        viewport: _,
        onViewportChange: I,
        itemRefCallback: U,
        selectedItem: O,
        onItemLeave: ae,
        itemTextRefCallback: ue,
        focusSelectedItem: H,
        selectedItemText: C,
        position: n,
        isPositioned: j,
        searchRef: le,
        children: /* @__PURE__ */ A(Ra, { as: $te, allowPinchZoom: !0, children: /* @__PURE__ */ A(
          Pa,
          {
            asChild: !0,
            trapped: y.open,
            onMountAutoFocus: (re) => {
              re.preventDefault();
            },
            onUnmountAutoFocus: ne(o, (re) => {
              var ye;
              (ye = y.trigger) == null || ye.focus({ preventScroll: !0 }), re.preventDefault();
            }),
            children: /* @__PURE__ */ A(
              xn,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: a,
                onPointerDownOutside: d,
                onFocusOutside: (re) => re.preventDefault(),
                onDismiss: () => y.onOpenChange(!1),
                children: /* @__PURE__ */ A(
                  se,
                  {
                    role: "listbox",
                    id: y.contentId,
                    "data-state": y.open ? "open" : "closed",
                    dir: y.dir,
                    onContextMenu: (re) => re.preventDefault(),
                    ...v,
                    ...we,
                    onPlaced: () => F(!0),
                    ref: N,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...v.style
                    },
                    onKeyDown: ne(v.onKeyDown, (re) => {
                      const ye = re.ctrlKey || re.altKey || re.metaKey;
                      if (re.key === "Tab" && re.preventDefault(), !ye && re.key.length === 1 && fe(re.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(re.key)) {
                        let xe = T().filter((be) => !be.disabled).map((be) => be.ref.current);
                        if (["ArrowUp", "End"].includes(re.key) && (xe = xe.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(re.key)) {
                          const be = re.target, ee = xe.indexOf(be);
                          xe = xe.slice(ee + 1);
                        }
                        setTimeout(() => te(xe)), re.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
aC.displayName = pte;
var vte = "SelectItemAlignedPosition", dC = x.forwardRef((e, t) => {
  const { __scopeSelect: r, onPlaced: n, ...o } = e, a = Qr(yn, r), d = en(yn, r), [i, s] = x.useState(null), [u, c] = x.useState(null), l = Oe(t, (N) => c(N)), p = ki(r), h = x.useRef(!1), m = x.useRef(!0), { viewport: f, selectedItem: $, selectedItemText: v, focusSelectedItem: y } = d, S = x.useCallback(() => {
    if (a.trigger && a.valueNode && i && u && f && $ && v) {
      const N = a.trigger.getBoundingClientRect(), O = u.getBoundingClientRect(), E = a.valueNode.getBoundingClientRect(), C = v.getBoundingClientRect();
      if (a.dir !== "rtl") {
        const be = C.left - O.left, ee = E.left - be, ce = N.left - ee, he = N.width + ce, Ee = Math.max(he, O.width), ot = window.innerWidth - Ht, Ve = L7(ee, [
          Ht,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(Ht, ot - Ee)
        ]);
        i.style.minWidth = he + "px", i.style.left = Ve + "px";
      } else {
        const be = O.right - C.right, ee = window.innerWidth - E.right - be, ce = window.innerWidth - N.right - ee, he = N.width + ce, Ee = Math.max(he, O.width), ot = window.innerWidth - Ht, Ve = L7(ee, [
          Ht,
          Math.max(Ht, ot - Ee)
        ]);
        i.style.minWidth = he + "px", i.style.right = Ve + "px";
      }
      const P = p(), T = window.innerHeight - Ht * 2, j = f.scrollHeight, F = window.getComputedStyle(u), Z = parseInt(F.borderTopWidth, 10), te = parseInt(F.paddingTop, 10), H = parseInt(F.borderBottomWidth, 10), de = parseInt(F.paddingBottom, 10), G = Z + te + j + de + H, le = Math.min($.offsetHeight * 5, G), fe = window.getComputedStyle(f), U = parseInt(fe.paddingTop, 10), ae = parseInt(fe.paddingBottom, 10), ue = N.top + N.height / 2 - Ht, se = T - ue, we = $.offsetHeight / 2, re = $.offsetTop + we, ye = Z + te + re, xe = G - ye;
      if (ye <= ue) {
        const be = P.length > 0 && $ === P[P.length - 1].ref.current;
        i.style.bottom = "0px";
        const ee = u.clientHeight - f.offsetTop - f.offsetHeight, ce = Math.max(
          se,
          we + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (be ? ae : 0) + ee + H
        ), he = ye + ce;
        i.style.height = he + "px";
      } else {
        const be = P.length > 0 && $ === P[0].ref.current;
        i.style.top = "0px";
        const ee = Math.max(
          ue,
          Z + f.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (be ? U : 0) + we
        ) + xe;
        i.style.height = ee + "px", f.scrollTop = ye - ue + f.offsetTop;
      }
      i.style.margin = `${Ht}px 0`, i.style.minHeight = le + "px", i.style.maxHeight = T + "px", n == null || n(), requestAnimationFrame(() => h.current = !0);
    }
  }, [
    p,
    a.trigger,
    a.valueNode,
    i,
    u,
    f,
    $,
    v,
    a.dir,
    n
  ]);
  et(() => S(), [S]);
  const [w, _] = x.useState();
  et(() => {
    u && _(window.getComputedStyle(u).zIndex);
  }, [u]);
  const I = x.useCallback(
    (N) => {
      N && m.current === !0 && (S(), y == null || y(), m.current = !1);
    },
    [S, y]
  );
  return /* @__PURE__ */ A(
    hte,
    {
      scope: r,
      contentWrapper: i,
      shouldExpandOnScrollRef: h,
      onScrollButtonChange: I,
      children: /* @__PURE__ */ A(
        "div",
        {
          ref: s,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: w
          },
          children: /* @__PURE__ */ A(
            ge.div,
            {
              ...o,
              ref: l,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...o.style
              }
            }
          )
        }
      )
    }
  );
});
dC.displayName = vte;
var mte = "SelectPopperPosition", b1 = x.forwardRef((e, t) => {
  const {
    __scopeSelect: r,
    align: n = "start",
    collisionPadding: o = Ht,
    ...a
  } = e, d = of(r);
  return /* @__PURE__ */ A(
    Ci,
    {
      ...d,
      ...a,
      ref: t,
      align: n,
      collisionPadding: o,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...a.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
b1.displayName = mte;
var [hte, af] = Bo(yn, {}), x1 = "SelectViewport", iC = x.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, nonce: n, ...o } = e, a = en(x1, r), d = af(x1, r), i = Oe(t, a.onViewportChange), s = x.useRef(0);
    return /* @__PURE__ */ ie(Ge, { children: [
      /* @__PURE__ */ A(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: n
        }
      ),
      /* @__PURE__ */ A(nf.Slot, { scope: r, children: /* @__PURE__ */ A(
        ge.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...o,
          ref: i,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...o.style
          },
          onScroll: ne(o.onScroll, (u) => {
            const c = u.currentTarget, { contentWrapper: l, shouldExpandOnScrollRef: p } = d;
            if (p != null && p.current && l) {
              const h = Math.abs(s.current - c.scrollTop);
              if (h > 0) {
                const m = window.innerHeight - Ht * 2, f = parseFloat(l.style.minHeight), $ = parseFloat(l.style.height), v = Math.max(f, $);
                if (v < m) {
                  const y = v + h, S = Math.min(m, y), w = y - S;
                  l.style.height = S + "px", l.style.bottom === "0px" && (c.scrollTop = w > 0 ? w : 0, l.style.justifyContent = "flex-end");
                }
              }
            }
            s.current = c.scrollTop;
          })
        }
      ) })
    ] });
  }
);
iC.displayName = x1;
var sC = "SelectGroup", [gte, yte] = Bo(sC), bte = x.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, ...n } = e, o = It();
    return /* @__PURE__ */ A(gte, { scope: r, id: o, children: /* @__PURE__ */ A(ge.div, { role: "group", "aria-labelledby": o, ...n, ref: t }) });
  }
);
bte.displayName = sC;
var uC = "SelectLabel", lC = x.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, ...n } = e, o = yte(uC, r);
    return /* @__PURE__ */ A(ge.div, { id: o.id, ...n, ref: t });
  }
);
lC.displayName = uC;
var Xd = "SelectItem", [xte, cC] = Bo(Xd), fC = x.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: r,
      value: n,
      disabled: o = !1,
      textValue: a,
      ...d
    } = e, i = Qr(Xd, r), s = en(Xd, r), u = i.value === n, [c, l] = x.useState(a ?? ""), [p, h] = x.useState(!1), m = Oe(
      t,
      (y) => {
        var S;
        return (S = s.itemRefCallback) == null ? void 0 : S.call(s, y, n, o);
      }
    ), f = It(), $ = x.useRef("touch"), v = () => {
      o || (i.onValueChange(n), i.onOpenChange(!1));
    };
    if (n === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ A(
      xte,
      {
        scope: r,
        value: n,
        disabled: o,
        textId: f,
        isSelected: u,
        onItemTextChange: x.useCallback((y) => {
          l((S) => S || ((y == null ? void 0 : y.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ A(
          nf.ItemSlot,
          {
            scope: r,
            value: n,
            disabled: o,
            textValue: c,
            children: /* @__PURE__ */ A(
              ge.div,
              {
                role: "option",
                "aria-labelledby": f,
                "data-highlighted": p ? "" : void 0,
                "aria-selected": u && p,
                "data-state": u ? "checked" : "unchecked",
                "aria-disabled": o || void 0,
                "data-disabled": o ? "" : void 0,
                tabIndex: o ? void 0 : -1,
                ...d,
                ref: m,
                onFocus: ne(d.onFocus, () => h(!0)),
                onBlur: ne(d.onBlur, () => h(!1)),
                onClick: ne(d.onClick, () => {
                  $.current !== "mouse" && v();
                }),
                onPointerUp: ne(d.onPointerUp, () => {
                  $.current === "mouse" && v();
                }),
                onPointerDown: ne(d.onPointerDown, (y) => {
                  $.current = y.pointerType;
                }),
                onPointerMove: ne(d.onPointerMove, (y) => {
                  var S;
                  $.current = y.pointerType, o ? (S = s.onItemLeave) == null || S.call(s) : $.current === "mouse" && y.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: ne(d.onPointerLeave, (y) => {
                  var S;
                  y.currentTarget === document.activeElement && ((S = s.onItemLeave) == null || S.call(s));
                }),
                onKeyDown: ne(d.onKeyDown, (y) => {
                  var S;
                  ((S = s.searchRef) == null ? void 0 : S.current) !== "" && y.key === " " || (ite.includes(y.key) && v(), y.key === " " && y.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
fC.displayName = Xd;
var ua = "SelectItemText", pC = x.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, className: n, style: o, ...a } = e, d = Qr(ua, r), i = en(ua, r), s = cC(ua, r), u = ute(ua, r), [c, l] = x.useState(null), p = Oe(
      t,
      (v) => l(v),
      s.onItemTextChange,
      (v) => {
        var y;
        return (y = i.itemTextRefCallback) == null ? void 0 : y.call(i, v, s.value, s.disabled);
      }
    ), h = c == null ? void 0 : c.textContent, m = x.useMemo(
      () => /* @__PURE__ */ A("option", { value: s.value, disabled: s.disabled, children: h }, s.value),
      [s.disabled, s.value, h]
    ), { onNativeOptionAdd: f, onNativeOptionRemove: $ } = u;
    return et(() => (f(m), () => $(m)), [f, $, m]), /* @__PURE__ */ ie(Ge, { children: [
      /* @__PURE__ */ A(ge.span, { id: s.textId, ...a, ref: p }),
      s.isSelected && d.valueNode && !d.valueNodeHasChildren ? Oo.createPortal(a.children, d.valueNode) : null
    ] });
  }
);
pC.displayName = ua;
var $C = "SelectItemIndicator", vC = x.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, ...n } = e;
    return cC($C, r).isSelected ? /* @__PURE__ */ A(ge.span, { "aria-hidden": !0, ...n, ref: t }) : null;
  }
);
vC.displayName = $C;
var w1 = "SelectScrollUpButton", mC = x.forwardRef((e, t) => {
  const r = en(w1, e.__scopeSelect), n = af(w1, e.__scopeSelect), [o, a] = x.useState(!1), d = Oe(t, n.onScrollButtonChange);
  return et(() => {
    if (r.viewport && r.isPositioned) {
      let i = function() {
        const u = s.scrollTop > 0;
        a(u);
      };
      const s = r.viewport;
      return i(), s.addEventListener("scroll", i), () => s.removeEventListener("scroll", i);
    }
  }, [r.viewport, r.isPositioned]), o ? /* @__PURE__ */ A(
    gC,
    {
      ...e,
      ref: d,
      onAutoScroll: () => {
        const { viewport: i, selectedItem: s } = r;
        i && s && (i.scrollTop = i.scrollTop - s.offsetHeight);
      }
    }
  ) : null;
});
mC.displayName = w1;
var A1 = "SelectScrollDownButton", hC = x.forwardRef((e, t) => {
  const r = en(A1, e.__scopeSelect), n = af(A1, e.__scopeSelect), [o, a] = x.useState(!1), d = Oe(t, n.onScrollButtonChange);
  return et(() => {
    if (r.viewport && r.isPositioned) {
      let i = function() {
        const u = s.scrollHeight - s.clientHeight, c = Math.ceil(s.scrollTop) < u;
        a(c);
      };
      const s = r.viewport;
      return i(), s.addEventListener("scroll", i), () => s.removeEventListener("scroll", i);
    }
  }, [r.viewport, r.isPositioned]), o ? /* @__PURE__ */ A(
    gC,
    {
      ...e,
      ref: d,
      onAutoScroll: () => {
        const { viewport: i, selectedItem: s } = r;
        i && s && (i.scrollTop = i.scrollTop + s.offsetHeight);
      }
    }
  ) : null;
});
hC.displayName = A1;
var gC = x.forwardRef((e, t) => {
  const { __scopeSelect: r, onAutoScroll: n, ...o } = e, a = en("SelectScrollButton", r), d = x.useRef(null), i = ki(r), s = x.useCallback(() => {
    d.current !== null && (window.clearInterval(d.current), d.current = null);
  }, []);
  return x.useEffect(() => () => s(), [s]), et(() => {
    var u;
    const c = i().find((l) => l.ref.current === document.activeElement);
    (u = c == null ? void 0 : c.ref.current) == null || u.scrollIntoView({ block: "nearest" });
  }, [i]), /* @__PURE__ */ A(
    ge.div,
    {
      "aria-hidden": !0,
      ...o,
      ref: t,
      style: { flexShrink: 0, ...o.style },
      onPointerDown: ne(o.onPointerDown, () => {
        d.current === null && (d.current = window.setInterval(n, 50));
      }),
      onPointerMove: ne(o.onPointerMove, () => {
        var u;
        (u = a.onItemLeave) == null || u.call(a), d.current === null && (d.current = window.setInterval(n, 50));
      }),
      onPointerLeave: ne(o.onPointerLeave, () => {
        s();
      })
    }
  );
}), wte = "SelectSeparator", yC = x.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, ...n } = e;
    return /* @__PURE__ */ A(ge.div, { "aria-hidden": !0, ...n, ref: t });
  }
);
yC.displayName = wte;
var S1 = "SelectArrow", Ate = x.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, ...n } = e, o = of(r), a = Qr(S1, r), d = en(S1, r);
    return a.open && d.position === "popper" ? /* @__PURE__ */ A(Oi, { ...o, ...n, ref: t }) : null;
  }
);
Ate.displayName = S1;
var Ste = "SelectBubbleInput", _te = x.forwardRef(
  ({ __scopeSelect: e, value: t, ...r }, n) => {
    const o = x.useRef(null), a = Oe(n, o), d = R2(t);
    return x.useEffect(() => {
      const i = o.current;
      if (!i) return;
      const s = window.HTMLSelectElement.prototype, u = Object.getOwnPropertyDescriptor(
        s,
        "value"
      ).set;
      if (d !== t && u) {
        const c = new Event("change", { bubbles: !0 });
        u.call(i, t), i.dispatchEvent(c);
      }
    }, [d, t]), /* @__PURE__ */ A(
      ge.select,
      {
        ...r,
        style: { ...n_, ...r.style },
        ref: a,
        defaultValue: t
      }
    );
  }
);
_te.displayName = Ste;
function bC(e) {
  return e === "" || e === void 0;
}
function xC(e) {
  const t = it(e), r = x.useRef(""), n = x.useRef(0), o = x.useCallback(
    (d) => {
      const i = r.current + d;
      t(i), function s(u) {
        r.current = u, window.clearTimeout(n.current), u !== "" && (n.current = window.setTimeout(() => s(""), 1e3));
      }(i);
    },
    [t]
  ), a = x.useCallback(() => {
    r.current = "", window.clearTimeout(n.current);
  }, []);
  return x.useEffect(() => () => window.clearTimeout(n.current), []), [r, o, a];
}
function wC(e, t, r) {
  const n = t.length > 1 && Array.from(t).every((i) => i === t[0]) ? t[0] : t, o = r ? e.indexOf(r) : -1;
  let a = Ete(e, Math.max(o, 0));
  n.length === 1 && (a = a.filter((i) => i !== r));
  const d = a.find(
    (i) => i.textValue.toLowerCase().startsWith(n.toLowerCase())
  );
  return d !== r ? d : void 0;
}
function Ete(e, t) {
  return e.map((r, n) => e[(t + n) % e.length]);
}
var AC = QM, Mte = tC, Cte = rC, SC = nC, Ote = iC, _C = lC, EC = fC, Nte = pC, Ite = vC, MC = mC, CC = hC, OC = yC;
const Pte = x.forwardRef(({ className: e, children: t, ...r }, n) => /* @__PURE__ */ ie(
  AC,
  {
    ref: n,
    className: q(
      "flex h-9 w-full items-center justify-between whitespace-nowrap rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm ring-offset-background data-[placeholder]:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1",
      e
    ),
    ...r,
    children: [
      t,
      /* @__PURE__ */ A(Mte, { asChild: !0, children: /* @__PURE__ */ A(qM, { className: "size-4 opacity-50" }) })
    ]
  }
));
Pte.displayName = AC.displayName;
const NC = x.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  MC,
  {
    ref: r,
    className: q("flex cursor-default items-center justify-center py-1", e),
    ...t,
    children: /* @__PURE__ */ A(ate, { className: "size-4" })
  }
));
NC.displayName = MC.displayName;
const IC = x.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  CC,
  {
    ref: r,
    className: q("flex cursor-default items-center justify-center py-1", e),
    ...t,
    children: /* @__PURE__ */ A(qM, { className: "size-4" })
  }
));
IC.displayName = CC.displayName;
const Rte = x.forwardRef(({ className: e, children: t, position: r = "popper", ...n }, o) => /* @__PURE__ */ A(Cte, { children: /* @__PURE__ */ ie(
  SC,
  {
    ref: o,
    className: q(
      "relative z-50 max-h-[--radix-select-content-available-height] min-w-[8rem] overflow-y-auto overflow-x-hidden rounded-md border bg-popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-select-content-transform-origin]",
      r === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
      e
    ),
    position: r,
    ...n,
    children: [
      /* @__PURE__ */ A(NC, {}),
      /* @__PURE__ */ A(
        Ote,
        {
          className: q(
            "p-1",
            r === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
          ),
          children: t
        }
      ),
      /* @__PURE__ */ A(IC, {})
    ]
  }
) }));
Rte.displayName = SC.displayName;
const Tte = x.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  _C,
  {
    ref: r,
    className: q("px-2 py-1.5 text-sm font-semibold", e),
    ...t
  }
));
Tte.displayName = _C.displayName;
const Dte = x.forwardRef(({ className: e, children: t, ...r }, n) => /* @__PURE__ */ ie(
  EC,
  {
    ref: n,
    className: q(
      "relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-2 pr-8 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...r,
    children: [
      /* @__PURE__ */ A("span", { className: "absolute right-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ A(Ite, { children: /* @__PURE__ */ A(O_, { className: "size-4" }) }) }),
      /* @__PURE__ */ A(Nte, { children: t })
    ]
  }
));
Dte.displayName = EC.displayName;
const Lte = x.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ A(OC, { ref: r, className: q("-mx-1 my-1 h-px bg-muted", e), ...t }));
Lte.displayName = OC.displayName;
const Fte = s2, PC = X(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  Ta,
  {
    className: q(
      "fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t,
    ref: r
  }
));
PC.displayName = Ta.displayName;
const kte = jt(
  "fixed z-50 gap-4 bg-background p-6 shadow-lg transition ease-in-out data-[state=closed]:duration-300 data-[state=open]:duration-500 data-[state=open]:animate-in data-[state=closed]:animate-out",
  {
    variants: {
      side: {
        top: "inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
        bottom: "inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
        left: "inset-y-0 left-0 h-full w-3/4 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
        right: "inset-y-0 right-0 h-full w-3/4 border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm"
      }
    },
    defaultVariants: {
      side: "right"
    }
  }
), jte = X(
  ({ side: e = "right", className: t, children: r, ...n }, o) => /* @__PURE__ */ ie(Fte, { children: [
    /* @__PURE__ */ A(PC, {}),
    /* @__PURE__ */ ie(Da, { ref: o, className: q(kte({ side: e }), t), ...n, children: [
      /* @__PURE__ */ ie(Cy, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-secondary", children: [
        /* @__PURE__ */ A(o2, { className: "size-4" }),
        /* @__PURE__ */ A("span", { className: "sr-only", children: "Close" })
      ] }),
      r
    ] })
  ] })
);
jte.displayName = Da.displayName;
const Bte = X(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  $i,
  {
    ref: r,
    className: q("text-lg font-semibold text-foreground", e),
    ...t
  }
));
Bte.displayName = $i.displayName;
const Zte = X(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  vi,
  {
    ref: r,
    className: q("text-sm text-muted-foreground", e),
    ...t
  }
));
Zte.displayName = vi.displayName;
function wt() {
  return wt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, wt.apply(null, arguments);
}
function RC(e, [t, r]) {
  return Math.min(r, Math.max(t, e));
}
function go(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(n) {
    if (e == null || e(n), r === !1 || !n.defaultPrevented) return t == null ? void 0 : t(n);
  };
}
function Ute(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function TC(...e) {
  return (t) => e.forEach(
    (r) => Ute(r, t)
  );
}
function Kr(...e) {
  return rr(TC(...e), e);
}
function DC(e, t = []) {
  let r = [];
  function n(a, d) {
    const i = /* @__PURE__ */ dt(d), s = r.length;
    r = [
      ...r,
      d
    ];
    function u(l) {
      const { scope: p, children: h, ...m } = l, f = (p == null ? void 0 : p[e][s]) || i, $ = ar(
        () => m,
        Object.values(m)
      );
      return /* @__PURE__ */ _e(f.Provider, {
        value: $
      }, h);
    }
    function c(l, p) {
      const h = (p == null ? void 0 : p[e][s]) || i, m = Ar(h);
      if (m) return m;
      if (d !== void 0) return d;
      throw new Error(`\`${l}\` must be used within \`${a}\``);
    }
    return u.displayName = a + "Provider", [
      u,
      c
    ];
  }
  const o = () => {
    const a = r.map((d) => /* @__PURE__ */ dt(d));
    return function(d) {
      const i = (d == null ? void 0 : d[e]) || a;
      return ar(
        () => ({
          [`__scope${e}`]: {
            ...d,
            [e]: i
          }
        }),
        [
          d,
          i
        ]
      );
    };
  };
  return o.scopeName = e, [
    n,
    Gte(o, ...t)
  ];
}
function Gte(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map(
      (o) => ({
        useScope: o(),
        scopeName: o.scopeName
      })
    );
    return function(o) {
      const a = n.reduce((d, { useScope: i, scopeName: s }) => {
        const u = i(o)[`__scope${s}`];
        return {
          ...d,
          ...u
        };
      }, {});
      return ar(
        () => ({
          [`__scope${t.scopeName}`]: a
        }),
        [
          a
        ]
      );
    };
  };
  return r.scopeName = t.scopeName, r;
}
function LC(e) {
  const t = Nt(e);
  return rt(() => {
    t.current = e;
  }), ar(
    () => (...r) => {
      var n;
      return (n = t.current) === null || n === void 0 ? void 0 : n.call(t, ...r);
    },
    []
  );
}
function Vte({ prop: e, defaultProp: t, onChange: r = () => {
} }) {
  const [n, o] = Hte({
    defaultProp: t,
    onChange: r
  }), a = e !== void 0, d = a ? e : n, i = LC(r), s = rr((u) => {
    if (a) {
      const c = typeof u == "function" ? u(e) : u;
      c !== e && i(c);
    } else o(u);
  }, [
    a,
    e,
    o,
    i
  ]);
  return [
    d,
    s
  ];
}
function Hte({ defaultProp: e, onChange: t }) {
  const r = Ie(e), [n] = r, o = Nt(n), a = LC(t);
  return rt(() => {
    o.current !== n && (a(n), o.current = n);
  }, [
    n,
    o,
    a
  ]), r;
}
const Kte = /* @__PURE__ */ dt(void 0);
function Wte(e) {
  const t = Ar(Kte);
  return e || t || "ltr";
}
function zte(e) {
  const t = Nt({
    value: e,
    previous: e
  });
  return ar(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [
    e
  ]);
}
const Yte = globalThis != null && globalThis.document ? V7 : () => {
};
function Xte(e) {
  const [t, r] = Ie(void 0);
  return Yte(() => {
    if (e) {
      r({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const n = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length) return;
        const a = o[0];
        let d, i;
        if ("borderBoxSize" in a) {
          const s = a.borderBoxSize, u = Array.isArray(s) ? s[0] : s;
          d = u.inlineSize, i = u.blockSize;
        } else
          d = e.offsetWidth, i = e.offsetHeight;
        r({
          width: d,
          height: i
        });
      });
      return n.observe(e, {
        box: "border-box"
      }), () => n.unobserve(e);
    } else
      r(void 0);
  }, [
    e
  ]), t;
}
const qd = /* @__PURE__ */ X((e, t) => {
  const { children: r, ...n } = e, o = bo.toArray(r), a = o.find(Jte);
  if (a) {
    const d = a.props.children, i = o.map((s) => s === a ? bo.count(d) > 1 ? bo.only(null) : /* @__PURE__ */ Nd(d) ? d.props.children : null : s);
    return /* @__PURE__ */ _e(_1, wt({}, n, {
      ref: t
    }), /* @__PURE__ */ Nd(d) ? /* @__PURE__ */ C1(d, void 0, i) : null);
  }
  return /* @__PURE__ */ _e(_1, wt({}, n, {
    ref: t
  }), r);
});
qd.displayName = "Slot";
const _1 = /* @__PURE__ */ X((e, t) => {
  const { children: r, ...n } = e;
  return /* @__PURE__ */ Nd(r) ? /* @__PURE__ */ C1(r, {
    ...Qte(n, r.props),
    ref: t ? TC(t, r.ref) : r.ref
  }) : bo.count(r) > 1 ? bo.only(null) : null;
});
_1.displayName = "SlotClone";
const qte = ({ children: e }) => /* @__PURE__ */ _e(MO, null, e);
function Jte(e) {
  return /* @__PURE__ */ Nd(e) && e.type === qte;
}
function Qte(e, t) {
  const r = {
    ...t
  };
  for (const n in t) {
    const o = e[n], a = t[n];
    /^on[A-Z]/.test(n) ? o && a ? r[n] = (...d) => {
      a(...d), o(...d);
    } : o && (r[n] = o) : n === "style" ? r[n] = {
      ...o,
      ...a
    } : n === "className" && (r[n] = [
      o,
      a
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...r
  };
}
const ere = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], ji = ere.reduce((e, t) => {
  const r = /* @__PURE__ */ X((n, o) => {
    const { asChild: a, ...d } = n, i = a ? qd : t;
    return rt(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ _e(i, wt({}, d, {
      ref: o
    }));
  });
  return r.displayName = `Primitive.${t}`, {
    ...e,
    [t]: r
  };
}, {});
function tre(e) {
  const t = e + "CollectionProvider", [r, n] = DC(t), [o, a] = r(t, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), d = (h) => {
    const { scope: m, children: f } = h, $ = Ae.useRef(null), v = Ae.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ Ae.createElement(o, {
      scope: m,
      itemMap: v,
      collectionRef: $
    }, f);
  }, i = e + "CollectionSlot", s = /* @__PURE__ */ Ae.forwardRef((h, m) => {
    const { scope: f, children: $ } = h, v = a(i, f), y = Kr(m, v.collectionRef);
    return /* @__PURE__ */ Ae.createElement(qd, {
      ref: y
    }, $);
  }), u = e + "CollectionItemSlot", c = "data-radix-collection-item", l = /* @__PURE__ */ Ae.forwardRef((h, m) => {
    const { scope: f, children: $, ...v } = h, y = Ae.useRef(null), S = Kr(m, y), w = a(u, f);
    return Ae.useEffect(() => (w.itemMap.set(y, {
      ref: y,
      ...v
    }), () => void w.itemMap.delete(y))), /* @__PURE__ */ Ae.createElement(qd, {
      [c]: "",
      ref: S
    }, $);
  });
  function p(h) {
    const m = a(e + "CollectionConsumer", h);
    return Ae.useCallback(() => {
      const f = m.collectionRef.current;
      if (!f) return [];
      const $ = Array.from(f.querySelectorAll(`[${c}]`));
      return Array.from(m.itemMap.values()).sort(
        (v, y) => $.indexOf(v.ref.current) - $.indexOf(y.ref.current)
      );
    }, [
      m.collectionRef,
      m.itemMap
    ]);
  }
  return [
    {
      Provider: d,
      Slot: s,
      ItemSlot: l
    },
    p,
    n
  ];
}
const FC = [
  "PageUp",
  "PageDown"
], kC = [
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight"
], jC = {
  "from-left": [
    "Home",
    "PageDown",
    "ArrowDown",
    "ArrowLeft"
  ],
  "from-right": [
    "Home",
    "PageDown",
    "ArrowDown",
    "ArrowRight"
  ],
  "from-bottom": [
    "Home",
    "PageDown",
    "ArrowDown",
    "ArrowLeft"
  ],
  "from-top": [
    "Home",
    "PageDown",
    "ArrowUp",
    "ArrowLeft"
  ]
}, Va = "Slider", [E1, rre, nre] = tre(Va), [BC, foe] = DC(Va, [
  nre
]), [ore, Bi] = BC(Va), are = /* @__PURE__ */ X((e, t) => {
  const { name: r, min: n = 0, max: o = 100, step: a = 1, orientation: d = "horizontal", disabled: i = !1, minStepsBetweenThumbs: s = 0, defaultValue: u = [
    n
  ], value: c, onValueChange: l = () => {
  }, onValueCommit: p = () => {
  }, inverted: h = !1, ...m } = e, [f, $] = Ie(null), v = Kr(
    t,
    (F) => $(F)
  ), y = Nt(/* @__PURE__ */ new Set()), S = Nt(0), w = d === "horizontal", _ = f ? !!f.closest("form") : !0, I = w ? dre : ire, [N = [], O] = Vte({
    prop: c,
    defaultProp: u,
    onChange: (F) => {
      var Z;
      (Z = [
        ...y.current
      ][S.current]) === null || Z === void 0 || Z.focus(), l(F);
    }
  }), E = Nt(N);
  function C(F) {
    const Z = mre(N, F);
    j(F, Z);
  }
  function P(F) {
    j(F, S.current);
  }
  function T() {
    const F = E.current[S.current];
    N[S.current] !== F && p(N);
  }
  function j(F, Z, { commit: te } = {
    commit: !1
  }) {
    const H = bre(a), de = xre(Math.round((F - n) / a) * a + n, H), G = RC(de, [
      n,
      o
    ]);
    O((le = []) => {
      const fe = $re(le, G, Z);
      if (yre(fe, s * a)) {
        S.current = fe.indexOf(G);
        const U = String(fe) !== String(le);
        return U && te && p(fe), U ? fe : le;
      } else return le;
    });
  }
  return /* @__PURE__ */ _e(ore, {
    scope: e.__scopeSlider,
    disabled: i,
    min: n,
    max: o,
    valueIndexToChangeRef: S,
    thumbs: y.current,
    values: N,
    orientation: d
  }, /* @__PURE__ */ _e(E1.Provider, {
    scope: e.__scopeSlider
  }, /* @__PURE__ */ _e(E1.Slot, {
    scope: e.__scopeSlider
  }, /* @__PURE__ */ _e(I, wt({
    "aria-disabled": i,
    "data-disabled": i ? "" : void 0
  }, m, {
    ref: v,
    onPointerDown: go(m.onPointerDown, () => {
      i || (E.current = N);
    }),
    min: n,
    max: o,
    inverted: h,
    onSlideStart: i ? void 0 : C,
    onSlideMove: i ? void 0 : P,
    onSlideEnd: i ? void 0 : T,
    onHomeKeyDown: () => !i && j(n, 0, {
      commit: !0
    }),
    onEndKeyDown: () => !i && j(o, N.length - 1, {
      commit: !0
    }),
    onStepKeyDown: ({ event: F, direction: Z }) => {
      if (!i) {
        const te = FC.includes(F.key) || F.shiftKey && kC.includes(F.key) ? 10 : 1, H = S.current, de = N[H], G = a * te * Z;
        j(de + G, H, {
          commit: !0
        });
      }
    }
  })))), _ && N.map(
    (F, Z) => /* @__PURE__ */ _e(pre, {
      key: Z,
      name: r ? r + (N.length > 1 ? "[]" : "") : void 0,
      value: F
    })
  ));
}), [ZC, UC] = BC(Va, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), dre = /* @__PURE__ */ X((e, t) => {
  const { min: r, max: n, dir: o, inverted: a, onSlideStart: d, onSlideMove: i, onSlideEnd: s, onStepKeyDown: u, ...c } = e, [l, p] = Ie(null), h = Kr(
    t,
    (S) => p(S)
  ), m = Nt(), f = Wte(o), $ = f === "ltr", v = $ && !a || !$ && a;
  function y(S) {
    const w = m.current || l.getBoundingClientRect(), _ = [
      0,
      w.width
    ], I = df(_, v ? [
      r,
      n
    ] : [
      n,
      r
    ]);
    return m.current = w, I(S - w.left);
  }
  return /* @__PURE__ */ _e(ZC, {
    scope: e.__scopeSlider,
    startEdge: v ? "left" : "right",
    endEdge: v ? "right" : "left",
    direction: v ? 1 : -1,
    size: "width"
  }, /* @__PURE__ */ _e(GC, wt({
    dir: f,
    "data-orientation": "horizontal"
  }, c, {
    ref: h,
    style: {
      ...c.style,
      "--radix-slider-thumb-transform": "translateX(-50%)"
    },
    onSlideStart: (S) => {
      const w = y(S.clientX);
      d == null || d(w);
    },
    onSlideMove: (S) => {
      const w = y(S.clientX);
      i == null || i(w);
    },
    onSlideEnd: () => {
      m.current = void 0, s == null || s();
    },
    onStepKeyDown: (S) => {
      const w = jC[v ? "from-left" : "from-right"].includes(S.key);
      u == null || u({
        event: S,
        direction: w ? -1 : 1
      });
    }
  })));
}), ire = /* @__PURE__ */ X((e, t) => {
  const { min: r, max: n, inverted: o, onSlideStart: a, onSlideMove: d, onSlideEnd: i, onStepKeyDown: s, ...u } = e, c = Nt(null), l = Kr(t, c), p = Nt(), h = !o;
  function m(f) {
    const $ = p.current || c.current.getBoundingClientRect(), v = [
      0,
      $.height
    ], y = df(v, h ? [
      n,
      r
    ] : [
      r,
      n
    ]);
    return p.current = $, y(f - $.top);
  }
  return /* @__PURE__ */ _e(ZC, {
    scope: e.__scopeSlider,
    startEdge: h ? "bottom" : "top",
    endEdge: h ? "top" : "bottom",
    size: "height",
    direction: h ? 1 : -1
  }, /* @__PURE__ */ _e(GC, wt({
    "data-orientation": "vertical"
  }, u, {
    ref: l,
    style: {
      ...u.style,
      "--radix-slider-thumb-transform": "translateY(50%)"
    },
    onSlideStart: (f) => {
      const $ = m(f.clientY);
      a == null || a($);
    },
    onSlideMove: (f) => {
      const $ = m(f.clientY);
      d == null || d($);
    },
    onSlideEnd: () => {
      p.current = void 0, i == null || i();
    },
    onStepKeyDown: (f) => {
      const $ = jC[h ? "from-bottom" : "from-top"].includes(f.key);
      s == null || s({
        event: f,
        direction: $ ? -1 : 1
      });
    }
  })));
}), GC = /* @__PURE__ */ X((e, t) => {
  const { __scopeSlider: r, onSlideStart: n, onSlideMove: o, onSlideEnd: a, onHomeKeyDown: d, onEndKeyDown: i, onStepKeyDown: s, ...u } = e, c = Bi(Va, r);
  return /* @__PURE__ */ _e(ji.span, wt({}, u, {
    ref: t,
    onKeyDown: go(e.onKeyDown, (l) => {
      l.key === "Home" ? (d(l), l.preventDefault()) : l.key === "End" ? (i(l), l.preventDefault()) : FC.concat(kC).includes(l.key) && (s(l), l.preventDefault());
    }),
    onPointerDown: go(e.onPointerDown, (l) => {
      const p = l.target;
      p.setPointerCapture(l.pointerId), l.preventDefault(), c.thumbs.has(p) ? p.focus() : n(l);
    }),
    onPointerMove: go(e.onPointerMove, (l) => {
      l.target.hasPointerCapture(l.pointerId) && o(l);
    }),
    onPointerUp: go(e.onPointerUp, (l) => {
      const p = l.target;
      p.hasPointerCapture(l.pointerId) && (p.releasePointerCapture(l.pointerId), a(l));
    })
  }));
}), sre = "SliderTrack", ure = /* @__PURE__ */ X((e, t) => {
  const { __scopeSlider: r, ...n } = e, o = Bi(sre, r);
  return /* @__PURE__ */ _e(ji.span, wt({
    "data-disabled": o.disabled ? "" : void 0,
    "data-orientation": o.orientation
  }, n, {
    ref: t
  }));
}), F7 = "SliderRange", lre = /* @__PURE__ */ X((e, t) => {
  const { __scopeSlider: r, ...n } = e, o = Bi(F7, r), a = UC(F7, r), d = Nt(null), i = Kr(t, d), s = o.values.length, u = o.values.map(
    (p) => VC(p, o.min, o.max)
  ), c = s > 1 ? Math.min(...u) : 0, l = 100 - Math.max(...u);
  return /* @__PURE__ */ _e(ji.span, wt({
    "data-orientation": o.orientation,
    "data-disabled": o.disabled ? "" : void 0
  }, n, {
    ref: i,
    style: {
      ...e.style,
      [a.startEdge]: c + "%",
      [a.endEdge]: l + "%"
    }
  }));
}), k7 = "SliderThumb", cre = /* @__PURE__ */ X((e, t) => {
  const r = rre(e.__scopeSlider), [n, o] = Ie(null), a = Kr(
    t,
    (i) => o(i)
  ), d = ar(
    () => n ? r().findIndex(
      (i) => i.ref.current === n
    ) : -1,
    [
      r,
      n
    ]
  );
  return /* @__PURE__ */ _e(fre, wt({}, e, {
    ref: a,
    index: d
  }));
}), fre = /* @__PURE__ */ X((e, t) => {
  const { __scopeSlider: r, index: n, ...o } = e, a = Bi(k7, r), d = UC(k7, r), [i, s] = Ie(null), u = Kr(
    t,
    ($) => s($)
  ), c = Xte(i), l = a.values[n], p = l === void 0 ? 0 : VC(l, a.min, a.max), h = vre(n, a.values.length), m = c == null ? void 0 : c[d.size], f = m ? hre(m, p, d.direction) : 0;
  return rt(() => {
    if (i)
      return a.thumbs.add(i), () => {
        a.thumbs.delete(i);
      };
  }, [
    i,
    a.thumbs
  ]), /* @__PURE__ */ _e("span", {
    style: {
      transform: "var(--radix-slider-thumb-transform)",
      position: "absolute",
      [d.startEdge]: `calc(${p}% + ${f}px)`
    }
  }, /* @__PURE__ */ _e(E1.ItemSlot, {
    scope: e.__scopeSlider
  }, /* @__PURE__ */ _e(ji.span, wt({
    role: "slider",
    "aria-label": e["aria-label"] || h,
    "aria-valuemin": a.min,
    "aria-valuenow": l,
    "aria-valuemax": a.max,
    "aria-orientation": a.orientation,
    "data-orientation": a.orientation,
    "data-disabled": a.disabled ? "" : void 0,
    tabIndex: a.disabled ? void 0 : 0
  }, o, {
    ref: u,
    style: l === void 0 ? {
      display: "none"
    } : e.style,
    onFocus: go(e.onFocus, () => {
      a.valueIndexToChangeRef.current = n;
    })
  }))));
}), pre = (e) => {
  const { value: t, ...r } = e, n = Nt(null), o = zte(t);
  return rt(() => {
    const a = n.current, d = window.HTMLInputElement.prototype, i = Object.getOwnPropertyDescriptor(d, "value").set;
    if (o !== t && i) {
      const s = new Event("input", {
        bubbles: !0
      });
      i.call(a, t), a.dispatchEvent(s);
    }
  }, [
    o,
    t
  ]), /* @__PURE__ */ _e("input", wt({
    style: {
      display: "none"
    }
  }, r, {
    ref: n,
    defaultValue: t
  }));
};
function $re(e = [], t, r) {
  const n = [
    ...e
  ];
  return n[r] = t, n.sort(
    (o, a) => o - a
  );
}
function VC(e, t, r) {
  const n = 100 / (r - t) * (e - t);
  return RC(n, [
    0,
    100
  ]);
}
function vre(e, t) {
  return t > 2 ? `Value ${e + 1} of ${t}` : t === 2 ? [
    "Minimum",
    "Maximum"
  ][e] : void 0;
}
function mre(e, t) {
  if (e.length === 1) return 0;
  const r = e.map(
    (o) => Math.abs(o - t)
  ), n = Math.min(...r);
  return r.indexOf(n);
}
function hre(e, t, r) {
  const n = e / 2, o = df([
    0,
    50
  ], [
    0,
    n
  ]);
  return (n - o(t) * r) * r;
}
function gre(e) {
  return e.slice(0, -1).map(
    (t, r) => e[r + 1] - t
  );
}
function yre(e, t) {
  if (t > 0) {
    const r = gre(e);
    return Math.min(...r) >= t;
  }
  return !0;
}
function df(e, t) {
  return (r) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const n = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + n * (r - e[0]);
  };
}
function bre(e) {
  return (String(e).split(".")[1] || "").length;
}
function xre(e, t) {
  const r = Math.pow(10, t);
  return Math.round(e * r) / r;
}
const HC = are, wre = ure, Are = lre, Sre = cre, _re = x.forwardRef(({ className: e, ...t }, r) => /* @__PURE__ */ ie(
  HC,
  {
    ref: r,
    className: q("relative flex w-full touch-none select-none items-center", e),
    ...t,
    children: [
      /* @__PURE__ */ A(wre, { className: "relative h-2 w-full grow overflow-hidden rounded-full bg-secondary", children: /* @__PURE__ */ A(Are, { className: "absolute h-full bg-primary" }) }),
      /* @__PURE__ */ A(Sre, { className: "block size-5 rounded-full border-2 border-primary bg-background ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50" })
    ]
  }
));
_re.displayName = HC.displayName;
function Ere({
  prop: e,
  defaultProp: t,
  onChange: r = () => {
  }
}) {
  const [n, o] = Mre({ defaultProp: t, onChange: r }), a = e !== void 0, d = a ? e : n, i = it(r), s = x.useCallback(
    (u) => {
      if (a) {
        const c = typeof u == "function" ? u(e) : u;
        c !== e && i(c);
      } else
        o(u);
    },
    [a, e, o, i]
  );
  return [d, s];
}
function Mre({
  defaultProp: e,
  onChange: t
}) {
  const r = x.useState(e), [n] = r, o = x.useRef(n), a = it(t);
  return x.useEffect(() => {
    o.current !== n && (a(n), o.current = n);
  }, [n, o, a]), r;
}
var Cre = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], KC = Cre.reduce((e, t) => {
  const r = /* @__PURE__ */ C_(`Primitive.${t}`), n = x.forwardRef((o, a) => {
    const { asChild: d, ...i } = o, s = d ? r : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ A(s, { ...i, ref: a });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), sf = "Switch", [Ore, poe] = At(sf), [Nre, Ire] = Ore(sf), WC = x.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: r,
      name: n,
      checked: o,
      defaultChecked: a,
      required: d,
      disabled: i,
      value: s = "on",
      onCheckedChange: u,
      form: c,
      ...l
    } = e, [p, h] = x.useState(null), m = Oe(t, (S) => h(S)), f = x.useRef(!1), $ = p ? c || !!p.closest("form") : !0, [v = !1, y] = Ere({
      prop: o,
      defaultProp: a,
      onChange: u
    });
    return /* @__PURE__ */ ie(Nre, { scope: r, checked: v, disabled: i, children: [
      /* @__PURE__ */ A(
        KC.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": v,
          "aria-required": d,
          "data-state": XC(v),
          "data-disabled": i ? "" : void 0,
          disabled: i,
          value: s,
          ...l,
          ref: m,
          onClick: ne(e.onClick, (S) => {
            y((w) => !w), $ && (f.current = S.isPropagationStopped(), f.current || S.stopPropagation());
          })
        }
      ),
      $ && /* @__PURE__ */ A(
        Pre,
        {
          control: p,
          bubbles: !f.current,
          name: n,
          value: s,
          checked: v,
          required: d,
          disabled: i,
          form: c,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
WC.displayName = sf;
var zC = "SwitchThumb", YC = x.forwardRef(
  (e, t) => {
    const { __scopeSwitch: r, ...n } = e, o = Ire(zC, r);
    return /* @__PURE__ */ A(
      KC.span,
      {
        "data-state": XC(o.checked),
        "data-disabled": o.disabled ? "" : void 0,
        ...n,
        ref: t
      }
    );
  }
);
YC.displayName = zC;
var Pre = (e) => {
  const { control: t, checked: r, bubbles: n = !0, ...o } = e, a = x.useRef(null), d = R2(r), i = T2(t);
  return x.useEffect(() => {
    const s = a.current, u = window.HTMLInputElement.prototype, c = Object.getOwnPropertyDescriptor(u, "checked").set;
    if (d !== r && c) {
      const l = new Event("click", { bubbles: n });
      c.call(s, r), s.dispatchEvent(l);
    }
  }, [d, r, n]), /* @__PURE__ */ A(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: r,
      ...o,
      tabIndex: -1,
      ref: a,
      style: {
        ...e.style,
        ...i,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function XC(e) {
  return e ? "checked" : "unchecked";
}
var qC = WC, Rre = YC;
const Tre = X(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  qC,
  {
    className: q(
      "peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input",
      e
    ),
    ...t,
    ref: r,
    children: /* @__PURE__ */ A(
      Rre,
      {
        className: q(
          "pointer-events-none block h-4 w-4 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0"
        )
      }
    )
  }
));
Tre.displayName = qC.displayName;
const Dre = X(
  ({ className: e, ...t }, r) => /* @__PURE__ */ A("div", { className: "relative w-full overflow-auto", children: /* @__PURE__ */ A("table", { ref: r, className: q("w-full caption-bottom text-sm", e), ...t }) })
);
Dre.displayName = "Table";
const Lre = X(
  ({ className: e, ...t }, r) => /* @__PURE__ */ A("thead", { ref: r, className: q("[&_tr]:border-b", e), ...t })
);
Lre.displayName = "TableHeader";
const Fre = X(
  ({ className: e, ...t }, r) => /* @__PURE__ */ A("tbody", { ref: r, className: q("[&_tr:last-child]:border-0", e), ...t })
);
Fre.displayName = "TableBody";
const kre = X(
  ({ className: e, ...t }, r) => /* @__PURE__ */ A(
    "tfoot",
    {
      ref: r,
      className: q("border-t bg-muted/50 font-medium [&>tr]:last:border-b-0", e),
      ...t
    }
  )
);
kre.displayName = "TableFooter";
const jre = X(
  ({ className: e, ...t }, r) => /* @__PURE__ */ A(
    "tr",
    {
      ref: r,
      className: q("border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted", e),
      ...t
    }
  )
);
jre.displayName = "TableRow";
const Bre = X(
  ({ className: e, ...t }, r) => /* @__PURE__ */ A(
    "th",
    {
      ref: r,
      className: q(
        "h-10 px-2 text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]",
        e
      ),
      ...t
    }
  )
);
Bre.displayName = "TableHead";
const Zre = X(
  ({ className: e, ...t }, r) => /* @__PURE__ */ A(
    "td",
    {
      ref: r,
      className: q(
        "p-2 align-middle [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]",
        e
      ),
      ...t
    }
  )
);
Zre.displayName = "TableCell";
const Ure = X(
  ({ className: e, ...t }, r) => /* @__PURE__ */ A("caption", { ref: r, className: q("mt-4 text-sm text-muted-foreground", e), ...t })
);
Ure.displayName = "TableCaption";
var Zi = "Tabs", [Gre, $oe] = At(Zi, [
  Ii
]), JC = Ii(), [Vre, uf] = Gre(Zi), Hre = x.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: r,
      value: n,
      onValueChange: o,
      defaultValue: a,
      orientation: d = "horizontal",
      dir: i,
      activationMode: s = "automatic",
      ...u
    } = e, c = xE(i), [l, p] = Do({
      prop: n,
      onChange: o,
      defaultProp: a ?? "",
      caller: Zi
    });
    return /* @__PURE__ */ A(
      Vre,
      {
        scope: r,
        baseId: It(),
        value: l,
        onValueChange: p,
        orientation: d,
        dir: c,
        activationMode: s,
        children: /* @__PURE__ */ A(
          ge.div,
          {
            dir: c,
            "data-orientation": d,
            ...u,
            ref: t
          }
        )
      }
    );
  }
);
Hre.displayName = Zi;
var QC = "TabsList", eO = x.forwardRef(
  (e, t) => {
    const { __scopeTabs: r, loop: n = !0, ...o } = e, a = uf(QC, r), d = JC(r);
    return /* @__PURE__ */ A(
      ME,
      {
        asChild: !0,
        ...d,
        orientation: a.orientation,
        dir: a.dir,
        loop: n,
        children: /* @__PURE__ */ A(
          ge.div,
          {
            role: "tablist",
            "aria-orientation": a.orientation,
            ...o,
            ref: t
          }
        )
      }
    );
  }
);
eO.displayName = QC;
var tO = "TabsTrigger", rO = x.forwardRef(
  (e, t) => {
    const { __scopeTabs: r, value: n, disabled: o = !1, ...a } = e, d = uf(tO, r), i = JC(r), s = aO(d.baseId, n), u = dO(d.baseId, n), c = n === d.value;
    return /* @__PURE__ */ A(
      CE,
      {
        asChild: !0,
        ...i,
        focusable: !o,
        active: c,
        children: /* @__PURE__ */ A(
          ge.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": c,
            "aria-controls": u,
            "data-state": c ? "active" : "inactive",
            "data-disabled": o ? "" : void 0,
            disabled: o,
            id: s,
            ...a,
            ref: t,
            onMouseDown: ne(e.onMouseDown, (l) => {
              !o && l.button === 0 && l.ctrlKey === !1 ? d.onValueChange(n) : l.preventDefault();
            }),
            onKeyDown: ne(e.onKeyDown, (l) => {
              [" ", "Enter"].includes(l.key) && d.onValueChange(n);
            }),
            onFocus: ne(e.onFocus, () => {
              const l = d.activationMode !== "manual";
              !c && !o && l && d.onValueChange(n);
            })
          }
        )
      }
    );
  }
);
rO.displayName = tO;
var nO = "TabsContent", oO = x.forwardRef(
  (e, t) => {
    const { __scopeTabs: r, value: n, forceMount: o, children: a, ...d } = e, i = uf(nO, r), s = aO(i.baseId, n), u = dO(i.baseId, n), c = n === i.value, l = x.useRef(c);
    return x.useEffect(() => {
      const p = requestAnimationFrame(() => l.current = !1);
      return () => cancelAnimationFrame(p);
    }, []), /* @__PURE__ */ A(St, { present: o || c, children: ({ present: p }) => /* @__PURE__ */ A(
      ge.div,
      {
        "data-state": c ? "active" : "inactive",
        "data-orientation": i.orientation,
        role: "tabpanel",
        "aria-labelledby": s,
        hidden: !p,
        id: u,
        tabIndex: 0,
        ...d,
        ref: t,
        style: {
          ...e.style,
          animationDuration: l.current ? "0s" : void 0
        },
        children: p && a
      }
    ) });
  }
);
oO.displayName = nO;
function aO(e, t) {
  return `${e}-trigger-${t}`;
}
function dO(e, t) {
  return `${e}-content-${t}`;
}
var iO = eO, sO = rO, uO = oO;
const Kre = X(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  iO,
  {
    ref: r,
    className: q(
      "inline-flex h-9 items-center justify-center rounded-lg bg-muted p-1 text-muted-foreground",
      e
    ),
    ...t
  }
));
Kre.displayName = iO.displayName;
const Wre = X(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  sO,
  {
    ref: r,
    className: q(
      "inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow",
      e
    ),
    ...t
  }
));
Wre.displayName = sO.displayName;
const zre = X(({ className: e, ...t }, r) => /* @__PURE__ */ A(
  uO,
  {
    ref: r,
    className: q(
      "mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      e
    ),
    ...t
  }
));
zre.displayName = uO.displayName;
var lO = "Toggle", cO = x.forwardRef((e, t) => {
  const { pressed: r, defaultPressed: n, onPressedChange: o, ...a } = e, [d, i] = Do({
    prop: r,
    onChange: o,
    defaultProp: n ?? !1,
    caller: lO
  });
  return /* @__PURE__ */ A(
    ge.button,
    {
      type: "button",
      "aria-pressed": d,
      "data-state": d ? "on" : "off",
      "data-disabled": e.disabled ? "" : void 0,
      ...a,
      ref: t,
      onClick: ne(e.onClick, () => {
        e.disabled || i(!d);
      })
    }
  );
});
cO.displayName = lO;
var fO = cO;
const Yre = jt(
  "inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium transition-colors hover:bg-muted hover:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-accent data-[state=on]:text-accent-foreground [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-transparent",
        outline: "border border-input bg-transparent shadow-sm hover:bg-accent hover:text-accent-foreground"
      },
      size: {
        default: "h-9 px-2 min-w-9",
        sm: "h-8 px-1.5 min-w-8",
        lg: "h-10 px-2.5 min-w-10"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), Xre = x.forwardRef(({ className: e, variant: t, size: r, ...n }, o) => /* @__PURE__ */ A(fO, { ref: o, className: q(Yre({ variant: t, size: r, className: e })), ...n }));
Xre.displayName = fO.displayName;
const lf = dt({
  m: () => {
  }
});
var qre = (e) => e.type === "checkbox", Jre = (e) => e instanceof Date, pO = (e) => e == null;
const Qre = (e) => typeof e == "object";
var Zo = (e) => !pO(e) && !Array.isArray(e) && Qre(e) && !Jre(e), ene = (e) => Zo(e) && e.target ? qre(e.target) ? e.target.checked : e.target.value : e, tne = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, rne = (e, t) => e.has(tne(t)), nne = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return Zo(t) && t.hasOwnProperty("isPrototypeOf");
}, one = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function cf(e) {
  let t;
  const r = Array.isArray(e);
  if (e instanceof Date)
    t = new Date(e);
  else if (e instanceof Set)
    t = new Set(e);
  else if (!(one && (e instanceof Blob || e instanceof FileList)) && (r || Zo(e)))
    if (t = r ? [] : {}, !r && !nne(e))
      t = e;
    else
      for (const n in e)
        e.hasOwnProperty(n) && (t[n] = cf(e[n]));
  else
    return e;
  return t;
}
var $O = (e) => Array.isArray(e) ? e.filter(Boolean) : [], M1 = (e) => e === void 0, at = (e, t, r) => {
  if (!t || !Zo(e))
    return r;
  const n = $O(t.split(/[,[\].]+?/)).reduce((o, a) => pO(o) ? o : o[a], e);
  return M1(n) || n === e ? M1(e[t]) ? r : e[t] : n;
}, j7 = (e) => typeof e == "boolean", ane = (e) => /^\w*$/.test(e), dne = (e) => $O(e.replace(/["|']|\]/g, "").split(/\.|\[/)), B7 = (e, t, r) => {
  let n = -1;
  const o = ane(t) ? [t] : dne(t), a = o.length, d = a - 1;
  for (; ++n < a; ) {
    const i = o[n];
    let s = r;
    if (n !== d) {
      const u = e[i];
      s = Zo(u) || Array.isArray(u) ? u : isNaN(+o[n + 1]) ? {} : [];
    }
    if (i === "__proto__")
      return;
    e[i] = s, e = e[i];
  }
  return e;
};
const Z7 = {
  BLUR: "blur",
  CHANGE: "change"
}, U7 = {
  all: "all"
}, vO = Ae.createContext(null), Ui = () => Ae.useContext(vO), ine = (e) => {
  const { children: t, ...r } = e;
  return Ae.createElement(vO.Provider, { value: r }, t);
};
var sne = (e, t, r, n = !0) => {
  const o = {
    defaultValues: t._defaultValues
  };
  for (const a in e)
    Object.defineProperty(o, a, {
      get: () => {
        const d = a;
        return t._proxyFormState[d] !== U7.all && (t._proxyFormState[d] = !n || U7.all), r && (r[d] = !0), e[d];
      }
    });
  return o;
}, une = (e) => Zo(e) && !Object.keys(e).length, lne = (e, t, r, n) => {
  r(e);
  const { name: o, ...a } = e;
  return une(a) || Object.keys(a).length >= Object.keys(t).length || Object.keys(a).find((d) => t[d] === !0);
}, cne = (e) => Array.isArray(e) ? e : [e], mO = (e, t, r) => !e || !t || e === t || cne(e).some((n) => n && (r ? n === t : n.startsWith(t) || t.startsWith(n)));
function hO(e) {
  const t = Ae.useRef(e);
  t.current = e, Ae.useEffect(() => {
    const r = !e.disabled && t.current.subject && t.current.subject.subscribe({
      next: t.current.next
    });
    return () => {
      r && r.unsubscribe();
    };
  }, [e.disabled]);
}
function fne(e) {
  const t = Ui(), { control: r = t.control, disabled: n, name: o, exact: a } = e || {}, [d, i] = Ae.useState(r._formState), s = Ae.useRef(!0), u = Ae.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), c = Ae.useRef(o);
  return c.current = o, hO({
    disabled: n,
    next: (l) => s.current && mO(c.current, l.name, a) && lne(l, u.current, r._updateFormState) && i({
      ...r._formState,
      ...l
    }),
    subject: r._subjects.state
  }), Ae.useEffect(() => (s.current = !0, u.current.isValid && r._updateValid(!0), () => {
    s.current = !1;
  }), [r]), sne(d, r, u.current, !1);
}
var pne = (e) => typeof e == "string", $ne = (e, t, r, n, o) => pne(e) ? at(r, e, o) : Array.isArray(e) ? e.map((a) => at(r, a)) : r;
function vne(e) {
  const t = Ui(), { control: r = t.control, name: n, defaultValue: o, disabled: a, exact: d } = e || {}, i = Ae.useRef(n);
  i.current = n, hO({
    disabled: a,
    subject: r._subjects.values,
    next: (c) => {
      mO(i.current, c.name, d) && u(cf($ne(i.current, r._names, c.values || r._formValues, !1, o)));
    }
  });
  const [s, u] = Ae.useState(r._getWatch(n, o));
  return Ae.useEffect(() => r._removeUnmounted()), s;
}
function mne(e) {
  const t = Ui(), { name: r, disabled: n, control: o = t.control, shouldUnregister: a } = e, d = rne(o._names.array, r), i = vne({
    control: o,
    name: r,
    defaultValue: at(o._formValues, r, at(o._defaultValues, r, e.defaultValue)),
    exact: !0
  }), s = fne({
    control: o,
    name: r,
    exact: !0
  }), u = Ae.useRef(o.register(r, {
    ...e.rules,
    value: i,
    ...j7(e.disabled) ? { disabled: e.disabled } : {}
  }));
  return Ae.useEffect(() => {
    const c = o._options.shouldUnregister || a, l = (p, h) => {
      const m = at(o._fields, p);
      m && m._f && (m._f.mount = h);
    };
    if (l(r, !0), c) {
      const p = cf(at(o._options.defaultValues, r));
      B7(o._defaultValues, r, p), M1(at(o._formValues, r)) && B7(o._formValues, r, p);
    }
    return () => {
      (d ? c && !o._state.action : c) ? o.unregister(r) : l(r, !1);
    };
  }, [r, o, d, a]), Ae.useEffect(() => {
    at(o._fields, r) && o._updateDisabledField({
      disabled: n,
      fields: o._fields,
      name: r,
      value: at(o._fields, r)._f.value
    });
  }, [n, r, o]), {
    field: {
      name: r,
      value: i,
      ...j7(n) || s.disabled ? { disabled: s.disabled || n } : {},
      onChange: Ae.useCallback((c) => u.current.onChange({
        target: {
          value: ene(c),
          name: r
        },
        type: Z7.CHANGE
      }), [r]),
      onBlur: Ae.useCallback(() => u.current.onBlur({
        target: {
          value: at(o._formValues, r),
          name: r
        },
        type: Z7.BLUR
      }), [r, o]),
      ref: Ae.useCallback((c) => {
        const l = at(o._fields, r);
        l && c && (l._f.ref = {
          focus: () => c.focus(),
          select: () => c.select(),
          setCustomValidity: (p) => c.setCustomValidity(p),
          reportValidity: () => c.reportValidity()
        });
      }, [o._fields, r])
    },
    formState: s,
    fieldState: Object.defineProperties({}, {
      invalid: {
        enumerable: !0,
        get: () => !!at(s.errors, r)
      },
      isDirty: {
        enumerable: !0,
        get: () => !!at(s.dirtyFields, r)
      },
      isTouched: {
        enumerable: !0,
        get: () => !!at(s.touchedFields, r)
      },
      isValidating: {
        enumerable: !0,
        get: () => !!at(s.validatingFields, r)
      },
      error: {
        enumerable: !0,
        get: () => at(s.errors, r)
      }
    })
  };
}
const hne = (e) => e.render(mne(e)), Ha = ({
  children: e,
  name: t,
  messages: r,
  apiError: n,
  ...o
}) => {
  const a = rr(
    (i, s) => qN(r, t, i, s),
    [r, t]
  ), d = ar(() => ({ m: a, apiError: n }), [n, a]);
  return /* @__PURE__ */ A(lf.Provider, { value: d, children: /* @__PURE__ */ A(ine, { ...o, children: e }) });
};
Ha.displayName = "ApiForm";
const gO = dt({}), yO = dt({}), Gi = () => {
  const e = Ar(gO), t = Ar(yO), { getFieldState: r, formState: n } = Ui(), o = r(e.name, n);
  if (!e)
    throw new Error("useFormField should be used within <FormField>");
  const { id: a } = t;
  return {
    id: a,
    name: e.name,
    formItemId: `${a}-form-item`,
    formDescriptionId: `${a}-form-item-description`,
    formMessageId: `${a}-form-item-message`,
    ...o
  };
}, Zr = ({
  ...e
}) => (
  // eslint-disable-next-line react/jsx-no-constructed-context-values
  /* @__PURE__ */ A(gO.Provider, { value: { name: e.name }, children: /* @__PURE__ */ A(hne, { ...e }) })
), yr = X(
  ({ className: e, ...t }, r) => {
    const n = CO();
    return (
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      /* @__PURE__ */ A(yO.Provider, { value: { id: n }, children: /* @__PURE__ */ A("div", { ref: r, className: q("space-y-0.5", e), ...t }) })
    );
  }
);
yr.displayName = "FormItem";
const br = X(({ className: e, ...t }, r) => {
  const { error: n, formItemId: o } = Gi();
  return /* @__PURE__ */ A(MM, { ref: r, className: q(n && "text-destructive", e), htmlFor: o, ...t });
});
br.displayName = "FormLabel";
const xr = X(
  ({ ...e }, t) => {
    const { error: r, formItemId: n, formDescriptionId: o, formMessageId: a } = Gi();
    return /* @__PURE__ */ A(
      To,
      {
        ref: t,
        id: n,
        "aria-describedby": r ? `${o} ${a}` : `${o}`,
        "aria-invalid": !!r,
        ...e
      }
    );
  }
);
xr.displayName = "FormControl";
const gne = X(
  ({ className: e, ...t }, r) => {
    const { formDescriptionId: n } = Gi();
    return /* @__PURE__ */ A(
      "p",
      {
        ref: r,
        id: n,
        className: q("text-[0.8rem] text-muted-foreground", e),
        ...t
      }
    );
  }
);
gne.displayName = "FormDescription";
const wr = X(
  ({ className: e, children: t, ...r }, n) => {
    var o, a;
    const { error: d, name: i, formMessageId: s } = Gi(), { m: u, apiError: c } = Ar(lf), l = t || u(((a = (o = c == null ? void 0 : c.data) == null ? void 0 : o[i]) == null ? void 0 : a.type) ?? "", i) || u((d == null ? void 0 : d.type) ?? "", i);
    return /* @__PURE__ */ A(
      "p",
      {
        ref: n,
        id: s,
        className: q("text-[0.8rem] font-medium text-destructive", e),
        ...r,
        children: l ?? /* @__PURE__ */ A(Ge, { children: " " })
      }
    );
  }
);
wr.displayName = "FieldMessage";
const Ka = X(
  ({ className: e, children: t, ...r }, n) => {
    const { m: o, apiError: a } = Ar(lf), d = t || o((a == null ? void 0 : a.code) ?? "");
    return /* @__PURE__ */ A("p", { ref: n, className: q("text-[0.8rem] font-medium text-destructive", e), ...r, children: d ?? /* @__PURE__ */ A(Ge, { children: " " }) });
  }
);
Ka.displayName = "FormMessage";
const Wa = {
  forgotPassword: {
    email: {
      required: "Email is requires",
      isNotEmpty: "Email cannot be empty"
    }
  },
  resetPassword: {
    secret: {
      required: "Password is required",
      isNotEmpty: "Password cannot be empty",
      min: "Password is too short",
      max: "Password is too long",
      alpha: "Password must contain alpha character",
      lowercase: "Password must contain lowercase character",
      uppercase: "Password must contain uppercase character",
      digit: "Password must contain numeric character",
      special: "Password must contain special character"
    },
    secretRepeat: {
      required: "Repeat the required",
      oneOf: "Passwords do not match"
    }
  },
  signup: {
    email: {
      required: "Email is requires",
      isNotEmpty: "Email cannot be empty"
    },
    username: {
      required: "Username is required",
      isNotEmpty: "Username cannot be empty"
    },
    "duplicate-username": "Username is already in use",
    "duplicate-email": "Email is already in use",
    "signup-domain-restriction": "You cannot signup with that email domain. Are you sure you are signing up for the right tenant?",
    "tenant-disabled": "You cannot signup as it seems that this tenant is disabled.",
    "tenant-not-found": "You cannot signup as it seems that this tenant does not exist.",
    "signup-disabled": "This platform can be joined only by invitation."
  },
  auth: {
    username: {
      required: "Username/email is required",
      isNotEmpty: "Username/email cannot be empty"
    },
    secret: {
      required: "Password is required",
      isNotEmpty: "Password cannot be empty"
    },
    "access-denied": "Your account seems to be blocked. Please contact support if this is not expected.",
    "approval-pending": "You have not been approved by an administrator, yet.",
    "secret-challenge": "You did not verify your email address.",
    "tenant-disabled": "You cannot login as it seems that your tenant is disabled.",
    "tenant-not-found": "You cannot login as it seems that this tenant does not exist."
  },
  optionality: "Value is required",
  required: "Value is required",
  isNotEmpty: "Value cannot be empty",
  isEmail: "Value is not a valid email address",
  minLength: "Value is too short",
  max: "Value is too long",
  "invalid-code": "Code is invalid or expired",
  "validation-error": "Provided data is not valid",
  "authentication-failed": "Login failed. Check provided credentials."
}, yne = Ca({
  email: mr().required().email()
}).required(), bne = ri(yne);
function voe({ sidebar: e, logo: t }) {
  const [r] = Co(), n = r == null ? void 0 : r.get("client"), o = ti({
    resolver: bne,
    defaultValues: {
      email: ""
    }
  }), { service: a } = Po(), { submit: d, apiError: i, isApiLoading: s, isApiOk: u } = ni(async (c) => {
    await a.requestSecretReset(c.email, n ?? void 0);
  });
  return /* @__PURE__ */ ie("div", { className: "flex h-screen w-screen flex-1", children: [
    /* @__PURE__ */ A(
      "div",
      {
        className: Ur("flex flex-1 flex-col justify-center px-4 py-12 sm:px-6 lg:px-20 xl:px-24", {
          "lg:flex-none": !!e
        }),
        children: /* @__PURE__ */ ie("div", { className: "mx-auto grid w-[350px] gap-6", children: [
          /* @__PURE__ */ ie("div", { className: "mb-8 grid gap-2 text-center", children: [
            /* @__PURE__ */ A("div", { className: "flex flex-col items-center", children: t }),
            /* @__PURE__ */ A("h1", { className: "text-3xl font-bold", children: "Forgot password" }),
            /* @__PURE__ */ A("p", { className: "text-balance text-muted-foreground", children: "Enter your email to get the email reset link" })
          ] }),
          /* @__PURE__ */ A("div", { className: "grid gap-4", children: /* @__PURE__ */ A(Ha, { name: "forgotPassword", messages: Wa, apiError: i, ...o, children: /* @__PURE__ */ ie("form", { onSubmit: o.handleSubmit(d), className: "space-y-6", children: [
            /* @__PURE__ */ A(
              Zr,
              {
                control: o.control,
                name: "email",
                render: ({ field: c }) => /* @__PURE__ */ ie(yr, { children: [
                  /* @__PURE__ */ A(br, { children: "Email address" }),
                  /* @__PURE__ */ A(xr, { children: /* @__PURE__ */ A(
                    gr,
                    {
                      type: "text",
                      placeholder: "email",
                      autoCapitalize: "none",
                      autoComplete: "username email",
                      autoCorrect: "off",
                      autoFocus: !0,
                      disabled: s || u,
                      ...c
                    }
                  ) }),
                  /* @__PURE__ */ A(wr, {})
                ] })
              }
            ),
            /* @__PURE__ */ ie("div", { className: "space-y-2", children: [
              /* @__PURE__ */ ie(
                pn,
                {
                  type: "submit",
                  disabled: s || u,
                  className: "relative w-full",
                  tabIndex: 3,
                  children: [
                    "Reset password",
                    s && /* @__PURE__ */ A(Qd, { className: "absolute left-[calc(50%-4.5rem)] size-4 animate-spin" })
                  ]
                }
              ),
              /* @__PURE__ */ A(Ka, {})
            ] })
          ] }) }) }),
          /* @__PURE__ */ ie(Sa, { className: Ur({ invisible: !u }), children: [
            /* @__PURE__ */ A(z7, { className: "size-4" }),
            /* @__PURE__ */ A(_a, { children: "Email sent!" }),
            /* @__PURE__ */ A(Ea, { children: "Check your email with further instructions." })
          ] })
        ] })
      }
    ),
    !!e && /* @__PURE__ */ A("div", { className: "relative hidden w-0 flex-1 lg:block", children: e })
  ] });
}
const xne = 1, wne = 1e6;
let Oc = 0;
function Ane() {
  return Oc = (Oc + 1) % Number.MAX_SAFE_INTEGER, Oc.toString();
}
const Nc = /* @__PURE__ */ new Map(), G7 = (e) => {
  if (Nc.has(e))
    return;
  const t = setTimeout(() => {
    Nc.delete(e), fa({
      type: "REMOVE_TOAST",
      toastId: e
    });
  }, wne);
  Nc.set(e, t);
}, Sne = (e, t) => {
  switch (t.type) {
    case "ADD_TOAST":
      return {
        ...e,
        toasts: [t.toast, ...e.toasts].slice(0, xne)
      };
    case "UPDATE_TOAST":
      return {
        ...e,
        toasts: e.toasts.map((r) => r.id === t.toast.id ? { ...r, ...t.toast } : r)
      };
    case "DISMISS_TOAST": {
      const { toastId: r } = t;
      return r ? G7(r) : e.toasts.forEach((n) => {
        G7(n.id);
      }), {
        ...e,
        toasts: e.toasts.map(
          (n) => n.id === r || r === void 0 ? {
            ...n,
            open: !1
          } : n
        )
      };
    }
    case "REMOVE_TOAST":
      return t.toastId === void 0 ? {
        ...e,
        toasts: []
      } : {
        ...e,
        toasts: e.toasts.filter((r) => r.id !== t.toastId)
      };
  }
}, Cd = [];
let Od = { toasts: [] };
function fa(e) {
  Od = Sne(Od, e), Cd.forEach((t) => {
    t(Od);
  });
}
function _ne({ ...e }) {
  const t = Ane(), r = (o) => fa({
    type: "UPDATE_TOAST",
    toast: { ...o, id: t }
  }), n = () => fa({ type: "DISMISS_TOAST", toastId: t });
  return fa({
    type: "ADD_TOAST",
    toast: {
      ...e,
      id: t,
      open: !0,
      onOpenChange: (o) => {
        o || n();
      }
    }
  }), {
    id: t,
    dismiss: n,
    update: r
  };
}
function bO() {
  const [e, t] = Ie(Od);
  return rt(() => (Cd.push(t), () => {
    const r = Cd.indexOf(t);
    r > -1 && Cd.splice(r, 1);
  }), [e]), {
    ...e,
    toast: _ne,
    dismiss: (r) => fa({ type: "DISMISS_TOAST", toastId: r })
  };
}
function xO() {
  const { toasts: e } = bO();
  return /* @__PURE__ */ ie(XX, { children: [
    e.map(function({ id: t, title: r, description: n, action: o, ...a }) {
      return /* @__PURE__ */ ie(S_, { ...a, children: [
        /* @__PURE__ */ ie("div", { className: "grid gap-1", children: [
          r && /* @__PURE__ */ A(E_, { children: r }),
          n && /* @__PURE__ */ A(M_, { children: n })
        ] }),
        o,
        /* @__PURE__ */ A(__, {})
      ] }, t);
    }),
    /* @__PURE__ */ A(A_, {})
  ] });
}
function wO() {
  const { toast: e } = bO(), [t] = Co(), r = t == null ? void 0 : t.get("error");
  rt(() => {
    r && e({
      title: "There was an error",
      description: Ene(r),
      variant: "destructive"
    });
  }, [e, r]);
}
function Ene(e) {
  const t = Wa.signup, r = t && typeof t != "string" ? t[e] : void 0;
  return r && typeof r == "string" ? r : "Unexpected errors";
}
const AO = (e) => /* @__PURE__ */ x.createElement("svg", { enableBackground: "new 0 0 32 32", id: "Layer_1", viewBox: "0 0 32 32", xmlSpace: "preserve", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...e }, /* @__PURE__ */ x.createElement("g", { id: "OUTLINE_copy_2" }, /* @__PURE__ */ x.createElement("g", null, /* @__PURE__ */ x.createElement("path", { d: "M16,0C7.163,0,0,7.164,0,16s7.163,16,16,16c8.836,0,16-7.164,16-16S24.837,0,16,0z M16.173,24.596    c-4.749,0-8.596-3.847-8.596-8.596s3.847-8.596,8.596-8.596c2.321,0,4.261,0.855,5.748,2.24l-2.423,2.423v-0.005    c-0.902-0.86-2.047-1.3-3.325-1.3c-2.836,0-5.141,2.396-5.141,5.232s2.305,5.238,5.141,5.238c2.573,0,4.325-1.472,4.685-3.492    h-4.685v-3.353h8.085c0.107,0.574,0.166,1.177,0.166,1.805C24.424,21.104,21.136,24.596,16.173,24.596z" })))), Mne = Ca({
  username: mr().required(),
  secret: mr().required()
}).required(), Cne = ri(Mne);
function moe({ signup: e, sidebar: t, logo: r }) {
  const n = Aa(), { tenant: o } = H7(), [a] = Co(), d = a == null ? void 0 : a.get("client");
  wO();
  const i = ti({
    resolver: Cne,
    defaultValues: {
      username: "",
      secret: ""
    }
  }), { service: s, signUpPagePath: u, forgotPasswordPagePath: c, authHostUrl: l } = Po(), [p, h] = Ie([]);
  rt(() => {
    s.getSocialConnections().then((y) => h(y)).catch((y) => {
      console.error(y), h([]);
    });
  }, [s]);
  const { submit: m, apiError: f, isApiLoading: $ } = ni(async (y) => {
    if (await s.signIn(y.username, y.secret), !d) {
      n("/");
      return;
    }
    const S = await s.createAccessCode(d);
    window.location.href = `${S.authorizationUrl}?code=${S.code}`;
  }), v = rr(() => {
    window.location.href = `${l}/auth/google?client=${encodeURIComponent(d ?? "")}&tenant=${encodeURIComponent(o ?? "")}`;
  }, [l, d, o]);
  return /* @__PURE__ */ ie("div", { className: "flex h-screen w-screen flex-1", children: [
    /* @__PURE__ */ A(
      "div",
      {
        className: Ur("flex flex-1 flex-col justify-center px-4 py-12 sm:px-6 lg:px-20 xl:px-24", {
          "lg:flex-none": !!t
        }),
        children: /* @__PURE__ */ ie("div", { className: "mx-auto grid w-[350px] gap-6", children: [
          /* @__PURE__ */ ie("div", { className: "mb-8 grid gap-2 text-center", children: [
            /* @__PURE__ */ A("div", { className: "flex flex-col items-center", children: r }),
            /* @__PURE__ */ A("h1", { className: "text-3xl font-bold", children: "Sign in" }),
            /* @__PURE__ */ A("p", { className: "text-balance text-muted-foreground", children: "Enter your email below to login to your account" }),
            e && /* @__PURE__ */ ie("p", { className: "mt-2 text-sm leading-6 text-foreground/75", children: [
              "Don't have an account?",
              " ",
              /* @__PURE__ */ A(
                "a",
                {
                  onClick: () => n(
                    (o ? `/${o}` : "") + u + (d ? `?client=${d}` : "")
                  ),
                  className: "ml-auto font-normal text-foreground/100",
                  tabIndex: 4,
                  children: "Sign up"
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ ie("div", { className: "grid gap-4", children: [
            /* @__PURE__ */ A(Ha, { name: "auth", messages: Wa, apiError: f, ...i, children: /* @__PURE__ */ ie("form", { onSubmit: i.handleSubmit(m), className: "flex-col gap-2", children: [
              /* @__PURE__ */ A(
                Zr,
                {
                  control: i.control,
                  name: "username",
                  render: ({ field: y }) => /* @__PURE__ */ ie(yr, { children: [
                    /* @__PURE__ */ A(br, { children: "Username or email address" }),
                    /* @__PURE__ */ A(xr, { children: /* @__PURE__ */ A(
                      gr,
                      {
                        type: "text",
                        autoCapitalize: "none",
                        autoComplete: "username email",
                        autoCorrect: "off",
                        tabIndex: 1,
                        autoFocus: !0,
                        ...y
                      }
                    ) }),
                    /* @__PURE__ */ A(wr, {})
                  ] })
                }
              ),
              /* @__PURE__ */ A(
                Zr,
                {
                  control: i.control,
                  name: "secret",
                  render: ({ field: y }) => /* @__PURE__ */ ie(yr, { children: [
                    /* @__PURE__ */ ie(br, { className: "mb-1.5 flex items-center", children: [
                      "Password",
                      /* @__PURE__ */ A(
                        "a",
                        {
                          onClick: () => n(c + (d ? `?client=${d}` : "")),
                          className: "ml-auto font-normal text-muted-foreground",
                          tabIndex: 5,
                          children: "Forgot password?"
                        }
                      )
                    ] }),
                    /* @__PURE__ */ A(xr, { children: /* @__PURE__ */ A(
                      gr,
                      {
                        type: "password",
                        autoCapitalize: "none",
                        autoComplete: "current-password",
                        autoCorrect: "off",
                        tabIndex: 2,
                        ...y
                      }
                    ) }),
                    /* @__PURE__ */ A(wr, {})
                  ] })
                }
              ),
              /* @__PURE__ */ ie("div", { className: "space-y-2", children: [
                /* @__PURE__ */ ie(pn, { type: "submit", disabled: $, className: "relative w-full", tabIndex: 3, children: [
                  "Sign in",
                  $ && /* @__PURE__ */ A(Qd, { className: "absolute left-[calc(50%-3rem)] size-4 animate-spin" })
                ] }),
                /* @__PURE__ */ A(Ka, {})
              ] })
            ] }) }),
            !!p.length && /* @__PURE__ */ ie(Ge, { children: [
              /* @__PURE__ */ ie("div", { className: "relative mb-8 mt-4", children: [
                /* @__PURE__ */ A("div", { "aria-hidden": "true", className: "absolute inset-0 flex items-center", children: /* @__PURE__ */ A("div", { className: "w-full border-t border-border" }) }),
                /* @__PURE__ */ A("div", { className: "relative flex justify-center text-sm font-medium leading-6", children: /* @__PURE__ */ A("span", { className: "bg-background px-6", children: "Or continue with" }) })
              ] }),
              p.includes("google") && /* @__PURE__ */ ie(
                pn,
                {
                  type: "button",
                  onClick: v,
                  variant: "outline",
                  className: "relative w-full",
                  children: [
                    /* @__PURE__ */ A(AO, { className: "mr-2 size-5 fill-foreground" }),
                    "Google"
                  ]
                }
              )
            ] })
          ] })
        ] })
      }
    ),
    !!t && /* @__PURE__ */ A("div", { className: "relative hidden w-0 flex-1 lg:block", children: t }),
    /* @__PURE__ */ A(xO, {})
  ] });
}
const hoe = ({ element: e, sso: t = !1 }) => {
  const r = Aa(), { isAuthenticated: n } = I1(), { authPagePath: o, authorizeUrl: a } = Po();
  return rt(() => {
    if (!n) {
      if (t) {
        if (!a) throw new Error("AuthorizeUrl must be specified with sso option.");
        window.location.href = a;
        return;
      }
      if (!o) throw new Error("AuthPagePath must be specified when sso option is off.");
      r(o);
    }
  }, [n, o, r, a, t]), n ? e : /* @__PURE__ */ A(Ge, { children: null });
}, One = Ca({
  secret: mr().required(),
  secretRepeat: mr().required().oneOf([VI("secret")])
}).required(), Nne = ri(One);
function goe({ sidebar: e, logo: t }) {
  const r = Aa(), [n] = Co(), o = n == null ? void 0 : n.get("code"), a = (n == null ? void 0 : n.get("reason")) === "signup", d = ti({
    resolver: Nne,
    defaultValues: {
      secret: "",
      secretRepeat: ""
    }
  }), { service: i, authPagePath: s } = Po(), { submit: u, apiError: c, isApiOk: l, isApiLoading: p } = ni(async (h) => {
    const { client: m } = await i.resetSecret(h.secret, o ?? "");
    setTimeout(() => {
      r(s + (m ? `?client=${m}` : ""));
    }, 3e3);
  });
  return /* @__PURE__ */ ie("div", { className: "flex h-screen w-screen flex-1", children: [
    /* @__PURE__ */ A(
      "div",
      {
        className: Ur("flex flex-1 flex-col justify-center px-4 py-12 sm:px-6 lg:px-20 xl:px-24", {
          "lg:flex-none": !!e
        }),
        children: /* @__PURE__ */ ie("div", { className: "mx-auto grid w-[350px] gap-6", children: [
          /* @__PURE__ */ ie("div", { className: "mb-8 grid gap-2 text-center", children: [
            /* @__PURE__ */ A("div", { className: "flex flex-col items-center", children: t }),
            /* @__PURE__ */ A("h1", { className: "text-3xl font-bold", children: a ? /* @__PURE__ */ A(Ge, { children: "Set your password" }) : /* @__PURE__ */ A(Ge, { children: "Reset password" }) }),
            /* @__PURE__ */ A("p", { className: "text-balance text-muted-foreground", children: a ? /* @__PURE__ */ A(Ge, { children: "You can define your password here." }) : /* @__PURE__ */ A(Ge, { children: "You can reset your password here." }) })
          ] }),
          /* @__PURE__ */ A("div", { className: "grid gap-4", children: /* @__PURE__ */ A(Ha, { name: "resetPassword", messages: Wa, apiError: c, ...d, children: /* @__PURE__ */ ie("form", { onSubmit: d.handleSubmit(u), className: "space-y-6", children: [
            /* @__PURE__ */ A(
              Zr,
              {
                control: d.control,
                name: "secret",
                render: ({ field: h }) => /* @__PURE__ */ ie(yr, { children: [
                  /* @__PURE__ */ A(br, { children: "Password" }),
                  /* @__PURE__ */ A(xr, { children: /* @__PURE__ */ A(
                    gr,
                    {
                      type: "password",
                      autoCapitalize: "none",
                      autoComplete: "current-password",
                      autoCorrect: "off",
                      autoFocus: !0,
                      ...h
                    }
                  ) }),
                  /* @__PURE__ */ A(wr, {})
                ] })
              }
            ),
            /* @__PURE__ */ A(
              Zr,
              {
                control: d.control,
                name: "secretRepeat",
                render: ({ field: h }) => /* @__PURE__ */ ie(yr, { children: [
                  /* @__PURE__ */ A(br, { children: "Repeat password" }),
                  /* @__PURE__ */ A(xr, { children: /* @__PURE__ */ A(
                    gr,
                    {
                      type: "password",
                      autoCapitalize: "none",
                      autoComplete: "current-password",
                      autoCorrect: "off",
                      ...h
                    }
                  ) }),
                  /* @__PURE__ */ A(wr, {})
                ] })
              }
            ),
            /* @__PURE__ */ ie("div", { className: "space-y-2", children: [
              /* @__PURE__ */ ie(pn, { type: "submit", disabled: p, className: "relative w-full", children: [
                "Reset password",
                p && /* @__PURE__ */ A(Qd, { className: "absolute left-[calc(50%-3rem)] size-4 animate-spin" })
              ] }),
              /* @__PURE__ */ A(Ka, {})
            ] })
          ] }) }) }),
          /* @__PURE__ */ ie(Sa, { className: Ur({ invisible: !l }), children: [
            /* @__PURE__ */ A(FO, { className: "size-4" }),
            /* @__PURE__ */ A(_a, { children: "Password successfully set!" }),
            /* @__PURE__ */ A(Ea, { children: "You will be redirect to the login page, soon." })
          ] })
        ] })
      }
    ),
    !!e && /* @__PURE__ */ A("div", { className: "relative hidden w-0 flex-1 lg:block", children: e })
  ] });
}
const Ine = Ca({
  username: mr().required().max(100),
  email: mr().required().email().max(256),
  name: mr().optional().max(100)
}).required(), Pne = ri(Ine);
function yoe({ sidebar: e, logo: t }) {
  const r = Aa(), { tenant: n } = H7(), [o] = Co(), a = o == null ? void 0 : o.get("client");
  wO();
  const d = ti({
    resolver: Pne,
    defaultValues: {
      username: "",
      email: "",
      name: ""
    }
  }), { service: i, authPagePath: s, authHostUrl: u } = Po(), { submit: c, apiError: l, isApiLoading: p, isApiOk: h } = ni(async (v) => {
    await i.signUp(v.email, v.username, v.name, a ?? void 0, n), setTimeout(() => {
      if (!a) {
        r((n ? `/${n}` : "") + s);
        return;
      }
      r((n ? `/${n}` : "") + `${s}?client=${a}`);
    }, 3e3);
  }), [m, f] = Ie([]);
  rt(() => {
    i.getSocialConnections().then((v) => f(v)).catch((v) => {
      console.error(v), f([]);
    });
  }, [i]);
  const $ = rr(() => {
    window.location.href = `${u}/auth/google?client=${encodeURIComponent(a ?? "")}&tenant=${encodeURIComponent(n ?? "")}`;
  }, [u, a, n]);
  return /* @__PURE__ */ ie("div", { className: "flex h-screen w-screen flex-1", children: [
    /* @__PURE__ */ A(
      "div",
      {
        className: Ur("flex flex-1 flex-col justify-center px-4 py-12 sm:px-6 lg:px-20 xl:px-24", {
          "lg:flex-none": !!e
        }),
        children: /* @__PURE__ */ ie("div", { className: "mx-auto grid w-[350px] gap-6", children: [
          /* @__PURE__ */ ie("div", { className: "mb-8 grid gap-2 text-center", children: [
            /* @__PURE__ */ A("div", { className: "flex flex-col items-center", children: t }),
            /* @__PURE__ */ A("h1", { className: "text-3xl font-bold", children: "Sign up" }),
            /* @__PURE__ */ A("p", { className: "text-balance text-muted-foreground", children: "Fill in below form and create your new account" }),
            /* @__PURE__ */ ie("p", { className: "mt-2 text-sm leading-6 text-foreground/75", children: [
              "Already have an account?",
              " ",
              /* @__PURE__ */ A(
                "a",
                {
                  onClick: () => r((n ? `/${n}` : "") + s + (a ? `?client=${a}` : "")),
                  className: "ml-auto font-normal text-foreground/100",
                  tabIndex: 4,
                  children: "Sign In"
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ ie("div", { className: "grid gap-4", children: [
            /* @__PURE__ */ A(Ha, { name: "signup", messages: Wa, apiError: l, ...d, children: /* @__PURE__ */ ie("form", { onSubmit: d.handleSubmit(c), className: "flex-col gap-2", children: [
              /* @__PURE__ */ A(
                Zr,
                {
                  control: d.control,
                  name: "email",
                  render: ({ field: v }) => /* @__PURE__ */ ie(yr, { children: [
                    /* @__PURE__ */ A(br, { children: "Email" }),
                    /* @__PURE__ */ A(xr, { children: /* @__PURE__ */ A(
                      gr,
                      {
                        type: "email",
                        autoCapitalize: "none",
                        autoComplete: "email",
                        autoCorrect: "off",
                        tabIndex: 1,
                        autoFocus: !0,
                        ...v
                      }
                    ) }),
                    /* @__PURE__ */ A(wr, {})
                  ] })
                }
              ),
              /* @__PURE__ */ A(
                Zr,
                {
                  control: d.control,
                  name: "username",
                  render: ({ field: v }) => /* @__PURE__ */ ie(yr, { children: [
                    /* @__PURE__ */ A(br, { children: "Username" }),
                    /* @__PURE__ */ A(xr, { children: /* @__PURE__ */ A(
                      gr,
                      {
                        type: "text",
                        autoCapitalize: "none",
                        autoComplete: "username",
                        autoCorrect: "off",
                        tabIndex: 2,
                        ...v
                      }
                    ) }),
                    /* @__PURE__ */ A(wr, {})
                  ] })
                }
              ),
              /* @__PURE__ */ A(
                Zr,
                {
                  control: d.control,
                  name: "name",
                  render: ({ field: v }) => /* @__PURE__ */ ie(yr, { children: [
                    /* @__PURE__ */ A(br, { children: "Name" }),
                    /* @__PURE__ */ A(xr, { children: /* @__PURE__ */ A(
                      gr,
                      {
                        type: "text",
                        autoCapitalize: "true",
                        autoComplete: "name",
                        autoCorrect: "off",
                        tabIndex: 3,
                        ...v
                      }
                    ) }),
                    /* @__PURE__ */ A(wr, {})
                  ] })
                }
              ),
              /* @__PURE__ */ ie("div", { className: "space-y-2", children: [
                /* @__PURE__ */ ie(pn, { type: "submit", disabled: p, className: "relative w-full", tabIndex: 3, children: [
                  "Sign up",
                  p && /* @__PURE__ */ A(Qd, { className: "absolute left-[calc(50%-3rem)] size-4 animate-spin" })
                ] }),
                /* @__PURE__ */ A(Ka, {})
              ] })
            ] }) }),
            !!m.length && /* @__PURE__ */ ie(Ge, { children: [
              /* @__PURE__ */ ie("div", { className: "relative mb-8 mt-4", children: [
                /* @__PURE__ */ A("div", { "aria-hidden": "true", className: "absolute inset-0 flex items-center", children: /* @__PURE__ */ A("div", { className: "w-full border-t border-border" }) }),
                /* @__PURE__ */ A("div", { className: "relative flex justify-center text-sm font-medium leading-6", children: /* @__PURE__ */ A("span", { className: "bg-background px-6", children: "Or continue with" }) })
              ] }),
              m.includes("google") && /* @__PURE__ */ ie(
                pn,
                {
                  type: "button",
                  onClick: $,
                  variant: "outline",
                  className: "relative w-full",
                  children: [
                    /* @__PURE__ */ A(AO, { className: "mr-2 size-5 fill-foreground" }),
                    "Google"
                  ]
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ ie(Sa, { className: Ur({ invisible: !h }), children: [
            /* @__PURE__ */ A(z7, { className: "size-4" }),
            /* @__PURE__ */ A(_a, { children: "Signup success!" }),
            /* @__PURE__ */ A(Ea, { children: "Check your email with further instructions." })
          ] })
        ] })
      }
    ),
    !!e && /* @__PURE__ */ A("div", { className: "relative hidden w-0 flex-1 lg:block", children: e }),
    /* @__PURE__ */ A(xO, {})
  ] });
}
const boe = ({
  element: e,
  permissions: t,
  require: r = "any",
  fallback: n
}) => {
  const { userInfo: o } = I1();
  return Rne(o, t, r) ? e : n ?? /* @__PURE__ */ A(Ge, { children: null });
};
function Rne(e, t, r) {
  if (!e) return !1;
  switch (r) {
    case "all":
      return yo.hasAll(t, e.permissions);
    case "none":
      return yo.hasNone(t, e.permissions);
    default:
      return yo.hasAny(t, e.permissions);
  }
}
const xoe = ({ element: e, roles: t, require: r = "any", fallback: n }) => {
  const { userInfo: o } = I1();
  return Tne(o, t, r) ? e : n ?? /* @__PURE__ */ A(Ge, { children: null });
};
function Tne(e, t, r) {
  if (!e) return !1;
  switch (r) {
    case "all":
      return yo.hasAll(t, e.roles);
    case "none":
      return yo.hasNone(t, e.roles);
    default:
      return yo.hasAny(t, e.roles);
  }
}
export {
  Soe as ApiError,
  Bne as Auth,
  W7 as AuthApiContext,
  K7 as AuthInfoContext,
  SO as AuthService,
  Zne as AuthorizationCode,
  voe as ForgotPassword,
  moe as Login,
  hoe as Protected,
  goe as ResetPassword,
  yoe as Signup,
  boe as WithPermissions,
  xoe as WithRoles,
  _oe as createAxiosInstance,
  Eoe as transformApiValidationErrors,
  Po as useAuthApi,
  I1 as useAuthInfo
};
//# sourceMappingURL=default.js.map
